/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 288);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(296);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(394)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(396);


var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */
var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
  return Object.keys(props).filter(function (name) {
    return prefixes.some(function (prefix) {
      return name.indexOf(prefix) === 0;
    });
  }).reduce(function (result, name) {
    result[name] = props[name];
    return result;
  }, {});
};

var _default = filterPropsByPrefix;
exports["default"] = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Style", {
  enumerable: true,
  get: function get() {
    return _theme.Style;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _theme.useTheme;
  }
});

__webpack_require__(409);

var _theme = _interopRequireWildcard(__webpack_require__(410));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _theme["default"];
exports["default"] = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTokenPrefixes = exports.memoizeTokenStyles = exports.getUnthemedTokens = exports.getTokenHelper = exports.getToken = exports.getIconFromTokens = void 0;

var _pascalCase = _interopRequireDefault(__webpack_require__(412));

var _upperFirst = _interopRequireDefault(__webpack_require__(202));

var _lowerFirst = _interopRequireDefault(__webpack_require__(413));

var _functional = __webpack_require__(19);

/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */
var getToken = function getToken(tokens, key, suffixKeys) {
  // If we got an array of suffix keys, turn them into a PascalCaseString and
  // look up the token
  if (suffixKeys && Array.isArray(suffixKeys)) {
    var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
    return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
  } else if (suffixKeys) {
    var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
    return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
  } else {
    return tokens[key];
  }
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */


exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function (prefixKey, tokens) {
  var helper = function helper(key, suffixKeys) {
    return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
  };

  helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
  // "myBorderWidth" and "myBorderColor" tokens.

  helper.borderCss = function (key) {
    var width = helper(key, "width");
    var color = helper(key, "color");
    return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
  }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
  // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
  // and "myShadowColor" tokens


  helper.boxShadowCss = function (key) {
    var color = helper(key, "color");
    return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
  }; // Pass in "myMotion" and a single css property or array of properties and
  // shorthand transition css will be generated that animates those properties
  // based on "myMotionFunction" and "myMotionDuration" tokens


  helper.transitionCss = function (key, properties) {
    var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
    return Array.isArray(properties) ? properties.map(function (property) {
      return "".concat(property, " ").concat(transition);
    }).join(", ") : "".concat(properties, " ").concat(transition);
  };

  return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */

exports.getTokenHelper = getTokenHelper;

var getIconFromTokens = function getIconFromTokens(tokens) {
  return Object.keys(tokens).reduce(function (result, key) {
    if (key.indexOf("Data") > 0) {
      result.data = tokens[key];
    } else if (key.indexOf("Rtl") > 0) {
      result.dataRtl = tokens[key];
    } else if (key.indexOf("Width") > 0) {
      result.width = tokens[key];
    } else if (key.indexOf("Height") > 0) {
      result.height = tokens[key];
    }

    return result;
  }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */


exports.getIconFromTokens = getIconFromTokens;

var getUnthemedTokens = function getUnthemedTokens(tokens) {
  var unthemedTokens = tokens({});
  return Object.keys(unthemedTokens).reduce(function (result, key) {
    if (unthemedTokens[key] !== undefined) {
      result[key] = unthemedTokens[key];
    }

    return result;
  }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */


exports.getUnthemedTokens = getUnthemedTokens;

var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
  var match = new RegExp("^".concat(prefix));
  return Object.keys(tokens).reduce(function (result, key) {
    if (match.test(key)) {
      result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
    }

    return result;
  }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */


exports.removeTokenPrefixes = removeTokenPrefixes;

var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
  /* eslint-disable-next-line rulesdir/no-partial-memoization */
  var fn = (0, _functional.memoize)(function (t) {
    return (0, _functional.memoizeByKeys)(function (props) {
      return f(t, props);
    }, keys);
  });
  return function (t, props) {
    return fn(t)(props);
  };
};

exports.memoizeTokenStyles = memoizeTokenStyles;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = convertSecondsToTimeFormat;
/* harmony export (immutable) */ __webpack_exports__["e"] = convertEpochToHHMMSS;
/* harmony export (immutable) */ __webpack_exports__["r"] = getTimeDiffFromCurrentTimeInHHMMSSFormat;
/* harmony export (immutable) */ __webpack_exports__["g"] = convertMillisecondsToHHMM;
/* harmony export (immutable) */ __webpack_exports__["l"] = getDateInMMDDYYYYWithOffset;
/* harmony export (immutable) */ __webpack_exports__["j"] = getBaseUrl;
/* harmony export (immutable) */ __webpack_exports__["C"] = naIfDefault;
/* harmony export (immutable) */ __webpack_exports__["o"] = getRefreshInterval;
/* harmony export (immutable) */ __webpack_exports__["D"] = parseCapabilitiesResponse;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatAlias;
/* harmony export (immutable) */ __webpack_exports__["u"] = isArrayEquals;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateOTSMetric;
/* harmony export (immutable) */ __webpack_exports__["k"] = getCluster;
/* unused harmony export getFromLocalStorage */
/* unused harmony export saveIntoLocalStorage */
/* harmony export (immutable) */ __webpack_exports__["F"] = saveFilterState;
/* harmony export (immutable) */ __webpack_exports__["E"] = readFilterState;
/* harmony export (immutable) */ __webpack_exports__["n"] = getLatestPicker;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isNotEmpty; });
/* harmony export (immutable) */ __webpack_exports__["t"] = isARorSSD;
/* unused harmony export isSSD */
/* harmony export (immutable) */ __webpack_exports__["B"] = isRouteChevronEnabled;
/* harmony export (immutable) */ __webpack_exports__["y"] = isOneBox;
/* harmony export (immutable) */ __webpack_exports__["G"] = trimColValue;
/* harmony export (immutable) */ __webpack_exports__["s"] = getTimeInSecond;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertEpochMillisToLocalTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = convertEpochMillisToLocalDateTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateStageDuration;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getFormattedTime; });
/* unused harmony export isDevelopmentEnv */
/* harmony export (immutable) */ __webpack_exports__["q"] = getStage;
/* harmony export (immutable) */ __webpack_exports__["p"] = getRegion;
/* harmony export (immutable) */ __webpack_exports__["w"] = isNotINRegionOrSSD;
/* harmony export (immutable) */ __webpack_exports__["x"] = isNotSSDAndINRegion;
/* harmony export (immutable) */ __webpack_exports__["f"] = convertEpochToLocaleFormat;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isRSWSBosonFlowEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isRouteAdjustmentEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(26);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function convertSecondsToTimeFormat(seconds){var hours=Math.floor(seconds/3600)%24;var minutes=Math.floor(seconds/60)%60;var secs=Math.round(seconds%60);return[hours,minutes,secs].map(function(v){return v<10?"0"+v:v;}).filter(function(v,i){return v!=="00"||i>0;}).join(":");}function convertEpochToHHMMSS(epochTime){if(!epochTime){return"-";}var time=new Date(parseInt(epochTime,10));var hours=time.getHours();var minutes=time.getMinutes();var secs=time.getSeconds();return[hours,minutes,secs].map(function(v){return v<10?"0"+v:v;}).join(":");}function getTimeDiffFromCurrentTimeInHHMMSSFormat(time){if(!time){return"...";}var curDate=new Date();var timeDiff=curDate.getTime()-time;return convertSecondsToTimeFormat(timeDiff/1000);}function convertMillisecondsToHHMM(milliseconds){if(!milliseconds){return"-";}var time=new Date(parseInt(milliseconds,10));return('0'+time.getHours()).slice(-2)+':'+('0'+time.getMinutes()).slice(-2);}function getDateInMMDDYYYYWithOffset(offset){var presentDate=new Date();presentDate.setDate(presentDate.getDate()+offset);return presentDate.getMonth()+1+"/"+presentDate.getDate()+"/"+presentDate.getFullYear();}function getBaseUrl(endpoint){var url=new URL(endpoint);return url.origin;}function naIfDefault(value){return!value||value==="..."?"NA":value;}/**
 * This method return the refresh interval in milliseconds
 * @returns {number}
 */function getRefreshInterval(stationConfig){if(stationConfig){return stationConfig.refreshInterval;}return __WEBPACK_IMPORTED_MODULE_2__Constants__["i" /* DEFAULT_REFRESH_INTERVAL */];}function parseCapabilitiesResponse(response){return response?JSON.parse(response.capability):'';}function formatAlias(alias){return alias!=null&&alias.indexOf('@')>-1?alias.split('@')[0]:alias;}/**
 * Compare 2 arrays of string and returns true if they are equal.
 * @param array1
 * @param array2
 * @return {boolean}
 */function isArrayEquals(array1,array2){if(!array1||!array2||array1.length!==array2.length){return false;}var sortedArray1=array1.sort();var sortedArray2=array2.sort();for(var i=sortedArray1.length;i--;){if(sortedArray1[i]!==sortedArray2[i])return false;}return true;}/**
 * Calculate the OTS metric for list of routes.
 * @param routes
 */function calculateOTSMetric(routes){var filteredRoutes=routes.filter(function(route){return route.stageTime&&route.plannedDispatchTime;});if(!filteredRoutes.length){return"-";}var otsRoutes=0;filteredRoutes.forEach(function(route){if(route.plannedDispatchTime-route.stageTime>=0){otsRoutes++;}});return(otsRoutes/filteredRoutes.length*100).toFixed(2);}/**
 * Return cluster from route code.
 * Supports routing 3.0 regex.
 *
 * @param routeCode
 * @return {*}
 */function getCluster(routeCode){if(!routeCode){return"";}return routeCode.split("-")[0].replace(/[0-9]/g,'');}/**
 * Handles exception while reading from localStorage
 * @param key
 */function getFromLocalStorage(key){try{return localStorage.getItem(key);}catch(e){return null;}}/**
 * Handles exception while writing into localStorage
 * @param key
 * @param value
 */function saveIntoLocalStorage(key,value){try{localStorage.setItem(key,value);}catch(e){}}/**
 * Saves filter state into local storage along with current station code.
 * It also translates the newState into JSON.
 * @param newState
 */function saveFilterState(filterKey,newState){try{newState.stageTabViewType=__WEBPACK_IMPORTED_MODULE_2__Constants__["w" /* ROUTE_VIEW */];var record=JSON.stringify({data:newState,stationCode:Object(__WEBPACK_IMPORTED_MODULE_1__network_NetworkUtil__["a" /* getStationCode */])()});saveIntoLocalStorage(filterKey,record);}catch(e){}}/**
 * Reads filter state from local storage by translating it into Json.
 * If current station code is different the persisted one, it returns null.
 * @param filterKey
 */function readFilterState(filterKey){try{var json=getFromLocalStorage(filterKey)||null;if(json){var record=JSON.parse(json);if(record.stationCode===Object(__WEBPACK_IMPORTED_MODULE_1__network_NetworkUtil__["a" /* getStationCode */])()){return record.data;}}}catch(ignored){}return null;}/**
 * Returns the picker for this route (for AMZL sites)
 * if route is not picked yet we use RPS information
 * if route is picked we use SPS information
 *
 * @param rswsRoute
 * @return {*|string}
 */function getLatestPicker(capability,rswsRoute){if(__WEBPACK_IMPORTED_MODULE_2__Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)){if(rswsRoute.activeAssignee){return rswsRoute.activeAssignee;}else if(rswsRoute.routeStatus===__WEBPACK_IMPORTED_MODULE_3__EntityStatusManager__["a" /* ASSIGNABLE */]||capability===__WEBPACK_IMPORTED_MODULE_2__Constants__["e" /* CORE_AMZL */]&&rswsRoute.routeStatus===__WEBPACK_IMPORTED_MODULE_3__EntityStatusManager__["e" /* IN_PROGRESS */]){return'...';}else{return Array.isArray(rswsRoute.pickAssociates)&&rswsRoute.pickAssociates.length?rswsRoute.pickAssociates[0].alias:'...';}}return"...";}var isNotEmpty=function isNotEmpty(value){return value&&__WEBPACK_IMPORTED_MODULE_2__Constants__["l" /* EMPTY_STRING */]!==value;};function isARorSSD(capability){return capability&&(capability===__WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* AR */]||capability===__WEBPACK_IMPORTED_MODULE_2__Constants__["x" /* SSD */]);}function isSSD(capability){return capability&&capability===__WEBPACK_IMPORTED_MODULE_2__Constants__["x" /* SSD */];}function isRouteChevronEnabled(stationConfig){return stationConfig.highSPREnabled||stationConfig.parallelPickEnabled;}/**
 * Checks existence of one-box string in the url
 * @return {boolean}
 */function isOneBox(){var location=window.location.href;return location&&location.includes("onebox");}/**
 * Trims String to max length for displaying inside tables.
 */function trimColValue(value,maxLength){if(value&&(typeof value==='string'||value instanceof String)&&value.length>maxLength){return value.substr(0,maxLength)+"...";}return value;}function getTimeInSecond(time){if(!time){return 0;}var splitTime=time.split(":");if(splitTime.length>2){return parseInt(splitTime[0],10)*60*60+parseInt(splitTime[1],10)*60+parseInt(splitTime[2],10);}else{return parseInt(splitTime[0],10)*60+parseInt(splitTime[1],10);}}function convertMillisToSecond(time){return Math.ceil(time/1000);}function convertEpochMillisToLocalTime(epochTime){var options={hour:'numeric',minute:'numeric',second:'numeric',hour12:false};var date=new Date(epochTime);return date.toLocaleString('en-GB',options);}function convertEpochMillisToLocalDateTime(epochTime){var options={month:'long',day:'numeric',hour:'numeric',minute:'numeric',hour12:false};var date=new Date(epochTime);return date.toLocaleString('en-GB',options);}/**
 * This method is only applicable for AR/SSD
 */function calculateStageDuration(route){if(route.pickAssociates.length>0&&!route.pickingErrorMessage){if(route.pickAssociates[0].pickingDuration){return convertSecondsToTimeFormat(convertMillisToSecond(route.pickAssociates[0].pickingDuration));}else if(route.pickAssociates[0].startTime){return getTimeDiffFromCurrentTimeInHHMMSSFormat(route.pickAssociates[0].startTime);}}return"...";}/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param currentDate
 * @param locale
 * @return string
 */var getFormattedTime=function getFormattedTime(currentDate,locale){return new Intl.DateTimeFormat(locale,__WEBPACK_IMPORTED_MODULE_2__Constants__["g" /* DATE_TIME_FORMAT */]).format(currentDate);};function isDevelopmentEnv(){return "production"!==__WEBPACK_IMPORTED_MODULE_2__Constants__["m" /* ENVIRONMENT */].PROD&&"production"!==__WEBPACK_IMPORTED_MODULE_2__Constants__["m" /* ENVIRONMENT */].TEST;}/**
 * Parses domain name and NODE_ENV variable to get current stage.
 * @return {string}
 */function getStage(){if(isDevelopmentEnv()){return __WEBPACK_IMPORTED_MODULE_2__Constants__["y" /* STAGE */].DEV;}var hostname=window.location.hostname;if(hostname.includes("integ."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["y" /* STAGE */].BETA;else if(hostname.includes("master."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["y" /* STAGE */].GAMMA;else return __WEBPACK_IMPORTED_MODULE_2__Constants__["y" /* STAGE */].PROD;}/**
 * Parses domain name and NODE_ENV variable to get current region.
 * @return {string}
 */function getRegion(){if(isDevelopmentEnv()){return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].JP;}var hostname=window.location.hostname;if(hostname.includes("na.")||hostname.includes("us."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].NA;else if(hostname.includes("eu.")||hostname.includes("gb."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].EU;else if(hostname.includes("jp."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].JP;else if(hostname.includes("in."))return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].IN;else return __WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].JP;}/**
 * Checks if Region is EU/NA/JP or capability is SSD
 * @param capability
 * @returns {boolean}
 */function isNotINRegionOrSSD(capability){return getRegion()!==__WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].IN||isSSD(capability);}/**
 * Checks if Region is IN and capability is non SSD.
 * @param capability
 * @returns {boolean}
 */function isNotSSDAndINRegion(capability){return getRegion()===__WEBPACK_IMPORTED_MODULE_2__Constants__["v" /* REGION */].IN&&!isSSD(capability);}/**
 * Input is epoch, output is date-time in browser local time zone
 * For eg:
 *  Input: 1637145000000
 *  Output: 2021/11/17 16:00:00 (Sweden date time format)
 * Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
 */function convertEpochToLocaleFormat(epoch){if(epoch&&typeof epoch==='number'){return new Date(epoch).toLocaleString('sv');}return"";}/**
 * Checks if the RSWS Boson Flow feature is enabled.
 *
 * @returns {Promise<boolean>} A Promise that resolves to a boolean indicating whether the feature is enabled.
 */var isRSWSBosonFlowEnabled=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["d" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_2__Constants__["o" /* IS_RSWS_BOSON_FLOW_ENABLED */]]);case 3:response=_context.sent;return _context.abrupt("return",response.data&&response.data.isRSWSBosonFlowEnabled);case 7:_context.prev=7;_context.t0=_context["catch"](0);console.error("Error occurred while fetching config from Boson App config");case 10:return _context.abrupt("return",false);case 11:case"end":return _context.stop();}}},_callee,this,[[0,7]]);}));return function isRSWSBosonFlowEnabled(){return _ref.apply(this,arguments);};}();/**
 * Checks if the Route Adjustment Flow feature is enabled.
 *
 * @returns {Promise<boolean>} A Promise that resolves to a boolean indicating whether the feature is enabled.
 */var isRouteAdjustmentEnabled=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["d" /* getFeaturesFromParent */])([__WEBPACK_IMPORTED_MODULE_2__Constants__["n" /* IS_ROUTE_ADJUSTMENT_ENABLED */]]);case 3:response=_context2.sent;return _context2.abrupt("return",response.data&&response.data.isRouteAdjustmentEnabled);case 7:_context2.prev=7;_context2.t0=_context2["catch"](0);console.error("Error occurred while fetching config from Boson App config");case 10:return _context2.abrupt("return",false);case 11:case"end":return _context2.stop();}}},_callee2,this,[[0,7]]);}));return function isRouteAdjustmentEnabled(){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_AMZL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AR_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CART_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ROUTE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PLAN_MANAGEMENT_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return STAGE_BY_TIME_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EMPTY_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TIMEOUT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_REFRESH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MILLIS_IN_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DOCK_DOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return IS_RSWS_BOSON_FLOW_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return IS_ROUTE_ADJUSTMENT_ENABLED; });
/* unused harmony export MARKETPLACE_LOCALE_MAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DARK_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOCALE_DIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TIMEOUTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return STAGE_LOCATION_TYPE; });
/* unused harmony export DWP_FILE_UPLOAD_SOURCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_CAPABILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATE_TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CACHE_TTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PAGE_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ENVIRONMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPART_TABLE_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OPERATION_TYPES; });
var CORE_AMZL="AMZL_CORE";var AR_V2="AR_NEXT_GEN";var AR="AR";var SSD="SSD";var CART_VIEW="CART_VIEW";var ROUTE_VIEW="ROUTE_VIEW";var PLAN_MANAGEMENT_VIEW="PLAN_MANAGEMENT_VIEW";var STAGE_BY_TIME_THRESHOLD=30*60*1000;var EMPTY_STRING="";var TIMEOUT_STRING="timeout";var DEFAULT_REFRESH_INTERVAL=60*1000;// 1 minute.
var MILLIS_IN_SECOND=1000;var DOCK_DOOR="DOCK_DOOR";var IS_RSWS_BOSON_FLOW_ENABLED="isRSWSBosonFlowEnabled";var IS_ROUTE_ADJUSTMENT_ENABLED="isRouteAdjustmentEnabled";var MARKETPLACE_LOCALE_MAP={de:["de","de-DE","de-CH","de-AT","de-LU","de-LI"],es:["es","es-ES","es-AR","es-GT","es-CR","es-PA","es-DO","es-MX","es-VE","es-CO","es-PE","es-EC","es-CL","es-UY","es-PY","es-BO","es-SV","es-HN","es-NI","es-PR"],ja:["ja","ja-JP"],it:["it","it-IT","it-CH"],fr:["fr","fr-FR","fr-BE","fr-CA","fr-CH","fr-LU"],ar:["ar","ar-SA","ar-IQ","ar-EG","ar-LY","ar-DZ","ar-MA","ar-TN","ar-OM","ar-YE","ar-SY","ar-JO","ar-LB","ar-KW","ar-AE","ar-BH","ar-QA"],en:["en"],tr:["tr","tr-TR"]};var DARK_MODE={DARK:"dark",LIGHT:"light"};var LOCALE={AR:"ar",DE:"de",EN:"en",ES:"es",FR:"fr",IT:"it",JA:"ja",TR:"tr"};var LOCALE_DIRECTION={RIGHT_TO_LEFT:"rtl",LEFT_TO_RIGHT:"ltr"};var TIMEOUTS={RSWS_GET_STATION_ROUTES_API_TIMEOUT:45000,RSWS_DEFAULT_API_TIMEOUT:25000};var STAGE_LOCATION_TYPE={PLANNED:"PLANNED",NORMAL:"NORMAL",OVERFLOW:"OVERFLOW"};var DWP_FILE_UPLOAD_SOURCE={AUTO:"auto",MANUAL:"manual"};var DEFAULT_CAPABILITIES=[CORE_AMZL,SSD,AR];var DATE_TIME_FORMAT={year:'numeric',month:'long',day:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit',timeZoneName:'short',hourCycle:'h24'/** Worst case API latency is assumed to be 10 sec */};var CACHE_TTL=50000;var PAGE_HEADERS={STAGE:{tab:"outboundAMZL.tabHeading",tabAlt:"Outbound",head:"stage.heading",headAlt:"Stage",desc:"stage.description",descAlt:"This table shows routes’ status and details during the outbound stage process"},DEPART:{tab:"outboundAMZL.tabHeading",tabAlt:"Outbound",head:"depart.heading",headAlt:"Depart",desc:"depart.description",descAlt:"This table shows routes’ status and details during the outbound depart process"}};var STAGE={DEV:"dev",BETA:"beta",GAMMA:"gamma",PROD:"prod"};var REGION={NA:"US",EU:"EU",JP:"JP",IN:"IN"};var ENVIRONMENT={DEV:"development",TEST:"test",PROD:"production"};var DEPART_TABLE_ACTIONS={BULK_UPDATE_ROUTE_STATUS_MODAL:"BULK_UPDATE_ROUTE_STATUS_MODAL",BULK_UPDATE_ROUTE_STATUS:"BULK_UPDATE_ROUTE_STATUS",BULK_SUCCESS_NOTIFICATION_UPDATE:"BULK_SUCCESS_NOTIFICATION_UPDATE",CLOSE_BULK_UPDATE_NOTIFICATION:"CLOSE_BULK_UPDATE_NOTIFICATION",LOAD_VIEW:"LOAD_VIEW"};var OPERATION_TYPES={ROUTE_READY_FOR_DISPATCH:"ROUTE_READY_FOR_DISPATCH"};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(517);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(11)["default"];

var assertThisInitialized = __webpack_require__(23);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _row = _interopRequireDefault(__webpack_require__(393));

var _default = _row["default"];
exports["default"] = _default;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* unused harmony export intlShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
exports.memoizeArray = memoizeArray;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeCurry = memoizeCurry;

/**
 * Author: shekwong@
 */
var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */

function memoize(f) {
  var memo = new Map();
  return function (i) {
    if (memo.has(i)) {
      return memo.get(i);
    }

    var result = f(i);
    memo.set(i, result);
    return result;
  };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */


function memoizeCurry(f, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(a);
  }

  return memoize(function (x) {
    return memoizeCurry(a.bind(null, x), depth - 1);
  });
}
/**
 * A helper function used by memoizeByKeys.
 */


function memoizeByKeysCurry(f, resolver, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(resolver);
  }

  return memoize(function (x) {
    return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
  });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */


function memoizeByKeys(f, keys) {
  var args = undefined;
  var g = memoizeByKeysCurry(f, function () {
    return f(args);
  }, keys.length - 1);
  return function (a) {
    if (!a) {
      var _c = g;
      keys.forEach(function () {
        _c = _c(undefined);
      });
      return _c;
    }

    args = a;
    var c = g;
    keys.forEach(function (k) {
      c = c(args[k]);
    });
    return c;
  };
}
/**
 * A helper function used by memoizeArray.
 */


function memoizeByVarArgsCurry(f) {
  var a = f;
  return memoize(function (x) {
    return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
  });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */


function memoizeArray(f) {
  var memoized = memoizeByVarArgsCurry(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f(args);
  });
  return function (vals) {
    var g = memoized;
    vals.forEach(function (v) {
      g = g(v);
    });
    return g(END);
  };
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CapabilityContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_CapabilityReducer__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CapabilityContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var model={capability:'',baseUrl:'',stationConfig:{initialised:false,pickStageDecoupleEnabled:false,plannedDispatchTimeEnabled:false,splitStagingEnabled:false,highSPREnabled:false,authEnabled:false,amxl:false,refreshInterval:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["i" /* DEFAULT_REFRESH_INTERVAL */],stagenabled:false,ssdmmotenabled:false,loadGuideSheetDownloadEnabled:false}};var CapabilityContextProvider=function CapabilityContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_CapabilityReducer__["a" /* CapabilityReducer */],model),_useReducer2=_slicedToArray(_useReducer,2),configViewModel=_useReducer2[0],configDispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CapabilityContext.Provider,{value:{configViewModel:configViewModel,configDispatch:configDispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (CapabilityContextProvider);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(116));

var text = function text(t) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tokens = (0, _text["default"])(t.tokens);
  return {
    color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
    fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
    fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
    fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
    lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
  };
};

var _default = text;
exports["default"] = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icon = _interopRequireDefault(__webpack_require__(439));

var _default = _icon["default"];
exports["default"] = _default;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useDeviceLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceLayoutProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_ResponsiveProps_js__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive__);
/*
This acts as common context and it will provide context related to device info and layout
Currently It is using Responsive Component from Meridian library to decide the applicable properties.
*/var DeviceLayoutContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();var useDeviceLayout=function useDeviceLayout(){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(DeviceLayoutContext);};var DeviceLayoutProvider=function DeviceLayoutProvider(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_responsive___default.a,{query:"max-width",props:__WEBPACK_IMPORTED_MODULE_1__constant_ResponsiveProps_js__["a" /* responsiveProps */]},function(_ref2){var isMobile=_ref2.isMobile,spacingInset_shorthand2=_ref2.spacingInset_shorthand2,spacingInset_shorthand4=_ref2.spacingInset_shorthand4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeviceLayoutContext.Provider,{value:{isMobile:isMobile,spacingInset_shorthand2:spacingInset_shorthand2,spacingInset_shorthand4:spacingInset_shorthand4}},children);});};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFeaturesFromParent; });
/* harmony export (immutable) */ __webpack_exports__["h"] = setDarkModeStateListener;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDarkModeStatus; });
/* harmony export (immutable) */ __webpack_exports__["g"] = publishClientSideMetrics;
/* unused harmony export getCycleDataFromParent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNodeCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAPIGatewayDataFromParent; });
/* unused harmony export getOverviewData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDocumentURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLocaleFromParent; });
/* unused harmony export setSelectedCycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(10);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var postMessagePromises={};function generateGuid(){/**
     * @return {string}
     */function S4(){return((1+Math.random())*0x10000|0).toString(16).substring(1);}return(S4()+S4()+"-"+S4()+"-4"+S4().substr(0,3)+"-"+S4()+"-"+S4()+S4()+S4()).toLowerCase();}/**
 * This method will get the feature flag from AppConfig
 * @param {List<String>} features
 * @returns
 */var getFeaturesFromParent=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(features){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return postMessagePromised(window.parent,{method:'getFeatureStatus',args:{features:features}},'*');case 2:return _context.abrupt("return",_context.sent);case 3:case"end":return _context.stop();}}},_callee,this);}));return function getFeaturesFromParent(_x){return _ref.apply(this,arguments);};}();function postMessagePromised(targetWindow,message,targetOrigin,timeout){var newGuid=generateGuid();message.guid=newGuid;postMessagePromises[newGuid]={};postMessagePromises[newGuid]['promise']=new Promise(function(resolve,reject){postMessagePromises[newGuid]['resolve']=resolve;postMessagePromises[newGuid]['reject']=reject;targetWindow.postMessage(message,targetOrigin);if(timeout){setTimeout(function(){postMessagePromises[newGuid].resolve(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["C" /* TIMEOUT_STRING */]);},timeout);}});return postMessagePromises[newGuid].promise;}var setCurrentDarkMode=function setCurrentDarkMode(){};function setDarkModeStateListener(darkModeStateListener){setCurrentDarkMode=darkModeStateListener;}var getDarkModeStatus=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return postMessagePromised(window.parent,{method:"getDarkModeStatus",args:{}},"*");case 2:return _context2.abrupt("return",_context2.sent);case 3:case"end":return _context2.stop();}}},_callee2,this);}));return function getDarkModeStatus(){return _ref2.apply(this,arguments);};}();function publishClientSideMetrics(args){window.parent.postMessage({method:'publishClientSideMetrics',args:args},"*");}var getCycleDataFromParent=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return postMessagePromised(window.parent,{method:'getCycleDataFromParent',args:{}},'*');case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_callee3,this);}));return function getCycleDataFromParent(){return _ref3.apply(this,arguments);};}();var getNodeCapability=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return postMessagePromised(window.parent,{method:'getNodeCapability',args:{}},'*');case 2:return _context4.abrupt("return",_context4.sent);case 3:case"end":return _context4.stop();}}},_callee4,this);}));return function getNodeCapability(){return _ref4.apply(this,arguments);};}();var getAPIGatewayDataFromParent=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return postMessagePromised(window.parent,{method:'getAPIGatewayDataFromParent',args:args},'*');case 2:return _context5.abrupt("return",_context5.sent);case 3:case"end":return _context5.stop();}}},_callee5,this);}));return function getAPIGatewayDataFromParent(_x2){return _ref5.apply(this,arguments);};}();var getOverviewData=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return postMessagePromised(window.parent,{method:'getOverviewData',args:args},'*');case 2:return _context6.abrupt("return",_context6.sent);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getOverviewData(_x3){return _ref6.apply(this,arguments);};}();var getDocumentURL=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return postMessagePromised(window.parent,{method:'getDocumentURL',args:{}},'*');case 2:return _context7.abrupt("return",_context7.sent);case 3:case"end":return _context7.stop();}}},_callee7,this);}));return function getDocumentURL(){return _ref7.apply(this,arguments);};}();var getLocaleFromParent=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return postMessagePromised(window.parent,{method:'getLocale',args:{}},'*',200);case 2:response=_context8.sent;if(!(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["C" /* TIMEOUT_STRING */]!==response)){_context8.next=5;break;}return _context8.abrupt("return",JSON.parse(response.locale));case 5:case"end":return _context8.stop();}}},_callee8,this);}));return function getLocaleFromParent(){return _ref8.apply(this,arguments);};}();function setSelectedCycle(selectedCycle){window.parent.postMessage({method:'setSelectedCycle',args:{selectedCycle:selectedCycle}},"*");}window.addEventListener("message",onNewPostMessageFromParent,false);function onNewPostMessageFromParent(event){if(event.data.method&&subscribeAbleEvents.hasOwnProperty(event.data.method)){subscribeAbleEvents[event.data.method](event.data);}}var subscribeAbleEvents={"sendCycleDataToChild":sendCycleDataToChild,"sendApiGatewayResponse":sendApiGatewayResponse,"sendOverviewResponse":sendOverviewResponse,"sendCapabilityResponse":sendCapabilityResponse,"sendDocumentURL":sendDocumentURL,"sendLocaleResponse":sendChildData,"sendDarkModeStatus":sendDarkModeStatus,"sendFeatureStatus":sendFeatureStatus};function sendDarkModeStatus(data){if(data.childData.capability===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["f" /* DARK_MODE */].DARK){setCurrentDarkMode(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["f" /* DARK_MODE */].DARK);}else{setCurrentDarkMode(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["f" /* DARK_MODE */].LIGHT);}}function sendCycleDataToChild(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendCapabilityResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendApiGatewayResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendOverviewResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendDocumentURL(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendChildData(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}/**
 * Sends the feature status data to the corresponding promise resolver.
 */function sendFeatureStatus(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(435));

var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(584));

var _default = _text["default"];
exports["default"] = _default;

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteStageContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_RouteStageReducer__ = __webpack_require__(318);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var RouteStageContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var RouteStageContextProvider=function RouteStageContextProvider(props){var state={totalRoutes:'0',stagedRoutes:'0',departedRoutes:'0',preStagedCarts:'0',stagedCarts:'0',dwellingCartsDSP:'0',dwellingCartsFlex:'0',cartList:[],routeList:[],stageTaskPlanList:[],alert:{},lastUpdated:null,showPendingConfirmation:false,pendingConfirmationData:null};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_RouteStageReducer__["a" /* RouteStageReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RouteStageContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (RouteStageContextProvider);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(164);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SIDELINED; });
/* unused harmony export ROUTE_CUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGNABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IN_PROGRESS; });
/* unused harmony export STOW_IN_PROGRESS */
/* unused harmony export PICKED */
/* unused harmony export MISSING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOT_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STAGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRE_STAGED; });
/* unused harmony export NOT_STAGED */
/* unused harmony export NOT_DEPARTED */
/* unused harmony export NOT_ASSIGNED */
/* unused harmony export ASSIGNED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEPARTED; });
/* unused harmony export EXECUTING */
/* unused harmony export PLANNED */
/* unused harmony export CANCELLED */
/* unused harmony export ROUTE_CANCELLED */
/* unused harmony export READY_FOR_DISPATCH */
/* unused harmony export DISPATCHED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PARTIALLY_DEPARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PARTIALLY_STAGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTERIM_STAGED; });
/* unused harmony export NOT_PICKED_STATUS_LIST */
/* unused harmony export MULTI_BOX */
/* unused harmony export PDD */
/* unused harmony export SCHEDULED_DELIVERY */
/* unused harmony export CART_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STAGE_TASK_PLAN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEPART_STATUS; });
/* unused harmony export DEPART_STATUS_IN */
/* unused harmony export SHIPMENT_TYPE_AMXL */
/* harmony export (immutable) */ __webpack_exports__["u"] = getRouteStatus;
/* harmony export (immutable) */ __webpack_exports__["v"] = getRouteStatusColor;
/* harmony export (immutable) */ __webpack_exports__["x"] = getStageStatus;
/* unused harmony export isPickingComplete */
/* harmony export (immutable) */ __webpack_exports__["y"] = getStageStatusColor;
/* harmony export (immutable) */ __webpack_exports__["r"] = getDepartStatus;
/* unused harmony export getDepartStatusForIN */
/* harmony export (immutable) */ __webpack_exports__["s"] = getDepartStatusColor;
/* harmony export (immutable) */ __webpack_exports__["p"] = getCartStatus;
/* harmony export (immutable) */ __webpack_exports__["z"] = getStageStatusList;
/* harmony export (immutable) */ __webpack_exports__["t"] = getDepartStatusList;
/* harmony export (immutable) */ __webpack_exports__["w"] = getShipmentTypeList;
/* harmony export (immutable) */ __webpack_exports__["q"] = getCartStatusColor;
/* harmony export (immutable) */ __webpack_exports__["A"] = handleUnassignedRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(9);
var SIDELINED="Sidelined";var ROUTE_CUT="RouteCut";var ASSIGNABLE="Assignable";var IN_PROGRESS="In Progress";var STOW_IN_PROGRESS="Stow in progress";var PICKED="Picked";var MISSING="Missing";var READY="Ready";var NOT_READY="Not Ready";var STAGED="Staged";var PRE_STAGED="Pre Staged";var NOT_STAGED="Not Staged";var NOT_DEPARTED="Not Departed";var NOT_ASSIGNED="Not Assigned";var ASSIGNED="Assigned";var STOWED="Stowed";var DEPARTED="Departed";var EXECUTING="EXECUTING";var PLANNED="PLANNED";var CANCELLED="Cancelled";var ROUTE_CANCELLED="Cancelled";var READY_FOR_DISPATCH="READYFORDISPATCH";var DISPATCHED="DISPATCHED";var PARTIALLY_DEPARTED="Departed (partial)";var PARTIALLY_STAGED="Staged (partial)";var INTERIM_STAGED="Staged-Interim";var NOT_PICKED_STATUS_LIST=[NOT_READY,ASSIGNABLE,IN_PROGRESS];var MULTI_BOX="MultiBox";var PDD="PDD";var SCHEDULED_DELIVERY="Scheduled Delivery";var CART_STATUS={PRE_STAGED:PRE_STAGED,STAGED:STAGED,SIDELINED:SIDELINED};var STAGE_STATUS={NOT_READY:NOT_READY,READY:READY,PRE_STAGED:PRE_STAGED,STAGED:STAGED,PARTIALLY_STAGED:PARTIALLY_STAGED,SIDELINED:SIDELINED};var STAGE_TASK_PLAN_STATUS={ASSIGNABLE:"ASSIGNABLE",HOLD:"HOLD"};var DEPART_STATUS={NOT_READY:NOT_READY,READY:READY,DEPARTED:DEPARTED,PARTIALLY_DEPARTED:PARTIALLY_DEPARTED};var DEPART_STATUS_IN={NOT_READY:NOT_READY,READY:READY,DEPARTED:DEPARTED,ROUTE_CANCELLED:ROUTE_CANCELLED};var SHIPMENT_TYPE_AMXL={SCHEDULED_DELIVERY:SCHEDULED_DELIVERY,PDD:PDD,MULTI_BOX:MULTI_BOX/**
 * Returns route status
 *
 * @param rswsRoute status returned by RSWS
 * @param stationConfig station config 
 * @returns parsed status
 */};function getRouteStatus(rswsRoute,stationConfig){if(rswsRoute.sidelined){return SIDELINED;}else if(rswsRoute.routeCut){return ROUTE_CUT;}else if(isRouteInterimStaged(rswsRoute,stationConfig)){return INTERIM_STAGED;}return rswsRoute.routeStatus;}/**
 * Checks if route is staged at dock door. Applicable only to SSD MMOT
 * @param route
 * @returns {boolean}
 */function isRouteStagedAtDD(route){var isRouteStaged=false;route.stagingLocations.forEach(function(stagingLocation){if(stagingLocation.locationType===__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* DOCK_DOOR */]){isRouteStaged=true;}});return isRouteStaged;}function isRouteInterimStaged(rswsRoute,stationConfig){return stationConfig&&stationConfig.ssdmmotenabled&&rswsRoute.routeStatus===STAGED&&!isRouteStagedAtDD(rswsRoute);}/**
 * Returns route status indicator color
 *
 * @param status of route
 * @returns color
 */function getRouteStatusColor(routeStatus){switch(routeStatus){case SIDELINED:return"error";case ROUTE_CUT:return"warning";case DEPARTED:return"success";case STAGED:return"success";case ASSIGNABLE:return"neutral";default:return"warning";}}function allCartsPreStaged(carts,route,capability,stationConfig){return carts&&carts.length&&carts.every(function(cart){return getCartStatus(route,cart,capability,stationConfig)===PRE_STAGED;});}function allCartsStaged(carts,route,capability,stationConfig){return carts&&carts.length&&carts.every(function(cart){return getCartStatus(route,cart,capability,stationConfig)===STAGED;});}/**
 * Returns stage status
 *
 * @param rswsRoute status returned by RSWS
 * @param stationConfig
 * @param capability
 * @returns stage status
 */function getStageStatus(rswsRoute,stationConfig,capability){if(rswsRoute.sidelined){return SIDELINED;}var isArOrSSD=Object(__WEBPACK_IMPORTED_MODULE_1__Util__["t" /* isARorSSD */])(capability);switch(rswsRoute.routeStatus){case DEPARTED:case PARTIALLY_DEPARTED:case PARTIALLY_STAGED:case STAGED:if(stationConfig.splitStagingEnabled){if(allCartsPreStaged(rswsRoute.carts,rswsRoute,capability,stationConfig)){return STAGE_STATUS.PRE_STAGED;}else if(allCartsStaged(rswsRoute.carts,rswsRoute,capability,stationConfig)){return STAGE_STATUS.STAGED;}}else if(isRouteInterimStaged(rswsRoute,stationConfig)){return INTERIM_STAGED;}return isPartiallyStaged(rswsRoute,stationConfig,capability)?STAGE_STATUS.PARTIALLY_STAGED:STAGE_STATUS.STAGED;case ASSIGNABLE:if(isArOrSSD){return STAGE_STATUS.READY;}else{return STAGE_STATUS.NOT_READY;}case IN_PROGRESS:if(isArOrSSD||!stationConfig.pickStageDecoupleEnabled&&isPickingComplete(rswsRoute)){return STAGE_STATUS.READY;}else{return STAGE_STATUS.NOT_READY;}default:return rswsRoute.routeStatus;}}/**
 * Note: NOT applicable for ARv2.
 * Note: After stage-re-arch project, partial staging status for AMZL coupled sites is determined using pickProgressV2.
 * Note : For STAG, we are directly returning FALSE as we don't have item level progress available
 * TODO : For STAG, construct a solution to track item level progress
 * @param rswsRoute
 */function isPartiallyStaged(rswsRoute,stationConfig,capability){if(stationConfig.stagenabled){return false;}else if(stationConfig.pickStageDecoupleEnabled||Object(__WEBPACK_IMPORTED_MODULE_1__Util__["t" /* isARorSSD */])(capability)){return rswsRoute.stageProgress&&rswsRoute.stageProgress.totalCount&&rswsRoute.stageProgress.completedCount<rswsRoute.stageProgress.totalCount;}else{return rswsRoute.pickProgressV2&&rswsRoute.pickProgressV2.totalCount&&rswsRoute.pickProgressV2.completedCount<rswsRoute.pickProgressV2.totalCount;}}/**
 * Checks if picking is complete ( Not For ARv2 )
 * @param route
 * @param capability
 * @return {boolean|*}
 */function isPickingComplete(route){return route.routeStatus&&!NOT_PICKED_STATUS_LIST.includes(route.routeStatus)||route.pickProgressV2&&route.pickProgressV2.totalCount>0&&route.pickProgressV2.completedCount===route.pickProgressV2.totalCount;}/**
 * Returns stage status indicator color
 *
 * @param stage status of route
 * @returns color
 */function getStageStatusColor(stageStatus){switch(stageStatus){case STAGE_STATUS.SIDELINED:return"error";case STAGE_STATUS.STAGED:return"success";case STAGE_STATUS.PRE_STAGED:case STAGE_STATUS.PARTIALLY_STAGED:case STAGE_STATUS.READY:case INTERIM_STAGED:return"warning";default:return"neutral";}}/**
 * Returns depart status
 *
 * @param route status returned by RSWS
 * @returns depart status
 */function getDepartStatus(rswsRoute,capability){if(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["w" /* isNotINRegionOrSSD */])(capability)){switch(rswsRoute.routeStatus){case DEPARTED:return DEPART_STATUS.DEPARTED;case PARTIALLY_DEPARTED:return DEPART_STATUS.PARTIALLY_DEPARTED;case STAGED:case PARTIALLY_STAGED:return DEPART_STATUS.READY;case READY:return DEPART_STATUS.READY;default:return DEPART_STATUS.NOT_READY;}}return getDepartStatusForIN(rswsRoute);}function getDepartStatusForIN(rswsRoute){switch(rswsRoute.routeStatus){case ASSIGNABLE:return DEPART_STATUS_IN.NOT_READY;case STOWED:return DEPART_STATUS_IN.READY;case STOW_IN_PROGRESS:return DEPART_STATUS_IN.NOT_READY;case DEPARTED:return DEPART_STATUS_IN.DEPARTED;case CANCELLED:return DEPART_STATUS_IN.ROUTE_CANCELLED;default:return DEPART_STATUS.NOT_READY;}}/**
 * Returns depart status indicator color
 *
 * @param depart status of route
 * @returns color
 */function getDepartStatusColor(departStatus){switch(departStatus){case DEPART_STATUS.DEPARTED:return"success";case DEPART_STATUS.PARTIALLY_DEPARTED:case DEPART_STATUS.READY:return"warning";default:return"neutral";}}/**
 * Returns cart status
 *
 * @param route status returned by RSWS
 * @param cart object created from stow and RSWS response.
 * @param capability - station capability
 * @param stationConfig - station config
 * @returns parsed status
 */function getCartStatus(route,cart,capability,stationConfig){if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){if(route.sidelined&&cart.status!=="STAGED"){return SIDELINED;}else if(cart.status==="MISSED"){return MISSING;}else if(cart.status==="STAGED"){return STAGED;}else if(cart.isStowed||cart.status==="READY"){return READY;}else{return NOT_READY;}}else if(stationConfig.splitStagingEnabled){if(route.sidelined&&cart.status!=="STAGED"||cart.status==="SIDELINED"){return SIDELINED;}else if(cart.status==="MISSED"){return MISSING;}else if(cart.status==="STAGED"||cart.stageTime){return STAGED;}else if(cart.preStageLocation){return PRE_STAGED;}else{return NOT_READY;}}else{if(route.sidelined&&cart.status!=="STAGED"||cart.status==="SIDELINED"){return SIDELINED;}else if(cart.status==="STAGED"||cart.stageTime){return STAGED;}else{return PRE_STAGED;}}}function getStageStatusList(viewType,stationConfig){var statusList=Object.values(STAGE_STATUS);if(stationConfig.ssdmmotenabled){statusList.push(INTERIM_STAGED);}if(stationConfig.pickStageDecoupleEnabled&&viewType===__WEBPACK_IMPORTED_MODULE_0__Constants__["w" /* ROUTE_VIEW */]){return statusList.filter(function(status){return status!==READY;});}else if(stationConfig.splitStagingEnabled){return statusList;}else if(!stationConfig.pickStageDecoupleEnabled){return statusList.filter(function(status){return status!==PRE_STAGED;});}else{return Object.values(CART_STATUS);}}function getDepartStatusList(capability){if(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["w" /* isNotINRegionOrSSD */])(capability)){return Object.values(DEPART_STATUS);}return Object.values(DEPART_STATUS_IN);}function getShipmentTypeList(){return Object.values(SHIPMENT_TYPE_AMXL);}/**
 * Returns cart status indicator color
 *
 * @param status of cart
 * @returns color
 */function getCartStatusColor(cartStatus){switch(cartStatus){case SIDELINED:return"error";case MISSING:return"error";case STAGED:return"success";case READY:return"warning";case PRE_STAGED:return"warning";default:return"neutral";}}/**
 * Updates route status to assignable if route is unassigned
 *
 * @param capability
 * @param routes
 * @returns updated routes
 */function handleUnassignedRoutes(capability,routes){if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* CORE_AMZL */]){routes.forEach(function(route){if(route.routeStatus===IN_PROGRESS&&!route.activeAssignee){route.routeStatus=ASSIGNABLE;}//Note: picking duration needs to handled if required in stage/depart tab.
});}return routes;}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _link = _interopRequireDefault(__webpack_require__(560));

var _default = _link["default"];
exports["default"] = _default;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStationCode;
function getStationCode(){var params=new URLSearchParams(window.location.search);return params.get('stationCode');}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return STAGE_TAB_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEPART_TAB_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CART_INFO_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_STAGE_TASK_PLAN_LIST_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSOCIATE_TAB_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GLOBAL_METRIC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RSWS_DWP_UPLOAD_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RSWS_DWP_METADATA_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RSWS_ROUTE_LIST_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RSWS_ROUTE_DETAIL_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RSWS_BATCH_ROUTE_DETAILS_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RSWS_STATION_CONFIG_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RSWS_STATION_DETAILS_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RSWS_SIDELINE_ROUTE_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RSWS_UPDATE_ROUTE_STATUS_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RSWS_UNASSIGN_ROUTE_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SVS_FLOOR_DATA_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SVS_ROUTE_DATA_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROUTE_CACHE_HIT_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ROUTE_CACHE_MISS_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ERROR_COUNT_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RSWS_GET_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RSWS_GET_STATION_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_ROUTE_TO_STOWED_IN_CACHE; });
/* unused harmony export ONE_BOX_IDENTIFIER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MetricType; });
/* harmony export (immutable) */ __webpack_exports__["C"] = logOperationalMetric;
/* harmony export (immutable) */ __webpack_exports__["B"] = logErrorMetric;
/* harmony export (immutable) */ __webpack_exports__["A"] = logCounterMetric;
/* unused harmony export logLatencyMetric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(9);
var STAGE_TAB_METRIC_KEY="SCC_OUTBOUND_STAGE_TAB";var DEPART_TAB_METRIC_KEY="SCC_OUTBOUND_DEPART_TAB";var CART_INFO_METRIC_KEY="SCC_OUTBOUND_CART_INFO_VIEW";var GET_STAGE_TASK_PLAN_LIST_METRIC_KEY="SCC_OUTBOUND_GET_STAGE_TASK_PLAN_LIST";var UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY="SCC_OUTBOUND_UPDATE_STAGE_TASK_PLAN_STATUS_METRIC";var ASSOCIATE_TAB_METRIC_KEY="SCC_OUTBOUND_STAGE_ASSOCIATE_TAB";var GLOBAL_METRIC_KEY="SCC_OUTBOUND_SVSW";var RSWS_DWP_UPLOAD_METRIC="uploadDWP";var RSWS_DWP_METADATA_METRIC="getDWPMetadata";var RSWS_ROUTE_LIST_METRIC="getRouteInformation";var RSWS_ROUTE_DETAIL_METRIC="getContainersFromRSWS";var RSWS_BATCH_ROUTE_DETAILS_METRIC="BatchGetRouteDetails";var RSWS_STATION_CONFIG_METRIC="getStationConfig";var RSWS_STATION_DETAILS_METRIC="getStationDetails";var RSWS_SIDELINE_ROUTE_METRIC="sidelineRoute";var RSWS_UPDATE_ROUTE_STATUS_METRIC="updateRouteStatus";var RSWS_UNASSIGN_ROUTE_METRIC="unassignRoute";var SVS_FLOOR_DATA_METRIC="getFloorDataFromSVS";var SVS_ROUTE_DATA_METRIC="getRouteDataFromSVS";var ROUTE_CACHE_HIT_METRIC="routeCacheHit";var ROUTE_CACHE_MISS_METRIC="routeCacheMiss";var ERROR_COUNT_METRIC="javascript";//Error is appended in publish method
var RSWS_GET_CONFIG="getRSWSConfig";var RSWS_GET_STATION_CONFIG_SUCCESS="getStationConfigSuccess";var UPDATE_ROUTE_TO_STOWED_IN_CACHE="updateRouteToStowedInCache";var ONE_BOX_IDENTIFIER="ONEBOX";var MetricType={SUCCESS:true,FAILED:false/**
 * Publishes API operation metrics: Latency, Errors, Counts and Station-Wise Counts.
 * @param startTime
 * @param stationCode
 * @param processName
 * @param metricName
 * @param type
 * @param error - exception if any
 */};function logOperationalMetric(startTime,stationCode,processName,metricName,type,error){logLatencyMetric(startTime,processName,metricName);if(type===MetricType.SUCCESS){logCounterMetric(stationCode,processName,metricName);}else{logErrorMetric(stationCode,processName,metricName,error);}}/**
 * Publishes error metric.
 * @param stationCode
 * @param processName
 * @param metricName
 * @param error - exception if any
 */function logErrorMetric(stationCode,processName,metricName,error){var errorMetric=metricName+"Error";if(error&&error.response){//axios client was given an error response (5xx, 4xx)
errorMetric+=getErrorStatusStr(error.response.status);}else if(error&&error.request){//axios client never received a response, and the request was never left
errorMetric=metricName+"NetworkError";}logCounterMetric(stationCode,processName,errorMetric);}function getErrorStatusStr(status){if(!status||status<400){return"";}else if(status>=400&&status<500){return"4xx";}else if(status>=500){return"5xx";}}/**
 * Publishes counter metrics and station wise counter metrics.
 * @param stationCode
 * @param processName
 * @param metricName
 */function logCounterMetric(stationCode,processName,metricName){var combinedProcessName=stationCode+"_"+processName;var countMetricReq=publishClientSideMetricsRequest(processName,metricName,1,metricTypeEnum.COUNT);var stationWiseCountMetric=publishClientSideMetricsRequest(combinedProcessName,metricName,1,metricTypeEnum.COUNT);Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["g" /* publishClientSideMetrics */])(countMetricReq);Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["g" /* publishClientSideMetrics */])(stationWiseCountMetric);if(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["y" /* isOneBox */])()){var oneBoxKey=getOneBoxProcessName(processName);var oneBoxCountMetricReq=publishClientSideMetricsRequest(oneBoxKey,metricName,1,metricTypeEnum.COUNT);Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["g" /* publishClientSideMetrics */])(oneBoxCountMetricReq);}}/**
 * Publishes latency metrics
 * @param startTime
 * @param processName
 * @param metricName
 */function logLatencyMetric(startTime,processName,metricName){var metricValue=getTimeDiff(startTime);var timeMetricReq=publishClientSideMetricsRequest(processName,metricName,metricValue,metricTypeEnum.TIME);Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["g" /* publishClientSideMetrics */])(timeMetricReq);if(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["y" /* isOneBox */])()){var oneBoxKey=getOneBoxProcessName(processName);var oneBoxTimeMetricReq=publishClientSideMetricsRequest(oneBoxKey,metricName,metricValue,metricTypeEnum.TIME);Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["g" /* publishClientSideMetrics */])(oneBoxTimeMetricReq);}}var getOneBoxProcessName=function getOneBoxProcessName(processName){return processName+"_"+ONE_BOX_IDENTIFIER;};function getTimeDiff(time){return Date.now()-time;}var metricTypeEnum={COUNT:"count",TIME:"time"};function publishClientSideMetricsRequest(processName,metricName,metricValue,metricType){return{processName:processName,metricName:metricName,metricValue:metricValue,metricType:metricType};}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StageFilterContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_StageFilterReducer__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_LocalStorageKeys__ = __webpack_require__(48);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var StageFilterContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var StageFilterContextProvider=function StageFilterContextProvider(props){var initialState={xptNodes:null,departure:[],driverType:[],cluster:[],viewType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["d" /* CART_VIEW */],stageTabViewType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["w" /* ROUTE_VIEW */],status:[],stageLocationType:[],data:{xptNodes:[],departure:[],driverType:[],cluster:[]}};var urlState=props.context?JSON.parse(props.context.replace('%2f','/')):null;if(urlState){initialState=Object.assign({},initialState,urlState);Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_4__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],initialState);}var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_StageFilterReducer__["a" /* StageFilterReducer */],initialState),_useReducer2=_slicedToArray(_useReducer,2),viewModelF=_useReducer2[0],dispatchF=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StageFilterContext.Provider,{value:{viewModelF:viewModelF,dispatchF:dispatchF}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (StageFilterContextProvider);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRtl = exports.getHorizontalDirection = exports.getDOMDirection = void 0;

var _functional = __webpack_require__(19);

var _canUseDom = _interopRequireDefault(__webpack_require__(118));

var rtlMap = {
  left: "right",
  right: "left",
  borderLeft: "borderRight",
  borderRight: "borderLeft",
  start: "right",
  end: "left",
  topLeft: "topRight",
  topRight: "topLeft",
  bottomLeft: "bottomRight",
  bottomRight: "bottomLeft"
};
var horizontalDirectionMap = {
  start: "left",
  end: "right"
};
/**
 * This method returns the RTL equivalent for an LTR direction.
 * Eg:
 *  getRtl("borderLeft") returns "borderRight"
 *  getRtl("start") returns "right"
 */

var getRtl = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(rtlMap, str) ? rtlMap[str] : str;
});
/**
 * This method returns left/right for start/end. This allows us to accept the
 * start/end prop for our components that have directional props (eg: alignmentHorizontal)
 * while still supporting IE11 which doesn't accept start/end.
 */

exports.getRtl = getRtl;
var getHorizontalDirection = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(horizontalDirectionMap, str) ? horizontalDirectionMap[str] : str;
});
/**
 * Returns the dir of the DOM from an anchor passed into it
 *
 * @param anchor
 */

exports.getHorizontalDirection = getHorizontalDirection;

var getDOMDirection = function getDOMDirection(anchor) {
  try {
    var dir = _canUseDom["default"] && anchor !== null && typeof anchor !== "undefined" ? window.getComputedStyle(anchor).direction : "ltr";
    return dir;
  } catch (_) {
    return "ltr";
  }
};

exports.getDOMDirection = getDOMDirection;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useFocus = _interopRequireDefault(__webpack_require__(438));

var _default = _useFocus["default"];
exports["default"] = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(81);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _column = _interopRequireDefault(__webpack_require__(585));

var _default = _column["default"];
exports["default"] = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(298);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(356);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(68)["default"];

var assertThisInitialized = __webpack_require__(181);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTE_DATA_CACHE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STAGE_FILTER_STATE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEPART_FILTER_STATE_KEY; });
var ROUTE_DATA_CACHE_KEY="routeDataCache";var STAGE_FILTER_STATE_KEY="stageFilterState";var DEPART_FILTER_STATE_KEY="departFilterState";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(417);

var iterableToArrayLimit = __webpack_require__(418);

var unsupportedIterableToArray = __webpack_require__(203);

var nonIterableRest = __webpack_require__(419);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(205);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _focusRing = _interopRequireDefault(__webpack_require__(209));

var _elevation = __webpack_require__(54);

var _token = __webpack_require__(8);

var _borderRadius = _interopRequireDefault(__webpack_require__(117));

var _rtl = __webpack_require__(39);

/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */
var focusRing = function focusRing(themeTokens, _ref) {
  var _ref2, _ref3;

  var focus = _ref.focus,
      error = _ref.error,
      dropShadow = _ref.dropShadow,
      gapColor = _ref.gapColor,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$hoverSelector = _ref.hoverSelector,
      hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides;
  var tokens = (0, _focusRing["default"])(themeTokens);
  var state = focus ? "focus" : error ? "error" : undefined;
  var width = (0, _token.getToken)(tokens, "focusRingWidth");
  var color = (0, _token.getToken)(tokens, "focusRingColor", state);
  var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
  // element then use an inset box shadow.

  var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
  var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
  return _ref3 = {
    // The focuseable element needs to be relatively positioned so that we can
    // absolutely position the focus ring
    position: "relative",
    // If the ring entirely overlaps the focused element's border, turn the
    // element's border off to avoid artifacts near the rounded corners
    borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
  }, (0, _defineProperty2["default"])(_ref3, hoverSelector, dropShadowCss && !color ? {
    boxShadow: dropShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, hoverSelector.split(",").map(function (selector) {
    return "".concat(selector.trim(), ":after");
  }).join(", "), dropShadowCss && state === "error" ? {
    boxShadow: dropShadowAndGapShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref3, "&:after", color ? (_ref2 = {
    content: "''",
    pointerEvents: "none",
    position: "absolute",
    top: -offset - borderWidth,
    right: -offset - borderWidth,
    bottom: -offset - borderWidth,
    left: -offset - borderWidth,
    border: "".concat(width, "px solid ").concat(color),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides) : typeof borderRadius === "string" ? borderRadius.split(" ").map(function (radius) {
      var r = parseInt(radius);
      return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
    }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : borderRadius
  }), (0, _defineProperty2["default"])(_ref2, "boxShadow", state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss), _ref2) : undefined), _ref3;
};

var _default = focusRing;
exports["default"] = _default;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  elevationBackground: 0,
  elevationMidground: 10,
  elevationForeground: 20,
  elevationMasthead: 30,
  elevationFixture: 40,
  elevationSideMenu: 50,
  elevationModal: 60,
  elevationPopover: 70,
  elevationTooltip: 80
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tag = _interopRequireDefault(__webpack_require__(562));

var _default = _tag["default"];
exports["default"] = _default;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(319);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSpacing = exports.parseAlignment = void 0;

var _spacing = _interopRequireDefault(__webpack_require__(415));

var _token = __webpack_require__(8);

// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
  return spacing ? spacing.split(" ").map(function (spacing) {
    return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
  }) : [];
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.


exports.parseSpacing = parseSpacing;

var parseAlignment = function parseAlignment(alignment) {
  var values = alignment.split(" ");
  return {
    x: values[1],
    y: values[0]
  };
};

exports.parseAlignment = parseAlignment;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clickable = _interopRequireDefault(__webpack_require__(436));

var _default = _clickable["default"];
exports["default"] = _default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */
var isSameComponent = function isSameComponent(a, b) {
  if (!a || !b) {
    // Bail if either component wasn't provided
    return false;
  } else if (false) {
    // If a name is set then rely on that in development mode. The component
    // name is more reliable than the type in development mode becaues of a
    // limitation of react-hot-loader (see:
    // https://github.com/gaearon/react-hot-loader/issues/304). Don't use this
    // in production though because minification will change the name and break
    // the comparison.
    var aName = a.displayName || a.name;
    var bName = b.displayName || b.name;
    return aName === bName;
  } else {
    // Just check if the components reference the same class/function.
    return a === b;
  }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */


var isElementOf = function isElementOf(component) {
  return function (element) {
    if (!component || !element) {
      // Bail if either the component or element wasn't provided
      return false;
    } else if (element.type && element.type.WrappedComponent) {
      // If the element's component has a static WrappedComponent property, assume
      // we're working with a HoC and compare the wrapped component instead of the
      // HoC component. The connect HoC from redux uses this pattern, so this
      // check ensures that isElementOf works correctly on redux-connected
      // components.
      return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
    } else {
      // If WrappedComonent isn't set do a normal comparison of element.type
      // (the component that element was instantiated from) and component.
      return isSameComponent(element.type, component);
    }
  };
};

var _default = isElementOf;
exports["default"] = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(441);

var iterableToArray = __webpack_require__(442);

var unsupportedIterableToArray = __webpack_require__(203);

var nonIterableSpread = __webpack_require__(443);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(456),
    getValue = __webpack_require__(459);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBar", {
  enumerable: true,
  get: function get() {
    return _tableActionBar["default"];
  }
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBar.TableActionBarOverlay;
  }
});
Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function get() {
    return _tableCell["default"];
  }
});
Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function get() {
    return _tableRow["default"];
  }
});
Object.defineProperty(exports, "TableSectionHeader", {
  enumerable: true,
  get: function get() {
    return _tableSectionHeader["default"];
  }
});
exports["default"] = void 0;

var _table = _interopRequireDefault(__webpack_require__(516));

var _tableRow = _interopRequireDefault(__webpack_require__(136));

var _tableCell = _interopRequireDefault(__webpack_require__(229));

var _tableSectionHeader = _interopRequireDefault(__webpack_require__(228));

var _tableActionBar = _interopRequireWildcard(__webpack_require__(536));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _table["default"];
exports["default"] = _default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// These styles are helpful for visually hiding an element while still allowing
// the user to interact with it (e.g. hide an input but allow the user to focus
// on it by clicking on an associated label). Simply applying "display: none" to
// an input will tell the browser to ignore it completely and the user will not
// be able to interact with it at all. Having an invisible yet interactive
// element is useful for creating custom styled inputs that are backed by their
// native html counterparts under the hood or for presenting information to
// screen-readers only.
var visuallyHidden = {
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  border: 0,
  width: 1,
  height: 1,
  opacity: 0
};
var _default = visuallyHidden;
exports["default"] = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tooltip = _interopRequireDefault(__webpack_require__(567));

var _default = _tooltip["default"];
exports["default"] = _default;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchRouteInformation;
/* harmony export (immutable) */ __webpack_exports__["h"] = getStageTaskPlanList;
/* harmony export (immutable) */ __webpack_exports__["k"] = updateStageTaskPlanStatus;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRouteData;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDispatchTime;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFilterData;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchRouteContent;
/* harmony export (immutable) */ __webpack_exports__["i"] = sideLineRoute;
/* harmony export (immutable) */ __webpack_exports__["j"] = unassignStager;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchNodeConfig;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchSubStations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Logger__ = __webpack_require__(67);
var getCartsForARStation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(args){var dispatcher,filterDispatcher,baseUrl,capability,stationConfig,result,lastUpdated,routes,floors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;dispatcher=args.dispatcher,filterDispatcher=args.filterDispatcher,baseUrl=args.baseUrl,capability=args.capability,stationConfig=args.stationConfig;_context.next=4;return Promise.all([getStationRoutes(baseUrl,capability,null,stationConfig),getFloorData()]);case 4:result=_context.sent;lastUpdated=new Date().getTime();routes=result[0]&&result[0].status===200?result[0].data.routes:[];floors=result[1]&&result[1].status===200?result[1].data.floors:[];dispatcher({type:"RECEIVE_DATA",data:Object.assign({},getCartsFromRouteAndFloorData(routes,floors,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:getFilterData(routes)});_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getCartsForARStation",_context.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["B" /* logErrorMetric */])(Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["d" /* ERROR_COUNT_METRIC */]);case 16:case"end":return _context.stop();}}},_callee,this,[[0,12]]);}));return function getCartsForARStation(_x){return _ref.apply(this,arguments);};}();var getRouteInformation=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(args){var dispatcher,filterDispatcher,baseUrl,capability,xptNodes,stationConfig,configDispatch,stationCode,response,lastUpdated,output;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatcher=args.dispatcher,filterDispatcher=args.filterDispatcher,baseUrl=args.baseUrl,capability=args.capability,xptNodes=args.xptNodes,stationConfig=args.stationConfig,configDispatch=args.configDispatch;stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context2.prev=2;_context2.next=5;return getStationRoutes(baseUrl,capability,xptNodes,stationConfig);case 5:response=_context2.sent;lastUpdated=new Date().getTime();if(response){output=response.data.routes;dispatcher({type:"UPDATE_ROUTE_DATA_CACHE",data:{record:{response:response.data,xptNodes:xptNodes,stationCode:stationCode},lastUpdated:lastUpdated}});dispatcher({type:"RECEIVE_DATA",data:Object.assign({},getRouteData(output,capability,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:getFilterData(output)});configDispatch({type:'RECEIVE_REFRESH_INTERVAL',data:{refreshInterval:response.data.routeRefreshRate}});}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getRouteInformation",_context2.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["B" /* logErrorMetric */])(Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["d" /* ERROR_COUNT_METRIC */]);case 14:case"end":return _context2.stop();}}},_callee2,this,[[2,10]]);}));return function getRouteInformation(_x2){return _ref2.apply(this,arguments);};}();var getStationRoutes=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(baseUrl,capability,xptNodes,stationConfig){var startTime,stationCode,api,response,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context3.prev=2;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_GET_STATION_ROUTES_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context3.next=11;break;}requestPayload=getRouteRequestPayload(capability,xptNodes);_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context3.sent;_context3.next=14;break;case 11:_context3.next=13;return api.get(getRouteRequestURL(capability,xptNodes));case 13:response=_context3.sent;case 14:if(!(response&&response.status===200)){_context3.next=19;break;}Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);return _context3.abrupt("return",response);case 19:error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getStationRoutes",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);case 22:_context3.next=28;break;case 24:_context3.prev=24;_context3.t0=_context3["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getStationRoutes",_context3.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context3.t0);case 28:return _context3.abrupt("return",null);case 29:case"end":return _context3.stop();}}},_callee3,this,[[2,24]]);}));return function getStationRoutes(_x3,_x4,_x5,_x6){return _ref3.apply(this,arguments);};}();var getFloorData=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var startTime,stationCode,filterMap,requestBody,requestPayload,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context4.prev=2;filterMap={'NODE':[stationCode]};requestBody={filters:filterMap,fieldsRequired:["FLOOR_LABEL","ROUTE_CODE","CART_DATA","ROUTE_ID"]};requestPayload={resourcePath:"svs/floors/data",httpMethod:"post",processName:"stow",requestBody:requestBody};_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context4.sent;if(!(response&&response.status===200)){_context4.next=14;break;}Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["w" /* SVS_FLOOR_DATA_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);return _context4.abrupt("return",response);case 14:Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["w" /* SVS_FLOOR_DATA_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED);case 15:_context4.next=21;break;case 17:_context4.prev=17;_context4.t0=_context4["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getFloorData",_context4.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["w" /* SVS_FLOOR_DATA_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED);case 21:return _context4.abrupt("return",null);case 22:case"end":return _context4.stop();}}},_callee4,this,[[2,17]]);}));return function getFloorData(){return _ref4.apply(this,arguments);};}();var getStageTaskPlanListContent=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(baseUrl,stationConfig,dispatcher){var startTime,stationCode,mainUri,api,response,requestBody,requestPayload,output,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();mainUri="/apigw/getStageTasks/stationCode/"+stationCode;_context5.prev=3;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});requestBody={"associateId":"DUMMY_ID"};if(!(stationConfig&&stationConfig.authEnabled)){_context5.next=13;break;}requestPayload={resourcePath:mainUri,httpMethod:"POST",processName:"routeStaging",requestBody:requestBody};_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 10:response=_context5.sent;_context5.next=16;break;case 13:_context5.next=15;return api.post(mainUri,requestBody);case 15:response=_context5.sent;case 16:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["e" /* GET_STAGE_TASK_PLAN_LIST_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);output={stageTaskPlanList:response.data.stageTaskList};dispatcher({type:"RECEIVE_DATA",data:output});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getStageTaskPlanList",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["e" /* GET_STAGE_TASK_PLAN_LIST_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context5.next=23;break;case 19:_context5.prev=19;_context5.t0=_context5["catch"](3);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getStageTaskPlanList",_context5.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["e" /* GET_STAGE_TASK_PLAN_LIST_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context5.t0);case 23:case"end":return _context5.stop();}}},_callee5,this,[[3,19]]);}));return function getStageTaskPlanListContent(_x7,_x8,_x9){return _ref5.apply(this,arguments);};}();var updateStageTaskPlanStatusContent=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(baseUrl,stationConfig,dispatcher,planId,status,forceUpdate,cycleName){var startTime,stationCode,baseUri,mainUri,api,response,requestBody,requestPayload,_ref7,_ref7$stageBlockingTa,stageBlockingTasksPending,_ref7$countOfPendingT,countOfPendingTasks,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();baseUri="/apigw/updateStageTaskPlan/stationCode/"+stationCode+"/planId/"+planId+"/status/"+status;mainUri=baseUri+"?forceUpdate="+forceUpdate+"&cycleName="+cycleName;_context6.prev=4;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});requestBody={"associateId":"DUMMY_ID"};if(!(stationConfig&&stationConfig.authEnabled)){_context6.next=14;break;}requestPayload={resourcePath:baseUri,httpMethod:"POST",processName:"routeStaging",requestBody:requestBody,requestParams:{forceUpdate:[forceUpdate.toString()],cycleName:[cycleName.toString()]}};_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 11:response=_context6.sent;_context6.next=17;break;case 14:_context6.next=16;return api.post(mainUri,requestBody);case 16:response=_context6.sent;case 17:if(!(response&&response.status===200)){_context6.next=28;break;}if(!(forceUpdate===false&&response.data)){_context6.next=24;break;}_ref7=response.data||{},_ref7$stageBlockingTa=_ref7.stageBlockingTasksPending,stageBlockingTasksPending=_ref7$stageBlockingTa===undefined?false:_ref7$stageBlockingTa,_ref7$countOfPendingT=_ref7.countOfPendingTasks,countOfPendingTasks=_ref7$countOfPendingT===undefined?0:_ref7$countOfPendingT;if(!(stageBlockingTasksPending===true)){_context6.next=24;break;}dispatcher({type:"SHOW_ROUTE_ADJUSTMENT_PENDING",data:{planId:planId,status:status,numberOfRemainingPackages:countOfPendingTasks}});Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["z" /* UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);return _context6.abrupt("return");case 24:Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["z" /* UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);getStageTaskPlanListContent(baseUrl,stationConfig,dispatcher);_context6.next=31;break;case 28:error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI. updateStageTaskPlanStatus",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["z" /* UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);case 31:_context6.next=37;break;case 33:_context6.prev=33;_context6.t0=_context6["catch"](4);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI. updateStageTaskPlanStatus",_context6.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["z" /* UPDATE_STAGE_TASK_PLAN_STATUS_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context6.t0);case 37:case"end":return _context6.stop();}}},_callee6,this,[[4,33]]);}));return function updateStageTaskPlanStatusContent(_x10,_x11,_x12,_x13,_x14,_x15,_x16){return _ref6.apply(this,arguments);};}();var getRouteContent=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(routeId,cartId,dispatcher,baseUrl,stationCode,stationConfig){var startTime,api,response,requestBody,requestPayload,output,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:startTime=Date.now();_context7.prev=1;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context7.next=11;break;}requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)]};requestPayload={resourcePath:"/apigw/route/"+routeId+"/stationCode/"+stationCode,httpMethod:"get",processName:"routeStaging",requestParams:requestBody};_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context7.sent;_context7.next=14;break;case 11:_context7.next=13;return api.get("/rsws/route/"+routeId+"/stationCode/"+stationCode+"?date="+Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0));case 13:response=_context7.sent;case 14:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["b" /* CART_INFO_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);output=response.data.containers;dispatcher({type:"RECEIVE_DATA",data:getContainers(output,cartId)});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getRouteContent",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["b" /* CART_INFO_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context7.next=21;break;case 17:_context7.prev=17;_context7.t0=_context7["catch"](1);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getRouteContent",_context7.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["b" /* CART_INFO_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["o" /* RSWS_ROUTE_DETAIL_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context7.t0);case 21:case"end":return _context7.stop();}}},_callee7,this,[[1,17]]);}));return function getRouteContent(_x17,_x18,_x19,_x20,_x21,_x22){return _ref8.apply(this,arguments);};}();var sidelineRouteRequest=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,routeId,stationCode,baseUrl,stationConfig){var startTime,requestBody,api,response,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:startTime=Date.now();_context8.prev=1;requestBody={"stationCode":stationCode,"operationType":"SIDELINE","requestAttributes":{"routeId":[routeId]}};api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context8.next=11;break;}requestPayload={resourcePath:"/apigw/execute-operation/",httpMethod:"post",processName:"routeStaging",requestBody:requestBody};_context8.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context8.sent;_context8.next=14;break;case 11:_context8.next=13;return api.post("/rsws/execute-operation/",requestBody);case 13:response=_context8.sent;case 14:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["q" /* RSWS_SIDELINE_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);dispatcher({type:"ROUTE_SIDELINED_SUCCESS",data:{alert:{title:"Route Sidelined",type:"success"}}});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.sidelineRouteRequest",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["q" /* RSWS_SIDELINE_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);dispatcher({type:"ROUTE_SIDELINED_ERROR",data:{alert:{title:"Route Sidelined Failed",type:"error"}}});}_context8.next=22;break;case 17:_context8.prev=17;_context8.t0=_context8["catch"](1);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.sidelineRouteRequest",_context8.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["q" /* RSWS_SIDELINE_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context8.t0);dispatcher({type:"ROUTE_SIDELINED_ERROR",data:{alert:{title:"Route Sidelined Failed",type:"error"}}});case 22:case"end":return _context8.stop();}}},_callee8,this,[[1,17]]);}));return function sidelineRouteRequest(_x23,_x24,_x25,_x26,_x27){return _ref9.apply(this,arguments);};}();/** Unassign Stager **/var unassignStagerRequest=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,stageListId,stationCode,associateId,baseUrl,stationConfig){var startTime,requestBody,api,response,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:startTime=Date.now();_context9.prev=1;requestBody={"stationCode":stationCode,"operationType":"UNASSIGN_STAGER","requestAttributes":{"stagelistId":[stageListId],"associateId":[associateId]}};api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context9.next=11;break;}requestPayload={resourcePath:"/apigw/execute-operation/",httpMethod:"post",processName:"routeStaging",requestBody:requestBody};_context9.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context9.sent;_context9.next=14;break;case 11:_context9.next=13;return api.post("/rsws/execute-operation/",requestBody);case 13:response=_context9.sent;case 14:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["t" /* RSWS_UNASSIGN_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);dispatcher({type:"SHOW_NOTIFICATION",data:{alert:{title:"Cart Unassigned",type:"success"}}});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.unassignStagerRequest",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["t" /* RSWS_UNASSIGN_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);dispatcher({type:"SHOW_NOTIFICATION",data:{alert:{title:"Cart Unassignment Failed",type:"error"}}});}_context9.next=22;break;case 17:_context9.prev=17;_context9.t0=_context9["catch"](1);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.unassignStagerRequest",_context9.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["t" /* RSWS_UNASSIGN_ROUTE_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context9.t0);dispatcher({type:"SHOW_NOTIFICATION",data:{alert:{title:"Cart Unassignment Failed",type:"error"}}});case 22:case"end":return _context9.stop();}}},_callee9,this,[[1,17]]);}));return function unassignStagerRequest(_x28,_x29,_x30,_x31,_x32,_x33){return _ref10.apply(this,arguments);};}();/** Get Station Config **/var getNodeConfig=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,baseUrl){var startTime,stationCode,response,requestPayload,api,stationConfig,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context10.prev=2;response=void 0;_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["z" /* isRSWSBosonFlowEnabled */])();case 6:if(!_context10.sent){_context10.next=13;break;}requestPayload={resourcePath:"/apigw/config",requestParams:{stationCode:[stationCode]},httpMethod:"get",processName:"routeStaging"};_context10.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 10:response=_context10.sent;_context10.next=17;break;case 13:api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});_context10.next=16;return api.get("/rsws/config?stationCode="+stationCode);case 16:response=_context10.sent;case 17:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["r" /* RSWS_STATION_CONFIG_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);stationConfig=response.data;dispatcher({type:"RECEIVE_STATION_CONFIG",data:{stationConfig:Object.assign({initialised:true},stationConfig,{refreshInterval:stationConfig.routeRefreshRate})}});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getNodeConfig",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["r" /* RSWS_STATION_CONFIG_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context10.next=24;break;case 20:_context10.prev=20;_context10.t0=_context10["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getNodeConfig",_context10.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["r" /* RSWS_STATION_CONFIG_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context10.t0);case 24:return _context10.abrupt("return",null);case 25:case"end":return _context10.stop();}}},_callee10,this,[[2,20]]);}));return function getNodeConfig(_x34,_x35){return _ref11.apply(this,arguments);};}();/** Get XPT Stations **/var getSubStationsWithParentNode=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,baseUrl,metricKey,stationConfig){var startTime,stationCode,api,response,requestPayload,subStationsResponse,xptNodeList,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context11.prev=2;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context11.next=11;break;}requestPayload={resourcePath:"/apigw/details/station/"+stationCode,httpMethod:"get",processName:"routeStaging"};_context11.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context11.sent;_context11.next=14;break;case 11:_context11.next=13;return api.get("/rsws/details/station/"+stationCode);case 13:response=_context11.sent;case 14:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["s" /* RSWS_STATION_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);subStationsResponse=response.data;xptNodeList=parseSubStationsResponse(subStationsResponse);if(xptNodeList&&Array.isArray(xptNodeList)&&xptNodeList.length>0){xptNodeList.push(stationCode);}dispatcher({type:"RECEIVE_XPT_NODES",data:{xptNodes:xptNodeList}});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getSubStations",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["s" /* RSWS_STATION_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context11.next=21;break;case 17:_context11.prev=17;_context11.t0=_context11["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in StageNetworkAPI.getSubStations",_context11.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["s" /* RSWS_STATION_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context11.t0);case 21:return _context11.abrupt("return",null);case 22:case"end":return _context11.stop();}}},_callee11,this,[[2,17]]);}));return function getSubStationsWithParentNode(_x36,_x37,_x38,_x39){return _ref12.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Get Route List **/function fetchRouteInformation(args){var capability=args.capability;if(capability===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["b" /* AR_V2 */]){getCartsForARStation(args);}else{getRouteInformation(args);}}function getCartsFromRouteAndFloorData(routes,floors,stationConfig){var routeIdToRouteMap=routes.reduce(function(map,route){map[route.routeId]=route;return map;},{});floors.forEach(function(floor){var route=routeIdToRouteMap[floor.routeId];if(!route||!floor.cart||!floor.cart.label){return;}if(route.carts.some(function(e){return e.cartId===floor.cart.label;})){//cart is already staged
var cartIndex=route.carts.findIndex(function(e){return e.cartId===floor.cart.label;});route.carts[cartIndex].isStowed=floor.cart.status==='STOW_COMPLETE';route.carts[cartIndex].stowTime=floor.cart.stowCompleteTime;route.carts[cartIndex].floorLocation=floor.label;}else{//cart is not staged
route.carts.push({cartId:floor.cart.label,isStowed:floor.cart.status==='STOW_COMPLETE',stowTime:floor.cart.stowCompleteTime,floorLocation:floor.label});}});return extractViewModelArV2(routes,stationConfig);}function getRouteRequestPayload(capability,xptNodes){var mainUri="/apigw/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();if(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)&&Array.isArray(xptNodes)&&xptNodes.length){var nodeList=[].concat(_toConsumableArray(xptNodes));var requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)],"nodes":[nodeList.join(",")]};var requestPayload={resourcePath:mainUri,httpMethod:"get",processName:"routeStaging",requestParams:requestBody};return requestPayload;}else{var _requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)]};var _requestPayload={resourcePath:mainUri,httpMethod:"get",processName:"routeStaging",requestParams:_requestBody};return _requestPayload;}}function getRouteRequestURL(capability,xptNodes){var mainUri="/rsws/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])()+"?date="+Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0);if(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)&&Array.isArray(xptNodes)&&xptNodes.length){var nodeList=[].concat(_toConsumableArray(xptNodes));return mainUri+"&nodes="+nodeList.join(",");}else{return mainUri;}}function getStageTaskPlanList(baseUrl,stationConfig,dispatcher){getStageTaskPlanListContent(baseUrl,stationConfig,dispatcher);}function updateStageTaskPlanStatus(baseUrl,stationConfig,dispatcher,planId,status,forceUpdate,cycleName){updateStageTaskPlanStatusContent(baseUrl,stationConfig,dispatcher,planId,status,forceUpdate,cycleName);}function getRouteData(output,capability,stationConfig){var model={totalRoutes:'0',stagedRoutes:'0',preStagedCarts:'0',stagedCarts:'0',dwellingCartsDSP:'0',dwellingCartsFlex:'0',cartList:[]};output=Object(__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["A" /* handleUnassignedRoutes */])(capability,output);model.routeList=convertRouteToUIModel(output,capability,stationConfig);model.totalRoutes=model.routeList.length;model.routeList.forEach(function(route){if(route.routeStatus==="Staged"||route.routeStatus==="Departed"||route.routeStatus==="Departed (partial)"){model.stagedRoutes++;}var carts=route.carts;var currentRouteCarts=[];carts.forEach(function(cart){var cartDetail={routeId:route.routeId,cartId:cart.cartId,stationCode:route.stationCode,routeCode:route.routeCode,routeType:route.routeType,routeSLA:Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["g" /* convertMillisecondsToHHMM */])(route.criticalPullTime),status:Object(__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["p" /* getCartStatus */])(route,cart,capability,stationConfig),routeStatus:route.sidelined?__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["k" /* SIDELINED */]:route.routeStatus,location:Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["b" /* getCartStagingLocation */])(route,cart,capability),routeStagingLocation:route.stagingLocation,/* this is sent to cart drill down view */hazmatWeight:route.hazmatWeight?route.hazmatWeight:"...",picker:route.picker,associate:cart.assignee?cart.assignee.indexOf("@")>-1?cart.assignee.split("@")[0]:cart.assignee:"...",driver:route.driver?route.driver.name:"...",dwelling:cart.isDwelling,stageTime:cart.stageTime,dwellingDuration:cart.isDwelling&&cart.dwellDuration?Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["h" /* convertSecondsToTimeFormat */])(cart.dwellDuration/1000):"..."};model.cartList.push(cartDetail);currentRouteCarts.push(cartDetail);if(cartDetail.status===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["l" /* STAGED */]){model.stagedCarts++;}else if(cartDetail.status===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["i" /* PRE_STAGED */]){model.preStagedCarts++;}});route.carts=currentRouteCarts;});model.dwellingCartsDSP=model.cartList.filter(function(cart){return cart.dwelling===true&&cart.routeType.startsWith("DSP");}).length;model.dwellingCartsFlex=model.cartList.filter(function(cart){return cart.dwelling===true&&!cart.routeType.startsWith("DSP");}).length;return model;}function convertRouteToUIModel(routes,capability,stationConfig){return routes.map(function(route){if(capability===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["e" /* CORE_AMZL */]){route.carts=route.carts.filter(function(cart){return cart.preStageLocation!==null&&cart.preStageLocation!==''||cart.stageTime;});}route.criticalPullTime=getDispatchTime(route,capability);var stageStatus=Object(__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["x" /* getStageStatus */])(route,stationConfig,capability);route.stagingLocations=Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["d" /* transformStagingLocations */])(route);return{routeId:route.routeId,routeCode:route.routeCode,stationCode:route.stationCode,routeType:route.type,routeSLA:Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["g" /* convertMillisecondsToHHMM */])(route.criticalPullTime),criticalPullTime:route.criticalPullTime,plannedDispatchTime:route.plannedDispatchTime,routeStatus:Object(__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["u" /* getRouteStatus */])(route,stationConfig),picker:Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["i" /* formatAlias */])(Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["n" /* getLatestPicker */])(capability,route)),stageStatus:stageStatus,/* NOT USED FOR ARV2 */hazmatWeight:route.hazmatWeight?route.hazmatWeight:"",driver:route.driver?route.driver.name:"...",sidelined:route.sidelined,stagingLocations:route.stagingLocations,// Represents list of staging location objects
stagingLocation:Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["c" /* getRouteStagingLocation */])(route),// Represents display label for staging location
totalCarts:route.carts?route.carts.length:0,carts:route.carts,stageTime:getRouteStageTime(route,stageStatus),stageProgress:getStageProgress(route),startTime:getRouteStartTime(route),/* first picker start time */endTime:getRouteEndTime(route),stageDuration:Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["b" /* calculateStageDuration */])(route),/* overall picking duration */stageError:route.pickingErrorMessage,stationPairs:getStationPairs(route)};});}function getRouteStartTime(route){if(route.pickAssociates.length&&route.pickAssociates[0].startTime){return Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["d" /* convertEpochMillisToLocalTime */])(route.pickAssociates[0].startTime);}return"...";}function getRouteEndTime(route){if(route.pickAssociates.length&&route.pickAssociates[0].endTime){return Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["d" /* convertEpochMillisToLocalTime */])(route.pickAssociates[0].endTime);}return"...";}function getStageProgress(rswsRoute){if(rswsRoute.stageProgress){return rswsRoute.stageProgress.completedCount+"/"+rswsRoute.stageProgress.totalCount;}return"...";}function getRouteStageTime(route,stageStatus){if(Array.isArray(route.carts)&&route.carts.length&&(stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].STAGED||stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].PARTIALLY_STAGED)&&!route.sidelined){var cartList=route.carts.filter(function(cart){return cart.stageTime;});if(cartList.length){var lastCart=cartList.reduce(function(previous,current){return previous.stageTime>current.stageTime?previous:current;});return lastCart.stageTime;}}return null;}function getStationPairs(route){if(route.sourceLocation!=null&&route.sourceLocation.length>0){return route.sourceLocation.filter(function(item,pos){return route.sourceLocation.indexOf(item)===pos;}).join(", ");}return"...";}/**
 * return driver arrival time if available else fallback to RTW dispatch time.
 * @param route
 * @param capability
 * @return {*}
 */function getDispatchTime(route,capability){if(capability===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["e" /* CORE_AMZL */]&&route.plannedDispatchTime){return route.plannedDispatchTime;}return route.criticalPullTime;}function extractViewModelArV2(routes,stationConfig){var model={totalRoutes:'0',stagedRoutes:'0',departedRoutes:'0',preStagedCarts:'0',stagedCarts:'0',dwellingCartsDSP:'0',dwellingCartsFlex:'0',routeList:[],cartList:[]};model.routeList=convertRouteToUIModel(routes,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["b" /* AR_V2 */],stationConfig);model.routeList.forEach(function(route){var carts=route.carts;carts.forEach(function(cart){var cartDetail=Object.assign({},route,{cartId:cart.cartId,stageListId:cart.stageListId,stationCode:route.stationCode,stageSLA:calculateStageSLA(route.criticalPullTime),status:Object(__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["p" /* getCartStatus */])(route,cart,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["b" /* AR_V2 */],stationConfig),location:Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["b" /* getCartStagingLocation */])(route,cart,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["b" /* AR_V2 */]),routeStagingLocation:route.stagingLocation,/* this is sent to cart drill down view */associateId:cart.assignee,floorLocation:Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["a" /* getCartFloorLocation */])(cart,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["b" /* AR_V2 */]),associate:cart.assignee?cart.assignee.indexOf("@")>-1?cart.assignee.split("@")[0]:cart.assignee:"..."});cartDetail.dwelling=cartDetail.status==="Ready"&&cart.isStowed?"Yes":"NO";cartDetail.dwellingDuration=cartDetail.dwelling&&cart.stowTime?Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["r" /* getTimeDiffFromCurrentTimeInHHMMSSFormat */])(cart.stowTime):"...";//This will fix the dwelling duration for the hotswapped carts in case they are removed from sort location
if(cartDetail.dwellingDuration==="..."&&cart.isDwelling&&cart.dwellDuration){cartDetail.dwellingDuration=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["h" /* convertSecondsToTimeFormat */])(cart.dwellDuration/1000);cartDetail.dwelling="Yes";}model.cartList.push(cartDetail);if(cartDetail.status==="Staged"){model.stagedCarts++;}});if(route.routeStatus==="Staged"){model.stagedRoutes++;}else if(route.routeStatus==="Departed"){model.departedRoutes++;}});model.totalRoutes=model.routeList.length;model.dwellingCartsDSP=model.cartList.filter(function(cart){return cart.dwelling==="Yes"&&cart.routeType.startsWith("DSP");}).length;model.dwellingCartsFlex=model.cartList.filter(function(cart){return cart.dwelling==="Yes"&&!cart.routeType.startsWith("DSP");}).length;return model;}function calculateStageSLA(criticalPullTime){if(criticalPullTime){var stageByTime=criticalPullTime-__WEBPACK_IMPORTED_MODULE_5__util_Constants__["z" /* STAGE_BY_TIME_THRESHOLD */];return Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["g" /* convertMillisecondsToHHMM */])(stageByTime);}else{return"...";}}function getFilterData(output){var data={departure:new Set(),driverType:new Set(["DSP","DP"]),cluster:new Set()};output.forEach(function(route){if(route.type!=="..."){data.driverType.add(route.type);}data.cluster.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["k" /* getCluster */])(route.routeCode));if(route.criticalPullTime!=null){data.departure.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["g" /* convertMillisecondsToHHMM */])(route.criticalPullTime));}});return data;}/** Get Route Information for give route code **/function fetchRouteContent(routeId,cartId,dispatcher,baseUrl,stationCode,stationConfig){getRouteContent(routeId,cartId,dispatcher,baseUrl,stationCode,stationConfig);}function getContainers(output,cartId){var model={name:cartId,bags:[],packages:[]};var containers=output.filter(function(container){return container.parentResourceLabel===cartId;});containers.forEach(function(container){if(container.containerType==="PACKAGE"){model.packages.push(getContainer(container));}else{model.bags.push(getContainer(container));}});return model;}function getContainer(container){return{label:container.label,location:container.stackingLocation,picked:container.containerStates.includes("PICKED"),staged:container.containerStates.includes("STAGED"),departed:container.containerStates.includes("DEPARTED")};}/** SideLine Route **/function sideLineRoute(dispatcher,routeId,stationCode,baseUrl,stationConfig){sidelineRouteRequest(dispatcher,routeId,stationCode,baseUrl,stationConfig);}function unassignStager(dispatcher,stageListId,stationCode,associateId,baseUrl,stationConfig){unassignStagerRequest(dispatcher,stageListId,stationCode,associateId,baseUrl,stationConfig);}function fetchNodeConfig(dispatcher,baseUrl){getNodeConfig(dispatcher,baseUrl);}function fetchSubStations(dispatcher,baseUrl,capability,metricKey,stationConfig){if(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)){getSubStationsWithParentNode(dispatcher,baseUrl,metricKey,stationConfig);}}function parseSubStationsResponse(response){if(response&&Array.isArray(response.subNodes)){return response.subNodes.map(function(station){return station.code;},[]);}return[];}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_katal_logger__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_katal_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_katal_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(9);
var KATAL_LOGGER_URL_MAP=new Map();KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].NA+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].DEV,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].EU+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].DEV,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].JP+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].DEV,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].NA+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].BETA,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].EU+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].BETA,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].JP+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].BETA,"https://qu7lcw3mpb.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].NA+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].GAMMA,"https://oscf8w0cla.execute-api.us-east-1.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].EU+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].GAMMA,"https://t1z5eetpzg.execute-api.eu-west-1.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].JP+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].GAMMA,"https://g4jiwl57hj.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].IN+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].GAMMA,"https://gjr1153gsb.execute-api.eu-west-1.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].NA+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].PROD,"https://thfx609fl0.execute-api.us-east-1.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].EU+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].PROD,"https://c5p4pn01u1.execute-api.eu-west-1.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].JP+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].PROD,"https://qg29msoxn1.execute-api.us-west-2.amazonaws.com/prod/v1/log");KATAL_LOGGER_URL_MAP.set(__WEBPACK_IMPORTED_MODULE_3__Constants__["v" /* REGION */].IN+"-"+__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].PROD,"https://esz0yfck71.execute-api.eu-west-1.amazonaws.com/prod/v1/log");function getLoggerURL(){var key=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["p" /* getRegion */])()+"-"+Object(__WEBPACK_IMPORTED_MODULE_4__Util__["q" /* getStage */])();return KATAL_LOGGER_URL_MAP.get(key);}function getTimezone(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone;}catch(ignored){}}var Logger={log:null,info:function info(message,context){this.log&&this.log.info(message,context);},error:function error(message,_error,context){this.log&&this.log.error(message,_error,context);},fatal:function fatal(message,error,context){this.log&&this.log.fatal(message,error,context);},initialise:function initialise(){var stage=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["q" /* getStage */])();this.log=new __WEBPACK_IMPORTED_MODULE_0__amzn_katal_logger___default.a({url:getLoggerURL(),logThreshold:__WEBPACK_IMPORTED_MODULE_0__amzn_katal_logger__["Level"].INFO,decodeStackTrace:true,maxLogLineSize:10000,context:{sessionId:Object(__WEBPACK_IMPORTED_MODULE_1_uuid__["v4"])(),stationCode:Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),isOneBox:Object(__WEBPACK_IMPORTED_MODULE_4__Util__["y" /* isOneBox */])(),timezone:getTimezone()},logToConsole:stage!==__WEBPACK_IMPORTED_MODULE_3__Constants__["y" /* STAGE */].PROD});this.log.addErrorListener();}};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _box = _interopRequireDefault(__webpack_require__(406));

var _default = _box["default"];
exports["default"] = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(408);
} else {
  module.exports = require("./prop-types");
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = __webpack_require__(4);

var _functional = __webpack_require__(19);

var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */

var cxMemoized = function cxMemoized(a, b) {
  return cxMemoizedCurried(a)(b);
};

var _default = cxMemoized;
exports["default"] = _default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(82),
    getRawTag = __webpack_require__(421),
    objectToString = __webpack_require__(422);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(211),
    isLength = __webpack_require__(132);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _heading = _interopRequireDefault(__webpack_require__(635));

var _default = _heading["default"];
exports["default"] = _default;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepartContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_DepartReducer__ = __webpack_require__(702);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DepartContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var DepartContextProvider=function DepartContextProvider(props){var state={totalRoute:0,partialDepartedRoutes:0,departedRoutes:0,routeList:[],lastUpdated:null,alert:{},bulkDepartStatus:null};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_DepartReducer__["a" /* DepartReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DepartContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (DepartContextProvider);

/***/ }),
/* 76 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);

  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
exports.normalize = normalize;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;

exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function identity (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return mappingA.name - mappingB.name;
}
exports.compareByOriginalPositions = compareByOriginalPositions;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return mappingA.name - mappingB.name;
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(68));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _ValidateSimpleString = _interopRequireDefault(__webpack_require__(178));

var _KatalMetricType = _interopRequireDefault(__webpack_require__(179));

/**
 * Abstract base class for a single metric in Katal.
 *
 * A single metric contains the name (metricKey), value, type, and the isMonitor flag; everything else is in the
 * KatalMetricsContext it is published to.
 */
var KatalMetricObject = /*#__PURE__*/function () {
  /**
   * Metric types.
   */

  /**
   * Create a new KatalMetricObject with the given name.
   *
   * @param name Name for this metric; published as metricKey field
   */
  function KatalMetricObject(name) {
    (0, _classCallCheck2.default)(this, KatalMetricObject);
    this._name = name;
    this._isMonitor = false;
  }
  /**
   * Get the name for this metric.
   *
   * Note that the name is immutable, and this cannot be set.
   *
   * @returns Name for this metric
   */


  (0, _createClass2.default)(KatalMetricObject, [{
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * Alias for name.
     *
     * @returns Name for this metric
     */

  }, {
    key: "metricKey",
    get: function get() {
      return this._name;
    }
    /**
     * Set the isMonitor flag for this metric, and returns this object for continued use.
     *
     * This flag determines if the metric can be used for dashboards and alarms (i.e. if it will be published to PMET)
     * @param isMonitor New value for the isMonitor flag; defaults to true
     * @returns This object
     */

  }, {
    key: "withMonitor",
    value: function withMonitor() {
      var isMonitor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isMonitor = isMonitor;
      return this;
    }
    /**
     * Set the isMonitor flag for this metric.
     *
     * The value is forced to a boolean based on its truthiness.
     *
     * @param isMonitor New value for the isMonitor flag
     */

  }, {
    key: "isMonitor",
    get:
    /**
     * Get the isMonitor flag for this metric.
     *
     * @returns isMonitor flag for this metric.
     */
    function get() {
      return this._isMonitor;
    }
    /**
     * Check if this metric can be meaningfully monitored.
     *
     * Subclasses must override this.
     *
     * @return Whether this metric can be meaningfully monitored
     */
    ,
    set: function set(isMonitor) {
      this._isMonitor = !!isMonitor;
    }
  }, {
    key: "canMonitor",
    get: function get() {
      throw new Error('Subclass of KatalMetricObject must implement canMonitor');
    }
    /**
     * Get the type of this metric.
     *
     * @return Type of this metric (one of: String, Counter, Timer, List)
     */

  }, {
    key: "type",
    get: function get() {
      throw new Error('Subclass of KatalMetricObject must implement type getter');
    }
    /**
     * Check for a validation error on this object.
     *
     * Returns the first validation error encountered if one is found, otherwise undefined.
     *
     * @returns {Error | undefined} Error found with this object, or undefined if no error is found
     */

  }, {
    key: "validationError",
    value: function validationError() {
      if (this.isMonitor !== undefined && typeof this.isMonitor !== 'boolean') {
        return new Error("Field isMonitor should be a boolean, but it was a ".concat((0, _typeof2.default)(this.isMonitor)));
      }

      return (0, _ValidateSimpleString.default)(this.name, 'field name');
    }
  }]);
  return KatalMetricObject;
}();

exports.default = KatalMetricObject;
(0, _defineProperty2.default)(KatalMetricObject, "Types", _KatalMetricType.default);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(182);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDataWithExpiry;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDataWithExpiry;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRemainingTTL;
/* harmony export (immutable) */ __webpack_exports__["c"] = isRouteCacheValid;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateRouteToStowedInCacheOnReadyForDispatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MetricUtil__ = __webpack_require__(37);
/**
 * Saves data in local storage and set expiry time.
 */function setDataWithExpiry(key,value){try{var currTime=value.lastUpdated===undefined?new Date().getTime():value.lastUpdated;var record={data:value.record,lastUpdated:currTime,expiry:currTime+__WEBPACK_IMPORTED_MODULE_3__Constants__["c" /* CACHE_TTL */]};localStorage.setItem(key,JSON.stringify(record));}catch(e){}}/**
 * Retrieves data from local storage if not expired, null otherwise.
 */function getDataWithExpiry(key){var response={cachedData:null,lastUpdated:null};try{var storedJson=localStorage.getItem(key)||null;if(!storedJson){return response;}var record=JSON.parse(storedJson);var now=new Date();// compare the expiry time of the item with the current time
if(now.getTime()>record.expiry){// cache is expired
localStorage.removeItem(key);return response;}response.cachedData=record.data;response.lastUpdated=record.lastUpdated;return response;}catch(e){return response;}}/**
 * If cache is present for key, this method return number of milliseconds pending until expiry.
 * Otherwise returns 0.
 */function getRemainingTTL(key){try{var storedJson=localStorage.getItem(key)||null;if(!storedJson){return 0;}var record=JSON.parse(storedJson);var now=new Date();// compare the expiry time of the item with the current time
if(now.getTime()<record.expiry){return record.expiry-now.getTime();}}catch(e){}return 0;}/**
 * Checks whether the route cache is valid or not based on the expiry time
 */function isRouteCacheValid(xptNodes){var _getDataWithExpiry=getDataWithExpiry(__WEBPACK_IMPORTED_MODULE_1__LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]),cachedData=_getDataWithExpiry.cachedData;var stationCode=Object(__WEBPACK_IMPORTED_MODULE_0__network_NetworkUtil__["a" /* getStationCode */])();return cachedData&&Object(__WEBPACK_IMPORTED_MODULE_2__Util__["u" /* isArrayEquals */])(xptNodes,cachedData.xptNodes)&&stationCode===cachedData.stationCode;}/**
 * Keep expiry of data same since we expiry is tracked at the cache level.
 */function updateRouteToStowedInCacheOnReadyForDispatch(routeId){var startTime=Date.now();var stationCode=Object(__WEBPACK_IMPORTED_MODULE_0__network_NetworkUtil__["a" /* getStationCode */])();var metricName=__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["y" /* UPDATE_ROUTE_TO_STOWED_IN_CACHE */];try{var _getDataWithExpiry2=getDataWithExpiry(__WEBPACK_IMPORTED_MODULE_1__LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]),cachedData=_getDataWithExpiry2.cachedData,lastUpdated=_getDataWithExpiry2.lastUpdated;if(cachedData==null||cachedData.response==null||cachedData.response.routes==null){return;}cachedData.response.routes.forEach(function(route){if(route.routeId===routeId){route.routeStatus=__WEBPACK_IMPORTED_MODULE_4__EntityStatusManager__["o" /* STOWED */];}});var record={data:cachedData,lastUpdated:lastUpdated,expiry:lastUpdated+__WEBPACK_IMPORTED_MODULE_3__Constants__["c" /* CACHE_TTL */]};localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */],JSON.stringify(record));Object(__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */],metricName,__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["g" /* MetricType */].SUCCESS);}catch(e){Object(__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */],metricName,__WEBPACK_IMPORTED_MODULE_5__MetricUtil__["g" /* MetricType */].FAILED);}}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(420);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(50);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1.76 1.76l8.48 8.48M10.24 1.76l-8.48 8.48'/%3e%3c/g%3e%3c/svg%3e",
  iconCloseWidth: 12,
  iconCloseHeight: 12
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(485),
    baseKeys = __webpack_require__(491),
    isArrayLike = __webpack_require__(73);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */
var getIconCss = function getIconCss(data, color) {
  return data && color ? "url(\"".concat(data.replace(new RegExp("currentColor", "g"), // NOTE: Encode any "#" chars in the color value to future proof against
  // this change: https://www.chromestatus.com/feature/5656049583390720
  color.replace(new RegExp("#", "g"), "%23")), "\")") : "none";
};

var _default = getIconCss;
exports["default"] = _default;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tableActionBarOverlayBackgroundColor: tokens.themeForegroundPrimaryFocus,
    tableForegroundColor: tokens.themeForegroundPrimaryDefault,
    tableBackgroundColorPrimary: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorHover: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorPressed: tokens.themeBackgroundTertiaryDefault,
    tableBackgroundColorHighlight: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorStripe: tokens.themeBackgroundSecondaryDefault,
    tableFontSizeNestedHeader: 14,
    tableFontSizeSectionHeader: 14,
    tableFontSizeBody: 12,
    tableFontWeightHeader: 600,
    tableFontWeightBody: 400,
    tableBorderWidthHeader: 2,
    tableBorderWidthBody: 1,
    tableBorderRadius: 0,
    tableBorderColor: tokens.themeBorderSecondaryDefault,
    tableActionBarOverlayBackgroundColorHover: tokens.themeForegroundAccentHover,
    tableActionBarOverlayBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    tableActionBarOverlayForegroundColor: tokens.themeForegroundInvertedDefault,
    tableSortIndicatorColorDefault: tokens.themeForegroundSecondaryDefault,
    tableSortIndicatorColorHover: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorFocus: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorPressed: tokens.themeForegroundAccentPressed,
    tableSortIndicatorColorSorted: tokens.themeForegroundPrimaryDefault,
    tableSortIndicatorColorPreselected: tokens.themeBorderAccentPreselected,
    tableSortIndicatorWidth: 24,
    tableSortIndicatorHeight: 24,
    tableSortIndicatorSpacing: 4,
    tableSpacingHorizontal: 16,
    tableSpacingVerticalSmall: 8,
    tableSpacingVerticalMedium: 16,
    tableMotionDuration: "100ms",
    tableMotionFunction: "ease",
    tableOverflowShadowOffsetX: 0,
    tableOverflowShadowOffsetY: 8,
    tableOverflowShadowBlur: 8,
    tableOverflowShadowSpread: -4,
    tableOverflowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyRowShadowOffsetX: 0,
    tableOverflowStickyRowShadowOffsetY: 8,
    tableOverflowStickyRowShadowBlur: 8,
    tableOverflowStickyRowShadowSpread: 0,
    tableOverflowStickyRowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyColumnShadowOffsetY: 0,
    tableOverflowStickyColumnShadowOffsetX: 8,
    tableOverflowStickyColumnShadowBlur: 8,
    tableOverflowStickyColumnShadowSpread: 0,
    tableOverflowStickyColumnShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(235),
    findIndex = __webpack_require__(122);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepartFilterContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_DepartFilterReducer__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_LocalStorageKeys__ = __webpack_require__(48);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DepartFilterContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var DepartFilterContextProvider=function DepartFilterContextProvider(props){var initialState={xptNodes:null,departure:[],driverType:[],cluster:[],status:[],departByTime:[],data:{xptNodes:[],departure:[],driverType:[],cluster:[],departByTime:[]}};var urlState=props.context?JSON.parse(props.context.replace('%2f','/')):null;if(urlState){initialState=Object.assign({},initialState,urlState);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_3__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],initialState);}var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_DepartFilterReducer__["a" /* DepartFilterReducer */],initialState),_useReducer2=_slicedToArray(_useReducer,2),viewModelF=_useReducer2[0],dispatchF=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DepartFilterContext.Provider,{value:{viewModelF:viewModelF,dispatchF:dispatchF}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (DepartFilterContextProvider);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(321);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72),
    isObjectLike = __webpack_require__(58);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.getBoundingFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _findIndex = _interopRequireDefault(__webpack_require__(122));

var _findLastIndex = _interopRequireDefault(__webpack_require__(226));

var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */

var canFocusNode = function canFocusNode(node) {
  return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};

exports.canFocusNode = canFocusNode;

var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
  return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};

exports.canKeyboardFocusNode = canKeyboardFocusNode;

var getFocusNodes = function getFocusNodes(node) {
  return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};

exports.getFocusNodes = getFocusNodes;

var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
  return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */


exports.getKeyboardFocusNodes = getKeyboardFocusNodes;

var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
  var nodes = [canFocusNode(node) ? node : undefined].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
  var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
  var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
  var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
  var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
  return {
    startNodes: startNodes,
    endNodes: endNodes
  };
};

exports.getBoundingFocusNodes = getBoundingFocusNodes;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(444),
    baseMatchesProperty = __webpack_require__(500),
    identity = __webpack_require__(134),
    isArray = __webpack_require__(40),
    property = __webpack_require__(508);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(446),
    listCacheDelete = __webpack_require__(447),
    listCacheGet = __webpack_require__(448),
    listCacheHas = __webpack_require__(449),
    listCacheSet = __webpack_require__(450);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(124);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(468);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(92);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

/**
 * Determines if an element is an instance of any one component from a list of
 * components.
 */
var isElementOfAny = function isElementOfAny(components) {
  return function (element) {
    return [].concat(components).some(function (component) {
      return (0, _isElementOf["default"])(component)(element);
    });
  };
};

var _default = isElementOfAny;
exports["default"] = _default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var noTextWrap = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    popoverForegroundColorOutline: tokens.themeForegroundPrimaryDefault,
    popoverForegroundColorFill: "#FFFFFF",
    popoverBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    popoverBackgroundColorFill: "#252829",
    popoverBorderWidth: 1,
    popoverBorderRadius: 4,
    popoverBorderColorOutline: tokens.themeBorderSecondaryDefault,
    popoverBorderColorFill: tokens.themeBorderAlternateDefault,
    popoverSpacingInsetVerticalSmall: 8,
    popoverSpacingInsetVerticalMedium: 12,
    popoverSpacingInsetHorizontalSmall: 8,
    popoverSpacingInsetHorizontalMedium: 12,
    popoverArrowWidth: 16,
    popoverArrowHeight: 8,
    popoverHeaderSpacingHorizontal: 8,
    popoverHeaderFontWeight: 600,
    popoverDropShadowOffsetX: 0,
    popoverDropShadowOffsetY: 1,
    popoverDropShadowBlur: 2,
    popoverDropShadowSpread: 0,
    popoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    popoverMotionDuration: "150ms",
    popoverMotionFunction: "ease",
    popoverClosedScale: 90,
    popoverOffsetWithArrow: 16,
    popoverOffsetWithoutArrow: 8
  }
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestOrigin = exports.getAvailableSpace = exports.flipOrigin = exports.flipAlignment = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Flip an alignment string (e.g. from "top" to "bottom" etc)
 */
var flipAlignment = function flipAlignment(alignment) {
  return {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    center: "center"
  }[alignment];
};
/**
 * Flip an origin (in the form of { x: "left", y: "bottom"}) across either one
 * or both axis.
 */


exports.flipAlignment = flipAlignment;

var flipOrigin = function flipOrigin(origin, flipX, flipY) {
  return {
    x: flipX ? flipAlignment(origin.x) : origin.x,
    y: flipY ? flipAlignment(origin.y) : origin.y
  };
};
/**
 * Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
 * any arbitrary extra space, and an axis, determine how much space is available
 * in the viewport along the provided axis to render a popover.
 */


exports.flipOrigin = flipOrigin;

var getAvailableSpaceOnAxis = function getAvailableSpaceOnAxis(axis, _ref) {
  var anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      extraSpace = _ref.extraSpace;
  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge); // Determine the position along the requested axis in the viewport that
  // represents the edge of the available space for the popover

  var popoverEdge = anchorOrigin[axis] === edge ? anchorRect[edge] : anchorOrigin[axis] === oppositeEdge ? anchorRect[edge] + anchorRect[dimension] : anchorOrigin[axis] === "center" ? anchorRect[edge] + anchorRect[dimension] / 2 : undefined; // Calculate the available space along the requested axis that the popover can
  // use to render

  var availableSpace = popoverOrigin[axis] === edge ? viewportRect[dimension] - popoverEdge - extraSpace[axis] : popoverOrigin[axis] === oppositeEdge ? popoverEdge - extraSpace[axis] : popoverOrigin[axis] === "center" ? 2 * (Math.min(viewportRect[dimension] - popoverEdge, popoverEdge) - extraSpace[axis]) : undefined;
  return Math.max(0, availableSpace);
}; // Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
// and any arbitrary extra space, determine how much space is available in the
// viewport to render a popover.


var getAvailableSpace = function getAvailableSpace(args) {
  return {
    x: getAvailableSpaceOnAxis("x", args),
    y: getAvailableSpaceOnAxis("y", args)
  };
};
/**
 * Given an axis and a bunch of other information, this determines the
 * transform that, when applied to the popover and anchor origins, will result
 * in the best origins to display the popover. The transform will either be a
 * shift left or right (or up or down) along the axis (e.g. center -> left or
 * center -> right) or a flip across the axis entirely (to the other side of the
 * anchor).
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 */


exports.getAvailableSpace = getAvailableSpace;

var getBestOriginTransformOnAxis = function getBestOriginTransformOnAxis(axis, args) {
  var getSpace = function getSpace(anchorOrigin, popoverOrigin) {
    return getAvailableSpaceOnAxis(axis, _objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: anchorOrigin,
      popoverOrigin: popoverOrigin
    }));
  };

  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge);
  var spaceWithPreferredOrigin = getSpace(args.anchorOrigin, args.popoverOrigin);
  var preferredOriginIsGood = spaceWithPreferredOrigin >= args.popoverRect[dimension]; // If the popover is center-aligned on the anchor then try shifting it
  // left/right or up/down (depending on the axis)

  var tryShift = args.popoverOrigin[axis] === "center" && args.anchorOrigin[axis] === "center" && !preferredOriginIsGood;
  var spaceShiftedStart = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge))) : 0;
  var spaceShiftedEnd = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge))) : 0;
  var shift = spaceShiftedStart > spaceWithPreferredOrigin && spaceShiftedStart > spaceShiftedEnd ? edge : spaceShiftedEnd > spaceWithPreferredOrigin ? oppositeEdge : undefined; // If shifting didn't work then try flipping the popover over the axis
  // entirely (to the other side of the anchor).

  var tryFlip = !preferredOriginIsGood && !shift;
  var flip = tryFlip && getSpace(flipOrigin(args.anchorOrigin, axis === "x", axis === "y"), flipOrigin(args.popoverOrigin, axis === "x", axis === "y")) > spaceWithPreferredOrigin;
  return shift ? {
    type: "shift",
    axis: axis,
    alignment: shift
  } : flip ? {
    type: "flip",
    axis: axis
  } : {
    type: "none"
  };
};
/**
 * This is used to apply a transform from `getBestOriginTransformOnAxis` to an
 * origin object.
 */


var transformOrigin = function transformOrigin(transform, origin) {
  switch (transform.type) {
    case "shift":
      return _objectSpread(_objectSpread({}, origin), {}, (0, _defineProperty2["default"])({}, transform.axis, transform.alignment));

    case "flip":
      return flipOrigin(origin, transform.axis === "x", transform.axis === "y");

    default:
      return origin;
  }
};
/**
 * Determine the anchor and popover origins that will work best for displaying
 * the popover. If there is enough space to show the popover at the origins
 * requested by the user then that will always be treated as the best option.
 * If there is not enough space at those origins *and* there are alternate
 * origins that will buy us more space, the origins that will give us the most
 * space are treated as the best option.
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 *
 * Note that a popover may be shifted side to side or flipped over it's anchor
 * entirely, but it will never moved to an adjacent side (e.g. from the left to
 * the top). Designers/developers should be able to choose good enough defaults
 * for their popovers that this kind of transform won't be necessary to render
 * the popovers within the viewport.
 */


var getBestOrigin = function getBestOrigin(args) {
  // Determine the transforms along the x and y axis that will result in the
  // best display of the popover (not running off any edges of the viewport).
  var transformX = getBestOriginTransformOnAxis("x", args);
  var transformY = getBestOriginTransformOnAxis("y", args); // Apply the transforms to both the anchor origin and the popover origin

  var bestAnchorOrigin = transformOrigin(transformY, transformOrigin(transformX, args.anchorOrigin));
  var bestPopoverOrigin = transformOrigin(transformY, transformOrigin(transformX, args.popoverOrigin)); // Return the new origins along with the available space that they obtained
  // for the popover

  return {
    anchorOrigin: bestAnchorOrigin,
    popoverOrigin: bestPopoverOrigin,
    availableSpace: getAvailableSpace(_objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: bestAnchorOrigin,
      popoverOrigin: bestPopoverOrigin
    }))
  };
};

exports.getBestOrigin = getBestOrigin;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
  var frame = requestAnimationFrame(function () {
    frame = requestAnimationFrame(callback);
  });
  return function () {
    return cancelAnimationFrame(frame);
  };
};

var _default = waitAnimationFrame;
exports["default"] = _default;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(610)();
}


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OVERFLOW_FILTER_TAG_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyGlobalStageLocationTypeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyInlineStagingLocationFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilterTagLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(10);
var OVERFLOW_FILTER_TAG_LABEL="With Overflow";/**
 * If stageLocationType filter is set, it filter out routes which does not have overflow stage location.
 *
 * @param filterState
 * @param route
 * @return {boolean}
 */var applyGlobalStageLocationTypeFilter=function applyGlobalStageLocationTypeFilter(filterState,route){if(filterState.stageLocationType.length===0){return true;}var result=false;route.stagingLocations.forEach(function(location){if(location.type===__WEBPACK_IMPORTED_MODULE_0__Constants__["A" /* STAGE_LOCATION_TYPE */].OVERFLOW){result=true;}});return result;};/**
 * If inline column filter value is provided,
 * This method checks if route has any staging location with display label containing input value.
 * @param route
 * @param value
 * @return {boolean}
 */var applyInlineStagingLocationFilter=function applyInlineStagingLocationFilter(route,value){if(value.length===0){return true;}var result=false;route.stagingLocations.forEach(function(location){if(location.displayLabel.toLowerCase().includes(value.toLowerCase())){result=true;}});return result;};/**
 * Return filter tag label on the basis of type and value of filter.
 *
 * @param filter
 * @param value
 * @return {string|*}
 */var getFilterTagLabel=function getFilterTagLabel(filter,value){if(filter==="stageLocationType"){return OVERFLOW_FILTER_TAG_LABEL;}return value;};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_AssociateDetailReducer__ = __webpack_require__(617);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AssociateContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AssociateContextProvider=function AssociateContextProvider(props){var state={associate:[]};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_AssociateDetailReducer__["a" /* AssociateDetailReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),associateViewModel=_useReducer2[0],associateModelDispatcher=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AssociateContext.Provider,{value:{associateViewModel:associateViewModel,associateModelDispatcher:associateModelDispatcher}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AssociateContextProvider);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CapabilityContext__ = __webpack_require__(20);
/**
 * Custom hook which manages an extra ref variable and keeps it updated with current config.
 *
 * Use-case: To solve stale closures issue in useEffect without re-rendering on context updates.
 * ie. when we don't want to have dependency on capability context in useContext, but need
 * to use updated config inside it, in such cases we use configViewModelRef.
 *
 * @return {{configViewModel, configViewModelRef: React.MutableRefObject<*>, configDispatch}}
 */var useCapabilityContext=function useCapabilityContext(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel,configDispatch=_useContext.configDispatch;var configViewModelRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(configViewModel);configViewModelRef.current=configViewModel;return{configViewModel:configViewModel,configDispatch:configDispatch,configViewModelRef:configViewModelRef};};/* harmony default export */ __webpack_exports__["a"] = (useCapabilityContext);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(306)();
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.StackFrame = factory();
    }
}(this, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
        return function() {
            return this[p];
        };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var objectProps = ['evalOrigin'];

    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);

    function StackFrame(obj) {
        if (!obj) return;
        for (var i = 0; i < props.length; i++) {
            if (obj[props[i]] !== undefined) {
                this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
    }

    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) {
                this.evalOrigin = v;
            } else if (v instanceof Object) {
                this.evalOrigin = new StackFrame(v);
            } else {
                throw new TypeError('Eval Origin must be an Object or StackFrame');
            }
        },

        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) {
                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) {
                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            }
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };

    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');

        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);

        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }

        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };

    for (var i = 0; i < booleanProps.length; i++) {
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        })(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
            return function(v) {
                if (!_isNumber(v)) {
                    throw new TypeError(p + ' must be a Number');
                }
                this[p] = Number(v);
            };
        })(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
            return function(v) {
                this[p] = String(v);
            };
        })(stringProps[k]);
    }

    return StackFrame;
}));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _KatalMetricNamedObjectList = _interopRequireDefault(__webpack_require__(357));

var _KatalMetricTimerStopwatch = _interopRequireDefault(__webpack_require__(186));

var _KatalMetricCounter = _interopRequireDefault(__webpack_require__(183));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Metric that pairs a timer and a failure counter to record the time and status of an attempt to do something.
 */
var KatalMetricTimedAttempt = /*#__PURE__*/function (_KatalMetricNamedObje) {
  (0, _inherits2.default)(KatalMetricTimedAttempt, _KatalMetricNamedObje);

  var _super = _createSuper(KatalMetricTimedAttempt);

  /** The sub-metric name for latency. */

  /** The sub-metric name for failure count. */

  /**
   * Create a new timed attempt with the given name
   *
   * This will create two inner metrics, a KatalMetricCounter that has the given name with ".Failure" appended,
   * and a KatalMetricTimerStopwatch that has the given name with ".Latency" appended.
   *
   * @param name Name of this attempt
   */
  function KatalMetricTimedAttempt(name) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricTimedAttempt);
    _this = _super.call(this, name);

    _this.setNamedMetric(KatalMetricTimedAttempt.LATENCY_SUFFIX, function (name) {
      return new _KatalMetricTimerStopwatch.default(name);
    });

    _this.setNamedMetric(KatalMetricTimedAttempt.FAILURE_SUFFIX, function (name) {
      return new _KatalMetricCounter.default(name, 1);
    });

    return _this;
  }
  /**
   * Set the failure counter metric based on the given failure status.
   *
   * If failure is true the counter will have a value of 1; if it is false the counter will have a value of 0.
   *
   * @param failure Whether this is a failure or not; default true
   */


  (0, _createClass2.default)(KatalMetricTimedAttempt, [{
    key: "setFailure",
    value: function setFailure() {
      var failure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var failureCount = failure ? 1 : 0;
      var metric = this.failureMetric;
      metric.value = failureCount;
    }
    /**
     * Set the failure status to false.
     */

  }, {
    key: "setSuccess",
    value: function setSuccess() {
      this.setFailure(false);
    }
    /**
     * Set the latency metric to the given value, in milliseconds.
     *
     * Note you don't normally have to set this, the underlying metric is a KatalMetricTimerStopwatch that will start
     * and stop automatically.
     *
     * @param latencyMs Latency in milliseconds
     */

  }, {
    key: "setLatency",
    value: function setLatency(latencyMs) {
      var metric = this.latencyMetric;
      metric.value = latencyMs;
    }
    /**
     * Get the timer stopwatch metric for this attempt.
     *
     * @return Timer stopwatch metric for this attempt
     */

  }, {
    key: "latencyMetric",
    get: function get() {
      return this.getNamedMetric(KatalMetricTimedAttempt.LATENCY_SUFFIX);
    }
    /**
     * Get the failure counter metric for this attempt.
     *
     * @return Failure counter metric for this event
     */

  }, {
    key: "failureMetric",
    get: function get() {
      return this.getNamedMetric(KatalMetricTimedAttempt.FAILURE_SUFFIX);
    }
  }]);
  return KatalMetricTimedAttempt;
}(_KatalMetricNamedObjectList.default);

exports.default = KatalMetricTimedAttempt;
(0, _defineProperty2.default)(KatalMetricTimedAttempt, "LATENCY_SUFFIX", 'Latency');
(0, _defineProperty2.default)(KatalMetricTimedAttempt, "FAILURE_SUFFIX", 'Failure');

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = firstMap;

/**
 * Returns the first non-undefined value that results from running each value
 * in the given array through the mapper function.
 * @param array An array of values.
 * @param mapper A mapper function that should return a value or undefined.
 * @returns The first non-undefined value from the mapper function.
 */
function firstMap(array, mapper) {
  var toReturn = undefined;
  array.some(function (val) {
    toReturn = mapper(val);
    return toReturn != null;
  });
  return toReturn;
}

;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    textFontFamilyAmazonEmber: "\"Amazon Ember\", \"Amazon Ember Arabic\", Arial, sans-serif",
    textFontFamilyAmazonEmberArabic: "\"Amazon Ember Arabic\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberDisplay: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberMonospace: "\"Amazon Ember Monospace\", \"Courier New\", Courier, monospace",
    textFontFamilyBookerly: "Bookerly, Georgia, serif",
    textFontFamilyBookerlyDisplay: "\"Bookerly Display\", Georgia, serif",
    textFontSizeD300: 76,
    textFontSizeD200: 54,
    textFontSizeD100: 48,
    textFontSizeD50: 36,
    textFontSizeH600: 36,
    textFontSizeH500: 28,
    textFontSizeH400: 24,
    textFontSizeH300: 20,
    textFontSizeH200: 18,
    textFontSizeH100: 16,
    textFontSizeB500: 20,
    textFontSizeB400: 18,
    textFontSizeB300: 16,
    textFontSizeB200: 14,
    textFontSizeB100: 12,
    textFontWeightD300: 200,
    textFontWeightD200: 200,
    textFontWeightD100: 200,
    textFontWeightD50: 200,
    textFontWeightH600: 600,
    textFontWeightH500: 600,
    textFontWeightH400: 600,
    textFontWeightH300: 600,
    textFontWeightH200: 600,
    textFontWeightH100: 600,
    textFontWeightB500: 400,
    textFontWeightB400: 400,
    textFontWeightB300: 400,
    textFontWeightB200: 400,
    textFontWeightB100: 400,
    textLineHeightD300: "96px",
    textLineHeightD200: "64px",
    textLineHeightD100: "60px",
    textLineHeightD50: "48px",
    textLineHeightH600: "48px",
    textLineHeightH500: "36px",
    textLineHeightH400: "32px",
    textLineHeightH300: "24px",
    textLineHeightH200: "24px",
    textLineHeightH100: "20px",
    textLineHeightB500: "28px",
    textLineHeightB400: "28px",
    textLineHeightB300: "24px",
    textLineHeightB200: "20px",
    textLineHeightB100: "16px",
    textColorPrimary: tokens.themeForegroundPrimaryDefault,
    textColorSecondary: tokens.themeForegroundSecondaryDefault,
    textColorError: tokens.themeForegroundPrimaryError,
    textColorInverted: tokens.themeForegroundInvertedDefault,
    textListSpacingHorizontal: 20,
    textListSpacingVertical: 8
  }
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value for a border radius style.
 *
 * eg: `0px 4px 4px 0px`
 *
 * @returns {string}
 */
var getBorderRadius = function getBorderRadius(borderRadius) {
  var sides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var topLeft = sides.includes("topLeft") ? borderRadius : 0;
  var topRight = sides.includes("topRight") ? borderRadius : 0;
  var bottomLeft = sides.includes("bottomLeft") ? borderRadius : 0;
  var bottomRight = sides.includes("bottomRight") ? borderRadius : 0;
  return "".concat(topLeft, "px ").concat(topRight, "px ").concat(bottomRight, "px ").concat(bottomLeft, "px");
};

var _default = getBorderRadius;
exports["default"] = _default;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var _default = canUseDOM;
exports["default"] = _default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _alert = _interopRequireDefault(__webpack_require__(416));

var _default = _alert["default"];
exports["default"] = _default;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    buttonMotionDuration: "100ms",
    buttonMotionFunction: "ease",
    buttonBackgroundColorPrimaryDefault: tokens.themeForegroundAccentDefault,
    buttonBackgroundColorPrimaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorPrimaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorPrimaryDisabled: tokens.themeForegroundAccentDisabled,
    buttonBackgroundColorSecondaryDefault: tokens.themeBackgroundTertiaryDefault,
    buttonBackgroundColorSecondaryHover: tokens.themeBackgroundTertiaryHover,
    buttonBackgroundColorSecondaryPressed: tokens.themeBackgroundTertiaryPressed,
    buttonBackgroundColorSecondaryDisabled: tokens.themeBackgroundTertiaryDisabled,
    buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorLinkDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorLinkDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorLinkLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorLinkLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonBackgroundColorIconDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorIconDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorIconLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorIconLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonForegroundColorPrimaryDefault: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorPrimaryDisabled: tokens.themeBackgroundAccentDisabled,
    buttonForegroundColorSecondaryDefault: tokens.themeForegroundPrimaryDefault,
    buttonForegroundColorSecondaryDisabled: tokens.themeForegroundTertiaryDisabled,
    buttonForegroundColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonForegroundColorTertiaryHover: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryFocus: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryPressed: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonForegroundColorLinkDarkBackdropDefault: tokens.themePalette300,
    buttonForegroundColorLinkDarkBackdropHover: tokens.themePalette200,
    buttonForegroundColorLinkDarkBackdropPressed: tokens.themePalette100,
    buttonForegroundColorLinkDarkBackdropDisabled: tokens.themePaletteMuted500,
    buttonForegroundColorLinkLightBackdropDefault: tokens.themePalette500,
    buttonForegroundColorLinkLightBackdropHover: tokens.themePalette600,
    buttonForegroundColorLinkLightBackdropPressed: tokens.themePalette700,
    buttonForegroundColorLinkLightBackdropDisabled: tokens.themePaletteMuted200,
    buttonForegroundColorIconDarkBackdropDefault: "#FFFFFF",
    buttonForegroundColorIconDarkBackdropDisabled: "#697576",
    buttonForegroundColorIconLightBackdropDefault: "#232F3E",
    buttonForegroundColorIconLightBackdropDisabled: "#BBC0C1",
    buttonFontSizeSmall: 14,
    buttonFontSizeMedium: 16,
    buttonFontSizeLarge: 18,
    buttonFontSizeXlarge: 28,
    buttonBorderWidth: 2,
    buttonBorderRadius: 4,
    buttonBorderColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonBorderColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBorderColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBorderColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonSpacingInsetHorizontalSmall: 10,
    buttonSpacingInsetHorizontalMedium: 16,
    buttonSpacingInsetHorizontalLarge: 16,
    buttonSpacingInsetHorizontalXlarge: 24,
    buttonHeightSmall: 32,
    buttonHeightMedium: 40,
    buttonHeightLarge: 48,
    buttonHeightXlarge: 64,
    buttonFocusOutlineOffset: 4
  }
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(123),
    baseIteratee = __webpack_require__(94),
    toInteger = __webpack_require__(135);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(50);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(460),
    mapCacheDelete = __webpack_require__(467),
    mapCacheGet = __webpack_require__(469),
    mapCacheHas = __webpack_require__(470),
    mapCacheSet = __webpack_require__(471);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(126),
    setCacheAdd = __webpack_require__(473),
    setCacheHas = __webpack_require__(474);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(487),
    isObjectLike = __webpack_require__(58);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(40),
    isSymbol = __webpack_require__(92);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(225);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _emotion = __webpack_require__(4);

var _focus = _interopRequireDefault(__webpack_require__(227));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(100));

var _functional = __webpack_require__(19);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)({
    "&[mdn-row-background-color-custom] > *": {
      backgroundColor: "".concat(backgroundColor, " !important")
    }
  });
}, ["backgroundColor"]);
/**
 * Used to render a table row. Children must be TableCell components. Place this
 * as a child of the Table component.
 */

var TableRow = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableRow, _React$Component);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    (0, _classCallCheck2["default"])(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      var key = (0, _keycode["default"])(event);

      if (key === "space" || key === "enter") {
        _this.props.onClick(); // Prevent default space and enter behavior (scroll or submit,
        // respectively)


        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderRow", function (_ref2) {
      var parent = _ref2.parent,
          cells = _ref2.cells,
          focus = _ref2.focus,
          focusTrigger = _ref2.focusTrigger,
          _ref2$focusProps = _ref2.focusProps,
          focusProps = _ref2$focusProps === void 0 ? {} : _ref2$focusProps;
      var props = _this.props;
      var clickable = Boolean(props.onClick);
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement("tr", (0, _extends2["default"])({}, passThroughProps, {
        className: styles({
          backgroundColor: hexBgColor
        }),
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onKeyDown: clickable ? _this.onKeyDown : undefined,
        tabIndex: clickable ? "0" : undefined,
        "mdn-row-focus": focus && focusTrigger === "keyboard" ? "" : undefined,
        "mdn-row-parent": parent ? "" : undefined,
        "mdn-row-highlight": props.highlight ? "" : undefined,
        "mdn-row-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-row-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-row-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-row-highlight-on-hover": props.highlightOnHover ? "" : undefined,
        "mdn-row-highlight-on-press": props.onClick && props.highlightOnHover ? "" : undefined,
        "mdn-row-open": parent && props.open ? "" : undefined,
        "mdn-row-child": props.child ? "" : undefined,
        "mdn-row-last-child": props.lastChild ? "" : undefined
      }, focusProps), cells);
    });
    return _this;
  }

  (0, _createClass2["default"])(TableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          open = _this$props.open,
          children = _this$props.children;
      var childRows = [];
      var cells = []; // Separate cells from nested rows

      _react["default"].Children.forEach(children, function (child) {
        if (_this2.isRow(child)) {
          childRows.push(child);
        } else {
          cells.push(child);
        }
      });

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onClick ? /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (focus) {
        return _this2.renderRow(_objectSpread({
          parent: childRows.length > 0,
          cells: cells
        }, focus));
      }) : this.renderRow({
        parent: childRows.length > 0,
        cells: cells
      }), open ? childRows.map(function (row, index) {
        return /*#__PURE__*/_react["default"].cloneElement(row, {
          child: true,
          lastChild: index === childRows.length - 1
        });
      }) : null);
    }
  }]);
  return TableRow;
}(_react["default"].Component);

TableRow.propTypes =  false ? {
  /**
   * A list of `TableCell` elements, as well as any nested `TableRow` elements
   * for expandable tables.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * Indicates that this row is a child of another row. This prop is set
   * automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  child: _propTypes["default"].bool,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This determines if the row is highlighted.
   *
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * This determines if the row should highlight when the user hovers over it.
   * If the row is clickable (i.e. a click handler is passed to the `onClick`
   * prop) then it will also take on a pressed when the user activates it.
   */
  highlightOnHover: _propTypes["default"].bool,

  /**
   * Indicates that this row is the last child of another row. This prop is
   * set automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  lastChild: _propTypes["default"].bool,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * The component that will render any nested table rows (for expandable
   * tables). Inherits the value passed to the "rowComponents" prop of Table by
   * default.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
var _default = TableRow;
exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronRightSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallWidth: 6,
  iconChevronRightSmallHeight: 10
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var addDebouncedEventListener = function addDebouncedEventListener(node, event, listener, options) {
  var timeout = null;

  var debouncedListener = function debouncedListener(event) {
    window.cancelAnimationFrame(timeout);

    if (window && window.requestAnimationFrame) {
      timeout = window.requestAnimationFrame(function () {
        return listener(event);
      });
    }
  };

  if (node && node.addEventListener) {
    node.addEventListener(event, debouncedListener, options);
  }

  return function () {
    window.cancelAnimationFrame(timeout);

    if (node && node.removeEventListener) {
      node.removeEventListener(event, debouncedListener, options);
    }
  };
};

var _default = addDebouncedEventListener;
exports["default"] = _default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _checkbox = _interopRequireDefault(__webpack_require__(529));

var _default = _checkbox["default"];
exports["default"] = _default;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckLargeData: "data:image/svg+xml,%3csvg width='13' height='9' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 4.017l3.996 3.998L12.006 1' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCheckLargeWidth: 13,
  iconCheckLargeHeight: 9
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pagination = _interopRequireDefault(__webpack_require__(538));

var _default = _pagination["default"];
exports["default"] = _default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(539);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconMenuMeatballData: "data:image/svg+xml,%3csvg width='20' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3ccircle transform='rotate(90 18 2)' cx='18' cy='2' r='2'/%3e%3ccircle transform='rotate(90 10 2)' cx='10' cy='2' r='2'/%3e%3ccircle transform='rotate(90 2 2)' cx='2' cy='2' r='2'/%3e%3c/g%3e%3c/svg%3e",
  iconMenuMeatballWidth: 20,
  iconMenuMeatballHeight: 4
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tagFontSize: 14,
    tagHeight: 20,
    tagIndicatorDiameter: 12,
    tagCloseIconMotionDuration: "100ms",
    tagCloseIconMotionFunction: "ease",
    tagCloseIconSize: 16,
    tagCloseIconColorDismissibleThemeDefault: tokens.themeForegroundAccentDefault,
    tagCloseIconColorDismissibleThemeHover: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleThemePressed: tokens.themeForegroundAccentPressed,
    tagCloseIconColorDismissibleThemeFocus: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleNeutralDefault: tokens.themeForegroundTertiaryDefault,
    tagCloseIconColorDismissibleNeutralHover: tokens.themeForegroundTertiaryHover,
    tagCloseIconColorDismissibleNeutralPressed: tokens.themeForegroundTertiaryPressed,
    tagCloseIconColorDismissibleNeutralFocus: tokens.themeForegroundSecondaryDefault,
    tagSpacingInsetStatusRight: 12,
    tagSpacingInsetStatusLeft: 4,
    tagSpacingInsetDismissibleRight: 2,
    tagSpacingInsetDismissibleLeft: 8,
    tagSpacingHorizontal: 8,
    tagBackgroundColorDismissibleTheme: tokens.themeBackgroundAccentDefault,
    tagBackgroundColorDismissibleNeutral: tokens.themeBackgroundTertiaryDefault,
    tagBorderWidth: 1,
    tagBorderRadius: 13,
    tagBorderCompactWidth: 2,
    tagBorderCompactRadius: 999,
    tagBorderColorStatusSuccess: "#ADE422",
    tagBorderColorStatusWarning: "#FAD000",
    tagBorderColorStatusError: "#DE1B1B",
    tagBorderColorStatusNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorStatusTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorCompact: "#232F3E",
    tagFocusOutlineOffset: 4
  }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverController = _interopRequireDefault(__webpack_require__(577));

var _default = _popoverController["default"];
exports["default"] = _default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _portal = _interopRequireDefault(__webpack_require__(578));

var _default = _portal["default"];
exports["default"] = _default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _input = _interopRequireDefault(__webpack_require__(580));

var _default = _input["default"];
exports["default"] = _default;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _responsive = _interopRequireDefault(__webpack_require__(620));

var _default = _responsive["default"];
exports["default"] = _default;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OptionListGroup", {
  enumerable: true,
  get: function get() {
    return _optionListGroup["default"];
  }
});
Object.defineProperty(exports, "OptionListItem", {
  enumerable: true,
  get: function get() {
    return _optionListItem["default"];
  }
});
exports["default"] = void 0;

var _optionList = _interopRequireDefault(__webpack_require__(629));

var _optionListItem = _interopRequireDefault(__webpack_require__(631));

var _optionListGroup = _interopRequireDefault(__webpack_require__(259));

var _default = _optionList["default"];
exports["default"] = _default;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SelectOption", {
  enumerable: true,
  get: function get() {
    return _selectOption["default"];
  }
});
Object.defineProperty(exports, "SelectOptionGroup", {
  enumerable: true,
  get: function get() {
    return _selectOptionGroup["default"];
  }
});
exports["default"] = void 0;

var _select = _interopRequireDefault(__webpack_require__(637));

var _selectOption = _interopRequireDefault(__webpack_require__(262));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(263));

var _default = _select["default"];
exports["default"] = _default;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    scrimBackgroundColor: tokens.themeBackgroundOverlayDefault,
    scrimMotionTiming: "150ms",
    scrimMotionFunction: "ease",
    scrimElevation: 60
  }
};

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_csv__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(18);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ExportCSV=function ExportCSV(props){var csvLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),csvData=_useState2[0],setCSVData=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(csvData.length>0){csvLink.current.link.click();}},[csvData]);var exportCSVFile=function exportCSVFile(){if(props.csvDataProvider){var result=props.csvDataProvider();if(Array.isArray(result)){setCSVData(result);}}};var fileName=props.filePrefix+"_"+new Date().toISOString().slice(0,10)+".csv";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",alignmentHorizontal:"right",spacingInset:"none",spacing:"none"},props.isLink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default.a,{type:"secondary",onClick:exportCSVFile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"stage.exportCSV",defaultMessage:"Export To CSV"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:exportCSVFile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"stage.exportCSV",defaultMessage:"Export To CSV"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_csv__["CSVLink"],{data:csvData,ref:csvLink,filename:fileName,target:"_blank",fileencoding:"UTF-8"})));};/* harmony default export */ __webpack_exports__["a"] = (ExportCSV);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getStageDataInCSVFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDepartDataInCSVFormat;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDepartDataInCSVFormatForIN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routeStageStatus_CartViewTableColumns__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routeStageStatus_RouteViewTableColumns__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depart_DepartTableColumns__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getStageDataInCSVFormat(cartList,routeList,viewType,capability,stationConfig){if((capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]||stationConfig.pickStageDecoupleEnabled)&&viewType===__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* CART_VIEW */]){return getStageDataCartViewInCSVFormat(cartList,capability);}else{return getStageDataRouteViewInCSVFormat(routeList,capability);}}function getStageDataCartViewInCSVFormat(cartList,capability){var csvData=[];//header
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* CORE_AMZL */]){csvData.push(["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__routeStageStatus_CartViewTableColumns__["a" /* CART_VIEW_TABLE_COLUMNS_AMZL */])));}else{csvData.push(["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__routeStageStatus_CartViewTableColumns__["b" /* CART_VIEW_TABLE_COLUMNS_AR */])));}//rows
cartList.forEach(function(cart){var rowData=[];//ROUTE_CODE
rowData.push(cart.routeCode);//DISPATCH_TIME
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* CORE_AMZL */]){rowData.push(cart.routeSLA);}//CART_ID
rowData.push(cart.cartId);//ROUTE_ID
rowData.push(cart.routeId);//STAGE_BY_TIME
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){rowData.push(cart.stageSLA);}//LOCATION
rowData.push(cart.location);//STATUS
rowData.push(cart.status);//DWELL_DURATION
rowData.push(cart.dwellingDuration);//STAGE TIME
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* CORE_AMZL */]){rowData.push(Object(__WEBPACK_IMPORTED_MODULE_4__Util__["e" /* convertEpochToHHMMSS */])(cart.stageTime));}//ASSOCIATE
rowData.push(cart.associate);//STATION_PAIRS
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){rowData.push(cart.stationPairs);}//ROUTE_TYPE
rowData.push(cart.routeType);csvData.push(rowData);});return csvData;}function getStageDataRouteViewInCSVFormat(routeList,capability){var csvData=[];var columns=["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__routeStageStatus_RouteViewTableColumns__["b" /* ROUTE_VIEW_TABLE_COLUMNS */]));var isNodeARorSSD=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["t" /* isARorSSD */])(capability);if(isNodeARorSSD){columns=["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__routeStageStatus_RouteViewTableColumns__["a" /* AR_SSD_ROUTE_VIEW_TABLE_COLUMNS */]));}if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* CORE_AMZL */]){columns=columns.filter(function(column){return column!==__WEBPACK_IMPORTED_MODULE_3__depart_DepartTableColumns__["c" /* DRIVER */];});}//header
csvData.push(columns);//rows
routeList.forEach(function(route){var rowData=[];//ROUTE_CODE
rowData.push(route.routeCode);//DISPATCH_TIME
rowData.push(route.routeSLA);//ROUTE_ID
rowData.push(route.routeId);//LOCATION
rowData.push(route.stagingLocation);//STATUS
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){rowData.push(route.routeStatus);}else{rowData.push(route.stageStatus);}if(isNodeARorSSD){rowData.push(route.stageProgress);rowData.push(route.picker);}//STAGE_TIME
if(__WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)){rowData.push(Object(__WEBPACK_IMPORTED_MODULE_4__Util__["e" /* convertEpochToHHMMSS */])(route.stageTime));}if(isNodeARorSSD){rowData.push(route.stageDuration);}//CARTS
if(!isNodeARorSSD){rowData.push(route.totalCarts);}//DRIVER
if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){rowData.push(route.driver);}//ROUTE_TYPE
rowData.push(route.routeType);csvData.push(rowData);});return csvData;}function getDepartDataInCSVFormat(routeList){var csvData=[];var columns=["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__depart_DepartTableColumns__["a" /* DEPART_TABLE_COLUMNS */]));//header
csvData.push(columns);//rows
routeList.forEach(function(route){var rowData=[];//ROUTE_CODE
rowData.push(route.routeCode);//DISPATCH_TIME
rowData.push(route.routeSLA);//ROUTE_ID
rowData.push(route.routeId);//LOCATION
rowData.push(route.stagingLocation);//STATUS
rowData.push(route.status);//PROGRESS
rowData.push(route.departProgress);//DRIVER
rowData.push(route.driver);//ROUTE_TYPE
rowData.push(route.routeType);csvData.push(rowData);});return csvData;}function getDepartDataInCSVFormatForIN(routeList){var csvData=[];var columns=["Route Code"].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__depart_DepartTableColumns__["b" /* DEPART_TABLE_COLUMNS_IN */]));//header
csvData.push(columns);//rows
routeList.forEach(function(route){var rowData=[];//ROUTE_CODE
rowData.push(route.routeCode);//DISPATCH_TIME
rowData.push(route.routeSLA);//ROUTE_ID
rowData.push(route.routeId);//LOCATION
rowData.push(route.sectorCodes);//STATUS
rowData.push(route.status);//PROGRESS
rowData.push(route.stowProgress+(route.topOffPackageCount?" + "+route.topOffPackageCount:""));//DRIVER
rowData.push(route.driver);//ROUTE_TYPE
rowData.push(route.routeType);csvData.push(rowData);});return csvData;}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DWPFileContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_DWPUploadReducer__ = __webpack_require__(671);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DWPFileContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var DWPFileContextProvider=function DWPFileContextProvider(props){var state={fileName:'',creationTime:'',uploadSource:undefined};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_DWPUploadReducer__["a" /* DWPUploadReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModelDWP=_useReducer2[0],dispatchDWP=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DWPFileContext.Provider,{value:{viewModelDWP:viewModelDWP,dispatchDWP:dispatchDWP}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (DWPFileContextProvider);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileDisplay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_DeviceLayoutContext__ = __webpack_require__(25);
/*
    This acts as a wrapper component and based on visibility parameter
     it will decide to show that component in mobile or not
     eg: If visibility is true wrapped component will be shown on mobile and not on desktop
         If visibility is false wrapped component will be shown on desktop and not on mobile
*/var MobileDisplay=function MobileDisplay(_ref){var children=_ref.children,visibility=_ref.visibility;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_0__context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;return isMobile?visibility?children:null:visibility?null:children;};

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateFilterContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_AssociateFilterReducer__ = __webpack_require__(691);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AssociateFilterContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AssociateFilterContextProvider=function AssociateFilterContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_AssociateFilterReducer__["a" /* AssociateFilterReducer */],[]),_useReducer2=_slicedToArray(_useReducer,2),states=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AssociateFilterContext.Provider,{value:{states:states,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AssociateFilterContextProvider);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartDetailContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_CartDetailReducer__ = __webpack_require__(699);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CartDetailContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var CartDetailContextProvider=function CartDetailContextProvider(props){var state={name:"",bags:[],packages:[]};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_CartDetailReducer__["a" /* CartDetailReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartDetailContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (CartDetailContextProvider);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(291);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Switch; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return matchPath; });
/* unused harmony export withRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path) return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context$$1, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(111);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(313);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(31);
var normalizeHeaderName = __webpack_require__(326);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(169);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(169);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(168)))

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var settle = __webpack_require__(327);
var cookies = __webpack_require__(329);
var buildURL = __webpack_require__(165);
var buildFullPath = __webpack_require__(330);
var parseHeaders = __webpack_require__(333);
var isURLSameOrigin = __webpack_require__(334);
var createError = __webpack_require__(170);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(328);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getRouteStagingLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCartStagingLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCartFloorLocation;
/* harmony export (immutable) */ __webpack_exports__["d"] = transformStagingLocations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(10);
var OVERFLOW_LOCATION_SUFFIX=" (Overflow)";/**
 * Returns staging location of route.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param rswsRoute - response route obj from rsws
 */function getRouteStagingLocation(rswsRoute){if(rswsRoute.stagingLocations.length){return rswsRoute.stagingLocations.map(function(location){return location.displayLabel;}).join(", ");}return"...";}/**
 * Returns staging location of cart.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param route - response route obj from rsws
 * @param cart - cart from SVS/RSWS
 * @param capability - station capability
 */function getCartStagingLocation(route,cart,capability){if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]){if(route.stagingLocation&&route.stagingLocation!=="..."){return route.stagingLocation;}else{return cart.floorLocation?cart.floorLocation:"...";}}else{if(cart.stagingLocation){return getDisplayLabel(cart.stagingLocation);}else if(cart.stageTime){return route.stagingLocation;}else{return cart.preStageLocation;}}}/**
 * Returns floor location of cart.
 *
 * @param cart - cart from SVS/RSWS
 * @param capability - station capability
 */function getCartFloorLocation(cart,capability){if(capability===__WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* AR_V2 */]&&cart.floorLocation&&cart.floorLocation!=="..."){return cart.floorLocation;}else{return null;}}/**
 * Returns parsed staging locations list for route.
 * @param rswsRoute
 * @return {*[]|{displayLabel: (null|string|*), label: (null|string|*), type: string}[]|*}
 */function transformStagingLocations(rswsRoute){if(Array.isArray(rswsRoute.stagingLocations)&&rswsRoute.stagingLocations.length){return rswsRoute.stagingLocations.map(function(location){return{label:location.label,type:location.type,displayLabel:getDisplayLabel(location)};});}else if(rswsRoute.stagingLocation&&rswsRoute.stagingLocation!=="..."){return[{label:rswsRoute.stagingLocation,displayLabel:rswsRoute.stagingLocation,type:__WEBPACK_IMPORTED_MODULE_0__Constants__["A" /* STAGE_LOCATION_TYPE */].NORMAL}];}return[];}function getDisplayLabel(location){if(location.type===__WEBPACK_IMPORTED_MODULE_0__Constants__["A" /* STAGE_LOCATION_TYPE */].OVERFLOW){return""+location.label+OVERFLOW_LOCATION_SUFFIX;}else{return location.label;}}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var base64VLQ = __webpack_require__(175);
var util = __webpack_require__(77);
var ArraySet = __webpack_require__(176).ArraySet;
var MappingList = __webpack_require__(349).MappingList;

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = util.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = util.getArg(aArgs, 'generated');
    var original = util.getArg(aArgs, 'original', null);
    var source = util.getArg(aArgs, 'source', null);
    var name = util.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = util.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[util.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[util.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = util.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet();
    var newNames = new ArraySet();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = util.join(aSourceMapPath, mapping.source)
          }
          if (sourceRoot != null) {
            mapping.source = util.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = util.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = ''

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += base64VLQ.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += base64VLQ.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += base64VLQ.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += base64VLQ.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += base64VLQ.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = util.relative(aSourceRoot, source);
      }
      var key = util.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

exports.SourceMapGenerator = SourceMapGenerator;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

var base64 = __webpack_require__(348);

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
exports.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = __webpack_require__(77);
var has = Object.prototype.hasOwnProperty;

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet() {
  this._array = [];
  this._set = Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet.prototype.size = function ArraySet_size() {
  return Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = util.toSetString(aStr);
  var isDuplicate = has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    this._set[sStr] = idx;
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet.prototype.has = function ArraySet_has(aStr) {
  var sStr = util.toSetString(aStr);
  return has.call(this._set, sStr);
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  var sStr = util.toSetString(aStr);
  if (has.call(this._set, sStr)) {
    return this._set[sStr];
  }
  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

exports.ArraySet = ArraySet;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Counter", {
  enumerable: true,
  get: function get() {
    return _KatalMetricCounter.default;
  }
});
Object.defineProperty(exports, "HttpRequest", {
  enumerable: true,
  get: function get() {
    return _KatalMetricHttpRequest.default;
  }
});
Object.defineProperty(exports, "Initialization", {
  enumerable: true,
  get: function get() {
    return _KatalMetricInitialization.default;
  }
});
Object.defineProperty(exports, "Object", {
  enumerable: true,
  get: function get() {
    return _KatalMetricObject.default;
  }
});
Object.defineProperty(exports, "String", {
  enumerable: true,
  get: function get() {
    return _KatalMetricString.default;
  }
});
Object.defineProperty(exports, "TimedAttempt", {
  enumerable: true,
  get: function get() {
    return _KatalMetricTimedAttempt.default;
  }
});
Object.defineProperty(exports, "Timer", {
  enumerable: true,
  get: function get() {
    return _KatalMetricTimer.default;
  }
});
Object.defineProperty(exports, "TimerStopwatch", {
  enumerable: true,
  get: function get() {
    return _KatalMetricTimerStopwatch.default;
  }
});

var _KatalMetricObject = _interopRequireDefault(__webpack_require__(78));

var _KatalMetricString = _interopRequireDefault(__webpack_require__(180));

var _KatalMetricCounter = _interopRequireDefault(__webpack_require__(183));

var _KatalMetricTimer = _interopRequireDefault(__webpack_require__(185));

var _KatalMetricTimerStopwatch = _interopRequireDefault(__webpack_require__(186));

var _KatalMetricTimedAttempt = _interopRequireDefault(__webpack_require__(113));

var _KatalMetricInitialization = _interopRequireDefault(__webpack_require__(360));

var _KatalMetricHttpRequest = _interopRequireDefault(__webpack_require__(361));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateSimpleString;

var _typeof2 = _interopRequireDefault(__webpack_require__(68));

var SIMPLE_STRING_PAT = /^[A-Za-z0-9.:@_/-]+$/;
var SIMPLE_STRING_MAX_LEN = 127;
/**
 * Check if the given value is valid to be published to KatalMetrics as a field value,
 * such as site, serviceName, methodName, or actionId (note this is not used to check values for string metrics).
 * It returns either undefined (no error), or an Error object describing the problem.
 *
 * To be published, it must be a non-empty string, less than 256 characters, containing only ASCII
 * letters, numbers, or these characters: .:@_/- (those are the PMET field value requirements).
 *
 * @param val String value to check
 * @param nameForError Name to use in the error message, if one is generated
 * @returns Error, or undefined if no error
 */

function validateSimpleString(val, nameForError) {
  if (typeof val !== "string") {
    return new Error("Expected ".concat(nameForError, " to be a string, but it was a ").concat((0, _typeof2.default)(val)));
  }

  if (val.length > SIMPLE_STRING_MAX_LEN) {
    return new Error("Expected ".concat(nameForError, " to be less than ").concat(SIMPLE_STRING_MAX_LEN, " characters, but it was ").concat(val.length, " characters"));
  }

  if (val.length < 1) {
    return new Error("Expected ".concat(nameForError, " to be non-blank"));
  }

  if (!SIMPLE_STRING_PAT.test(val)) {
    return new Error("Expected ".concat(nameForError, " to contain only valid characters, but it was ").concat(val, ".  It can only contain letters, numbers, and these symbols: .:@_/-"));
  } // Couldn't find anything wrong, implicitly return undefined

}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Metric types.
 */
var KatalMetricType;

(function (KatalMetricType) {
  KatalMetricType["String"] = "String";
  KatalMetricType["Counter"] = "Counter";
  KatalMetricType["Timer"] = "Timer";
  KatalMetricType["List"] = "List";
})(KatalMetricType || (KatalMetricType = {}));

;
var _default = KatalMetricType;
exports.default = _default;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(68));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(181));

var _get2 = _interopRequireDefault(__webpack_require__(79));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _KatalMetricObject2 = _interopRequireDefault(__webpack_require__(78));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * String type.
 *
 * Can be used to store arbitrary strings of data.
 */
var KatalMetricString = /*#__PURE__*/function (_KatalMetricObject) {
  (0, _inherits2.default)(KatalMetricString, _KatalMetricObject);

  var _super = _createSuper(KatalMetricString);

  /**
   * Create a string with the given name and value.
   *
   * @param name String name
   * @param value String value
   */
  function KatalMetricString(name, value) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricString);
    _this = _super.call(this, name);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "truncate", false);
    _this.value = value;
    return _this;
  }
  /**
   * Get the value for this string metric.
   *
   * @return Value for this metric
   */


  (0, _createClass2.default)(KatalMetricString, [{
    key: "value",
    get: function get() {
      return this._value;
    }
    /**
     * Set the value for this string metric.
     *
     * The new value should be a string, but number and boolean types will be automatically converted to strings.
     * For other types, including undefined and null, the value will be accepted, but will fail validation when publishing.
     *
     * @param value New value for this metric
     */
    ,
    set: function set(value) {
      if (typeof value === "number" || typeof value === "boolean") {
        value = value.toString();
      }

      this._value = value;
    }
    /**
     * Truncation flag for this string metric.
     *
     * If set, the value here will be automatically truncated to the maximum size allowed by the current schema.
     * Otherwise, sending a value larger than allowed will result in a failure.
     *
     * @param value True to automatically truncate metrics, otherwise false
     */

  }, {
    key: "type",
    get:
    /**
     * Gets the type for this metric.
     *
     * @return Always returns "String".
     */
    function get() {
      return _KatalMetricObject2.default.Types.String;
    }
  }, {
    key: "canMonitor",
    get: function get() {
      return false;
    }
  }, {
    key: "validationError",
    value: function validationError() {
      var superError = (0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricString.prototype), "validationError", this).call(this);
      if (superError) return superError;

      if (typeof this.value !== 'string') {
        return new Error("Expected field value in String metrics object '".concat(this.name, "' to be type string, but it was ").concat((0, _typeof2.default)(this.value)));
      }

      if (this.value.length > KatalMetricString.MAX_SIZE) {
        if (this.truncate) {
          this.value = this.value.substring(0, KatalMetricString.MAX_SIZE);
        } else {
          return new Error("Expected field value in String metrics object '".concat(this.name, "' to be ").concat(KatalMetricString.MAX_SIZE, " characters or less, but it was ").concat(this.value.length, " characters."));
        }
      } // Didn't find anything wrong, implicitly return undefined

    }
  }]);
  return KatalMetricString;
}(_KatalMetricObject2.default);

exports.default = KatalMetricString;
(0, _defineProperty2.default)(KatalMetricString, "MAX_SIZE", 256);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(42);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _get2 = _interopRequireDefault(__webpack_require__(79));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _KatalMetricObject2 = _interopRequireDefault(__webpack_require__(78));

var _ValidateSimpleInt = _interopRequireDefault(__webpack_require__(184));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Counter type.
 *
 * Can be used to count the number of times an event happened on a page, or as a simple 1/0 counter to track
 * success and failure.
 */
var KatalMetricCounter = /*#__PURE__*/function (_KatalMetricObject) {
  (0, _inherits2.default)(KatalMetricCounter, _KatalMetricObject);

  var _super = _createSuper(KatalMetricCounter);

  /**
   * Create a new counter with the given name and value.
   *
   * @param name Counter name
   * @param value Counter value
   */
  function KatalMetricCounter(name) {
    var _this;

    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    (0, _classCallCheck2.default)(this, KatalMetricCounter);
    _this = _super.call(this, name);
    _this.value = value;
    return _this;
  }
  /**
   * Get the value for this counter
   *
   * @return Counter value
   */


  (0, _createClass2.default)(KatalMetricCounter, [{
    key: "value",
    get: function get() {
      return this._value;
    }
    /**
     * Set a new value for this counter
     *
     * @param value New value for this counter
     */
    ,
    set: function set(value) {
      // Math.round will also coerce from a string if necessary, and return NaN if invalid
      this._value = Math.round(value);
    }
    /**
     * Gets the type for this counter.
     *
     * @return Always returns "Counter".
     */

  }, {
    key: "type",
    get: function get() {
      return _KatalMetricObject2.default.Types.Counter;
    }
    /**
     * Add a number to this counter.
     *
     * Can also be negative to subtract.
     *
     * @param addValue Amount to add to this counter
     */

  }, {
    key: "add",
    value: function add(addValue) {
      this.value += addValue;
    }
  }, {
    key: "canMonitor",
    get: function get() {
      return true;
    }
  }, {
    key: "validationError",
    value: function validationError() {
      var superError = (0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricCounter.prototype), "validationError", this).call(this);
      if (superError) return superError;
      return (0, _ValidateSimpleInt.default)(this.value, "field value in Counter metrics object '".concat(this.name, "'"));
    }
  }]);
  return KatalMetricCounter;
}(_KatalMetricObject2.default);

exports.default = KatalMetricCounter;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateSimpleInt;

var _typeof2 = _interopRequireDefault(__webpack_require__(68));

/**
 * Number.isInteger is not in IE11, and letting Babel polyfill it added too much weight.
 * Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
 */
var isInteger = function isInteger(val) {
  return isFinite(val) && Math.floor(val) === val;
};
/**
 * Check if the given value is valid to be published to KatalMetrics as an integer (Counter or Timer),
 * and return either undefined (no error), or an Error object describing the problem.
 *
 * @param val Value to check
 * @param nameForError Name to use when constructing the error message, if necessary
 * @returns Error, or undefined if no error
 */


function validateSimpleInt(val, nameForError) {
  if (typeof val !== 'number') {
    return new Error("Expected ".concat(nameForError, " to have type 'number', but it was type '").concat((0, _typeof2.default)(val), "'"));
  }

  if (val < 0) {
    return new Error("Expected ".concat(nameForError, " to be positive, but it was ").concat(val));
  } // This will also catch NaN and Infinity


  if (!isInteger(val)) {
    return new Error("Expected ".concat(nameForError, " to be an integer, but it was ").concat(val));
  } // Couldn't find anything wrong, implicitly return undefined

}

;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _get2 = _interopRequireDefault(__webpack_require__(79));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _KatalMetricObject2 = _interopRequireDefault(__webpack_require__(78));

var _ValidateSimpleInt = _interopRequireDefault(__webpack_require__(184));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Timer type.
 *
 * Can be used to record a time.  This class requires explicit value; see KatalMetricTimerStopwatch for automatic
 * timing.
 */
var KatalMetricTimer = /*#__PURE__*/function (_KatalMetricObject) {
  (0, _inherits2.default)(KatalMetricTimer, _KatalMetricObject);

  var _super = _createSuper(KatalMetricTimer);

  /**
   * Create a new timer metric.
   *
   * @param name Name for the metric
   * @param value Timer value in milliseconds
   */
  function KatalMetricTimer(name, value) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricTimer);
    _this = _super.call(this, name);
    _this.value = value;
    return _this;
  }
  /**
   * Get the value for this timer
   *
   * @return Timer value in milliseconds
   */


  (0, _createClass2.default)(KatalMetricTimer, [{
    key: "value",
    get: function get() {
      return this._value;
    }
    /**
     * Set the value for this timer
     *
     * @param value New timer value in milliseconds
     */
    ,
    set: function set(value) {
      if (value == undefined) {
        this._value = value;
        return;
      } // Math.round will also coerce from a string if necessary, and return NaN if invalid


      this._value = Math.round(value);
    }
    /**
     * Get the type for this timer.
     *
     * @return Always returns "Timer".
     */

  }, {
    key: "type",
    get: function get() {
      return _KatalMetricObject2.default.Types.Timer;
    }
  }, {
    key: "canMonitor",
    get: function get() {
      return true;
    }
  }, {
    key: "validationError",
    value: function validationError() {
      var superError = (0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricTimer.prototype), "validationError", this).call(this);
      if (superError) return superError;
      return (0, _ValidateSimpleInt.default)(this.value, "field value in Timer metrics object '".concat(this.name, "'"));
    }
  }]);
  return KatalMetricTimer;
}(_KatalMetricObject2.default);

exports.default = KatalMetricTimer;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _set2 = _interopRequireDefault(__webpack_require__(187));

var _get2 = _interopRequireDefault(__webpack_require__(79));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _KatalMetricTimer2 = _interopRequireDefault(__webpack_require__(185));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Subclass of KatalMetricTimer that can be started and stopped, and will record the elapsed time between starting and
 * stopping.  By default it will start when the object is created, and stopped when the value is retrieved with
 * the getter "value".
 */
var KatalMetricTimerStopwatch = /*#__PURE__*/function (_KatalMetricTimer) {
  (0, _inherits2.default)(KatalMetricTimerStopwatch, _KatalMetricTimer);

  var _super = _createSuper(KatalMetricTimerStopwatch);

  /**
   * Create a new timer with the given name and starting time.  If no starting time is given, the current time is used.
   *
   * @param name Name for this timer
   * @param startTime Millisecond epoch time for the start time; defaults to now
   */
  function KatalMetricTimerStopwatch(name, startTime) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricTimerStopwatch);
    _this = _super.call(this, name, undefined);

    _this.start(startTime);

    _this._value = undefined;
    return _this;
  }
  /**
   * Re-start timer with the given start time, or the current time if none is given.
   *
   * @param startTime When the timer was started, in epoch milliseconds; defaults to now
   */


  (0, _createClass2.default)(KatalMetricTimerStopwatch, [{
    key: "start",
    value: function start(startTime) {
      this._startTime = startTime || this.now();
    }
    /**
     * Stop the timer and record the elapsed time.
     *
     * @param stopTime When the timer was stopped, in epoch milliseconds; defaults to now
     */

  }, {
    key: "stop",
    value: function stop(stopTime) {
      return this._stopTime = stopTime || this.now();
    }
    /**
     * Check if the timer has been stopped.
     *
     * @returns Whether the timer has been stopped yet
     */

  }, {
    key: "isStopped",
    get: function get() {
      return this._stopTime !== undefined;
    }
    /**
     * Get the elapsed time between when the timer was started and stopped; if the timer has not yet been stopped,
     * stop it first.
     *
     * @returns Elapsed time between when timer was started and stopped
     */

  }, {
    key: "value",
    get: function get() {
      if ((0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricTimerStopwatch.prototype), "value", this) === undefined) {
        if (!this.isStopped) {
          this.stop();
        } // Rely on super.value setter to round


        (0, _set2.default)((0, _getPrototypeOf2.default)(KatalMetricTimerStopwatch.prototype), "value", this.stopTime - this.startTime, this, true);
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricTimerStopwatch.prototype), "value", this);
    }
    /**
     * Get when this timer was started.
     *
     * @return Start time, in epoch milliseconds
     */
    ,
    set:
    /**
     * Set the value for this metric.  Note this will override the stopwatch behavior and just use the given value.
     *
     * @param value Value for this metric
     */
    function set(value) {
      (0, _set2.default)((0, _getPrototypeOf2.default)(KatalMetricTimerStopwatch.prototype), "value", value, this, true);
    }
  }, {
    key: "startTime",
    get: function get() {
      return this._startTime;
    }
    /**
     * Get when this timer was stopped (or undefined if it is still running)
     *
     * @return Stop time, in epoch millseconds, or undefined if the stopwatch is still running
     */

  }, {
    key: "stopTime",
    get: function get() {
      return this._stopTime;
    }
  }, {
    key: "now",
    value: function now() {
      return performance.now();
    }
  }]);
  return KatalMetricTimerStopwatch;
}(_KatalMetricTimer2.default);

exports.default = KatalMetricTimerStopwatch;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(182);

var defineProperty = __webpack_require__(53);

function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set(target, property, value, receiver) {
      var base = superPropBase(target, property);
      var desc;

      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }

      desc = Object.getOwnPropertyDescriptor(receiver, property);

      if (desc) {
        if (!desc.writable) {
          return false;
        }

        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        defineProperty(receiver, property, value);
      }

      return true;
    };
  }

  return set(target, property, value, receiver);
}

function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);

  if (!s && isStrict) {
    throw new Error('failed to set property');
  }

  return value;
}

module.exports = _set;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _ValidateSimpleString = _interopRequireDefault(__webpack_require__(178));

var _validateCloudWatchDimensions = _interopRequireDefault(__webpack_require__(366));

var _FirstMap = _interopRequireDefault(__webpack_require__(114));

var _mergeLists = __webpack_require__(189);

var _embedRequestId = __webpack_require__(191);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var REQUIRED_FIELDS = ['site', 'serviceName', 'methodName']; // Not required, but general usage (such as complex querying) may be limited without these fields.

var DESIRED_FIELDS = ['actionId'];

var KatalMetricsContext = /*#__PURE__*/function () {
  /**
   * Create a new metrics context with the given fields.
   *
   * @param contextFields Context fields value (default empty)
   */
  function KatalMetricsContext() {
    var contextFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, KatalMetricsContext);
    // Copy fields so this is immutable
    this.context = _objectSpread({}, contextFields);
  }
  /**
   * Return a new KatalMetricsContext which is a copy of this context, with values added or overridden from
   * the given context.
   *
   * If the given context is null or empty, this method may return the original object as an optimization.
   *
   * @param thatContext Context to merge values from
   * @return New context with default values from this context, and values overridden or added by the given context.
   */


  (0, _createClass2.default)(KatalMetricsContext, [{
    key: "merge",
    value: function merge(thatContext) {
      if (!thatContext) return this; // Check for a common error

      if (thatContext instanceof KatalMetricsContext.Builder) {
        throw new Error("KatalMetricsContext.Builder object passed instead of KatalMetricsContext.  Try calling .build() method.");
      }

      var context = thatContext instanceof KatalMetricsContext ? thatContext.context : thatContext;

      var newContext = _objectSpread(_objectSpread(_objectSpread({}, this.context), context), {}, {
        relatedMetrics: (0, _mergeLists.mergeLists)(this.context.relatedMetrics, context.relatedMetrics),
        relatedMetricsSingleAction: (0, _mergeLists.mergeLists)(this.context.relatedMetricsSingleAction, context.relatedMetricsSingleAction),
        // Combines the dimensions from base publisher with any child publisher.
        cloudWatchDimensions: (0, _mergeLists.mergeLists)(this.context.cloudWatchDimensions, context.cloudWatchDimensions)
      });

      return new KatalMetricsContext(newContext);
    }
    /**
     * Return a new context which is a copy of this context with relatedMetricsSingleAction removed.
     *
     * This is intended to be called when creating a new child publisher.
     *
     * @return Copy of this context, with relatedMetricsSingleAction removed
     */

  }, {
    key: "withoutRelatedMetricsSingleAction",
    value: function withoutRelatedMetricsSingleAction() {
      return new KatalMetricsContext(_objectSpread(_objectSpread({}, this.context), {}, {
        relatedMetricsSingleAction: undefined
      }));
    }
    /**
     * Get a context suitable for publication to the driver.
     *
     * This method strips out any private fields, and leaves only fields from the schema that the driver should publish.
     *
     * @return Context suitable for driver publication
     */

  }, {
    key: "driverContext",
    value: function driverContext() {
      // Don't publish relatedMetrics to the driver
      var newContextFields = _objectSpread({}, this.context);

      delete newContextFields["relatedMetrics"];
      delete newContextFields["relatedMetricsSingleAction"];
      delete newContextFields["requestId"];

      if (this.context.requestId) {
        newContextFields.actionId = (0, _embedRequestId.embedRequestId)(newContextFields.actionId, this.context.requestId);
      }

      return new KatalMetricsContext(newContextFields);
    }
    /**
     * Get a simple JavaScript object with a copy of the fields for this context.
     *
     * @return Simple Javascript object with a copy of the fields for this context
     */

  }, {
    key: "getFields",
    value: function getFields() {
      // Copy fields so this remains immutable
      return _objectSpread({}, this.context);
    }
    /**
     * Check for a validation error on this context.
     *
     * Returns the first validation error encountered if one is found, otherwise undefined.
     *
     * @returns Errors found with this context
     */

  }, {
    key: "validationError",
    value: function validationError() {
      var _this = this;

      var err; // Fields “site”, “serviceName”, “methodName”, and “metricKey” are required.

      err = (0, _FirstMap.default)(REQUIRED_FIELDS, function (field) {
        if (_this.context[field] == undefined) {
          return new Error("Field ".concat(field, " is required, but it is ").concat(_this.context[field]));
        }
      });
      if (err) return err; // https://sim.amazon.com/issues/KAT-9769

      DESIRED_FIELDS.forEach(function (field) {
        if (!_this.context[field]) {
          var _window;

          var noDesiredFieldEvent = new CustomEvent("katal.metrics.missing-".concat(field), {
            detail: {
              context: _this.context
            }
          });
          (_window = window) === null || _window === void 0 ? void 0 : _window.dispatchEvent(noDesiredFieldEvent);
          console.warn("No ".concat(field, " present in context."));
        }
      });
      return (0, _FirstMap.default)(Object.keys(this.context), function (field) {
        return _this.validateField(field);
      });
    }
    /**
     * Validate an individual context field.
     *
     * @param field Name of field to validate
     * @returns Error found with this field, or undefined
     */

  }, {
    key: "validateField",
    value: function validateField(field) {
      var val = this.context[field];
      var nameForError = "field ".concat(field);

      switch (field) {
        // Strings which could be used as partition keys ("site" and "serviceName") cannot contain slashes, in
        // addition to the other restictions below.
        case 'site':
        case 'serviceName':
          if (val.indexOf('/') > -1) return new Error("Expected ".concat(nameForError, " to contain only valid characters, but it was ").concat(val, ".  It cannot contain a slash."));
        // Else fall through
        // Strings for fields “site”, “serviceName”, “methodName”, “metricKey” must match be valid PMET field names:
        // maximum length of 256, only letters, numbers, and the dot, colon, at-sign, underscore, forward-slash,
        // and slash characters (in short the regex ^[A-Za-z0-9.:@_/-]+$).

        case 'methodName':
        case 'actionId':
          return (0, _ValidateSimpleString.default)(val, nameForError);

        case 'cloudWatchDimensions':
          return (0, _validateCloudWatchDimensions.default)(val || []);
      } // No error found, implicitly return undefined

    }
    /**
     * Builder class for KatalMetricsContext
     */

  }]);
  return KatalMetricsContext;
}();

exports.default = KatalMetricsContext;
(0, _defineProperty2.default)(KatalMetricsContext, "Builder", /*#__PURE__*/function () {
  function _class2() {
    (0, _classCallCheck2.default)(this, _class2);
    (0, _defineProperty2.default)(this, "context", {});
  }

  (0, _createClass2.default)(_class2, [{
    key: "withSite",
    value: function withSite(site) {
      this.context.site = site;
      return this;
    }
  }, {
    key: "withServiceName",
    value: function withServiceName(serviceName) {
      this.context.serviceName = serviceName;
      return this;
    }
  }, {
    key: "withMethodName",
    value: function withMethodName(methodName) {
      this.context.methodName = methodName;
      return this;
    }
  }, {
    key: "withActionId",
    value: function withActionId(actionId) {
      this.context.actionId = actionId;
      return this;
    }
  }, {
    key: "withRequestId",
    value: function withRequestId(requestId) {
      this.context.requestId = requestId;
      return this;
    }
  }, {
    key: "withCloudWatchDimensions",
    value: function withCloudWatchDimensions(dimensions) {
      this.context.cloudWatchDimensions = dimensions;
      return this;
    }
    /**
     * Replace any related metrics with the given list (see addRelatedMetrics to add instead of replace).
     *
     * Related metrics are metrics that are published whenever a new action is started.  They are used to relate the
     * action back to the context where it is happening, for example a request ID or a user identity.
     *
     * @param relatedMetrics Related metrics to publish when a new action is started for this context
     * @returns This builder object to continue building
     */

  }, {
    key: "withRelatedMetrics",
    value: function withRelatedMetrics() {
      for (var _len = arguments.length, relatedMetrics = new Array(_len), _key = 0; _key < _len; _key++) {
        relatedMetrics[_key] = arguments[_key];
      }

      this.context.relatedMetrics = relatedMetrics;
      return this;
    }
    /**
     * Add additional related metrics to this builder.  See withRelatedMetrics for more information.
     *
     * @param relatedMetrics Additional related metrics to publish when a new action is started for this context
     * @returns This builder object to continue building
     */

  }, {
    key: "addRelatedMetrics",
    value: function addRelatedMetrics() {
      for (var _len2 = arguments.length, relatedMetrics = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        relatedMetrics[_key2] = arguments[_key2];
      }

      this.context.relatedMetrics = (0, _mergeLists.mergeLists)(this.context.relatedMetrics, relatedMetrics);
      return this;
    }
    /**
     * Replace single-action related metrics with the given list (see addRelatedMetricsSingleAction to add instead of replace,
     * and withRelatedMetrics for more information about related metrics).
     *
     * Single-action related metrics are published when a new child metric publisher is created, but not included as
     * related metrics for the new child metric publisher, so are not published again if the child metric publisher
     * creates grandchild published metrics.
     *
     * @param metrics Related metrics
     * @returns This builder object to continue building
     */

  }, {
    key: "withRelatedMetricsSingleAction",
    value: function withRelatedMetricsSingleAction() {
      for (var _len3 = arguments.length, metrics = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        metrics[_key3] = arguments[_key3];
      }

      this.context.relatedMetricsSingleAction = metrics;
      return this;
    }
    /**
     * Add additional single-action related metrics to this builder.  See addRelatedMetricsSingleAction for more information.
     *
     * @param metrics Related metrics
     * @returns This builder object to continue building
     */

  }, {
    key: "addRelatedMetricsSingleAction",
    value: function addRelatedMetricsSingleAction() {
      for (var _len4 = arguments.length, metrics = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        metrics[_key4] = arguments[_key4];
      }

      this.context.relatedMetricsSingleAction = (0, _mergeLists.mergeLists)(this.context.relatedMetricsSingleAction, metrics);
      return this;
    }
    /**
     * Take the fields set in this builder and use them to create a new KatalMetricsContext.
     *
     * @return KatalMetricsContext object built with the parameters given to this builder
     */

  }, {
    key: "build",
    value: function build() {
      return new KatalMetricsContext(this.context);
    }
  }]);
  return _class2;
}());

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeLists = mergeLists;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(367));

// Helper method to merge two lists which could be undefined
// Returns merged lists if either is defined, otherwise returns undefined
function mergeLists(list1, list2) {
  if (list1 || list2) {
    return [].concat((0, _toConsumableArray2.default)(list1 || []), (0, _toConsumableArray2.default)(list2 || []));
  } else {
    return undefined;
  }
}

;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.embedRequestId = embedRequestId;

// until we can add a requestId field to the andes schema we will embed it in the actionId
function embedRequestId(actionId, requestId) {
  if (requestId) {
    return [requestId, actionId].join("::");
  }

  return actionId;
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

/**
 * Abstract base class for a Katal metrics driver.
 */
var KatalMetricsDriver = /*#__PURE__*/function () {
  function KatalMetricsDriver() {
    (0, _classCallCheck2.default)(this, KatalMetricsDriver);
  }

  (0, _createClass2.default)(KatalMetricsDriver, [{
    key: "publish",
    value:
    /**
     * Publish the given metric object with the given error handler and context.
     *
     * @param metricObject Metric object to publish.  Contains metricKey, isMonitor, type, and value.
     * @param context Context for publishing this metric.  Contains all other fields to be published.
     */
    function publish(metricObject, context) {
      throw new Error('KatalMetricsDriver is an abstract class, please choose a driver and use that instead');
    }
  }]);
  return KatalMetricsDriver;
}();

exports.default = KatalMetricsDriver;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 195 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  themeForegroundPrimaryDefault: "#232F3E",
  themeForegroundPrimaryFocus: "#077398",
  themeForegroundPrimaryError: "#AD0A30",
  themeForegroundPrimaryDisabled: "#BBC0C1",
  themeForegroundSecondaryDefault: "#697576",
  themeForegroundSecondaryDisabled: "#E7E9E9",
  themeForegroundTertiaryDefault: "#697576",
  themeForegroundTertiaryHover: "#485050",
  themeForegroundTertiaryPressed: "#252829",
  themeForegroundTertiaryDisabled: "#ABB0B5",
  themeForegroundInvertedDefault: "#FFFFFF",
  themeForegroundAccentDefault: "#077398",
  themeForegroundAccentHover: "#055D7B",
  themeForegroundAccentPressed: "#03384B",
  themeForegroundAccentDisabled: "#C1DEE8",
  themeBorderPrimaryDefault: "#697576",
  themeBorderPrimaryDisabled: "#BBC0C1",
  themeBorderPrimaryFocus: "#077398",
  themeBorderPrimaryError: "#CC0C39",
  themeBorderPrimaryWarning: "#DCB700",
  themeBorderSecondaryDefault: "#BBC0C1",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#E7E9E9",
  themeBorderAlternateDefault: "rgba(0, 0, 0, 0)",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#077398",
  themeBorderAccentPressed: "#055D7B",
  themeBorderAccentDisabled: "#90C5D7",
  themeBorderAccentPreselected: "#7CCEE9",
  themeBorderAlternateAccentDefault: "#055D7B",
  themeBackgroundPrimaryDefault: "#FFFFFF",
  themeBackgroundPrimaryDisabled: "#F0F1F2",
  themeBackgroundSecondaryDefault: "#F0F1F2",
  themeBackgroundSecondaryError: "#FF7494",
  themeBackgroundSecondaryWarning: "#FCDE4D",
  themeBackgroundTertiaryDefault: "#E7E9E9",
  themeBackgroundTertiaryHover: "#BBC0C1",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#ECEDED",
  themeBackgroundAlternatePrimaryDefault: "#FFFFFF",
  themeBackgroundAlternatePrimarySelected: "#F0F1F2",
  themeBackgroundAlternatePrimaryHover: "#E7E9E9",
  themeBackgroundAlternatePrimaryPressed: "#BBC0C1",
  themeBackgroundAlternateSecondaryDefault: "#F9FAFA",
  themeBackgroundAlternateTertiaryDefault: "#FFFFFF",
  themeBackgroundAlternateTertiaryFocus: "#F9FAFA",
  themeBackgroundAccentDefault: "#B9E8F7",
  themeBackgroundAccentDisabled: "#86A4AF",
  themeBackgroundInvertedDefault: "#0B0C0C",
  themeBackgroundOverlayDefault: "rgba(11, 12, 12, 0.5)",
  themeBackgroundOverlayPressed: "rgba(11, 12, 12, 0.04)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D",
  _themeColorScaleCategorical: ["#36C2B4","#EB64D7","#FF8F00","#8169F8","#FCC201","#FF5A94","#708090"],
  _themeColorScaleComparison: ["#348118","#DE1B1B"],
  _themeColorScaleViolet: ["#DDC8FF","#C9A8FF","#A588FF","#8169F8","#614FD9","#3E36BB"],
  _themeColorScalePurple: ["#E9C6E4","#ECA8E0","#EC88DC","#EB64D7","#C54FB4","#8C297D"],
  _themeColorScalePink: ["#FFDBE5","#FFB5CA","#FF8CAF","#FF5A94","#DC3C71","#BA1750"],
  _themeColorScaleTangerine: ["#FFE5CB","#FFCB96","#FFAE5D","#FF8F00","#D4780C","#A45C0A"],
  _themeColorScaleGold: ["#FFF4D9","#FFE8B1","#FFDB86","#FCC201","#DAA500","#BF8E00"],
  _themeColorScaleTurquoise: ["#C3E9E7","#78D9CF","#36C2B4","#2C9F93","#227D74","#1B5F5B"],
  _themeColorScaleForest: ["#D6ECC9","#ABD994","#7EC55E","#47B120","#348118","#005C00"],
  _themeColorScaleCrimson: ["#FFD9CF","#FFB09F","#F98771","#EE5A46","#DE1B1B","#AF1F18"],
  _themeColorScaleSlate: ["#DADEE2","#B6BDC6","#929EAB","#708090","#596571","#434C54"],
  _themeColorScaleDiverging: ["#2C9F93","#36C2B4","#78D9CF","#C3E9E7","#FFF4D9","#FFE8B1","#FFDB86","#FCC201"],
  _themeColorScaleDivergingWithMiddle: ["#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#FFF4D9","#78D9CF","#36C2B4","#2C9F93","#227D74"]
};

/***/ }),
/* 200 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  themeForegroundPrimaryDefault: "#FFFFFF",
  themeForegroundPrimaryFocus: "#7CCEE9",
  themeForegroundPrimaryError: "#FF7494",
  themeForegroundPrimaryDisabled: "#697576",
  themeForegroundSecondaryDefault: "#BBC0C1",
  themeForegroundSecondaryDisabled: "#485050",
  themeForegroundTertiaryDefault: "#BBC0C1",
  themeForegroundTertiaryHover: "#E7E9E9",
  themeForegroundTertiaryPressed: "#F0F1F2",
  themeForegroundTertiaryDisabled: "#5B5F5F",
  themeForegroundInvertedDefault: "#232F3E",
  themeForegroundAccentDefault: "#47C2EC",
  themeForegroundAccentHover: "#7CCEE9",
  themeForegroundAccentPressed: "#B9E8F7",
  themeForegroundAccentDisabled: "#204B5A",
  themeBorderPrimaryDefault: "#E7E9E9",
  themeBorderPrimaryDisabled: "#485050",
  themeBorderPrimaryFocus: "#077398",
  themeBorderPrimaryError: "#FF7494",
  themeBorderPrimaryWarning: "#FEF2B8",
  themeBorderSecondaryDefault: "#697576",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#485050",
  themeBorderAlternateDefault: "#697576",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#47C2EC",
  themeBorderAccentPressed: "#7CCEE9",
  themeBorderAccentDisabled: "#24586A",
  themeBorderAccentPreselected: "#055D7B",
  themeBorderAlternateAccentDefault: "#00A8E1",
  themeBackgroundPrimaryDefault: "#0B0C0C",
  themeBackgroundPrimaryDisabled: "#252829",
  themeBackgroundSecondaryDefault: "#252829",
  themeBackgroundSecondaryError: "#AD0A30",
  themeBackgroundSecondaryWarning: "#FAD000",
  themeBackgroundTertiaryDefault: "#485050",
  themeBackgroundTertiaryHover: "#697576",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#323838",
  themeBackgroundAlternatePrimaryDefault: "#252829",
  themeBackgroundAlternatePrimarySelected: "#485050",
  themeBackgroundAlternatePrimaryHover: "#697576",
  themeBackgroundAlternatePrimaryPressed: "#949C9C",
  themeBackgroundAlternateSecondaryDefault: "#0B0C0C",
  themeBackgroundAlternateTertiaryDefault: "#485050",
  themeBackgroundAlternateTertiaryFocus: "#252829",
  themeBackgroundAccentDefault: "#055D7B",
  themeBackgroundAccentDisabled: "#14181D",
  themeBackgroundInvertedDefault: "#FFFFFF",
  themeBackgroundOverlayDefault: "rgba(108, 119, 120, 0.5)",
  themeBackgroundOverlayPressed: "rgba(255, 255, 255, 0.16)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D",
  _themeColorScaleCategorical: ["#36C2B4","#EB64D7","#FF8F00","#8169F8","#FCC201","#FF5A94","#708090"],
  _themeColorScaleComparison: ["#47B120","#EE5A46"],
  _themeColorScaleViolet: ["#3E36BB","#614FD9","#8169F8","#A588FF","#C9A8FF","#DDC8FF"],
  _themeColorScalePurple: ["#8C297D","#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#E9C6E4"],
  _themeColorScalePink: ["#BA1750","#DC3C71","#FF5A94","#FF8CAF","#FFB5CA","#FFDBE5"],
  _themeColorScaleTangerine: ["#A45C0A","#D4780C","#FF8F00","#FFAE5D","#FFCB96","#FFE5CB"],
  _themeColorScaleGold: ["#BF8E00","#DAA500","#FCC201","#FFDB86","#FFE8B1","#FFF4D9"],
  _themeColorScaleTurquoise: ["#1B5F5B","#227D74","#2C9F93","#36C2B4","#78D9CF","#C3E9E7"],
  _themeColorScaleForest: ["#005C00","#348118","#47B120","#7EC55E","#ABD994","#D6ECC9"],
  _themeColorScaleCrimson: ["#AF1F18","#DE1B1B","#EE5A46","#F98771","#FFB09F","#FFD9CF"],
  _themeColorScaleSlate: ["#434C54","#596571","#708090","#929EAB","#B6BDC6","#DADEE2"],
  _themeColorScaleDiverging: ["#2C9F93","#36C2B4","#78D9CF","#C3E9E7","#FFF4D9","#FFE8B1","#FFDB86","#FCC201"],
  _themeColorScaleDivergingWithMiddle: ["#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#FFF4D9","#78D9CF","#36C2B4","#2C9F93","#227D74"]
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ColorSchemeContext = void 0;

var _react = __webpack_require__(0);

/**
 * Context for passing the theme's color scheme down the tree.
 */
var ColorSchemeContext = /*#__PURE__*/(0, _react.createContext)("light");
exports.ColorSchemeContext = ColorSchemeContext;

var useColorScheme = function useColorScheme() {
  return (0, _react.useContext)(ColorSchemeContext);
};

var _default = useColorScheme;
exports["default"] = _default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var upperFirst = function upperFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

var _default = upperFirst;
exports["default"] = _default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(204);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var buttonReset = {
  display: "inline-block",
  padding: 0,
  border: 0,
  outline: "none",
  backgroundColor: "transparent",
  textAlign: "inherit",
  color: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  WebkitAppearance: "none",
  WebkitMarginBefore: 0,
  WebkitMarginAfter: 0,
  WebkitMarginStart: 0,
  WebkitMarginEnd: 0,
  "::-moz-focus-inner": {
    border: 0
  }
};
var _default = buttonReset;
exports["default"] = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72),
    isArray = __webpack_require__(40),
    isObjectLike = __webpack_require__(58);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverStyles = exports.focusStyles = exports.disabledStyles = exports.defaultStyles = exports.activeStyles = void 0;

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var getStyles = function getStyles(t, _ref) {
  var type = _ref.type,
      backdrop = _ref.backdrop,
      state = _ref.state;
  return {
    color: t("foregroundColor", [type, backdrop, state]),
    backgroundColor: t("backgroundColor", [type, backdrop, state]),
    borderColor: t("borderColor", [type, state])
  };
};

var activeStyles = function activeStyles(t, _ref2) {
  var type = _ref2.type,
      backdrop = _ref2.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "pressed"
  });
};

exports.activeStyles = activeStyles;

var hoverStyles = function hoverStyles(t, _ref3) {
  var type = _ref3.type,
      backdrop = _ref3.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "hover"
  });
};

exports.hoverStyles = hoverStyles;

var defaultStyles = function defaultStyles(t, _ref4) {
  var type = _ref4.type,
      backdrop = _ref4.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "default"
  });
};

exports.defaultStyles = defaultStyles;

var disabledStyles = function disabledStyles(t, _ref5) {
  var type = _ref5.type,
      backdrop = _ref5.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "disabled"
  });
};

exports.disabledStyles = disabledStyles;

var focusStyles = function focusStyles(t, _ref6) {
  var focus = _ref6.focus,
      borderWidth = _ref6.borderWidth,
      borderRadius = _ref6.borderRadius,
      backdropColor = _ref6.backdropColor,
      linkOrIcon = _ref6.linkOrIcon,
      outlineOffset = _ref6.outlineOffset;
  return (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    gapColor: backdropColor,
    dropShadow: !linkOrIcon,
    offset: outlineOffset !== undefined ? outlineOffset : t("focusOutlineOffset")
  });
};

exports.focusStyles = focusStyles;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    focusRingWidth: 2,
    focusRingColorFocus: tokens.themeBorderPrimaryFocus,
    focusRingColorError: tokens.themeBorderPrimaryError,
    focusRingDropShadowOffsetX: 0,
    focusRingDropShadowOffsetY: 1,
    focusRingDropShadowBlur: 2,
    focusRingDropShadowSpread: 0,
    focusRingDropShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(95),
    stackClear = __webpack_require__(451),
    stackDelete = __webpack_require__(452),
    stackGet = __webpack_require__(453),
    stackHas = __webpack_require__(454),
    stackSet = __webpack_require__(455);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72),
    isObject = __webpack_require__(84);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(472),
    isObjectLike = __webpack_require__(58);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(127),
    arraySome = __webpack_require__(475),
    cacheHas = __webpack_require__(128);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(50),
    stubFalse = __webpack_require__(488);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(217)(module)))

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(489),
    baseUnary = __webpack_require__(219),
    nodeUtil = __webpack_require__(490);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(50);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(84);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(224),
    toKey = __webpack_require__(99);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(40),
    isKey = __webpack_require__(133),
    stringToPath = __webpack_require__(502),
    toString = __webpack_require__(81);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(511);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(123),
    baseIteratee = __webpack_require__(94),
    toInteger = __webpack_require__(135);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focus = _interopRequireDefault(__webpack_require__(518));

var _default = _focus["default"];
exports["default"] = _default;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRow = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tableRow = _interopRequireDefault(__webpack_require__(136));

var _tableCell = _interopRequireDefault(__webpack_require__(229));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This can be used to create a header for a group of Row components. Use it
 * exactly like you would a normal Row. The only difference is that this takes
 * normal content children instead of Cell components.
 */
var TableSectionHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableSectionHeader, _React$Component);

  var _super = _createSuper(TableSectionHeader);

  function TableSectionHeader() {
    (0, _classCallCheck2["default"])(this, TableSectionHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableSectionHeader, [{
    key: "render",
    value: function render() {
      // This component is API sugar only, at render time it's replaced with `Row`
      // and `Cell` components
      return null;
    }
  }]);
  return TableSectionHeader;
}(_react["default"].Component);

TableSectionHeader.propTypes =  false ? {
  /**
   * The contents of the section header.
   *
   * Note that this does *not* support table cells as children, this is a
   * generic content area that spans the width of the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set this to force the cell to span more than one column.
   *
   * NOTE: This helps build an accessible TableSectionHeader. However,
   * any provided columnSpan will be overwritten to 1 when a Table has a
   * [stickyHeaderColumn](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-Table-stickyHeaderColumn).
   *
   * @since 5.24.0
   */
  columnSpan: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func
} : {};

var toRow = function toRow(isRow, element, stickyHeaderColumn) {
  var children = _react["default"].Children.toArray(element.props.children); // The number of columns the header cell spans. Use the defined `columnSpan` if
  // defined else if the table has a sticky header column, fallback to 1, else 100.


  var columnSpan = stickyHeaderColumn ? 1 : element.props.columnSpan || 100;
  return /*#__PURE__*/_react["default"].createElement(_tableRow["default"], (0, _extends2["default"])({}, element.props, {
    id: undefined
  }), /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    header: true,
    highlight: true,
    sectionHeader: true,
    id: element.props.id,
    columnSpan: columnSpan,
    scope: "colgroup"
  }, children.filter(function (child) {
    return !isRow(child);
  })), (!element.props.columnSpan || stickyHeaderColumn) && columnSpan < 100 && /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    highlight: true,
    columnSpan: 100,
    sectionHeader: true,
    headers: element.props.id,
    scope: "colgroup"
  }), children.filter(isRow));
};

exports.toRow = toRow;
var _default = TableSectionHeader;
exports["default"] = _default;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(230));

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _isElementOfAny = _interopRequireDefault(__webpack_require__(100));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _rtl = __webpack_require__(39);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var unthemedCheckboxTokens = (0, _token.getUnthemedTokens)(_checkbox["default"]);
/**
 * Helpers
 */

var getCheckbox = function getCheckbox(checkboxComponents, elements) {
  if (checkboxComponents && typeof elements !== "string") {
    var isCheckbox = (0, _isElementOfAny["default"])(checkboxComponents);

    var child = _react["default"].Children.toArray(elements)[0];

    return isCheckbox(child) ? child : null;
  } else {
    return null;
  }
};

var getCheckboxWidth = (0, _functional.memoize)(function (size) {
  return (0, _token.getToken)(unthemedCheckboxTokens, "checkboxWidth", size);
});

var stretchCheckbox = function stretchCheckbox(checkbox) {
  return /*#__PURE__*/_react["default"].cloneElement(checkbox, {
    fillParent: true
  });
};
/**
 * Styles
 */


var styles = (0, _functional.memoize)(function (checkboxWidth) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        width = _ref.width,
        height = _ref.height,
        backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {
      textAlign: (0, _rtl.getHorizontalDirection)(alignmentHorizontal)
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      textAlign: (0, _rtl.getRtl)(alignmentHorizontal)
    }), (0, _defineProperty2["default"])(_css, "verticalAlign", alignmentVertical === "center" ? "middle" : alignmentVertical), (0, _defineProperty2["default"])(_css, "width", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "minWidth", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "height", height || "inherit"), (0, _defineProperty2["default"])(_css, "boxSizing", width || height ? "border-box" : "content-box"), (0, _defineProperty2["default"])(_css, "&[mdn-cell-background-color-custom]", {
      backgroundColor: "".concat(backgroundColor, " !important")
    }), (0, _defineProperty2["default"])(_css, "&[mdn-hidden-cell]", {
      display: "none"
    }), (0, _defineProperty2["default"])(_css, "& > span", checkboxWidth ? {
      display: "block",
      height: "100%",
      position: "static"
    } : undefined), _css));
  }, ["alignmentHorizontal", "alignmentVertical", "width", "height", "backgroundColor"]);
});
/**
 * Component
 */

/**
 * Used to render a table cell. Can take any children. Place this as a child of
 * the TableRow component.
 *
 * Note that the Table component will automatically set some props on this
 * component (e.g. `header={true}` if the cell is in a header row). This means
 * that if you wrap this component in your own custom table cell component, you
 * should still pass all props through to this component. For example:
 *
 * // Correct
 * const MyCustomCell = ({ myCustomProp, ...extraProps }) =>
 *   <TableCell {...extraProps} />
 *
 * // Incorrect
 * const MyCustomCell = ({ myCustomProp, children }) =>
 *   <TableCell>{children}</TableCell>
 */

var TableCell = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableCell, _React$Component);

  var _super = _createSuper(TableCell);

  function TableCell() {
    (0, _classCallCheck2["default"])(this, TableCell);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined; // If the only child of the cell is a checkbox then stretch the checkbox to
      // fill the cell, making the entire cell clickable

      var checkbox = getCheckbox(props.checkboxComponents, props.children);
      var children = checkbox ? stretchCheckbox(checkbox) : props.children;
      var checkboxWidth = checkbox ? getCheckboxWidth(checkbox.props.size) : undefined;
      var tag = props.header ? "th" : "td";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        className: styles(checkboxWidth)(props),
        colSpan: props.columnSpan,
        rowSpan: props.rowSpan,
        id: props.id,
        headers: props.headers,
        "aria-sort": props.sortDirection,
        "mdn-cell-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-cell-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-cell-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-cell-highlight": props.highlight ? "" : undefined,
        "mdn-cell-selectable": checkbox ? "" : undefined,

        /* eslint-disable-next-line react/prop-types */
        "mdn-section-header": props.sectionHeader ? "" : undefined,
        "mdn-hidden-cell": !props.showCell ? "" : undefined,
        // HACK: Don't include `scope` in prop-types since we already take
        // care of setting scope in `table.js` and don't want users overwriting.
        // We could use context, but that would require potentially hundreds of
        // contexts for a single table so this is more performant.

        /* eslint-disable-next-line react/prop-types */
        scope: props.scope
      }),
      /*#__PURE__*/
      // An extra span is needed for the fancy nested headers style and for
      // the chevron icon placed on the left side of parent rows.
      _react["default"].createElement("span", null, children));
    }
  }]);
  return TableCell;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TableCell, "defaultProps", {
  alignmentHorizontal: "start",
  alignmentVertical: "center",
  defaultSortDirection: "ascending",
  showCell: true
});
TableCell.propTypes =  false ? {
  /**
   * The horizontal alignment of content inside the cell.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end"]),

  /**
   * The vertical alignment of content inside the cell.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. This can be set on the `Table` component itself, in
   * which case it is not necessary to set it here for each individual cell.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The contents of the cell. Any elements are allowed except for nested
   * Meridian tables.
   */
  children: _propTypes["default"].node,

  /**
   * Set this to force the cell to span more than one column.
   */
  columnSpan: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Apply this to a header cell to specify the sort direction that should be
   * applied first when the user turns on sorting for the column.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * Set this to true if the cell is a header cell (either in a headerRow or
   * header column). Note that this is automatically set if the TableCell is
   * placed in a Table component, so in most cases you should not have to
   * touch this.
   */
  header: _propTypes["default"].bool,

  /**
   * A string of Table header id's with which to associate.
   *
   * See [Mozilla's documentation](https://developer.mozilla.org/en-US/docs/Learn/HTML/Tables/Advanced#using_column_and_row_headers)
   * to learn more (Note: the `scope` attribute is taken care of in Meridian.)
   *
   * @since 5.17.0
   */
  headers: _propTypes["default"].string,

  /**
   * The height of the cell. If left blank the browser will dynamically choose
   * a height based on the cell's contents and the other cells in the table.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Highlight this cell.
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.17.0
   */
  id: _propTypes["default"].string,

  /**
   * Set this to force the cell to span more than one row.
   *
   * Use this in conjunction with `showCell={false}` to hide empty cells
   * covered by the spanned rows.
   *
   * @since 5.29.0
   */
  rowSpan: _propTypes["default"].number,

  /**
   * Set this to false to hide the cell completely, including from screen readers.
   *
   * This is useful in combination with the `rowSpan` prop, when you need to
   * hide empty cells that are covered by the spanned rows.
   *
   * @since 5.29.0
   */
  showCell: _propTypes["default"].bool,

  /**
   * Specify a key that the Table component can use to identify the cell when
   * determining which column should be sorted. If this prop is provided the
   * cell will be made clickable and a sort icon will be added to it.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * Apply this to a header cell if the data in the cell's column is sorted.
   *
   * This is automatically set by the Table component, so in most cases you
   * should not have to touch this. See the docs for the corresponding
   * "sortDirection" column on the Table component.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The width of the cell. If left blank the browser will dynamically choose
   * a width based on the cell's contents and the other cells in the table.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = TableCell;
exports["default"] = _default;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    checkboxMotionDuration: "100ms",
    checkboxMotionFunction: "ease",
    checkboxForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    checkboxForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    checkboxBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    checkboxBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    checkboxBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    checkboxBackgroundColorUnselectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorUnselectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    checkboxBorderWidth: 1,
    checkboxBorderRadius: 4,
    checkboxBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    checkboxBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    checkboxBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxIndicatorColorSelectedDefault: tokens.themeForegroundInvertedDefault,
    checkboxIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    checkboxIndicatorColorUnselectedHover: tokens.themeForegroundAccentDefault,
    checkboxIndicatorColorUnselectedPressed: tokens.themeForegroundInvertedDefault,
    checkboxWidthMedium: 20,
    checkboxWidthLarge: 24,
    checkboxHeightMedium: 20,
    checkboxHeightLarge: 24,
    checkboxSpacingHorizontal: 12
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(87));

var _chevronDownSmall = _interopRequireDefault(__webpack_require__(232));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(519));

var _theme = __webpack_require__(7);

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _getIconCss = _interopRequireDefault(__webpack_require__(86));

var _text = _interopRequireDefault(__webpack_require__(22));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var positionStickyElevation = {
  rowHeader: 1,
  columnHeader: 2,
  tableHeaderCell: 3
};
var chevronDownIcon = (0, _token.getIconFromTokens)(_chevronDownSmall["default"]);
var chevronRightIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var spacing = _ref.spacing,
      showDividers = _ref.showDividers,
      showExpandedDividers = _ref.showExpandedDividers,
      showStripes = _ref.showStripes,
      nestedRows = _ref.nestedRows,
      layout = _ref.layout;
  return (0, _functional.memoize)(function (t) {
    var _trFirstChild;

    var borderColor = t("borderColor");
    var borderWidthHeader = t("borderWidthHeader");
    var borderWidthBody = t("borderWidthBody");
    var spacingHorizontal = t("spacingHorizontal");
    var spacingVerticalSmall = t("spacingVerticalSmall");
    var backgroundColorDefault = t("backgroundColorDefault");
    var backgroundColorHover = t("backgroundColorHover");
    var backgroundColorPressed = t("backgroundColorPressed");
    var backgroundColorHighlight = t("backgroundColorHighlight");
    var backgroundColorStripe = t("backgroundColorStripe");
    return (0, _emotion.css)(
    /**
     * Layout
     */
    {
      width: "100%",
      tableLayout: layout,
      "& tr": {
        // HACK: This, in combination with "height: inherit" on table cells, allows
        // cell contents to stretch to fill the cell height if necessary (e.g. a
        // checkbox with `fillParent={true}`). See:
        // https://stackoverflow.com/questions/3215553/make-a-div-fill-an-entire-table-cell
        height: 1
      },
      "& td, & th": {
        position: "relative"
      }
    },
    /**
     * Typography
     */
    (0, _text["default"])(t), {
      "& td": {
        fontWeight: t("fontWeightBody")
      },
      "& th": {
        fontWeight: t("fontWeightHeader")
      },
      // Highlighted header cells should use the normal font weight
      "& th[mdn-cell-highlight]": {
        fontWeight: t("fontWeightBody")
      },
      // Section headers have their own font size
      "& th[mdn-section-header]": (0, _defineProperty2["default"])({
        fontSize: t("fontSizeSectionHeader")
      }, "[dir=\"rtl\"] &", {
        // HACK: need the fix the section header right padding
        // in RTL layouts.
        paddingRight: "".concat(spacingHorizontal, "px !important")
      })
    },
    /**
     * Background colors
     */
    {
      "& td, & th": {
        backgroundColor: backgroundColorDefault,
        "&[mdn-cell-highlight]": {
          backgroundColor: backgroundColorHighlight
        },
        "&[mdn-cell-background-color-primary]": {
          backgroundColor: backgroundColorDefault
        },
        "&[mdn-cell-background-color-secondary]": {
          backgroundColor: backgroundColorHover
        }
      },
      "& tbody > tr[mdn-row-highlight] > *": {
        backgroundColor: backgroundColorHighlight
      },
      "& tbody > tr[mdn-row-background-color-primary] > *": {
        backgroundColor: backgroundColorDefault
      },
      "& tbody > tr[mdn-row-background-color-secondary] > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-hover]:hover > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-press]:active > *": {
        backgroundColor: backgroundColorPressed
      },
      "& tbody > tr:nth-child(even) > *": showStripes ? {
        backgroundColor: backgroundColorStripe
      } : undefined,
      transition: t.transitionCss("motion", "background-color")
    },
    /**
     * Borders
     */
    {
      borderCollapse: "separate",
      borderSpacing: 0,
      // Always add a border between the header and the body (if a header
      // exists)
      "& thead > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Add a thick border after the last row in a set of open child rows
      "& tbody > tr[mdn-row-last-child] + tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthHeader
      },
      "& tbody > tr[mdn-row-last-child]:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Remove the borders between open child rows
      "& tbody > tr[mdn-row-child] > *": {
        borderTopColor: showExpandedDividers ? undefined : "transparent"
      }
    }, showDividers ? {
      // Add top borders to rows
      "& tbody > tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthBody
      },
      // Add a bottom border to the last row
      "& tbody > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthBody
      },
      // Remove the top border from the first row if a header exists (the
      // header will apply a special border to separate the header from the
      // body)
      "& thead + tbody > tr:first-child > *": {
        borderTop: "none"
      }
    } : undefined,
    /**
     * Padding
     */
    {
      "& td, & th": {
        // Add padding for half the horizontal spacing to each cell so that when
        // the cells are lined up in a row the space between the cell contents
        // adds up to the original horizontal spacing.
        padding: "".concat(t("spacingVertical", spacing), "px ").concat(spacingHorizontal / 2, "px"),
        // Show the full horizontal spacing on the left and right hand sides of
        // each row.
        "&:first-child": (0, _defineProperty2["default"])({
          // For tables with nested rows add extra padding for the chevron icon
          paddingLeft: nestedRows ? spacingHorizontal * 2 + chevronRightIcon.width : spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingRight: nestedRows ? "".concat(spacingHorizontal * 2 + chevronRightIcon.width, "px !important") : spacingHorizontal,
          // HACK: the above paddingLeft still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingLeft: spacingHorizontal / 2
        }),
        "&:last-child": (0, _defineProperty2["default"])({
          // HACK: IE11 does not support padding-inline-* so we have
          // to use directional padding-left/right. If/when we drop IE11 we can simplify
          // these styles to be:
          // {
          //   paddingInlineStart: spacingHorizontal,
          // }
          paddingRight: spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingLeft: spacingHorizontal,
          // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingRight: spacingHorizontal / 2
        })
      },
      // Cells in the table header or header cells in the table body that span
      // the entire row (section header cells) use "small" vertical spacing,
      // regardless of the user's spacing setting.
      "& thead > tr > *, & tbody > tr > th:only-child": {
        paddingTop: spacingVerticalSmall,
        paddingBottom: spacingVerticalSmall
      }
    },
    /**
     * Nested header rows
     */
    {
      "& thead > tr:not(:last-child) > *": {
        fontSize: t("fontSizeNestedHeader"),
        paddingBottom: 0,
        // Shrink the span down to fit the cell contents so that it obscures the
        // horizontal stripe behind the contents but not across the entire cell.
        // Add pseudo elements to add a little padding between the contents and
        // the stripe
        "& > span": {
          display: "inline-block",
          position: "relative",
          backgroundColor: "inherit",
          "&:before, &:after": {
            content: "''",
            backgroundColor: "inherit",
            display: "block",
            height: "100%",
            width: spacingHorizontal,
            position: "absolute",
            top: 0
          },
          "&:before": {
            right: "100%"
          },
          "&:after": {
            left: "100%"
          }
        },
        // Add a horizontal stripe along the center of the cell
        "&:before": {
          content: "''",
          display: "block",
          height: t("borderWidthHeader"),
          left: 0,
          right: 0,
          backgroundColor: borderColor,
          position: "absolute",
          top: "calc(50% + ".concat(spacingVerticalSmall / 2, "px)"),
          transform: "translateY(-50%)"
        }
      }
    },
    /**
     * Expandable rows
     */
    {
      // Add a chevron icon as a pseudo-element to the first cell in the row
      "& tbody > tr[mdn-row-parent] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.data, t("foregroundColor")),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center left ".concat(spacingHorizontal, "px")
      }, "[dir=\"rtl\"] &", {
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.dataRtl, t("foregroundColor")),
        backgroundPosition: "center right ".concat(spacingHorizontal, "px")
      }),
      // Point the chevron icon down if the row is open
      "& tbody > tr[mdn-row-parent][mdn-row-open] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronDownIcon.data, t("foregroundColor")),
        // Scoot the down chevron, which is a tad wider than the right
        // chevron, to the left a bit so it is horizontally centered on the
        // same point that the right chevron was.
        backgroundPosition: "center left ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      }, "[dir=\"rtl\"] &", {
        backgroundPosition: "center right ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      })
    },
    /**
     * Clickable rows
     */
    {
      "& tr[tabindex]": {
        cursor: "pointer"
      },
      // TODO: We need an actual focus style for clickable rows. Right now we
      // just fall back to the default outline. See https://sim.amazon.com/issues/MRDN-127
      "& tr[tabindex]:not([mdn-row-focus])": {
        outline: "none"
      }
    },
    /**
     * Selectable cells
     */
    {
      // If we're dealing with a selectable table cell (a cell containing a
      // single checkbox that has been stretched to fill the entire cell) then
      // expand the cell padding (by taking padding from the cell to the right)
      // to maximize the clickable area.
      "& tr > *:first-child[mdn-cell-selectable]": (_trFirstChild = {
        // HACK: IE11 does not support padding-inline-* so we have
        // to use directional padding-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   paddingInlineEnd: spacingHorizontal,
        //   "& + *": {
        //     paddingInlineStart: 0,
        //   },
        // }
        paddingRight: spacingHorizontal
      }, (0, _defineProperty2["default"])(_trFirstChild, "[dir=\"rtl\"] &", {
        paddingLeft: spacingHorizontal
      }), (0, _defineProperty2["default"])(_trFirstChild, "& + *", (0, _defineProperty2["default"])({
        paddingLeft: 0
      }, "[dir=\"rtl\"] &", {
        // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
        // we need to reapply the half horizontal spacing to paddingLeft
        paddingLeft: spacingHorizontal / 2,
        paddingRight: 0
      })), _trFirstChild)
    });
  });
}, ["spacing", "showDividers", "showExpandedDividers", "showStripes", "nestedRows", "layout"]);
var stickyStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var stickyHeaderColumn = _ref2.stickyHeaderColumn,
      stickyHeaderColumnOffset = _ref2.stickyHeaderColumnOffset,
      headerColumnStuck = _ref2.headerColumnStuck,
      stickyHeaderRow = _ref2.stickyHeaderRow,
      stickyHeaderRowOffset = _ref2.stickyHeaderRowOffset,
      headerRowStuck = _ref2.headerRowStuck;
  return (0, _functional.memoize)(function (t) {
    var _stickyHeaderCellStyl, _theadTrLastOfTyp;

    var stickyHeaderCellStyles = (_stickyHeaderCellStyl = {
      position: "sticky",
      left: stickyHeaderColumnOffset,
      zIndex: positionStickyElevation.columnHeader
    }, (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "[dir=\"rtl\"] &", {
      left: "unset",
      right: stickyHeaderColumnOffset
    }), (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "::after", {
      position: "absolute",
      content: "''",
      top: 0,
      right: 0,
      bottom: 0,
      width: 8,
      boxShadow: headerColumnStuck ? t.boxShadowCss("overflowStickyColumnShadow") : undefined
    }), _stickyHeaderCellStyl);
    return (0, _emotion.css)(
    /**
     * Sticky column header
     */
    stickyHeaderColumn ? {
      "tbody th": stickyHeaderCellStyles,
      "[mdn-row-child] > td:first-child": stickyHeaderCellStyles
    } : undefined,
    /**
     * Sticky row header
     */
    stickyHeaderRow ? {
      "thead tr:last-of-type th": {
        position: "sticky",
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.rowHeader,
        "::after": {
          position: "absolute",
          content: "''",
          bottom: 0,
          right: 0,
          left: 0,
          height: 8,
          boxShadow: headerRowStuck ? t.boxShadowCss("overflowStickyRowShadow") : undefined
        }
      }
    } : undefined,
    /**
     * Sticky row and column header (in LTR it's the top-left-most cell)
     */
    stickyHeaderRow && stickyHeaderColumn ? {
      "thead tr:last-of-type th:first-child": (_theadTrLastOfTyp = {
        left: stickyHeaderColumnOffset,
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.tableHeaderCell
      }, (0, _defineProperty2["default"])(_theadTrLastOfTyp, "[dir=\"rtl\"] &", {
        left: "unset",
        right: stickyHeaderColumnOffset
      }), (0, _defineProperty2["default"])(_theadTrLastOfTyp, "filter", headerColumnStuck ? "drop-shadow(".concat(t("overflowStickyColumnShadowOffsetX"), "px ").concat(t("overflowStickyColumnShadowOffsetY"), "px ").concat(t("overflowStickyColumnShadowBlur"), "px ").concat(t("overflowStickyColumnShadowColor"), ")") : undefined), _theadTrLastOfTyp)
    } : undefined);
  });
}, ["stickyHeaderColumn", "stickyHeaderColumnOffset", "headerColumnStuck", "stickyHeaderRow", "stickyHeaderRowOffset", "headerRowStuck"]);
/**
 * This component renders a `<table />` tag along with all the styles necessary to
 * property display rows and cells placed inside the tag. This is used under the
 * hood by the Table component which adds some nice APIs on top of it, so in
 * most cases you should not have to touch this.
 */

var TableContainer = function TableContainer(props) {
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      headerColumnStuck = _useState2[0],
      setHeaderColumnStuck = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      headerRowStuck = _useState4[0],
      setHeaderRowStuck = _useState4[1];

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, passThroughProps, {
    className: (0, _emotion.cx)(props.className, styles(props)(t), stickyStyles(_objectSpread(_objectSpread({}, props), {}, {
      headerColumnStuck: headerColumnStuck,
      headerRowStuck: headerRowStuck
    }))(t)),
    "mdn-table-fixed": props.fixed ? "" : undefined
  }), props.children), props.stickyHeaderColumn || props.stickyHeaderRow ? /*#__PURE__*/_react["default"].createElement(_stickyScrollTracker["default"], {
    trackX: props.stickyHeaderColumn,
    trackY: props.stickyHeaderRow,
    onChangeX: setHeaderColumnStuck,
    onChangeY: setHeaderRowStuck
  }) : null);
};

TableContainer.displayName = "TableContainer";
TableContainer.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set this to true if the table is being used to contain fixed content.
   */
  fixed: _propTypes["default"].bool,

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderColumn" prop if you don't want
   * to stick table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls vertically.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderRow" prop if you don't want
   * to stick table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number
} : {};
var _default = TableContainer;
exports["default"] = _default;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDownSmallData: "data:image/svg+xml,%3csvg width='10' height='6' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1l4 4 4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronDownSmallWidth: 10,
  iconChevronDownSmallHeight: 6
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(522);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeBounds = exports.emptyNodeBounds = exports.compareNodeBounds = void 0;
var emptyNodeBounds = {
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
exports.emptyNodeBounds = emptyNodeBounds;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Check to see if two rectangles, defined by top/left origin and width/height,
 * are equal.
 */

var compareNodeBounds = function compareNodeBounds(a, b) {
  return a === b || a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
/**
 * This returns a rectangle from a DOM node that represents the size and
 * position of the node relative to the viewport. If the node does not exist
 * then an empty rectangle is returned. Note that the width and height do not
 * take any CSS scale transforms into account.
 */


exports.compareNodeBounds = compareNodeBounds;

var getNodeBounds = function getNodeBounds(node) {
  if (!canUseDOM) {
    return emptyNodeBounds;
  } else if (node === window) {
    var width = window.innerWidth;
    var height = window.innerHeight;
    return {
      top: 0,
      left: 0,
      width: width,
      height: height
    };
  } else if (node === document.documentElement) {
    // For the document element, getBoundingClientRect() will return scroll
    // offset instead of actual position for top/left values (in all browsers
    // except edge). This is inconsistent with the function's behavior for other
    // nodes (in all browsers except edge). Resolve this by just assuming the
    // top/left of the document element is 0/0 (true in all cases except for
    // when the "html" tag has been repositioned with CSS, which is rare).
    var _node$getBoundingClie = node.getBoundingClientRect(),
        _width = _node$getBoundingClie.width,
        _height = _node$getBoundingClie.height;

    return {
      top: 0,
      left: 0,
      width: _width,
      height: _height
    };
  } else if (node && node.getBoundingClientRect) {
    // For normal nodes, get the width and height from offsetWidth and
    // offsetHeight instead of getBoundingClientRect. This will ignore any CSS
    // scale transforms that are applied.
    var _width2 = node.offsetWidth;
    var _height2 = node.offsetHeight;

    var _node$getBoundingClie2 = node.getBoundingClientRect(),
        top = _node$getBoundingClie2.top,
        left = _node$getBoundingClie2.left;

    return {
      top: top,
      left: left,
      width: _width2,
      height: _height2
    };
  } else {
    return emptyNodeBounds;
  }
};

exports.getNodeBounds = getNodeBounds;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(94),
    isArrayLike = __webpack_require__(73),
    keys = __webpack_require__(85);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(87));

var _close = _interopRequireDefault(__webpack_require__(83));

var _elevation = __webpack_require__(54);

var _row = _interopRequireDefault(__webpack_require__(17));

var _button = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _theme = _interopRequireWildcard(__webpack_require__(7));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(100));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _functional = __webpack_require__(19);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: _elevation.elevationForeground,
    color: t("foregroundColor"),
    backgroundColor: t("backgroundColor"),
    "& > [mdn-table-action-bar-overlay-label] > [mdn-table-action-bar-overlay-label-hidden]": _visuallyHidden["default"]
  });
};

var getOverrideTokens = (0, _functional.memoize)(function (t) {
  return {
    themeBorderPrimaryFocus: t("foregroundColor"),
    // Overlays in light mode
    buttonForegroundColorLinkDarkBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropPressed: t("foregroundColor"),
    buttonBackgroundColorLinkDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorLinkDarkBackdropPressed: t("backgroundColorPressed"),
    buttonBackgroundColorIconDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorIconDarkBackdropPressed: t("backgroundColorPressed"),
    // Overlays in dark mode
    buttonForegroundColorLinkLightBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropPressed: t("foregroundColor")
  };
});
/**
 * Used to render an overlay containing bulk actions over an action bar. Place
 * this as a child of the TableActionBar component.
 */

var TableActionBarOverlay = function TableActionBarOverlay(props) {
  var buttonComponents = props.buttonComponents;
  var isButton = (0, _react.useMemo)(function () {
    return (0, _isElementOfAny["default"])(buttonComponents);
  }, [buttonComponents]);

  var buttons = _react["default"].Children.toArray(props.children).filter(isButton);

  var t = (0, _theme.useTheme)(_table["default"], "tableActionBarOverlay");
  return /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: getOverrideTokens(t)
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    className: styles(t),
    type: "fill",
    spacingInset: "medium",
    spacing: "small",
    widths: ["fill"]
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "true",
    "mdn-table-action-bar-overlay-label": ""
  }, props.label, /*#__PURE__*/_react["default"].createElement("span", {
    "mdn-table-action-bar-overlay-label-hidden": ""
  }, props.openLabel)), buttons.map(function (button) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      backdropColor: t("backgroundColor")
    });
  }), props.onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: props.onClose,
    backdropColor: t("backgroundColor"),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null));
};

TableActionBarOverlay.propTypes =  false ? {
  /**
   * The contents of the action bar overlay.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The component or components that will render as buttons. Defaults
   * to Meridian's Button.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  buttonComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * An accessible label for the overlay's close button.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * A label that is shown on the left hand side of the overlay. This label
   * should indicate the number of rows selected in the table (e.g. something
   * like "3 shipments selected" or "4 of 10 regions selected").
   */
  label: _propTypes["default"].node,

  /**
   * An accessible label read by screen readers after label when the overlay appears.
   * This label should indicate what new content is available within the overlay
   * (e.g. "new actions available").
   */
  openLabel: _propTypes["default"].string,

  /**
   * This is called when the user attempts to close the overlay.
   */
  onClose: _propTypes["default"].func
} : {};
TableActionBarOverlay.defaultProps = {
  label: null,
  closeLabel: "Close",
  openLabel: "new actions available",
  buttonComponents: [_button["default"]]
};
var _default = TableActionBarOverlay;
exports["default"] = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(238);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(123),
    baseIsNaN = __webpack_require__(542),
    strictIndexOf = __webpack_require__(543);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(215),
    isFlattenable = __webpack_require__(544);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(134),
    overRest = __webpack_require__(545),
    setToString = __webpack_require__(547);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(73),
    isObjectLike = __webpack_require__(58);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(127),
    arrayIncludes = __webpack_require__(237),
    arrayIncludesWith = __webpack_require__(239),
    cacheHas = __webpack_require__(128),
    createSet = __webpack_require__(553),
    setToArray = __webpack_require__(129);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronLeftSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallWidth: 6,
  iconChevronLeftSmallHeight: 10
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _emotion = __webpack_require__(4);

var _token = __webpack_require__(8);

var _noTextWrap = _interopRequireDefault(__webpack_require__(101));

/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */
var getTextStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _ul, _ref2, _ol, _ref3, _css;

  var fontFamily = _ref.fontFamily,
      color = _ref.color,
      type = _ref.type,
      transform = _ref.transform,
      alignment = _ref.alignment,
      tag = _ref.tag,
      truncate = _ref.truncate,
      breakWord = _ref.breakWord,
      listStyle = _ref.listStyle;
  return (0, _emotion.css)( // DEFAULT: These are the default text styles - drop in a <Text /> tag in
  // with no parent and no props and this is what you'll get.
  {
    fontFamily: t("fontFamilyAmazonEmber"),
    fontWeight: t("fontWeightB300"),
    fontSize: t("fontSizeB300"),
    lineHeight: t("lineHeightB300"),
    color: t("colorPrimary")
  }, // INHERIT: These styles enable you to cascade <Text /> components - place a
  // <Text /> component inside another <Text /> component and the descendant
  // component will inherit from the ancestor instead of falling back to the
  // default styles.
  {
    "[mdn-text] &": {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      color: "inherit"
    }
  }, // OVERRIDE: These styles enable you to override any default or inherited
  // styles using the component's props. The :not() selector is added to
  // increase the specificity of the styles so they override everything else
  // without resorting to !important.
  {
    "&:not(#mdn-specificity-hack)": {
      fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
      fontWeight: type ? t("fontWeight", type) : undefined,
      fontSize: type ? t("fontSize", type) : undefined,
      lineHeight: type ? t("lineHeight", type) : undefined,
      color: color ? t("color", color) : undefined
    }
  }, (_css = {
    textTransform: transform,
    textAlign: alignment ? alignment : undefined,
    // Clear the default margin on tags like "p"
    margin: 0,
    // If a single word is too wide for the element then allow the browser
    // to break it up at an arbitrary location. A hyphen will not be
    // added. This won't look great, but is better than the word flowing
    // off the edge of the element and potentially getting
    // clipped/obscured.
    overflowWrap: breakWord ? "break-word" : undefined,
    // HACK: Overflow wrap for IE11
    wordWrap: breakWord ? "break-word" : undefined
  }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", (_ref2 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref2, "listStyleType", "disc"), (0, _defineProperty2["default"])(_ref2, "& ul", (_ul = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ul, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ul, "listStyleType", "circle"), (0, _defineProperty2["default"])(_ul, "& ul", {
    listStyleType: "square"
  }), _ul)), _ref2)), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", (_ref3 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref3, "listStyleType", listStyle ? listStyle : "decimal"), (0, _defineProperty2["default"])(_ref3, "& ol", (_ol = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ol, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ol, "listStyleType", listStyle ? listStyle : "lower-alpha"), (0, _defineProperty2["default"])(_ol, "& ol", {
    listStyleType: listStyle ? listStyle : "lower-roman"
  }), _ol)), _ref3)), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
    paddingTop: t("listSpacingVertical")
  }), _css), truncate ? _noTextWrap["default"] : undefined);
}, ["fontFamily", "color", "type", "transform", "alignment", "tag", "truncate", "breakWord", "listStyle"]);
var _default = getTextStyles;
exports["default"] = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverBody = _interopRequireDefault(__webpack_require__(568));

var _default = _popoverBody["default"];
exports["default"] = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _transitionController = _interopRequireDefault(__webpack_require__(579));

var _default = _transitionController["default"];
exports["default"] = _default;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    inputSpacingVertical: 4,
    inputSpacingInsetVerticalDefault: 0,
    inputSpacingInsetVerticalAuto: 12,
    inputSpacingInsetHorizontal: 12,
    inputHeightSmall: 32,
    inputHeightMedium: 40,
    inputHeightLarge: 48,
    inputHeightXlarge: 60,
    inputLineHeightDefault: "20px",
    inputLineHeightAuto: "24px",
    inputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    inputForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    inputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputBorderWidth: 1,
    inputBorderRadius: 4,
    inputBorderColorDefault: tokens.themeBorderPrimaryDefault,
    inputBorderColorDisabled: tokens.themeBorderPrimaryDisabled,
    inputFocusRingBorderWidth: 1,
    inputFocusRingBorderRadius: 4,
    inputBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    inputBackgroundColorDisabled: tokens.themeBackgroundPrimaryDisabled,
    inputFontSizeDefault: 16,
    inputFontSizeSmall: 14,
    inputEndcapBorderWidth: 1,
    inputEndcapBorderRadius: 4,
    inputEndcapBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    inputLabelFontSizeDefault: 16,
    inputLabelFontSizeFloated: 14,
    inputLabelColorDefault: tokens.themeForegroundPrimaryDefault,
    inputLabelColorFocus: tokens.themeForegroundPrimaryFocus,
    inputLabelColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputLabelFloatDistanceXlarge: 12,
    inputLabelFloatDistanceAuto: 4,
    inputLabelMotionDuration: "150ms",
    inputLabelMotionFunction: "ease",
    inputSupportTextFontSize: 14,
    inputSupportTextColor: tokens.themeForegroundSecondaryDefault,
    inputSupportTextInset: 2
  }
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inputBox = _interopRequireDefault(__webpack_require__(581));

var _default = _inputBox["default"];
exports["default"] = _default;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(583));

var _default = _supportTextWrapper["default"];
exports["default"] = _default;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var inputReset = function inputReset(_ref) {
  var textColor = _ref.textColor,
      placeholderColor = _ref.placeholderColor,
      empty = _ref.empty;
  return {
    display: "block",
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    width: "100%",
    color: textColor,
    WebkitTextFillColor: empty ? placeholderColor : textColor,
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    outline: "none",
    // Base built-in style resets
    WebkitAppearance: "none",
    MozAppearance: "textfield",
    // Remove the clear button from search inputs
    "::-ms-clear": {
      display: "none"
    },
    "::-ms-reveal": {
      display: "none"
    },
    "::-webkit-search-decoration": {
      display: "none"
    },
    "::-webkit-search-cancel-button": {
      display: "none"
    },
    "::-webkit-search-results-button": {
      display: "none"
    },
    "::-webkit-search-results-decoration ": {
      display: "none"
    },
    // Remove the built-in error outline
    ":invalid": {
      boxShadow: "none"
    },
    ":-moz-submit-invalid": {
      boxShadow: "none"
    },
    ":-moz-ui-invalid": {
      boxShadow: "none"
    },
    // Remove the numeric input up/down buttons in webkit
    "::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    "::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    // Set the placeholder colors
    "::-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-webkit-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::placeholder": {
      opacity: "1",
      color: placeholderColor
    }
  };
};

var _default = inputReset;
exports["default"] = _default;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value of IDs for the support text used by
 * form field components with a SupportTextWrapper. To be used
 * in an aria-describedby prop to ensure that helper text,
 * constraint text, and error messages are read in the correct
 * order by screen readers.
 *
 * eg: `myinput-constraint-text myinput-helper-text myinput-error-message`
 *
 * @returns {string}
 */
var getSupportTextAriaDescribedby = function getSupportTextAriaDescribedby(_ref) {
  var id = _ref.id,
      hasHelperText = _ref.hasHelperText,
      hasConstraintText = _ref.hasConstraintText,
      hasErrorMessage = _ref.hasErrorMessage,
      errorMessageFirst = _ref.errorMessageFirst;
  var helperText = hasHelperText ? "".concat(id, "-helper-text") : null;
  var constraintText = hasConstraintText ? "".concat(id, "-constraint-text") : null;
  var errorMessage = hasErrorMessage ? "".concat(id, "-error-message") : null;
  return errorMessageFirst ? [errorMessage, helperText, constraintText].filter(Boolean).join(" ") : [helperText, errorMessage, constraintText].filter(Boolean).join(" ");
};

var _default = getSupportTextAriaDescribedby;
exports["default"] = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(595)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(602);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TableScrollWrapper=function TableScrollWrapper(_ref){var children=_ref.children;var scrollContainerRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var scrollContainer=scrollContainerRef.current;if(!scrollContainer)return;var handleTableInputFocus=function handleTableInputFocus(e){var parentCell=e.target.closest('td, th');if(!parentCell||parentCell.cellIndex===0)return;// CSS scroll-margin handles the offset automatically
parentCell.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});};scrollContainer.addEventListener('focusin',handleTableInputFocus,true);return function(){return scrollContainer.removeEventListener('focusin',handleTableInputFocus,true);};},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:scrollContainerRef,className:'table-scroll-wrapper',style:{overflowX:"auto",width:"100%"}},children);};/* harmony default export */ __webpack_exports__["a"] = (TableScrollWrapper);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function get() {
    return _menuItem["default"];
  }
});
exports["default"] = void 0;

var _menu = _interopRequireDefault(__webpack_require__(624));

var _menuItem = _interopRequireDefault(__webpack_require__(632));

var _default = _menu["default"];
exports["default"] = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _close = _interopRequireDefault(__webpack_require__(83));

var _button2 = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _functional = __webpack_require__(19);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var styles = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    fontWeight: t("headerFontWeight"),
    marginBottom: t("spacingInsetVerticalMedium"),
    "& > button": (0, _defineProperty2["default"])({
      marginTop: 4 - t("spacingInsetVerticalMedium"),
      marginRight: 4 - t("spacingInsetHorizontalMedium"),
      marginLeft: t("headerSpacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginLeft: 4 - t("spacingInsetHorizontalMedium"),
      marginRight: t("headerSpacingHorizontal")
    })
  });
});
/**
 * This component can be used to render a title and close button for a popover.
 * Place this as a child of the Popover component.
 */

var PopoverHeader = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    ref: ref,
    className: styles(props.t
    /* eslint-disable-line react/prop-types */
    )
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id
    /* eslint-disable-line react/prop-types */

  }, props.children), /*#__PURE__*/_react["default"].createElement(_button2["default"], {
    type: "icon",
    size: "small",
    onClick: props.onClose
    /* eslint-disable-line react/prop-types */

  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }, props.closeLabel)));
});

PopoverHeader.displayName = "PopoverHeader";
PopoverHeader.propTypes =  false ? {
  /**
   * The contents of the header. Plain text recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * An accessible label for the close button.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string
} : {};
PopoverHeader.defaultProps = {
  closeLabel: "Close"
};
var _default = PopoverHeader;
exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

/**
 * This component groups option list items.
 *
 * @since 5.13.0
 */
var OptionListGroup = function OptionListGroup(props) {
  var label = props.label,
      children = props.children,
      disabled = props.disabled;
  var labelId = (0, _uniqueId["default"])("option-list-group-title-");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  var ariaLabel = passThroughProps["aria-label"];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "group",
    "aria-labelledby": labelId
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("span", {
    id: labelId,
    role: "presentation",
    disabled: disabled,
    "aria-label": ariaLabel
  }, label), children);
};

OptionListGroup.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes. Nested groups not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The label of the group.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = OptionListGroup;
exports["default"] = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(81);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOptionValueSelected = exports.isOption = exports.isGroup = exports.getOptionsFromChildren = exports.getNonOptionsFromChildren = exports.createOptionItemsAndGroups = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _selectOption = _interopRequireDefault(__webpack_require__(262));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(263));

var _optionList = __webpack_require__(149);

var _highlightSubstring = _interopRequireDefault(__webpack_require__(264));

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;
var isGroup = (0, _isElementOf["default"])(_selectOptionGroup["default"]);
exports.isGroup = isGroup;

var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
  return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};

exports.isOptionValueSelected = isOptionValueSelected;

var getOptionFromSelectOption = function getOptionFromSelectOption(_ref) {
  var selectOption = _ref.selectOption,
      index = _ref.index,
      groupDisabled = _ref.groupDisabled;
  return _objectSpread({
    index: index,
    label: selectOption.props.label.toString(),
    value: selectOption.props.value,
    children: selectOption.props.children,
    disabled: groupDisabled || selectOption.props.disabled
  }, (0, _filterPropsByPrefix["default"])(selectOption.props, ["data-"]));
};

var getOptionsFromChildren = function getOptionsFromChildren(children) {
  // The final list of options
  var options = []; // Rest option counter to 0

  var optionCounter = 0;

  _react["default"].Children.toArray(children).forEach(function (child) {
    // If we're parsing an option, push onto options
    if (isOption(child)) {
      var index = optionCounter;
      options.push(getOptionFromSelectOption({
        selectOption: child,
        index: index
      })); // Update option counter

      optionCounter += 1;
    } // If we're parsing a group, iterate over its children and add to options
    else if (isGroup(child)) {
      var groupDisabled = child.props.disabled;

      _react["default"].Children.toArray(child.props.children).forEach(function (child) {
        var index = optionCounter;

        if (isOption(child)) {
          options.push(getOptionFromSelectOption({
            selectOption: child,
            index: index,
            groupDisabled: groupDisabled
          })); // Update option counter

          optionCounter += 1;
        }
      });
    }
  });

  return options;
};

exports.getOptionsFromChildren = getOptionsFromChildren;

var createOptionItemFromSelectOption = function createOptionItemFromSelectOption(option, _ref2) {
  var selectValue = _ref2.selectValue,
      onClickOption = _ref2.onClickOption,
      searchQuery = _ref2.searchQuery,
      groupDisabled = _ref2.groupDisabled;
  var _option$props = option.props,
      label = _option$props.label,
      value = _option$props.value,
      disabled = _option$props.disabled;
  var key = option.key;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(option.props, ["data-", "aria-"]);
  var children = searchQuery && option.props.children === undefined ? function () {
    return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
      match: searchQuery
    }, label);
  } : option.props.children;
  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, _objectSpread({
    key: key !== null && key !== void 0 ? key : value,
    selected: isOptionValueSelected(selectValue, value),
    onClick: function onClick() {
      return onClickOption(value);
    },
    label: label.toString(),
    disabled: disabled || groupDisabled
  }, passThroughProps), children);
};

var createOptionGroupFromSelectOptionGroup = function createOptionGroupFromSelectOptionGroup(group, _ref3) {
  var selectValue = _ref3.selectValue,
      onClickOption = _ref3.onClickOption,
      searchQuery = _ref3.searchQuery;
  var _group$props = group.props,
      label = _group$props.label,
      disabled = _group$props.disabled;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(group.props, ["aria-", "data-"]);

  var children = _react["default"].Children.toArray(group.props.children).map(function (child) {
    if (isOption(child)) {
      return createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery,
        groupDisabled: disabled
      });
    }
  });

  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListGroup, _objectSpread({
    key: label,
    label: label.toString(),
    disabled: disabled
  }, passThroughProps), children);
};

var createOptionItemsAndGroups = function createOptionItemsAndGroups(_ref4) {
  var children = _ref4.children,
      selectValue = _ref4.value,
      onClickOption = _ref4.onClickOption,
      searchQuery = _ref4.searchQuery;
  var optionsAndGroups = [];

  _react["default"].Children.toArray(children).forEach(function (child) {
    if (isOption(child)) {
      optionsAndGroups.push(createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    } else if (isGroup(child)) {
      optionsAndGroups.push(createOptionGroupFromSelectOptionGroup(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    }
  });

  return optionsAndGroups;
};

exports.createOptionItemsAndGroups = createOptionItemsAndGroups;

var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
  return _react["default"].Children.toArray(children).filter(function (child) {
    return child && !isOption(child) && !isGroup(child);
  });
};

exports.getNonOptionsFromChildren = getNonOptionsFromChildren;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 */
var SelectOption = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOption, _React$Component);

  var _super = _createSuper(SelectOption);

  function SelectOption() {
    (0, _classCallCheck2["default"])(this, SelectOption);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOption, [{
    key: "render",
    value: function render() {
      // The top-level OptionListItem component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOption;
}(_react["default"].Component);

SelectOption.propTypes =  false ? {
  /**
   * The option's label.
   *
   * This is shown in the `Select` component's field when the option is
   * selected, and as the text for the option if no `children` prop is provided.
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * The value of the option. This will be passed to the `Select` component's
   * `onChange` handler when this option is selected.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Use this to render custom (non-plain-text) children in the option.
   *
   * This should be a function that returns the elements to render. It will
   * receive as its only argument an object containing the following keys:
   *   - `preselected` - a boolean that will be true if the user has
   *     focused on the option with their mouse or keyboard
   *   - `selected` - a boolean that will be true if the user has selected the
   *     option.
   * This data can be used to tailor the display of the custom option children
   * based on the state of the option.
   */
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOption;
exports["default"] = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 *
 * @since 5.13.0
 */
var SelectOptionGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionGroup, _React$Component);

  var _super = _createSuper(SelectOptionGroup);

  function SelectOptionGroup() {
    (0, _classCallCheck2["default"])(this, SelectOptionGroup);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOptionGroup, [{
    key: "render",
    value: function render() {
      // The top-level OptionListGroup component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOptionGroup;
}(_react["default"].Component);

SelectOptionGroup.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements. Nested groups are not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The group's label.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOptionGroup;
exports["default"] = _default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _highlightSubstring = _interopRequireDefault(__webpack_require__(641));

var _default = _highlightSubstring["default"];
exports["default"] = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    modalMobileCloseButtonSpacingTop: 4,
    modalMobileCloseButtonSpacingRight: 2,
    modalMotionDuration: "300ms",
    modalMotionFunction: "ease",
    modalBorderWidth: 1,
    modalBorderRadius: 4,
    modalHeaderForegroundColor: "#FFFFFF",
    modalHeaderBackgroundColor: "#252829",
    modalHeaderFontWeight: 600,
    modalHeaderMinHeight: 48,
    modalHeaderSpacingInsetTop: 8,
    modalHeaderSpacingInsetRight: 40,
    modalHeaderSpacingInsetBottom: 8,
    modalHeaderSpacingInsetLeft: 16,
    modalCloseButtonSpacingTop: 8,
    modalCloseButtonSpacingRight: 8,
    modalBodyBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    modalFooterSpacingInset: 16,
    modalFooterBorderWidth: 1,
    modalFooterBorderRadius: 0,
    modalFooterBorderColor: tokens.themeBorderTertiaryDefault,
    modalDropShadowOffsetX: 0,
    modalDropShadowOffsetY: 2,
    modalDropShadowBlur: 4,
    modalDropShadowSpread: 0,
    modalDropShadowColor: "rgba(11, 12, 12, 0.16)",
    modalFloatingBreakpoint: 721
  }
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scrim = _interopRequireDefault(__webpack_require__(650));

var _default = _scrim["default"];
exports["default"] = _default;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnimateFade", {
  enumerable: true,
  get: function get() {
    return _animateFade["default"];
  }
});
Object.defineProperty(exports, "AnimateFadeScale", {
  enumerable: true,
  get: function get() {
    return _animateFadeScale["default"];
  }
});
Object.defineProperty(exports, "AnimateSlideIn", {
  enumerable: true,
  get: function get() {
    return _animateSlideIn["default"];
  }
});
exports["default"] = void 0;

var _withAnimateMount = _interopRequireDefault(__webpack_require__(651));

var _animateFade = _interopRequireDefault(__webpack_require__(652));

var _animateSlideIn = _interopRequireDefault(__webpack_require__(653));

var _animateFadeScale = _interopRequireDefault(__webpack_require__(654));

var _default = _withAnimateMount["default"];
exports["default"] = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */
var onDirectClick = function onDirectClick(callback) {
  // Listeners to add when the user mouses down on our element.
  var addListeners = function addListeners(node) {
    node.addEventListener("click", onClick);
    node.addEventListener("mouseout", onMouseOut);
  }; // Listeners to remove when the user finishes their click or mouses out of
  // the element.


  var removeListeners = function removeListeners(node) {
    node.removeEventListener("click", onClick);
    node.removeEventListener("mouseout", onMouseOut);
  }; // This is the final "direct" click handler.


  var onClick = function onClick(event) {
    removeListeners(event.target);
    callback(event);
  }; // If the user mouses out clear our listeners (and stop listening for a click
  // event, as it would no longer be directly on the element).


  var onMouseOut = function onMouseOut(event) {
    return removeListeners(event.target);
  }; // If the user mouses down directly on the element that this event is bound
  // to then start listening for a click event to finish things off.


  var onMouseDown = function onMouseDown(event) {
    if (event.target === event.currentTarget) {
      addListeners(event.target);
    }
  };

  return callback ? onMouseDown : undefined;
};

var _default = onDirectClick;
exports["default"] = _default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focusTrap = _interopRequireDefault(__webpack_require__(655));

var _default = _focusTrap["default"];
exports["default"] = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(238),
    isArrayLike = __webpack_require__(73),
    isString = __webpack_require__(207),
    toInteger = __webpack_require__(135),
    values = __webpack_require__(656);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isSafari = exports.isSafari = function isSafari() {
  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
};

var isJsons = exports.isJsons = function isJsons(array) {
  return Array.isArray(array) && array.every(function (row) {
    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
  });
};

var isArrays = exports.isArrays = function isArrays(array) {
  return Array.isArray(array) && array.every(function (row) {
    return Array.isArray(row);
  });
};

var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
  return Array.from(array.map(function (json) {
    return Object.keys(json);
  }).reduce(function (a, b) {
    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
  }, []));
};

var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
  headers = headers || jsonsHeaders(jsons);

  var headerLabels = headers;
  var headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map(function (header) {
      return header.label;
    });
    headerKeys = headers.map(function (header) {
      return header.key;
    });
  }

  var data = jsons.map(function (object) {
    return headerKeys.map(function (header) {
      return getHeaderValue(header, object);
    });
  });
  return [headerLabels].concat(_toConsumableArray(data));
};

var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
    if (o[p] === undefined) {
      arr.splice(1);
    } else {
      return o[p];
    }
  }, obj);

  return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};

var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
  return element || element === 0 ? element : '';
};

var joiner = exports.joiner = function joiner(data) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';

  return data.filter(function (e) {
    return e;
  }).map(function (row) {
    return row.map(function (element) {
      return elementOrEmpty(element);
    }).map(function (column) {
      return "" + enclosingCharacter + column + enclosingCharacter;
    }).join(separator);
  }).join("\n");
};

var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
};

var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
};

var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
  return headers ? headers.join(separator) + "\n" + data : data;
};

var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
  if (typeof data === 'string') return string2csv(data, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};

var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
  var csv = toCSV(data, headers, separator, enclosingCharacter);
  var type = isSafari() ? 'application/csv' : 'text/csv';
  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;

  var URL = window.URL || window.webkitURL;

  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
  headers: _propTypes.array,
  target: _propTypes.string,
  separator: _propTypes.string,
  filename: _propTypes.string,
  uFEFF: _propTypes.bool,
  onClick: _propTypes.func,
  asyncOnClick: _propTypes.bool
};

var defaultProps = exports.defaultProps = {
  separator: ',',
  filename: 'generatedBy_react-csv.csv',
  uFEFF: true,
  asyncOnClick: false
};

var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ButtonOption", {
  enumerable: true,
  get: function get() {
    return _buttonOption["default"];
  }
});
exports["default"] = void 0;

var _buttonGroup = _interopRequireDefault(__webpack_require__(668));

var _buttonOption = _interopRequireDefault(__webpack_require__(669));

var _default = _buttonGroup["default"];
exports["default"] = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fieldsetReset = {
  border: 0,
  padding: 0,
  margin: 0,
  "& legend": {
    padding: 0
  }
};
var _default = fieldsetReset;
exports["default"] = _default;

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var StageStatusViewV2=function StageStatusViewV2(data){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;var headerFont=isMobile?"b100":"h100";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip___default.a,{position:"right",title:data.stageStatus.tooltip?data.stageStatus.tooltip:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{type:headerFont},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:data.stageStatus.title,defaultMessage:data.stageStatus.message})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{type:"d50"},data.stageStatus.value));};/* harmony default export */ __webpack_exports__["a"] = (StageStatusViewV2);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var ActionableMetricView=function ActionableMetricView(data){var onMetricCountClick=function onMetricCountClick(){if(data.onMetricCountClick){data.onMetricCountClick();}};var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_5__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;var headerFont=isMobile?"b100":"h100";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{type:headerFont},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:data.stageStatus.title,defaultMessage:data.stageStatus.message}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{type:"d50"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default.a,{type:"secondary",onClick:onMetricCountClick},data.stageStatus.value)));};/* harmony default export */ __webpack_exports__["a"] = (ActionableMetricView);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ScrollableElementWrapper=function ScrollableElementWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{overflowX:"auto",width:"100%"}},children);};/* harmony default export */ __webpack_exports__["a"] = (ScrollableElementWrapper);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BreadcrumbGroup", {
  enumerable: true,
  get: function get() {
    return _breadcrumbGroup["default"];
  }
});
exports["default"] = void 0;

var _breadcrumbGroup = _interopRequireDefault(__webpack_require__(676));

var _breadcrumb = _interopRequireDefault(__webpack_require__(679));

var _default = _breadcrumb["default"];
exports["default"] = _default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_MobileDisplay__ = __webpack_require__(155);
/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @param tab
 * @param tabAlt
 * @return JSX.Element
 */var PageHeader=function PageHeader(_ref){var head=_ref.head,headAlt=_ref.headAlt,desc=_ref.desc,descAlt=_ref.descAlt,tab=_ref.tab,tabAlt=_ref.tabAlt;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_6__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand2,spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"h100",spacingTop:"medium",color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:tab,defaultMessage:tabAlt}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_heading___default.a,{level:2,type:"h400",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:head,defaultMessage:headAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:desc,defaultMessage:descAlt}))));};PageHeader.propTypes={head:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,headAlt:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,desc:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,descAlt:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,tab:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,tabAlt:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterExpander; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var FilterExpander=function FilterExpander(_ref){var children=_ref.children;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),open=_useState2[0],setOpen=_useState2[1];var onClick=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){setOpen(!open);},[open]);var FilterButton=function FilterButton(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{onClick:onClick,type:"link",size:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_tokens_base_icon_filter___default.a})," Filters");};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterButton,null),open?children:null);};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * React component for getting the last refresh time in a page
 * @param deps
 * @param locale
 * @return JSX.Element
 */var RefreshTimer=function RefreshTimer(_ref){var deps=_ref.deps,intl=_ref.intl,lastUpdated=_ref.lastUpdated;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),latestRefreshTime=_useState2[0],setRefreshTime=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(lastUpdated===null)setRefreshTime("");else if(lastUpdated!==undefined)setRefreshTime(Object(__WEBPACK_IMPORTED_MODULE_4__Util__["m" /* getFormattedTime */])(new Date(lastUpdated),intl.locale));else setRefreshTime(Object(__WEBPACK_IMPORTED_MODULE_4__Util__["m" /* getFormattedTime */])(new Date(),intl.locale));},deps);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{type:"b200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"common.data_last_updated",defaultMessage:"Data last updated"}),": ",latestRefreshTime);};RefreshTimer.propTypes={deps:__WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].array,locale:__WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(RefreshTimer));

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModalFooter", {
  enumerable: true,
  get: function get() {
    return _modalFooter["default"];
  }
});
exports["default"] = void 0;

var _modal = _interopRequireDefault(__webpack_require__(685));

var _modalFooter = _interopRequireDefault(__webpack_require__(286));

var _default = _modal["default"];
exports["default"] = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

/**
 * This component is used to render a footer in your Modal. It is meant to
 * be used with Modals of type "scrollableRegion," and without it modals of
 * those type will not render correctly.
 */
var ModalFooter = function ModalFooter(props) {
  var children = props.children;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("footer", passThroughProps, children);
};

ModalFooter.propTypes =  false ? {
  /**
   * The contents of the footer. Can be any components, but we suggest you
   * include action buttons here (e.g. "Close" and "Cancel") so that they are
   * easily reachable by your customers
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string
} : {};
var _default = ModalFooter;
exports["default"] = _default;

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociatePerformanceContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_AssociatePerformanceReducer__ = __webpack_require__(689);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AssociatePerformanceContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AssociatePerformanceContextProvider=function AssociatePerformanceContextProvider(props){var state={sortPref:{column:"alias",direction:"ascending"},associatePerformance:[]};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_AssociatePerformanceReducer__["a" /* AssociatePerformanceReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AssociatePerformanceContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AssociatePerformanceContextProvider);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289);
module.exports = __webpack_require__(295);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(290).enable();
  window.Promise = __webpack_require__(292);
}

// fetch() polyfill for making API calls.
__webpack_require__(293);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(294);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(158);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(158);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetRouter", function() { return GetRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serviceWorker__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tokens_base_font_amazon_ember_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tokens_base_font_amazon_ember_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tokens_base_font_amazon_ember_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_stageStatus_Stage__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_stageassociate_Associates__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cartDrillDown_CartDetailComponent__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_depart_Depart__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_en__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_ja__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_it__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_fr__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_es__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_de__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_ar__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_ar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_ar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_tr__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_tr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_tr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handler_LocaleHandler__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_handler_ErrorBoundary__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_util_Logger__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_theme_blue_dark__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_theme_blue_dark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_theme_blue_dark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_theme_blue_light__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_theme_blue_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_theme_blue_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_theme__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_util_Constants__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_en___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_ja___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_it___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_16_react_intl_locale_data_de___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_fr___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_15_react_intl_locale_data_es___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_17_react_intl_locale_data_ar___default.a);Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_18_react_intl_locale_data_tr___default.a);Object(__WEBPACK_IMPORTED_MODULE_19__handler_LocaleHandler__["b" /* getLocale */])().then(function(locale){document.getElementsByTagName('html')[0].setAttribute("dir",Object(__WEBPACK_IMPORTED_MODULE_19__handler_LocaleHandler__["a" /* getDirection */])(locale));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GetRouter,{locale:locale}),document.getElementById('root'));});__WEBPACK_IMPORTED_MODULE_21__components_util_Logger__["a" /* Logger */].initialise();var GetRouter=function GetRouter(_ref){var locale=_ref.locale;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_27__components_util_Constants__["f" /* DARK_MODE */].LIGHT),_useState2=_slicedToArray(_useState,2),currentDarkMode=_useState2[0],setCurrentDarkMode=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_26__components_handler_ParentDataHandler__["h" /* setDarkModeStateListener */])(setCurrentDarkMode);Object(__WEBPACK_IMPORTED_MODULE_26__components_handler_ParentDataHandler__["b" /* getDarkModeStatus */])();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_theme___default.a,{tokens:currentDarkMode===__WEBPACK_IMPORTED_MODULE_27__components_util_Constants__["f" /* DARK_MODE */].DARK?__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_theme_blue_dark___default.a:__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_theme_blue_light___default.a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_handler_ErrorBoundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["b" /* IntlProvider */],{locale:locale,messages:Object(__WEBPACK_IMPORTED_MODULE_19__handler_LocaleHandler__["c" /* getMessages */])(locale)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_context_DeviceLayoutContext__["a" /* DeviceLayoutProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/stage/:context',component:__WEBPACK_IMPORTED_MODULE_6__components_stageStatus_Stage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/stage',component:__WEBPACK_IMPORTED_MODULE_6__components_stageStatus_Stage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/stageassociates',component:__WEBPACK_IMPORTED_MODULE_7__components_stageassociate_Associates__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/cartDetail/:routeId/:cartId/:status/:location/:associate/:stationCode',component:__WEBPACK_IMPORTED_MODULE_8__components_cartDrillDown_CartDetailComponent__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/depart/:context',component:__WEBPACK_IMPORTED_MODULE_9__components_depart_Depart__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{path:'/depart',component:__WEBPACK_IMPORTED_MODULE_9__components_depart_Depart__["a" /* default */]})))))));};// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
__WEBPACK_IMPORTED_MODULE_4__serviceWorker__["a" /* unregister */]();

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(297),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(299),r=__webpack_require__(300);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(301);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashRouter; });
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(160);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(111);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    try {
      if (this.props.onClick) this.props.onClick(event);
    } catch (ex) {
      event.preventDefault();
      throw ex;
    }

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var pathToMatch = locationProp ? locationProp.pathname : context.location.pathname;
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* matchPath */])(pathToMatch, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, context.location) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: to
    }, rest));
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}




/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(90);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 305 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(307);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(312)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(162);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export register */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(config){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location.href);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebook/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Let's check if a service worker still exists or not.
checkValidServiceWorker(swUrl,config);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://bit.ly/CRA-PWA');});}else{// Is not localhost. Just register service worker
registerValidSW(swUrl,config);}});}}function registerValidSW(swUrl,config){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;if(installingWorker==null){return;}installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the updated precached content has been fetched,
// but the previous service worker will still serve the older
// content until all client tabs are closed.
console.log('New content is available and will be used when all '+'tabs for this page are closed. See https://bit.ly/CRA-PWA.');// Execute callback
if(config&&config.onUpdate){config.onUpdate(registration);}}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');// Execute callback
if(config&&config.onSuccess){config.onSuccess(registration);}}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl,config){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
var contentType=response.headers.get('content-type');if(response.status===404||contentType!=null&&contentType.indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl,config);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StageView__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__associate_context_AssociateContextProvider__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fileupload_context_DWPUploadContext__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stage=function(_Component){_inherits(Stage,_Component);function Stage(){_classCallCheck(this,Stage);return _possibleConstructorReturn(this,(Stage.__proto__||Object.getPrototypeOf(Stage)).apply(this,arguments));}_createClass(Stage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__global_context_CapabilityContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__context_StageFilterContext__["b" /* default */],{context:this.props.match.params.context},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context_RouteStageContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fileupload_context_DWPUploadContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__associate_context_AssociateContextProvider__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StageView__["a" /* default */],{history:this.props.history}))))));}}]);return Stage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Stage);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteStageReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_CacheManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__ = __webpack_require__(37);
var RouteStageReducer=function RouteStageReducer(state,action){switch(action.type){case"LOAD_VIEW":{var _action$data=action.data,dispatcher=_action$data.dispatcher,filterDispatcher=_action$data.filterDispatcher,capability=_action$data.capability,xptNodes=_action$data.xptNodes,stationConfig=_action$data.stationConfig;if(__WEBPACK_IMPORTED_MODULE_3__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(capability)){//try to load data from cache if xpt filters and ttl is valid.
if(Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["c" /* isRouteCacheValid */])(xptNodes)){var _getDataWithExpiry=Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["a" /* getDataWithExpiry */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]),cachedData=_getDataWithExpiry.cachedData,lastUpdated=_getDataWithExpiry.lastUpdated;Object(__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["A" /* logCounterMetric */])(Object(__WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["h" /* ROUTE_CACHE_HIT_METRIC */]);dispatcher({type:"RECEIVE_DATA",data:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["g" /* getRouteData */])(cachedData.response.routes,capability,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["f" /* getFilterData */])(cachedData.response.routes)});return state;}else{Object(__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["A" /* logCounterMetric */])(Object(__WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_5__util_MetricUtil__["i" /* ROUTE_CACHE_MISS_METRIC */]);}}Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["c" /* fetchRouteInformation */])(action.data);return state;}case"LOAD_STAGE_PLAN_TASKS":{var _action$data2=action.data,baseUrl=_action$data2.baseUrl,_stationConfig=_action$data2.stationConfig,_dispatcher=_action$data2.dispatcher;Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["h" /* getStageTaskPlanList */])(baseUrl,_stationConfig,_dispatcher);return state;}case"UPDATE_STAGE_TASK_PLAN_STATUS":{var _action$data3=action.data,_baseUrl=_action$data3.baseUrl,_stationConfig2=_action$data3.stationConfig,_dispatcher2=_action$data3.dispatcher,planId=_action$data3.planId,status=_action$data3.status,forceUpdate=_action$data3.forceUpdate,cycleName=_action$data3.cycleName;Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["k" /* updateStageTaskPlanStatus */])(_baseUrl,_stationConfig2,_dispatcher2,planId,status,forceUpdate,cycleName);return state;}case"SHOW_ROUTE_ADJUSTMENT_PENDING":{return Object.assign({},state,{showPendingConfirmation:true,pendingConfirmationData:action.data});}case"CLEAR_PENDING_CONFIRMATION":{return Object.assign({},state,{showPendingConfirmation:false,pendingConfirmationData:null});}case"UNLOAD_VIEW":return state;case"RECEIVE_DATA":return Object.assign({},state,action.data);case"UPDATE_ROUTE_DATA_CACHE":{Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["d" /* setDataWithExpiry */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */],action.data);return state;}case"SIDELINE_ROUTE":{var _action$data4=action.data,_dispatcher3=_action$data4.dispatcher,routeId=_action$data4.routeId,stationCode=_action$data4.stationCode,_baseUrl2=_action$data4.baseUrl,_stationConfig3=_action$data4.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["i" /* sideLineRoute */])(_dispatcher3,routeId,stationCode,_baseUrl2,_stationConfig3);return state;}case"UNASSIGN_STAGER":{var _action$data5=action.data,_dispatcher4=_action$data5.dispatcher,stageListId=_action$data5.stageListId,_stationCode=_action$data5.stationCode,associateId=_action$data5.associateId,_baseUrl3=_action$data5.baseUrl,_stationConfig4=_action$data5.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["j" /* unassignStager */])(_dispatcher4,stageListId,_stationCode,associateId,_baseUrl3,_stationConfig4);return state;}case"SHOW_NOTIFICATION":return Object.assign({},state,action.data);case"ROUTE_SIDELINED_SUCCESS":return Object.assign({},state,action.data);case"ROUTE_SIDELINED_ERROR":return Object.assign({},state,action.data);case"REMOVE_NOTIFICATION":var notification={alert:{}};return Object.assign({},state,notification);case"ALREADY_SIDELINED":return Object.assign({},state,action.data);default:return state;}};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(320);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var bind = __webpack_require__(164);
var Axios = __webpack_require__(322);
var mergeConfig = __webpack_require__(171);
var defaults = __webpack_require__(167);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(172);
axios.CancelToken = __webpack_require__(335);
axios.isCancel = __webpack_require__(166);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(336);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(337);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var buildURL = __webpack_require__(165);
var InterceptorManager = __webpack_require__(323);
var dispatchRequest = __webpack_require__(324);
var mergeConfig = __webpack_require__(171);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var transformData = __webpack_require__(325);
var isCancel = __webpack_require__(166);
var defaults = __webpack_require__(167);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(170);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(331);
var combineURLs = __webpack_require__(332);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(172);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level = void 0;
var promise_polyfill_1 = __importDefault(__webpack_require__(339));
var stacktrace_js_1 = __importDefault(__webpack_require__(343));
var katal_metrics_1 = __webpack_require__(354);
var metrics_aggregator_1 = __webpack_require__(385);
var Level;
(function (Level) {
    Level["DEBUG"] = "debug";
    Level["INFO"] = "info";
    Level["WARN"] = "warn";
    Level["ERROR"] = "error";
    Level["FATAL"] = "fatal";
})(Level = exports.Level || (exports.Level = {}));
var LOG_LEVELS = [
    Level.DEBUG,
    Level.INFO,
    Level.WARN,
    Level.ERROR,
    Level.FATAL,
];
var DEFAULT_MAX_LOG_LINE_SIZE = 10000; // 10 kilobytes default
var DEFAULT_BATCH_TIMEOUT_DURATION = 5000;
var DEFAULT_MAX_LOGS_PER_BATCH = 25;
var CONFIG_DEFAULTS = {
    logThreshold: Level.DEBUG,
    maxLogLineSize: DEFAULT_MAX_LOG_LINE_SIZE,
    batchTimeoutDuration: DEFAULT_BATCH_TIMEOUT_DURATION,
    decodeStackTrace: false,
    recordMetrics: true,
    context: {},
    headers: {},
    logToConsole: false,
    maxLogsPerBatch: DEFAULT_MAX_LOGS_PER_BATCH,
};
// obtained from https://developer.mozilla.org/en-US/docs/Web/API/Event
var EVENT_PROPERTIES = [
    'bubbles',
    'cancelBubble',
    'cancelable',
    'composed',
    'currentTarget',
    'deepPath',
    'defaultPrevented',
    'eventPhase',
    'explicitOriginalTarget',
    'originalTarget',
    'returnValue',
    'srcElement',
    'target',
    'timeStamp',
    'type',
    'isTrusted',
];
var KatalLogger = /** @class */ (function () {
    /**
     * Construct a KatalLogger
     *
     * @param config
     */
    function KatalLogger(config) {
        var _this = this;
        this.resourceTimingLogged = false;
        this.sendLogsToBackend = function () {
            var logsToSend = _this.logLineQueue;
            if (logsToSend.length === 0) {
                return;
            }
            _this.logLineQueue = [];
            var logs = {
                logs: logsToSend,
            };
            _this.sendLogToBackend(JSON.stringify(logs));
            _this.queueTimerId = undefined;
        };
        var configWithDefaults = __assign(__assign({}, CONFIG_DEFAULTS), config);
        this.url = configWithDefaults.url;
        this.logThreshold = configWithDefaults.logThreshold;
        this.maxLogLineSize = configWithDefaults.maxLogLineSize;
        this.context = configWithDefaults.context;
        this.logToConsole = configWithDefaults.logToConsole;
        this.headers = configWithDefaults.headers;
        this.recordMetrics = configWithDefaults.recordMetrics;
        this.batchTimeoutDuration = configWithDefaults.batchTimeoutDuration;
        this.decodeStackTrace = configWithDefaults.decodeStackTrace;
        this.maxLogsPerBatch = configWithDefaults.maxLogsPerBatch;
        this.xhrWithCredentials = configWithDefaults.xhrWithCredentials;
        this.logLineQueue = [];
        this.unregisterFns = [];
        this.unloaded = false;
        this.logThresholdIndex = Math.max(LOG_LEVELS.indexOf(Level.DEBUG), LOG_LEVELS.indexOf(this.logThreshold));
        if (this.recordMetrics) {
            katal_metrics_1.metricsPublisher.publishCounterMonitor("KatalLogger:construct", 1);
        }
        this.registerUnloadAction(function () {
            _this.unloaded = true;
            _this.sendLogsToBackend();
        });
    }
    /**
     * Cover all of the unload cases:
     * https://www.igvita.com/2015/11/20/dont-lose-user-and-app-state-use-page-visibility/
     */
    KatalLogger.prototype.registerUnloadAction = function (callback) {
        this.registerEvent('pagehide', callback);
        this.registerEvent('beforeunload', callback);
        this.registerEvent('visibilitychange', function () {
            if (document.visibilityState === 'hidden') {
                callback();
            }
        });
    };
    /**
     * Log a copy of Katal Metrics emitted on this page
     * @param filterFunction: an optional function to filter metrics before publishing
     */
    KatalLogger.prototype.addMetricsListener = function (filterFunction) {
        var _this = this;
        var aggregator = new metrics_aggregator_1.MetricsAggregator(filterFunction);
        var unloadedAlready = false;
        this.registerUnloadAction(function () {
            if (unloadedAlready)
                return;
            unloadedAlready = true;
            _this.info('Katal Metrics', aggregator.aggregatedMetrics);
        });
    };
    /**
     * Adds a formatted version of Performance API logs.
     * Uses https://developer.mozilla.org/en-US/docs/Web/API/Performance/getEntries
     * to determine resource and paint timings.
     */
    KatalLogger.prototype.addPerformanceListener = function () {
        var _this = this;
        this.registerUnloadAction(function () {
            _this.logResourceTiming();
        });
    };
    KatalLogger.prototype.logResourceTiming = function () {
        if (this.resourceTimingLogged) {
            return;
        }
        this.resourceTimingLogged = true;
        var resource = window.performance
            .getEntriesByType('resource')
            .reduce(function (acc, resourceTiming) {
            var _a;
            var _b = resourceTiming, name = _b.name, initiatorType = _b.initiatorType, duration = _b.duration;
            var resource = name.split('/').pop();
            acc[initiatorType] = (_a = acc[initiatorType]) !== null && _a !== void 0 ? _a : {};
            acc[initiatorType][resource] = Math.round(duration);
            return acc;
        }, {});
        var paint = window.performance
            .getEntriesByType('paint')
            .reduce(function (acc, _a) {
            var name = _a.name, startTime = _a.startTime;
            acc[name] = Math.round(startTime);
            return acc;
        }, {});
        this.info("Performance Timing", { resource: resource, paint: paint });
    };
    /**
     * Adds an event listener for errors. Will log the error if the filter callback returns true
     *
     * @param filterCallback function that takes an error object and returns whether it should be logged
     */
    KatalLogger.prototype.addErrorListener = function (filterCallback) {
        var _this = this;
        ['error', 'unhandledrejection'].map(function (listener) {
            _this.registerEvent(listener, 
            /* istanbul ignore next - this.eventListener tested seperately */
            function (e) {
                return _this.eventListener(e, filterCallback);
            }, true);
        });
    };
    /**
     * Removes the registered error event listeners
     * Normal applications need not call this.
     * This is required for multitenant SPAs to avoid memory leaks.
     */
    KatalLogger.prototype.removeErrorListener = function () {
        this.unregisterFns.forEach(function (fn) { return fn(); });
    };
    KatalLogger.prototype.registerEvent = function (event, cb, capture) {
        window.addEventListener(event, cb, capture);
        this.unregisterFns.push(function () {
            window.removeEventListener(event, cb, capture);
        });
    };
    KatalLogger.prototype.eventListener = function (e, filterCallback) {
        var errorMessage;
        var error;
        // e is an ErrorEvent
        if (e.error) {
            errorMessage = e.error.message;
            error = e.error;
        }
        // e is PromiseRejectionEvent
        else if (e.reason) {
            if (isError(e.reason)) {
                errorMessage = e.reason.message;
                error = e.reason;
            }
            else {
                errorMessage = e.reason;
            }
        }
        else if (isError(e)) {
            errorMessage = e.message;
            error = e;
        }
        else {
            errorMessage = "An unknown error occurred: " + this.toStringObject(e);
            // Capture a stack trace
            error = new Error('Unknown error');
        }
        if (errorMessage !== 'KatalLogger error' &&
            (!filterCallback || filterCallback(error))) {
            try {
                return this.error(errorMessage, error);
            }
            catch (_) {
                // Prevent infinite loops by swallowing errors that occur while logging errors
            }
        }
    };
    KatalLogger.prototype.createJsonStringifyReplacer = function () {
        var cache = new Map();
        return function (key, value) {
            if (typeof value === 'object' && value != null) {
                if (cache.has(value)) {
                    return "reference-loop, also referenced from '" + cache.get(value) + "'";
                }
                cache.set(value, key);
            }
            return value;
        };
    };
    /**
     * Event objects are hard to serialize (see https://stackoverflow.com/questions/11547672/how-to-stringify-event-object) so we need a helper method
     */
    KatalLogger.prototype.toStringObject = function (object) {
        var constructorName = object.constructor.name;
        if (object instanceof Event) {
            var eventObject = {};
            for (var _i = 0, EVENT_PROPERTIES_1 = EVENT_PROPERTIES; _i < EVENT_PROPERTIES_1.length; _i++) {
                var prop = EVENT_PROPERTIES_1[_i];
                eventObject[prop] = object[prop];
            }
            object = eventObject;
        }
        return (constructorName +
            ':' +
            JSON.stringify(object, this.createJsonStringifyReplacer()));
    };
    KatalLogger.prototype.debug = function (message, error, context) {
        var _this = this;
        return this.extractArgs(Level.DEBUG, message, error, context).then(function (args) {
            return _this.sendRequest(args);
        });
    };
    KatalLogger.prototype.info = function (message, error, context) {
        var _this = this;
        return this.extractArgs(Level.INFO, message, error, context).then(function (args) {
            return _this.sendRequest(args);
        });
    };
    KatalLogger.prototype.warn = function (message, error, context) {
        var _this = this;
        return this.extractArgs(Level.WARN, message, error, context).then(function (args) {
            return _this.sendRequest(args);
        });
    };
    KatalLogger.prototype.error = function (message, error, context) {
        var _this = this;
        return this.extractArgs(Level.ERROR, message, error, context).then(function (args) {
            return _this.sendRequest(args);
        });
    };
    KatalLogger.prototype.fatal = function (message, error, context) {
        var _this = this;
        return this.extractArgs(Level.FATAL, message, error, context).then(function (args) {
            return _this.sendRequest(args);
        });
    };
    KatalLogger.prototype.extractArgs = function (level, message, error, context) {
        var errorInfo = isError(error)
            ? {
                errorMessage: error.message,
                errorName: error.name,
                errorStackTrace: '',
            }
            : undefined;
        var logPayload = {
            level: level,
            message: message,
            error: errorInfo,
            context: __assign(__assign(__assign({}, this.context), (errorInfo ? context : error)), { logTime: Date.now() }),
        };
        if (logPayload.error) {
            return this.getStackTraceFromError(error).then(function (trace) {
                logPayload.error.errorStackTrace = trace;
                return logPayload;
            });
        }
        return promise_polyfill_1.default.resolve(logPayload);
    };
    KatalLogger.prototype.getStackTraceFromError = function (error) {
        if (!this.decodeStackTrace) {
            return promise_polyfill_1.default.resolve(String(error.stack));
        }
        return promise_polyfill_1.default.resolve(stacktrace_js_1.default.fromError(error).then(function (stackframes) {
            return stackframes.map(function (sf) { return sf.toString(); }).join('\n');
        }));
    };
    KatalLogger.prototype.sendRequest = function (payload) {
        this.queueLogLine(payload);
        if (this.logToConsole) {
            this.sendLogToConsole(payload);
        }
    };
    KatalLogger.prototype.sendLogToConsole = function (data) {
        var level = data.level;
        if (!LOG_LEVELS.includes(data.level) || data.level === Level.FATAL) {
            level = Level.ERROR;
        }
        console[level](data);
    };
    KatalLogger.prototype.queueLogLine = function (payload) {
        if (this.payloadIsValid(payload)) {
            this.appendToQueue(payload);
            if (this.unloaded || this.logLineQueue.length >= this.maxLogsPerBatch) {
                this.sendLogsToBackend();
            }
            else if (!this.queueTimerId) {
                this.queueTimerId = window.setTimeout(this.sendLogsToBackend, this.batchTimeoutDuration);
            }
        }
    };
    KatalLogger.prototype.appendToQueue = function (payload) {
        this.logLineQueue.push(payload);
    };
    KatalLogger.prototype.sendLogToBackend = function (dataString) {
        if (this.url) {
            if ((navigator === null || navigator === void 0 ? void 0 : navigator.sendBeacon) && !Object.keys(this.headers).length) {
                navigator.sendBeacon(this.url, dataString);
            }
            else {
                var xhr_1 = new XMLHttpRequest();
                // xhr request is set to async.
                // In case this needs to be changed to sync, it should be noted that xhr.withCredentials with sync request is not supported since Firefox 11.
                // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#browser_compatibility
                xhr_1.open('POST', this.url, true);
                if (this.xhrWithCredentials) {
                    xhr_1.withCredentials = this.xhrWithCredentials;
                }
                Object.entries(this.headers).forEach(function (_a) {
                    var headerName = _a[0], headerValue = _a[1];
                    xhr_1.setRequestHeader(headerName, headerValue);
                });
                xhr_1.send(dataString);
            }
        }
    };
    KatalLogger.prototype.payloadIsValid = function (data) {
        var a = LOG_LEVELS.indexOf(data.level);
        var b = this.logThresholdIndex;
        var passesLogLevelCheck = a >= b;
        if (passesLogLevelCheck) {
            var dataString = JSON.stringify(data);
            var dataStringLength = dataString.length;
            if (dataStringLength <= this.maxLogLineSize) {
                return true;
            }
        }
        return false;
    };
    return KatalLogger;
}());
exports.default = KatalLogger;
function isError(object) {
    /* istanbul ignore next - in node (unit tests) there is no error.constructor. In ie, there is no error.stack */
    return ((object === null || object === void 0 ? void 0 : object.name) && object.message && (object.stack || !!object.constructor));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__finally__ = __webpack_require__(342);


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = __WEBPACK_IMPORTED_MODULE_0__finally__["a" /* default */];

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["default"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(340).setImmediate))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(341);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76), __webpack_require__(168)))

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (finallyConstructor);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(344), __webpack_require__(345), __webpack_require__(346)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('error-stack-parser'), require('stack-generator'), require('stacktrace-gps'));
    } else {
        root.StackTrace = factory(root.ErrorStackParser, root.StackGenerator, root.StackTraceGPS);
    }
}(this, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
    var _options = {
        filter: function(stackframe) {
            // Filter out stackframes for this library by default
            return (stackframe.functionName || '').indexOf('StackTrace$$') === -1 &&
                (stackframe.functionName || '').indexOf('ErrorStackParser$$') === -1 &&
                (stackframe.functionName || '').indexOf('StackTraceGPS$$') === -1 &&
                (stackframe.functionName || '').indexOf('StackGenerator$$') === -1;
        },
        sourceCache: {}
    };

    var _generateError = function StackTrace$$GenerateError() {
        try {
            // Error must be thrown to get stack in IE
            throw new Error();
        } catch (err) {
            return err;
        }
    };

    /**
     * Merge 2 given Objects. If a conflict occurs the second object wins.
     * Does not do deep merges.
     *
     * @param {Object} first base object
     * @param {Object} second overrides
     * @returns {Object} merged first and second
     * @private
     */
    function _merge(first, second) {
        var target = {};

        [first, second].forEach(function(obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    target[prop] = obj[prop];
                }
            }
            return target;
        });

        return target;
    }

    function _isShapedLikeParsableError(err) {
        return err.stack || err['opera#sourceloc'];
    }

    function _filtered(stackframes, filter) {
        if (typeof filter === 'function') {
            return stackframes.filter(filter);
        }
        return stackframes;
    }

    return {
        /**
         * Get a backtrace from invocation point.
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */
        get: function StackTrace$$get(opts) {
            var err = _generateError();
            return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
        },

        /**
         * Get a backtrace from invocation point.
         * IMPORTANT: Does not handle source maps or guess function names!
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */
        getSync: function StackTrace$$getSync(opts) {
            opts = _merge(_options, opts);
            var err = _generateError();
            var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
            return _filtered(stack, opts.filter);
        },

        /**
         * Given an error object, parse it.
         *
         * @param {Error} error object
         * @param {Object} opts
         * @returns {Promise} for Array[StackFrame}
         */
        fromError: function StackTrace$$fromError(error, opts) {
            opts = _merge(_options, opts);
            var gps = new StackTraceGPS(opts);
            return new Promise(function(resolve) {
                var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
                resolve(Promise.all(stackframes.map(function(sf) {
                    return new Promise(function(resolve) {
                        function resolveOriginal() {
                            resolve(sf);
                        }

                        gps.pinpoint(sf).then(resolve, resolveOriginal)['catch'](resolveOriginal);
                    });
                })));
            }.bind(this));
        },

        /**
         * Use StackGenerator to generate a backtrace.
         *
         * @param {Object} opts
         * @returns {Promise} of Array[StackFrame]
         */
        generateArtificially: function StackTrace$$generateArtificially(opts) {
            opts = _merge(_options, opts);
            var stackFrames = StackGenerator.backtrace(opts);
            if (typeof opts.filter === 'function') {
                stackFrames = stackFrames.filter(opts.filter);
            }
            return Promise.resolve(stackFrames);
        },

        /**
         * Given a function, wrap it such that invocations trigger a callback that
         * is called with a stack trace.
         *
         * @param {Function} fn to be instrumented
         * @param {Function} callback function to call with a stack trace on invocation
         * @param {Function} errback optional function to call with error if unable to get stack trace.
         * @param {Object} thisArg optional context object (e.g. window)
         */
        instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
            if (typeof fn !== 'function') {
                throw new Error('Cannot instrument non-function object');
            } else if (typeof fn.__stacktraceOriginalFn === 'function') {
                // Already instrumented, return given Function
                return fn;
            }

            var instrumented = function StackTrace$$instrumented() {
                try {
                    this.get().then(callback, errback)['catch'](errback);
                    return fn.apply(thisArg || this, arguments);
                } catch (e) {
                    if (_isShapedLikeParsableError(e)) {
                        this.fromError(e).then(callback, errback)['catch'](errback);
                    }
                    throw e;
                }
            }.bind(this);
            instrumented.__stacktraceOriginalFn = fn;

            return instrumented;
        },

        /**
         * Given a function that has been instrumented,
         * revert the function to it's original (non-instrumented) state.
         *
         * @param {Function} fn to de-instrument
         */
        deinstrument: function StackTrace$$deinstrument(fn) {
            if (typeof fn !== 'function') {
                throw new Error('Cannot de-instrument non-function object');
            } else if (typeof fn.__stacktraceOriginalFn === 'function') {
                return fn.__stacktraceOriginalFn;
            } else {
                // Function not instrumented, return original
                return fn;
            }
        },

        /**
         * Given an error message and Array of StackFrames, serialize and POST to given URL.
         *
         * @param {Array} stackframes
         * @param {String} url
         * @param {String} errorMsg
         * @param {Object} requestOptions
         */
        report: function StackTrace$$report(stackframes, url, errorMsg, requestOptions) {
            return new Promise(function(resolve, reject) {
                var req = new XMLHttpRequest();
                req.onerror = reject;
                req.onreadystatechange = function onreadystatechange() {
                    if (req.readyState === 4) {
                        if (req.status >= 200 && req.status < 400) {
                            resolve(req.responseText);
                        } else {
                            reject(new Error('POST to ' + url + ' failed with status: ' + req.status));
                        }
                    }
                };
                req.open('post', url);

                // Set request headers
                req.setRequestHeader('Content-Type', 'application/json');
                if (requestOptions && typeof requestOptions.headers === 'object') {
                    var headers = requestOptions.headers;
                    for (var header in headers) {
                        if (Object.prototype.hasOwnProperty.call(headers, header)) {
                            req.setRequestHeader(header, headers[header]);
                        }
                    }
                }

                var reportPayload = {stack: stackframes};
                if (errorMsg !== undefined && errorMsg !== null) {
                    reportPayload.message = errorMsg;
                }

                req.send(JSON.stringify(reportPayload));
            });
        }
    };
}));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('stackframe'));
    } else {
        root.ErrorStackParser = factory(root.StackFrame);
    }
}(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(\),.*$)/g, '');
                }
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');

                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);

                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                var tokens = sanitizedLine.split(/\s+/).slice(1);
                // if a location was matched, pass it to extractLocation() otherwise pop the last token
                var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                var functionName = tokens.join(' ') || undefined;
                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                } else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                        new StackFrame({
                            functionName: match[3] || undefined,
                            fileName: match[2],
                            lineNumber: match[1],
                            source: lines[i]
                        })
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                    .replace(/<anonymous function(: (\w+))?>/, '$2')
                    .replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                    undefined : argsRaw.split(',');

                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
}));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('stackframe'));
    } else {
        root.StackGenerator = factory(root.StackFrame);
    }
}(this, function(StackFrame) {
    return {
        backtrace: function StackGenerator$$backtrace(opts) {
            var stack = [];
            var maxStackSize = 10;

            if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
                maxStackSize = opts.maxStackSize;
            }

            var curr = arguments.callee;
            while (curr && stack.length < maxStackSize && curr['arguments']) {
                // Allow V8 optimizations
                var args = new Array(curr['arguments'].length);
                for (var i = 0; i < args.length; ++i) {
                    args[i] = curr['arguments'][i];
                }
                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
                    stack.push(new StackFrame({functionName: RegExp.$1 || undefined, args: args}));
                } else {
                    stack.push(new StackFrame({args: args}));
                }

                try {
                    curr = curr.caller;
                } catch (e) {
                    break;
                }
            }
            return stack;
        }
    };
}));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(347), __webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('source-map/lib/source-map-consumer'), require('stackframe'));
    } else {
        root.StackTraceGPS = factory(root.SourceMap || root.sourceMap, root.StackFrame);
    }
}(this, function(SourceMap, StackFrame) {
    'use strict';

    /**
     * Make a X-Domain request to url and callback.
     *
     * @param {String} url
     * @returns {Promise} with response text if fulfilled
     */
    function _xdr(url) {
        return new Promise(function(resolve, reject) {
            var req = new XMLHttpRequest();
            req.open('get', url);
            req.onerror = reject;
            req.onreadystatechange = function onreadystatechange() {
                if (req.readyState === 4) {
                    if ((req.status >= 200 && req.status < 300) ||
                        (url.substr(0, 7) === 'file://' && req.responseText)) {
                        resolve(req.responseText);
                    } else {
                        reject(new Error('HTTP status: ' + req.status + ' retrieving ' + url));
                    }
                }
            };
            req.send();
        });

    }

    /**
     * Convert a Base64-encoded string into its original representation.
     * Used for inline sourcemaps.
     *
     * @param {String} b64str Base-64 encoded string
     * @returns {String} original representation of the base64-encoded string.
     */
    function _atob(b64str) {
        if (typeof window !== 'undefined' && window.atob) {
            return window.atob(b64str);
        } else {
            throw new Error('You must supply a polyfill for window.atob in this environment');
        }
    }

    function _parseJson(string) {
        if (typeof JSON !== 'undefined' && JSON.parse) {
            return JSON.parse(string);
        } else {
            throw new Error('You must supply a polyfill for JSON.parse in this environment');
        }
    }

    function _findFunctionName(source, lineNumber/*, columnNumber*/) {
        var syntaxes = [
            // {name} = function ({args}) TODO args capture
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/,
            // function {name}({args}) m[1]=name m[2]=args
            /function\s+([^('"`]*?)\s*\(([^)]*)\)/,
            // {name} = eval()
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/,
            // fn_name() {
            /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/,
            // {name} = () => {
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/
        ];
        var lines = source.split('\n');

        // Walk backwards in the source lines until we find the line which matches one of the patterns above
        var code = '';
        var maxLines = Math.min(lineNumber, 20);
        for (var i = 0; i < maxLines; ++i) {
            // lineNo is 1-based, source[] is 0-based
            var line = lines[lineNumber - i - 1];
            var commentPos = line.indexOf('//');
            if (commentPos >= 0) {
                line = line.substr(0, commentPos);
            }

            if (line) {
                code = line + code;
                var len = syntaxes.length;
                for (var index = 0; index < len; index++) {
                    var m = syntaxes[index].exec(code);
                    if (m && m[1]) {
                        return m[1];
                    }
                }
            }
        }
        return undefined;
    }

    function _ensureSupportedEnvironment() {
        if (typeof Object.defineProperty !== 'function' || typeof Object.create !== 'function') {
            throw new Error('Unable to consume source maps in older browsers');
        }
    }

    function _ensureStackFrameIsLegit(stackframe) {
        if (typeof stackframe !== 'object') {
            throw new TypeError('Given StackFrame is not an object');
        } else if (typeof stackframe.fileName !== 'string') {
            throw new TypeError('Given file name is not a String');
        } else if (typeof stackframe.lineNumber !== 'number' ||
            stackframe.lineNumber % 1 !== 0 ||
            stackframe.lineNumber < 1) {
            throw new TypeError('Given line number must be a positive integer');
        } else if (typeof stackframe.columnNumber !== 'number' ||
            stackframe.columnNumber % 1 !== 0 ||
            stackframe.columnNumber < 0) {
            throw new TypeError('Given column number must be a non-negative integer');
        }
        return true;
    }

    function _findSourceMappingURL(source) {
        var sourceMappingUrlRegExp = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/mg;
        var lastSourceMappingUrl;
        var matchSourceMappingUrl;
        // eslint-disable-next-line no-cond-assign
        while (matchSourceMappingUrl = sourceMappingUrlRegExp.exec(source)) {
            lastSourceMappingUrl = matchSourceMappingUrl[1];
        }
        if (lastSourceMappingUrl) {
            return lastSourceMappingUrl;
        } else {
            throw new Error('sourceMappingURL not found');
        }
    }

    function _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache) {
        return new Promise(function(resolve, reject) {
            var loc = sourceMapConsumer.originalPositionFor({
                line: stackframe.lineNumber,
                column: stackframe.columnNumber
            });

            if (loc.source) {
                // cache mapped sources
                var mappedSource = sourceMapConsumer.sourceContentFor(loc.source);
                if (mappedSource) {
                    sourceCache[loc.source] = mappedSource;
                }

                resolve(
                    // given stackframe and source location, update stackframe
                    new StackFrame({
                        functionName: loc.name || stackframe.functionName,
                        args: stackframe.args,
                        fileName: loc.source,
                        lineNumber: loc.line,
                        columnNumber: loc.column
                    }));
            } else {
                reject(new Error('Could not get original source for given stackframe and source map'));
            }
        });
    }

    /**
     * @constructor
     * @param {Object} opts
     *      opts.sourceCache = {url: "Source String"} => preload source cache
     *      opts.sourceMapConsumerCache = {/path/file.js.map: SourceMapConsumer}
     *      opts.offline = True to prevent network requests.
     *              Best effort without sources or source maps.
     *      opts.ajax = Promise returning function to make X-Domain requests
     */
    return function StackTraceGPS(opts) {
        if (!(this instanceof StackTraceGPS)) {
            return new StackTraceGPS(opts);
        }
        opts = opts || {};

        this.sourceCache = opts.sourceCache || {};
        this.sourceMapConsumerCache = opts.sourceMapConsumerCache || {};

        this.ajax = opts.ajax || _xdr;

        this._atob = opts.atob || _atob;

        this._get = function _get(location) {
            return new Promise(function(resolve, reject) {
                var isDataUrl = location.substr(0, 5) === 'data:';
                if (this.sourceCache[location]) {
                    resolve(this.sourceCache[location]);
                } else if (opts.offline && !isDataUrl) {
                    reject(new Error('Cannot make network requests in offline mode'));
                } else {
                    if (isDataUrl) {
                        // data URLs can have parameters.
                        // see http://tools.ietf.org/html/rfc2397
                        var supportedEncodingRegexp =
                            /^data:application\/json;([\w=:"-]+;)*base64,/;
                        var match = location.match(supportedEncodingRegexp);
                        if (match) {
                            var sourceMapStart = match[0].length;
                            var encodedSource = location.substr(sourceMapStart);
                            var source = this._atob(encodedSource);
                            this.sourceCache[location] = source;
                            resolve(source);
                        } else {
                            reject(new Error('The encoding of the inline sourcemap is not supported'));
                        }
                    } else {
                        var xhrPromise = this.ajax(location, {method: 'get'});
                        // Cache the Promise to prevent duplicate in-flight requests
                        this.sourceCache[location] = xhrPromise;
                        xhrPromise.then(resolve, reject);
                    }
                }
            }.bind(this));
        };

        /**
         * Creating SourceMapConsumers is expensive, so this wraps the creation of a
         * SourceMapConsumer in a per-instance cache.
         *
         * @param {String} sourceMappingURL = URL to fetch source map from
         * @param {String} defaultSourceRoot = Default source root for source map if undefined
         * @returns {Promise} that resolves a SourceMapConsumer
         */
        this._getSourceMapConsumer = function _getSourceMapConsumer(sourceMappingURL, defaultSourceRoot) {
            return new Promise(function(resolve) {
                if (this.sourceMapConsumerCache[sourceMappingURL]) {
                    resolve(this.sourceMapConsumerCache[sourceMappingURL]);
                } else {
                    var sourceMapConsumerPromise = new Promise(function(resolve, reject) {
                        return this._get(sourceMappingURL).then(function(sourceMapSource) {
                            if (typeof sourceMapSource === 'string') {
                                sourceMapSource = _parseJson(sourceMapSource.replace(/^\)\]\}'/, ''));
                            }
                            if (typeof sourceMapSource.sourceRoot === 'undefined') {
                                sourceMapSource.sourceRoot = defaultSourceRoot;
                            }

                            resolve(new SourceMap.SourceMapConsumer(sourceMapSource));
                        }, reject);
                    }.bind(this));
                    this.sourceMapConsumerCache[sourceMappingURL] = sourceMapConsumerPromise;
                    resolve(sourceMapConsumerPromise);
                }
            }.bind(this));
        };

        /**
         * Given a StackFrame, enhance function name and use source maps for a
         * better StackFrame.
         *
         * @param {StackFrame} stackframe object
         * @returns {Promise} that resolves with with source-mapped StackFrame
         */
        this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
            return new Promise(function(resolve, reject) {
                this.getMappedLocation(stackframe).then(function(mappedStackFrame) {
                    function resolveMappedStackFrame() {
                        resolve(mappedStackFrame);
                    }

                    this.findFunctionName(mappedStackFrame)
                        .then(resolve, resolveMappedStackFrame)
                        // eslint-disable-next-line no-unexpected-multiline
                        ['catch'](resolveMappedStackFrame);
                }.bind(this), reject);
            }.bind(this));
        };

        /**
         * Given a StackFrame, guess function name from location information.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */
        this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
            return new Promise(function(resolve, reject) {
                _ensureStackFrameIsLegit(stackframe);
                this._get(stackframe.fileName).then(function getSourceCallback(source) {
                    var lineNumber = stackframe.lineNumber;
                    var columnNumber = stackframe.columnNumber;
                    var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
                    // Only replace functionName if we found something
                    if (guessedFunctionName) {
                        resolve(new StackFrame({
                            functionName: guessedFunctionName,
                            args: stackframe.args,
                            fileName: stackframe.fileName,
                            lineNumber: lineNumber,
                            columnNumber: columnNumber
                        }));
                    } else {
                        resolve(stackframe);
                    }
                }, reject)['catch'](reject);
            }.bind(this));
        };

        /**
         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */
        this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
            return new Promise(function(resolve, reject) {
                _ensureSupportedEnvironment();
                _ensureStackFrameIsLegit(stackframe);

                var sourceCache = this.sourceCache;
                var fileName = stackframe.fileName;
                this._get(fileName).then(function(source) {
                    var sourceMappingURL = _findSourceMappingURL(source);
                    var isDataUrl = sourceMappingURL.substr(0, 5) === 'data:';
                    var defaultSourceRoot = fileName.substring(0, fileName.lastIndexOf('/') + 1);

                    if (sourceMappingURL[0] !== '/' && !isDataUrl && !(/^https?:\/\/|^\/\//i).test(sourceMappingURL)) {
                        sourceMappingURL = defaultSourceRoot + sourceMappingURL;
                    }

                    return this._getSourceMapConsumer(sourceMappingURL, defaultSourceRoot)
                        .then(function(sourceMapConsumer) {
                            return _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache)
                                .then(resolve)['catch'](function() {
                                    resolve(stackframe);
                                });
                        });
                }.bind(this), reject)['catch'](reject);
            }.bind(this));
        };
    };
}));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
exports.SourceMapGenerator = __webpack_require__(174).SourceMapGenerator;
exports.SourceMapConsumer = __webpack_require__(350).SourceMapConsumer;
exports.SourceNode = __webpack_require__(353).SourceNode;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
exports.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
exports.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = __webpack_require__(77);

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

exports.MappingList = MappingList;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = __webpack_require__(77);
var binarySearch = __webpack_require__(351);
var ArraySet = __webpack_require__(176).ArraySet;
var base64VLQ = __webpack_require__(175);
var quickSort = __webpack_require__(352).quickSort;

function SourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  return sourceMap.sections != null
    ? new IndexedSourceMapConsumer(sourceMap)
    : new BasicSourceMapConsumer(sourceMap);
}

SourceMapConsumer.fromSourceMap = function(aSourceMap) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
}

/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer.prototype._version = 3;

// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});

SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer.prototype._charIsMappingSeparator =
  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
  };

SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;

SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;

/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer.prototype.eachMapping =
  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;

    var mappings;
    switch (order) {
    case SourceMapConsumer.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
    }

    var sourceRoot = this.sourceRoot;
    mappings.map(function (mapping) {
      var source = mapping.source === null ? null : this._sources.at(mapping.source);
      if (source != null && sourceRoot != null) {
        source = util.join(sourceRoot, source);
      }
      return {
        source: source,
        generatedLine: mapping.generatedLine,
        generatedColumn: mapping.generatedColumn,
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: mapping.name === null ? null : this._names.at(mapping.name)
      };
    }, this).forEach(aCallback, context);
  };

/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
SourceMapConsumer.prototype.allGeneratedPositionsFor =
  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = util.getArg(aArgs, 'line');

    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
      source: util.getArg(aArgs, 'source'),
      originalLine: line,
      originalColumn: util.getArg(aArgs, 'column', 0)
    };

    if (this.sourceRoot != null) {
      needle.source = util.relative(this.sourceRoot, needle.source);
    }
    if (!this._sources.has(needle.source)) {
      return [];
    }
    needle.source = this._sources.indexOf(needle.source);

    var mappings = [];

    var index = this._findMapping(needle,
                                  this._originalMappings,
                                  "originalLine",
                                  "originalColumn",
                                  util.compareByOriginalPositions,
                                  binarySearch.LEAST_UPPER_BOUND);
    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (aArgs.column === undefined) {
        var originalLine = mapping.originalLine;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we found. Since
        // mappings are sorted, this is guaranteed to find all mappings for
        // the line we found.
        while (mapping && mapping.originalLine === originalLine) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      } else {
        var originalColumn = mapping.originalColumn;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we were searching for.
        // Since mappings are sorted, this is guaranteed to find all mappings for
        // the line we are searching for.
        while (mapping &&
               mapping.originalLine === line &&
               mapping.originalColumn == originalColumn) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      }
    }

    return mappings;
  };

exports.SourceMapConsumer = SourceMapConsumer;

/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  var version = util.getArg(sourceMap, 'version');
  var sources = util.getArg(sourceMap, 'sources');
  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.
  var names = util.getArg(sourceMap, 'names', []);
  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util.getArg(sourceMap, 'mappings');
  var file = util.getArg(sourceMap, 'file', null);

  // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  sources = sources
    .map(String)
    // Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(util.normalize)
    // Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function (source) {
      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
        ? util.relative(sourceRoot, source)
        : source;
    });

  // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.
  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);

  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;

/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap =
  function SourceMapConsumer_fromSourceMap(aSourceMap) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);

    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
                                                            smc.sourceRoot);
    smc.file = aSourceMap._file;

    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.

    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];

    for (var i = 0, length = generatedMappings.length; i < length; i++) {
      var srcMapping = generatedMappings[i];
      var destMapping = new Mapping;
      destMapping.generatedLine = srcMapping.generatedLine;
      destMapping.generatedColumn = srcMapping.generatedColumn;

      if (srcMapping.source) {
        destMapping.source = sources.indexOf(srcMapping.source);
        destMapping.originalLine = srcMapping.originalLine;
        destMapping.originalColumn = srcMapping.originalColumn;

        if (srcMapping.name) {
          destMapping.name = names.indexOf(srcMapping.name);
        }

        destOriginalMappings.push(destMapping);
      }

      destGeneratedMappings.push(destMapping);
    }

    quickSort(smc.__originalMappings, util.compareByOriginalPositions);

    return smc;
  };

/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._sources.toArray().map(function (s) {
      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
    }, this);
  }
});

/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
BasicSourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;

    while (index < length) {
      if (aStr.charAt(index) === ';') {
        generatedLine++;
        index++;
        previousGeneratedColumn = 0;
      }
      else if (aStr.charAt(index) === ',') {
        index++;
      }
      else {
        mapping = new Mapping();
        mapping.generatedLine = generatedLine;

        // Because each offset is encoded relative to the previous one,
        // many segments often have the same encoding. We can exploit this
        // fact by caching the parsed variable length fields of each segment,
        // allowing us to avoid a second parse if we encounter the same
        // segment again.
        for (end = index; end < length; end++) {
          if (this._charIsMappingSeparator(aStr, end)) {
            break;
          }
        }
        str = aStr.slice(index, end);

        segment = cachedSegments[str];
        if (segment) {
          index += str.length;
        } else {
          segment = [];
          while (index < end) {
            base64VLQ.decode(aStr, index, temp);
            value = temp.value;
            index = temp.rest;
            segment.push(value);
          }

          if (segment.length === 2) {
            throw new Error('Found a source, but no line and column');
          }

          if (segment.length === 3) {
            throw new Error('Found a source and line, but no column');
          }

          cachedSegments[str] = segment;
        }

        // Generated column.
        mapping.generatedColumn = previousGeneratedColumn + segment[0];
        previousGeneratedColumn = mapping.generatedColumn;

        if (segment.length > 1) {
          // Original source.
          mapping.source = previousSource + segment[1];
          previousSource += segment[1];

          // Original line.
          mapping.originalLine = previousOriginalLine + segment[2];
          previousOriginalLine = mapping.originalLine;
          // Lines are stored 0-based
          mapping.originalLine += 1;

          // Original column.
          mapping.originalColumn = previousOriginalColumn + segment[3];
          previousOriginalColumn = mapping.originalColumn;

          if (segment.length > 4) {
            // Original name.
            mapping.name = previousName + segment[4];
            previousName += segment[4];
          }
        }

        generatedMappings.push(mapping);
        if (typeof mapping.originalLine === 'number') {
          originalMappings.push(mapping);
        }
      }
    }

    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;

    quickSort(originalMappings, util.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
  };

/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping =
  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
                                         aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.

    if (aNeedle[aLineName] <= 0) {
      throw new TypeError('Line must be greater than or equal to 1, got '
                          + aNeedle[aLineName]);
    }
    if (aNeedle[aColumnName] < 0) {
      throw new TypeError('Column must be greater than or equal to 0, got '
                          + aNeedle[aColumnName]);
    }

    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
  };

/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans =
  function SourceMapConsumer_computeColumnSpans() {
    for (var index = 0; index < this._generatedMappings.length; ++index) {
      var mapping = this._generatedMappings[index];

      // Mappings do not contain a field for the last generated columnt. We
      // can come up with an optimistic estimate, however, by assuming that
      // mappings are contiguous (i.e. given two consecutive mappings, the
      // first mapping ends where the second one starts).
      if (index + 1 < this._generatedMappings.length) {
        var nextMapping = this._generatedMappings[index + 1];

        if (mapping.generatedLine === nextMapping.generatedLine) {
          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
          continue;
        }
      }

      // The last mapping for each line spans the entire line.
      mapping.lastGeneratedColumn = Infinity;
    }
  };

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor =
  function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      util.compareByGeneratedPositionsDeflated,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._generatedMappings[index];

      if (mapping.generatedLine === needle.generatedLine) {
        var source = util.getArg(mapping, 'source', null);
        if (source !== null) {
          source = this._sources.at(source);
          if (this.sourceRoot != null) {
            source = util.join(this.sourceRoot, source);
          }
        }
        var name = util.getArg(mapping, 'name', null);
        if (name !== null) {
          name = this._names.at(name);
        }
        return {
          source: source,
          line: util.getArg(mapping, 'originalLine', null),
          column: util.getArg(mapping, 'originalColumn', null),
          name: name
        };
      }
    }

    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
  function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) {
      return false;
    }
    return this.sourcesContent.length >= this._sources.size() &&
      !this.sourcesContent.some(function (sc) { return sc == null; });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor =
  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) {
      return null;
    }

    if (this.sourceRoot != null) {
      aSource = util.relative(this.sourceRoot, aSource);
    }

    if (this._sources.has(aSource)) {
      return this.sourcesContent[this._sources.indexOf(aSource)];
    }

    var url;
    if (this.sourceRoot != null
        && (url = util.urlParse(this.sourceRoot))) {
      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
      // many users. We can help them out when they expect file:// URIs to
      // behave like it would if they were running a local HTTP server. See
      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
      if (url.scheme == "file"
          && this._sources.has(fileUriAbsPath)) {
        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
      }

      if ((!url.path || url.path == "/")
          && this._sources.has("/" + aSource)) {
        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
      }
    }

    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor =
  function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = util.getArg(aArgs, 'source');
    if (this.sourceRoot != null) {
      source = util.relative(this.sourceRoot, source);
    }
    if (!this._sources.has(source)) {
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    }
    source = this._sources.indexOf(source);

    var needle = {
      source: source,
      originalLine: util.getArg(aArgs, 'line'),
      originalColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      util.compareByOriginalPositions,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (mapping.source === needle.source) {
        return {
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        };
      }
    }

    return {
      line: null,
      column: null,
      lastColumn: null
    };
  };

exports.BasicSourceMapConsumer = BasicSourceMapConsumer;

/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }

  var version = util.getArg(sourceMap, 'version');
  var sections = util.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new ArraySet();
  this._names = new ArraySet();

  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = util.getArg(s, 'offset');
    var offsetLine = util.getArg(offset, 'line');
    var offsetColumn = util.getArg(offset, 'column');

    if (offsetLine < lastOffset.line ||
        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;

    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
    }
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;

/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor =
  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = binarySearch.search(needle, this._sections,
      function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) {
          return cmp;
        }

        return (needle.generatedColumn -
                section.generatedOffset.generatedColumn);
      });
    var section = this._sections[sectionIndex];

    if (!section) {
      return {
        source: null,
        line: null,
        column: null,
        name: null
      };
    }

    return section.consumer.originalPositionFor({
      line: needle.generatedLine -
        (section.generatedOffset.generatedLine - 1),
      column: needle.generatedColumn -
        (section.generatedOffset.generatedLine === needle.generatedLine
         ? section.generatedOffset.generatedColumn - 1
         : 0),
      bias: aArgs.bias
    });
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function (s) {
      return s.consumer.hasContentsOfAllSources();
    });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor =
  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      var content = section.consumer.sourceContentFor(aSource, true);
      if (content) {
        return content;
      }
    }
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor =
  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      // Only consider this section if the requested source is in the list of
      // sources of the consumer.
      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
        continue;
      }
      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
      if (generatedPosition) {
        var ret = {
          line: generatedPosition.line +
            (section.generatedOffset.generatedLine - 1),
          column: generatedPosition.column +
            (section.generatedOffset.generatedLine === generatedPosition.line
             ? section.generatedOffset.generatedColumn - 1
             : 0)
        };
        return ret;
      }
    }

    return {
      line: null,
      column: null
    };
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings =
  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];
      var sectionMappings = section.consumer._generatedMappings;
      for (var j = 0; j < sectionMappings.length; j++) {
        var mapping = sectionMappings[j];

        var source = section.consumer._sources.at(mapping.source);
        if (section.consumer.sourceRoot !== null) {
          source = util.join(section.consumer.sourceRoot, source);
        }
        this._sources.add(source);
        source = this._sources.indexOf(source);

        var name = section.consumer._names.at(mapping.name);
        this._names.add(name);
        name = this._names.indexOf(name);

        // The mappings coming from the consumer for the section have
        // generated positions relative to the start of the section, so we
        // need to offset them to be relative to the start of the concatenated
        // generated file.
        var adjustedMapping = {
          source: source,
          generatedLine: mapping.generatedLine +
            (section.generatedOffset.generatedLine - 1),
          generatedColumn: mapping.generatedColumn +
            (section.generatedOffset.generatedLine === mapping.generatedLine
            ? section.generatedOffset.generatedColumn - 1
            : 0),
          originalLine: mapping.originalLine,
          originalColumn: mapping.originalColumn,
          name: name
        };

        this.__generatedMappings.push(adjustedMapping);
        if (typeof adjustedMapping.originalLine === 'number') {
          this.__originalMappings.push(adjustedMapping);
        }
      }
    }

    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, util.compareByOriginalPositions);
  };

exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;

/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  // This function terminates when one of the following is true:
  //
  //   1. We find the exact element we are looking for.
  //
  //   2. We did not find the exact element, but we can return the index of
  //      the next-closest element.
  //
  //   3. We did not find the exact element, and there is no next-closest
  //      element than the one we are searching for, so we return -1.
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    // Found the element we are looking for.
    return mid;
  }
  else if (cmp > 0) {
    // Our needle is greater than aHaystack[mid].
    if (aHigh - mid > 1) {
      // The element is in the upper half.
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }

    // The exact needle element was not found in this haystack. Determine if
    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  }
  else {
    // Our needle is less than aHaystack[mid].
    if (mid - aLow > 1) {
      // The element is in the lower half.
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }

    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}

/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }

  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }

  // We have found either the exact element, or the next-closest element than
  // the one we are searching for. However, there may be more than one such
  // element. Make sure we always return the smallest of these.
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }

  return index;
};


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */
function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}

/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */
function randomIntInRange(low, high) {
  return Math.round(low + (Math.random() * (high - low)));
}

/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */
function doQuickSort(ary, comparator, p, r) {
  // If our lower bound is less than our upper bound, we (1) partition the
  // array into two pieces and (2) recurse on each half. If it is not, this is
  // the empty array and our base case.

  if (p < r) {
    // (1) Partitioning.
    //
    // The partitioning chooses a pivot between `p` and `r` and moves all
    // elements that are less than or equal to the pivot to the before it, and
    // all the elements that are greater than it after it. The effect is that
    // once partition is done, the pivot is in the exact place it will be when
    // the array is put in sorted order, and it will not need to be moved
    // again. This runs in O(n) time.

    // Always choose a random pivot so that an input array which is reverse
    // sorted does not cause O(n^2) running time.
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;

    swap(ary, pivotIndex, r);
    var pivot = ary[r];

    // Immediately after `j` is incremented in this loop, the following hold
    // true:
    //
    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
    //
    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }

    swap(ary, i + 1, j);
    var q = i + 1;

    // (2) Recurse on each half.

    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}

/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */
exports.quickSort = function (ary, comparator) {
  doQuickSort(ary, comparator, 0, ary.length - 1);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator = __webpack_require__(174).SourceMapGenerator;
var util = __webpack_require__(77);

// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;

// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;

// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";

/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}

/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */
SourceNode.fromStringWithSourceMap =
  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();

    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are removed from this array, by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var shiftNextLine = function() {
      var lineContents = remainingLines.shift();
      // The last line of a file might not have a newline.
      var newLine = remainingLines.shift() || "";
      return lineContents + newLine;
    };

    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;

    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;

    aSourceMapConsumer.eachMapping(function (mapping) {
      if (lastMapping !== null) {
        // We add the code from "lastMapping" to "mapping":
        // First check if there is a new line in between.
        if (lastGeneratedLine < mapping.generatedLine) {
          // Associate first line with "lastMapping"
          addMappingWithCode(lastMapping, shiftNextLine());
          lastGeneratedLine++;
          lastGeneratedColumn = 0;
          // The remaining code is added without mapping
        } else {
          // There is no new line in between.
          // Associate the code between "lastGeneratedColumn" and
          // "mapping.generatedColumn" with "lastMapping"
          var nextLine = remainingLines[0];
          var code = nextLine.substr(0, mapping.generatedColumn -
                                        lastGeneratedColumn);
          remainingLines[0] = nextLine.substr(mapping.generatedColumn -
                                              lastGeneratedColumn);
          lastGeneratedColumn = mapping.generatedColumn;
          addMappingWithCode(lastMapping, code);
          // No more remaining code, continue
          lastMapping = mapping;
          return;
        }
      }
      // We add the generated code until the first mapping
      // to the SourceNode without any mapping.
      // Each line is added as separate string.
      while (lastGeneratedLine < mapping.generatedLine) {
        node.add(shiftNextLine());
        lastGeneratedLine++;
      }
      if (lastGeneratedColumn < mapping.generatedColumn) {
        var nextLine = remainingLines[0];
        node.add(nextLine.substr(0, mapping.generatedColumn));
        remainingLines[0] = nextLine.substr(mapping.generatedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
      }
      lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLines.length > 0) {
      if (lastMapping) {
        // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
      }
      // and add the remaining lines without any mapping
      node.add(remainingLines.join(""));
    }

    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aRelativePath != null) {
          sourceFile = util.join(aRelativePath, sourceFile);
        }
        node.setSourceContent(sourceFile, content);
      }
    });

    return node;

    function addMappingWithCode(mapping, code) {
      if (mapping === null || mapping.source === undefined) {
        node.add(code);
      } else {
        var source = aRelativePath
          ? util.join(aRelativePath, mapping.source)
          : mapping.source;
        node.add(new SourceNode(mapping.originalLine,
                                mapping.originalColumn,
                                source,
                                code,
                                mapping.name));
      }
    }
  };

/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length-1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    }
    else {
      if (chunk !== '') {
        aFn(chunk, { source: this.source,
                     line: this.line,
                     column: this.column,
                     name: this.name });
      }
    }
  }
};

/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len-1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};

/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  }
  else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  }
  else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};

/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */
SourceNode.prototype.setSourceContent =
  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
  };

/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walkSourceContents =
  function SourceNode_walkSourceContents(aFn) {
    for (var i = 0, len = this.children.length; i < len; i++) {
      if (this.children[i][isSourceNode]) {
        this.children[i].walkSourceContents(aFn);
      }
    }

    var sources = Object.keys(this.sourceContents);
    for (var i = 0, len = sources.length; i < len; i++) {
      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
    }
  };

/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};

/**
 * Returns the string representation of this source node along with a source
 * map.
 */
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null
        && original.line !== null
        && original.column !== null) {
      if(lastOriginalSource !== original.source
         || lastOriginalLine !== original.line
         || lastOriginalColumn !== original.column
         || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        // Mappings end at eol
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });

  return { code: generated.code, map: map };
};

exports.SourceNode = SourceNode;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metricsPublisher = void 0;
/* istanbul ignore file */
var KatalMetrics = __importStar(__webpack_require__(355));
var katal_metrics_driver_sushi_1 = __importDefault(__webpack_require__(375));
var metricsErrorHandler = function (err) {
    console.error(err);
};
var metricsDriver = new katal_metrics_driver_sushi_1.default.Builder()
    .withDomainRealm('prod', 'USAmazon')
    .withErrorHandler(metricsErrorHandler)
    .build();
var urlMatch = /([^?]+)/.exec(window.location.href);
var urlMetric = new KatalMetrics.Metric.String('url', urlMatch ? urlMatch[1] : window.location.href);
urlMetric.truncate = true;
var metricsContext = new KatalMetrics.Context.Builder()
    .withSite('KatalLoggerInternalMetrics')
    .withServiceName('KatalLogger')
    .addRelatedMetrics(urlMetric)
    .build();
var initialMetricsPublisher = new KatalMetrics.Publisher(metricsDriver, metricsErrorHandler, metricsContext);
exports.metricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("KatalLogger:Loaded");
//# sourceMappingURL=katal-metrics.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

var _typeof = __webpack_require__(68);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CloudWatchDimensions", {
  enumerable: true,
  get: function get() {
    return _CloudWatchDimensions.CloudWatchDimensions;
  }
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function get() {
    return _KatalMetricsContext.default;
  }
});
Object.defineProperty(exports, "ErrorHandler", {
  enumerable: true,
  get: function get() {
    return _ErrorHandler.ErrorHandler;
  }
});
exports.Metric = void 0;
Object.defineProperty(exports, "MetricsDriver", {
  enumerable: true,
  get: function get() {
    return _KatalMetricsDriver.default;
  }
});
Object.defineProperty(exports, "Publisher", {
  enumerable: true,
  get: function get() {
    return _KatalMetricsPublisher.default;
  }
});

var Metric = _interopRequireWildcard(__webpack_require__(177));

exports.Metric = Metric;

var _KatalMetricsPublisher = _interopRequireDefault(__webpack_require__(362));

var _KatalMetricsContext = _interopRequireDefault(__webpack_require__(188));

var _KatalMetricsDriver = _interopRequireDefault(__webpack_require__(192));

var _ErrorHandler = __webpack_require__(373);

var _CloudWatchDimensions = __webpack_require__(374);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),
/* 356 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _KatalMetricObjectList = _interopRequireDefault(__webpack_require__(358));

var _ObjectValuesPonyfill = _interopRequireDefault(__webpack_require__(359));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Metric object list that tracks metrics by name, and generates metrics prefixed with the name of this object.
 */
var KatalMetricNamedObjectList = /*#__PURE__*/function (_KatalMetricObjectLis) {
  (0, _inherits2.default)(KatalMetricNamedObjectList, _KatalMetricObjectLis);

  var _super = _createSuper(KatalMetricNamedObjectList);

  /**
   * Create a new named object list.
   *
   * The name given here will be used to prefix all metrics.
   *
   * @param name Name of this metric
   */
  function KatalMetricNamedObjectList(name) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricNamedObjectList);
    _this = _super.call(this, name);
    _this.namedMetrics = {};
    return _this;
  }

  (0, _createClass2.default)(KatalMetricNamedObjectList, [{
    key: "metricList",
    get: function get() {
      return (0, _ObjectValuesPonyfill.default)(this.namedMetrics);
    }
    /**
     * Replace the metric with the given name with a new metric generated by the given function.
     *
     * If the newly created metric supports monitoring, its isMonitor flag will be set to the value of the
     * isMonitor flag for this containing object.
     *
     * @param subName Name of this sub-metric
     * @param metricCreator Function which takes the full name for this metric
     *        and returns a newly constructed KatalMetricObject with this name and an appropriate value
     */

  }, {
    key: "setNamedMetric",
    value: function setNamedMetric(subName, metricCreator) {
      var fullName = this.getNameForSubMetric(subName);
      var metric = metricCreator(fullName);

      if (metric.canMonitor) {
        metric.isMonitor = this.isMonitor;
      }

      this.namedMetrics[subName] = metric;
    }
    /**
     * If the given value is undefined or null, delete the metric with the give name; otherwise if the given named
     * metric already exists update its value; otherwise create a new metric of the given type and set its value.
     *
     * This specialized helper method is designed to deal with the common case of a value setter in a more complex
     * metric.  Outside of subclasses, other methods will probably prove more useful.
     *
     * If the value is null the metric will also be deleted.
     *
     * @param subName Name of metric to create or delete
     * @param newValueClass Class of new metric to create
     * @param newValue New value for this metric (or undefined to delete the metric)
     */

  }, {
    key: "setOrDeleteNamedMetricValue",
    value: function setOrDeleteNamedMetricValue(subName, newValueClass, newValue) {
      if (newValue == undefined) {
        this.deleteNamedMetric(subName);
      } else {
        var metric = this.getOrCreateNamedMetric(subName, function (name) {
          return new newValueClass(name, newValue);
        });
        metric.value = newValue;
      }
    }
    /**
     * Get the sub-metric with the given name if it exists, otherwise use the given function to create a new metric and
     * store and return that.
     *
     * @param subName Name of this sub-metric
     * @param metricCreator Function which takes the full name for this metric
     *        and returns a newly constructed KatalMetricObject with this name and an appropriate value
     * @return Metric object which was retrieved or created
     */

  }, {
    key: "getOrCreateNamedMetric",
    value: function getOrCreateNamedMetric(subName, metricCreator) {
      if (!this.namedMetrics[subName]) {
        this.setNamedMetric(subName, metricCreator);
      }

      return this.namedMetrics[subName];
    }
    /**
     * Return the given named sub-metric, if it exists.
     *
     * @param {string} subName Name of this sub-metric
     * @return {KatalMetricObject | undefined} Metric object with this name if it exists, otherwise undefined
     */

  }, {
    key: "getNamedMetric",
    value: function getNamedMetric(subName) {
      return this.namedMetrics[subName];
    }
    /**
     * Delete the given named sub-metric.
     *
     * @param subName Name of this sub-metric
     */

  }, {
    key: "deleteNamedMetric",
    value: function deleteNamedMetric(subName) {
      delete this.namedMetrics[subName];
    }
    /**
     * Get the value for the given metric, or undefined if the metric does not exist.
     *
     * @param subName Name of this sub-metric
     * @return Value for the given metric, or undefined if the metric does not exist
     */

  }, {
    key: "getNamedMetricValue",
    value: function getNamedMetricValue(subName) {
      var metric = this.getNamedMetric(subName);
      if (!metric) return undefined;
      return metric.value;
    }
    /**
     * Generate a name for the given sub-metric.
     *
     * @param subName Name of this sub-metric
     * @return Full name for this sub-metric
     */

  }, {
    key: "getNameForSubMetric",
    value: function getNameForSubMetric(subName) {
      return "".concat(this.name, ".").concat(subName);
    }
  }]);
  return KatalMetricNamedObjectList;
}(_KatalMetricObjectList.default);

exports.default = KatalMetricNamedObjectList;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _get2 = _interopRequireDefault(__webpack_require__(79));

var _set2 = _interopRequireDefault(__webpack_require__(187));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _KatalMetricObject2 = _interopRequireDefault(__webpack_require__(78));

var _FirstMap = _interopRequireDefault(__webpack_require__(114));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Abstract metric that contains a list of other metrics; when it is published, the list of metrics is retrieved, and all
 * are published.
 */
var KatalMetricObjectList = /*#__PURE__*/function (_KatalMetricObject) {
  (0, _inherits2.default)(KatalMetricObjectList, _KatalMetricObject);

  var _super = _createSuper(KatalMetricObjectList);

  /**
   * Create a new KatalMetricObjectList.
   *
   * @param name Name for this metric.  Not really used, but present for consistency with other metrics.
   */
  function KatalMetricObjectList(name) {
    (0, _classCallCheck2.default)(this, KatalMetricObjectList);
    return _super.call(this, name);
  }
  /**
   * Get the list of for this object
   *
   * @returns Array of metrics for this object
   */


  (0, _createClass2.default)(KatalMetricObjectList, [{
    key: "metricList",
    get: function get() {
      throw new Error('Subclass of KatalMetricObjectList must implement metricList getter');
    }
  }, {
    key: "isMonitor",
    get: // This just delegates to the superclass, but if we override the setter without overriding the getter
    // getting the property will always return undefined.
    function get() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(KatalMetricObjectList.prototype), "isMonitor", this);
    },
    set: function set(isMonitor) {
      (0, _set2.default)((0, _getPrototypeOf2.default)(KatalMetricObjectList.prototype), "isMonitor", isMonitor, this, true);
      this.metricList.forEach(function (metric) {
        if (metric.canMonitor) {
          metric.isMonitor = isMonitor;
        }
      });
    }
  }, {
    key: "canMonitor",
    get: function get() {
      return true;
    }
  }, {
    key: "type",
    get: function get() {
      return _KatalMetricObject2.default.Types.List;
    }
    /**
     * If any of the contained metrics are invalid, return the first validation error encountered; otherwise return
     * undefined.
     *
     * Note that this isn't called by the publisher; it validates each sub-metric on its own.
     *
     * @returns Error found with submetric, if any; else undefined
     */

  }, {
    key: "validationError",
    value: function validationError() {
      // Doesn't make sense to check superclass error here, since it is the contained metrics that matter.
      return (0, _FirstMap.default)(this.metricList, function (metric) {
        return metric.validationError();
      });
    }
  }]);
  return KatalMetricObjectList;
}(_KatalMetricObject2.default);

exports.default = KatalMetricObjectList;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var objectValues = Object.values ? Object.values : function (object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
};
var _default = objectValues;
exports.default = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _KatalMetricTimedAttempt = _interopRequireDefault(__webpack_require__(113));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Standardized metric for instrumenting application initialization.
 *
 * Under the hood it is a KatalMetricTimedAttempt with the name "Initialization".
 * That object will contain a metric suffixed with ".Latency" for the latency of this request, and a metric suffixed
 * with ".Failure" to record the failure or success of this request.
 *
 * By default the request will be tracked as a failure; to mark it as a success call the "setSuccess()" method.
 *
 * By default, these metrics will be created:
 *   Initialization.Latency - Latency for application initialization
 *   Initialization.Failure - Failure for this application initialization (1 for failure, 0 for success)
 */
var KatalMetricInitialization = /*#__PURE__*/function (_KatalMetricTimedAtte) {
  (0, _inherits2.default)(KatalMetricInitialization, _KatalMetricTimedAtte);

  var _super = _createSuper(KatalMetricInitialization);

  /** The name for this metric. */

  /**
   * Create a new timed attempt metric named "Initialization", for recording latency and failure information about
   * your application's initialization.
   */
  function KatalMetricInitialization() {
    (0, _classCallCheck2.default)(this, KatalMetricInitialization);
    return _super.call(this, KatalMetricInitialization.INITIALIZE_METRIC_NAME);
  }

  return KatalMetricInitialization;
}(_KatalMetricTimedAttempt.default);

exports.default = KatalMetricInitialization;
(0, _defineProperty2.default)(KatalMetricInitialization, "INITIALIZE_METRIC_NAME", 'Initialization');

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _inherits2 = _interopRequireDefault(__webpack_require__(46));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(47));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(42));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _KatalMetricTimedAttempt = _interopRequireDefault(__webpack_require__(113));

var _KatalMetricString = _interopRequireDefault(__webpack_require__(180));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Standardized metric for instrumenting HTTP requests.
 *
 * Under the hood it is a KatalMetricTimedAttempt with the name you provide prefixed with "HTTPRequest.".
 * That object will contain a metric suffixed with ".Latency" for the latency of this request, and a metric suffixed
 * with ".Failure" to record the failure or success of this request.
 *
 * By default the request will be tracked as a failure; to mark it as a success call the "setSuccess()" method.
 *
 * It has additional properties which will be emitted if set; see url, statusCode, and statusText.
 *
 * For example, if you gave the name "Search", these metrics will be created:
 *   HTTPRequest.Search.Latency - Latency for this request
 *   HTTPRequest.Search.Failure - Failure for this request (1 for failure, 0 for success)
 */
var KatalMetricHttpRequest = /*#__PURE__*/function (_KatalMetricTimedAtte) {
  (0, _inherits2.default)(KatalMetricHttpRequest, _KatalMetricTimedAtte);

  var _super = _createSuper(KatalMetricHttpRequest);

  /** The prefix for this metric. */

  /** The suffix for URL metrics of this class. */

  /** The suffix for HTTP response code metrics of this class. */

  /** The suffix for HTTP response text metrics of this class. */

  /**
   * Create a new HTTP Request timed attempt metric incorporating the given name.
   *
   * The name you give will be used to create a KatalMetricTimedAttempt with the provided name prefixed with "HTTPRequest.".
   *
   * @param name Name of this metric; resulting metrics will prefix this name with "HTTPRequest."
   */
  function KatalMetricHttpRequest(name) {
    (0, _classCallCheck2.default)(this, KatalMetricHttpRequest);
    return _super.call(this, "".concat(KatalMetricHttpRequest.HTTP_REQUEST_PREFIX, ".").concat(name));
  }
  /**
   * Set the url for this metric.
   *
   * A string metric will be added to the list of objects that will be published for this metric.  Its name will
   * be this metrics name suffixed with '.URL', and its value will be the URL value given here.
   *
   * @param value URL for this metric
   */


  (0, _createClass2.default)(KatalMetricHttpRequest, [{
    key: "url",
    get:
    /**
     * Get the URL for this metric, if defined.
     *
     * @return The URL for this metric, or undefined
     */
    function get() {
      return this.getNamedMetricValue(KatalMetricHttpRequest.URL_SUFFIX);
    }
    /**
     * Get the URL metric object associated with this metric, if defined.
     *
     * @return Associated URL metric object, or undefined
     */
    ,
    set: function set(value) {
      this.setOrDeleteNamedMetricValue(KatalMetricHttpRequest.URL_SUFFIX, _KatalMetricString.default, value);
    }
  }, {
    key: "urlMetric",
    get: function get() {
      return this.getNamedMetric(KatalMetricHttpRequest.URL_SUFFIX);
    }
    /**
     * Set the HTTP response status code for this metric.
     *
     * A string metric will be added to the list of objects that will be published for this metric.  Its name will
     * be this metrics name suffixed with '.StatusCode', and its value will be the status code value given here.
     *
     * @param value HTTP response status code for this metric
     */

  }, {
    key: "statusCode",
    get:
    /**
     * Get the HTTP response status code for this metric, if defined.
     *
     * @return Associated HTTP response status code metric object, or undefined
     */
    function get() {
      return this.getNamedMetricValue(KatalMetricHttpRequest.STATUS_CODE_SUFFIX);
    }
    /**
     * Get the HTTP response status code metric object associated with this metric, if defined.
     *
     * @return HTTP response status code metric object, or undefined
     */
    ,
    set: function set(value) {
      this.setOrDeleteNamedMetricValue(KatalMetricHttpRequest.STATUS_CODE_SUFFIX, _KatalMetricString.default, value);
    }
  }, {
    key: "statusCodeMetric",
    get: function get() {
      return this.getNamedMetric(KatalMetricHttpRequest.STATUS_CODE_SUFFIX);
    }
    /**
     * Set the HTTP response status text for this metric.
     *
     * A string metric will be added to the list of objects that will be published for this metric.  Its name will
     * be this metrics name suffixed with '.StatusText', and its value will be the status text value given here.
     *
     * @param statusText HTTP response status text for this metric, or undefined to remove
     */

  }, {
    key: "statusText",
    get:
    /**
     * Get the HTTP response status text for this metric, if defined.
     *
     * @return Associated HTTP response status text metric object, or undefined
     */
    function get() {
      return this.getNamedMetricValue(KatalMetricHttpRequest.STATUS_TEXT_SUFFIX);
    }
    /**
     * Get the HTTP response status text for this metric, if defined.
     *
     * @return Associated HTTP response status text metric object, or undefined
     */
    ,
    set: function set(value) {
      this.setOrDeleteNamedMetricValue(KatalMetricHttpRequest.STATUS_TEXT_SUFFIX, _KatalMetricString.default, value);
    }
  }, {
    key: "statusTextMetric",
    get: function get() {
      return this.getNamedMetric(KatalMetricHttpRequest.STATUS_TEXT_SUFFIX);
    }
  }]);
  return KatalMetricHttpRequest;
}(_KatalMetricTimedAttempt.default);

exports.default = KatalMetricHttpRequest;
(0, _defineProperty2.default)(KatalMetricHttpRequest, "HTTP_REQUEST_PREFIX", 'HTTPRequest');
(0, _defineProperty2.default)(KatalMetricHttpRequest, "URL_SUFFIX", 'URL');
(0, _defineProperty2.default)(KatalMetricHttpRequest, "STATUS_CODE_SUFFIX", 'StatusCode');
(0, _defineProperty2.default)(KatalMetricHttpRequest, "STATUS_TEXT_SUFFIX", 'StatusText');

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33));

var _createClass2 = _interopRequireDefault(__webpack_require__(36));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(53));

var _v = _interopRequireDefault(__webpack_require__(363));

var _KatalMetricsContext = _interopRequireDefault(__webpack_require__(188));

var _metricObject = __webpack_require__(177);

var _mergeLists = __webpack_require__(189);

var _metricsExtension = __webpack_require__(372);

var _embedRequestId = __webpack_require__(191);

var INITIALIZATION_METHOD_NAME = 'Initialization';

/**
 * Default error handler if the user-supplied error handler fails or is unset.
 * Should never be called unless user-provided error handler misbehaves.
 */
var DEFAULT_ERROR_HANDLER = function DEFAULT_ERROR_HANDLER(err) {
  console.error("Error publishing metrics:");
  console.error(err);
};

var PARENT_ACTION_ID_NAME = 'parentActionId';

var getContextFields = function getContextFields(context) {
  if (context.context) {
    return context.context;
  } else {
    return context;
  }
};
/**
 * Class used for publishing metrics to Katal.  Contains a driver and a context.
 *
 * This class knows how to publish metrics, and how to create new publishers with a modified context.
 */


var KatalMetricsPublisher = /*#__PURE__*/function () {
  /**
   * Create a new metrics publisher with the given driver and context
   *
   * @param driver Subclass of KatalMetricsDriver used to publish the metrics
   * @param errorHandler Handler for errors that occur while using this publisher
   * @param context Context for this metrics publisher; contains data to be included with every
   *     metric published using this publisher object.  Default is an empty context.
   */
  function KatalMetricsPublisher(driver) {
    var _this = this;

    var errorHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ERROR_HANDLER;
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _KatalMetricsContext.default();
    (0, _classCallCheck2.default)(this, KatalMetricsPublisher);
    (0, _defineProperty2.default)(this, "combinedErrorHandler", function (err) {
      try {
        _this.errorHandler(err);
      } catch (nextErr) {
        console.error("Error handling error publishing metrics:");
        console.error(nextErr);
        DEFAULT_ERROR_HANDLER(err);
      }
    });

    // Check for a common error
    if (context instanceof _KatalMetricsContext.default.Builder) {
      throw new Error("KatalMetricsContext.Builder object passed instead of KatalMetricsContext.  Try calling .build() method.");
    }

    this.driver = driver;
    this.errorHandler = errorHandler;
    this.context = !(context instanceof _KatalMetricsContext.default) ? new _KatalMetricsContext.default(context) : context;
  }
  /**
   * Call the error-handler supplied by the user when this object was constructed; if that is unset or itself throws
   * an exception, calls the default error handler as a fallback, which will just log the error to the console.
   *
   * @param err Error object to handle
   */


  (0, _createClass2.default)(KatalMetricsPublisher, [{
    key: "withErrorHandling",
    value:
    /**
     * Helper method to wrap a function in the error handler.
     *
     * @param doTheThing Function to run under the wrapper
     * @return Return value from called function
     */
    function withErrorHandling(doTheThing) {
      try {
        return doTheThing();
      } catch (err) {
        this.combinedErrorHandler(err);
      }
    }
    /**
     * Helper method to return all the related metrics of base publisher and additionalContext.
     *
     * @param additionalContext Additional context to be included in the new publisher
     * @return Return all related metrics from base publisher and additionalContext.
     */

  }, {
    key: "getAdditionalRelatedMetrics",
    value: function getAdditionalRelatedMetrics(additionalContext) {
      var newContext = additionalContext instanceof _KatalMetricsContext.default ? additionalContext.context : additionalContext;
      var baseRelatedMetrics = this.getBaseRelatedMetrics();
      return (0, _mergeLists.mergeLists)(baseRelatedMetrics, newContext.relatedMetrics);
    }
    /**
     * Helper method to return all the related metrics of base publisher.
     *
     * @return Return all related metrics from the base publisher.
     */

  }, {
    key: "getBaseRelatedMetrics",
    value: function getBaseRelatedMetrics() {
      return (0, _mergeLists.mergeLists)(this.context.context.relatedMetrics, this.context.context.relatedMetricsSingleAction);
    }
    /**
     * Publish the given metric object.
     *
     * This method is guaranteed never to throw an exception.  If the metric object or context are invalid,
     * or any other exception is thrown while publishing, the publisher's error handler is called.  If the
     * publisher's error handler is unset or fails, the default error handler is called (see defaultErrorHandler).
     *
     * @param katalMetricObject Metric object to publish
     */

  }, {
    key: "publish",
    value: function publish(katalMetricObject) {
      var _this2 = this;

      this.withErrorHandling(function () {
        if (!katalMetricObject) {
          throw new Error("Cannot publish undefined/null metric object");
        }

        if (_metricObject.Object.Types.List === katalMetricObject.type) {
          katalMetricObject.metricList.forEach(function (metric) {
            _this2.publish(metric);
          });
        } else {
          var driverContext = _this2.context.driverContext();

          var contextError = driverContext.validationError();
          if (contextError) throw contextError;
          var objectError = katalMetricObject.validationError();
          if (objectError) throw objectError;
          (0, _metricsExtension.dispatchMetricEvent)(katalMetricObject, driverContext);

          _this2.driver.publish(katalMetricObject, driverContext);
        }
      });
    }
    /**
     * Create a new publisher which is identical to this publisher, but with the given context fields merged into
     * the new publisher's context.
     *
     * @param additionalContext Additional context to be included in the new publisher
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildPublisher",
    value: function newChildPublisher(additionalContext) {
      return new KatalMetricsPublisher(this.driver, this.errorHandler, this.context.merge(additionalContext));
    }
    /**
     * Begin a new action, and return a new publisher for metrics related to that action.
     *
     * Beginning a new action involves the following steps:
     *   1. Generate a new actionId for the action, randomly in the browser
     *   2. If there are any related metrics in the context, publish them
     *   3. Create and return a new publisher with this object's context, merged with any additional context given,
     *      merged with the actionId generated above.
     *
     * @param additionalContext Additional context to be included in the new publisher
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildActionPublisher",
    value: function newChildActionPublisher(additionalContext) {
      var actionId = this._generateActionid(additionalContext);

      var newContext = this.context.withoutRelatedMetricsSingleAction().merge({
        actionId: actionId
      }).merge(additionalContext);
      var newPublisher = new KatalMetricsPublisher(this.driver, this.errorHandler, newContext);
      var allRelatedMetrics = additionalContext && !(additionalContext instanceof _KatalMetricsContext.default.Builder) ? this.getAdditionalRelatedMetrics(additionalContext) : this.getBaseRelatedMetrics();

      if (allRelatedMetrics) {
        allRelatedMetrics.forEach(function (metric) {
          newPublisher.publish(metric);
        });
      }

      return newPublisher;
    }
    /**
     * Begin a new chained child action, and return a new publisher for metrics related to that action.
     *
     * A chained action is handled the same way as in newChildActionPublisher, but additionally,
     * the returned publisher has a relatedMetricNoInherit named "parentActionId", with the newly
     * generated actionId as its value.
     *
     * The effect of this is that any further chained child actions can be connected back to this
     * action through the parentActionId, and so on recursively.
     *
     * @param additionalContext Additional context to be included in the new publisher
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildActionPublisherChained",
    value: function newChildActionPublisherChained(additionalContext) {
      var actionId = this._generateActionid(additionalContext);

      var parentActionId = (0, _embedRequestId.embedRequestId)(actionId, this.context.context.requestId);
      var relatedMetricsSingleAction = [new _metricObject.String(PARENT_ACTION_ID_NAME, parentActionId)];
      var newContext = new _KatalMetricsContext.default({
        actionId: actionId,
        relatedMetricsSingleAction: relatedMetricsSingleAction
      }).merge(additionalContext);
      return this.newChildActionPublisher(newContext);
    }
    /**
     * Helper method to create a new chained child action publisher with the given value for methodName.
     *
     * Apart from setting the methodName in the child context, this method is identical to newChildActionPublisherChained.
     *
     * @param methodName Method name for new publisher context
     * @param additionalContext Additional context to supply (optional)
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildActionPublisherChainedForMethod",
    value: function newChildActionPublisherChainedForMethod(methodName, additionalContext) {
      return this.newChildActionPublisherChained(new _KatalMetricsContext.default({
        methodName: methodName
      }).merge(additionalContext));
    }
    /**
     * Helper method to create a new action publisher with the given value for methodName.
     *
     * Apart from setting the methodName in the child context, this method is identical to newChildActionPublisherForMethod.
     * @param methodName Method name for new publisher context
     * @param additionalContext Additional context to supply (optional)
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildActionPublisherForMethod",
    value: function newChildActionPublisherForMethod(methodName, additionalContext) {
      return this.newChildActionPublisher(new _KatalMetricsContext.default({
        methodName: methodName
      }).merge(additionalContext));
    }
    /**
     * Helper method to create a new action for application initialization.  It will always have a methodName
     * of "Initialization"; otherwise this method is identical to newChildActionPublisherForMethod.
     *
     * @param additionalContext Additional context to be included in the new publisher
     * @returns New publisher identical to this one, but with an updated context
     */

  }, {
    key: "newChildActionPublisherForInitialization",
    value: function newChildActionPublisherForInitialization(additionalContext) {
      return this.newChildActionPublisherForMethod(INITIALIZATION_METHOD_NAME, additionalContext);
    }
    /**
     * Helper method to publish a string with the given name and value.
     *
     * @param name Metric name
     * @param value String value
     */

  }, {
    key: "publishString",
    value: function publishString(name, value) {
      this.publish(new _metricObject.String(name, value));
    }
    /**
     * Helper method to publish a string with the given name and value, truncated to the maximum size allowed by the
     * schema.
     *
     * @param name Metric name
     * @param value String value
     */

  }, {
    key: "publishStringTruncate",
    value: function publishStringTruncate(name, value) {
      var object = new _metricObject.String(name, value);
      object.truncate = true;
      this.publish(object);
    }
    /**
     * Helper method to publish a counter with the given name and value.
     *
     * @param name Metric name
     * @param value Counter value
     */

  }, {
    key: "publishCounter",
    value: function publishCounter(name, value) {
      this.publish(new _metricObject.Counter(name, value));
    }
    /**
     * Helper method to publish a timer with the given name and value.
     *
     * @param name Metric name
     * @param value Timer value
     */

  }, {
    key: "publishTimer",
    value: function publishTimer(name, value) {
      this.publish(new _metricObject.Timer(name, value));
    }
    /**
     * Helper method to publish a counter with the isMonitor flag set, and the given name and value.
     *
     * @param name Metric name
     * @param value Counter value
     */

  }, {
    key: "publishCounterMonitor",
    value: function publishCounterMonitor(name, value) {
      this.publish(new _metricObject.Counter(name, value).withMonitor());
    }
    /**
     * Helper method to publish a timer with the isMonitor flag set, and the given name and value.
     *
     * @param name Metric name
     * @param value Timer value
     */

  }, {
    key: "publishTimerMonitor",
    value: function publishTimerMonitor(name, value) {
      this.publish(new _metricObject.Timer(name, value).withMonitor());
    }
    /**
     * Private helper method to extract an actionId from a context if one is provided, and otherwise generate a new one.
     *
     * @returns Action ID string
     */

  }, {
    key: "_generateActionid",
    value: function _generateActionid(context) {
      if (context) {
        var fields = getContextFields(context);

        if (fields.actionId) {
          return fields.actionId;
        }
      }

      return (0, _v.default)();
    }
  }]);
  return KatalMetricsPublisher;
}();

exports.default = KatalMetricsPublisher;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(364);
var bytesToUuid = __webpack_require__(365);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateCloudWatchDimensions;

var _FirstMap = _interopRequireDefault(__webpack_require__(114));

var PRINTABLE_ASCII_PATTERN = /^[\x20-\x7E]+$/;
var AT_LEAST_ONE_NON_WHITESPACE_PATTERN = /^.*\S+.*$/;
var DIMENSION_NAME_STRING_MAX_LEN = 255;
var DIMENSION_VALUE_STRING_MAX_LEN = 1024;
/**
 * Check if the given dimensions are valid to be published to KatalMonitoring back-end.
 * It returns either undefined (no error), or an Error object describing the problem.
 *
 * To be published, name and value of string metrics must follow restrictions as described by
 * CloudWatch Dimension API Documentation:
 * https://docs.aws.amazon.com/AmazonCloudWatch/latest/APIReference/API_Dimension.html
 *
 * @param dimensions Array of string metrics to check
 * @returns Error, or undefined if no error
 */

function validateCloudWatchDimensions(dimensions) {
  return (0, _FirstMap.default)(dimensions, function (dimension) {
    var name = dimension.name,
        value = dimension.value;
    return validateCloudWatchDimension(name, value);
  });
}
/**
 * Check if the given dimension is valid as described by CloudWatch documentation.
 * https://docs.aws.amazon.com/AmazonCloudWatch/latest/APIReference/API_Dimension.html
 *
 * @param name CloudWatch Dimension Name String to check
 * @param value CloudWatch Dimension Value String to check
 * @returns Error, or undefined if no error
 */


function validateCloudWatchDimension(name, value) {
  if (name.length > DIMENSION_NAME_STRING_MAX_LEN) {
    return new Error("Expected Dimension name for value ".concat(value, " to be ").concat(DIMENSION_NAME_STRING_MAX_LEN, " characters or less, but it was ").concat(name.length, " characters"));
  }

  if (name.length < 1) {
    return new Error("Expected Dimension name for value ".concat(value, " to be non-blank"));
  }

  if (!PRINTABLE_ASCII_PATTERN.test(name)) {
    return new Error("Expected Dimension name for value ".concat(value, " to contain only ASCII characters, but it was ").concat(name));
  }

  if (!AT_LEAST_ONE_NON_WHITESPACE_PATTERN.test(name)) {
    return new Error("Expected Dimension name for value ".concat(value, " to contain at least one non whitespace character, but it was ").concat(name));
  }

  if (name.startsWith(":")) {
    return new Error("Expected Dimension name for value ".concat(value, " to not start with a colon (\":\"), but it was ").concat(name));
  }

  if (value.length > DIMENSION_VALUE_STRING_MAX_LEN) {
    return new Error("Expected Dimension value for name ".concat(name, " to be ").concat(DIMENSION_VALUE_STRING_MAX_LEN, " characters or less, but it was ").concat(value.length, " characters"));
  }

  if (value.length < 1) {
    return new Error("Expected Dimension value for name ".concat(name, " to be non-blank"));
  }

  if (!PRINTABLE_ASCII_PATTERN.test(value)) {
    return new Error("Expected Dimension value for name ".concat(name, " to contain only ASCII characters, but it was ").concat(value));
  }

  if (!AT_LEAST_ONE_NON_WHITESPACE_PATTERN.test(value)) {
    return new Error("Expected Dimension value for name ".concat(name, " to contain at least one non whitespace character, but it was ").concat(value, "}"));
  } // Couldn't find anything wrong, implicitly return undefined

}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(368);

var iterableToArray = __webpack_require__(369);

var unsupportedIterableToArray = __webpack_require__(370);

var nonIterableSpread = __webpack_require__(371);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(190);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(190);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchMetricEvent = dispatchMetricEvent;

/**
 * Publish to external parties that are 
 * listening for katal.metrics.publish Custom Events
 */
function dispatchMetricEvent(metric, context) {
  if (typeof window === 'undefined') {
    return;
  }

  dispatchCustomEvent(metric, context); // for legacy purposes, also publish to __KATAL_METRICS_EXTENSION__

  publishToMetricsExtension(metric, context);
}

function dispatchCustomEvent(metric, context) {
  if (typeof CustomEvent !== "function") {
    return;
  }

  var event = new CustomEvent('katal.metrics.publish', {
    detail: {
      metric: metric,
      context: context.getFields()
    }
  });
  window.dispatchEvent(event);
}
/**
 * @Deprecated
 * Publish to https://code.amazon.com/packages/KatalMetricsExtension
 * The extension injects a global __KATAL_METRICS_EXTENSION__ object with a
 * `publish` method.
 */


function publishToMetricsExtension(metric, context) {
  var extension = window.__KATAL_METRICS_EXTENSION__;

  if (extension) {
    extension.publish(metric, context.getFields());
  }
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_HANDLER = void 0;

var DEFAULT_ERROR_HANDLER = function DEFAULT_ERROR_HANDLER(err) {
  throw err;
};

exports.DEFAULT_ERROR_HANDLER = DEFAULT_ERROR_HANDLER;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__(376);

var _KatalMetricsDriverSushi = __webpack_require__(377);

/* istanbul ignore file */
var _default = _KatalMetricsDriverSushi.KatalMetricsDriverSushi;
exports.default = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(193);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KatalMetricsDriverSushi = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(378));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(194));

var _createClass2 = _interopRequireDefault(__webpack_require__(195));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(379));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(381));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(196));

var _inherits2 = _interopRequireDefault(__webpack_require__(382));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(115));

var _KatalMetricsDriver2 = _interopRequireDefault(__webpack_require__(192));

var _KatalMetricType = _interopRequireDefault(__webpack_require__(179));

var _katalSushiClient = _interopRequireDefault(__webpack_require__(384));

var _temp;

var KAT_STANDALONE_NEXUS_PRODUCER_ID = 'katal';
var KAT_STANDALONE_DEFAULT_SOURCE_GROUPS = {
  test: 'com.amazon.eel.katal.metrics.core.nexus.gamma',
  prod: 'com.amazon.eel.katal.metrics.core.nexus'
};

var KatalMetricsDriverSushi =
/*#__PURE__*/
function (_KatalMetricsDriver) {
  (0, _inherits2.default)(KatalMetricsDriverSushi, _KatalMetricsDriver);

  function KatalMetricsDriverSushi(options) {
    var _this;

    (0, _classCallCheck2.default)(this, KatalMetricsDriverSushi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(KatalMetricsDriverSushi).call(this));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sushi", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "producerId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sourceGroupId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "errorHandler", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "combinedErrorHandler", function (err) {
      if (_this.errorHandler) {
        try {
          _this.errorHandler(err); // Return to avoid falling through to default error handler


          return;
        } catch (nextErr) {
          console.error("Error handling error publishing metrics:");
          console.error(nextErr); // Fall through
        }
      }

      _this.defaultErrorHandler(err);
    });
    var domain = options.domain,
        realm = options.realm,
        errorHandler = options.errorHandler,
        sushiClient = options.sushiClient,
        _options$sushiProduce = options.sushiProducer,
        producerId = _options$sushiProduce === void 0 ? KAT_STANDALONE_NEXUS_PRODUCER_ID : _options$sushiProduce,
        sushiClientOptions = options.sushiClientOptions,
        sushiClientTransportOverride = options.sushiClientTransportOverride; // custom source group always overrides defaults

    var sourceGroupId = options.sourceGroupId || KAT_STANDALONE_DEFAULT_SOURCE_GROUPS[domain] || KAT_STANDALONE_DEFAULT_SOURCE_GROUPS['test'];
    _this.sushi = sushiClient || _this.buildSushiClient(domain, realm, sourceGroupId, sushiClientOptions, sushiClientTransportOverride);
    _this.errorHandler = errorHandler;
    _this.producerId = producerId;
    _this.sourceGroupId = sourceGroupId;
    return _this;
  }

  (0, _createClass2.default)(KatalMetricsDriverSushi, [{
    key: "beforeUnload",

    /**
     * Register a callback to be called right before the page unloads. This
     * allows for any final metrics, such as page visit duration, to be sent
     * before the user navigates away from the page or closes the tab.
     * NOTE: This is an experimental API and may change in the future.
     * @param cb The callback to call.
     */
    value: function beforeUnload(cb) {
      this.sushi.onSushiUnload(cb);
    }
    /**
     * Default error handler if the user-supplied error handler fails or is unset.  Should never be called unless
     * user-provided error handler misbehaves.
     *
     * @param err Unhandled error object
     */

  }, {
    key: "defaultErrorHandler",
    value: function defaultErrorHandler(err) {
      console.error("Error publishing metrics:");
      console.error(err);
    }
    /**
     * Call the error-handler supplied by the user when this object was constructed; if that is unset or itself throws
     * an exception, calls the default error handler as a fallback, which will just log the error to the console.
     *
     * @param err Error object to handle
     */

  }, {
    key: "withErrorHandling",

    /**
     * Helper method to wrap a function in the error handler.
     *
     * @param doTheThing Function to run under the wrapper
     * @return Return value from called function
     */
    value: function withErrorHandling(doTheThing) {
      try {
        return doTheThing();
      } catch (err) {
        this.combinedErrorHandler(err);
      }
    }
  }, {
    key: "buildSushiClient",
    value: function buildSushiClient(domain, realm, sourceGroupId, sushiClientOptions, sushiClientTransportOverride) {
      if (!domain || !realm) {
        throw new Error('KatalMetricsDriverSushi requires a domain and realm to build a sushi client.');
      }

      return new _katalSushiClient.default(KatalMetricsDriverSushi.getRealmName(realm), sourceGroupId, this.combinedErrorHandler, sushiClientOptions, sushiClientTransportOverride);
    }
  }, {
    key: "publish",
    // TODO: errorHandler in this method is deprecated and is not referenced.
    // Tech debt: https://issues.amazon.com/issues/KAT-875
    value: function publish(metricObject, errorHandler, context) {
      var _this2 = this;

      // Support for new 2-argument form of publish, which does not pass the unused errorHandler object (KAT-875)
      var metricsContext = arguments.length < 3 ? arguments[1] : arguments[2];
      this.withErrorHandling(function () {
        // TODO: This logic is now moved into KatalMetricsPublisher, once everybody has that update we can remove this.
        // Tech debt: https://issues.amazon.com/issues/KAT-876
        if (_KatalMetricType.default.List === metricObject.type) {
          metricObject.metricList.forEach(function (metric) {
            _this2.publish(metric, metricsContext);
          });
          return;
        }

        var nexusSchema = _this2.mapObjectTypeToNexusSchema(metricObject.type);

        var fields = (0, _objectSpread2.default)({}, metricsContext.context, {
          metricKey: metricObject.name,
          value: metricObject.value
        });

        if (metricObject.isMonitor) {
          fields.isMonitor = true;
        } // Reset the event count back to 0, otherwise Sushi will stop publishing after 1K items (https://issues.amazon.com/issues/KAT-1534)


        _this2.sushi.reset();

        _this2.sushi.event(fields, _this2.producerId, nexusSchema, {
          "ssd": 1
        });
      });
    }
  }, {
    key: "mapObjectTypeToNexusSchema",
    value: function mapObjectTypeToNexusSchema(objectType) {
      switch (objectType) {
        case _KatalMetricType.default.String:
          return 'katal.client.metrics.String.2';

        case _KatalMetricType.default.Counter:
          return 'katal.client.metrics.Counter.3';

        case _KatalMetricType.default.Timer:
          return 'katal.client.metrics.Timer.2';

        default:
          throw new Error("Unknown type ".concat(objectType, " when publishing metric object."));
      }
    }
  }], [{
    key: "getRealmName",
    value: function getRealmName(realm) {
      switch (realm) {
        case 'NAAmazon':
        case 'USAmazon':
          return _katalSushiClient.default.REGIONS.NA;

        case 'EUAmazon':
          return _katalSushiClient.default.REGIONS.EU;

        case 'FEAmazon':
        case 'JPAmazon':
          return _katalSushiClient.default.REGIONS.FE;

        case 'CNAmazon':
          return _katalSushiClient.default.REGIONS.CN;

        default:
          // Let the SushiClient decide if this is bogus or not.
          return realm;
      }
    }
  }]);
  return KatalMetricsDriverSushi;
}(_KatalMetricsDriver2.default);

exports.KatalMetricsDriverSushi = KatalMetricsDriverSushi;
(0, _defineProperty2.default)(KatalMetricsDriverSushi, "Builder", (_temp =
/*#__PURE__*/
function () {
  function _temp() {
    (0, _classCallCheck2.default)(this, _temp);
    (0, _defineProperty2.default)(this, "context", {});
  }

  (0, _createClass2.default)(_temp, [{
    key: "withSushiClient",
    value: function withSushiClient(sushiClient) {
      this.context.sushiClient = sushiClient;
      return this;
    }
  }, {
    key: "withDomainRealm",
    value: function withDomainRealm(domain, realm) {
      this.context.domain = domain;
      this.context.realm = realm;
      return this;
    }
  }, {
    key: "withCustomProducer",
    value: function withCustomProducer(sushiProducerId) {
      this.context.sushiProducer = sushiProducerId;
      return this;
    }
  }, {
    key: "withCustomSourceGroup",
    value: function withCustomSourceGroup(sourceGroupId) {
      this.context.sourceGroupId = sourceGroupId;
      return this;
    }
  }, {
    key: "withErrorHandler",
    value: function withErrorHandler(errorHandler) {
      this.context.errorHandler = errorHandler;
      return this;
    }
  }, {
    key: "withSushiClientOptions",
    value: function withSushiClientOptions(sushiClientOptions) {
      this.context.sushiClientOptions = sushiClientOptions;
      return this;
    }
  }, {
    key: "withSushiClientTransportOverride",
    value: function withSushiClientTransportOverride(sushiClientTransportOverride) {
      this.context.sushiClientTransportOverride = sushiClientTransportOverride;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return new KatalMetricsDriverSushi(this.context);
    }
  }]);
  return _temp;
}(), _temp));

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(115);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(380)["default"];

var assertThisInitialized = __webpack_require__(196);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(383);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(193);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(115));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(194));

var _createClass2 = _interopRequireDefault(__webpack_require__(195));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * This class encapsulates two IIFEs that the Sushi library contains. A fake CSM and Window object are created and provided
 * to the functions so that they actually execute in a controlled environment away from any CSM code that might be executing
 * at the platform level within the page.
 *
 * The basic run order is the following:
 * 1. Build the mock CSM object, then build a mock Window object that references the CSM object as ue_csm
 * 2. Run the transportation-clients.js Script from SushiJavascriptClient providing the mocks. It will modify globals on the mock objects.
 * 3. Run the sushi-client.js script from SushiJavaScriptClient providing the mocks. It will create an instance of the sushi client and inject it into the CSM globals in the mocks.
 * 4. whenever event() is called, refer to the encapsulated csm object to add the event to the queue.
 */
var SushiClient =
/*#__PURE__*/
function () {
  (0, _createClass2.default)(SushiClient, null, [{
    key: "createSushiUrl",
    value: function createSushiUrl(region, sourceGroup) {
      if (!sourceGroup) {
        throw new Error("Sushi Driver was not provided with a source group.");
      }

      var domain;

      switch (region) {
        case SushiClient.REGIONS.NA:
          domain = "unagi-na";
          break;

        case SushiClient.REGIONS.EU:
          domain = "unagi-eu";
          break;

        case SushiClient.REGIONS.FE:
          domain = "unagi-fe";
          break;

        case SushiClient.REGIONS.CN:
          domain = "unagi-cn";
          break;

        default:
          throw new Error("Unrecognized region '".concat(region, "' provided to SushiClient."));
      }

      return "https://".concat(domain, ".amazon.com/1/events/").concat(sourceGroup);
    }
  }, {
    key: "createCsmUserContext",
    value: function createCsmUserContext(sushiUrl) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _objectSpread({
        hiPriFlushInterval: 1000,
        lowPriFlushInterval: 10000,
        requestId: "1",
        errorChannel: "jserr",
        sessionStorageWrapper: undefined,
        errorHandlerFunction: console.log,
        sushiUrl: sushiUrl
      }, options);
    }
    /**
     * Create a Sushi Client for a region and source group
     *
     * @param region Region in SushiClient.REGIONS
     * @param sourceGroup Sushi Eel source group
     * @param errorHandler Error handler function
     * @param options Additional CSM context overrides
     * @param clientOverride An optional transportation client for overriding the default clients (navigator.sendBeacon and XDomainRequest or XMLHttpRequest)
     */

  }, {
    key: "REGIONS",
    get: function get() {
      return {
        NA: "NA",
        EU: "EU",
        FE: "FE",
        CN: "CN"
      };
    }
  }]);

  function SushiClient() {
    var region = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SushiClient.REGIONS.NA;
    var sourceGroup = arguments.length > 1 ? arguments[1] : undefined;
    var errorHandler = arguments.length > 2 ? arguments[2] : undefined;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var clientOverride = arguments.length > 4 ? arguments[4] : undefined;
    (0, _classCallCheck2.default)(this, SushiClient);
    var sushiUrl = SushiClient.createSushiUrl(region, sourceGroup);
    var csmUserContext = SushiClient.createCsmUserContext(sushiUrl, options);
    this.ue_csm = this.setupMockCSMObject(csmUserContext);
    this.encapsulatedWindow = this.setupMockWindow(this.ue_csm);
    this.transportationClientCode(this.ue_csm, window);

    if (clientOverride) {
      this.ue_csm.ue._sBcn = {
        isSupported: true,
        send: function send(endpoint, payload) {
          clientOverride(endpoint, payload);
          return true;
        }
      };
    }

    this.clientCode(this.ue_csm, this.encapsulatedWindow);
    this.errorHandler = errorHandler;
  }

  (0, _createClass2.default)(SushiClient, [{
    key: "event",
    value: function event(data, producerId, schemaId, options) {
      var debug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (debug) {
        console.log("SushiClient wrapper publishing the following:", {
          data: data,
          producerId: producerId,
          schemaId: schemaId,
          options: options
        });
      }

      return this.ue_csm.ue.event(data, producerId, schemaId, options);
    }
    /**
     * If you plan to emit 1000 or more events per instantiated client,
     * call reset after calling event to allow the CSM client to continue sending events.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.ue_csm.ue.event.reset();
    }
    /**
     * Register a callback that will be called just before each time metrics are
     * flushed to the network.
     * @param callback A function that sushi will call before flushes.
     */

  }, {
    key: "onSushiFlush",
    value: function onSushiFlush(callback) {
      this.ue_csm.ue.onSushiFlush(callback);
    }
    /**
     * Register a callback that will be called just before the page unloads.
     * This can be used to send any final metrics to sushi, such as page visit
     * duration or batched counters.
     * @param callback A function that sushi will call before unload.
     */

  }, {
    key: "onSushiUnload",
    value: function onSushiUnload(callback) {
      this.ue_csm.ue.onSushiUnload(callback);
    }
  }, {
    key: "setupMockCSMObject",
    value: function setupMockCSMObject(csmUserContext) {
      var _this = this;

      var execStub = function execStub(callback, attribution) {
        return callback;
      };

      var eventStub = function eventStub(log, producer, eventType) {
        console.warn("SushiClient CSM stub called in unsupported manner: event()");
      };

      var errorHandler = function errorHandler(logEvent, channel) {
        if (_this.errorHandler) {
          _this.errorHandler(logEvent);
        } else {
          console.log("An error has occurred in SushiClient channel " + channel, logEvent);
        }
      };

      var attachHandler = function attachHandler(evt, handler, container) {
        //TODO might be able to just use window.ue.attach?
        container = container || window; //ok to use real window global here.

        if (window.EventTarget && window.EventTarget.prototype && window.EventTarget.prototype.addEventListener) {
          window.EventTarget.prototype.addEventListener.call(container, evt, handler, !!window.ue_clf);
        } else if (container.addEventListener) {
          container.addEventListener(evt, handler, !!window.ue_clf);
        } else if (container.attachEvent) {
          container.attachEvent("on" + evt, handler);
        }
      };

      return {
        ue_hpsi: csmUserContext.hiPriFlushInterval,
        ue_lpsi: csmUserContext.lowPriFlushInterval,
        ue: {
          ssw: csmUserContext.sessionStorageWrapper,
          log: errorHandler,
          exec: execStub,
          event: eventStub,
          attach: attachHandler
        },
        ueLogError: csmUserContext.errorHandlerFunction,
        ue_surl: csmUserContext.sushiUrl,
        ue_id: csmUserContext.requestId,
        ue_err_chan: csmUserContext.errorChannel
      };
    }
  }, {
    key: "setupMockWindow",
    value: function setupMockWindow(ue_csm) {
      //apparently cannot ref the setTimeout function directly in some browsers so we have to wrap it.
      var timeoutWrapper = function timeoutWrapper(fn, timeout) {
        return window.setTimeout(fn, timeout);
      };

      return {
        ue_csm: ue_csm,
        ueLogError: ue_csm.ueLogError,
        ue: ue_csm.ue,
        setTimeout: timeoutWrapper
      };
    }
    /**
     * Code within function pulled directly from
     * https://code.amazon.com/packages/SushiJavaScriptClient/blobs/mainline/--/javascript/sushi-client.js
     */

  }, {
    key: "clientCode",
    value: function clientCode(ue_csm, window) {
      ue_csm.ue.exec(function (b, k) {
        function A() {
          for (var a = 0; a < arguments.length; a++) {
            var c = arguments[a];

            try {
              var h;

              if (c.isSupported) {
                var b = t.buildPayload(l, e);
                h = c.send(J, b);
              } else throw dummyException;

              return h;
            } catch (d) {}
          }

          B({
            m: "All supported clients failed",
            attribution: "CSMSushiClient_TRANSPORTATION_FAIL",
            f: "sushi-client.js",
            logLevel: "ERROR"
          }, k.ue_err_chan || "jserr");
        }

        function m() {
          if (e.length) {
            for (var a = 0; a < n.length; a++) {
              n[a]();
            }

            A(d._sBcn || {}, d._ajx || {});
            e = [];
            f = {};
            l = {};
            u = v = q = w = 0;
          }
        }

        function K() {
          var a = new Date(),
              c = function c(a) {
            return 10 > a ? "0" + a : a;
          };

          return Date.prototype.toISOString ? a.toISOString() : a.getUTCFullYear() + "-" + c(a.getUTCMonth() + 1) + "-" + c(a.getUTCDate()) + "T" + c(a.getUTCHours()) + ":" + c(a.getUTCMinutes()) + ":" + c(a.getUTCSeconds()) + "." + String((a.getUTCMilliseconds() / 1E3).toFixed(3)).slice(2, 5) + "Z";
        }

        function x(a) {
          try {
            return JSON.stringify(a);
          } catch (c) {}

          return null;
        }

        function C(a, c, h, g) {
          var p = !1;
          g = g || {};
          r++;
          r == D && B({
            m: "Max number of Sushi Logs exceeded",
            f: "sushi-client.js",
            logLevel: "ERROR",
            attribution: "CSMSushiClient_MAX_CALLS"
          }, k.ue_err_chan || "jserr");
          var f;
          if (f = !(r >= D)) (f = a && -1 < a.constructor.toString().indexOf("Object") && c && -1 < c.constructor.toString().indexOf("String") && h && -1 < h.constructor.toString().indexOf("String")) || L++;
          f && (d.count && d.count("Event:" + h, 1), a.producerId = a.producerId || c, a.schemaId = a.schemaId || h, a.timestamp = K(), c = Date.now ? Date.now() : +new Date(), h = Math.random().toString().substring(2, 12), a.messageId = b.ue_id + "-" + c + "-" + h, g && !g.ssd && (a.sessionId = a.sessionId || b.ue_sid, a.requestId = a.requestId || b.ue_id, a.obfuscatedMarketplaceId = a.obfuscatedMarketplaceId || b.ue_mid), (c = x(a)) ? (c = c.length, (e.length == M || q + c > N) && m(), q += c, a = {
            data: t.compressEvent(a)
          }, e.push(a), (g || {}).n ? 0 === E ? m() : u || (u = k.setTimeout(m, E)) : v || (v = k.setTimeout(m, O)), p = !0) : p = !1);
          !p && b.ue_int && console.error("Invalid JS Nexus API call");
          return p;
        }

        function F() {
          if (!G) {
            for (var a = 0; a < y.length; a++) {
              y[a]();
            }

            for (a = 0; a < n.length; a++) {
              n[a]();
            }

            e.length && (b.ue_sbuimp && b.ue && b.ue.ssw && (a = x({
              dct: l,
              evt: e
            }), b.ue.ssw("eeldata", a), b.ue.ssw("eelsts", "unk")), A(d._sBcn || {}));
            G = !0;
          }
        }

        function H(a) {
          y.push(a);
        }

        function I(a) {
          n.push(a);
        }

        var D = 1E3,
            M = 499,
            N = 524288,
            s = function s() {},
            d = b.ue || {},
            B = d.log || s,
            P = b.uex || s;

        (b.uet || s)("bb", "ue_sushi_v1", {
          wb: 1
        });

        var J = b.ue_surl || "https://unagi-na.amazon.com/1/events/com.amazon.csm.nexusclient.gamma",
            Q = ["messageId", "timestamp"],
            z = "#",
            e = [],
            f = {},
            l = {},
            q = 0,
            w = 0,
            L = 0,
            r = 0,
            y = [],
            n = [],
            G = !1,
            u,
            v,
            E = void 0 === b.ue_hpsi ? 1E3 : b.ue_hpsi,
            O = void 0 === b.ue_lpsi ? 1E4 : b.ue_lpsi,
            t = function () {
          function a(a) {
            f[a] = z + w++;
            l[f[a]] = a;
            return f[a];
          }

          function c(b) {
            if (!(b instanceof Function)) {
              if (b instanceof Array) {
                for (var g = [], d = b.length, e = 0; e < d; e++) {
                  g[e] = c(b[e]);
                }

                return g;
              }

              if (b instanceof Object) {
                g = {};

                for (d in b) {
                  b.hasOwnProperty(d) && (g[f[d] ? f[d] : a(d)] = -1 === Q.indexOf(d) ? c(b[d]) : b[d]);
                }

                return g;
              }

              return "string" === typeof b && (b.length > (z + w).length || b.charAt(0) === z) ? f[b] ? f[b] : a(b) : b;
            }
          }

          return {
            compressEvent: c,
            buildPayload: function buildPayload() {
              return x({
                cs: {
                  dct: l
                },
                events: e
              });
            }
          };
        }();

        (function () {
          if (d.event && d.event.isStub) {
            if (b.ue_sbuimp && b.ue && b.ue.ssw) {
              var a = b.ue.ssw("eelsts").val;

              if (a && "unk" === a && (a = b.ue.ssw("eeldata").val)) {
                var c;

                a: {
                  try {
                    c = JSON.parse(a);
                    break a;
                  } catch (f) {}

                  c = null;
                }

                c && c.evt instanceof Array && c.dct instanceof Object && (e = c.evt, l = c.dct, e && l && (m(), b.ue.ssw("eeldata", "{}"), b.ue.ssw("eelsts", "scs")));
              }
            }

            d.event.replay(function (a) {
              a[3] = a[3] || {};
              a[3].n = 1;
              C.apply(this, a);
            });
            d.onSushiUnload.replay(function (a) {
              H(a[0]);
            });
            d.onSushiFlush.replay(function (a) {
              I(a[0]);
            });
          }
        })();

        d.attach("beforeunload", F);
        d.attach("pagehide", F);
        d._cmps = t;
        d.event = C;

        d.event.reset = function () {
          r = 0;
        };

        d.onSushiUnload = H;
        d.onSushiFlush = I;

        try {
          k.P && k.P.register && k.P.register("sushi-client", s);
        } catch (R) {
          b.ueLogError(R, {
            logLevel: "WARN"
          });
        }

        P("ld", "ue_sushi_v1", {
          wb: 1
        });
      }, "Nxs-JS-Client")(ue_csm, window);
    }
    /**
     * The code in this function is pulled directly from:
     * https://code.amazon.com/packages/SushiJavaScriptClient/blobs/mainline/--/javascript/transportation-clients.js
     */

  }, {
    key: "transportationClientCode",
    value: function transportationClientCode(ue_csm, window) {
      ue_csm.ue.exec(function (b, c) {
        var e = function e() {},
            f = function () {
          return {
            send: function send(b, d) {
              if (d && b) {
                var a;
                if (c.XDomainRequest) a = new XDomainRequest(), a.onerror = e, a.ontimeout = e, a.onprogress = e, a.onload = e, a.timeout = 0;else if (c.XMLHttpRequest) {
                  if (a = new XMLHttpRequest(), !("withCredentials" in a)) throw "";
                } else a = void 0;
                if (!a) throw "";
                a.open("POST", b, !0);
                a.setRequestHeader && a.setRequestHeader("Content-type", "text/plain");
                a.send(d);
              }
            },
            isSupported: !0
          };
        }(),
            g = function () {
          return {
            send: function send(c, d) {
              if (c && d) if (navigator.sendBeacon(c, d)) b.ue_sbuimp && b.ue && b.ue.ssw && b.ue.ssw("eelsts", "scs");else throw "";
            },
            isSupported: !!navigator.sendBeacon && !(c.cordova && c.cordova.platformId && "ios" == c.cordova.platformId)
          };
        }();

        b.ue._ajx = f;
        b.ue._sBcn = g;
      }, "Transportation-clients")(ue_csm, window);
    }
  }]);
  return SushiClient;
}();

exports.default = SushiClient;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsAggregator = void 0;
var MetricsAggregator = /** @class */ (function () {
    function MetricsAggregator(filterFunction) {
        var _this = this;
        this.filterFunction = filterFunction;
        this.aggregatedMetrics = {};
        window.addEventListener('katal.metrics.publish', function (event) {
            _this.aggregateMetric(event);
        });
    }
    MetricsAggregator.prototype.aggregateMetric = function (event) {
        var _a = event.detail, metric = _a.metric, context = _a.context;
        var serviceName = context.serviceName, methodName = context.methodName;
        if (this.filterFunction && !this.filterFunction(metric, context)) {
            return;
        }
        this.aggregatedMetrics[serviceName] =
            this.aggregatedMetrics[serviceName] || {};
        this.aggregatedMetrics[serviceName][methodName] =
            this.aggregatedMetrics[serviceName][methodName] || {};
        this.aggregatedMetrics[serviceName][methodName][metric.name] =
            this.aggregatedMetrics[serviceName][methodName][metric.name] || [];
        this.aggregatedMetrics[serviceName][methodName][metric.name].push(metric.value);
    };
    return MetricsAggregator;
}());
exports.MetricsAggregator = MetricsAggregator;
//# sourceMappingURL=metrics-aggregator.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(387);
var v4 = __webpack_require__(388);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(197);
var bytesToUuid = __webpack_require__(198);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(197);
var bytesToUuid = __webpack_require__(198);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CapabilityReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__ = __webpack_require__(66);
var CapabilityReducer=function CapabilityReducer(state,action){switch(action.type){case"GET_CAPABILITIES":return Object.assign({},state,action.data);case"GET_STATION_CONFIG":var _action$data=action.data,dispatcher=_action$data.dispatcher,baseUrl=_action$data.baseUrl;Object(__WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__["a" /* fetchNodeConfig */])(dispatcher,baseUrl);return state;case"RECEIVE_STATION_CONFIG":return Object.assign({},state,action.data);case"RECEIVE_REFRESH_INTERVAL":return Object.assign({},state,{stationConfig:Object.assign({},state.stationConfig,{refreshInterval:action.data.refreshInterval})});default:return state;}};

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StageFilterReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__ = __webpack_require__(37);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var StageFilterReducer=function StageFilterReducer(state,action){switch(action.type){case"RECEIVE_FILTER_DATA":{var newState=Object.assign({},state,{data:Object.assign({},state.data,action.data)});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],newState);return newState;}case"SELECT_CLUSTER":{var _newState=Object.assign({},state,{cluster:action.Cluster});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState);return _newState;}case"SELECT_DRIVER_TYPE":{var _newState2=Object.assign({},state,{driverType:action.DriverType});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState2);return _newState2;}case"SELECT_STATUS":{var _newState3=Object.assign({},state,{status:action.status});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState3);return _newState3;}case"SELECT_DEPARTURE":{var _newState4=Object.assign({},state,{departure:action.Departure});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState4);return _newState4;}case"SELECT_VIEW_TYPE":{var _newState5=Object.assign({},state,{viewType:action.viewType});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState5);return _newState5;}case"SELECT_STAGE_TAB_VIEW_TYPE":{return Object.assign({},state,{stageTabViewType:action.stageTabViewType});}case"UNLOAD_VIEW":return state;case"REMOVE_ALL_FILTER":{var _newState6=Object.assign({},state);Object.entries(state).forEach(function(entry){var key=entry[0];var values=entry[1];if(Array.isArray(values)&&values.length&&key!=='data'){_newState6[key]=[];}});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState6);return _newState6;}case"REMOVE_FILTER":{var _action$data=action.data,key=_action$data.key,value=_action$data.value;state[key]=state[key].filter(function(item){return item!==value;});var newItem=state[key].filter(function(item){return item!==value;});var _newState7=Object.assign({},state,_defineProperty({},key,newItem));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState7);return _newState7;}case"LOAD_XPT_NODES":var _action$data2=action.data,dispatcher=_action$data2.dispatcher,baseUrl=_action$data2.baseUrl,capability=_action$data2.capability,stationConfig=_action$data2.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_StageNetworkAPI__["d" /* fetchSubStations */])(dispatcher,baseUrl,capability,__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],stationConfig);return state;case"RECEIVE_XPT_NODES":{var xptNodes=action.data.xptNodes;var savedState=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["E" /* readFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */]);var _newState8=Object.assign({},state,{xptNodes:xptNodes,data:Object.assign({},state.data,{xptNodes:xptNodes})});if(savedState){_newState8=Object.assign({},state,{data:Object.assign({},state.data,{xptNodes:xptNodes})});}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState8);return _newState8;}case"SELECT_XPT_NODE":{var _newState9=Object.assign({},state,{xptNodes:action.xptNodes});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState9);return _newState9;}case"SELECT_STAGE_LOCATION_TYPE":{var _newState10=Object.assign({},state,{stageLocationType:action.stageLocationType});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */],_newState10);return _newState10;}case"LOAD_FILTERS":{var _savedState=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["E" /* readFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["c" /* STAGE_FILTER_STATE_KEY */]);if(_savedState){return Object.assign({},state,_savedState);}return state;}default:return state;}};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_AlertView__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routeStageStatus_RouteStageTable__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StageOverallStatus__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StageFilter__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StageViewSelector__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StageOverallStatusV2__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__associate_context_AssociateContextProvider__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__associate_AssociateDetailView__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_PageHeader__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StageFilterV2Wrapper__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_MobileDisplay__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__StageTabViewSelector__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PlanManagementView__ = __webpack_require__(684);
var StageView=function StageView(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel,configDispatch=_useContext.configDispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__associate_context_AssociateContextProvider__["a" /* AssociateContext */]),associateViewModel=_useContext2.associateViewModel;var stationCode=Object(__WEBPACK_IMPORTED_MODULE_13__network_NetworkUtil__["a" /* getStationCode */])();var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_18__context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext3.viewModelF;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["A" /* logCounterMetric */])(stationCode,__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["m" /* RSWS_GET_CONFIG */]);Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["c" /* getDocumentURL */])(),Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["f" /* getNodeCapability */])()]).then(function(result){//const result = ["https://logistics-co-uk-preprod.amazon.com",{capability: "\""+CORE_AMZL+"\""}];
var model={capability:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["D" /* parseCapabilitiesResponse */])(result[1]),baseUrl:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["j" /* getBaseUrl */])(result[0])};configDispatch({type:'GET_CAPABILITIES',data:model});configDispatch({type:'GET_STATION_CONFIG',data:{dispatcher:configDispatch,baseUrl:model.baseUrl}});});},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(configViewModel.capability!==''&&configViewModel.stationConfig.initialised){Object(__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["A" /* logCounterMetric */])(stationCode,__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_6__util_MetricUtil__["n" /* RSWS_GET_STATION_CONFIG_SUCCESS */]);}},[configViewModel.stationConfig.initialised]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,configViewModel.capability!==''&&configViewModel.stationConfig.initialised?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__alert_AlertView__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__StageTabViewSelector__["a" /* default */],null),associateViewModel.associate.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_PageHeader__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10__util_Constants__["t" /* PAGE_HEADERS */].STAGE):null,viewModelF.stageTabViewType===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["u" /* PLAN_MANAGEMENT_VIEW */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__PlanManagementView__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__StageFilterV2Wrapper__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StageFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_10__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StageOverallStatusV2__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StageOverallStatus__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StageViewSelector__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__routeStageStatus_RouteStageTable__["a" /* default */],{history:props.history})," ")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__associate_AssociateDetailView__["a" /* default */],null)):null);};/* harmony default export */ __webpack_exports__["a"] = (StageView);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
var AlertView=function AlertView(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var removeNotification=function removeNotification(){dispatch({type:'REMOVE_NOTIFICATION'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,viewModel.alert.title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-8"],spacingInset:"large large none",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{onClose:function onClose(){return removeNotification();},size:"medium",type:viewModel.alert.type},viewModel.alert.title)):null);};/* harmony default export */ __webpack_exports__["a"] = (AlertView);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridColumns = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _box = _interopRequireDefault(__webpack_require__(69));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _parsers = __webpack_require__(57);

var _functional = __webpack_require__(19);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _rtl = __webpack_require__(39);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values

exports.gridColumns = gridColumns;

var parseWidth = function parseWidth(width) {
  return typeof width === "string" && /^grid-/.test(width) ? {
    type: "grid",
    // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
    // "grid-4" to 0.3333)
    value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
  } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
    type: "percentage",
    // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
    // to 0.3333)
    value: Math.floor(100 * parseFloat(width)) / 10000
  } : width === "fit" || width === "fill" ? {
    type: "flex",
    value: width
  } : width !== undefined && width !== null && width !== "" ? {
    type: "css",
    value: width
  } : {
    type: "empty",
    value: null
  };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)


var wrapContainerStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch"
});

var rowStyles = function rowStyles(widths) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var wrap = _ref.wrap,
        spacing = _ref.spacing,
        alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        reverse = _ref.reverse;
    var spacingValues = (0, _parsers.parseSpacing)(spacing);
    var verticalSpacing = spacingValues[0];
    var horizontalSpacing = spacingValues[1] || verticalSpacing;
    return (0, _emotion.css)((_css = {
      width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
      display: "flex",
      flexDirection: reverse ? "row-reverse" : "row",
      flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
      alignItems: {
        top: "flex-start",
        bottom: "flex-end"
      }[alignmentVertical] || alignmentVertical,
      justifyContent: {
        left: "flex-start",
        right: "flex-end",
        justify: "space-between"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)] || (0, _rtl.getHorizontalDirection)(alignmentHorizontal),
      // Reset the extra margins caused by the children on the right/bottom
      // edges. We can't do a simple reset on the first/last child because
      // there may be any number of children on the right/bottom edges if the
      // row wraps.
      margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      margin: wrap === "none" ? undefined : "0 0 ".concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " -").concat(horizontalSpacing, "px")
    }), (0, _defineProperty2["default"])(_css, "& > *", (0, _defineProperty2["default"])({
      // Make sure that any borders or padding applied to the child don't throw
      // of the widths that we apply
      boxSizing: "border-box !important",
      // Set margins for horizontal spacing and vertical spacing if the row is
      // allowed to wrap (and clear other margins)
      margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
    }, "[dir=\"rtl\"] &", {
      margin: "0 0 ".concat(wrap === "none" ? 0 : verticalSpacing, "px ").concat(horizontalSpacing, "px !important")
    })), (0, _defineProperty2["default"])(_css, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginRight: "0 !important"
    } : undefined), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginLeft: "0px !important"
    } : undefined), _css), // If we've got an array of widths, apply each width to the child whose
    // index in the dom matches the widths's index in the array. If we've
    // got a single height, apply that to all children.
    Array.isArray(widths) ? widths.reduce(function (result, width, index) {
      result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
        width: width,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      });
      return result;
    }, {}) : {
      "& > *": childStyles({
        width: widths,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      })
    });
  }, ["wrap", "spacing", "alignmentHorizontal", "alignmentVertical", "reverse"]);
};

var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);

var childStyles = function childStyles(_ref2) {
  var rawWidth = _ref2.width,
      wrap = _ref2.wrap,
      horizontalSpacing = _ref2.horizontalSpacing;
  var width = parseWidth(rawWidth);
  return {
    // Stretch the child to fill remaining space if the width is "fill"
    flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
    // Ensure that the child isn't smashed by flexbox if it has an explicit
    // width set.
    flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
    width: width.type === "grid" || width.type === "percentage" ? // For percentage widths (or grid widths), set the element to the
    // specified percentage of the row's width (e.g. 50%) but subtract the
    // gutter spacing from the width to ensure there's enough room for the
    // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
    // subtract the full gutter width since each element has a full gutter
    // to its right (the extra gutter on the right edge of the row is
    // removed with a negative margin on the parent element). For rows
    // that don't wrap the last element doesn't have a gutter to its
    // right, so things are a bit more complicated. In this case there's
    // one less gutter than there are elements in the row (e.g. 3 elements
    // have 2 gutters between them) so subtracting a full gutter from each
    // element's width would be too much. We have to spread out this saved
    // saved gutter space proportional to the percentage of the row that
    // the element takes up. For example if a row has two elements that
    // each take up 50% of the row with a single 16px gutter between them,
    // then we'd subtract 50% of the 16px gutter from each element giving
    // us a final width of 50% - 8px for each element.
    "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? // If the size is a plain CSS value then just use that directly
    "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : // And lastly for fit, fill, or empty values leave it up to flexbox
    undefined
  };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */


var Row = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // A row with an explicit height cannot wrap
  var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
  // for the "widths" property

  var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
  var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
    wrap: wrap
  })); // Apply the row styles to an extra div inside the box so margins that are
  // applied to the box (e.g. if the row is nested in another row) don't
  // conflict with the margins that are applied by `rowStyles`.

  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
    ref: ref
  }), wrap === "none" ? props.children : /*#__PURE__*/_react["default"].createElement("div", {
    className: rowStyles
  }, props.children));
});

Row.displayName = "Row";
Row.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the row.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * Specify the vertical alignment of the elements inside the row.
   *
   * @since 5.x
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "stretch", "baseline"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a row. Any elements can be supplied here, although if
   * only one child is supplied the row will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * If set to true this will reverse the order in which the elements in the row
   * are rendered (the first element will be rendered where the last normally
   * would, and vice-versa).
   */
  reverse: _propTypes["default"].bool,

  /**
   * Set the spacing between elements in the row using a preset.
   *
   * Two spacing values are allowed (separated by a space) if the `wrap` prop is
   * set. In this case the first value will be used as the vertical spacing
   * between elements and the second value will be used as the horizontal
   * spacing.
   */
  spacing: _propTypes2["default"].spacing(2),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the row using one of Meridian's Box component styles.
   * If omitted the row will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of each element in the row.
   *
   * If a single width is provided then it will be applied to every element in
   * the row. If an array of widths is provided then each width will be
   * applied to the element in the row that exists at the same index as the
   * width in the array (e.g. `[<element 0 width>, <element 1 width>, null, <element 3 width>]`).
   *
   * The possible values for each width are:
   *   - `number` - A fixed pixel width.
   *   - `string` - Any valid CSS width.
   *   - `"fit"` - The element's width will shrink to fit its contents.
   *   - `"fill"` - The element's width will fill all remaining space in the row.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the row equally.
   *   - `"grid-<x>"` - The element will take up "x" grid units on a 12-column grid
   *     ("x" can be 1-12).
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set this to allow elements that overflow the width of the row to wrap. If
   * this is set to `"down"` then elements that overflow to the right will wrap
   * down below the other elements. If set to `"up"` then the overflowing
   * elements will wrap up above the other elements.
   *
   * NOTE: Negative margins are used internally in order to maintain the correct
   * gutter spacing between elements that wrap ([this technique is recommended by MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)).
   * This can cause unwanted horizontal scrolling if the inset spacing of the
   * row is less than the gutter spacing *and* the row is placed in a parent that
   * allows overflow. To resolve this you can either increase the padding/margin
   * around the row (using the `insetSpacing` prop of the row or by applying
   * padding/margin to an element that wraps the row) or turn off the
   * overflow on the row's parent element (by applying an `overflow: hidden`
   * style). You can also turn off wrapping on the row or consider using custom
   * styles to build a layout with something like [CSS grid](https://css-tricks.com/snippets/css/complete-guide-grid/).
   */
  wrap: _propTypes["default"].oneOf(["up", "down", "none"])
} : {};
Row.defaultProps = {
  wrap: "none",
  spacing: "medium",
  alignmentVertical: "center",
  alignmentHorizontal: "start"
};
var _default = Row;
exports["default"] = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(395);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_cache__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_serialize__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_utils__ = __webpack_require__(405);




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_cache__["a" /* default */])(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["b" /* insertStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: __WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */].bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(400);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(404);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _box = _interopRequireDefault(__webpack_require__(407));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _theme = __webpack_require__(7);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _box2 = __webpack_require__(414);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */
var Box = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return (// Only pull in theme tokens if we're styling the box
    props.backgroundColor || props.type ? /*#__PURE__*/_react["default"].createElement(ThemedBox, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }), props.children) : /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
      className: (0, _cxMemoized["default"])((0, _box2.styles)(props), props.className),
      id: props.id,
      tabIndex: props.tabIndex,
      ref: ref
    }), props.children)
  );
});

Box.displayName = "Box";
Box.propTypes = {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The elements to render inside the box.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.20.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Box.defaultProps = {
  tag: "div",
  spacingInset: "none"
};
/* eslint-disable react/prop-types */

/**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */

var ThemedBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_box["default"], "box");
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
    className: (0, _cxMemoized["default"])((0, _box2.themedStyles)(t)(props), props.className),
    id: props.id,
    tabIndex: props.tabIndex,
    ref: ref
  }), props.children);
});

ThemedBox.displayName = "ThemedBox";
/* eslint-enable react/prop-types */

var _default = Box;
exports["default"] = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    boxBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    boxBackgroundColorFill: tokens.themeBackgroundSecondaryDefault,
    boxBorderWidth: 1,
    boxBorderRadiusOutline: 4,
    boxBorderRadiusFill: 4,
    boxBorderColorOutline: tokens.themeBorderSecondaryDefault
  }
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var shim = function shim() {};

shim.isRequired = shim;

var getShim = function getShim() {
  return shim;
}; // Important!
// Keep this list in sync with production version in `./_prop-types.js`.


var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
  size: size,
  flexAlignment: flexAlignment,
  spacing: spacing,
  alignment: alignment
};
exports["default"] = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _emotion = __webpack_require__(4);

/**
 * Global styles
 */
(0, _emotion.injectGlobal)({
  /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */
  "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
    body: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale"
    }
  },

  /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */
  "main, nav, header, footer": {
    display: "block"
  }
});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = Style;
exports.useTheme = exports["default"] = exports.ThemeContext = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _blueLight = _interopRequireDefault(__webpack_require__(199));

var _getColorSchemeFromTokens = _interopRequireDefault(__webpack_require__(411));

var _useColorScheme = __webpack_require__(201);

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Context for passing theme tokens down the tree.
 */
var ThemeContext = /*#__PURE__*/(0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */

exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function (a, b) {
  return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */

var applyTheme = (0, _functional.memoizeCurry)(function (themeTokens, tokens) {
  return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */

var useTheme = function useTheme(tokens) {
  var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var themeTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = applyTheme(themeTokens)(tokens);
  return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */


exports.useTheme = useTheme;

function Theme(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children;
  var contextTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = mergeTokens(contextTokens)(tokens);
  var colorScheme = (0, _getColorSchemeFromTokens["default"])(currentTokens);
  return /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: currentTokens
  }, /*#__PURE__*/_react["default"].createElement(_useColorScheme.ColorSchemeContext.Provider, {
    value: colorScheme
  }, children));
}

Theme.propTypes =  false ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * An object of theme tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].string)])).isRequired
} : {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */

function Style(_ref2) {
  var tokens = _ref2.tokens,
      map = _ref2.map,
      children = _ref2.children;
  return children(useTheme(tokens, "", map || true));
}

Style.propTypes = {
  children: _propTypes["default"].func.isRequired,
  map: _propTypes["default"].func,
  tokens: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = Theme;
exports["default"] = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _blueDark = _interopRequireDefault(__webpack_require__(200));

// The pivotal token used to determine if a set of tokens are "dark" or "light"
var themeBackgroundPrimaryDefault = _blueDark["default"].themeBackgroundPrimaryDefault;
/**
 * Returns if a tokens object represents a "light" or "dark" color scheme
 */

var getColorSchemeFromTokens = function getColorSchemeFromTokens(tokens) {
  return tokens.themeBackgroundPrimaryDefault === themeBackgroundPrimaryDefault ? "dark" : "light";
};

var _default = getColorSchemeFromTokens;
exports["default"] = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _upperFirst = _interopRequireDefault(__webpack_require__(202));

var pascalCase = function pascalCase(strings) {
  return strings.map(_upperFirst["default"]).join("");
};

var _default = pascalCase;
exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var lowerFirst = function lowerFirst(str) {
  return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};

var _default = lowerFirst;
exports["default"] = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themedStyles = exports.styles = exports.cardStyles = void 0;

var _emotion = __webpack_require__(4);

var _text = _interopRequireDefault(__webpack_require__(22));

var _functional = __webpack_require__(19);

var _borderRadius = _interopRequireDefault(__webpack_require__(117));

var _token = __webpack_require__(8);

var _parsers = __webpack_require__(57);

var cardStyles = (0, _functional.memoize)(function (c) {
  var borderRadius = c("borderRadius");
  var imageBorderRadius = borderRadius - c("borderWidth");
  return (0, _emotion.css)((0, _text["default"])(c), {
    border: c.borderCss("border"),
    borderRadius: borderRadius,
    boxShadow: c.boxShadowCss("dropShadowDefault"),
    position: "relative",
    "& > *[role=img]": {
      borderRadius: (0, _borderRadius["default"])(imageBorderRadius, ["topLeft", "topRight"])
    }
  });
});
exports.cardStyles = cardStyles;
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      borderRadius = _ref.borderRadius,
      width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      spacingInset = _ref.spacingInset;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    // If we have a border radius defined then clip content so that it doesn't
    // bleed out the corners
    overflow: borderRadius ? "hidden" : undefined,
    overflowX: overflowX ? overflowX : undefined,
    overflowY: overflowY ? overflowY : undefined,
    padding: (0, _parsers.parseSpacing)(spacingInset).map(function (value) {
      return "".concat(value, "px");
    }).join(" "),
    borderStyle: borderWidth && borderColor ? "solid" : undefined,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  });
}, ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
exports.styles = styles;
var themedStyles = (0, _functional.memoize)(function (t) {
  return (0, _functional.memoizeByKeys)(function (_ref2) {
    var type = _ref2.type,
        backgroundColor = _ref2.backgroundColor,
        width = _ref2.width,
        height = _ref2.height,
        minWidth = _ref2.minWidth,
        minHeight = _ref2.minHeight,
        maxWidth = _ref2.maxWidth,
        maxHeight = _ref2.maxHeight,
        overflowX = _ref2.overflowX,
        overflowY = _ref2.overflowY,
        spacingInset = _ref2.spacingInset;
    return styles({
      backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [backgroundColor, "default"]) || backgroundColor : t("backgroundColor", type),
      borderColor: t("borderColor", type),
      borderWidth: t("borderWidth"),
      borderRadius: t("borderRadius", type),
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      overflowX: overflowX,
      overflowY: overflowY,
      spacingInset: spacingInset
    });
  }, ["type", "backgroundColor", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
});
exports.themedStyles = themedStyles;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  spacing100: 2,
  spacing200: 4,
  spacing300: 8,
  spacing400: 16,
  spacing450: 24,
  spacing500: 32,
  spacing600: 64,
  spacingNone: 0,
  spacingXxsmall: 2,
  spacingXsmall: 4,
  spacingSmall: 8,
  spacingMedium: 16,
  spacingLarge: 32,
  spacingXlarge: 64
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _alert = _interopRequireDefault(__webpack_require__(423));

var _alertErrorXlarge = _interopRequireDefault(__webpack_require__(424));

var _alertErrorLarge = _interopRequireDefault(__webpack_require__(425));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(426));

var _alertInformationalLarge = _interopRequireDefault(__webpack_require__(427));

var _alertInformationalSmall = _interopRequireDefault(__webpack_require__(428));

var _alertSuccessXlarge = _interopRequireDefault(__webpack_require__(429));

var _alertSuccessLarge = _interopRequireDefault(__webpack_require__(430));

var _alertSuccessSmall = _interopRequireDefault(__webpack_require__(431));

var _alertWarningXlarge = _interopRequireDefault(__webpack_require__(432));

var _alertWarningLarge = _interopRequireDefault(__webpack_require__(433));

var _alertWarningSmall = _interopRequireDefault(__webpack_require__(434));

var _close = _interopRequireDefault(__webpack_require__(83));

var _theme = __webpack_require__(7);

var _button = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _token = __webpack_require__(8);

var _focus = __webpack_require__(93);

var _getIconCss = _interopRequireDefault(__webpack_require__(86));

var _text = _interopRequireDefault(__webpack_require__(22));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var iconTokens = {
  small: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  medium: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  large: {
    error: _alertErrorLarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessLarge["default"],
    warning: _alertWarningLarge["default"]
  },
  xlarge: {
    error: _alertErrorXlarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessXlarge["default"],
    warning: _alertWarningXlarge["default"]
  }
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css2;

  var size = _ref.size,
      type = _ref.type,
      toast = _ref.toast,
      width = _ref.width;
  var borderWidth = t("borderWidth", size);
  var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
  return (0, _emotion.css)((_css2 = {
    /**
     * Container styles
     */
    boxSizing: "border-box",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    alignItems: size === "xlarge" ? "center" : "flex-start",
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderColor: t("borderColor", type),
    borderStyle: borderWidth ? "solid" : undefined,
    borderRadius: t("borderRadius"),
    padding: t("spacingInset", size),
    width: width,
    boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingHorizontal", size),
      marginRight: "0"
    }
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] & > * + *", {
    marginRight: t("spacingHorizontal", size),
    marginLeft: "0"
  }), (0, _defineProperty2["default"])(_css2, "& > [role=img]", {
    flexShrink: 0,
    alignSelf: size === "xlarge" ? "center" : "stretch",
    backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [size, type])),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: icon.width,
    // This ensures that the icon is vertically centered on the first line of
    // text for single-line alerts and on the first two lines of text for
    // multi-line alerts.
    minHeight: icon.height,
    maxHeight: icon.height * 2
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-text]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["message", size],
    fontWeight: "body",
    // TODO: This token should be renamed to "message"
    lineHeight: ["message", size]
  }), {
    textAlign: size === "xlarge" ? "center" : "initial",
    color: t("foregroundColor", [size, type]),
    flex: "auto",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    // Allow the message to wrap below the title if it's too long to fit.
    flexWrap: "wrap"
  })), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-title]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["title", size],
    fontWeight: "title",
    lineHeight: ["title", size]
  }), (0, _defineProperty2["default"])({
    color: t("foregroundColor", [size, type]),
    flexShrink: 0,
    fontWeight: t("fontWeightTitle"),
    // Fallback to "0" for margin-top to cancel out default browser stylings
    // on heading elements
    marginTop: t("spacingVertical", size) || 0,
    marginBottom: 0,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // marginInlineEnd: t("titleSpacingRight", size),
    marginRight: t("titleSpacingRight", size),
    marginLeft: 0
  }, "[dir=\"rtl\"] &", {
    marginLeft: t("titleSpacingRight", size),
    marginRight: 0
  }))), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-message]", {
    margin: 0,
    marginTop: t("spacingVertical", size),
    // Make the message fill the whole width of the alert, but keep it on
    // the same line as the title until it has to wrap.
    flex: "auto",
    flexShrink: 0,
    maxWidth: "100%"
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-link]", {
    color: "".concat(t("linkColor", [size]), " !important"),
    textDecoration: size === "medium" || size === "large" ? "underline !important" : undefined
  }), _css2));
}, ["size", "type", "toast", "width"]);

var closeButtonStyles = function closeButtonStyles(t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "xlarge" ? (0, _defineProperty2["default"])({
    position: "absolute",
    top: t("closeButtonSpacing", size),
    right: t("closeButtonSpacing", size)
  }, "[dir=\"rtl\"] &", {
    right: "auto",
    left: t("closeButtonSpacing", size)
  }) : (0, _defineProperty2["default"])({
    flexShrink: 0,
    margin: t("closeButtonSpacing", size) - t("spacingInset", size),
    // HACK: Since we specify marginLeft/Right for the & > * + * style above
    // to accommodate IE11 we have to overwrite them with !important here.
    // If/when we drop IE11 we can simplify these styles to be:
    // marginInlineStart: t("spacingHorizontal", size),
    marginLeft: "".concat(t("spacingHorizontal", size), "px !important"),
    marginRight: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }, "[dir=\"rtl\"] &", {
    marginRight: "".concat(t("spacingHorizontal", size), "px !important"),
    marginLeft: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }));
};

var AlertTitle = function AlertTitle(_ref5) {
  var level = _ref5.level,
      children = _ref5.children,
      id = _ref5.id;
  var Tag = level ? "h".concat(level) : "div";
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    "mdn-alert-title": "",
    id: id
  }, children);
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */


function Alert(props) {
  var t = (0, _theme.useTheme)(_alert["default"], "alert");
  var idPrefix = (0, _react.useMemo)(function () {
    return props.id || (0, _uniqueId["default"])("alert-");
  }, [props.id]);
  var node = (0, _react.useRef)();
  var big = props.size === "large" || props.size === "xlarge";
  var title = big ? props.title : undefined;
  var titleId = title ? "".concat(idPrefix, "-title") : undefined;
  var childrenId = "".concat(idPrefix, "-children");
  var showCloseButton = props.onClose && props.size !== "small";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]); // If autoFocus is true then focus on the first interactive element in the
  // alert. This'll either be the first action rendered by the user or the
  // alert's close button if there are no actions.

  var autoFocus = props.autoFocus,
      inaccessibleAutoFocus = props.inaccessibleAutoFocus;
  (0, _react.useEffect)(function () {
    if (autoFocus || inaccessibleAutoFocus) {
      var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current),
          _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1),
          firstFocusNode = _getKeyboardFocusNode2[0];

      if (firstFocusNode) {
        firstFocusNode.focus();
      }
    }
  }, [autoFocus, inaccessibleAutoFocus]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    className: styles(t, props),
    ref: autoFocus || inaccessibleAutoFocus ? node : undefined,
    role: showCloseButton ? "alertdialog" : "alert",
    "aria-labelledby": titleId,
    "aria-describedby": childrenId,
    id: idPrefix
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-text": ""
  }, title ? /*#__PURE__*/_react["default"].createElement(AlertTitle, {
    id: titleId,
    level: props.titleLevel
  }, title) : null, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-alert-message": "",
    id: childrenId
  }, props.children)), showCloseButton ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: big ? "medium" : "small",
    onClick: props.onClose,
    backdropColor: t("backgroundColor", [props.size, props.type]),
    className: closeButtonStyles(t, props),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null);
}

Alert.propTypes =  false ? {
  /**
   * The main message to be shown in the alert. Any elements are allowed, but
   * plain text and links are recommended. Meridian [links](https://meridian.a2z.com/components/link/?platform=react-web)
   * will be underlined and use the primary font color.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Alert component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-labelledby | aria-describedby
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the alert's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.22.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.21.0
   */
  id: _propTypes["default"].string,

  /**
   * Automatically focus on the alert when it's presented. The first interactive
   * element rendered in the alert will be focused, otherwise the alert's close
   * button will be focused. This will have no effect if the alert does not
   * contain any interactive elements.
   *
   * Use this when presenting an urgent alert that should grab the user's focus.
   * This will disrupt the user's current task, so use this with caution.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset. Note that this also
   * affects the layout of the alert and the availability of other props (namely
   * `title` and `onClose`).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * A text-only title to display before the main message. This is only
   * available for alerts with `size` set to `"large"` or `"xlarge"`.
   */
  title: _propTypes["default"].string,

  /**
   * The title heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements)
   * and, if set, will render the Alert title in a heading component. For example,
   * setting `titleLevel={2}` will render the Alert title in an `<h2>` element.
   *
   * You should chose a level based on the Alerts markup position and the documents
   * current heading structure ([lean more](https://www.w3.org/TR/2016/REC-html51-20161101/sections.html#headings-and-sections)). This will make it easier for
   * screen reader users to quickly make sense of the page's structure.
   *
   * For example, if the Alert is intended for the entire page, a `titleLevel={1}`
   * could be warranted. If the Alert is only relevant to a particular section
   * that was titled with a `<Heading level={3}/>`, a `titleLevel={3}` would be
   * a better choice.
   *
   * Because we cannot safely presume the heading structure of your page we do not
   * set a default value. If `titleLevel` is left unset, the title will render
   * in a `<div>` element.
   *
   * @since 5.21.0
   */
  titleLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),

  /**
   * Use this to indicate that the Alert is being used to display a toast
   * message. A drop shadow will be rendered behind the alert's body. This is
   * only applicable to "medium" and "large" alerts.
   *
   * This prop is intended to be used in tandem with the [Toaster](https://meridian.a2z.com/components/toaster/?platform=react-web) component.
   */
  toast: _propTypes["default"].bool,

  /**
   * The type of message that is being communicated with the alert. See the
   * design guidelines for recommendations regarding which type to use.
   */
  type: _propTypes["default"].oneOf(["error", "warning", "success", "informational"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a function is supplied here then a dismiss button will be rendered in
   * the alert. The function will be called when the dismiss button is clicked.
   * The function will not receive any arguments.
   *
   * This only applies to alerts that are not size small. For alert with `size`
   * set to `"xlarge"` the dismiss button will be placed in the top right of
   * the closest parent element of the alert with non-static positioning.
   */
  onClose: _propTypes["default"].func
} : {};
Alert.defaultProps = {
  size: "large",
  type: "informational",
  closeLabel: "Dismiss"
};
AlertTitle.propTypes =  false ? {
  children: Alert.propTypes.title,
  id: _propTypes["default"].string,
  level: Alert.propTypes.titleLevel
} : {};
var _default = Alert;
exports["default"] = _default;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 419 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(82),
    arrayMap = __webpack_require__(120),
    isArray = __webpack_require__(40),
    isSymbol = __webpack_require__(92);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(82);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    alertMobileFontSizeTitleSmall: 14,
    alertMobileFontSizeTitleMedium: 14,
    alertMobileFontSizeTitleLarge: 16,
    alertMobileFontSizeTitleXlarge: 24,
    alertMobileFontSizeMessageSmall: 14,
    alertMobileFontSizeMessageMedium: 14,
    alertMobileFontSizeMessageLarge: 16,
    alertMobileFontSizeMessageXlarge: 16,
    alertMobileLineHeightTitleSmall: "16px",
    alertMobileLineHeightTitleMedium: "16px",
    alertMobileLineHeightTitleLarge: "24px",
    alertMobileLineHeightTitleXlarge: "32px",
    alertMobileLineHeightMessageSmall: "16px",
    alertMobileLineHeightMessageMedium: "16px",
    alertMobileLineHeightMessageLarge: "24px",
    alertMobileLineHeightMessageXlarge: "24px",
    alertMobileMessageSpacingInsetHorizontalLarge: 15,
    alertMobileMessageSpacingInsetVerticalLarge: 8,
    alertMobileCloseButtonSpacingLarge: 3,
    alertBackgroundColorMediumError: "#F9D5E2",
    alertBackgroundColorMediumWarning: "#FEF2B8",
    alertBackgroundColorMediumSuccess: "#DCF3A0",
    alertBackgroundColorMediumInformational: "#F0F1F2",
    alertBackgroundColorLargeError: "#F9D5E2",
    alertBackgroundColorLargeWarning: "#FEF2B8",
    alertBackgroundColorLargeSuccess: "#DCF3A0",
    alertBackgroundColorLargeInformational: "#F0F1F2",
    alertForegroundColorSmallDefault: tokens.themeForegroundPrimaryDefault,
    alertForegroundColorSmallError: tokens.themeForegroundPrimaryError,
    alertForegroundColorMediumDefault: "#232F3E",
    alertForegroundColorLargeDefault: "#232F3E",
    alertForegroundColorXlargeDefault: tokens.themeForegroundPrimaryDefault,
    alertLinkColorMedium: "#232F3E",
    alertLinkColorLarge: "#232F3E",
    alertFontSizeTitleSmall: 14,
    alertFontSizeTitleMedium: 14,
    alertFontSizeTitleLarge: 16,
    alertFontSizeTitleXlarge: 24,
    alertFontSizeMessageSmall: 14,
    alertFontSizeMessageMedium: 14,
    alertFontSizeMessageLarge: 16,
    alertFontSizeMessageXlarge: 16,
    alertFontWeightTitle: 600,
    alertFontWeightBody: 400,
    alertLineHeightTitleSmall: "16px",
    alertLineHeightTitleMedium: "16px",
    alertLineHeightTitleLarge: "24px",
    alertLineHeightTitleXlarge: "32px",
    alertLineHeightMessageSmall: "16px",
    alertLineHeightMessageMedium: "16px",
    alertLineHeightMessageLarge: "24px",
    alertLineHeightMessageXlarge: "24px",
    alertBorderWidthMedium: 1,
    alertBorderWidthLarge: 1,
    alertBorderRadius: 4,
    alertBorderColorError: "#CC0C39",
    alertBorderColorWarning: "#DCB700",
    alertBorderColorSuccess: "#98C91E",
    alertBorderColorInformational: "#BBC0C1",
    alertSpacingInsetMedium: 8,
    alertSpacingInsetLarge: 15,
    alertSpacingInsetXlarge: 15,
    alertSpacingHorizontalSmall: 8,
    alertSpacingHorizontalMedium: 8,
    alertSpacingHorizontalLarge: 16,
    alertSpacingHorizontalXlarge: 0,
    alertCloseButtonSpacingMedium: 0,
    alertCloseButtonSpacingLarge: 7,
    alertCloseButtonSpacingXlarge: 7,
    alertTitleSpacingRightDefault: 8,
    alertTitleSpacingRightXlarge: 0,
    alertSpacingVerticalXlarge: 24,
    alertMotionDuration: "200ms",
    alertMotionFunction: "ease",
    alertShadowColor: "rgba(11, 12, 12, 0.1)",
    alertShadowOffsetX: 0,
    alertShadowOffsetY: 8,
    alertShadowBlur: 16,
    alertShadowSpread: 0
  }
};

/***/ }),
/* 424 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='8' fill='%23FF7494' cx='44' cy='44' r='40'/%3e%3cpath d='M44 58.667a5 5 0 100 10 5 5 0 000-10z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M44 23.333v18.334' stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorXlargeWidth: 88,
  iconAlertErrorXlargeHeight: 88
};

/***/ }),
/* 425 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='2' fill='%23FF7494' cx='12' cy='12' r='11'/%3e%3cpath d='M12 16.273A1.364 1.364 0 1012 19a1.364 1.364 0 000-2.727z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 7v5' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorLargeWidth: 24,
  iconAlertErrorLargeHeight: 24
};

/***/ }),
/* 426 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23FF7494' fill-rule='nonzero' cx='8' cy='8' r='8'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23CC0C39' fill-rule='nonzero'/%3e%3cpath d='M8 4v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='12' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorSmallWidth: 16,
  iconAlertErrorSmallHeight: 16
};

/***/ }),
/* 427 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3cpath d='M12 11v6M13 17h-2M12 11h-1' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='12' cy='8' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalLargeWidth: 24,
  iconAlertInformationalLargeHeight: 24
};

/***/ }),
/* 428 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' fill-rule='nonzero' cx='8' cy='8' r='7.5'/%3e%3cpath d='M8 7.063v3.75M8 7.063h-.938M8.938 10.813H7.062' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='4.25' r='1'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalSmallWidth: 16,
  iconAlertInformationalSmallHeight: 16
};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='44' cy='44' r='40.333'/%3e%3cpath d='M44 88c24.3 0 44-19.7 44-44S68.3 0 44 0 0 19.7 0 44s19.7 44 44 44zm0-7.333C23.75 80.667 7.333 64.25 7.333 44S23.75 7.333 44 7.333 80.667 23.75 80.667 44 64.25 80.667 44 80.667z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round' d='M22 44.061l14.65 14.66L62.358 33'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessXlargeWidth: 88,
  iconAlertSuccessXlargeHeight: 88
};

/***/ }),
/* 430 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M6 12.017l3.996 3.998L17.006 9'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessLargeWidth: 24,
  iconAlertSuccessLargeHeight: 24
};

/***/ }),
/* 431 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' fill-rule='nonzero' cx='7.97' cy='7.97' r='7.47'/%3e%3cpath d='M11.705 6.103l-4.669 4.669M7.036 10.772l-2.8-2.802' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3cpath d='M7.97 15.94A7.97 7.97 0 107.97 0a7.97 7.97 0 000 15.94zm0-1A6.97 6.97 0 117.97 1a6.97 6.97 0 010 13.94z' fill='%2398C91E' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessSmallWidth: 16,
  iconAlertSuccessSmallHeight: 16
};

/***/ }),
/* 432 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M82.293 72.449L49.898 7.583A6.656 6.656 0 0043.996 4a6.656 6.656 0 00-5.902 3.583L5.699 72.449C1.756 80.29 7.605 84 11.273 84h65.67c3.494 0 9.29-3.814 5.35-11.551z' stroke='%23DCB700' stroke-width='8' fill='%23FCDE4D' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M43.57 62.333a4.583 4.583 0 100 9.167 4.583 4.583 0 000-9.167z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M43.57 36.667v14.666' stroke='%23232F3E' stroke-width='7.333' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningXlargeWidth: 88,
  iconAlertWarningXlargeHeight: 88
};

/***/ }),
/* 433 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' fill='%23FCDE4D'/%3e%3cpath d='M14.518 1.538A2.837 2.837 0 0012 0a2.83 2.83 0 00-2.51 1.523L.574 19.377C-.698 21.905.87 24 3 24h18.06c2.083 0 3.631-2.133 2.364-4.627L14.518 1.538zm7.123 18.74c.552 1.084.09 1.722-.58 1.722H3c-.732 0-1.196-.62-.64-1.727l8.91-17.841a.83.83 0 011.465.015l8.901 17.823.004.007z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 10v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningLargeWidth: 24,
  iconAlertWarningLargeHeight: 24
};

/***/ }),
/* 434 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M15.205 13.08L9.11.994A1.254 1.254 0 008 .326c-.467 0-.895.257-1.111.668L.794 13.08c-.742 1.462.358 2.153 1.048 2.153h12.356c.658 0 1.748-.71 1.007-2.153z' fill='%23FCDE4D'/%3e%3cpath d='M9.557.942a1.757 1.757 0 00-3.11-.007L.302 13.12C-.506 14.71.468 16 1.797 16h12.448c1.296 0 2.258-1.312 1.452-2.882L9.557.942zm4.688 14.077H1.797c-.644 0-1.072-.566-.62-1.456L7.32 1.384A.77.77 0 018 .981c.29 0 .553.159.685.41l6.138 12.17c.45.879.027 1.458-.577 1.458z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M8 11.667a1 1 0 100 2 1 1 0 000-2z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M8 6v3' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningSmallWidth: 16,
  iconAlertWarningSmallHeight: 16
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _button = _interopRequireDefault(__webpack_require__(121));

var _theme = __webpack_require__(7);

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _buttonStyles = __webpack_require__(208);

var _text = _interopRequireDefault(__webpack_require__(22));

var _token = __webpack_require__(8);

var _isColorDark = _interopRequireDefault(__webpack_require__(440));

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var size = _ref.size,
      type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled,
      minWidth = _ref.minWidth,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor,
      iconOnly = _ref.iconOnly,
      circular = _ref.circular;
  var state = disabled ? "disabled" : "default";
  var linkOrIcon = type === "link" || type === "icon";
  var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderStyle = borderColor ? "solid" : undefined;
  var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: size
  }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : (0, _buttonStyles.defaultStyles)(t, {
    type: type,
    backdrop: backdrop
  }), (_css = {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    outline: "none",
    position: "relative",
    minWidth: minWidth,
    height: t("height", size),
    // Make icon-only buttons square w/ no padding and all other buttons
    // flexible with padding.
    width: iconOnly ? t("height", size) : undefined,
    flexShrink: iconOnly ? 0 : undefined,
    padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
    transition: t.transitionCss("motion", ["color", "background-color", "border-color"]),
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    whiteSpace: "nowrap",
    // HACK: IE11 will only show a pseudo element on a button if
    // overflow is set to visible, and our focus ring is displayed with a
    // pseudo element.
    overflow: "visible",
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingInsetHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingInsetHorizontal", size),
      marginRight: 0
    }
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > * + *", {
    marginLeft: 0,
    marginRight: t("spacingInsetHorizontal", size)
  }), (0, _defineProperty2["default"])(_css, ":hover", !disabled ? (0, _buttonStyles.hoverStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), (0, _defineProperty2["default"])(_css, ":active", !disabled ? (0, _buttonStyles.activeStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), _css), !disabled ? (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    backdropColor: backdropColor,
    linkOrIcon: linkOrIcon
  }) : undefined);
}, ["size", "type", "focus", "disabled", "backdropColor", "minWidth", "iconOnly", "circular"]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.

var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
  var arr = _react["default"].Children.toArray(children);

  return arr.length > 1 ? arr.map(function (child, index) {
    return typeof child === "string" ? /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, child) : child;
  }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */


var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?

  var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
  // edge of the icon/text (which is visible), not the edge of the button
  // element (which is not visible). The magic "24" for the icon variant is the
  // size of a standard icon. By subtracting that from the height of the button
  // and dividing by 2 we get the distance between the invisible edge of the
  // button and the visible edge of the icon.

  var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
    ref: ref,
    className: (0, _emotion.cx)(styles(t, {
      type: props.type,
      size: props.size,
      disabled: props.disabled,
      circular: props.circular,
      backdropColor: props.backdropColor,
      minWidth: props.minWidth,
      focus: focus && focusTrigger === "keyboard",
      iconOnly: iconOnly
    }), props.className),
    disabled: props.disabled,
    id: props.id,
    href: props.href,
    rel: props.rel,
    target: props.target,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    propagateClickEvent: props.propagateClickEvent,
    tabIndex: props.tabIndex,
    download: props.download,
    submit: props.submit // eslint-disable-next-line react/prop-types
    ,
    "aria-label": props["aria-label"] || props.label || undefined,
    form: props.form || undefined,
    "mdn-popover-offset": popoverOffset
  }, focusProps), wrapStringSiblingsInSpans(props.children));
});

Button.displayName = "Button";
Button.propTypes =  false ? {
  /**
   * The button's contents. This can be a string label, an Icon, or a
   * combination of a string label and an Icon.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * This optimizes the button for display when placed over a particular
   * background color. This is only helpful if the button is placed over a
   * background color other than the current theme's primary background color.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * Render a circular button. This is only applicable to icon-only buttons.
   * Buttons with text labels cannot be circular.
   */
  circular: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `href` prop to render a button that
   * triggers the download of a file. See docs for the [HTML download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   *
   * @since 5.22.0
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on the button. The button may grow wider than this
   * value depending on the length of its label, but it will not grow narrow
   * than this value.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * If set to true the button will automatically trigger the submit action of
   * any `<form />` that it's placed in.
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the button.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link", "icon"]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=react-web)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
Button.defaultProps = {
  propagateClickEvent: true,
  size: "medium",
  type: "primary"
};
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _buttonReset = _interopRequireDefault(__webpack_require__(206));

var _linkReset = _interopRequireDefault(__webpack_require__(437));

var _functional = __webpack_require__(19);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var tag = _ref.tag,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
      // HACK: IE offsets the contents of buttons on mouse down (in the active
      // state) to create a faux 3D effect. These styles are applied to every
      // child of  the button in order to counter this effect so that we are
      // the masters of our own button-content-position-destiny.
      "& > *": {
        position: "relative"
      }
    }),
    a: _linkReset["default"]
  }[tag], {
    cursor: disabled ? "not-allowed" : "pointer",
    outline: "none"
  });
}, ["tag", "disabled"]);

var getPropsForNativeLink = function getPropsForNativeLink(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    role: props.role !== "link" ? props.role : undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex,
    onClick: props.onClick
  };
};

var getPropsForNativeButton = function getPropsForNativeButton(props) {
  return {
    disabled: props.disabled || undefined,
    type: props.submit ? "submit" : "button",
    role: props.role !== "button" ? props.role : undefined,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    form: props.form
  };
};

var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
    role: props.role,
    onKeyDown: function onKeyDown(event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links

      if (focus && key === "enter") {
        props.onClick(event);
      } // Disable scrolling on space-key-down for buttons


      if (focus && key === "space" && props.role === "button") {
        event.preventDefault();
      }
    },
    onKeyUp: props.role === "button" ? function (event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons

      if (focus && key === "space") {
        // NOTE: event.preventDefault() will have already been called at
        // this point to keep the space key from triggering a scroll
        // (see `onKeyDown` above), so instead of passing the original
        // event this will pass a mock event that looks like it hasn't
        // had preventDefault() called.
        props.onClick({
          defaultPrevented: false,
          preventDefault: _noop["default"]
        });
      }
    } : undefined,
    onClick: props.onClick
  };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */


var simulateLinkClick = function simulateLinkClick(linkAttributes) {
  // Create a link element that we can click
  var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
  // React normally does this for us, but the DOM doesn't so we have to do it
  // manually to avoid things like `download="undefined"` in the DOM.

  Object.assign(link, Object.keys(linkAttributes).reduce(function (result, key) {
    if (linkAttributes[key] !== undefined) {
      result[key] = linkAttributes[key];
    }

    return result;
  }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
  // FF)

  document.body.appendChild(link); // Trigger a click on the link

  link.click(); // Remove the link from the dom.

  document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */


var Clickable = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClick = props.onClick,
      href = props.href,
      target = props.target,
      submit = props.submit,
      disabled = props.disabled,
      rel = props.rel,
      download = props.download,
      tabIndex = props.tabIndex,
      propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
  // DOM

  var nativeRole = href && !submit ? "link" : "button";
  var role = props.role !== undefined ? props.role : nativeRole;
  var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "mdn-", "aria-"]); // What happens when the Clickable is clicked. Pretty key.

  var onClickTag = (0, _react.useCallback)(function (event) {
    // If the default event behavior was already prevented (e.g. by a nested
    // Clickable inside this one) then don't do anything
    if (!event.defaultPrevented) {
      var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
      // custom onClick handler, or do not have any native browser behavior.
      // This keeps any parent Clickable elements higher up in the DOM tree from
      // also handling the event. This doesn't stop propagation though - other
      // elements may want to react to the event even if its default behavior
      // was cancelled.

      if (disabled || onClick || !nativeBehavior) {
        event.preventDefault();
      } // If we were explicitly told to stop propagation on the event then
      // do so now


      if (!propagateClickEvent) {
        event.stopPropagation();
      } // If we're not disabled then handle the click


      if (!disabled) {
        // If the element has native behavior and we don't have a custom
        // onClick handler, then fall back to the native behavior (and stop
        // propagation to keep anyone else from handling the click).
        if (nativeBehavior && !onClick) {
          event.stopPropagation();
        } // If we've got an element with an href and the user has attempted to
        // open it in a new tab (via control-click, command-click, or
        // middle-mouse-button click) then do that
        else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) {
          simulateLinkClick({
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            download: download
          });
        } // If we were given a custom onClick handle then call it and pass the
        // href (if we have one). This makes it easy to do html5-history-style
        // links like this:
        //   <Clickable href="/path" onClick={push}>
        //     my accessible html5 link
        //   </Clickable>
        else if (onClick) {
          onClick(href);
        } // For non-link elements with an href and no onClick handler we have
        // to manually navigate to the href
        else if (href) {
          simulateLinkClick({
            href: href,
            target: target,
            rel: rel,
            download: download
          });
        }
      }
    }
  }, [onClick, href, target, submit, disabled, tag, rel, download, propagateClickEvent]); // Generate props that are specific to the tag we're rendering (e.g. a link,
  // a button, and a div will all require different props in order to acheive
  // a particular behavior). Memoize these to reduce the number of large objects
  // created on each render.

  var clickableProps = (0, _react.useMemo)(function () {
    var props = {
      onClick: onClickTag,
      role: role,
      disabled: disabled,
      href: href,
      rel: rel,
      target: target,
      tabIndex: tabIndex,
      submit: submit
    };
    return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
  }, [tag, onClickTag, role, disabled, href, rel, target, tabIndex, submit]); // HACK: Wrap string children in a span so that the IE positioning
  // hack (see the button styles above) can take effect

  var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function (child) {
    return typeof child !== "string";
  }).length === 0;
  return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseMove: props.onMouseMove,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    id: props.id,
    download: props.download,
    title: props.title,
    className: (0, _cxMemoized["default"])(styles({
      tag: tag,
      disabled: props.disabled
    }), props.className),
    form: props.form,
    ref: ref
  }), applyIE11StyleHack ? /*#__PURE__*/_react["default"].createElement("span", null, props.children) : props.children);
});

Clickable.displayName = "Clickable";
Clickable.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. See the [W3C aria docs](https://w3c.github.io/using-aria/) for
   * relevant props.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The contents of the component.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See docs for the [a tag's download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Determines whether or not the clickable propagates the click event.
   * Setting to false will run `event.stopPropagation()`.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * See docs for the [aria role attribute](https://www.w3.org/TR/wai-aria/#host_general_role).
   */
  role: _propTypes["default"].string,

  /**
   * See docs for the "submit" value of the [button tag's type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type).
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The tag used to render the component in the DOM. This defaults to either
   * `a` or `button`, whichever is the more appropriate choice given the other
   * props provided (e.g. `href` or `onClick`).
   */
  tag: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * Add a title to the element. Read [the MDN docs on title](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   */
  title: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse is pressed down on the component. The [mousedown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousedown_event)
   * is passed as the first argument to the function.
   */
  onMouseDown: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves within the component. The [mousemove event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousemove_event)
   * is passed as the first argument to the function.
   */
  onMouseMove: _propTypes["default"].func,

  /**
   * This is called when a mouse press is released on the component. The [mouseup event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseup_event)
   * is passed as the first argument to the function.
   */
  onMouseUp: _propTypes["default"].func
} : {};
Clickable.defaultProps = {
  propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var linkReset = {
  display: "inline-block",
  outline: "none",
  textDecoration: "none",
  color: "inherit",
  cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _react = __webpack_require__(0);

var _noop = _interopRequireDefault(__webpack_require__(27));

/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */

/**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */

/**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */

/**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */
var useFocus = function useFocus() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      disabled = _ref.disabled,
      multipleNodes = _ref.multipleNodes,
      _ref$onBlur = _ref.onBlur,
      onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;

  var _useState = (0, _react.useState)([false, null]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2),
      focus = _useState2$[0],
      focusDescendent = _useState2$[1],
      setFocus = _useState2[1];

  var focusedNode = (0, _react.useRef)();
  var blurTimeout = (0, _react.useRef)();
  var onFocus = (0, _react.useCallback)(function (event) {
    clearTimeout(blurTimeout.current);
    focusedNode.current = event ? event.target : undefined;
    var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;

    if (!focus || focusDescendent !== nextFocusDescendent) {
      setFocus([true, nextFocusDescendent]);
    }

    if (!focus) {
      onFocusCallback(event, getInteractionDevice());
    }
  }, [onFocusCallback, focus, focusDescendent]);
  var onBlurComplete = (0, _react.useCallback)(function (event) {
    setFocus([false, false]);
    onBlurCallback(event, getInteractionDevice());
  }, [onBlurCallback]);
  var onBlur = (0, _react.useCallback)(function (event) {
    if (event && multipleNodes) {
      clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
      // multiple elements. Instead, wait briefly using setTimeout to see if
      // onFocus is called for another element we're tracking. If it is then
      // we consider the state to still be focused, otherwise we can move ahead
      // and call `onBlurComplete`.

      event.persist();
      blurTimeout.current = setTimeout(function () {
        if (event.target === focusedNode.current) {
          onBlurComplete(event);
        }
      }, 0);
    } else {
      onBlurComplete(event);
    }
  }, [onBlurComplete, multipleNodes]);
  var focusProps = (0, _react.useMemo)(function () {
    return {
      onFocus: onFocus,
      onBlur: onBlur
    };
  }, [onFocus, onBlur]);
  (0, _react.useEffect)(function () {
    // When the node(s) are focused and we flip from enabled to disabled, clear
    // the focus (see the docs for the disabled param re: why this is
    // necessary).
    if (focus && disabled) {
      setFocus([false, false]);
    } // Clear the timeout when unmounting


    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, [focus, disabled]);
  return {
    focus: focus,
    focusProps: focusProps,
    focusDescendent: focusDescendent,
    focusTrigger: getInteractionDevice()
  };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */


var getInteractionDevice = function () {
  var device = "keyboard";

  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("mousedown", function () {
      return device = "mouse";
    }, true);
    window.addEventListener("keydown", function () {
      return device = "keyboard";
    }, true);
  }

  return function () {
    return device;
  };
}();

var _default = useFocus;
exports["default"] = _default;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _isString = _interopRequireDefault(__webpack_require__(207));

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _css;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var spanStyles = (0, _functional.memoize)(function (size) {
  return (0, _emotion.css)({
    position: "relative",
    flexShrink: 0,
    display: "inline-block",
    width: size,
    height: size,
    verticalAlign: "middle"
  });
});
var imgSpanStyles = (0, _emotion.css)({
  // Don't show the icon's label
  fontSize: 0,
  // Center the icon image
  "& svg": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)"
  }
}); // These RTL styles are applied to a parent span only when an icon contains an LTR and RTL version.

var rtlStyles = (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, "span[role=img]:nth-child(1)", (0, _defineProperty2["default"])({}, "[dir=\"rtl\"] &", {
  display: "none"
})), (0, _defineProperty2["default"])(_css, "span[role=img]:nth-child(2)", (0, _defineProperty2["default"])({
  display: "none"
}, "[dir=\"rtl\"] &", {
  display: "inline-block"
})), _css));

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};

var decodeSvgString = function decodeSvgString(svgData) {
  return decodeURIComponent(svgData.replace(/^data:image\/svg\+xml,/, "") // Add aria-hidden="true" so that screen readers ignore the underlying svg
  // (we label the parent span) and focusable="false" because IE11 defaults
  // to adding SVGs to the tab order
  ).replace(/<svg/, "<svg aria-hidden=\"true\" focusable=\"false\"");
};

var Icon = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens),
      data = _getIconFromTokens.data,
      dataRtl = _getIconFromTokens.dataRtl,
      width = _getIconFromTokens.width,
      height = _getIconFromTokens.height;

  var svg = decodeSvgString(data); // Create an RTL version of the SVG to be used for the RTL icon if it exists, else null

  var svgRtl = dataRtl ? decodeSvgString(dataRtl) : null;
  var html = (0, _react.useMemo)(function () {
    return {
      __html: svg
    };
  }, [svg]); // Generate RTL html for the RTL version of an SVG

  var htmlRtl = (0, _react.useMemo)(function () {
    return {
      __html: svgRtl
    };
  }, [svgRtl]);
  var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
  var simpleChildren = props.children === undefined || typeof props.children === "string";

  var stringChild = _react["default"].Children.toArray(props.children).filter(_isString["default"]).join(" ");

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: dataRtl ? (0, _emotion.cx)(rtlStyles, spanStyles(size), props.className) : (0, _emotion.cx)(spanStyles(size), props.className)
  }, /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    "aria-label": stringChild
  }, passThroughProps, {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? html : undefined
  }), simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: html
  }), props.children)), dataRtl && /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, passThroughProps, {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    "aria-label": simpleChildren ? props.children : undefined,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? htmlRtl : undefined
  }), simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: htmlRtl
  }), props.children)));
}), shouldNotUpdate);

Icon.sizes = {
  small: 16,
  large: 24
};
Icon.displayName = "Icon";
Icon.propTypes =  false ? {
  /**
   * An object of icon tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].object.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Icon component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-hidden | aria-label
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `children` prop details.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * An accessible label for the icon (not visible in the UI). A Badge component
   * can be passed in along with the label in order to render a badge on the
   * icon (visible in the UI).
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   * This can be used for positioning the icon or setting the icon's color
   *
   * This should *not* be used to override other styles on the component.
   * Meridian's internal CSS and HTML are private APIs and may change at any
   * time, potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onFocus: _propTypes["default"].func
} : {};
Icon.sizes = {
  small: 16,
  large: 24
};
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
  var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal

  var r = decimal >> 16 & 0xff; // extract red

  var g = decimal >> 8 & 0xff; // extract green

  var b = decimal >> 0 & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};

var isColorDark = function isColorDark(hex) {
  return getBrightness(hex) < 128;
};

var _default = isColorDark;
exports["default"] = _default;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(204);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(445),
    getMatchData = __webpack_require__(499),
    matchesStrictComparable = __webpack_require__(222);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(210),
    baseIsEqual = __webpack_require__(213);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(96);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(96);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(96);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(96);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(95);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(95),
    Map = __webpack_require__(125),
    MapCache = __webpack_require__(126);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(211),
    isMasked = __webpack_require__(457),
    isObject = __webpack_require__(84),
    toSource = __webpack_require__(212);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(458);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(50);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 459 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(461),
    ListCache = __webpack_require__(95),
    Map = __webpack_require__(125);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(462),
    hashDelete = __webpack_require__(463),
    hashGet = __webpack_require__(464),
    hashHas = __webpack_require__(465),
    hashSet = __webpack_require__(466);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(98);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(98);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(98);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(98);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(210),
    equalArrays = __webpack_require__(214),
    equalByTag = __webpack_require__(476),
    equalObjects = __webpack_require__(479),
    getTag = __webpack_require__(495),
    isArray = __webpack_require__(40),
    isBuffer = __webpack_require__(216),
    isTypedArray = __webpack_require__(218);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(82),
    Uint8Array = __webpack_require__(477),
    eq = __webpack_require__(124),
    equalArrays = __webpack_require__(214),
    mapToArray = __webpack_require__(478),
    setToArray = __webpack_require__(129);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(50);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(480);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(481),
    getSymbols = __webpack_require__(482),
    keys = __webpack_require__(85);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(215),
    isArray = __webpack_require__(40);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(483),
    stubArray = __webpack_require__(484);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 484 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(486),
    isArguments = __webpack_require__(130),
    isArray = __webpack_require__(40),
    isBuffer = __webpack_require__(216),
    isIndex = __webpack_require__(131),
    isTypedArray = __webpack_require__(218);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72),
    isObjectLike = __webpack_require__(58);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(72),
    isLength = __webpack_require__(132),
    isObjectLike = __webpack_require__(58);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(205);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(217)(module)))

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(492),
    nativeKeys = __webpack_require__(493);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(494);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 494 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(496),
    Map = __webpack_require__(125),
    Promise = __webpack_require__(497),
    Set = __webpack_require__(220),
    WeakMap = __webpack_require__(498),
    baseGetTag = __webpack_require__(72),
    toSource = __webpack_require__(212);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(50);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(50);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(50);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(221),
    keys = __webpack_require__(85);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(213),
    get = __webpack_require__(501),
    hasIn = __webpack_require__(505),
    isKey = __webpack_require__(133),
    isStrictComparable = __webpack_require__(221),
    matchesStrictComparable = __webpack_require__(222),
    toKey = __webpack_require__(99);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(223);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(503);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(504);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(126);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(506),
    hasPath = __webpack_require__(507);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 506 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(224),
    isArguments = __webpack_require__(130),
    isArray = __webpack_require__(40),
    isIndex = __webpack_require__(131),
    isLength = __webpack_require__(132),
    toKey = __webpack_require__(99);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(509),
    basePropertyDeep = __webpack_require__(510),
    isKey = __webpack_require__(133),
    toKey = __webpack_require__(99);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(223);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(512),
    isObject = __webpack_require__(84),
    isSymbol = __webpack_require__(92);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(513);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stageStatus_context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouteViewTable__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CartViewTable__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_CacheManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_context_useCapabilityContext__ = __webpack_require__(108);
var RouteStageTable=function RouteStageTable(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__stageStatus_context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext2.viewModelF,dispatchF=_useContext2.dispatchF;var _useCapabilityContext=Object(__WEBPACK_IMPORTED_MODULE_9__global_context_useCapabilityContext__["a" /* default */])(),configViewModel=_useCapabilityContext.configViewModel,configDispatch=_useCapabilityContext.configDispatch,configViewModelRef=_useCapabilityContext.configViewModelRef;var getRouteData=function getRouteData(){var config=configViewModelRef.current;if(config.capability===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["b" /* AR_V2 */]||config.stationConfig.initialised&&Array.isArray(viewModelF.xptNodes)){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch,filterDispatcher:dispatchF,baseUrl:config.baseUrl,capability:config.capability,xptNodes:viewModelF.xptNodes,stationConfig:config.stationConfig,configDispatch:configDispatch}});}};/**
     * This gets invoked on following events:
     *  1. On every page load,
     *  2. Every time xpt filter value is changed,
     *  3. When station config's initialised attribute changes - usually happens when NodeConfig API response is received.
     *  Note: Updates on station config does not re-render useEffect, if initialised attribute value is not changed.
     */Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getRouteData();var firstPollTime=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["o" /* getRefreshInterval */])(configViewModelRef.current.stationConfig);if(__WEBPACK_IMPORTED_MODULE_4__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModelRef.current.capability)){var remainingTTL=Object(__WEBPACK_IMPORTED_MODULE_7__util_CacheManager__["b" /* getRemainingTTL */])(__WEBPACK_IMPORTED_MODULE_8__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]);if(viewModelF.xptNodes&&Object(__WEBPACK_IMPORTED_MODULE_7__util_CacheManager__["c" /* isRouteCacheValid */])(viewModelF.xptNodes)){firstPollTime=remainingTTL;}}var timeoutHandler=function timeoutHandler(){getRouteData();timeout=setTimeout(timeoutHandler,Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["o" /* getRefreshInterval */])(configViewModelRef.current.stationConfig));};var timeout=setTimeout(timeoutHandler,firstPollTime);return function(){return clearTimeout(timeout);};},[viewModelF.xptNodes,configViewModel.stationConfig.initialised]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," ",viewModelF.viewType===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["d" /* CART_VIEW */]&&(!__WEBPACK_IMPORTED_MODULE_4__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)||configViewModel.stationConfig.pickStageDecoupleEnabled)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CartViewTable__["a" /* default */],{history:props.history}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RouteViewTable__["a" /* default */],{history:props.history})));};/* harmony default export */ __webpack_exports__["a"] = (RouteStageTable);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stageStatus_context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_small__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_left_small__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_left_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_left_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_icon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_FilterUtil__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__associate_context_AssociateContextProvider__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_TableScrollWrapper__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var RouteViewTable=function RouteViewTable(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext2.viewModel;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__stageStatus_context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext3.viewModelF;var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_21__associate_context_AssociateContextProvider__["a" /* AssociateContext */]),associateModelDispatcher=_useContext4.associateModelDispatcher;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),expandedRoutes=_useState2[0],setExpandedRoutes=_useState2[1];var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_23__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;/** Pagination State **/var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState4=_slicedToArray(_useState3,2),currentPage=_useState4[0],setCurrentPage=_useState4[1];/** Sorting **/var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("routeSLA"),_useState6=_slicedToArray(_useState5,2),sortColumn=_useState6[0],setSortColumn=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ascending"),_useState8=_slicedToArray(_useState7,2),sortDirection=_useState8[0],setSortDirection=_useState8[1];var onSort=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_ref){var sortColumn=_ref.sortColumn,sortDirection=_ref.sortDirection;setSortDirection(sortDirection);setSortColumn(sortColumn);},[]);/** In Line Table Filter State **/var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),routeCodeFilter=_useState10[0],setRouteCodeFilter=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),routeTypeFilter=_useState12[0],setRouteTypeFilter=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),routeStatus=_useState14[0],setRouteStatus=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),stageStatus=_useState16[0],setStageStatus=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),stageTime=_useState18[0],setStageTime=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),routeSLA=_useState20[0],setRouteSLA=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),location=_useState22[0],setLocation=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),driverFilter=_useState24[0],setDriverFilter=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState26=_slicedToArray(_useState25,2),cartsFilter=_useState26[0],setCartsFilter=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState28=_slicedToArray(_useState27,2),progressFilter=_useState28[0],setProgressFilter=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState30=_slicedToArray(_useState29,2),associateFilter=_useState30[0],setAssociateFilter=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState32=_slicedToArray(_useState31,2),stageDurationFilter=_useState32[0],setStageDurationFilter=_useState32[1];/** Global Filters **/var filterOption=function filterOption(route,filter,key){if(!viewModelF[filter]||viewModelF[filter].length===0){return true;}var result=false;viewModelF[filter].forEach(function(filterValue){if(filter==="status"&&route[key]===filterValue||filter!=="status"&&route[key].includes(filterValue)){result=true;}});return result;};/** Inline Filters **/var inLineFilter=function inLineFilter(route,filter,key){return filter.length===0||route[key]!=null&&route[key].toString().toLowerCase().startsWith(filter.toLowerCase());};var inLineContainsFilter=function inLineContainsFilter(route,filter,key){return filter.length===0||route[key]!=null&&route[key].toString().toLowerCase().includes(filter.toLowerCase());};var routeList=viewModel.routeList;routeList.sort(function(a,b){if(a[sortColumn]<b[sortColumn]){return sortDirection==="ascending"?-1:1;}if(a[sortColumn]>b[sortColumn]){return sortDirection==="ascending"?1:-1;}return 0;});routeList=routeList.filter(function(route){return filterOption(route,"cluster","routeCode");}).filter(function(route){return filterOption(route,"driverType","routeType");}).filter(function(route){return filterOption(route,"departure","routeSLA");}).filter(function(route){return filterOption(route,"status","stageStatus");}).filter(function(route){return Object(__WEBPACK_IMPORTED_MODULE_19__util_FilterUtil__["a" /* applyGlobalStageLocationTypeFilter */])(viewModelF,route);}).filter(function(route){return inLineFilter(route,routeCodeFilter,"routeCode");}).filter(function(route){return inLineContainsFilter(route,routeTypeFilter,"routeType");}).filter(function(route){return inLineFilter(route,routeStatus,"routeStatus");}).filter(function(route){return inLineFilter(route,stageStatus,"stageStatus");}).filter(function(route){return inLineFilter(route,progressFilter,"stageProgress");}).filter(function(route){return inLineFilter(route,associateFilter,"picker");}).filter(function(route){return inLineFilter(route,stageTime,"stageTime");}).filter(function(route){return inLineFilter(route,routeSLA,"routeSLA");}).filter(function(route){return Object(__WEBPACK_IMPORTED_MODULE_19__util_FilterUtil__["b" /* applyInlineStagingLocationFilter */])(route,location);}).filter(function(route){return inLineFilter(route,driverFilter,"driver");}).filter(function(route){return inLineFilter(route,cartsFilter,"totalCarts");}).filter(function(route){return inLineFilter(route,stageDurationFilter,"stageDuration");});var itemOnPage=50;var pageSize=Math.ceil(routeList.length/itemOnPage);var startPage=(currentPage-1)*itemOnPage;var endPage=startPage+itemOnPage>routeList.length-1?routeList.length-1:startPage+itemOnPage-1;if(startPage>routeList.length){setCurrentPage(1);}var onRouteClick=function onRouteClick(route){Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){var params=["Stage",Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(route.routeId),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(encodeURIComponent(route.routeStatus)),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(encodeURIComponent(route.stagingLocation)),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(route.hazmatWeight),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(route.picker),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(route.routeCode),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["C" /* naIfDefault */])(route.stationCode)];var url=new URL(result.replace("stage","pick"));var shareableLink="/routeDetail/"+params.join("/");url.searchParams.set("shareableLink",shareableLink);window.open(url.href,"_parent");});};var onLoadGuideSheetButtonClick=function onLoadGuideSheetButtonClick(route){Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){var baseURL=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["j" /* getBaseUrl */])(result);var url=new URL(baseURL+"/rsws/generateLoadGuideSheet/stationCode/"+route.stationCode+"?routeId="+route.routeId);window.open(url.href,"_blank");});};var expandRoute=function expandRoute(routeId){if(expandedRoutes.indexOf(routeId)!==-1){setExpandedRoutes(expandedRoutes.filter(function(expandedRoute){return expandedRoute!==routeId;}));}else{setExpandedRoutes(expandedRoutes.concat(routeId));}};var isRouteExpanded=function isRouteExpanded(routeId){return expandedRoutes.indexOf(routeId)!==-1;};var renderHeaderRow=function renderHeaderRow(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"routeSLA"},configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.dispatchTime",defaultMessage:"Dispatch Time"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"stage.stageByTime",defaultMessage:"Stage by time"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.routeId",defaultMessage:"Route ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"stagingLocation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.location",defaultMessage:"Location"})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeStatus"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.status",defaultMessage:"Status"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"stageStatus"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.status",defaultMessage:"Status"})),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"stageProgress"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.progress",defaultMessage:"Progress"})):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"picker"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.associate",defaultMessage:"Associate"})):null,__WEBPACK_IMPORTED_MODULE_15__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"stageTime"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.stageTime",defaultMessage:"Stage Time"})):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"stageDuration"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.stageDuration",defaultMessage:"Duration"})):null,!Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"totalCarts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.carts",defaultMessage:"Carts"})):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"driver"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.driver",defaultMessage:"Driver"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeType"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.type",defaultMessage:"Type"})),configViewModel.stationConfig.loadGuideSheetDownloadEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"totalCarts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.loadSheet",defaultMessage:"Load Sheet"})):null);};var onAssociateClick=function onAssociateClick(picker){var associate=[picker];associateModelDispatcher({type:"SET_ASSOCIATE",data:associate});};var renderAssociateCol=function renderAssociateCol(route){if(route.picker!=="..."){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{onClick:function onClick(){onAssociateClick(route.picker);},type:"secondary"},route.picker);}else{return"-";}};var renderStageDuration=function renderStageDuration(route){if(route.stageError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:route.stageError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default.a,null,route.stageDuration));}return route.stageDuration;};var renderInlineFilterRow=function renderInlineFilterRow(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeSLA,onChange:setRouteSLA})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeCodeFilter,onChange:setRouteCodeFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:location,onChange:setLocation})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeStatus,onChange:setRouteStatus})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stageStatus,onChange:setStageStatus})),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:progressFilter,onChange:setProgressFilter})):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:associateFilter,onChange:setAssociateFilter})):null,__WEBPACK_IMPORTED_MODULE_15__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stageTime,onChange:setStageTime})):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stageDurationFilter,onChange:setStageDurationFilter})):null,!Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:cartsFilter,onChange:setCartsFilter})):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:driverFilter,onChange:setDriverFilter})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeTypeFilter,onChange:setRouteTypeFilter})));};var renderRouteRow=function renderRouteRow(route){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:route.routeId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"right",title:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* convertEpochToLocaleFormat */])(route.criticalPullTime)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default.a,{alignment:"right"},route.routeSLA))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["B" /* isRouteChevronEnabled */])(configViewModel.stationConfig)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{"data-expand-link":route.routeId,onClick:function onClick(){return expandRoute(route.routeId);},type:"secondary",size:"small"},isRouteExpanded(route.routeId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_small___default.a}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_left_small___default.a})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{onClick:function onClick(){onRouteClick(route);},type:"secondary"},route.routeCode))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:route.stagingLocation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["G" /* trimColValue */])(route.stagingLocation,16)))),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:route.routeStatus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_13__util_EntityStatusManager__["v" /* getRouteStatusColor */])(route.routeStatus)},route.routeStatus&&route.routeStatus.length>11?route.routeStatus.substr(0,10)+"...":route.routeStatus))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:route.stageStatus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_13__util_EntityStatusManager__["y" /* getStageStatusColor */])(route.stageStatus)},route.stageStatus&&route.stageStatus.length>11?route.stageStatus.substr(0,10)+"...":route.stageStatus))),Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.stageProgress):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,renderAssociateCol(route)):null,__WEBPACK_IMPORTED_MODULE_15__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["g" /* convertMillisecondsToHHMM */])(route.stageTime)):null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},renderStageDuration(route)):null,!Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.totalCarts):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,route.driver):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,route.routeType),configViewModel.stationConfig.loadGuideSheetDownloadEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{onClick:function onClick(){onLoadGuideSheetButtonClick(route);},type:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.download",defaultMessage:"Download"}))):null)].concat(renderCartRows(route));};var renderCartRows=function renderCartRows(route){if(!isRouteExpanded(route.routeId)||!(Array.isArray(route.carts)&&route.carts.length)||!Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["B" /* isRouteChevronEnabled */])(configViewModel.stationConfig)){return[];}return route.carts.map(function(cart){return renderCartRow(route,cart);});};var renderCartRow=function renderCartRow(route,cart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:route.routeCode+"_"+cart.cartId,backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.cartId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:cart.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_13__util_EntityStatusManager__["q" /* getCartStatusColor */])(cart.status)},Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["G" /* trimColValue */])(cart.status,11)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["g" /* convertMillisecondsToHHMM */])(cart.stageTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_TableScrollWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",widths:"fill",spacingInset:spacingInset_shorthand2,className:"enable-scroll-x"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{showStripes:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)&&!Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["B" /* isRouteChevronEnabled */])(configViewModel.stationConfig),showDividers:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability),headerRows:1,headerColumns:1,fixHeaderRows:true,stickyHeaderColumn:true,stickyHeaderRow:true,spacing:"small",sortColumn:sortColumn,sortDirection:sortDirection,onSort:onSort},renderHeaderRow(),renderInlineFilterRow(),routeList.map(function(route,key){return key>=startPage&&key<=endPage?renderRouteRow(route):null;})),routeList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",alignmentHorizontal:"center",spacingInset:"medium none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default.a,{numberOfPages:pageSize,onChange:setCurrentPage,currentPage:currentPage})):null))));};/* harmony default export */ __webpack_exports__["a"] = (RouteViewTable);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _tableRow = _interopRequireDefault(__webpack_require__(136));

var _tableSectionHeader = _interopRequireWildcard(__webpack_require__(228));

var _tableContainer = _interopRequireDefault(__webpack_require__(231));

var _tableFixedHeaders = _interopRequireDefault(__webpack_require__(521));

var _checkbox = _interopRequireDefault(__webpack_require__(139));

var _tableSortToggle = _interopRequireDefault(__webpack_require__(531));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(100));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fullWidthStyles = (0, _emotion.css)({
  width: "100%",
  position: "relative"
});
/**
 * HACK that checks an element to see if it should have an explicit key set by
 * the user.
 *
 * This is dangerous because it delves into private React APIs. It is written in
 * such a way that if the private API is changed/removed then it will default to
 * `true` (indicating that a key is required) since adding explicit unique keys
 * can never hurt (other than being annoying) but omitting them can result in
 * tricky bugs.
 */

var dangerouslyCheckIfExplicitKeyIsRequired = function dangerouslyCheckIfExplicitKeyIsRequired(element) {
  return element && (!element._store || element._store.validated === undefined || element._store.validated === false);
};
/**
 * HACK that returns the key we should use for a row based on the row element
 * and its index in the table.
 *
 * ## Background
 *
 * Because we take the table rows provided by the user and then turn them into a
 * dynamic array, React thinks that explicit keys are always required (even for
 * static tables where row order will never change). We originally got around
 * this by setting each row key to the row index. This stopped the unnecessary
 * "key required" warnings for static tables, but also suppressed the necessary
 * "key required" warnings for dynamic tables (and made custom keys impossible).
 * In retrospect this was a poor choice and caused issues for tables with
 * dynamic rows that had internal state.
 *
 * ## Solution
 *
 * To address this problem we now a) always use the user's explicit keys if they
 * provide them and b) only use the row's index as a key for static tables (as
 * identified by elements where `dangerouslyCheckIfExplicitKeyIsRequired`
 * returns false). This is hacky, but makes our table behave just like any other
 * React component in terms of the key API (custom keys respected, warnings for
 * missing keys on dynamic elements, no warnings for missing keys on static
 * elements). Ultimately it was a poor choice to process all table rows as
 * arrays, but here we are.
 */


var getRowKey = function getRowKey(element, index) {
  return element.key || (dangerouslyCheckIfExplicitKeyIsRequired(element) ? undefined : index);
};
/**
 * Render a table - anything from advanced data tables with sorting and
 * filtering to simple static tables with basic content.
 */


var Table = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    (0, _classCallCheck2["default"])(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (rootRef) {
      _this.rootRef = rootRef; // If we're fixing table headers, re-render when the rootRef comes through

      if (_this.props.fixHeaderRows) {
        _this.forceUpdate();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isSectionHeader", (0, _isElementOfAny["default"])(_this.props.sectionHeaderComponents));
    return _this;
  }

  (0, _createClass2["default"])(Table, [{
    key: "getChildren",
    value:
    /**
     * This function takes the table children passed by the user, splits them into
     * non-rows, header rows, and body rows, and then transforms them based on the
     * props passed to this component (e.g. this component will set the `header`
     * prop on individual table cells based on the `headerRows` and
     * `headerColumns` props passed by the user).
     *
     * This function looks a bit messy because it prioritizes code performance
     * over code readability, accomplishing everything in a single pass over the
     * table cells.
     */
    function getChildren() {
      var _this2 = this;

      var props = this.props;
      var rowIndex = -1;
      var nestedRows = false;
      var nonRows = [];
      var headerRows = [];
      var bodyRows = []; // Walk through every child of the Table (mostly rows, but other children
      // such as a TableActionBar might be included).

      _react["default"].Children.forEach(props.children, function (child) {
        if (!_this2.isRow(child) && !_this2.isSectionHeader(child)) {
          // Gather all the elements that aren't rows together
          nonRows.push(child);
        } else {
          // Transform TableSectionHeader elements (syntactic sugar for users)
          // into actual TableRow elements (that we can render)
          var row = _this2.isSectionHeader(child) ? (0, _tableSectionHeader.toRow)(_this2.isRow, child, props.stickyHeaderColumn) : child;
          rowIndex += 1;
          var key = getRowKey(child, rowIndex); // Handle header rows

          if (rowIndex < props.headerRows) {
            // Add header={true} to every cell in every header row. Transform the
            // cell children into a TableSortToggle if the cell has a `sortColumn`
            // prop set.
            var headerRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              children: _react["default"].Children.map(row.props.children, function (child, columnIndex) {
                return child && /*#__PURE__*/_react["default"].cloneElement(child, {
                  header: true,
                  scope: "col",
                  sortDirection: child.props.sortColumn !== undefined && child.props.sortColumn === props.sortColumn ? props.sortDirection || child.props.defaultSortDirection : undefined,
                  checkboxComponents: columnIndex === 0 ? props.checkboxComponents : undefined,
                  children: props.onSort && child.props.sortColumn ? _this2.renderSortButton(child) : child.props.children
                });
              })
            });

            headerRows.push(headerRow);
          } // Handle body rows. Add header={true} to body cells that are part of
          // a header column. Also keep track of nested rows for styling
          // purposes.
          else {
            var prevColumnIndex = -1;

            var bodyRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              rowComponents: row.props.rowComponents || props.rowComponents,
              children: _react["default"].Children.map(row.props.children, function (child) {
                if (_this2.isRow(child)) {
                  nestedRows = true;
                  return child;
                } else if (child) {
                  // Clone header cells or cells that may contain a checkbox for
                  // selectable tables (we need to pass table-level data down to
                  // these cells).
                  var columnIndex = prevColumnIndex + 1;
                  var header = columnIndex < props.headerColumns;
                  var checkboxComponents = columnIndex === 0 ? props.checkboxComponents : undefined;
                  prevColumnIndex += 1;
                  return header || checkboxComponents ? /*#__PURE__*/_react["default"].cloneElement(child, {
                    header: child.props.header || header,
                    scope: child.props.sectionHeader ? "colgroup" : child.props.header || header ? "row" : undefined,
                    checkboxComponents: child.props.checkboxComponents || checkboxComponents
                  }) : child;
                } else {
                  return null;
                }
              })
            });

            bodyRows.push(bodyRow);
          }
        }
      });

      return {
        nonRows: nonRows,
        headerRows: headerRows,
        bodyRows: bodyRows,
        nestedRows: nestedRows
      };
    }
  }, {
    key: "renderSortButton",
    value: function renderSortButton(cell) {
      var _this$props = this.props,
          sortColumn = _this$props.sortColumn,
          sortDirection = _this$props.sortDirection,
          onSort = _this$props.onSort;
      return /*#__PURE__*/_react["default"].createElement(_tableSortToggle["default"], {
        sortColumn: cell.props.sortColumn,
        value: {
          sortColumn: sortColumn,
          sortDirection: sortDirection
        },
        defaultSortDirection: cell.props.defaultSortDirection,
        columnTextAlignment: cell.props.alignmentHorizontal,
        onChange: onSort
      }, cell.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var _this$getChildren = this.getChildren(),
          nestedRows = _this$getChildren.nestedRows,
          nonRows = _this$getChildren.nonRows,
          headerRows = _this$getChildren.headerRows,
          bodyRows = _this$getChildren.bodyRows;

      var tableContainerProps = _objectSpread({
        nestedRows: nestedRows
      }, props);

      var renderHead = headerRows.length > 0;
      var renderBody = bodyRows.length > 0;
      var useFixedHeaders = props.fixHeaderRows && this.rootRef && renderHead;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: fullWidthStyles,
        ref: this.updateRootRef
      }, !useFixedHeaders ? nonRows : /*#__PURE__*/_react["default"].createElement(_tableFixedHeaders["default"], {
        rootRef: this.rootRef,
        tableContainerProps: tableContainerProps,
        nonRows: nonRows,
        headerRows: headerRows,
        headerRowsOffset: props.fixHeaderRowsOffset,
        fullWidth: props.fixHeaderRowsFullWidth
      }), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], tableContainerProps, renderHead ? /*#__PURE__*/_react["default"].createElement("thead", {
        ref: this.updateHeadRef
      }, headerRows) : null, renderBody ? /*#__PURE__*/_react["default"].createElement("tbody", {
        ref: this.updateBodyRef
      }, bodyRows) : null));
    }
  }]);
  return Table;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Table, "defaultProps", {
  spacing: "medium",
  headerRows: 0,
  headerColumns: 0,
  rowComponents: [_tableRow["default"]],
  sectionHeaderComponents: [_tableSectionHeader["default"]],
  checkboxComponents: [_checkbox["default"]],
  layout: "auto",
  stickyHeaderColumnOffset: 0,
  stickyHeaderRowOffset: 0
});
Table.propTypes =  false ? {
  /**
   * Place `TableActionBar`, `TableRow`, and `TableSectionHeader`, components
   * as children of this component.
   *
   * Any unrecognized children will be extracted and rendered as previous
   * siblings to the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. Defaults to Checkbox.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Fix table header rows to the top of the scroll container when the user
   * scrolls down. This will also fix the TableActionBar if present.
   *
   * NOTE: We recommend turning on the `fixHeaderRowsFullWidth` property as
   * well, which is not enabled by default for backwards-compatibility
   * reasons.
   *
   * If you are not "fixing" an action bar, have a single header row, and are
   * not supporting IE11 we recommend using `stickyHeaderRow` which uses the
   * native CSS property `position: sticky`.
   */
  fixHeaderRows: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `fixHeaderRows` prop if you want the
   * table header to expand to fill the full width of the scroll container
   * when fixed.
   */
  fixHeaderRowsFullWidth: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "fixHeaderRows" prop if you don't want
   * to fix table header rows to the very top of the scroll container. Use
   * this to specify the pixel offset at which the rows should stick.
   */
  fixHeaderRowsOffset: _propTypes["default"].number,

  /**
   * This determines how many columns, starting on the left hand side of the
   * table, should be considered headers.
   */
  headerColumns: _propTypes["default"].number,

  /**
   * This determines how many rows, starting at the top of the table, should
   * be considered headers.
   *
   * NOTE: Expandable header rows are not supported.
   */
  headerRows: _propTypes["default"].number,

  /**
   * This determines how the browser will calculate the column widths of the
   * table. See the [table-layout CSS property](https://developer.mozilla.org/en-US/docs/Web/CSS/table-layout)
   * for details.
   */
  layout: _propTypes["default"].oneOf(["auto", "fixed"]),

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   *
   * NOTE: This prop is only necessary when creating nested rows whose children
   * are _not_ defined in the Table JSX. For instance, the following example
   * _does not_ require `nestedRows` to be defined since the `SelfContainedExpandableRow`'s
   * children are defined in the JSX defining `Table`.
   *
   * ```
   * const MyTable = () => (
   *   <Table rowComponents={[SelfContainedExpandableRow, TableRow]}>
   *     <SelfContainedExpandableRow>
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </SelfContainedExpandableRow>
   *   </Table>
   * )
   *
   * const SelfContainedExpandableRow = ({ children, rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       {children}
   *     </TableRow>
   *   )
   * }
   * ```
   *
   * The following example, however, _does_ require `nestedRows` to be `true`
   * since `SelfContainedExpandableRow`'s children are defined outside the JSX
   * defining `Table`.
   *
   * ```
   * const SelfContainedExpandableRow = ({ rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </TableRow>
   *   )
   * }
   *
   * const MyTable = () => (
   *   <Table
   *     rowComponents={[SelfContainedExpandableRow, TableRow]}
   *     nestedRows={true}
   *   >
   *     <SelfContainedExpandableRow />
   *   </Table>
   * )
   * ```
   *
   * @since  5.x
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * The component or components that will be used to render each table row.
   * Defaults to TableRow.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The component or components that will be used to render each table
   * section header. Defaults to TableSectionHeader.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  sectionHeaderComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This identifies which column is currently sorted. It is matched against
   * any "sortId" props set on TableCell elements in the table's header rows.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * This identifies which direction the data column identified by
   * "sortColumn" is sorted.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * NOTE: Currently stickyHeaderColumn only supports sticking one header column.
   *
   * NOTE: Enabling a stickyHeaderColumn will ignore any user-defined [colummSpan](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-TableSectionHeader-columnSpan)
   * prop on a TableSectionHeader.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderColumn' prop if you don't want
   * to stick the table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header row to the beginning of the scroll container when the
   * user scrolls vertically. Only the last table header row will become stuck.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   * There is also a known issue with using this prop with multiple header rows
   * (`headerColumns > 1`) on Safari desktop.
   *
   * NOTE: Currently stickyHeaderRow only supports sticking one header row. If there
   * are multiple header rows it will stick the header row closest to the table body.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderRow' prop if you don't want
   * to stick the table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number,

  /**
   * When the user clicks on the header of a sortable column this is called
   * with an object containing two keys: "sortColumn" and "sortDirection".
   */
  onSort: _propTypes["default"].func
} : {};
var _default = Table;
exports["default"] = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _useFocus = _interopRequireDefault(__webpack_require__(41));

/**
 * NOTE: This component is deprecated. Use the useFocus hook instead.
 */
var Focus = function Focus(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      multipleTargets = _ref.multipleTargets,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var focus = (0, _useFocus["default"])({
    disabled: disabled,
    multipleNodes: multipleTargets,
    onBlur: onBlur,
    onFocus: onFocus
  });
  return children(focus);
};

Focus.displayName = "Focus";
Focus.propTypes = {
  children: _propTypes["default"].func.isRequired,

  /**
   * A bug in React means that onBlur is not called when an element with focus
   * is disabled. This prop allows you to manually inform the Focus component
   * when the element(s) that it manages are disabled so that it can turn off
   * its internal focus state. See: https://github.com/facebook/react/issues/9142
   */
  disabled: _propTypes["default"].bool,

  /**
   * Turn this on if you are using this component to track the focus of
   * multiple elements.
   */
  multipleTargets: _propTypes["default"].bool,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
};
var _default = Focus;
exports["default"] = _default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(520));

var _default = _stickyScrollTracker["default"];
exports["default"] = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _canUseDom = _interopRequireDefault(__webpack_require__(118));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _emotion.css)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: "none",
  "& > [mdn-tracker-x]": {
    width: 0,
    height: 0,
    position: "sticky",
    top: 0
  },
  "& > [mdn-tracker-y]": (0, _defineProperty2["default"])({
    width: 0,
    height: 0,
    position: "sticky",
    left: 0
  }, "[dir=\"rtl\"] &", {
    left: "unset",
    right: 0
  })
});
var canUseIntersectionObserver = _canUseDom["default"] && "IntersectionObserver" in window;
/**
 * Tracks when a user has scrolled a "relative" container in either direction.
 */

var StickyScrollTracker = function StickyScrollTracker(_ref) {
  var trackX = _ref.trackX,
      trackY = _ref.trackY,
      onChangeX = _ref.onChangeX,
      onChangeY = _ref.onChangeY;
  var xTrackerRef = (0, _react.useRef)();
  var yTrackerRef = (0, _react.useRef)(); // Set up the x-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeX` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeX` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackX && // Tracker is in DOM
    xTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeX(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(xTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackX, onChangeX]); // Set up the y-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeY` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeY` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackY && // Tracker is in DOM
    yTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeY(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(yTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackY, onChangeY]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: styles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-y": "",
    ref: yTrackerRef
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-x": "",
    ref: xTrackerRef
  }));
};

StickyScrollTracker.displayName = "StickyScrollTracker";
StickyScrollTracker.propTypes =  false ? {
  /**
   * If we should track scrolling in the x direction
   */
  trackX: _propTypes["default"].bool,

  /**
   * If we should track scrolling in the y direction
   */
  trackY: _propTypes["default"].bool,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the x direction and `false` otherwise.
   */
  onChangeX: _propTypes["default"].func,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the y direction and `false` otherwise.
   */
  onChangeY: _propTypes["default"].func
} : {};
StickyScrollTracker.defaultProps = {
  trackX: false,
  trackY: false,
  onChangeX: _noop["default"],
  onChangeY: _noop["default"]
};
var _default = StickyScrollTracker;
exports["default"] = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _range = _interopRequireDefault(__webpack_require__(233));

var _table = _interopRequireDefault(__webpack_require__(87));

var _elevation = __webpack_require__(54);

var _tableContainer = _interopRequireDefault(__webpack_require__(231));

var _stickyContainer = _interopRequireDefault(__webpack_require__(525));

var _theme = __webpack_require__(7);

var _querySelectorArray = _interopRequireDefault(__webpack_require__(528));

var _token = __webpack_require__(8);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(138));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fixedHeaderRowStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var stuckY = _ref.stuckY,
      fullWidth = _ref.fullWidth,
      containerWidth = _ref.containerWidth,
      columnWidths = _ref.columnWidths;
  return (0, _emotion.css)(_objectSpread({
    // Apply the primary background color to the fixed header so non-fixed
    // elements don't show through the cracks (e.g. the space between an action
    // bar and the table header)
    backgroundColor: t("backgroundColorPrimary"),
    // Set the box shadow here if we're not including the fullWidth prop
    boxShadow: !fullWidth && t.boxShadowCss("overflowShadow"),
    // If the table overflows its container's width (e.g. for a horizontally
    // scrolling table) then we want the table header to do the same. The only
    // way to make sure the header does this is to set its width explicitly
    // (setting individual column widths is not enough - the browser will just
    // squish them down to fit the table's container).
    width: columnWidths.length > 0 ? columnWidths[0].reduce(function (result, width) {
      return result + width;
    }, 0) : undefined,
    // Unset the max width set by StickyContainer
    maxWidth: "unset !important",
    // Constrain the action bar to the width of the table's container (instead
    // of matching the table width) so that actions floated to the right hand
    // side of the bar don't disappear out of view for horizontally scrollable
    // tables.
    "& [mdn-action-bar]": {
      maxWidth: containerWidth
    },
    // Make sure the stuck non-rows paints correctly on the z-axis
    "& > [mdn-table-stuck-non-rows]": {
      transform: "translateZ(0)"
    },
    // Display a backdrop that makes the header appear to expand the full
    // width of the scroll parent
    "&:before": fullWidth && {
      content: "''",
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%",
      // Just go super super wide. We can't use something like 100% of the
      // viewport width in case we're in a horizontal scroller that is wider
      // than the viewport
      width: "10000px",
      boxSizing: "border-box",
      backgroundColor: t("backgroundColorPrimary"),
      borderBottomStyle: "solid",
      borderBottomWidth: t("borderWidthHeader"),
      borderBottomColor: t("borderColor"),
      boxShadow: t.boxShadowCss("overflowShadow"),
      opacity: stuckY ? 1 : 0,
      transition: t.transitionCss("motion", "opacity")
    },
    // When we override the width of the table cells (see below) we want to
    // make sure that the cell's padding doesn't affect the width that we set.
    "& th": {
      boxSizing: "border-box"
    }
  }, columnWidths.reduce(function (result, cellWidths, rowIndex) {
    result["& thead tr:nth-child(".concat(rowIndex + 1, ")")] = cellWidths.reduce(function (result, width, columnIndex) {
      result["& th:nth-child(".concat(columnIndex + 1, ")")] = {
        width: "".concat(width, "px !important")
      };
      return result;
    }, {});
    return result;
  }, {})));
}, ["stuckY", "fullWidth", "containerWidth", "columnWidths"]);
var initialState = {
  stuck: false,
  columnWidths: [],
  bodyHeight: 0
};

function reducer(state, action) {
  var type = action.type,
      columnWidths = action.columnWidths,
      bodyHeight = action.bodyHeight;

  switch (type) {
    case "WINDOW_RESIZED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "DOM_MUTATED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "STUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: true,
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "UNSTUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: false
      });
  }
}
/**
 * This can be used to fix the table headers so that they don't scroll out of
 * view.
 */


var TableFixedHeaders = function TableFixedHeaders(_ref2) {
  var rootRef = _ref2.rootRef,
      headerRows = _ref2.headerRows,
      headerRowsOffset = _ref2.headerRowsOffset,
      tableContainerProps = _ref2.tableContainerProps,
      fullWidth = _ref2.fullWidth,
      nonRows = _ref2.nonRows;
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      stuck = _useReducer2$.stuck,
      columnWidths = _useReducer2$.columnWidths,
      bodyHeight = _useReducer2$.bodyHeight,
      dispatch = _useReducer2[1]; // Measure the column widths (to fix the width of the header row cells) and the
  // table body height (to keep the fixed content from remaining stuck if the
  // user scrolls past the entire table).


  var headerRowCount = headerRows.length;
  var measureTable = (0, _react.useCallback)(function () {
    var bodyNode = rootRef.querySelector("tbody"); // Be sure to only query the columns that are in the "real" table

    var tableNode = rootRef.querySelector("table:not([mdn-table-fixed])");
    return {
      columnWidths: (0, _range["default"])(headerRowCount).map(function (_, rowIndex) {
        return (0, _querySelectorArray["default"])(tableNode, "thead tr:nth-child(".concat(rowIndex + 1, ") > *")).map(function (cell) {
          return cell.getBoundingClientRect().width;
        });
      }),
      bodyHeight: bodyNode ? bodyNode.getBoundingClientRect().height : 0
    };
  }, [headerRowCount, rootRef]); // When the header sticks update our internal "stuck" state and re-measure
  // the table to make sure we've got the latest dimensions

  var onStick = (0, _react.useCallback)(function () {
    return dispatch(_objectSpread({
      type: "STUCK"
    }, measureTable()));
  }, [measureTable]); // When the header unsticks update our internal "stuck" state.

  var onUnstick = (0, _react.useCallback)(function () {
    return dispatch({
      type: "UNSTUCK"
    });
  }, []); // When our internal "stuck" state flips to true, add a resize listener to the
  // window and a mutation observer to the table so we can re-measure the table
  // dimensions when it's likely that they've changed.

  (0, _react.useEffect)(function () {
    if (stuck) {
      var removeOnResizeListener = (0, _addDebouncedEventListener["default"])(window, "resize", function () {
        return dispatch(_objectSpread({
          type: "WINDOW_RESIZED"
        }, measureTable()));
      });
      var mutationObserver = new MutationObserver(function () {
        return dispatch(_objectSpread({
          type: "DOM_MUTATED"
        }, measureTable()));
      });
      mutationObserver.observe(rootRef.querySelector("table"), {
        childList: true,
        subtree: true
      });
      return function () {
        removeOnResizeListener();

        if (mutationObserver) {
          mutationObserver.disconnect();
        }
      };
    }
  }, [measureTable, rootRef, stuck]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": stuck ? "true" : undefined,
    style: {
      visibility: stuck ? "hidden" : undefined
    },
    key: stuck ? "stuck" : "unstuck"
  }, nonRows), /*#__PURE__*/_react["default"].createElement(_stickyContainer["default"], {
    offsetY: headerRowsOffset,
    maxOffsetY: bodyHeight,
    anchorNode: rootRef,
    onStick: onStick,
    onUnstick: onUnstick,
    zIndex: _elevation.elevationFixture
  }, function (_ref3) {
    var style = _ref3.style,
        stuckY = _ref3.stuckY;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      className: fixedHeaderRowStyles(t, {
        stuckY: stuckY,
        fullWidth: fullWidth,
        columnWidths: columnWidths,
        containerWidth: style.maxWidth
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: stuck ? "stuck" : "not-stuck",
      "mdn-table-stuck-non-rows": ""
    }, nonRows), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], (0, _extends2["default"])({}, tableContainerProps, {
      fixed: true
    }), /*#__PURE__*/_react["default"].createElement("thead", null, headerRows)));
  }));
};

TableFixedHeaders.displayName = "TableFixedHeaders";
TableFixedHeaders.propTypes =  false ? {
  /**
   * A ref pointing to the container around the table. This cannot be changed
   * once it's set.
   */
  rootRef: _propTypes["default"].object.isRequired,

  /**
   * The props set on the TableContainer element.
   */
  tableContainerProps: _propTypes["default"].object.isRequired,

  /*
   * Should the sticky header expand to fill the width of the scroll container
   * when it's displayed?
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * Any header rows to fix.
   */
  headerRows: _propTypes["default"].arrayOf(_propTypes["default"].node),

  /**
   * The pixel offset from the top of the scroll container at which to fix the
   * header rows.
   */
  headerRowsOffset: _propTypes["default"].number,

  /**
   * Any non-row elements to fix along with the header rows.
   */
  nonRows: _propTypes["default"].arrayOf(_propTypes["default"].node)
} : {};
TableFixedHeaders.defaultProps = {
  headerRowsOffset: 0
};
var _default = TableFixedHeaders;
exports["default"] = _default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(523),
    isIterateeCall = __webpack_require__(524),
    toFinite = __webpack_require__(225);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(124),
    isArrayLike = __webpack_require__(73),
    isIndex = __webpack_require__(131),
    isObject = __webpack_require__(84);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyContainer = _interopRequireDefault(__webpack_require__(526));

var _default = _stickyContainer["default"];
exports["default"] = _default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(138));

var _getScrollParent = _interopRequireDefault(__webpack_require__(527));

var _nodeBounds = __webpack_require__(234);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.

/**
 * The bounding box ensures that the sticky container is clipped as if it was a
 * sibling of the anchor node. Otherwise, because the sticky container is
 * position: fixed, it would flow outside of the anchor node's scroll parent.
 */
var boundingBoxStyle = function boundingBoxStyle(_ref) {
  var show = _ref.show,
      zIndex = _ref.zIndex,
      boundingBox = _ref.boundingBox;
  return {
    position: "fixed",
    top: 0,
    left: 0,
    overflow: "hidden",
    zIndex: zIndex,
    // This'll cover the same screen space as the scroll container, but we don't
    // want it to block interaction with elements underneath it.
    pointerEvents: "none",
    display: show ? undefined : "none",
    width: boundingBox.width,
    height: boundingBox.height,
    // NOTE: We could use "willChange: 'transform'" to optimize this a bit, but we
    // have chosen not to because that results in fuzzy text on non-retina
    // displays (at least in Chrome). The fuzzy text is the result of an
    // intentional optimization by the browser: https://googlechrome.github.io/samples/css-will-change-transform-rasterization/.
    transform: "translateY(".concat(boundingBox.top, "px) translateX(").concat(boundingBox.left, "px)")
  };
};
/**
 * The scroll box ensures that the sticky container scrolls normally when it's
 * not fixed.
 */


var scrollBoxStyle = function scrollBoxStyle(_ref2) {
  var top = _ref2.top,
      left = _ref2.left,
      width = _ref2.width,
      height = _ref2.height;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    // Re-enable all the pointer events that we disabled for the parent bounding
    // box (see `boundingBoxStyle`).
    pointerEvents: "all",
    transform: "translateY(".concat(top, "px) translateX(").concat(left, "px)"),
    maxWidth: width,
    maxHeight: height
  };
};
/**
 * Nifty wrapper around Math.max to ignore undefined values
 */


var max = function max() {
  for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }

  return Math.max.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Nifty wrapper around Math.min to ignore undefined values
 */


var min = function min() {
  for (var _len2 = arguments.length, numbers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    numbers[_key2] = arguments[_key2];
  }

  return Math.min.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Walk up the DOM tree from an element and find all the containers that are
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This list may include the element itself if the element is
 * scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getAllScrollParents = function getAllScrollParents(element, axis) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var scrollParent = (0, _getScrollParent["default"])(element, axis);

  if (scrollParent === document.documentElement) {
    return result.concat(scrollParent);
  } else {
    return getAllScrollParents(scrollParent.parentNode, axis, result.concat(scrollParent));
  }
};
/**
 * Returns the pixel width of a node's border on one side. If no border is
 * present or the border is not defined in terms of pixels this will return 0.
 *
 * HACK: Requiring border widths as pixels feels a bit hacky, but all the sticky
 * container math assumes pixels so we can't really deal with other units. I
 * can't think of a last time I saw a border width specified as a non-pixel unit
 * anyway. This should be a pretty safe assumption, and worse-case scenario
 * non-pixel borders will result in the same behavior we had prior to this
 * addition (the sticky element overlapping the border).
 */


var getBorderPixelWidth = function getBorderPixelWidth(node, side) {
  var rawValue = window.getComputedStyle(node).getPropertyValue("border-".concat(side, "-width"));
  return rawValue && rawValue.indexOf("px") !== -1 ? parseFloat(rawValue) : 0;
};
/**
 * Use this to "stick" scrollable content to the screen when it's about to
 * scroll out of view (a la position: sticky). This component works by watching
 * an "anchor" node and displaying itself when the anchor node starts to scroll
 * out of view. This component will automatically pick up the position and
 * dimensions of the anchor node, but the actual content must be provided via
 * the children prop. Use something like React.cloneElement if you want to clone
 * the anchor node to make it appear as if it's transitioning from a scrollable
 * to a fixed state. This cloning requires a little extra work, but it makes the
 * component's internals less complicated and its usage more flexible (e.g. you
 * can use it for a fixed table header, which you can't really rip out of its
 * parent element and display on its own).
 */


var StickyContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(StickyContainer, _React$Component);

  var _super = _createSuper(StickyContainer);

  function StickyContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, StickyContainer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      stuckX: false,
      stuckY: false,
      boundingBox: _nodeBounds.emptyNodeBounds,
      scrollBox: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "anchorNode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesX", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesY", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refresh", function () {
      var _this$props = _this.props,
          onStick = _this$props.onStick,
          onUnstick = _this$props.onUnstick;
      var state = _this.state;

      var boundingBox = _this.getBoundingBox();

      var _this$getScrollBox = _this.getScrollBox({
        boundingBox: boundingBox
      }),
          stuckX = _this$getScrollBox.stuckX,
          stuckY = _this$getScrollBox.stuckY,
          scrollBox = _this$getScrollBox.scrollBox;

      var stickyChange = state.stuckX !== stuckX || state.stuckY !== stuckY;

      var show = _this.show({
        stuckX: stuckX,
        stuckY: stuckY
      }); // Notify the user when the container sticks


      if (stuckX && !state.stuckX || stuckY && !state.stuckY) {
        onStick({
          stuckX: stuckX,
          stuckY: stuckY
        });
      } // Update the state if the container should be shown and anything has
      // changed


      if (show && (stickyChange || !(0, _nodeBounds.compareNodeBounds)(scrollBox, state.scrollBox) || !(0, _nodeBounds.compareNodeBounds)(boundingBox, state.boundingBox))) {
        _this.setState({
          stuckX: stuckX,
          stuckY: stuckY,
          scrollBox: scrollBox,
          boundingBox: boundingBox
        });
      } // Update the state if the container is unsticking


      if (!stuckX && !stuckY && stickyChange) {
        onUnstick();

        _this.setState({
          stuckX: false,
          stuckY: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(StickyContainer, [{
    key: "setup",
    value: function setup() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.anchorNode = _reactDom["default"].findDOMNode(this.props.anchorNode);

      if (this.anchorNode) {
        this.scrollParentNodesX = getAllScrollParents(this.anchorNode, "x");
        this.scrollParentNodesY = getAllScrollParents(this.anchorNode, "y");
        this.addEventListeners();
        this.refresh();
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.refresh, true)); // Update on window resizes as well, since that will affect the size and
      // position of the elements we're tracking

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.refresh, true));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "show",
    value: function show(_ref3) {
      var stuckX = _ref3.stuckX,
          stuckY = _ref3.stuckY;
      return stuckX || stuckY || this.props.showAlways;
    }
    /**
     * This function refreshes the bounding box, scroll box, and "stuck" state
     * in response to the user's scrolling.
     */

  }, {
    key: "getBoundingBox",
    value:
    /**
     * This function returns the bounds of the visible area where we can show
     * sticky elements. These bounds represent the intersection of all scrollable
     * elements up the DOM tree from our anchor element. This rectangle can be
     * used to position a sticky element relative to the scroll parent(s) and to
     * clip the sticky element to make it appear as if it was a child of the
     * scroll parent(s).
     */
    function getBoundingBox() {
      var scrollParentNodesX = this.scrollParentNodesX,
          scrollParentNodesY = this.scrollParentNodesY; // Get the left and right edges of the intersection of all the scroll
      // containers (representing the horizontal space that is actually visible).

      var _scrollParentNodesX$r = scrollParentNodesX.reduce(function (result, node) {
        var _getNodeBounds = (0, _nodeBounds.getNodeBounds)(node),
            left = _getNodeBounds.left; // Add the container's left border width so the sticky element doesn't
        // overlap the left border


        // Add the container's left border width so the sticky element doesn't
        // overlap the left border
        result.left = max(left + getBorderPixelWidth(node, "left"), result.left); // Use the container's clientWidth which excludes borders and scrollbars

        // Use the container's clientWidth which excludes borders and scrollbars
        result.right = min(left + node.clientWidth, result.right);
        return result;
      }, {}),
          left = _scrollParentNodesX$r.left,
          right = _scrollParentNodesX$r.right; // Get the top and bottom edges of the intersection of all the scroll
      // containers (representing the vertical space that is actually visible).


      var _scrollParentNodesY$r = scrollParentNodesY.reduce(function (result, node) {
        var _getNodeBounds2 = (0, _nodeBounds.getNodeBounds)(node),
            top = _getNodeBounds2.top; // Add the container's top border height so the sticky element doesn't
        // overlap the top border


        // Add the container's top border height so the sticky element doesn't
        // overlap the top border
        result.top = max(top + getBorderPixelWidth(node, "top"), result.top); // Use the container's clientHeight which excludes borders and scrollbars

        // Use the container's clientHeight which excludes borders and scrollbars
        result.bottom = min(top + node.clientHeight, result.bottom);
        return result;
      }, {}),
          top = _scrollParentNodesY$r.top,
          bottom = _scrollParentNodesY$r.bottom;

      return {
        top: top,
        left: left,
        width: Math.max(right - left, 0),
        height: Math.max(bottom - top, 0)
      };
    }
    /**
     * This function returns a rectangle that can be used to position a sticky
     * element relative to the bounding box returned by `getBoundingBox`. It also
     * returns the "stuck" state of the element (whether it's fixed along the x or
     * y axis).
     */

  }, {
    key: "getScrollBox",
    value: function getScrollBox(_ref4) {
      var boundingBox = _ref4.boundingBox;
      var _this$props2 = this.props,
          offsetX = _this$props2.offsetX,
          maxOffsetX = _this$props2.maxOffsetX,
          offsetY = _this$props2.offsetY,
          maxOffsetY = _this$props2.maxOffsetY;
      var anchorBox = (0, _nodeBounds.getNodeBounds)(this.anchorNode);
      var anchorLeft = anchorBox.left - boundingBox.left;
      var anchorTop = anchorBox.top - boundingBox.top;
      var maxY = maxOffsetY !== undefined ? anchorTop + maxOffsetY : offsetY;
      var maxX = maxOffsetX !== undefined ? anchorLeft + maxOffsetX : offsetX;
      var stuckX = offsetX !== undefined && anchorLeft < offsetX;
      var stuckY = offsetY !== undefined && anchorTop < offsetY;
      var scrollBox = {
        top: stuckY ? Math.min(maxY, offsetY) : anchorTop,
        left: stuckX ? Math.min(maxX, offsetX) : anchorLeft,
        width: anchorBox.width,
        height: anchorBox.height
      };
      return {
        stuckX: stuckX,
        stuckY: stuckY,
        scrollBox: scrollBox
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the anchor node changed then setup everything from scratch
      if (this.props.anchorNode !== prevProps.anchorNode) {
        this.setup();
      } // If a constraint changed then refresh


      if (this.props.offsetX !== prevProps.offsetX || this.props.offsetY !== prevProps.offsetY || this.props.maxOffsetX !== prevProps.maxOffsetX || this.props.maxOffsetY !== prevProps.maxOffsetY) {
        this.refresh();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          zIndex = _this$props3.zIndex,
          children = _this$props3.children;
      var _this$state = this.state,
          stuckY = _this$state.stuckY,
          stuckX = _this$state.stuckX,
          scrollBox = _this$state.scrollBox,
          boundingBox = _this$state.boundingBox;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: boundingBoxStyle({
          show: this.show({
            stuckX: stuckX,
            stuckY: stuckY
          }),
          zIndex: zIndex,
          boundingBox: boundingBox
        })
      }, children({
        stuckY: stuckY,
        stuckX: stuckX,
        style: scrollBoxStyle(scrollBox)
      }));
    }
  }]);
  return StickyContainer;
}(_react["default"].Component);

(0, _defineProperty2["default"])(StickyContainer, "defaultProps", {
  onStick: _noop["default"],
  onUnstick: _noop["default"]
});
StickyContainer.propTypes =  false ? {
  /**
   * Specify children as a function. StickyContainer will pass an object
   * containing three keys that can be used to render the children: "style"
   * which contains an object of styles that must be set on a wrapper around
   * the children, "stuckX" which indicates whether or not the container is
   * stuck along the X axis, and "stuckY" which indicates whether or not the
   * container is stuck along the Y axis.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * The node to track when showing, hiding, and positioning the sticky
   * container.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll left again with the rest
   * of the content.
   */
  maxOffsetX: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll up again with the rest of
   * the content.
   */
  maxOffsetY: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the top edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px down from the top, etc. If this is not provided the container
   * will not stick on the x axis.
   */
  offsetX: _propTypes["default"].number,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the left edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px right from the edge, etc. If this is not provided the
   * container will not stick on the y axis.
   */
  offsetY: _propTypes["default"].number,

  /**
   * Normally the sticky container is only rendered when it's stuck. Turn this
   * on to force it to render when unstuck as well.
   */
  showAlways: _propTypes["default"].bool,

  /**
   * Use this to determine how the sticky container is layered with other
   * elements.
   */
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the container transitions from unstuck to stuck
   */
  onStick: _propTypes["default"].func,

  /**
   * This is called when the container transitions from stuck to unstuck
   */
  onUnstick: _propTypes["default"].func
} : {};
var _default = StickyContainer;
exports["default"] = _default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isScrollable = function isScrollable(element, axis) {
  var style = window.getComputedStyle(element);
  return axis === "x" ? /(auto|scroll)/.test(style.overflowX) : axis === "y" ? /(auto|scroll)/.test(style.overflowY) : /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX);
};
/**
 * Walk up the DOM tree from an element and find the closest container that is
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This may return the element itself if the element is scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getScrollParent = function getScrollParent(element, axis) {
  return element && isScrollable(element, axis) ? element : element && element.parentElement ? getScrollParent(element.parentElement, axis) : document.documentElement;
};

var _default = getScrollParent;
exports["default"] = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Identical to querySelectorAll, except the results are returned as an array
 */
var querySelectorArray = function querySelectorArray(element, query) {
  return Array.prototype.slice.call(element.querySelectorAll(query));
};

var _default = querySelectorArray;
exports["default"] = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _checkbox = _interopRequireDefault(__webpack_require__(230));

var _checkLarge = _interopRequireDefault(__webpack_require__(140));

var _theme = __webpack_require__(7);

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _token = __webpack_require__(8);

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _text = _interopRequireDefault(__webpack_require__(22));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _cardContext = _interopRequireDefault(__webpack_require__(530));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _labelSpan;

  var fillParent = _ref.fillParent,
      disabled = _ref.disabled,
      labelled = _ref.labelled,
      checked = _ref.checked,
      hover = _ref.hover,
      focus = _ref.focus,
      size = _ref.size,
      hoverDisabled = _ref.hoverDisabled;
  var textStyleObject = (0, _text["default"])(t);
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var borderWidth = t("borderWidth");
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    /**
     * Outer wrapper
     *
     * This outer wrapper makes the checkbox a block-level component without
     * stretching the clickable-area beyond the visible label.
     */
    // NOTE: Use "flex" instead of "block" to achieve block-level display while
    // fixing the min-height issue in IE11:
    // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
    display: "flex",
    fontSize: 0,
    // Positioned this wrapper element statically if the checkbox is supposed
    // to fill its parent. The static positioning makes this wrapper disappear
    // when it comes to positioning so that the label (see "labelStyles" below)
    // is positioned relative to the parent of the checkbox, not this wrapper.
    position: fillParent ? "static" : undefined,
    // For IE11
    width: fillParent ? "100%" : undefined,
    height: fillParent ? "100%" : undefined,

    /**
     * Inner wrapper (the label element)
     */
    "& > label": _objectSpread(_objectSpread({}, textStyleObject), {}, {
      display: "inline-flex",
      flexDirection: "row",
      justifyContent: labelled ? "flex-start" : "center",
      alignItems: "center",
      position: fillParent ? "absolute" : "relative",
      top: fillParent ? 0 : undefined,
      right: fillParent ? 0 : undefined,
      bottom: fillParent ? 0 : undefined,
      left: fillParent ? 0 : undefined,
      color: t("foregroundColor", disabled ? "disabled" : "default"),
      cursor: disabled ? "not-allowed" : "pointer",
      userSelect: "none",
      minHeight: textStyleObject.lineHeight
    }),

    /**
     * Icon wrapper
     */
    "& > label > span": (_labelSpan = {
      // Vertically center icon
      display: "flex",
      alignItems: "center",
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // marginInlineEnd: labelled ? t("spacingHorizontal") : undefined,
      marginRight: labelled ? t("spacingHorizontal") : undefined,
      marginLeft: 0
    }, (0, _defineProperty2["default"])(_labelSpan, "[dir=\"rtl\"] &", {
      marginLeft: labelled ? t("spacingHorizontal") : undefined,
      marginRight: 0
    }), (0, _defineProperty2["default"])(_labelSpan, "width", t("width", size)), (0, _defineProperty2["default"])(_labelSpan, "height", t("height", size)), _labelSpan),

    /**
     * Visible checkbox (the Icon element)
     */
    "& > label > span > *[role=img]": (0, _emotion.css)({
      boxSizing: "border-box",
      flexShrink: 0,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      borderColor: t("borderColor", [modifier, state]),
      borderStyle: "solid",
      transition: t.transitionCss("motion", ["color", "background-color"]),
      color: t("indicatorColor", [modifier, state]),
      backgroundColor: t("backgroundColor", [modifier, state]),
      width: t("width", size),
      height: t("height", size)
    }, !disabled ? (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      dropShadow: true,
      offset: 4,
      gapColor: t.themeBackgroundPrimaryDefault,
      hoverSelector: "*:hover > &"
    }) : undefined),
    "& > label:hover > span > *[role=img]": !disabled && !hoverDisabled ? {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    } : undefined,
    "& > label:active > span > *[role=img]": !disabled ? {
      color: t("indicatorColor", [modifier, "pressed"]),
      backgroundColor: t("backgroundColor", [modifier, "pressed"]),
      borderColor: t("borderColor", [modifier, "pressed"])
    } : undefined
  }, hover && !hoverDisabled && !disabled ? {
    "& > label > span > *[role=img]": {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    }
  } : undefined);
}, ["fillParent", "disabled", "labelled", "hover", "checked", "focus", "size", "hoverDisabled"]); // Styles for the actual HTML checkbox element that is hidden from the user

var hiddenCheckboxStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * Render a form control that can be toggled on or off by the user. Usually
 * rendered in groups to allow one or more choices to be selected.
 */

var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = props.onChange;
  var t = (0, _theme.useTheme)(_checkbox["default"], "checkbox");
  var context = (0, _react.useContext)(_cardContext["default"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hoverDisabled = _useState2[0],
      setHoverDisabled = _useState2[1];

  var onMouseEnter = (0, _react.useCallback)(function () {
    return setHoverDisabled(false);
  }, [setHoverDisabled]);
  var handleChange = (0, _react.useCallback)(function (event) {
    if (onChange) onChange(event.target.checked);
    setHoverDisabled(true);
  }, [onChange, setHoverDisabled]);
  var labelled = Boolean(props.children);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: function onFocus(event) {
      if (props.onFocus) props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (props.onBlur) props.onBlur(event);
    }
  }),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      labelled: labelled,
      hover: context.hover,
      hoverDisabled: hoverDisabled,
      checked: props.checked,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard",
      size: props.size,
      fillParent: props.fillParent
    })
  }, /*#__PURE__*/_react["default"].createElement("label", {
    onMouseEnter: onMouseEnter
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenCheckboxStyles,
    type: "checkbox",
    name: props.name,
    value: props.value,
    "aria-checked": props.checked !== "mixed" ? Boolean(props.checked) : "mixed",
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(props.checked),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    onChange: handleChange,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.iconTokens
  }), labelled ? /*#__PURE__*/_react["default"].createElement("div", null, props.children) : null));
});

Checkbox.displayName = "Checkbox";
Checkbox.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Checkbox component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-checked
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].oneOf([true, false, "mixed"]),

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked. If
   * you're using a Checkbox without a visible label, be sure to assign a
   * label using `aria-label`.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If set to true the checkbox's clickable area will stretch to fill its
   * layout parent (the nearest ancestor with non-static positioning). The
   * checkbox's form control will be centered in the available space.
   *
   * This is currently used when checkboxes are rendered in table cells to make
   * table rows selectable.
   */
  fillParent: _propTypes["default"].bool,

  /**
   * Use this to customize the icon rendered in the checkbox. The value of this
   * prop should be an object of icon tokens imported directly from the Meridian
   * token library (e.g. `import checkTokens from "@amzn/meridian-tokens/base/icon/check-large`).
   *
   * The `"check-large"` icon is recommended for almost all checkboxes. The
   * `"minus"` icon is recommended for a checkbox that represents a partially
   * checked state (e.g. a "Select all" checkbox when only some items are
   * selected).
   *
   * See the [Iconography page](https://meridian.a2z.com/fundamentals/iconography/?platform=reactjs)
   * for a full list of the available icons.
   *
   * NOTE: This is deprecated and will be removed in 6.x.
   *
   * @deprecated 5.x
   */
  iconTokens: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the checked
   * state of the component (e.g. by clicking on it). The new checked state will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
Checkbox.defaultProps = {
  size: "medium",
  iconTokens: _checkLarge["default"]
};
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tableSortToggle = _interopRequireDefault(__webpack_require__(532));

var _default = _tableSortToggle["default"];
exports["default"] = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _table = _interopRequireDefault(__webpack_require__(87));

var _arrowsUpAndDown = _interopRequireDefault(__webpack_require__(533));

var _arrowUpLarge = _interopRequireDefault(__webpack_require__(534));

var _arrowDownLarge = _interopRequireDefault(__webpack_require__(535));

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _theme = __webpack_require__(7);

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _text = _interopRequireDefault(__webpack_require__(22));

var _token = __webpack_require__(8);

var _rtl = __webpack_require__(39);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var sortDirection = _ref.sortDirection,
      focus = _ref.focus,
      columnTextAlignment = _ref.columnTextAlignment;
  return (0, _emotion.css)((0, _text["default"])(t), {
    fontWeight: t("fontWeightHeader"),
    // Add padding to the sort button to increase its clickable area, but add
    // the same amount of negative margin to ensure that the sort button
    // padding doesn't double up with the table cell padding. This assumes
    // that the toggle will be placed in a container with at least the same
    // amount of padding as "sortIndicatorSpacing" (e.g. a table cell).
    padding: t("sortIndicatorSpacing"),
    margin: -t("sortIndicatorSpacing"),
    // Inline flex so that the sort button moves left/right according to the
    // table cell's text alignment
    display: "inline-flex",
    alignItems: "center",
    flexDirection: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "row-reverse" : "row",
    justifyContent: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "flex-end" : "flex-start",
    "& > * + *": (0, _defineProperty2["default"])({}, (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "marginRight" : "marginLeft", t("sortIndicatorSpacing")),
    // Icon wrapper styles
    "& > span:nth-child(2)": {
      width: t("sortIndicatorWidth"),
      height: t("sortIndicatorHeight")
    },
    // Icon styles
    "& > span > *[role=img]": {
      color: focus ? t("sortIndicatorColorFocus") : sortDirection !== null ? t("sortIndicatorColorSorted") : t("sortIndicatorColorDefault"),
      // The focus ring doesn't have a transition (for performance reasons) so
      // don't transition the icon when showing the focus state (otherwise the
      // icon fades in after the focus ring appears and it looks a bit wonky).
      transition: !focus ? t.transitionCss("motion", "color") : undefined
    },
    "&:hover > span > *[role=img]": {
      color: t("sortIndicatorColorHover")
    },
    "&:active > span > *[role=img]": {
      color: t("sortIndicatorColorPressed")
    }
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 2
  }));
}, ["sortDirection", "focus", "columnTextAlignment"]);
/**
 * Drop this in a table column's header cell to render a control that can be
 * used to change the sort direction of the column.
 */

var TableSortToggle = function TableSortToggle(_ref2) {
  var onChange = _ref2.onChange,
      sortColumn = _ref2.sortColumn,
      value = _ref2.value,
      defaultSortDirection = _ref2.defaultSortDirection,
      columnTextAlignment = _ref2.columnTextAlignment,
      children = _ref2.children;
  var t = (0, _theme.useTheme)(_table["default"], "table");
  var sortDirection = value && value.sortColumn === sortColumn ? value.sortDirection : null;
  var onClick = (0, _react.useCallback)(function () {
    return onChange({
      sortColumn: sortColumn,
      sortDirection: sortDirection === "ascending" ? "descending" : sortDirection === "descending" ? "ascending" : defaultSortDirection
    });
  }, [sortColumn, sortDirection, defaultSortDirection, onChange]);
  var iconDirection = sortDirection || defaultSortDirection;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
    onClick: onClick,
    className: styles(t, {
      focus: focus && focusTrigger === "keyboard",
      sortDirection: sortDirection,
      columnTextAlignment: columnTextAlignment
    })
  }), /*#__PURE__*/_react["default"].createElement("span", null, children), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: sortDirection === null ? _arrowsUpAndDown["default"] : iconDirection === "descending" ? _arrowDownLarge["default"] : _arrowUpLarge["default"]
  }));
};

TableSortToggle.displayName = "TableSortToggle";
TableSortToggle.propTypes =  false ? {
  /**
   * The table cell's text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The column that this toggle sorts.
   */
  sortColumn: _propTypes["default"].string.isRequired,

  /**
   * This is called when the user attempts to sort the column. The toggle's new
   * value, either "ascending" or "descending", will be passed to the function.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * This should match the text alignment of the table column that
   * contains the sort button.
   */
  columnTextAlignment: _propTypes["default"].oneOf(["left", "start", "right", "end"]),

  /**
   * This is the value that the toggle will default to when first clicked by the
   * user.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The column that is currently sorted and the direction that it's sorted.
   */
  value: _propTypes["default"].shape({
    sortColumn: _propTypes["default"].string,
    sortDirection: _propTypes["default"].PropTypes.oneOf(["ascending", "descending"])
  })
} : {};
TableSortToggle.defaultProps = {
  defaultSortDirection: "ascending"
};
var _default = TableSortToggle;
exports["default"] = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowsUpAndDownData: "data:image/svg+xml,%3csvg width='18' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3cpath d='M4 0a1 1 0 011 1v9.585l1.293-1.292a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414l-3 3A1.003 1.003 0 014 14l.085-.004a1.003 1.003 0 01-.052.003L4 14a1.223 1.223 0 01-.149-.011 1.12 1.12 0 01-.222-.06 1.005 1.005 0 01-.336-.222l.09.08a1.003 1.003 0 01-.09-.08l-3-3a1 1 0 111.414-1.414L3 10.585V1a1 1 0 01.883-.993L4 0zM14 14a1 1 0 001-1V3.415l1.293 1.292a1 1 0 001.32.083l.094-.083a1 1 0 000-1.414l-3-3A1 1 0 0014 0l.085.004A1 1 0 0014.033 0L14 0a1.016 1.016 0 00-.52.146 1.045 1.045 0 00-.187.147l.09-.08a1 1 0 00-.09.08l-3 3a1 1 0 001.414 1.414L13 3.415V13a1 1 0 00.883.993L14 14z'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowsUpAndDownWidth: 18,
  iconArrowsUpAndDownHeight: 14
};

/***/ }),
/* 534 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowUpLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M9 5L5 1 1 5M5 1v12'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowUpLargeWidth: 10,
  iconArrowUpLargeHeight: 14
};

/***/ }),
/* 535 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowDownLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4 4 4-4M5 13V1'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowDownLargeWidth: 10,
  iconArrowDownLargeHeight: 14
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBarOverlay["default"];
  }
});
exports["default"] = void 0;

var _tableActionBar = _interopRequireDefault(__webpack_require__(537));

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(236));

var _default = _tableActionBar["default"];
exports["default"] = _default;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _find = _interopRequireDefault(__webpack_require__(88));

var _table = _interopRequireDefault(__webpack_require__(87));

var _elevation = __webpack_require__(54);

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(236));

var _row = _interopRequireDefault(__webpack_require__(17));

var _button = _interopRequireDefault(__webpack_require__(28));

var _theme = __webpack_require__(7);

var _text = _interopRequireDefault(__webpack_require__(22));

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isButton = (0, _isElementOf["default"])(_button["default"]);

var styles = function styles(t, _ref) {
  var stickyOffset = _ref.stickyOffset,
      withOverlay = _ref.withOverlay;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // The action bar container adds whitespace between the action bar and the
    // table. It also ensures that the empty space is opaque (using the table's
    // background color) so that elements don't peak through between the action
    // bar and the table when the action bar is sticky.
    backgroundColor: t("backgroundColorDefault"),
    paddingBottom: t("spacingVerticalSmall"),
    "& > [mdn-action-bar]": {
      position: "relative"
    },
    // Hide the action bar's children when an overlay is shown (ensures that the
    // action bar's interactive children aren't focuseable when obscured by
    // an overlay).
    "& > [mdn-action-bar] > *:last-child": withOverlay && {
      visibility: "hidden"
    }
  }, stickyOffset !== undefined && {
    position: "sticky",
    top: stickyOffset,
    // Stack one higher than other fixtures to ensure that if the action bar
    // and table header conflict then the action bar is shown on top (this
    // happens when the user scrolls to the very bottom of an HTML table with
    // headers that are stuck using `position: sticky`).
    zIndex: _elevation.elevationFixture + 1
  });
};
/**
 * Used to render an action bar for a table. Usually placed as a child of the Table
 * component, but can be placed outside of the Table when necessary.
 */


var TableActionBar = function TableActionBar(props) {
  var children = props.children,
      alignmentHorizontal = props.alignmentHorizontal,
      widths = props.widths,
      stickyOffset = props.stickyOffset,
      overlayComponent = props.overlayComponent;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  var childrenArray = _react["default"].Children.toArray(children);

  var isOverlay = (0, _react.useMemo)(function () {
    return (0, _isElementOf["default"])(overlayComponent);
  }, [overlayComponent]);
  var isNotActionBarOverlay = (0, _react.useCallback)(function (child) {
    return !isOverlay(child);
  }, [isOverlay]);
  var overlay = (0, _find["default"])(children, isOverlay);
  var nonOverlayChildren = childrenArray.filter(isNotActionBarOverlay);
  var t = (0, _theme.useTheme)(_table["default"], "table");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      stickyOffset: stickyOffset,
      withOverlay: Boolean(overlay)
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-action-bar": ""
  }, overlay, /*#__PURE__*/_react["default"].createElement(_row["default"], (0, _extends2["default"])({}, passThroughProps, {
    widths: widths,
    type: "fill",
    spacingInset: "small medium",
    spacing: "small",
    alignmentHorizontal: alignmentHorizontal
  }), nonOverlayChildren.map(function (element) {
    return isButton(element) ? /*#__PURE__*/_react["default"].cloneElement(element, {
      backdropColor: t.tokens.themeBackgroundSecondaryDefault
    }) : element;
  }))));
};

TableActionBar.displayName = "TableActionBar";
TableActionBar.propTypes =  false ? {
  /**
   * The contents of the action bar.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Use this to determine how the children in the action bar are aligned
   * horizontally.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The component that will render as an overlay. Defaults to Meridian's TableActionBarOverlay.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   *
   * @since  5.x
   */
  overlayComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * This applies sticky positioning to the action bar so that it sticks to the
   * top of the viewport when the user scrolls. This is an experimental feature
   * that is not compatible with IE11. If you are using the TableActionBar with
   * Meridian's Table component, use the `fixHeaderRows` prop on the Table
   * component instead of this prop.
   */
  stickyOffset: _propTypes["default"].number,

  /**
   * Use this to determine the widths of the action bar's children. The action
   * bar uses the Row component under the hood - see the usage documentation of
   * the Row component for details on how to use this prop.
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))])
} : {};
TableActionBar.defaultProps = {
  alignmentHorizontal: "start",
  overlayComponent: _tableActionBarOverlay["default"]
};
var _default = TableActionBar;
exports["default"] = _default;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(142));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _range = _interopRequireDefault(__webpack_require__(233));

var _difference = _interopRequireDefault(__webpack_require__(540));

var _find = _interopRequireDefault(__webpack_require__(88));

var _union = _interopRequireDefault(__webpack_require__(552));

var _pagination = _interopRequireDefault(__webpack_require__(554));

var _token = __webpack_require__(8);

var _theme = __webpack_require__(7);

var _row = _interopRequireDefault(__webpack_require__(17));

var _arrowControls = _interopRequireDefault(__webpack_require__(555));

var _pageButton = _interopRequireDefault(__webpack_require__(558));

var _ellipse = _interopRequireDefault(__webpack_require__(559));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _excluded = ["pageNumbers", "currentPage", "t"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Constants */
var BREAK = "BREAK";
var MEDIUM_SET_SPACES = 5;
/** Helpers */

var isShortSet = function isShortSet(val) {
  return val <= 5;
};

var isMediumSet = function isMediumSet(val) {
  return val > 5 && val <= 8;
};

var isLongSet = function isLongSet(val) {
  return val > 8;
};

var insertIf = function insertIf(condition) {
  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  return condition ? elements : [];
}; // Lodash doesn't include the end value in the array which
// is confusing. This method simply adds +1 to the end value
// which makes the code easier to understand


var getRange = function getRange(start, end, step) {
  return (0, _range["default"])(start, end + 1, step);
}; // Get surrounding numbers around an anchor and return them as an array


var getSurroundingNumbers = function getSurroundingNumbers(_ref) {
  var anchor = _ref.anchor,
      setLength = _ref.setLength,
      ceiling = _ref.ceiling,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor;
  var surroundingNumbers = [anchor];
  var i = 1; // While we still have spaces to fill

  while (surroundingNumbers.length < setLength) {
    // If we can, put an even smaller number at the start of the array
    if (anchor - i > floor) surroundingNumbers.unshift(anchor - i); // If we can, put an even larger number at the end of the array

    if (anchor + i <= ceiling) surroundingNumbers.push(anchor + i);
    i += 1;
  }

  return surroundingNumbers;
};

var getNumberOfEdgePages = function getNumberOfEdgePages(_ref2) {
  var closeTrunc = _ref2.closeTrunc,
      farTrunc = _ref2.farTrunc,
      surroundingPages = _ref2.surroundingPages,
      farRange = _ref2.farRange;
  return farTrunc ? closeTrunc ? 1 // if truncating on both sides, display 1
  : 3 // else display 3
  : // if the further edge doesn't need truncation,
  // calculate how many slots remain. This is done
  // by calculating the difference in the total number
  // of slots (6) and how many numbers are being used
  // in the far set (eg. [1, 2, 3, 4, 5])
  6 - (0, _union["default"])(farRange, surroundingPages).length;
};
/** Sets */


var shortSet = {
  check: isShortSet,
  pageNumbers: function pageNumbers(_ref3) {
    var numberOfPages = _ref3.numberOfPages;
    return getRange(1, numberOfPages);
  }
};
var mediumSet = {
  check: isMediumSet,
  pageNumbers: function pageNumbers(_ref4) {
    var numberOfPages = _ref4.numberOfPages,
        currentPage = _ref4.currentPage;
    return getSurroundingNumbers({
      anchor: currentPage,
      setLength: MEDIUM_SET_SPACES,
      ceiling: numberOfPages
    });
  }
};
var longSet = {
  check: isLongSet,
  pageNumbers: function pageNumbers(_ref5) {
    var numberOfPages = _ref5.numberOfPages,
        currentPage = _ref5.currentPage;
    var surroundingPages = getSurroundingNumbers({
      anchor: currentPage,
      setLength: 3,
      ceiling: numberOfPages
    }); // If the outer surrounding numbers are more then 3 away from
    // their respective extreme, add a truncation/ellipse

    var needsBeginningTrunc = surroundingPages[0] - 3 >= 1;
    var needsEndingTrunc = surroundingPages[2] + 3 <= numberOfPages;
    var numberOfEndingPages = getNumberOfEdgePages({
      closeTrunc: needsEndingTrunc,
      farTrunc: needsBeginningTrunc,
      farRange: getRange(1, 3),
      surroundingPages: surroundingPages
    });
    var numberOfBegginningPages = getNumberOfEdgePages({
      closeTrunc: needsBeginningTrunc,
      farTrunc: needsEndingTrunc,
      farRange: getRange(numberOfPages - 2, numberOfPages),
      surroundingPages: surroundingPages
    });
    var beginningPages = getRange(1, numberOfBegginningPages); // We add + 1 to numberOfPages because we are starting
    // with the assumption if numberOfEndingPages = 1 the
    // range should only include that number.
    // e.g. numberOfPages = 10, numberOfEndingPages = 1
    // getRange(10 + 1 - 1, 10) = [10]
    // e.g. numberOfPages = 10, numberOfEndingPages = 2
    // getRange(10 + 1 - 2, 10) = [9, 10]

    var endPages = getRange(numberOfPages + 1 - numberOfEndingPages, numberOfPages);
    return [].concat((0, _toConsumableArray2["default"])((0, _difference["default"])(beginningPages, surroundingPages)), (0, _toConsumableArray2["default"])(insertIf(needsBeginningTrunc, BREAK)), (0, _toConsumableArray2["default"])(surroundingPages), (0, _toConsumableArray2["default"])(insertIf(needsEndingTrunc, BREAK)), (0, _toConsumableArray2["default"])((0, _difference["default"])(endPages, surroundingPages)));
  }
};

var buildPageNumbers = function buildPageNumbers(numberOfPages, currentPage) {
  return (0, _find["default"])([shortSet, mediumSet, longSet], function (_ref6) {
    var check = _ref6.check;
    return check(numberOfPages);
  }).pageNumbers({
    numberOfPages: numberOfPages,
    currentPage: currentPage
  });
};

var buildPageButtons = function buildPageButtons(_ref7) {
  var pageNumbers = _ref7.pageNumbers,
      currentPage = _ref7.currentPage,
      t = _ref7.t,
      props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
  return pageNumbers.map(function (value, index) {
    return value !== BREAK ? /*#__PURE__*/_react["default"].createElement(_pageButton["default"], (0, _extends2["default"])({}, props, {
      t: t,
      selected: value === currentPage,
      key: value
    }), value) : /*#__PURE__*/_react["default"].createElement(_ellipse["default"], {
      key: "ellipse-".concat(index),
      t: t,
      disabled: props.disabled
    });
  });
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    (0, _classCallCheck2["default"])(this, Pagination);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          showSkipArrows = _this$props.showSkipArrows,
          label = _this$props.label,
          locale = _this$props.locale;
      var _this$props2 = this.props,
          numberOfPages = _this$props2.numberOfPages,
          currentPage = _this$props2.currentPage;
      if (!numberOfPages || numberOfPages <= 0) numberOfPages = 1;

      if (!currentPage || currentPage <= 0) {
        currentPage = 1;
      } else if (currentPage > numberOfPages) {
        currentPage = numberOfPages;
      }

      var pageNumbers = buildPageNumbers(numberOfPages, currentPage);
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _pagination["default"],
        map: (0, _token.getTokenHelper)("pagination")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("nav", (0, _extends2["default"])({}, passThroughProps, {
          role: "navigation",
          "aria-label": label
        }), /*#__PURE__*/_react["default"].createElement(_row["default"], {
          spacing: "none"
        }, /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "left"
        })), buildPageButtons(_objectSpread(_objectSpread({}, _this.props), {}, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          pageNumbers: pageNumbers,
          t: t,
          locale: locale
        })), /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "right"
        }))));
      });
    }
  }]);
  return Pagination;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Pagination, "defaultProps", {
  showSkipArrows: false,
  label: "Pagination navigation",
  locale: "en-US",
  pageLabel: function pageLabel(pageNumber) {
    return "Go to page ".concat(pageNumber);
  },
  currentPageLabel: function currentPageLabel(nextPageNumber) {
    return "Current page, page ".concat(nextPageNumber);
  },
  previousPageLabel: function previousPageLabel(prevPageNumber) {
    return "Go to previous page, page ".concat(prevPageNumber);
  },
  nextPageLabel: function nextPageLabel(nextPageNumber) {
    return "Go to next page, page ".concat(nextPageNumber);
  },
  firstPageLabel: function firstPageLabel(firstPageNumber) {
    return "Go to first page, page ".concat(firstPageNumber);
  },
  lastPageLabel: function lastPageLabel(lastPageNumber) {
    return "Go to last page, page ".concat(lastPageNumber);
  }
});
Pagination.propTypes =  false ? {
  /**
   * The number of the currently selected page, where `1` is the first page
   * (*not* 0-indexed).
   */
  currentPage: _propTypes["default"].number.isRequired,

  /**
   * The total number of pages in the list being paginated.
   */
  numberOfPages: _propTypes["default"].number.isRequired,

  /**
   * A function that will be called when the user attempts to change the current
   * page (e.g. by clicking on the "Next page" button). The new page number
   * will be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `currentPage` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Icon component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-label
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `label` prop details.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the current page.
   *
   * This receives the current page's number as its only argument, and should return a string.
   */
  currentPageLabel: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that generates an accessible label for the skip-to-first-page button.
   *
   * This receives the first page's number as its only argument, and should return a string.
   */
  firstPageLabel: _propTypes["default"].func,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the skip-to-last-page button.
   *
   * This receives the last page's number as its only argument, and should return a string.
   */
  lastPageLabel: _propTypes["default"].func,

  /**
   * The locale used to display the numbers in the page buttons. Any local supported by
   * the [Number.toLocaleString API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString)
   * will work.
   */
  locale: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the go-to-next-page button.
   *
   * This receives the next page's number as its only argument, and should return a string.
   */
  nextPageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for any page.
   *
   * This receives a page number as its only argument, and should return a string.
   */
  pageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for the go-to-previous-page button.
   *
   * This receives the previous page's number as its only argument, and should return a string.
   */
  previousPageLabel: _propTypes["default"].func,

  /**
   * Use this to shop skip-to-first-page and skip-to-last-page buttons.
   */
  showSkipArrows: _propTypes["default"].bool
} : {};
var _default = Pagination;
exports["default"] = _default;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(541),
    baseFlatten = __webpack_require__(240),
    baseRest = __webpack_require__(241),
    isArrayLikeObject = __webpack_require__(242);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(127),
    arrayIncludes = __webpack_require__(237),
    arrayIncludesWith = __webpack_require__(239),
    arrayMap = __webpack_require__(120),
    baseUnary = __webpack_require__(219),
    cacheHas = __webpack_require__(128);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(82),
    isArguments = __webpack_require__(130),
    isArray = __webpack_require__(40);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(546);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(548),
    shortOut = __webpack_require__(551);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(549),
    defineProperty = __webpack_require__(550),
    identity = __webpack_require__(134);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(240),
    baseRest = __webpack_require__(241),
    baseUniq = __webpack_require__(243),
    isArrayLikeObject = __webpack_require__(242);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(220),
    noop = __webpack_require__(27),
    setToArray = __webpack_require__(129);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    paginationNumberWidth: 24,
    paginationNumberHeight: 24,
    paginationNumberColorDefault: tokens.themeForegroundAccentDefault,
    paginationNumberColorSelected: tokens.themeForegroundPrimaryDefault,
    paginationNumberColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationNumberSpacingInsetVertical: 2,
    paginationNumberSpacingInsetHorizontal: 8,
    paginationIndicatorBorderWidth: 2,
    paginationIndicatorBorderRadius: 999,
    paginationIndicatorHeight: 4,
    paginationIndicatorColorDefault: tokens.themeForegroundAccentDefault,
    paginationIndicatorColorHover: tokens.themeBorderAccentHover,
    paginationIndicatorColorPressed: tokens.themeBorderAccentPressed,
    paginationArrowColor: tokens.themeForegroundAccentDefault,
    paginationEllipseWidth: 24,
    paginationEllipseHeight: 14,
    paginationEllipseColorDefault: tokens.themeForegroundAccentDefault,
    paginationEllipseColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationMotionDuration: "100ms",
    paginationMotionFunction: "ease"
  }
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _chevronLeftSmall = _interopRequireDefault(__webpack_require__(244));

var _chevronDoubleRight = _interopRequireDefault(__webpack_require__(556));

var _chevronDoubleLeft = _interopRequireDefault(__webpack_require__(557));

var _theme = _interopRequireDefault(__webpack_require__(7));

var _row = _interopRequireDefault(__webpack_require__(17));

var _button = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/prop-types */
var ArrowControls = function ArrowControls(_ref) {
  var direction = _ref.direction,
      numberOfPages = _ref.numberOfPages,
      showSkipArrows = _ref.showSkipArrows,
      disabled = _ref.disabled,
      currentPage = _ref.currentPage,
      onChange = _ref.onChange,
      arrowColor = _ref.arrowColor,
      nextPageLabel = _ref.nextPageLabel,
      previousPageLabel = _ref.previousPageLabel,
      lastPageLabel = _ref.lastPageLabel,
      firstPageLabel = _ref.firstPageLabel;
  var overrideTokens = (0, _react.useMemo)(function () {
    return {
      buttonForegroundColorIconLightBackdropDefault: arrowColor,
      buttonForegroundColorIconDarkBackdropDefault: arrowColor
    };
  }, [arrowColor]);
  return direction === "right" ? /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage + 1);
    },
    disabled: disabled || currentPage === numberOfPages
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"]
  }, nextPageLabel(currentPage + 1))), showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(numberOfPages);
    },
    disabled: disabled || currentPage >= numberOfPages - 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleRight["default"]
  }, lastPageLabel(numberOfPages))))) : /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(1);
    },
    disabled: disabled || currentPage <= 2
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleLeft["default"]
  }, firstPageLabel(1))), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage - 1);
    },
    disabled: disabled || currentPage === 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronLeftSmall["default"]
  }, previousPageLabel(currentPage - 1)))));
};

var _default = ArrowControls;
exports["default"] = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleRightData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightWidth: 13,
  iconChevronDoubleRightHeight: 10
};

/***/ }),
/* 557 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleLeftData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftWidth: 13,
  iconChevronDoubleLeftHeight: 10
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _focus = _interopRequireDefault(__webpack_require__(227));

var _text = _interopRequireDefault(__webpack_require__(22));

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var indicatorStyle = function indicatorStyle(t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    position: "absolute !important",
    display: "inline-block",
    height: t("indicatorHeight"),
    left: t("numberSpacingInsetHorizontal"),
    right: t("numberSpacingInsetHorizontal"),
    borderRadius: t("indicatorBorderRadius"),
    backgroundColor: selected ? t("indicatorColor", "default") : "transparent",
    "button:hover &": !disabled && {
      backgroundColor: t("indicatorColorHover")
    },
    "button:active &": !disabled && {
      backgroundColor: t("indicatorColorPressed")
    },
    transition: t.transitionCss("motion", "background-color")
  });
};

var pageButtonStyle = function pageButtonStyle(t) {
  return (0, _emotion.css)({
    position: "relative",
    // HACK: This is necessary for the absolutely positioned indicator to show
    // up in IE11. See https://stackoverflow.com/questions/38235418/div-inside-button-not-working-as-expected-in-ie
    overflow: "visible",
    padding: "0 ".concat(t("numberSpacingInsetHorizontal"), "px"),
    textAlign: "center",
    "& > span": {
      display: "block"
    }
  });
};

var textStyle = function textStyle(t, _ref2) {
  var focus = _ref2.focus,
      selected = _ref2.selected,
      disabled = _ref2.disabled;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // We check for selected first because selected numbers still appear
    // enabled even if the button itself is disabled
    color: t("numberColor", selected ? "selected" : disabled ? "disabled" : "default"),
    transition: t.transitionCss("motion", "color"),
    margin: "".concat(t("numberSpacingInsetVertical"), "px 0"),
    minWidth: t("numberWidth"),
    outline: "none",
    width: "100%"
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1
  }));
};
/* eslint-disable react/prop-types */


var PageButton = function PageButton(_ref3) {
  var value = _ref3.children,
      onChange = _ref3.onChange,
      selected = _ref3.selected,
      disabled = _ref3.disabled,
      pageLabel = _ref3.pageLabel,
      currentPageLabel = _ref3.currentPageLabel,
      locale = _ref3.locale,
      t = _ref3.t;
  return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref4) {
    var focus = _ref4.focus,
        focusTrigger = _ref4.focusTrigger,
        focusProps = _ref4.focusProps;
    return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
      onClick: function onClick() {
        return !disabled && onChange(value);
      },
      className: pageButtonStyle(t),
      disabled: selected ? false : disabled,
      "aria-current": selected ? "page" : undefined,
      "aria-label": selected ? currentPageLabel(value) : pageLabel(value)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: textStyle(t, {
        selected: selected,
        disabled: disabled,
        focus: focus && focusTrigger === "keyboard"
      })
    }, value.toLocaleString(locale)), /*#__PURE__*/_react["default"].createElement("div", {
      className: indicatorStyle(t, {
        selected: selected,
        disabled: disabled
      })
    }));
  });
};
/* eslint-enable react/prop-types */


var _default = PageButton;
exports["default"] = _default;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _menuMeatball = _interopRequireDefault(__webpack_require__(143));

var _token = __webpack_require__(8);

var _getIconCss = _interopRequireDefault(__webpack_require__(86));

var menuMeatball = (0, _token.getIconFromTokens)(_menuMeatball["default"]);

var ellipseStyle = function ellipseStyle(t, _ref) {
  var disabled = _ref.disabled;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    backgroundImage: (0, _getIconCss["default"])(menuMeatball.data, t("ellipseColor", state)),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: t("ellipseWidth"),
    height: t("ellipseHeight")
  });
};
/* eslint-disable react/prop-types */


var Ellipse = function Ellipse(_ref2) {
  var t = _ref2.t,
      disabled = _ref2.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: ellipseStyle(t, {
      disabled: disabled
    })
  });
};
/* eslint-enable react/prop-types */


var _default = Ellipse;
exports["default"] = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _link = _interopRequireDefault(__webpack_require__(561));

var _text = _interopRequireDefault(__webpack_require__(116));

var _focusRing = _interopRequireDefault(__webpack_require__(209));

var _getTextStyles = _interopRequireDefault(__webpack_require__(245));

var _theme = __webpack_require__(7);

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _token = __webpack_require__(8);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled;

  var _focusRingTokens = (0, _focusRing["default"])(t.tokens),
      focusRingWidth = _focusRingTokens.focusRingWidth,
      focusRingColorFocus = _focusRingTokens.focusRingColorFocus;

  return (0, _emotion.css)({
    display: "inline",
    // HACK: Use !important to override the color set by the text styles
    color: "".concat(t("foregroundColor", disabled ? "disabled" : "default"), " !important"),
    textDecoration: type === "primary" ? "underline" : "none",
    transition: t.transitionCss("motion", "color"),
    // Use custom focus rings styles that will work even if the link wraps
    // across multiple lines.
    // NOTE: IE11 doesn't support outline-offset so the focus ring will
    // be tighter in that browser. The alternative would be to use our
    // previous multiple-box-shadow approach, but that has other issues
    // because it has to make an assumption about the background color
    // behind the link.
    outline: focus ? "".concat(focusRingWidth, "px solid ").concat(focusRingColorFocus) : undefined,
    outlineOffset: 2,
    ":hover": !disabled && {
      color: "".concat(t("foregroundColorHover"), " !important"),
      textDecoration: type === "secondary" ? "underline" : undefined
    },
    ":active": !disabled && {
      color: "".concat(t("foregroundColorPressed"), " !important")
    }
  }, (0, _getTextStyles["default"])((0, _token.getTokenHelper)("text")((0, _text["default"])(t.tokens)), {}));
}, ["type", "focus", "disabled"]);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_link["default"], "link");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, passThroughProps, {
    className: styles(t, {
      type: props.type,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard"
    }),
    target: props.target,
    rel: props.rel,
    disabled: props.disabled,
    href: props.href,
    onClick: props.onClick,
    tabIndex: props.tabIndex,
    download: props.download,
    propagateClickEvent: props.propagateClickEvent,
    tag: "a",
    ref: ref,
    "mdn-link": ""
  }), props.children);
});

Link.displayName = "Link";
Link.propTypes =  false ? {
  /**
   * The contents of the link. Plain text recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See the [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download) for details.
   * This string should be the file name which should be downloaded. If set to an empty string the browser
   * will default to file name (e.g. a file downloaded from `site.com/picture.jpg` will be named `picture.jpg`).
   */
  download: _propTypes["default"].string,

  /**
   * The URL that the link points to.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the link.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
Link.defaultProps = {
  type: "primary"
};
var _default = Link;
exports["default"] = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    linkForegroundColorDefault: tokens.themeForegroundAccentDefault,
    linkForegroundColorHover: tokens.themeForegroundAccentHover,
    linkForegroundColorPressed: tokens.themeForegroundAccentPressed,
    linkForegroundColorDisabled: tokens.themeBorderAccentDisabled,
    linkMotionDuration: "100ms",
    linkMotionFunction: "ease"
  }
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _statusTag = _interopRequireDefault(__webpack_require__(563));

var _dismissibleTag = _interopRequireDefault(__webpack_require__(565));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var Tag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return props.onClose && (props.type === "theme" || props.type === "neutral") && props.children ? /*#__PURE__*/_react["default"].createElement(_dismissibleTag["default"], (0, _extends2["default"])({
    onClose: props.onClose,
    closeLabel: props.closeLabel,
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex
  }, passThroughProps), props.children) : /*#__PURE__*/_react["default"].createElement(_statusTag["default"], (0, _extends2["default"])({
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex
  }, passThroughProps), props.children);
});

Tag.displayName = "Tag";
Tag.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The tag's label. Omit this to render a compact tag.
   */
  children: _propTypes["default"].string,

  /**
   * An accessible label for the tag's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * @since 5.14.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The visual style of the tag.
   */
  type: _propTypes["default"].oneOf(["theme", "neutral", "success", "warning", "error"]),

  /**
   * If `type` is set to `"theme"` or `"neutral"`, a function can be provided
   * here to render a dismissable tag.
   *
   * This prop will be ignored for compact tags (if `children` is not set) or
   * for tags that are not of type `"theme"` or `"neutral"`.
   */
  onClose: _propTypes["default"].func
} : {};
Tag.defaultProps = {
  type: "theme"
};
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _tag = _interopRequireDefault(__webpack_require__(144));

var _theme = __webpack_require__(7);

var _buttonReset = _interopRequireDefault(__webpack_require__(206));

var _token = __webpack_require__(8);

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _text = _interopRequireDefault(__webpack_require__(22));

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _indicator = _interopRequireDefault(__webpack_require__(564));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

/**
 * Styles
 */
var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus;
  return (0, _emotion.css)({
    // HACK: This is necessary to keep IE11 from allowing the tag's text to overflow
    // the boundaries of the tag. When we drop IE11 support this wrapper can be
    // removed and the "display" property of the styles below can be changed from
    // "inline-block" to "inline-flex" and other styles can move to `styles`.
    display: "inline-block"
  }, {
    outline: "none",
    "& > div > div": (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      offset: t("focusOutlineOffset"),
      borderRadius: t("borderRadius"),
      borderWidth: t("borderWidth"),
      dropShadow: t.boxShadowCss("dropShadowHover")
    })
  });
}, ["focus"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      children = _ref2.children;
  return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: t("height"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  }, children === undefined ? {
    width: t("height"),
    "& > div": {
      borderRadius: t("borderCompactRadius"),
      borderWidth: t("borderCompactWidth"),
      borderStyle: "solid",
      borderColor: t("borderColorCompact"),
      boxSizing: "border-box"
    }
  } : (0, _defineProperty2["default"])({
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderStyle: "solid",
    borderColor: t("borderColorStatus", type),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetStatusLeft"),
    //   paddingInlineEnd: t("spacingInsetStatusRight"),
    // },
    paddingRight: t("spacingInsetStatusRight"),
    paddingLeft: t("spacingInsetStatusLeft")
  }, "[dir=\"rtl\"] &", {
    paddingLeft: t("spacingInsetStatusRight"),
    paddingRight: t("spacingInsetStatusLeft")
  }));
}, ["type", "children"]);
/**
 * Component
 */

var StatusTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var compact = typeof props.children === "undefined" ? true : false;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: wrapperStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    }),
    ref: ref,
    "aria-label": props["aria-label"],
    tabIndex: props.tabIndex
  }, passThroughProps, focusProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  }, /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
    type: props.type,
    compact: compact
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.children)));
});

StatusTag.displayName = "StatusTag";
StatusTag.propTypes =  false ? {
  "aria-label": _propTypes["default"].string,
  children: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
StatusTag.defaultProps = {
  type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tag = _interopRequireDefault(__webpack_require__(144));

var _theme = __webpack_require__(7);

/**
 * Styles
 */
var styles = function styles(t, _ref) {
  var _css;

  var type = _ref.type,
      compact = _ref.compact;
  return (0, _emotion.css)((_css = {
    display: "inline-block",
    width: t("indicatorDiameter"),
    height: t("indicatorDiameter"),
    backgroundColor: t("borderColorStatus", type),
    borderRadius: t("indicatorDiameter") / 2,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: compact ? 0 : t("spacingHorizontal"),
    // },
    marginRight: compact ? 0 : t("spacingHorizontal")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginRight: 0,
    marginLeft: compact ? 0 : t("spacingHorizontal")
  }), (0, _defineProperty2["default"])(_css, "flexShrink", 0), _css));
};
/**
 * Component
 */


function Indicator(props) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  });
}

Indicator.propTypes =  false ? {
  compact: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
Indicator.defaultProps = {
  type: "theme"
};
var _default = Indicator;
exports["default"] = _default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _tag = _interopRequireDefault(__webpack_require__(144));

var _closeKnockout = _interopRequireDefault(__webpack_require__(566));

var _theme = __webpack_require__(7);

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _token = __webpack_require__(8);

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _text = _interopRequireDefault(__webpack_require__(22));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

/**
 * Styles
 */
var clickTargetSize = 20;
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _button, _css;

  var type = _ref.type;
  // This is the horizontal distance between the end of the icon and the end of the clickable,
  // on both the left and right side.
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _text["default"])(t), (_css = {
    backgroundColor: t("backgroundColorDismissible", type),
    borderRadius: t("borderRadius"),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetDismissibleLeft"),
    //   paddingInlineEnd: `calc(${iconClickableXDelta}px - ${t(
    //           "spacingInsetDismissibleRight"
    //         )}px) `,
    // },
    paddingRight: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px) "),
    paddingLeft: t("spacingInsetDismissibleLeft")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    paddingRight: t("spacingInsetDismissibleLeft"),
    paddingLeft: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px)")
  }), (0, _defineProperty2["default"])(_css, "display", "inline-flex"), (0, _defineProperty2["default"])(_css, "alignItems", "center"), (0, _defineProperty2["default"])(_css, "justifyContent", "center"), (0, _defineProperty2["default"])(_css, "height", t("height")), (0, _defineProperty2["default"])(_css, "lineHeight", "".concat(t("height"), "px")), (0, _defineProperty2["default"])(_css, "whiteSpace", "nowrap"), (0, _defineProperty2["default"])(_css, "& > button", (_button = {
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: `calc(${t("spacingHorizontal")}px - ${iconClickableXDelta}px)`,
    // },
    marginLeft: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)")
  }, (0, _defineProperty2["default"])(_button, "[dir=\"rtl\"] &", {
    marginRight: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)"),
    marginLeft: 0
  }), (0, _defineProperty2["default"])(_button, "lineHeight", 0), _button)), _css));
}, ["type"]);
var buttonStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var focus = _ref2.focus;
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: 999,
    offset: 4 - iconClickableXDelta
  }), {
    width: clickTargetSize,
    height: clickTargetSize,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center"
  });
}, ["focus"]);
var closeIconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var type = _ref3.type;
  return (0, _emotion.css)({
    width: t("closeIconSize"),
    height: t("closeIconSize"),
    color: t("closeIconColorDismissible", [type, "default"]),
    "button:hover &": {
      color: t("closeIconColorDismissible", [type, "hover"])
    },
    "button:active &": {
      color: t("closeIconColorDismissible", [type, "pressed"])
    },
    transition: t.transitionCss("closeIconMotion", "color")
  });
}, ["type"]);
/**
 * Component
 */

var DissmissibleTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, {
      type: props.type
    }),
    ref: ref,
    "aria-label": props["aria-label"]
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("span", null, props.children), /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({
    onClick: props.onClose,
    className: buttonStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    })
  }, focusProps, {
    tabIndex: props.tabIndex,
    "aria-label": props.closeLabel
  }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: closeIconStyles(t, props),
    tokens: _closeKnockout["default"]
  })));
});

DissmissibleTag.displayName = "DissmissibleTag";
DissmissibleTag.propTypes =  false ? {
  children: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  "aria-label": _propTypes["default"].string,
  closeLabel: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["theme", "neutral"])
} : {};
DissmissibleTag.defaultProps = {
  type: "theme"
};
var _default = DissmissibleTag;
exports["default"] = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseKnockoutData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.411 8.003l2.126-2.126a1 1 0 10-1.414-1.414L7.998 6.588l-2.12-2.124a1 1 0 10-1.416 1.412l2.122 2.126-2.121 2.12a1 1 0 001.414 1.415l2.12-2.12 2.115 2.12a1 1 0 101.416-1.413L9.41 8.004zM8 16A8 8 0 118 0a8 8 0 010 16z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseKnockoutWidth: 16,
  iconCloseKnockoutHeight: 16
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _popover = _interopRequireDefault(__webpack_require__(102));

var _elevation = __webpack_require__(54);

var _theme = __webpack_require__(7);

var _popoverBody = _interopRequireDefault(__webpack_require__(246));

var _popoverController = _interopRequireDefault(__webpack_require__(145));

var _utils = __webpack_require__(103);

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _rtl = __webpack_require__(39);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoize)(function (maxWidth) {
  return (0, _emotion.css)({
    overflowWrap: "break-word",
    pointerEvents: "none",
    maxWidth: maxWidth
  });
});
/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focusable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused. If you need to add context to a disabled element, consider
 * anchoring the tooltip to a help icon near the element:
 *
 * ```
 * <Row>
 *   <Button disabled={true}>Submit</Button>
 *   <Tooltip title="You can't perform this action, move along." position="right" id="submit-tooltip">
 *     <Icon tokens={helpIconTokens} tabIndex={0}>Help tooltip</Icon>
 *   </Tooltip>
 * </Row>
 * ```
 */

var Tooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hover: false,
      focus: false,
      id: _this.props.id ? _this.props.id : (0, _uniqueId["default"])("tooltip-")
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function () {
      return _this.props.open === undefined ? _this.state.hover || _this.state.focus : _this.props.open;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function (node) {
      if (node && node !== _this.anchorNode) {
        /* eslint-disable-next-line react/no-find-dom-node */
        _this.anchorNode = _reactDom["default"].findDOMNode(node); // If the Tooltip is managing state internally then bind the event
        // listeners that trigger internal state changes

        if (_this.props.open === undefined) {
          _this.addEventListeners();
        } // If the Tooltip is supposed to be open then force an update so it
        // re-renders with the anchor node


        if (_this.isOpen()) {
          _this.forceUpdate();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function () {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      _this.removeEventListeners();

      if (_this.anchorNode) {
        _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor); // NOTE: This *must* be bound using a native event listener because of a bug
        // in React: https://github.com/facebook/react/issues/4251


        _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.addEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function () {
      if (_this.anchorNode) {
        _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);

        _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.removeEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function () {
      return _this.setState({
        hover: false,
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          anchorNode = _assertThisInitialize.anchorNode; // If a user has not set an id for accessibility
      // use our own auto-generated one


      try {
        if (!anchorNode.hasAttribute("aria-controls")) {
          anchorNode.setAttribute("aria-controls", _this.state.id);
        }

        if (!anchorNode.hasAttribute("aria-describedby")) {
          anchorNode.setAttribute("aria-describedby", _this.state.id);
        }
      } catch (_) {// Silent error
      }

      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function () {
      return _this.setState({
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownAnchor", function (event) {
      if (_this.isOpen && (event.key === "Esc" || (0, _keycode["default"])(event) === "esc")) {
        _this.setState({
          focus: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If we're moving from state being managed via the `open` prop to state
      // being managed internally, bind the event listeners that trigger internal
      // state changes
      if (prevProps.open === undefined && this.props.open !== undefined) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          maxWidth = _this$props.maxWidth,
          children = _this$props.children;
      var position = (0, _rtl.getHorizontalDirection)(this.props.position);
      var anchorNode = this.anchorNode;
      var oppositePosition = (0, _utils.flipAlignment)(position);
      var vertical = position === "top" || position === "bottom";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);

      var popover = /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _popover["default"],
        map: (0, _token.getTokenHelper)("popover"),
        key: "popover"
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: _this2.isOpen(),
          anchorNode: anchorNode,
          anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
          popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
          offsetVertical: vertical ? t("offsetWithArrow") : 0,
          offsetHorizontal: vertical ? 0 : t("offsetWithArrow")
        }, function (_ref) {
          var popoverStyle = _ref.popoverStyle,
              popoverOrigin = _ref.popoverOrigin,
              anchorOrigin = _ref.anchorOrigin,
              anchorRect = _ref.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, passThroughProps, {
            type: "fill",
            spacingInset: "small",
            zIndex: _elevation.elevationTooltip,
            className: "".concat(styles(maxWidth), " ").concat(popoverStyle),
            id: _this2.props.id ? _this2.props.id : (0, _uniqueId["default"])("tooltip-")
          }, _popoverBody["default"].generateArrowProps({
            popoverOrigin: popoverOrigin,
            anchorOrigin: anchorOrigin,
            anchorRect: anchorRect
          })), title);
        });
      });

      var child = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(child, {
        ref: this.updateAnchorNode
      }), popover);
    }
  }]);
  return Tooltip;
}(_react["default"].Component);

Tooltip.propTypes =  false ? {
  /**
   * The element that the tooltip should reference.
   *
   * The tooltip will point at this element, and will be triggered when the
   * user hovers over this element or focuses on it.
   *
   * This element must accept a [ref](https://reactjs.org/docs/refs-and-the-dom.html),
   * and should be focuseable to ensure that the tooltip is accessible to keyboard
   * users.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * The position of the tooltip relative to the anchor element (provided via
   * `children`).
   *
   * Note that the tooltip may reposition itself to the opposite side of the
   * element if there is not enough screen space to display itself in the
   * position identified here.
   */
  position: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start"]).isRequired,

  /**
   * The content shown in the tooltip.
   */
  title: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Tooltip component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum width of the tooltip using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If defined this will determine whether the tooltip is open or closed. If
   * omitted the tooltip will manage it's own state.
   *
   * Use this sparingly, in most cases the tooltip's internal state management
   * will correctly determine when it should open and close.
   */
  open: _propTypes["default"].bool
} : {};
Tooltip.defaultProps = {
  maxWidth: 300
};
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _typeof2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _capitalize = _interopRequireDefault(__webpack_require__(569));

var _emotion = __webpack_require__(4);

var _popover = _interopRequireDefault(__webpack_require__(102));

var _elevation = __webpack_require__(54);

var _theme = __webpack_require__(7);

var _utils = __webpack_require__(103);

var _token = __webpack_require__(8);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _text = _interopRequireDefault(__webpack_require__(22));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverArrowWidth = _getUnthemedTokens.popoverArrowWidth; // Takes an edge (e.g. "top") and turns it into a CSS border property (e.g.
// "borderTop").


var edgeToBorder = function edgeToBorder(edge) {
  return "border".concat((0, _capitalize["default"])(edge));
}; // Takes an edge (e.g. "top") and a CSS length (e.g. "5px") and creates a
// CSS translation function (e.g. "translateY(5px)") that can be added to an
// element  via the CSS "transform" property.


var edgeToTransform = function edgeToTransform(edge, amount) {
  return "translate".concat(edge === "left" || edge === "right" ? "X" : "Y", "(").concat(amount, ")");
}; // These styles are used to create the little arrow that points away from the
// popover. The method used to create the triangles involves psuedo elements
// with different transparent borders applied to certain sides. A good demo of
// this method can be found here: https://codepen.io/chriscoyier/pen/lotjh. The
// benefit of this method is that it doesn't require any images, but the
// downside is that you can't apply a border to the triangle. To get around
// this a border is faked by placing a slightly offset background-colored
// triangle (the :after pseudo element) on top of a border-colored triangle (the
// :before pseudo element).


var arrowStyles = function arrowStyles(t, _ref) {
  var _afterBefore, _before, _after;

  var type = _ref.type,
      arrowPosition = _ref.arrowPosition,
      arrowAlignment = _ref.arrowAlignment,
      arrowOffset = _ref.arrowOffset;
  var backgroundColor = t("backgroundColor", type);
  var borderColor = t("borderColor", type);
  var borderWidth = t("borderWidth");
  var arrowHeight = t("arrowHeight");
  var arrowWidthHalf = t("arrowWidth") / 2; // This is the edge of the popover (either "top" or "left") that is parallel
  // to the direction the arrow is pointing.

  var arrowParallelEdge = arrowPosition === "top" || arrowPosition === "bottom" ? "left" : "top"; // This is the edge of the popover that is opposite the edge that the arrow
  // is positioned on.

  var arrowOppositeEdge = (0, _utils.flipAlignment)(arrowPosition); // This uses maths to determine how far we have to scoot the fill triangle
  // along its axis to reveal exactly `borderWidth` pixels of the border
  // triangle along a line that is perpendicular to the edges of both triangles.

  var fillTriangleOffset = borderWidth / Math.sin(Math.atan(arrowWidthHalf / arrowHeight)); // This translates the arrow in the direction orthogonal to the direction that
  // the arrow is pointing (i.e. left/right for an arrow pointing up/down or
  // up/down for an arrow pointing left/right).

  var orthogonalTransform = function orthogonalTransform(alignment) {
    return {
      top: ["".concat(arrowOffset, "px")],
      left: ["".concat(arrowOffset, "px")],
      right: ["-".concat(arrowOffset, "px"), "-100%"],
      bottom: ["-".concat(arrowOffset, "px"), "-100%"],
      center: ["".concat(arrowOffset, "px"), "-50%"]
    }[alignment].map(function (amount) {
      return edgeToTransform(arrowParallelEdge, amount);
    }).join(" ");
  };

  return (0, _emotion.css)({
    "&:after, &:before": (_afterBefore = {
      content: "''",
      position: "absolute",
      height: 0,
      width: 0
    }, (0, _defineProperty2["default"])(_afterBefore, arrowOppositeEdge, "100%"), (0, _defineProperty2["default"])(_afterBefore, arrowParallelEdge, {
      top: 0,
      left: 0,
      right: "100%",
      bottom: "100%",
      center: "50%"
    }[arrowAlignment]), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder(arrowParallelEdge), "".concat(arrowWidthHalf, "px solid transparent")), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder((0, _utils.flipAlignment)(arrowParallelEdge)), "".concat(arrowWidthHalf, "px solid transparent")), _afterBefore),
    // This creates a triangle with a background color that is the same color as
    // the popover's border.
    "&:before": (_before = {}, (0, _defineProperty2["default"])(_before, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(borderColor)), (0, _defineProperty2["default"])(_before, "transform", orthogonalTransform(arrowAlignment)), _before),
    // If the popover has a border then this creates a triangle that is the same
    // color as the popover's background color. This triangle is displayed on
    // top of the border colored triangle but is scooted back just a bit to
    // reveal enough of the border triangle to create a faux border around
    // itself.
    "&:after": (_after = {}, (0, _defineProperty2["default"])(_after, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(backgroundColor)), (0, _defineProperty2["default"])(_after, "transform", "".concat(orthogonalTransform(arrowAlignment), " ").concat(edgeToTransform(arrowOppositeEdge, "".concat(arrowOppositeEdge === "top" || arrowOppositeEdge === "left" ? "-" : "").concat(fillTriangleOffset, "px")))), _after)
  });
};

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      spacingInset = _ref2.spacingInset,
      zIndex = _ref2.zIndex,
      minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth,
      arrowPosition = _ref2.arrowPosition,
      arrowAlignment = _ref2.arrowAlignment,
      arrowOffset = _ref2.arrowOffset,
      allowOverflow = _ref2.allowOverflow;
  var borderColor = t("borderColor", type);
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: type
  }), {
    display: "inline-block",
    position: "relative",
    outline: "none",
    zIndex: zIndex,
    minWidth: minWidth,
    maxWidth: maxWidth,
    // Children wrapper styles
    "& > div": {
      // If this is used with the PopoverController component then a max
      // width and height will be set on the outer element of this
      // component. Setting the max width and height to "inherit" here will
      // constrain this inner element to the same width/height as its parent
      // (oddly enough max width/height "100%" won't work because CSS). This
      // ensures that scrollbars will be shown for content that overflows.
      // Without these styles this element just extends outside of its
      // parent.
      maxHeight: allowOverflow ? "inherit" : undefined,
      maxWidth: allowOverflow ? "inherit" : undefined,
      overflow: allowOverflow ? "auto" : "hidden",
      padding: spacingInset !== "none" ? "".concat(t("spacingInsetVertical", spacingInset), "px ").concat(t("spacingInsetHorizontal", spacingInset), "px") : undefined,
      backgroundColor: t("backgroundColor", type),
      borderColor: borderColor,
      borderWidth: borderColor ? t("borderWidth") : undefined,
      borderStyle: borderColor ? "solid" : undefined,
      borderRadius: t("borderRadius"),
      boxShadow: t.boxShadowCss("dropShadow")
    }
  }, arrowPosition ? arrowStyles(t, {
    type: type,
    arrowPosition: arrowPosition,
    arrowAlignment: arrowAlignment,
    arrowOffset: arrowOffset
  }) : undefined);
}, ["type", "spacingInset", "zIndex", "maxWidth", "minWidth", "arrowPosition", "arrowAlignment", "arrowOffset", "allowOverflow"]);

var PopoverBody = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_popover["default"], "popover");
  var style = (0, _typeof2["default"])(props.style) === "object" ? props.style : undefined;
  var className = "".concat((0, _cxMemoized["default"])(styles(t, props), props.className));
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  if (typeof props.style === "string") {
    className = className.concat(" ".concat(props.style));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    onKeyDown: props.onKeyDown,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    tabIndex: props.tabIndex,
    className: className,
    style: style,
    role: props.tabIndex ? "dialog" : "tooltip",
    "aria-labelledby": props.labelledById,
    "aria-expanded": props.open,
    id: props.id,
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("div", null, props.children));
}); // This helper generates the arrow props that are necessary to point a popover
// arrow at a particular anchor


PopoverBody.generateArrowProps = function (_ref3) {
  var popoverOrigin = _ref3.popoverOrigin,
      anchorOrigin = _ref3.anchorOrigin,
      anchorRect = _ref3.anchorRect,
      dir = _ref3.dir;
  var vertical = popoverOrigin.y !== anchorOrigin.y && popoverOrigin.y === (0, _utils.flipAlignment)(anchorOrigin.y);
  var arrowAlignment = vertical ? popoverOrigin.x : popoverOrigin.y; // Truncate the top and left values so that browsers can better handle
  // the positioning of the arrow relative to the anchor.
  // Without truncation we may get values like:
  // {
  //     "top": 39.09090805053711,
  //     "left": 387.2585144042969,
  //     "width": 137,
  //     "height": 40
  // }

  anchorRect.left = Math.trunc(anchorRect.left);
  anchorRect.top = Math.trunc(anchorRect.top);
  return {
    arrowAlignment: arrowAlignment,
    arrowPosition: vertical ? popoverOrigin.y : popoverOrigin.x === "end" && dir === "ltr" ? "left" : popoverOrigin.x === "end" ? "right" : popoverOrigin.x === "start" && dir === "ltr" ? "right" : popoverOrigin.x === "start" ? "left" : popoverOrigin.x,
    arrowOffset: arrowAlignment !== "center" ? anchorRect[vertical ? "width" : "height"] / 2 - popoverArrowWidth / 2 : 0
  };
};

PopoverBody.displayName = "PopoverBody";
PopoverBody.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * Set this to true to allow content to overflow with scrollbars.
   *
   * NOTE: This was added in conjunction with the `shrinkToFit` prop on the
   * Popover component. Like that prop, this prop should probably be removed in
   * the next major version and the shrink/overflow behavior made to be the
   * default behavior.
   */
  allowOverflow: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the PopoverBody component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * If you are looking to set an accessible `aria-label` for the screen reader, please see the `children` prop details.
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,
  arrowAlignment: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "center"]),
  arrowOffset: _propTypes["default"].number,

  /**
   * If this property is set then an arrow will be drawn pointing away from the
   * specified side of the popover body.
   */
  arrowPosition: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end"]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The id of an element that labels the popover body. See:
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
   */
  labelledById: _propTypes["default"].string,

  /**
   * Define a maximum width for the component. Any CSS width value is
   * acceptable.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Define a minimum width for the component. Any CSS width value is
   * acceptable.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  open: _propTypes["default"].bool,
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium"]),

  /**
   * Can either be an object (applied directly to the element's `style` attribute)
   * or a class name string (appended to the element's `class` attribute). A style
   * object is generally faster but class name allows RTL magic ✨
   */
  style: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["outline", "fill"]),
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
PopoverBody.defaultProps = {
  open: true,
  type: "outline",
  arrowAlignment: "center",
  arrowOffset: 0,
  spacingInset: "small",
  zIndex: _elevation.elevationPopover
};
var _default = PopoverBody;
exports["default"] = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(81),
    upperFirst = __webpack_require__(570);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(571);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(572),
    hasUnicode = __webpack_require__(247),
    stringToArray = __webpack_require__(574),
    toString = __webpack_require__(81);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(573);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(575),
    hasUnicode = __webpack_require__(247),
    unicodeToArray = __webpack_require__(576);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(142));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _noop = _interopRequireDefault(__webpack_require__(27));

var _popover = _interopRequireDefault(__webpack_require__(102));

var _utils = __webpack_require__(103);

var _rtl = __webpack_require__(39);

var _portal = _interopRequireDefault(__webpack_require__(146));

var _transitionController = _interopRequireDefault(__webpack_require__(248));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _parsers = __webpack_require__(57);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(138));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(104));

var _nodeBounds = __webpack_require__(234);

var _token = __webpack_require__(8);

var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// The closest a popover can be shown to the edge of the viewport
var viewportPadding = 16; // Grab the popover motion duration and function from our tokens.

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverMotionDuration = _getUnthemedTokens.popoverMotionDuration,
    popoverMotionFunction = _getUnthemedTokens.popoverMotionFunction,
    popoverClosedScale = _getUnthemedTokens.popoverClosedScale;
/**
 * Styles
 */
// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.


var styles = function styles(_ref) {
  var shrinkToFit = _ref.shrinkToFit,
      offsetHorizontal = _ref.offsetHorizontal,
      offsetVertical = _ref.offsetVertical,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      state = _ref.state,
      anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      availableSpace = _ref.availableSpace;

  // The distance to offset the popover from the anchor's left edge (changes
  // based on the anchor origin).
  var offsetFromAnchorLeft = function offsetFromAnchorLeft(_ref2) {
    var x = _ref2.x;
    return {
      left: -offsetHorizontal,
      center: anchorRect.width / 2 + offsetHorizontal,
      right: anchorRect.width + offsetHorizontal
    }[x];
  }; // The distance to offset the popover from the anchor's top edge (changes
  // based on the anchor origin).


  var offsetFromAnchorTop = {
    top: -offsetVertical,
    center: anchorRect.height / 2 + offsetVertical,
    bottom: anchorRect.height + offsetVertical
  }[anchorOrigin.y];
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    position: "fixed !important",
    boxSizing: "border-box",
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // downwards.
    top: state !== "exited" && popoverOrigin.y !== "bottom" ? anchorRect.top + offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // upwards.
    bottom: state !== "exited" && popoverOrigin.y === "bottom" ? viewportRect.height - anchorRect.top - offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its left edge if it's anchored at the
    // the left or center. This ensures long content forces the popover to
    // expand to the right.
    left: state !== "exited" && popoverOrigin.x === "left" || state !== "exited" && popoverOrigin.x === "end" || state !== "exited" && popoverOrigin.x === "center" ? anchorRect.left + offsetFromAnchorLeft({
      x: anchorOrigin.x === "end" ? "right" : anchorOrigin.x
    }) - viewportPadding : undefined,
    // Anchor the popover's position from its right edge if it's anchored at the
    // right. This ensures long content forces the popover to expand to the left.
    right: state !== "exited" && popoverOrigin.x === "right" || state !== "exited" && popoverOrigin.x === "start" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: anchorOrigin.x === "start" ? "left" : anchorOrigin.x
    }) - viewportPadding : undefined,
    transformOrigin: "".concat(popoverOrigin.y, " ").concat(popoverOrigin.x),
    opacity: state === "exited" || state === "exiting" ? 0 : 1,
    // For popovers that are anchored at their center, apply a transform to
    // ensure that the popover is positioned correctly and that long content
    // forces it to expand from the center.
    transform: "translateY(".concat(popoverOrigin.y === "center" ? "-50%" : "0%", ") translateX(").concat(popoverOrigin.x === "center" ? "-50%" : "0%", ") scale(").concat(state === "exited" || state === "exiting" ? popoverClosedScale / 100 : 1, ")"),
    transition: state === "entering" || state === "entered" || state === "exiting" ? "transform ".concat(popoverMotionDuration, " ").concat(popoverMotionFunction, ", opacity ").concat(popoverMotionDuration, " ").concat(popoverMotionFunction) : undefined,
    visibility: state === "exited" ? "hidden" : "visible",
    // Add margin on every side to make sure that the viewport padding is
    // maintained
    margin: viewportPadding,
    // If the user has specified a maxHeight then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available vertical space.
    maxHeight: state !== "exited" && shrinkToFit ? Math.min(maxHeight || availableSpace.y, availableSpace.y) : maxHeight,
    // If the user has specified a maxWidth then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available horizontal space.
    maxWidth: state !== "exited" && shrinkToFit ? Math.min(maxWidth || availableSpace.x, availableSpace.x) : maxWidth
  }, "[dir=\"rtl\"] &", {
    left: state !== "exited" && popoverOrigin.x === "start" ? anchorRect.left + offsetFromAnchorLeft({
      x: "right"
    }) - viewportPadding : popoverOrigin.x === "end" ? "inherit" : undefined,
    right: state !== "exited" && popoverOrigin.x === "end" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: "left"
    }) - viewportPadding : popoverOrigin.x === "start" ? "inherit" : undefined
  }));
};
/**
 * This component handles the positioning of popover content in relation to
 * another element (the "anchor" element). It allows you to "stick" the popover
 * to the anchor element.
 *
 * This component has two real benefits over a simple absolute-positing strategy
 * for popover content. First, it renders popover content at the root of the DOM
 * using portals. This allows popovers to break out of the anchor element's
 * parent containers regardless of any overflow/scroll styles on those
 * containers. Second, this component will automatically re-position and re-size
 * the popover content based on the available space in the viewport. This
 * ensures that the content in the popover will be as accessible to the user as
 * possible.
 *
 * This component does not actually render anything to the DOM. It simply
 * generates the styles necessary to correctly position the popover. The styles
 * are passed via render props to the component's children so that the user can
 * render the popover exactly how they want to. This requires that the user set
 * the style prop on their popover element to the `popoverStyle` render prop
 * returned by this component.
 */


var PopoverController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PopoverController, _React$Component);

  var _super = _createSuper(PopoverController);

  function PopoverController() {
    var _this;

    (0, _classCallCheck2["default"])(this, PopoverController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // Should we render the popover's children? We don't when the popover is
      // closed to avoid unnecessary work.
      render: false,
      // The bounding rectangle for the anchor node.
      anchorRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the popover node.
      popoverRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the viewport.
      viewportRect: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorRect", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          anchorNode = _this$props.anchorNode;

      if (open) {
        /* eslint-disable-next-line react/no-find-dom-node */
        var anchorDomNode = _reactDom["default"].findDOMNode(anchorNode);

        var anchorRect = (0, _nodeBounds.getNodeBounds)(anchorDomNode);

        if (!(0, _nodeBounds.compareNodeBounds)(anchorRect, _this.state.anchorRect)) {
          _this.setState({
            anchorRect: anchorRect
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateViewportRect", function () {
      var viewportRect = (0, _nodeBounds.getNodeBounds)(window);

      if (!(0, _nodeBounds.compareNodeBounds)(viewportRect, _this.state.viewportRect)) {
        _this.setState({
          viewportRect: viewportRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePopoverRect", function () {
      var popoverRect = (0, _nodeBounds.getNodeBounds)(_this.popoverNode);

      if (!(0, _nodeBounds.compareNodeBounds)(popoverRect, _this.state.popoverRect)) {
        _this.setState({
          popoverRect: popoverRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeWindow", function () {
      _this.updateViewportRect();

      _this.updateAnchorRect();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function (event) {
      var open = _this.props.open;

      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          popoverNode = _assertThisInitialize.popoverNode; // If the popover is open and the scroll event came from *outside* the
      // popover then assume the anchor element moved (and an update is needed for
      // the anchor rect).


      if (open && (!popoverNode || !popoverNode.contains(event.target))) {
        _this.updateAnchorRect();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      _this.props.onBeforeOpen();

      _this.setState({
        render: true
      }, function () {
        // Give the children a chance to settle before poking through the DOM
        _this.cancelAnimationFrame = (0, _waitAnimationFrame["default"])(function () {
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.popoverNode = _reactDom["default"].findDOMNode((0, _assertThisInitialized2["default"])(_this));

          _this.updateViewportRect();

          _this.updateAnchorRect();

          _this.updatePopoverRect();

          _this.addEventListeners();

          done();
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function (done) {
      _this.props.onOpen(_this.popoverNode);

      done();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      _this.props.onClose(_this.popoverNode);

      _this.removeEventListeners();

      _this.setState({
        render: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(PopoverController, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners just to be safe
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.onScroll, true)); // Listen for resize events from the window

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.onResizeWindow));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.open && Boolean(this.props.anchorNode)) {
        /* eslint-disable-next-line react/no-find-dom-node */
        this.onBeforeOpen(function () {
          return _this2.onOpen(_noop["default"]);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();

      if (this.cancelAnimationFrame) {
        this.cancelAnimationFrame();
      }

      clearTimeout(this.blurTimeout);
      clearTimeout(this.animationTimeout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var anchorNode = this.props.anchorNode;

      if (anchorNode !== prevProps.anchorNode) {
        this.updateAnchorRect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded); // HACK: 'dir' is used for RTL support to swap Popover to the opposite side.
      // Until we have a fully CSS-based solution for supporting RTL in the
      // Popover we have to take advantage of canUseDom. This dir prop
      // allows us to dynamically update start/end values to left/right
      // or right/left depending on the direction of the layout.

      var dir = (0, _rtl.getDOMDirection)(props.anchorNode); // HACK: For RTL, swap the anchorOrigin x direction.
      // EG: "center right" will become "center left".
      // Since we need to utilize canUseDom, the easiest way to swap
      // Popover in an RTL context (without doing a complete rewrite
      // to make the Popover entirely CSS-based using Emotion) is to
      // check whether the dom direction is RTL and if it is to
      // essentially swap all "left" to "right" and "right" to "left".

      var oppositeAnchorOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.anchorOrigin.split(" ")[1]));
      var newAnchorOrigin = dir === "rtl" ? "".concat(this.props.anchorOrigin.split(" ")[0], " ").concat(oppositeAnchorOriginXDirection) : this.props.anchorOrigin; // HACK: For RTL, swap the popoverOrigin x direction.
      // EG: "center right" will become "center left"

      var oppositePopoverOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.popoverOrigin.split(" ")[1]));
      var newPopoverOrigin = dir === "rtl" ? "".concat(this.props.popoverOrigin.split(" ")[0], " ").concat(oppositePopoverOriginXDirection) : this.props.popoverOrigin;
      var _this$state = this.state,
          anchorRect = _this$state.anchorRect,
          popoverRect = _this$state.popoverRect,
          viewportRect = _this$state.viewportRect,
          render = _this$state.render;

      var _getBestOrigin = (0, _utils.getBestOrigin)({
        anchorOrigin: (0, _parsers.parseAlignment)(newAnchorOrigin),
        popoverOrigin: (0, _parsers.parseAlignment)(newPopoverOrigin),
        extraSpace: {
          x: props.offsetHorizontal + viewportPadding,
          y: props.offsetVertical + viewportPadding
        },
        anchorRect: anchorRect,
        popoverRect: popoverRect,
        viewportRect: viewportRect
      }),
          anchorOrigin = _getBestOrigin.anchorOrigin,
          popoverOrigin = _getBestOrigin.popoverOrigin,
          availableSpace = _getBestOrigin.availableSpace;

      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open && Boolean(props.anchorNode),
        duration: parseInt(popoverMotionDuration),
        onBeforeEnter: this.onBeforeOpen,
        onEnter: this.onOpen,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? /*#__PURE__*/_react["default"].createElement(_portal["default"], null, children({
          popoverState: state,
          popoverStyle: styles({
            shrinkToFit: props.shrinkToFit,
            offsetHorizontal: props.offsetHorizontal,
            offsetVertical: props.offsetVertical,
            maxHeight: props.maxHeight,
            maxWidth: props.maxWidth,
            state: state,
            anchorOrigin: anchorOrigin,
            popoverOrigin: popoverOrigin,
            anchorRect: anchorRect,
            popoverRect: popoverRect,
            viewportRect: viewportRect,
            availableSpace: availableSpace
          }),
          popoverOrigin: popoverOrigin,
          anchorOrigin: anchorOrigin,
          anchorRect: anchorRect
        })) : null;
      });
    }
  }]);
  return PopoverController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(PopoverController, "defaultProps", {
  offsetHorizontal: 0,
  offsetVertical: 0,
  onBeforeOpen: _noop["default"],
  onOpen: _noop["default"],
  onClose: _noop["default"]
});
PopoverController.propTypes =  false ? {
  anchorOrigin: _propTypes2["default"].alignment.isRequired,
  children: _propTypes["default"].func.isRequired,
  popoverOrigin: _propTypes2["default"].alignment.isRequired,

  /**
   * Any dom node or React element is valid here, but it's recommended that
   * you add a ref to the React element you want to anchor the popover to and
   * then pass the result in here.
   *
   * This anchor node is required in order to open the popover, but is not
   * required to render a closed popover. This allows you to render an
   * instance of `<PopoverController />` while you're still waiting for a ref
   * to your anchor element.
   *
   * NOTE: When you add a callback ref to an element avoid using inline
   * functions, as they can result in the ref flipping to `null` which can
   * break popover positioning:
   * https://reactjs.org/docs/refs-and-the-dom.html#caveats-with-callback-refs
   */
  anchorNode: _propTypes["default"].object,
  maxHeight: _propTypes["default"].number,
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  offsetHorizontal: _propTypes["default"].number,
  offsetVertical: _propTypes["default"].number,
  open: _propTypes["default"].bool,

  /**
   * If set to true the controller will attempt to resize the popover if there
   * is not enough space to display it at its natural size.
   */
  shrinkToFit: _propTypes["default"].bool,
  onBeforeOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
var _default = PopoverController;
exports["default"] = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _canUseDom = _interopRequireDefault(__webpack_require__(118));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Portal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    (0, _classCallCheck2["default"])(this, Portal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }

      this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!_canUseDom["default"]) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement("div");
        document.body.appendChild(this.defaultNode);
      }

      return /*#__PURE__*/_reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(_react["default"].Component);

Portal.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,
  node: _propTypes["default"].any
} : {};
var _default = Portal;
exports["default"] = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(104));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noopWithCallback = function noopWithCallback(callback) {
  return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */


var TransitionController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TransitionController, _React$Component);

  var _super = _createSuper(TransitionController);

  function TransitionController() {
    var _this;

    (0, _classCallCheck2["default"])(this, TransitionController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      state: _this.props["in"] ? "entered" : "exited"
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function (callback, skip) {
      if (skip) {
        callback();
      } else {
        _this.cancelWait();

        _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function (callback) {
      var timeout;

      _this.cancelWait();

      _this.cancelWait = function () {
        return clearTimeout(timeout);
      };

      timeout = setTimeout(callback, _this.props.duration);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function (func) {
      return function (callback) {
        _this.callback = callback;
        func(function () {
          if (_this.callback === callback) {
            callback();
          }
        });
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(TransitionController, [{
    key: "transition",
    value:
    /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */
    function transition(_ref) {
      var _this2 = this;

      var onBefore = _ref.onBefore,
          onTransition = _ref.onTransition,
          onAfter = _ref.onAfter,
          stateDuring = _ref.stateDuring,
          stateAfter = _ref.stateAfter;
      var onBeforeWithCallback = this.withCallback(onBefore);
      var onTransitionWithCallback = this.withCallback(onTransition);
      this.cancelWait();
      onBeforeWithCallback(function () {
        return _this2.waitAnimationFrame(function () {
          return _this2.setState({
            state: stateDuring
          }, function () {
            return _this2.waitAnimationFrame(function () {
              return onTransitionWithCallback(function () {
                return _this2.waitDuration(function () {
                  return _this2.setState({
                    state: stateAfter
                  }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                });
              });
            }, // Don't wait an extra animation frame if no onTransition hook is
            // provided
            onTransition === noopWithCallback);
          });
        }, // Don't wait an extra animation frame if no onBefore hook is provided
        onBefore === noopWithCallback);
      });
    }
  }, {
    key: "transitionIn",
    value: function transitionIn() {
      this.transition({
        onBefore: this.props.onBeforeEnter,
        onTransition: this.props.onEnter,
        onAfter: this.props.onAfterEnter,
        stateDuring: "entering",
        stateAfter: "entered"
      });
    }
  }, {
    key: "transitionOut",
    value: function transitionOut() {
      this.transition({
        onBefore: this.props.onBeforeExit,
        onTransition: this.props.onExit,
        onAfter: this.props.onAfterExit,
        stateDuring: "exiting",
        stateAfter: "exited"
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props["in"] && !prevProps["in"]) {
        this.transitionIn();
      } else if (!this.props["in"] && prevProps["in"]) {
        this.transitionOut();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelWait();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.state);
    }
  }]);
  return TransitionController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
  onBeforeEnter: noopWithCallback,
  onEnter: noopWithCallback,
  onAfterEnter: _noop["default"],
  onBeforeExit: noopWithCallback,
  onExit: noopWithCallback,
  onAfterExit: _noop["default"]
});
TransitionController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  duration: _propTypes["default"].number.isRequired,
  "in": _propTypes["default"].bool.isRequired,

  /**
   * Called right after the state has changed to "entered".
   */
  onAfterEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited".
   */
  onAfterExit: _propTypes["default"].func,

  /**
   * Called right before the state will change from "exited" to "entering".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeEnter: _propTypes["default"].func,

  /**
   * Called right before the state will change from "entered" to "exiting".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeExit: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "entering". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onExit: _propTypes["default"].func
} : {};
var _default = TransitionController;
exports["default"] = _default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _emotion = __webpack_require__(4);

var _input = _interopRequireDefault(__webpack_require__(249));

var _theme = __webpack_require__(7);

var _inputBox = _interopRequireDefault(__webpack_require__(250));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(251));

var _inputReset = _interopRequireDefault(__webpack_require__(252));

var _token = __webpack_require__(8);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(253));

var _functional = __webpack_require__(19);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
var inputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      disabled = _ref2.disabled,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("foregroundColor", disabled ? "disabled" : "default"),
    placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
  }), {
    height: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    textOverflow: "ellipsis"
  });
}, ["size", "disabled", "empty"]);
var inputModes = {
  email: "email",
  // TODO: Add number -> decimal in 6.x. We can't add inside 5.x because some mobile
  // browsers do not show the minus sign for inputmode="decimal" which could break
  // end-user interaction.
  // number: "decimal",
  search: "search",
  tel: "tel",
  text: "text",
  url: "url"
};

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focusState = _useState2[0],
      setFocusState = _useState2[1];

  var inputRef = (0, _react.useRef)();
  var idProp = props.id;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("input-");
  }, [idProp]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // Make sure we never allow a value of `undefined` or `null`, which would put
  // the underlying input element in an uncontrolled state and allow the DOM and
  // the component to get out of sync.

  var value = props.value === undefined || props.value === null ? "" : props.value;
  var focus = props.focus !== undefined ? props.focus : focusState;
  var mask = props.type === "password" ? undefined : props.mask;
  var empty = value === "" && (!mask || !focus);
  var onChangeProp = props.onChange,
      onFocusProp = props.onFocus,
      onBlurProp = props.onBlur;
  var onChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    var pattern = mask ? undefined : props.pattern ? props.pattern : props.type === "number" ? /^(-?)([0-9]*)(\.?)([0-9]*)$/ : undefined;

    if (!props.disabled && (!pattern || value === "" || value.match(pattern))) {
      onChangeProp(value);
    }
  }, [props.pattern, props.type, props.disabled, mask, onChangeProp]);
  /**
   * Focus on the input anytime the user mouses down on the container. This
   * mimicks the default browser behavior when a user mouses down on an input.
   */

  var onMouseDownContainer = (0, _react.useCallback)(function (event) {
    if (inputRef.current && event.target !== inputRef.current) {
      event.preventDefault();
      inputRef.current.focus();
    }
  }, [inputRef]);
  var onFocus = (0, _react.useCallback)(function (event) {
    setFocusState(true);
    onFocusProp(event);
  }, [setFocusState, onFocusProp]);
  var onBlur = (0, _react.useCallback)(function (event) {
    setFocusState(false);
    onBlurProp(event);
  }, [setFocusState, onBlurProp]);
  var prefixId = props.prefix ? "".concat(id, "-prefix") : undefined;
  var suffixId = props.suffix ? "".concat(id, "-suffix") : undefined; // If there is not helperText, constraintText, errorMessage, prefix,
  // or suffix then the aria-describedby is empty.

  var ariaDescribedbyProp = {
    "aria-describedby": passThroughProps["aria-describedby"] ? passThroughProps["aria-describedby"] : props.helperText || props.constraintText || props.errorMessage || prefixId || suffixId ? [prefixId, suffixId, (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    })].filter(Boolean).join(" ") : undefined
  };

  var inputProps = _objectSpread(_objectSpread({
    "aria-label": props.label
  }, passThroughProps), {}, {
    onFocus: onFocus,
    onBlur: onBlur,
    className: (0, _emotion.cx)(inputStyles(t, _objectSpread(_objectSpread({}, props), {}, {
      empty: empty
    })), props.className),
    id: id,
    // HACK: https://sim.amazon.com/issues/P17584529
    type: props.type === "number" ? "text" : props.type,
    placeholder: props.placeholder,
    value: value,
    onChange: onChange,
    disabled: props.disabled,
    name: props.name,
    autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
    autoComplete: props.autoFill ? undefined : "off",
    onKeyDown: props.onKeyDown,
    spellCheck: props.spellcheck,
    inputMode: props.inputMode || inputModes[props.type],
    role: props.role
  }, ariaDescribedbyProp); // react-input-mask only supports callback refs, so we have to wrap our object
  // ref in a callback to make it happy.


  var maskInputRef = (0, _react.useCallback)(function (node) {
    return inputRef.current = node;
  }, [inputRef]); // Pass our internal inputRef on up to the forwarded ref. This allows us to
  // use the input ref internally (e.g. see onMouseDownContainer) and still give
  // the parent access to it.

  (0, _react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  }, [inputRef]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_inputBox["default"], {
    size: props.label ? "xlarge" : props.size,
    label: props.label,
    prefix: props.prefix,
    suffix: props.suffix,
    error: props.error,
    disabled: props.disabled,
    focus: focus,
    empty: empty,
    width: props.width,
    onMouseDown: onMouseDownContainer,
    htmlFor: id,
    cursor: "text",
    prefixIconTokens: props.prefixIconTokens,
    suffixIconTokens: props.suffixIconTokens,
    prefixId: prefixId,
    suffixId: suffixId
  }, mask ? mask.getElement(_objectSpread(_objectSpread({}, inputProps), {}, {
    inputRef: maskInputRef
  }), // If we're forcing focus on an input with a mask that only
  // shows on focus (!alwaysShow), then force the mask too.
  props.focus !== undefined && !mask.alwaysShow ? {
    alwaysShow: props.focus
  } : {}) : /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
    ref: inputRef
  })), props.children));
});

Input.displayName = "Input";
Input.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If adding a label with `aria-label`, first consider using the `label` prop
   * which will add a visible label and set the size to `xlarge`.
   *
   * @since 5.x
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Specify custom children that will be rendered as adjacent siblings to the
   * text input element.
   *
   * This is an advanced feature designed to allow custom overlays on an input.
   * You should not need this prop unless you are building an advanced component
   * on top of the input.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding input content.
   *
   * @since 5.21.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Input.
   *
   * @since 5.21.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * This can be used to force the visible focus state of the input on or off.
   * This only affects the display of the focus ring, it does not change the
   * focus state of the input as far as the browser is concerned.
   *
   * Note that this should only be used when the input is still functionally
   * focused, despite not having the user's actual focus (e.g. typing would still
   * update the value of the input). This situation is only likely if you're
   * composing the Input with other components to build a more complex input
   * control.
   */
  focus: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.21.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An id for the input that is unique among other inputs.
   *
   * This is only necessary if you need to use an input `size` other than xlarge
   * and want to add your own custom label for the specific input id,
   * eg: <Text tag="label" htmlFor="my-custom-id"/>
   *
   * It is recommended to use the `label` prop for almost all other cases,
   * which will set the `size` of the input to xlarge.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Useful for setting the keyboard for mobile browsers. For example, to display
   * a numeric keyboard:
   *
   * ```
   * // With decimal key
   * <Input type="number" inputMode="decimal" />
   *
   * // Without decimal
   * <Input type="number" inputMode="numeric" />
   * ```
   *
   * See docs for the [inputmode](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode)
   * for list of valid options, descriptions, and browser compatibility.
   *
   * Note: While `inputmode` is not "compatible" with all browsers no [supported
   * browsers](https://meridian.a2z.com/for-developers/react-web/getting-started/?platform=react-web#h4-browser-support)
   * will break or throw errors when the `inputmode` attribute is present.
   *
   * @since 5.14.0
   */
  inputMode: _propTypes["default"].string,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * Mask the input's value in order to force it to conform to a particular
   * format or template.
   *
   * This is helpful for things like formatting phone numbers:
   *
   * ```
   * import Input from "@amzn/meridian/input"
   * import InputMask from "@amzn/meridian/input/mask"
   *
   * const phoneMask = new InputMask("(###)###-####")
   * <Input type="tel" mask={phoneMask} />
   * ```
   *
   * The string passed to the mask accepts three special placeholder characters
   * by default:
   * - `"#"` - A placeholder for any digit [0-9]
   * - `"x"` - A placeholder for any latin character [A-Za-z]
   * - `"*"` - A placeholder for any latin character or digit [A-Za-z0-9]
   *
   * Custom placeholder characters can be set by passing an object of options as
   * the second argument to `InputMask`:
   *
   * ```
   * new InputMask("(^^^)^^^-^^^", { formatChars: { "^": "[1-8]" } })
   * ```
   *
   * Note that if the input type is "password" then this prop will be ignored.
   * Note that input masks should not be blank and should always include template
   * characters to indicate to the user that the input is masked.
   * Note that if custom placeholder characters are set, defaults are overridden.
   */
  mask: _propTypes["default"].object,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * This can be used to ensure that input matches a specific pattern defined
   * by a regular expression. If the user tries to enter a value that does not
   * match the pattern then `onChange` will simply not be triggered.
   *
   * Note that if the input type is `"password"` or an input mask is provided via the
   * `mask` prop then this prop will be ignored.
   */
  pattern: _propTypes["default"].instanceOf(RegExp),

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the component.
   *
   * To add a selectable prefix, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * @since 5.24.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Enable or disable spellchecking on the Input. See [the MDN documentation for `spellcheck`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).
   *
   * @since 5.18.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * Static text to show in an end-cap appended to the component.
   *
   * To add a selectable suffix, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,

  /**
   * The data type of the input's value.
   */
  type: _propTypes["default"].oneOf(["date", "email", "number", "password", "search", "tel", "text", "url", "time"]),

  /**
   * The value of the input.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the input). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   *
   * Note: For Inputs with `type="number"`, the new value passed to `onChange`
   * will be a `string` _not_ a `number`. The `string` type is necessary for
   * allowing users to enter floats like `1.5`. To arrive at `1.5`, a user needs
   * to enter the partial value `1.`. At this point, parsing the partial value
   * with `parseFloat` or `parseInt` will remove the decimal point, effectively
   * blocking the user from completing their entry.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
Input.defaultProps = {
  size: "medium",
  type: "text",
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  children: null,
  value: "",
  autoFill: true
};
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _input = _interopRequireDefault(__webpack_require__(249));

var _context = _interopRequireDefault(__webpack_require__(582));

var _theme = __webpack_require__(7);

var _useColorScheme = _interopRequireDefault(__webpack_require__(201));

var _getIconCss = _interopRequireDefault(__webpack_require__(86));

var _token = __webpack_require__(8);

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _text = _interopRequireDefault(__webpack_require__(22));

var _noTextWrap = _interopRequireDefault(__webpack_require__(101));

var _rtl = __webpack_require__(39);

var _borderRadius = _interopRequireDefault(__webpack_require__(117));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Styles
 */

/* Styles for the root element */
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var cursor = _ref.cursor,
      size = _ref.size,
      fontSize = _ref.fontSize,
      focus = _ref.focus,
      error = _ref.error,
      disabled = _ref.disabled,
      width = _ref.width,
      borderWidthLtr = _ref.borderWidthLtr,
      borderWidthRtl = _ref.borderWidthRtl,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides,
      inputBorderRadius = _ref.inputBorderRadius,
      colorScheme = _ref.colorScheme;
  var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: fontSize || size,
    lineHeight: "default",
    color: disabled ? "disabled" : "default"
  }), (_css = {
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "row",
    justifyContent: "stretch",
    cursor: disabled ? "not-allowed" : cursor,
    backgroundColor: t("backgroundColor", state),
    colorScheme: colorScheme,
    height: t("height", size),
    maxWidth: t("widthMax"),
    width: width,
    outline: "none",
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined,
    borderWidth: borderWidthLtr ? borderWidthLtr : t("borderWidth"),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides) : t("borderRadius")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : t("borderRadius"),
    borderWidth: borderWidthRtl ? borderWidthRtl : t("borderWidth")
  }), (0, _defineProperty2["default"])(_css, "borderColor", t("borderColor", state)), (0, _defineProperty2["default"])(_css, "borderStyle", "solid"), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    error: error,
    offset: 1,
    dropShadow: true,
    borderWidth: t("focusRingBorderWidth"),
    borderRadius: inputBorderRadius ? inputBorderRadius + 1 : t("borderRadius"),
    borderSides: borderSides
  }) : undefined);
}, ["cursor", "size", "fontSize", "focus", "error", "disabled", "width", "borderWidthLtr", "borderWidthRtl", "borderSides", "inputBorderRadius", "colorScheme"]);
/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */

var columnStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      label = _ref2.label;
  var horizontalPadding = t("spacingInsetHorizontal");
  var verticalPadding = t("spacingInsetVertical", size); // If we have a label then reduce the top padding until the label is the same
  // number of pixels from the top as the original top padding when it's floated
  // down over the input

  var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
  });
}, ["size", "label"]);

var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
  var state = _ref3.state,
      side = _ref3.side;
  return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};
/* Styles for the prefix/suffix caps on either end of the input */


var endcapStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var disabled = _ref4.disabled,
      side = _ref4.side,
      size = _ref4.size,
      label = _ref4.label;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), (0, _defineProperty2["default"])({
    flexShrink: 0,
    backgroundColor: t("endcapBackgroundColor"),
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topLeft", "bottomLeft"] : ["topRight", "bottomRight"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: side
    })
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topRight", "bottomRight"] : ["topLeft", "bottomLeft"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: (0, _rtl.getRtl)(side)
    })
  }), _noTextWrap["default"]);
}, ["disabled", "side", "size", "label"]);
/* Styles for everything in-between the endcaps */
// since the aislestyle and columnstyle shares the same attributes
// we can memoize them together

var aisleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref5) {
  var size = _ref5.size,
      label = _ref5.label;
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), {
    flex: "auto",
    overflow: "hidden"
  });
}, ["size", "label"]);
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref6) {
  var _css3;

  var animated = _ref6.animated,
      focus = _ref6.focus,
      disabled = _ref6.disabled,
      floated = _ref6.floated,
      size = _ref6.size;
  var colorState = disabled ? "disabled" : focus ? "focus" : "default";
  return (0, _emotion.css)((_css3 = {
    display: "block",
    cursor: "inherit",
    color: t("labelColor", colorState),
    fontSize: t("labelFontSizeDefault"),
    marginBottom: t("spacingVertical"),
    transformOrigin: "top left"
  }, (0, _defineProperty2["default"])(_css3, "[dir=\"rtl\"] &", {
    transformOrigin: "top right"
  }), (0, _defineProperty2["default"])(_css3, "transform", floated ? "translateY(0px) scale(".concat(t("labelFontSizeFloated") / t("labelFontSizeDefault"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)")), (0, _defineProperty2["default"])(_css3, "transition", animated ? t.transitionCss("labelMotion", ["color", "transform"]) : undefined), _css3), _noTextWrap["default"]);
}, ["animated", "focus", "disabled", "floated", "size"]);
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref7) {
  var _css4;

  var tokens = _ref7.tokens,
      disabled = _ref7.disabled,
      position = _ref7.position;
  var state = disabled ? "disabled" : "default";

  var _getIconFromTokens = (0, _token.getIconFromTokens)(tokens),
      width = _getIconFromTokens.width,
      data = _getIconFromTokens.data;

  return (0, _emotion.css)((_css4 = {
    flexShrink: 0,
    width: width,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart:
    //    position === "prefix"
    //      ? t("spacingInsetHorizontal")
    //      : 0,
    //   marginInlineEnd:
    //    position == "prefix"
    //      ? 0
    //      : t("spacingInsetHorizontal"),
    // },
    margin: position === "prefix" ? "0 0 0 ".concat(t("spacingInsetHorizontal"), "px") : "0 ".concat(t("spacingInsetHorizontal"), "px 0 0")
  }, (0, _defineProperty2["default"])(_css4, "[dir=\"rtl\"] &", {
    margin: position === "prefix" ? "0 ".concat(t("spacingInsetHorizontal"), "px 0 0") : "0 0 0 ".concat(t("spacingInsetHorizontal"), "px")
  }), (0, _defineProperty2["default"])(_css4, "backgroundImage", (0, _getIconCss["default"])(data, t("foregroundColor", state))), (0, _defineProperty2["default"])(_css4, "backgroundPosition", "center"), (0, _defineProperty2["default"])(_css4, "backgroundRepeat", "no-repeat"), _css4));
}, ["tokens", "disabled", "position"]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref8) {
  var size = _ref8.size,
      disabled = _ref8.disabled,
      empty = _ref8.empty,
      label = _ref8.label,
      floated = _ref8.floated;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    position: "relative",
    color: empty ? t("placeholderColor", state) : undefined,
    minHeight: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    opacity: label && !floated ? 0 : 1,
    pointerEvents: disabled ? "none" : undefined
  });
}, ["size", "disabled", "empty", "label", "floated"]);
/**
 * Component
 */

var InputBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");
  var colorScheme = (0, _useColorScheme["default"])();

  var _useContext = (0, _react.useContext)(_context["default"]),
      onFocus = _useContext.onFocus,
      onBlur = _useContext.onBlur,
      borderWidthLtr = _useContext.borderWidthLtr,
      borderWidthRtl = _useContext.borderWidthRtl,
      borderSides = _useContext.borderSides,
      inputBorderRadius = _useContext.inputBorderRadius;

  var styleProps = _objectSpread(_objectSpread({}, props), {}, {
    // If we have a label then the size must be at least "xlarge"
    size: props.label && props.size !== "xlarge" && props.size !== "auto" ? "xlarge" : props.size,
    floated: !props.label || (props.labelFloated !== undefined ? props.labelFloated : !props.empty || props.focus),
    borderWidthLtr: borderWidthLtr,
    borderWidthRtl: borderWidthRtl,
    borderSides: borderSides,
    inputBorderRadius: inputBorderRadius,
    colorScheme: colorScheme
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, styleProps),
    onMouseDown: props.onMouseDown,
    onFocus: onFocus,
    onBlur: onBlur,
    "mdn-input-box": "",
    tabIndex: props.tabIndex
  }, passThroughProps, {
    role: props.role,
    ref: ref,
    id: props.id
  }), props.prefix ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.prefixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "left"
    }))
  }, props.prefix) : null, props.prefixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-prefix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.prefixIconTokens,
      position: "prefix"
    }))
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: aisleStyles(t, styleProps)
  }, props.label ? /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, styleProps),
    htmlFor: props.htmlFor,
    id: props.labelId,
    "aria-hidden": "true"
  }, props.label) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: childrenStyles(t, styleProps)
  }, props.children)), props.suffixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-suffix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.suffixIconTokens,
      position: "suffix"
    }))
  }) : null, props.suffix ? typeof props.suffix === "string" ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.suffixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "right"
    }))
  }, props.suffix) : props.suffix : null);
});

InputBox.displayName = "InputBox";
InputBox.propTypes =  false ? {
  animated: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * NOTE: This was added to improve the a11y of the Select component.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,
  children: _propTypes["default"].node,
  cursor: _propTypes["default"].oneOf(["default", "text", "pointer"]),

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  empty: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */
  error: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  fontSize: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),
  htmlFor: _propTypes["default"].string,
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,

  /**
   * If this is set it will force the float state of the label. True = the
   * label is floated up above the input, false = the label is resting over
   * the input.
   */
  labelFloated: _propTypes["default"].bool,
  labelId: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the input.
   *
   * To add a selectable prefix to an input, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,
  prefixId: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * NOTE: This was added to improve the a11y of Select by allowing a "combobox" role to be passed
   * to the InputBox.
   *
   * @since 5.27.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset. This will set the font-size
   * unless `fontSize` is also set.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge", "auto"]),

  /**
   * Static text to show in an end-cap appended to the input.
   *
   * To add a selectable suffix to an input, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,
  suffixId: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * Note: This was added to improve the a11y of Select.
   *
   * @since 5.27.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onMouseDown: _propTypes["default"].func
} : {};
InputBox.defaultProps = {
  size: "medium",
  cursor: "default",
  animated: true
};
var _default = InputBox;
exports["default"] = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(29));

var _alert = _interopRequireDefault(__webpack_require__(119));

var _column = _interopRequireDefault(__webpack_require__(44));

var SupportTextWrapper = function SupportTextWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: props.className,
    spacing: "200"
  }, props.helperText && !props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.children, props.errorMessage && /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "100 none none none"
  }, /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    id: "".concat(props.id, "-error-message"),
    type: "error",
    size: "small"
  }, props.errorMessage)), props.helperText && props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.constraintText && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-constraint-text"),
    type: "b200",
    color: "secondary"
  }, props.constraintText));
};

SupportTextWrapper.displayName = "SupportTextWrapper";
SupportTextWrapper.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * The id used for the child form field component.
   * This will be used to generate the id's for the support text.
   * EG: "my-input" as an id will become "my-input-helper-text"
   * for the helper text's id.
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding form field content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the form field.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * When some form fields are xlarge we want the helper text to be below the
   * form field instead of above it, like Input or Select.
   * For form fields without a size prop (like InputGroup) we want the
   * helper text below regardless - so we use this boolean to dictate
   * whether or not the helper text is above or below the component
   * that the SupportTextWrapper wraps.
   */
  helperBelowFormField: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
} : {};
var _default = SupportTextWrapper;
exports["default"] = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(116));

var _getTextStyles = _interopRequireDefault(__webpack_require__(245));

var _theme = __webpack_require__(7);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendant Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */
var Text = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children;
  var t = (0, _theme.useTheme)(_text["default"], "text");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    id: props.id,
    className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
    tabIndex: props.tabIndex,
    title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
    "mdn-text": "",
    ref: ref,
    role: props.role,
    htmlFor: props.htmlFor
  }), children);
});

Text.displayName = "Text";
Text.propTypes =  false ? {
  /**
   * The text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The alignment of the text.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set this to true to allow the browser to break text at any arbitrary
   * location - even in the middle of a word. This can be helpful when rendering
   * very long strings without natural breakpoints like spaces or hyphens. This
   * can also cause awkward breaks in text, so use sparingly. See the
   * "break-word" value of the [CSS overflow-wrap property](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap)
   * for details.
   *
   * @since 5.x
   */
  breakWord: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary", "error", "inverted"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberArabic", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets the `for` attribute on the component's element. This is useful when
   * associating a label with an input.
   *
   * See docs to learn more about the [for attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#attr-for).
   * We use `htmlFor` to match [React's standard](https://reactjs.org/docs/dom-elements.html#htmlfor).
   *
   * ```
   * <Column>
   *   <Text tag="label" htmlFor="my-input">
   *     Phone number
   *   </Text>
   *   <Input id="my-input" value={value} onChange={setValue} />
   * </Column>
   * ```
   *
   * @since 5.x
   */
  htmlFor: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Sets the list-style for digits in an ordered list.
   *
   * Use this to set digits for a locale.
   * See [list style types](https://www.w3.org/International/tests/html-css/list-style-type/results-list-style-type) for more information.
   */
  listStyle: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for the [role attribute](https://www.w3.org/TR/wai-aria-1.0/roles)
   * for details on appropriate usage.
   *
   * @since 5.x
   */
  role: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Text to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Add advisory information related to the element. See the [HTML title attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   *
   * If the `truncate` property is set to true, this prop will default to the
   * contents of the `Text` component *if* the contents are a plain string.
   * Otherwise this prop should be manually set to the non-truncated text to
   * ensure that the full text is accessible to readers.
   */
  title: _propTypes["default"].string,

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
Text.defaultProps = {
  tag: "p"
};
var _default = Text;
exports["default"] = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _reduce = _interopRequireDefault(__webpack_require__(586));

var _box = _interopRequireDefault(__webpack_require__(69));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _parsers = __webpack_require__(57);

var _functional = __webpack_require__(19);

var _cxMemoized = _interopRequireDefault(__webpack_require__(71));

var _rtl = __webpack_require__(39);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(heights) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var spacing = _ref.spacing,
        alignmentVertical = _ref.alignmentVertical,
        alignmentHorizontal = _ref.alignmentHorizontal;
    return (0, _emotion.css)({
      display: "flex",
      flexDirection: "column",
      justifyContent: {
        top: "flex-start",
        bottom: "flex-end",
        center: "center",
        justify: "space-between"
      }[alignmentVertical],
      alignItems: {
        left: "flex-start",
        right: "flex-end",
        center: "center",
        stretch: "stretch"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)],
      // Set margins and heights on the children of the column. Use !important to
      // override any existing styles.
      "& > *": {
        // Make sure that any borders or padding applied to the child don't throw
        // of the heights that we apply
        boxSizing: "border-box !important",
        // Ensure that the correct bottom margin is set (and clear other margins)
        margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
        // Don't let the last child add extra space to the end of the column.
        ":last-child": {
          margin: "0 !important"
        }
      }
    }, // If we've got an array of heights, apply each height to the child
    // whose index in the dom matches the height's index in the array. If
    // we've got a single height, apply that to all children.
    Array.isArray(heights) ? (0, _reduce["default"])(heights, function (result, height, index) {
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
    }, {}) : {
      "& > *": childStyles(heights)
    });
  }, ["spacing", "alignmentVertical", "alignmentHorizontal"]);
};

var stylesWithUniqueHeights = (0, _functional.memoizeArray)(styles);
var stylesWithUniformHeights = (0, _functional.memoize)(styles);

var childStyles = function childStyles(height) {
  return {
    flex: height === "fill" ? "1 !important" : undefined,
    flexShrink: height && height !== "fill" && height !== "auto" ? "0 !important" : undefined,
    height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
  };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */


var Column = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // We need to memoize differently based on whether we got an array or scalar
  // for the "heights" property
  var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueHeights : stylesWithUniformHeights;
  var styles = stylesFunc(props.heights)(props);
  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _cxMemoized["default"])(styles, props.className),
    ref: ref
  }));
});

Column.displayName = "Column";
Column.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the column.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "stretch"]),

  /**
   * Specify the vertical alignment of the elements inside the column.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a column. Any elements can be supplied here, although if
   * only one child is supplied the column will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the column using a number (which will be treated as
   * pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the height of each element in the column.
   *
   * If a single height is provided then it will be applied to every element in
   * the column. If an array of heights is provided then each height will be
   * applied to the element in the column that exists at the same index as the
   * height in the array (e.g. `[<element 0 height>, <element 1 height>, null, <element 3 height>]`).
   *
   * The possible values for each height are:
   *   - `number` - A fixed pixel height.
   *   - `string` - Any valid CSS height.
   *   - `"fit"` - The element's height will shrink to fit its contents.
   *   - `"fill"` - The element's height will fill all remaining space in the column.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the column equally.
   */
  heights: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set the maximum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Set the vertical spacing between elements in the column using a preset.
   */
  spacing: _propTypes2["default"].spacing(1),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right, or `"100 none none none"` for 2px
   * padding on the top and 0px padding on the right, left, and bottom).
   *
   * For more information on available spacing tokens please visit the
   * [Spacing fundamentals page](https://meridian.a2z.com/fundamentals/spacing/).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the column using one of Meridian's Box component styles.
   * If omitted the column will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Column.defaultProps = {
  spacing: "medium",
  alignmentVertical: "top",
  alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(587),
    baseEach = __webpack_require__(588),
    baseIteratee = __webpack_require__(94),
    baseReduce = __webpack_require__(593),
    isArray = __webpack_require__(40);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(589),
    createBaseEach = __webpack_require__(592);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(590),
    keys = __webpack_require__(85);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(591);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(73);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 594 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(596), src$en$$ = __webpack_require__(601);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(255), src$es5$$ = __webpack_require__(597), src$compiler$$ = __webpack_require__(598), intl$messageformat$parser$$ = __webpack_require__(599);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(255);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(600)['default'];
exports['default'] = exports;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(604)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(609);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(605), src$en$$ = __webpack_require__(608);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(254), src$diff$$ = __webpack_require__(606), src$es5$$ = __webpack_require__(607);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(611);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(615)['default'];
exports['default'] = exports;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(616);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateDetailReducer; });
var AssociateDetailReducer=function AssociateDetailReducer(state,action){switch(action.type){case"SET_ASSOCIATE":return Object.assign({},state,{associate:action.data});case"RESET_ASSOCIATE_SELECTION":return Object.assign({},state,{associate:[]});default:return state;}};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return responsiveProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__ = __webpack_require__(619);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/var responsiveProps={isMobile:_defineProperty({default:false},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],true),spacingInset_shorthand2:_defineProperty({default:"none large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"none medium"),spacingInset_shorthand4:_defineProperty({default:"small large small large"},__WEBPACK_IMPORTED_MODULE_0__BreakPoints_js__["a" /* SMALL */],"small medium small medium")};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXTRA_SMALL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SMALL; });
/* unused harmony export LARGE */
var EXTRA_SMALL="480px";var SMALL="840px";var LARGE="1260px";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _matchMedia = _interopRequireDefault(__webpack_require__(621));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This looks through an object of nested objects and returns a flat array
 * containing all the unique keys found in the nested objects.
 */
var getUniqueNestedObjectKeys = function getUniqueNestedObjectKeys(props) {
  return Object.keys(props) // Get the keys of each nested object
  .map(function (prop) {
    return Object.keys(props[prop]);
  }) // Flatten the keys into one array
  .reduce(function (result, keys) {
    return result.concat(keys);
  }, []) // Filter out duplicate keys
  .filter(function (value, index, keys) {
    return keys.indexOf(value) === index;
  });
};
/**
 * Sort an array according to it's numeric values
 */


var sortNumeric = function sortNumeric(arr, direction) {
  arr.sort(function (a, b) {
    return (parseFloat(a) - parseFloat(b)) * (direction === "descending" ? -1 : 1);
  });
  return arr;
};
/* eslint-disable react/prop-types */

/**
 * This component allows you to respond to the state of media features such as
 * viewport width, viewport aspect ratio, and device orientation. This is
 * similar to "media queries for JavaScript" (and it's even powered by media
 * queries behind the scenes), but it's a lot more powerful. Instead of only
 * allowing you to toggle something on or off based on a matching media query,
 * it allows you to set set any JavaScript variable based on the various states
 * of a media feature. You can use this functionality to do things that are not
 * possible with plain CSS media queries like:
 *   - render entirely different component trees based on viewport size
 *   - pass different props to a component based on viewport width
 *   - change the location of elements in the DOM based on device orientation
 *
 * NOTE: The props passed to this component cannot be changed after the
 * component is first instantiated.
 *
 * ```
 * // Renders "red" below the 1000px breakpoint, "blue" at or above the 1000px
 * // breakpoint but below the 1500px breakpoint, and "green" at or above the
 * // 1500px breakpoint. Renders 12px font below the 1500px breakpoint and 24px
 * // at or above the 1500px breakpoint.
 * <Responsive
 *   query="min-width"
 *   props={{
 *     color: { default: "red", "1000px": "blue", "1500px": "green" },
 *     fontSize: { default: 12, "1500px": 24 },
 *   }}
 * >
 *   {({ color, fontSize }) => (
 *     <div style={{ fontSize }}>My fav color is {color}</div>
 *.  )}
 * </Responsive>
 * ```
 */


var ResponsiveClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ResponsiveClass, _React$Component);

  var _super = _createSuper(ResponsiveClass);

  function ResponsiveClass(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ResponsiveClass);
    _this = _super.call(this, props); // Extract the media condition from the "query" prop

    var condition = /^min-/.test(props.query) ? "min" : /^max-/.test(props.query) ? "max" : null; // Extract the media feature from the "query" prop

    var feature = condition ? props.query.replace(new RegExp("^".concat(condition, "-")), "") : props.query; // Extract a list of unique breakpoints from the keys of the "props" prop.
    // Don't include the "default" since that's not something we can actually
    // query for (we'll fallback to that manually if no breakpoint matches)

    var breakpoints = getUniqueNestedObjectKeys(props.props).filter(function (key) {
      return key !== "default";
    }); // Sort the breakpoints according to the media query condition so that later
    // on we can just take the last matching breakpoint and know that that's the
    // min/max matching breakpoint

    var sortedBreakpoints = condition ? sortNumeric(breakpoints, condition === "min" ? "ascending" : "descending") : breakpoints; // This is an object of `MediaQueryList` instances (or mock instances - see
    // `matchMedia`) keyed by the breakpoints that they're matching against (e.g.
    // `{ "0px": mediaQueryA, "1000px": mediaQueryB }`).

    _this.mediaQueries = sortedBreakpoints.map(function (breakpoint) {
      var mediaQuery = (0, _matchMedia["default"])({
        feature: feature,
        condition: condition,
        fallback: props.fallback,
        breakpoint: breakpoint
      });

      var listener = function listener() {
        return _this.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
      };

      return {
        breakpoint: breakpoint,
        mediaQuery: mediaQuery,
        startListening: function startListening() {
          return mediaQuery.addListener(listener);
        },
        stopListening: function stopListening() {
          return mediaQuery.removeListener(listener);
        }
      };
    }); // Save off the list of prop names for each access later

    _this.propNames = Object.keys(props.props); // State is an object keyed by breakpoint that includes the match state of
    // the media query for that breakpoint (e.g. if the query is "min-width",
    // we're listening at the breakpoints "0px" and "1000px", adn the viewport
    // width is "500px" then the state object would be:
    // { "0px": true, "1000px": false }

    _this.state = _this.mediaQueries.reduce(function (result, _ref) {
      var breakpoint = _ref.breakpoint,
          mediaQuery = _ref.mediaQuery;
      // If a fallback prop is present, match against that for the intial
      // state. This ensures that that the same value is used during server
      // rendering and during the initial rehydrating render on the client.
      result[breakpoint] = _this.props.fallback ? mediaQuery.matchesFallback : mediaQuery.matches;
      return result;
    }, {});
    return _this;
  }

  (0, _createClass2["default"])(ResponsiveClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mediaQueries.forEach(function (_ref2) {
        var mediaQuery = _ref2.mediaQuery,
            breakpoint = _ref2.breakpoint,
            startListening = _ref2.startListening;
        // Start listening for future state changes
        startListening(); // If we matched against the fallback prop on the initial render, but the
        // actual match is different, then update the state now and trigger a
        // re-render

        if (_this2.props.fallback && mediaQuery.matches !== mediaQuery.matchesFallback) {
          // Note: React batches state updates in lifecycle methods so we'll only
          // get one re-render no matter how many breakpoints we have to update.
          _this2.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mediaQueries.forEach(function (_ref3) {
        var stopListening = _ref3.stopListening;
        return stopListening();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // Choose the best value from "props" based on the state of our media
      // queries. If no match is found then return the "default" value (or
      // undefined if there is no default).
      var props = this.propNames.reduce(function (result, propName) {
        var prop = _this3.props.props[propName];

        var value = _this3.mediaQueries.reduce(function (result, _ref4) {
          var breakpoint = _ref4.breakpoint;
          return _this3.state[breakpoint] && prop[breakpoint] !== undefined ? prop[breakpoint] : result;
        }, prop["default"]);

        result[propName] = value;
        return result;
      }, {});
      return this.props.children(props);
    }
  }]);
  return ResponsiveClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var Responsive = function Responsive(props) {
  return /*#__PURE__*/_react["default"].createElement(ResponsiveClass, props);
};

Responsive.displayName = "Responsive";
Responsive.propTypes =  false ? {
  /**
   * A function that returns React elements. This will receive an object of
   * props based on the current state of the queried media feature and the
   * values passed to "props".
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * This is a nested object that allows you to define the prop values that
   * should be passed to the children function given any particular state of
   * the queried media feature. The special state "default" can be used to
   * indicate a value that should be returned if none of the other states are
   * matched. See the top-level documentation for this component for an
   * example.
   */
  props: _propTypes["default"].objectOf(_propTypes["default"].object).isRequired,

  /**
   * The media feature (e.g. width) and conditional (e.g. min) to watch for
   * changes and respond to.
   */
  query: _propTypes["default"].oneOf(["min-width", "max-width", "min-height", "max-height", "min-aspect-ratio", "max-aspect-ratio", "orientation"]).isRequired,

  /**
   * This is used as the fallback state of the queried media feature if the
   * component is rendered in an environment that doesn't support media
   * queries (e.g. NodeJS).
   *
   * Note that this does not have to match the states
   * found in the "props" object exactly to trigger a match. For example, if
   * "query" is set to "min-width", "fallback" is set to "1024px", and "props"
   * is set to `{ myValue: { default: "small", "800px": "medium", "1280px": "large" }}`,
   * then "myValue" would resolve to "medium" because "min-width: 800px"
   * passes when the width falls back to "1024px".
   *
   * IMPORTANT: This is required if you're server-rendering or pre-rendering this
   * component! Otherwise you may end up with a mismatch between your server
   * rendered markup and the markup that React tries to rehydrate with, and it
   * will literally shred the DOM.
   */
  fallback: _propTypes["default"].string
} : {};
var _default = Responsive;
exports["default"] = _default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(__webpack_require__(27));

var _functional = __webpack_require__(19);

/**
 * Attempt to convert a media query breakpoint to a number. If we received a
 * breakpoint like "5/10" (e.g. an aspect ratio) then run the math (e.g. "5/10"
 * => 0.5), otherwise just parse as a float (e.g. "5rem" => 5).
 */
var breakpointToNumber = function breakpointToNumber(str) {
  return /^\s?[0-9.]+\s?\/\s?[0-9.]+\s?$/.test(str) ? parseFloat(str.split("/")[0]) / parseFloat(str.split("/")[1]) : parseFloat(str);
};

var matchesFallback = function matchesFallback(_ref) {
  var condition = _ref.condition,
      breakpoint = _ref.breakpoint,
      fallback = _ref.fallback;
  return fallback === undefined ? false : condition === "min" ? breakpointToNumber(breakpoint) <= breakpointToNumber(fallback) : condition === "max" ? breakpointToNumber(breakpoint) >= breakpointToNumber(fallback) : breakpoint === fallback;
};
/**
 * A wrapper around `window.matchMedia`. If `window.matchMedia` is available
 * then a media query will be constructed and passed to `window.matchMedia` to
 * create a `MediaQueryList` instance. If we're in an env where
 * `window.matchMedia` is not available (e.g. NodeJS) then this will return a
 * mock MediaQueryList that matches against the provided fallback.
 */


var matchMedia = typeof window !== "undefined" && window.matchMedia ? (0, _functional.memoizeByKeys)(function (_ref2) {
  var condition = _ref2.condition,
      breakpoint = _ref2.breakpoint,
      feature = _ref2.feature,
      fallback = _ref2.fallback;
  // Build up a standard media query (e.g. `(min-width: 1000px)`) if
  // we have access to window.matchMedia
  var matchMedia = window.matchMedia("(".concat(condition ? "".concat(condition, "-") : "").concat(feature, ": ").concat(breakpoint, ")")); // Tack on the a property indicating whether the fallback matches.
  // This is helpful for situations where you're on the client, but want
  // to know what the match state would have been on the server (i.e.
  // when re-hydrating server-rendered markup on the client with React).

  matchMedia.matchesFallback = matchesFallback({
    condition: condition,
    breakpoint: breakpoint,
    fallback: fallback
  });
  return matchMedia;
}, ["feature", "condition", "breakpoint", "fallback"]) : function (args) {
  var matches = matchesFallback(args);
  return {
    // If we don't have access to `window.matchMedia` then "matches" will be
    // set statically based on the provided "fallback".
    matches: matches,
    // Mock out these functions for parity with the `MediaQueryList`
    // instance returned if `window.matchMedia` is available
    matchesFallback: matches,
    addListener: _noop["default"],
    removeListener: _noop["default"]
  };
};
var _default = matchMedia;
exports["default"] = _default;

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stageStatus_context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CartContextMenu__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CartViewTable=function CartViewTable(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__stageStatus_context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext2.viewModelF;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext3.configViewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_17__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;/** Pagination State **/var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState2=_slicedToArray(_useState,2),currentPage=_useState2[0],setCurrentPage=_useState2[1];/** Sorting **/var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("Cart ID"),_useState4=_slicedToArray(_useState3,2),sortColumn=_useState4[0],setSortColumn=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ascending"),_useState6=_slicedToArray(_useState5,2),sortDirection=_useState6[0],setSortDirection=_useState6[1];var onSort=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_ref){var sortColumn=_ref.sortColumn,sortDirection=_ref.sortDirection;setSortDirection(sortDirection);setSortColumn(sortColumn);},[]);/** In Line Table Filter **/var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),cartIdFilter=_useState8[0],setCartIdFilter=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),routeCodeFilter=_useState10[0],setRouteCodeFilter=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),routeTypeFilter=_useState12[0],setRouteTypeFilter=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),status=_useState14[0],setStatus=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),routeSLA=_useState16[0],setRouteSLA=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),location=_useState18[0],setLocation=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),dwellDuration=_useState20[0],setDwellDuration=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),stageTime=_useState22[0],setStageTime=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),stageSLAFilter=_useState24[0],setStageSLAFilter=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState26=_slicedToArray(_useState25,2),associateFilter=_useState26[0],setAssociateFilter=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState28=_slicedToArray(_useState27,2),stationPairsFilter=_useState28[0],setStationPairsFilter=_useState28[1];/** Filters **/var filterOption=function filterOption(cart,filter,key){if(!viewModelF[filter]||viewModelF[filter].length===0){return true;}var result=false;viewModelF[filter].forEach(function(filterValue){if(filter==='status'){result=result||cart[key]===filterValue;}else if(cart[key].includes(filterValue)){result=true;}});return result;};var inLineFilter=function inLineFilter(cart,filter,key){return filter.length===0||cart[key]!=null&&cart[key].toString().toLowerCase().startsWith(filter.toLowerCase());};var inLineContainsFilter=function inLineContainsFilter(cart,filter,key){return filter.length===0||cart[key]!=null&&cart[key].toString().toLowerCase().includes(filter.toLowerCase());};var cartList=viewModel.cartList;cartList.sort(function(a,b){if(a[sortColumn]<b[sortColumn]){return sortDirection==="ascending"?-1:1;}if(a[sortColumn]>b[sortColumn]){return sortDirection==="ascending"?1:-1;}return 0;});cartList=cartList.filter(function(cart){return filterOption(cart,"cluster","routeCode");}).filter(function(cart){return filterOption(cart,"driverType","routeType");}).filter(function(cart){return filterOption(cart,"departure","routeSLA");}).filter(function(cart){return filterOption(cart,"status","status");}).filter(function(cart){return inLineFilter(cart,cartIdFilter,"cartId");}).filter(function(cart){return inLineFilter(cart,routeCodeFilter,"routeCode");}).filter(function(cart){return inLineContainsFilter(cart,routeTypeFilter,"routeType");}).filter(function(cart){return inLineFilter(cart,status,"status");}).filter(function(cart){return inLineFilter(cart,routeSLA,"routeSLA");}).filter(function(cart){return inLineFilter(cart,location,"location");}).filter(function(cart){return inLineFilter(cart,dwellDuration,"dwellingDuration");}).filter(function(cart){return inLineFilter(cart,stageTime,"stageTime");}).filter(function(cart){return inLineFilter(cart,stageSLAFilter,"stageSLA");}).filter(function(cart){return inLineFilter(cart,associateFilter,"associate");}).filter(function(cart){return inLineContainsFilter(cart,stationPairsFilter,"stationPairs");});var itemOnPage=50;var pageSize=Math.ceil(cartList.length/itemOnPage);var startPage=(currentPage-1)*itemOnPage;var endPage=startPage+itemOnPage>cartList.length-1?cartList.length-1:startPage+itemOnPage-1;if(startPage>cartList.length){setCurrentPage(1);}var onCartClick=function onCartClick(cart){var url="/cartDetail/"+cart.routeId+"/"+cart.cartId+"/"+cart.status+"/"+cart.location+"/"+cart.associate+"/"+cart.stationCode;props.history.push(url);};var onRouteClick=function onRouteClick(cart){Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){var params=["Stage",Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(cart.routeId),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(encodeURIComponent(cart.routeStatus)),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(encodeURIComponent(cart.routeStagingLocation)),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(cart.hazmatWeight),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(cart.picker),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(cart.routeCode),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(cart.stationCode)];var url=new URL(result.replace("stage","pick"));var shareableLink="/routeDetail/"+params.join("/");url.searchParams.set("shareableLink",shareableLink);window.open(url.href,"_parent");});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",widths:"fill",spacingInset:spacingInset_shorthand2,className:"enable-scroll-x"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{showStripes:configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */],headerRows:1,headerColumns:1,fixHeaderRows:true,stickyHeaderColumn:true,stickyHeaderRow:true,showDividers:configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */],spacing:"small",sortColumn:sortColumn,sortDirection:sortDirection,onSort:onSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"routeSLA"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"stage.stageByTime",defaultMessage:"Stage by time"})):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"stageSLA"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.stageSLA",defaultMessage:"Stage By Time"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.routeId",defaultMessage:"Route ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"cartId"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.cartId",defaultMessage:"Cart ID"})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"stationPairs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.stationPairs",defaultMessage:"Pick Station"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.cartView_location",defaultMessage:"Staging Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"status"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"dwellingDuration"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.dwellDuration",defaultMessage:"Dwell Duration"})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"stageTime"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.stageTime",defaultMessage:"Stage Time"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"associate"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.associate",defaultMessage:"Associate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeType"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["a" /* FormattedMessage */],{id:"routeStageTable.type",defaultMessage:"Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeSLA,onChange:setRouteSLA})):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stageSLAFilter,onChange:setStageSLAFilter})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeCodeFilter,onChange:setRouteCodeFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:cartIdFilter,onChange:setCartIdFilter})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stationPairsFilter,onChange:setStationPairsFilter})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:location,onChange:setLocation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:status,onChange:setStatus})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:dwellDuration,onChange:setDwellDuration})),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stageTime,onChange:setStageTime})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:associateFilter,onChange:setAssociateFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeTypeFilter,onChange:setRouteTypeFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null)),cartList.map(function(cart,key){return key>=startPage&&key<=endPage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:cart.routeCode+cart.cartId},configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},cart.routeSLA):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},cart.stageSLA):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{onClick:function onClick(){onRouteClick(cart);},type:"secondary"},cart.routeCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{width:"145px"},configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_link___default.a,{onClick:function onClick(){onCartClick(cart);},type:"secondary"},cart.cartId):cart.cartId),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["b" /* AR_V2 */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.floorLocation?cart.floorLocation:cart.stationPairs):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tooltip___default.a,{position:"top",title:cart.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_16__util_EntityStatusManager__["q" /* getCartStatusColor */])(cart.status)},cart.status&&cart.status.length>11?cart.status.substr(0,10)+"...":cart.status))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},cart.dwellingDuration),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_14__util_Constants__["e" /* CORE_AMZL */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["g" /* convertMillisecondsToHHMM */])(cart.stageTime)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.associate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,cart.routeType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CartContextMenu__["a" /* default */],{cart:cart}))):null;}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,cartList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",alignmentHorizontal:"center",spacingInset:"medium none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default.a,{numberOfPages:pageSize,onChange:setCurrentPage,currentPage:currentPage})):null))));};/* harmony default export */ __webpack_exports__["a"] = (CartViewTable);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CartContextMenu=function CartContextMenu(props){var iconRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),open=_useState2[0],setOpen=_useState2[1];var onClickButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return setOpen(true);},[]);var onClose=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return setOpen(false);},[]);var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var sideLineRoute=function sideLineRoute(){dispatch({type:'SIDELINE_ROUTE',data:{dispatcher:dispatch,routeId:props.cart.routeId,stationCode:props.cart.stationCode,baseUrl:configViewModel.baseUrl,stationConfig:configViewModel.stationConfig}});};var unassignStager=function unassignStager(){dispatch({type:'UNASSIGN_STAGER',data:{dispatcher:dispatch,stageListId:props.cart.stageListId,stationCode:props.cart.stationCode,associateId:props.cart.associateId,baseUrl:configViewModel.baseUrl,stationConfig:configViewModel.stationConfig}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default.a,{type:"icon",ref:iconRef,onClick:onClickButton,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball___default.a},"Settings")),configViewModel.capability!==__WEBPACK_IMPORTED_MODULE_8__util_Constants__["e" /* CORE_AMZL */]||props.cart.status==='Sidelined'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu___default.a,{anchorNode:iconRef.current,open:open,position:"right",onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return sideLineRoute();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cartMenu.sideline",defaultMessage:"Sideline"}))),configViewModel.capability===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["b" /* AR_V2 */]&&props.cart.status==='Ready'&&props.cart.stageListId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu___default.a,{anchorNode:iconRef.current,open:open,position:"right",onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return unassignStager();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"cartMenu.unassign",defaultMessage:"Unassign"}))):null);};/* harmony default export */ __webpack_exports__["a"] = (CartContextMenu);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _popover = _interopRequireDefault(__webpack_require__(625));

var _optionList = _interopRequireWildcard(__webpack_require__(149));

var _rtl = __webpack_require__(39);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Renders a menu of options attached to another anchor element.
 *
 * NOTE: Do not mount a Menu inside an interactive element. The Menu's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Menu will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Menu being counted as a click on the element
 * where the Menu was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */
var Menu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Menu, _React$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionListRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function (ref) {
      return _this.optionListRef = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function () {
      // Re-trigger the option list's "componentDidMount" when the option list is
      // actually visible. This is necessary because the things the option list
      // does on mount, like setting the scroll and transferring focus, only work
      // when it's visible.
      _this.optionListRef.componentDidMount();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickItem", function (_ref) {
      var onClick = _ref.onClick,
          href = _ref.href,
          target = _ref.target;
      return function () {
        var anchorNode = _this.props.anchorNode; // Trigger the user-defined menu item action

        if (onClick) {
          onClick(href);
        } else if (href) {
          window.open(href, target || "_self");
        } // Transfer focus back to the menu anchor (this will close the menu)

        /* eslint-disable-next-line react/no-find-dom-node */


        _reactDom["default"].findDOMNode(anchorNode).focus(); // Clear the preselected menu item


        _this.setState({
          preselectedIndex: undefined
        });
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.open || this.props.open;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // If a minWidth is not set and the menu is positioned above or below the
      // anchor node, set the minWidth to the width of the anchor node

      var minWidth = this.props.minWidth === undefined && (props.position === "top" || props.position === "bottom") ? "anchor" : this.props.minWidth;
      return /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({}, passThroughProps, {
        indicatorArrow: false,
        open: props.open,
        onClose: props.onClose,
        onOpen: this.onOpen,
        anchorNode: props.anchorNode,
        minWidth: minWidth,
        position: (0, _rtl.getHorizontalDirection)(props.position),
        alignment: (0, _rtl.getHorizontalDirection)(props.alignment),
        spacingInset: "none",
        shrinkToFit: true,
        id: props.id
      }), /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
        autoFocus: true,
        ref: this.updateOptionListRef,
        role: "menu"
      }, _react["default"].Children.map(props.children, function (option) {
        // It's important to accept falsey option because rendering null is
        // the standard way to "turn off" a conditional JSX element.
        if (!option) return null;
        var passThroughProps = (0, _filterPropsByPrefix["default"])(option.props, ["data-", "aria-"]);
        return (
          /*#__PURE__*/
          // TODO: See https://sim.amazon.com/issues/MRDN-296 regarding the
          // empty label prop and the children-as-a-function below
          _react["default"].createElement(_optionList.OptionListItem, (0, _extends2["default"])({
            onClick: _this2.onClickItem(option.props),
            disabled: option.props.disabled,
            href: option.props.href,
            target: option.props.target,
            rel: option.props.rel,
            role: "menuitem",
            label: option.props["aria-label"] ? option.props["aria-label"] : ""
          }, passThroughProps), function () {
            return option.props.children;
          })
        );
      })));
    }
  }]);
  return Menu;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Menu, "defaultProps", {
  alignment: "center"
});
Menu.propTypes =  false ? {
  /**
   * Drop MenuItem components in here.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the menu open?
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * This determines which side of the anchor node the menu appears on.
   */
  position: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start"]).isRequired,

  /**
   * The menu will call this when it wants to close. The function provided
   * here should set the "open" prop to false.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * This determines how the menu is aligned with the anchor node. Note that
   * only certain values are valid depending on what the "position" prop is
   * set to. If the position is "top" or "bottom" then valid values here are
   * "left" or "start", "right" or "end", or "center". If the position is "left",
   * "start", "right", or "end" then valid values are "top", "bottom", or "center".
   */
  alignment: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start", "center"]),

  /**
   * The node to anchor the menu to. This should be a focusable element. This
   * is not required to mount the menu, but it is required to open it.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Menu component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * Within the Menu component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.22.0
   */
  id: _propTypes["default"].string,

  /**
   * Define a minimum width for the menu. If the value of the "position" prop
   * is set to "top" or "bottom", this will default to the width of the anchor
   * node.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
} : {};
var _default = Menu;
exports["default"] = _default;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PopoverHeader", {
  enumerable: true,
  get: function get() {
    return _popoverHeader["default"];
  }
});
exports["default"] = void 0;

var _popover = _interopRequireDefault(__webpack_require__(626));

var _popoverHeader = _interopRequireDefault(__webpack_require__(258));

var _default = _popover["default"];
exports["default"] = _default;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _find = _interopRequireDefault(__webpack_require__(88));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _popover = _interopRequireDefault(__webpack_require__(102));

var _popoverHeader = _interopRequireDefault(__webpack_require__(258));

var _theme = __webpack_require__(7);

var _popoverBody = _interopRequireDefault(__webpack_require__(246));

var _popoverController = _interopRequireDefault(__webpack_require__(145));

var _utils = __webpack_require__(103);

var _useOnBlurContainer2 = _interopRequireDefault(__webpack_require__(627));

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

var _focus = __webpack_require__(93);

var _rtl = __webpack_require__(39);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isHeader = (0, _isElementOf["default"])(_popoverHeader["default"]);

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};
/**
 * Renders a popover attached to another anchor element.
 *
 * NOTE: Do not mount a Popover inside an interactive element. The Popover's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Popover will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Popover being counted as a click on the element
 * where the Popover was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */


var Popover = /*#__PURE__*/_react["default"].memo(function (props) {
  var onOpenProp = props.onOpen,
      onKeyDownProp = props.onKeyDown,
      onClose = props.onClose,
      anchorNode = props.anchorNode,
      idProp = props.id,
      indicatorArrow = props.indicatorArrow,
      position = props.position,
      alignment = props.alignment,
      children = props.children,
      open = props.open,
      maxWidth = props.maxWidth,
      minWidth = props.minWidth,
      spacingInset = props.spacingInset,
      shrinkToFit = props.shrinkToFit;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var popoverBody = (0, _react.useRef)();
  var id = (0, _react.useMemo)(function () {
    return idProp ? idProp : (0, _uniqueId["default"])("popover-");
  }, [idProp]);
  var t = (0, _theme.useTheme)(_popover["default"], "popover"); // HACK: For RTL, update position and alignment to horizontal terms.
  // eg: start -> left, end -> right.
  // The actual RTL swapping of left to right and right to left
  // happens in the popover-controller.
  // The RTL swapping will happen based on left/right values automatically
  // in the popover-controller.
  // This is needed because "top left" is handled better than "top start".
  // If the direction is not "start" or "end" the call to getHorizontalDirection
  // will simply return the direction passed into it.

  var popoverPosition = (0, _rtl.getHorizontalDirection)(position);
  var popoverAlignment = (0, _rtl.getHorizontalDirection)(alignment); // Handle setting aria-expanded to `false` and refocusing on the anchor node
  // and then fire the customer's `onClose` function

  var closeFunc = (0, _react.useCallback)(function () {
    try {
      anchorNode.setAttribute("aria-expanded", "false"); // Try to refocus back on the anchor node

      if (anchorNode.focus) {
        anchorNode.focus();
      } else {
        /* eslint-disable-next-line react/no-find-dom-node */
        _reactDom["default"].findDOMNode(anchorNode).focus();
      }
    } catch (_) {// Silent error
    }

    onClose();
  }, [anchorNode, onClose]); // Transfer focus back to the popover anchor. This will automatically close
  // the popover because of our usage of `useOnBlurContainer` below.

  var close = (0, _react.useCallback)(function () {
    if (anchorNode.focus) {
      anchorNode.focus();
    } else {
      /* eslint-disable-next-line react/no-find-dom-node */
      _reactDom["default"].findDOMNode(anchorNode).focus();
    }
  }, [anchorNode]); // Create focus/blur handlers that will trigger closeFunc when focus moves
  // outside of the popover

  var _useOnBlurContainer = (0, _useOnBlurContainer2["default"])(closeFunc),
      onBlur = _useOnBlurContainer.onBlur,
      onFocus = _useOnBlurContainer.onFocus;

  var onFocusFunc = (0, _react.useCallback)(function () {
    // If a user has not set an id for accessibility
    // use our own auto-generated one
    try {
      if (!anchorNode.hasAttribute("aria-controls")) {
        anchorNode.setAttribute("aria-controls", id);
      }
    } catch (_) {// Silent error
    } // If a user hasn't set aria-haspopup, we'll do it
    // for them.


    try {
      if (!anchorNode.hasAttribute("aria-haspopup")) {
        anchorNode.setAttribute("aria-haspopup", "dialog");
      }
    } catch (_) {// Silent error
    }

    onFocus();
  }, [anchorNode, id, onFocus]);
  var onOpen = (0, _react.useCallback)(function () {
    try {
      anchorNode.setAttribute("aria-expanded", "true");
    } catch (_) {// Silent error
    } // When the popover is opened, focus on the first enabled focuseable node inside
    // it *or* the popover itself if it doesn't contain any focuseable nodes.


    var firstEnabledFocusNode = (0, _focus.getKeyboardFocusNodes)(popoverBody.current).filter(function (node) {
      return !node.disabled;
    })[0];
    var firstFocusNode = firstEnabledFocusNode || popoverBody.current;
    firstFocusNode.focus();
    onOpenProp();
  }, [anchorNode, onOpenProp]); // If the user presses the escape key, close the popover.

  var onKeyDown = (0, _react.useCallback)(function (event) {
    if ((0, _keycode["default"])(event) === "esc") {
      // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.
      event.stopPropagation();
      close();
    }

    onKeyDownProp(event);
  }, [onKeyDownProp, close]);
  var vertical = position === "top" || position === "bottom";

  var childrenArray = _react["default"].Children.toArray(children);

  var headerChild = (0, _find["default"])(childrenArray, isHeader);
  var nonHeaderChildren = childrenArray.filter(function (child) {
    return !isHeader(child);
  }); // Check if the anchor node has a special attribute set in order to
  // customize the distance a popover is placed from the element. This is
  // useful for elements whose visual edge is not the same as their layout
  // edge, in which case they'll want to scoot the popover around to make it
  // appear a reasonable distance from the element's visual edge.

  var customOffset = (0, _react.useMemo)(function () {
    /* eslint-disable-next-line react/no-find-dom-node */
    var anchorDomNode = anchorNode && _reactDom["default"].findDOMNode(anchorNode);

    var customOffset = parseInt(anchorDomNode && anchorDomNode.getAttribute("mdn-popover-offset"));
    return isNaN(customOffset) ? 0 : customOffset;
  }, [anchorNode]); // Calculate the final offset based on tokens, the presence of an indicator
  // arrow, and any custom offset specified by the anchor node (see above).

  var offset = (0, _react.useMemo)(function () {
    return Math.max(0, t("offset", indicatorArrow ? "withArrow" : "withoutArrow") + customOffset);
  }, [t, indicatorArrow, customOffset]);
  var headerId = headerChild ? "".concat(id, "-header") : undefined;
  return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: open,
    onOpen: onOpen,
    anchorNode: anchorNode,
    anchorOrigin: vertical ? "".concat(popoverPosition, " ").concat(popoverAlignment) : "".concat(popoverAlignment, " ").concat(popoverPosition),
    popoverOrigin: vertical ? "".concat((0, _utils.flipAlignment)(popoverPosition), " ").concat(popoverAlignment) : "".concat(popoverAlignment, " ").concat((0, _utils.flipAlignment)(popoverPosition)),
    offsetVertical: vertical ? offset : 0,
    offsetHorizontal: vertical ? 0 : offset,
    shrinkToFit: shrinkToFit,
    maxWidth: maxWidth
  }, function (_ref) {
    var popoverStyle = _ref.popoverStyle,
        popoverOrigin = _ref.popoverOrigin,
        anchorOrigin = _ref.anchorOrigin,
        anchorRect = _ref.anchorRect;
    return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, passThroughProps, indicatorArrow ? _objectSpread({}, _popoverBody["default"].generateArrowProps({
      popoverOrigin: popoverOrigin,
      anchorOrigin: anchorOrigin,
      anchorRect: anchorRect
    })) : null, {
      style: popoverStyle,
      minWidth: minWidth === "anchor" ? anchorRect.width : minWidth,
      maxWidth: maxWidth === "anchor" ? anchorRect.width : maxWidth,
      spacingInset: spacingInset,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      onFocus: onFocusFunc,
      tabIndex: "-1",
      ref: popoverBody,
      labelledById: headerId,
      allowOverflow: shrinkToFit,
      id: id
    }), headerChild ? /*#__PURE__*/_react["default"].cloneElement(headerChild, {
      onClose: close,
      t: t,
      id: headerId
    }) : null, nonHeaderChildren);
  });
}, shouldNotUpdate);

Popover.displayName = "Popover";
Popover.propTypes =  false ? {
  /**
   * The contents of the popover.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the popover open?
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * This determines which side of the anchor node the popover appears on.
   */
  position: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end"]).isRequired,

  /**
   * The popover will call this when it wants to close. The function provided
   * here should set the "open" prop to false.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * This determines how the popover is aligned with the anchor node.
   *
   * Note that only certain values are valid depending on what the "position" prop
   * is set to. If the position is "top" or "bottom" then valid values here
   * are "left", "right", or "center". If the position is "left" or "right"
   * then valid values are "top", "bottom", or "center".
   */
  alignment: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end", "center"]),

  /**
   * This must be an element that supports `onBlur` and `onFocus` properties.
   * This is not required to mount the popover, but it is required to open it.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Popover component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-expanded | aria-labelledby
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * Used to turn the indicator arrow for the PopoverBody child component off
   * and on. This is an internal API currently used for the Menu component,
   * and we recommend that you use the default value of `true` in normal use.
   */
  indicatorArrow: _propTypes["default"].bool,

  /**
   * Define a maximum width for the popover. Any CSS width value is
   * acceptable The magic value `"anchor"` may be used to set the maximum width
   * of the popover to the width of the anchor node.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Define a minimum width for the popover. Any CSS width value is
   * acceptable. The magic value `"anchor"` may be used to set the minimum width
   * of the popover to the width of the anchor node.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Turn this on to allow the popover to resize to fit within the viewport if
   * necessary. This may cause contents within the popover to scroll.
   *
   * NOTE: We recommend turning this prop on. It is off by default for backwards
   * compatibility. In the next major version of Meridian this prop will most
   * likely be removed and the "resize to fit" behavior will become the default
   * for the component.
   *
   * @since 5.x
   */
  shrinkToFit: _propTypes["default"].bool,

  /**
   * Apply padding around the contents of the popover using a preset.
   */
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium", "300", "400"]),

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * This function will be called when the popover is opened (after the
   * popover has been added to the DOM).
   */
  onOpen: _propTypes["default"].func
} : {};
Popover.defaultProps = {
  spacingInset: "medium",
  onKeyDown: _noop["default"],
  onOpen: _noop["default"],
  indicatorArrow: true,
  alignment: "center"
};
var _default = Popover;
exports["default"] = _default;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useOnBlurContainer = _interopRequireDefault(__webpack_require__(628));

var _default = _useOnBlurContainer["default"];
exports["default"] = _default;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

/**
 * Use this to detect when focus is leaving an element that contains other
 * focuseable elements. *Works with portals*.
 *
 * Elements receive blur events when they lose focus, but they also receive blur
 * events when the focus is transferred between elements that they contain. In
 * this case they'll get a blur event for the descendant losing focus followed
 * immediately by a focus event for the descendant receiving focus. This hook
 * allows you to listen only for the blur events where the focus is actually
 * moving outside the element, and is not just being transferred between
 * descendants of the element.
 */
var useOnBlurContainer = function useOnBlurContainer(onBlurContainer) {
  var blurTimeout = (0, _react.useRef)();
  var focus = (0, _react.useRef)(); // Clear the blur timeout when unmounting

  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, []); // When we get a blur event, mark the focus ref as false, wait one cycle,
  // and then execute the final callback if the focus ref is *still* false
  // (i.e. if onFocus wasn't called).

  var onBlur = (0, _react.useCallback)(function () {
    focus.current = false;
    blurTimeout.current = setTimeout(function () {
      if (!focus.current) {
        onBlurContainer();
      }
    }, 0);
  }, [onBlurContainer, focus]); // Mark the focus ref as true whenever we get a focus event

  var onFocus = (0, _react.useCallback)(function () {
    focus.current = true;
  }, [focus]);
  return {
    onBlur: onBlur,
    onFocus: onFocus
  };
};

var _default = useOnBlurContainer;
exports["default"] = _default;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _findIndex = _interopRequireDefault(__webpack_require__(122));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _optionList = _interopRequireDefault(__webpack_require__(630));

var _optionListGroup = _interopRequireDefault(__webpack_require__(259));

var _theme = __webpack_require__(7);

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _text = _interopRequireDefault(__webpack_require__(22));

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isGroup = (0, _isElementOf["default"])(_optionListGroup["default"]);
var styles = (0, _functional.memoize)(function (t) {
  var _lastChild;

  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    // Shared option and group header styles
    "& [mdn-option-list-item], & [role=presentation]": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      boxSizing: "border-box"
    },
    // Option styles
    "& [mdn-option-list-item]": {
      padding: "".concat(t("optionSpacingInsetVertical"), "px ").concat(t("optionSpacingInsetHorizontal"), "px"),
      transition: t.transitionCss("optionMotion", ["color", "background-color"]),
      // Foreground and background color
      backgroundColor: t("optionBackgroundColorDefault"),
      color: t("optionForegroundColorDefault"),
      // Set color of child <Text/> components
      "& p": {
        color: t("optionForegroundColorDefault")
      },
      "&[aria-selected=true]": {
        backgroundColor: t("optionBackgroundColorSelected"),
        color: t("optionForegroundColorSelected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorSelected")
        }
      },
      "&[aria-current=true]": {
        backgroundColor: t("optionBackgroundColorPreselected"),
        color: t("optionForegroundColorPreselected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPreselected")
        }
      },
      "&:active": {
        backgroundColor: t("optionBackgroundColorPressed"),
        color: t("optionForegroundColorPressed"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPressed")
        }
      },
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("optionBackgroundColorDisabled"),
        color: t("optionForegroundColorDisabled"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorDisabled")
        }
      }
    },
    // Group header styles
    "& [role=presentation]": {
      padding: "".concat(t("groupHeaderSpacingInsetVertical"), "px ").concat(t("groupHeaderSpacingInsetHorizontal"), "px"),
      // Foreground and background color
      backgroundColor: t("groupHeaderBackgroundColorDefault"),
      color: t("groupHeaderForegroundColorDefault"),
      fontWeight: t("groupHeaderFontWeight"),
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("groupHeaderBackgroundColorDisabled"),
        color: t("groupHeaderForegroundColorDisabled")
      }
    },
    // Group styles
    "& [role=group]": {
      borderBottom: t.borderCss("groupBorder")
    },
    // Children styles
    "& [mdn-option-list-item] > *:first-child": {
      flex: "auto"
    },
    // Selected indicator styles
    "&[aria-multiselectable=true] [mdn-option-list-item]": {
      "& > *:last-child": (_lastChild = {
        flexShrink: 0,
        // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
        // to use directional margin-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   marginInlineStart: t("optionSpacingHorizontal"),
        // },
        marginLeft: t("optionSpacingInsetHorizontal")
      }, (0, _defineProperty2["default"])(_lastChild, "[dir=\"rtl\"] &", {
        marginRight: t("optionSpacingInsetHorizontal"),
        marginLeft: 0
      }), (0, _defineProperty2["default"])(_lastChild, "color", t("optionIndicatorColorDefault")), (0, _defineProperty2["default"])(_lastChild, "transition", t.transitionCss("motion", "color")), _lastChild),
      "&[aria-current=true] > *:last-child": {
        color: t("optionIndicatorColorPreselected")
      },
      "&[aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorSelected")
      },
      "&:active > *:last-child": {
        color: t("optionIndicatorColorPressed")
      },
      "&[disabled] > *:last-child, &[aria-disabled] > *:last-child": {
        color: "transparent"
      },
      "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorDisabled")
      }
    }
  });
});
/**
 * This component helps render a keyboard-friendly list of selectable options.
 */

var OptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionList, _React$Component);

  var _super = _createSuper(OptionList);

  function OptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])(_this.props.role === "listbox" ? "option-list-" : "".concat(_this.props.role, "-")));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allOptions", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateListDomNode", function (node) {
      return _this.listDomNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function (options) {
      return (0, _findIndex["default"])(options, function (option) {
        return option && option.props.selected;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function () {
      return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function (offset) {
      var options = _this.allOptions;

      var preselectedIndex = _this.getPreselectedIndex();

      var selectedIndex = _this.getSelectedIndex(options);

      var enabledIndices = options.reduce(function (result, option, index) {
        if (option && !option.props.disabled) {
          result.push(index);
        }

        return result;
      }, []);
      var firstIndex = enabledIndices[0];
      var lastIndex = enabledIndices[enabledIndices.length - 1]; // If we've got a preselected or a selected option then move to the prev or
      // next option in the list (depending on the value of offset).

      var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;

      if (currentIndex !== -1) {
        var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
        return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move up, preselect the option at the bottom of the list.
      } else if (offset < 0) {
        return lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move down, preselect the option at the top of the list.
      } else {
        return firstIndex;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOptionByIndex", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.focus();
        return true;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function (preselectedIndex) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
      },
          focus = _ref.focus;

      if (_this.props.preselectedIndex === undefined) {
        _this.setState({
          preselectedIndex: preselectedIndex
        });

        if (focus) {
          _this.focusOptionByIndex(preselectedIndex);
        }
      }

      _this.props.onChangePreselectedIndex(preselectedIndex);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function (event) {
      // Call the user's key down handler first. If they prevent the default event
      // behavior, don't run any of our code.
      _this.props.onKeyDown(event);

      if (!event.defaultPrevented) {
        var key = (0, _keycode["default"])(event);
        var keyUsed = false; // Move the preselection up or down in the list when the up arrow is pressed

        if (key === "up" || key === "down") {
          var preselectedIndex = _this.getNextPreselectedIndex(key === "up" ? -1 : 1);

          _this.onChangePreselectedIndex(preselectedIndex);

          _this.scrollOptionIntoView(preselectedIndex);

          keyUsed = true;
        } // Simulate a click on the current preselected option when enter or space is
        // pressed


        if (key === "enter" || key === "space") {
          var _preselectedIndex = _this.getPreselectedIndex();

          var option = _this.allOptions[_preselectedIndex];

          if (option && !option.props.disabled) {
            _this.allOptions[_preselectedIndex].props.onClick();
          }

          keyUsed = true;
        } // Don't perform the normal action associated with the key (i.e. scroll for
        // arrows) if the key was used for an option list action


        if (keyUsed) {
          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function (index) {
      return function (domNode) {
        return (
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.optionDomNodes[index] = _reactDom["default"].findDOMNode(domNode)
        );
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.scrollIntoView(optionDomNode);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionList, [{
    key: "focus",
    value: function focus() {
      return this.listDomNode.focus();
    }
  }, {
    key: "processChildren",
    value: function processChildren() {
      var _this2 = this;

      var preselectedIndex = this.state.preselectedIndex;
      var id = this.props.id || this.id;
      var processedChildren = []; // Rest option counter to 0

      var optionCounter = 0; // Reset allOptions which tracks option components (no group components)

      this.allOptions = [];

      _react["default"].Children.toArray(this.props.children).forEach(function (child) {
        if (!child) {
          return;
        } else if (isGroup(child)) {
          var _this2$allOptions;

          var updatedGroup = /*#__PURE__*/_react["default"].cloneElement(child, child.props, _react["default"].Children.map(child.props.children, function (option, i) {
            var index = optionCounter + i;
            return /*#__PURE__*/_react["default"].cloneElement(option, {
              ref: _this2.optionRef(index),
              id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
              // If "child" (the group) is disabled then disable all of its options
              disabled: child.props.disabled || option.props.disabled,
              preselected: index === preselectedIndex,
              showIndicator: _this2.props.multiSelectable,
              onChangePreselected: function onChangePreselected(preselected) {
                return (// Don't shift focus on mouse over
                  _this2.onChangePreselectedIndex(preselected ? index : -1, {
                    focus: false
                  })
                );
              }
            });
          })); // Update allOptions tracker


          _this2.allOptions = (_this2$allOptions = _this2.allOptions).concat.apply(_this2$allOptions, (0, _toConsumableArray2["default"])(updatedGroup.props.children)); // Push onto array

          processedChildren.push(updatedGroup); // Update option counter

          optionCounter += updatedGroup.props.children.length;
        } else {
          var index = optionCounter;

          var updatedOption = /*#__PURE__*/_react["default"].cloneElement(child, {
            ref: _this2.optionRef(index),
            id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
            preselected: index === preselectedIndex,
            showIndicator: _this2.props.multiSelectable,
            onChangePreselected: function onChangePreselected(preselected) {
              return (// Don't shift focus on mouse over
                _this2.onChangePreselectedIndex(preselected ? index : -1, {
                  focus: false
                })
              );
            }
          }); // Update allOptions tracker


          _this2.allOptions = _this2.allOptions.concat(updatedOption); // Push onto array

          processedChildren.push(updatedOption); // Update option counter

          optionCounter += 1;
        }
      });

      return processedChildren;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Scroll the preselected or selected option into view on mount
      var preselectedIndex = this.getPreselectedIndex();

      if (preselectedIndex !== -1) {
        this.scrollOptionIntoView(preselectedIndex);
      } else {
        this.scrollOptionIntoView(this.getSelectedIndex(this.allOptions));
      } // Focus on mount


      if (this.props.autoFocus || this.props.inaccessibleAutoFocus) {
        // NOTE: React guarantees that callback refs will be resolved before
        // componentDidMount is called, so this is safe.
        this.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          preselectedIndex = _this$props.preselectedIndex,
          defaultPreselectedIndex = _this$props.defaultPreselectedIndex; // If the preselected index was changed via props, update the internal state

      if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) {
        this.setState({
          preselectedIndex: preselectedIndex
        });
        this.focusOptionByIndex(preselectedIndex);
      } else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
        this.setState({
          preselectedIndex: defaultPreselectedIndex
        }); // If the default was changed then scroll it into view. We don't do this
        // if the `preselectedIndex` prop is changed because that means the parent
        // component is fully managing state and will need to be responsible for
        // managing scroll position as well.

        this.scrollOptionIntoView(defaultPreselectedIndex);

        if (this.props.recalculateFocusOnUpdate) {
          this.focusOptionByIndex(defaultPreselectedIndex);
        }
      } // Always refocus on update in case the options move around and between groups
      // which could break React's connection with the underlying elements
      else if (this.props.recalculateFocusOnUpdate) {
        var _preselectedIndex2 = this.state.preselectedIndex;

        if (_preselectedIndex2 >= 0) {
          var successfulFocus = this.focusOptionByIndex(_preselectedIndex2); // If focusing on the preselected index was not successful, see if it was
          // because the option list shrunk

          if (!successfulFocus) {
            var filteredDomNodeList = this.optionDomNodes.filter(function (option) {
              return option;
            }); // If the list shrank and the preselected index now exceeds the number
            // of valid options, focus on the last valid option

            if (_preselectedIndex2 > filteredDomNodeList.length - 1) {
              this.setState({
                preselectedIndex: filteredDomNodeList.length - 1
              });
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var id = props.id || this.id;
      var children = this.processChildren();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _optionList["default"],
        map: (0, _token.getTokenHelper)("optionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.updateListDomNode,
          onKeyDown: _this3.onKeyDownContainer,
          tabIndex: "0",
          role: props.role,
          "aria-multiselectable": props.multiSelectable,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          className: styles(t),
          id: id
        }, children);
      });
    }
  }]);
  return OptionList;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionList, "defaultProps", {
  role: "listbox",
  onKeyDown: _noop["default"],
  onChangePreselectedIndex: _noop["default"]
});
OptionList.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * The index of the default "preselected" option. The "preselected" option
   * is the option that is highlighted and will be selected if the user
   * presses enter or space on their keyboard.
   *
   * NOTE: This is an uncontrolled component by default. It tracks the
   * preselected index using internal state. If the value of this prop changes
   * the internal state will be updated to reflect the new value, but
   * subsequent user interaction with the component may change the internal
   * state. To use make this component behave like a controlled component, use
   * the "preselectedIndex" and "onChangePreselectedIndex" props below.
   *
   */
  defaultPreselectedIndex: _propTypes["default"].number,

  /**
   * Sets an `id` attribute on the listbox element.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the option list will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * If set to true if more than one option may be selected at once.
   */
  multiSelectable: _propTypes["default"].bool,

  /**
   * Use this to fix the index of the "preselected" option. This will disable
   * the internal state used to track the preselected index.
   */
  preselectedIndex: _propTypes["default"].number,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  role: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called any time the OptionList wants to update the preselected
   * index
   */
  onChangePreselectedIndex: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   *
   * If `event.preventDefault()` is called from this handler then the option
   * list's default keyboard behavior will be prevented.
   */
  onKeyDown: _propTypes["default"].func
} : {};
var _default = OptionList;
exports["default"] = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    optionListOptionMobileSpacingInsetVertical: 16,
    optionListOptionMobileSpacingInsetHorizontal: 16,
    optionListOptionSpacingInsetVertical: 8,
    optionListOptionSpacingInsetHorizontal: 12,
    optionListOptionForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    optionListOptionForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionForegroundColorPreselected: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorPreselected: tokens.themeForegroundAccentHover,
    optionListOptionBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    optionListOptionBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    optionListOptionIndicatorColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionIndicatorColorPreselected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionIndicatorColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionMotionDuration: "100ms",
    optionListOptionMotionFunction: "ease",
    optionListOptionLineHeight: "24px",
    optionListGroupHeaderSpacingInsetVertical: 8,
    optionListGroupHeaderSpacingInsetHorizontal: 12,
    optionListGroupHeaderForegroundColorDefault: tokens.themeForegroundSecondaryDefault,
    optionListGroupHeaderForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListGroupHeaderBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderFontWeight: 600,
    optionListGroupBorderColor: tokens.themeBorderSecondaryDefault,
    optionListGroupBorderWidth: 1
  }
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _checkLarge = _interopRequireDefault(__webpack_require__(140));

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OptionListItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionListItem, _React$Component);

  var _super = _createSuper(OptionListItem);

  function OptionListItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselected: _this.props.preselected,
      selected: _this.props.selected
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseX", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseY", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseMove", function (event) {
      if (!_this.props.preselected) {
        _this.props.onChangePreselected(true);
      } // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).


      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function (event) {
      // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).
      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function (event) {
      // If the user has moused out of an option by moving their mouse (and not by
      // scrolling the option out from under their mouse) then blur it. Don't blur
      // if they haven't moved their mouse. This allows the user to use keyboard
      // navigation while their mouse cursor is resting over the list (otherwise
      // the mouse and keyboard end up fighting over control).
      if (_this.props.preselected && (event.clientX !== _this.mouseX || event.clientY !== _this.mouseY)) {
        _this.props.onChangePreselected(false);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionListItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.label !== this.props.label || nextProps.children !== this.props.children || nextProps.disabled !== this.props.disabled || nextProps.href !== this.props.href || nextProps.id !== this.props.id || nextState.selected !== this.state.selected || nextState.preselected !== this.state.preselected;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$state = this.state,
          selected = _this$state.selected,
          preselected = _this$state.preselected;
      var children = props.children ? props.children({
        selected: selected,
        preselected: preselected
      }) : props.label;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseMove: props.disabled ? undefined : this.onMouseMove,
        onMouseEnter: props.disabled ? undefined : this.onMouseEnter,
        onMouseLeave: props.disabled ? undefined : this.onMouseLeave,
        role: props.role,
        "aria-selected": selected ? "true" : "false",
        "aria-current": preselected ? "true" : undefined,
        "aria-label": props.label,
        tabIndex: "-1",
        "mdn-option-list-item": ""
      }), /*#__PURE__*/_react["default"].createElement("div", null, children), props.showIndicator ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        tokens: _checkLarge["default"]
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var preselected = state.preselected,
          selected = state.selected;

      if (props.selected !== selected) {
        // If the option was just selected or deselected then don't show the
        // preselected state
        return {
          selected: props.selected,
          preselected: false
        };
      } else if (props.preselected !== preselected) {
        // If the preselected prop was changed from on high then update the
        // internal preselected state to stay in sync
        return {
          preselected: props.preselected
        };
      } else {
        return null;
      }
    }
  }]);
  return OptionListItem;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionListItem, "defaultProps", {
  selected: false,
  preselected: false,
  role: "option"
});
OptionListItem.propTypes =  false ? {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the OptionListItem component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-selected | aria-current | aria-label
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  id: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  preselected: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,
  role: _propTypes["default"].string,
  selected: _propTypes["default"].bool,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  showIndicator: _propTypes["default"].bool,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  onChangePreselected: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = OptionListItem;
exports["default"] = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MenuItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuItem, _React$Component);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    (0, _classCallCheck2["default"])(this, MenuItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "render",
    value: function render() {
      // This component is used to create a nice API, the OptionListItem
      // component is used to actually render the menu item
      return null;
    }
  }]);
  return MenuItem;
}(_react["default"].Component);

MenuItem.propTypes =  false ? {
  /**
   * The content of the menu item. Plain text and icons are recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the MenuItem component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-selected | aria-current
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI,
   * but will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   * @since 5.11.0
   */
  "aria-label": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.13.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = MenuItem;
exports["default"] = _default;

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StageStatusView__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_RouteStageContext__ = __webpack_require__(30);
var StageOverallStatus=function StageOverallStatus(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-3","grid-3","grid-3"],spacingInset:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.totalRoutes",message:"Total Routes",value:viewModel.totalRoutes}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.routesStaged",message:"Routes Staged",value:viewModel.stagedRoutes}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.routesDeparted",message:"Routes Departed",value:viewModel.departedRoutes}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-3","grid-3","grid-3","grid-3"],spacingInset:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.cartsStaged",message:"Carts Staged",value:viewModel.stagedCarts}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.cartDwellingDSP",message:"Carts Dwelling (DSP)",value:viewModel.dwellingCartsDSP}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StageStatusView__["a" /* default */],{stageStatus:{title:"stageOverall.cartDwellingFlex",message:"Carts Dwelling (Flex)",value:viewModel.dwellingCartsFlex}})));};/* harmony default export */ __webpack_exports__["a"] = (StageOverallStatus);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
var StageStatusView=function StageStatusView(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overview-fph"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading___default.a,{level:3,type:"h300",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:data.stageStatus.title,defaultMessage:data.stageStatus.message}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"d50"},data.stageStatus.value));};/* harmony default export */ __webpack_exports__["a"] = (StageStatusView);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _text = _interopRequireDefault(__webpack_require__(29));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var Heading = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_text["default"], (0, _extends2["default"])({
    type: props.type ? props.type : "h".concat(7 - props.level, "00"),
    tag: "h".concat(props.level),
    id: props.id,
    color: props.color,
    alignment: props.alignment,
    transform: props.transform,
    truncate: props.truncate,
    fontFamily: props.fontFamily,
    className: props.className,
    tabIndex: props.tabIndex,
    ref: ref
  }, passThroughProps), props.children);
});

Heading.displayName = "Heading";
Heading.propTypes =  false ? {
  /**
   * The heading text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements).
   */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired,

  /**
   * The text alignment of the heading.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the heading's text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets an `id` attribute on the component's DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Heading to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
var _default = Heading;
exports["default"] = _default;

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_CapabilityContext__ = __webpack_require__(20);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var StageFilter=function StageFilter(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext.viewModelF,dispatchF=_useContext.dispatchF;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),filterState=_useState2[0],setFilterState=_useState2[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext3.viewModel;var toggleFilter=function toggleFilter(){setFilterState(!filterState);};var stageDataConversionHandler=function stageDataConversionHandler(){return Object(__WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__["c" /* getStageDataInCSVFormat */])(viewModel.cartList,viewModel.routeList,viewModelF.viewType,configViewModel.capability,configViewModel.stationConfig);};var isFilterSet=function isFilterSet(){var result=false;Object.entries(viewModelF).forEach(function(entry){var key=entry[0];var values=entry[1];result=result||Array.isArray(values)&&values.length&&key!=='data';});return result;};var clearAllFilters=function clearAllFilters(){dispatchF({type:'REMOVE_ALL_FILTER'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"medium large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default.a,{href:"",type:"secondary",onClick:toggleFilter},"Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{spacing:"small"},Object.entries(viewModelF).map(function(entry){var key=entry[0];var values=entry[1];return Array.isArray(values)&&key!=='data'?values.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{key:value,type:"neutral",onClose:function onClose(){return dispatchF({type:'REMOVE_FILTER',data:{key:key,value:value}});}},value);}):null;}),isFilterSet()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default.a,{onClick:clearAllFilters,type:"secondary"},"Clear all"):null)),filterState?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacing:"none",spacingInset:"medium large medium large",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{heights:"fill",alignmentHorizontal:"left",spacingInset:"none small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{type:"h100",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"stageFilter.departure",defaultMessage:"Departure"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DEPARTURE',Departure:data});},value:viewModelF.departure,size:"small",placeholder:"Departure",width:150},[].concat(_toConsumableArray(viewModelF.data.departure)).sort().map(function(departure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:departure,label:"Departing "+departure,value:departure});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{heights:"fill",alignmentHorizontal:"left",spacingInset:"none small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{type:"h100",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"stageFilter.driverType",defaultMessage:"Driver Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:data});},value:viewModelF.driverType,size:"small",placeholder:"Driver Type",width:150},[].concat(_toConsumableArray(viewModelF.data.driverType)).sort().map(function(driverType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:driverType,label:driverType,value:driverType});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{heights:"fill",alignmentHorizontal:"left",spacingInset:"none small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{type:"h100",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"stageFilter.cluster",defaultMessage:"Cluster"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_CLUSTER',Cluster:data});},value:viewModelF.cluster,size:"small",placeholder:"Cluster",width:150},[].concat(_toConsumableArray(viewModelF.data.cluster)).sort().map(function(cluster){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:cluster,label:cluster,value:cluster});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{heights:"fit",alignmentHorizontal:"left",spacingInset:"none small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{type:"h100",alignment:"left"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__["a" /* default */],{csvDataProvider:stageDataConversionHandler,filePrefix:"STAGE"}))):null);};/* harmony default export */ __webpack_exports__["a"] = (StageFilter);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _find = _interopRequireDefault(__webpack_require__(88));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(260));

var _chevronSelect = _interopRequireDefault(__webpack_require__(638));

var _select = _interopRequireDefault(__webpack_require__(639));

var _selectOptionList = _interopRequireDefault(__webpack_require__(640));

var _selectOptionListContainer = _interopRequireDefault(__webpack_require__(643));

var _utils = __webpack_require__(261);

var _inputBox = _interopRequireDefault(__webpack_require__(250));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _theme = __webpack_require__(7);

var _responsive = _interopRequireDefault(__webpack_require__(148));

var _context = _interopRequireDefault(__webpack_require__(659));

var _token = __webpack_require__(8);

var _text = _interopRequireDefault(__webpack_require__(22));

var _inputReset = _interopRequireDefault(__webpack_require__(252));

var _noTextWrap = _interopRequireDefault(__webpack_require__(101));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(251));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(253));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width,
      minWidth = _ref.minWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    position: "relative",
    width: width,
    // If an explicit width is set then don't allow the select to flex
    flex: width ? "none !important" : undefined,
    minWidth: minWidth
  });
}, ["width", "minWidth"]);
var customSearchInputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled,
      open = _ref2.open,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("searchInputForegroundColorDefault"),
    placeholderColor: t("searchInputPlaceholderColor", disabled ? "disabled" : "default")
  }), // If the select is open then hide the value label and show the input,
  // otherwise hide the input and show the label. Note that the input is
  // visually hidden but is still focuseable (so the user can tab to it).
  open ? {
    "& + div": {
      display: "none"
    }
  } : // Preserve the input's width so the Select doesn't change width on
  // focus/input reveal.
  _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
    width: "auto",
    position: "initial"
  }));
}, ["disabled", "open", "empty"]);
var valueLabelStyles = (0, _emotion.css)(_noTextWrap["default"]);

var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  // Are the select options open?
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // This enables us to preselect an option in the option list. This is the
  // "default" because the internal state of the option list may change if the
  // user uses up/down arrow keys to manage the preselected index.


  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      defaultPreselectedIndex = _useState4[0],
      setDefaultPreselectedIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultPreselectedIndex),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      preselectedIndex = _useState6[0],
      setPreselectedIndex = _useState6[1]; // For this component, there are two types of searching:
  //   1) Custom searching is what happens when `onSearch` and `searchQuery`
  //      are passed in as props. This renders a search input inside the
  //      Select and allows the developer to filter options down according to
  //      any custom search algorithm.
  //   2) Native searching is what happens when no custom search props are
  //      passed. This search mimicks the behavior of native html selects -
  //      the search query is stored internally and the first option that
  //      matches the query (prefix matching only) is selected if the select
  //      is closed or "preselected" if the select is open.


  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      nativeSearchQuery = _useState8[0],
      setNativeSearchQuery = _useState8[1]; // We don't actually use the focus prop but we DO set it down the line


  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      setFocusState = _useState10[1];

  var rootRef = (0, _react.useRef)(null);
  var optionListRef = (0, _react.useRef)(null);

  var updateOptionListRef = function updateOptionListRef(ref) {
    return optionListRef.current = ref;
  };

  var customSearchInputRef = (0, _react.useRef)(null);
  var onSearch = props.onSearch;
  var nativeSearchTimeoutDuration = 1000; // Generate a unique id that can be used to reference this element in the DOM

  var id = props.id || (0, _uniqueId["default"])("select-");
  var popupId = (0, _uniqueId["default"])("options-list-");
  var isMultiSelectable = Array.isArray(props.value);
  var isNativeSearching = /[\S]/.test(nativeSearchQuery);
  var isCustomSearchable = Boolean(props.onSearch);
  var nativeSearchTimeout = (0, _react.useRef)(); // Assign the local and prop ref (if it exists) to the target ref (select)

  var assignRefs = (0, _react.useCallback)(function (targetRef) {
    rootRef.current = targetRef;

    if (forwardedRef) {
      // Assign the ref with a function (Class components) or assigning .current
      // (modern functional components using the `useRef` hook)
      if (typeof forwardedRef === "function") {
        forwardedRef(targetRef);
      } else {
        forwardedRef.current = targetRef;
      }
    }
  }, [forwardedRef]);
  var options = (0, _utils.getOptionsFromChildren)(props.children);
  var selectedOptions = options.filter(function (option) {
    return (0, _utils.isOptionValueSelected)(props.value, option.value);
  });
  var valueLabel = props.valueLabel(selectedOptions) || "";
  var t = (0, _theme.useTheme)(_select["default"], "select");
  /**
   * Close the select, optionally retaining focus on the handle.
   */

  var close = (0, _react.useCallback)(function (_ref3) {
    var retainFocus = _ref3.retainFocus;
    setOpen(false);
    setFocusState(retainFocus);
    setDefaultPreselectedIndex(undefined);

    if (isCustomSearchable) {
      onSearch("");
    } else {
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
    } // Move focus back to the main node before closing the option list


    if (retainFocus) {
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    }
  }, [isCustomSearchable, onSearch]);
  /**
   * Take the current search query and attempt to find and focus the matching
   * option
   */

  var nativeSearch = (0, _react.useCallback)(function (searchQuery) {
    var value = props.value,
        onChange = props.onChange,
        children = props.children;
    var options = (0, _utils.getOptionsFromChildren)(children).filter(function (_ref4) {
      var disabled = _ref4.disabled;
      return !disabled;
    });
    var selectedOption = (0, _find["default"])(options, function (option) {
      return (0, _utils.isOptionValueSelected)(value, option.value);
    }); // Look for the first option that starts with the full search query

    var searchQueryRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(searchQuery)), "i");
    var fullMatch = (0, _find["default"])(options, function (option) {
      return searchQueryRegExp.test(option.label);
    }); // Look for an option that starts with the last character typed. Sort the
    // options so that if the same character is typed repeatedly the focus
    // cycles through all matching options.

    var lastChar = searchQuery[searchQuery.length - 1];
    var lastCharRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(lastChar)), "i");
    var currentIndex = open ? defaultPreselectedIndex : selectedOption ? selectedOption.index : 0;
    var lastCharMatch = (0, _find["default"])([].concat((0, _toConsumableArray2["default"])(options.slice(currentIndex + 1)), (0, _toConsumableArray2["default"])(options.slice(0, currentIndex + 1))), function (option) {
      return lastCharRegExp.test(option.label);
    }); // Prefer a full match to a last character match

    var match = fullMatch || lastCharMatch; // If the select is expanded and we have a match then focus it

    if (match && open) {
      setDefaultPreselectedIndex(match.index);
    } // If the select is closed and we have a match then select it
    else if (match) {
      onChange(isMultiSelectable ? [match.value] : match.value);
    }
  }, [defaultPreselectedIndex, isMultiSelectable, open, props]);
  /**
   * Event handlers
   */

  var onClickOption = function onClickOption(value) {
    if (isMultiSelectable) {
      // If the value is selected then deselect it, otherwise select it
      if ((0, _utils.isOptionValueSelected)(props.value, value)) {
        props.onChange(props.value.filter(function (v) {
          return v !== value;
        }));
      } else {
        props.onChange([].concat((0, _toConsumableArray2["default"])(props.value), [value]));
      } // If the searchable, multi-Select contains groups, refocus
      // on the Select after an option has been clicked.


      if (isCustomSearchable && _react["default"].Children.toArray(props.children).some(function (child) {
        return (0, _utils.isGroup)(child);
      })) {
        customSearchInputRef.current.focus();
      }
    } else {
      close({
        retainFocus: true
      });
      props.onChange(value);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    var disabled = props.disabled;
    var key = (0, _keycode["default"])(event); // HACK: Assume the key is "printable" (can be added to a search query) if
    // it's either of length 1 or a space.

    var printableKey = key && key.length === 1 ? key : key === "space" ? " " : undefined;
    var isNativeSearch = isNativeSearching;
    var keyUsed = false; // If any character is typed that doesn't trigger behavior in the option
    // list (as indicated by event.defaultPrevented set to true) then make sure
    // the custom search input is focused

    if (isCustomSearchable && !event.defaultPrevented && customSearchInputRef.current !== document.activeElement) {
      customSearchInputRef.current.focus();
    } // If no custom search behavior is defined and a printable key was typed,
    // trigger the "native" search functionality that mimics the browser


    if (!isCustomSearchable && printableKey) {
      var nativeSearchQueryPrintableKey = nativeSearchQuery + printableKey;
      setNativeSearchQuery(nativeSearchQueryPrintableKey);
      nativeSearch(nativeSearchQueryPrintableKey); // Reset the timeout that will the search query

      clearTimeout(nativeSearchTimeout.current);
      nativeSearchTimeout.current = window.setTimeout(function () {
        setNativeSearchQuery("");
        setDefaultPreselectedIndex(undefined);
      }, nativeSearchTimeoutDuration);
      keyUsed = true;
    } // If no custom search behavior is defined and backspace or delete was
    // pressed, clear the "native" search query


    if (!isCustomSearchable && (key === "backspace" || key === "delete")) {
      // Reset the timeout that will clear search query and instead clear the
      // query immediately
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
      keyUsed = true;
    } // If the user hits escape on an open select then close it


    if (open && key === "esc") {
      // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.
      event.stopPropagation();
      close({
        retainFocus: true
      });
      keyUsed = true;
    } // If the user hits up, down, or backspace/delete/space (and they're not in
    // the middle of a search) on a collapsed select then open it


    if (!open && !disabled && (key === "up" || key === "down" || (key === "backspace" || key === "delete" || key === "space") && !isNativeSearch)) {
      setOpen(true);
      keyUsed = true;
    } // Disabled tabbing while the select is open


    if (open && key === "tab") {
      keyUsed = true;
    } // Don't perform the normal action associated with the key (e.g. scroll for
    // arrows/space) if the key was used for a select-related action


    if (keyUsed) {
      event.preventDefault();
    }
  };

  var onKeyDownOptionList = function onKeyDownOptionList(event) {
    // Prevent "space" from selecting an option when the user is searching
    if ((0, _keycode["default"])(event) === "space" && isNativeSearching) {
      event.preventDefault();
    }
  };

  var onKeyDownCustomSearchInput = function onKeyDownCustomSearchInput(event) {
    var key = (0, _keycode["default"])(event); // If the user presses an up/down arrow key when focused on an open
    // searchable select's search input, then transfer the focus to the option
    // list and immediately move the preselected index from the current option
    // to the next/previous option. This mimicks what would happen if the option
    // list was focused when the arrow key was pressed.

    if (open && (key === "down" || key === "up") && optionListRef.current) {
      setDefaultPreselectedIndex(optionListRef.current.getNextPreselectedIndex(key === "down" ? 1 : -1));
      optionListRef.current.focus();
      event.preventDefault();
    } // If the user presses enter when focused on an open searchable select's
    // search input, then select the  first item in the option list (which will
    // be the preselected option). This mimicks what would happen if the option
    // list was focused when the enter key was pressed.
    else if (open && key === "enter") {
      var firstOption = (0, _utils.getOptionsFromChildren)(props.children)[0]; // Only select the first option if there's a search query

      if (firstOption && props.searchQuery && !firstOption.disabled) {
        onClickOption(firstOption.value);
      } // Don't submit a form if the user presses enter on an open searchable
      // select


      event.preventDefault();
    }
  };

  var onChangeCustomSearchInput = function onChangeCustomSearchInput(event) {
    var value = event.target.value; // Make sure the select is open if the user is typing in a search query

    if (!open) {
      setOpen(true);
    } // If we have a query, presleect the first option if it isn't already


    if (value && defaultPreselectedIndex !== 0) {
      setDefaultPreselectedIndex(0);
    } // If we don't have a query, clear the preselected option


    if (!value && defaultPreselectedIndex !== -1) {
      setDefaultPreselectedIndex(-1);
    }

    props.onSearch(value);
  };

  var onMouseDownInputBox = function onMouseDownInputBox(event) {
    if (isCustomSearchable) {
      if (!open) {
        // If the user mouses down on a closed searchable select, open it
        setOpen(true);
      }

      if (event.target !== customSearchInputRef.current) {
        // If the user mouses down on the input box of a custom searchable
        // select, focus on the custom search input
        customSearchInputRef.current.focus();
        event.preventDefault();
      }
    } else {
      // If the user mouses down on a non-searchable select, toggle it
      setOpen(!open);
    }
  };
  /**
   * Re-trigger the option list's "componentDidMount" when the option list is
   * actually visible. This is necessary because the things the option list does
   * on mount (like setting the scroll and transferring focus) only work when
   * it's visible, but the PopoverController mounts it in an invisible state (in
   * order to fade it in). This is only done for the popover because the
   * BottomSheet's onOpen even fires before its children are mounted, so this
   * won't work.
   */


  var onOpenPopover = function onOpenPopover() {
    if (optionListRef.current) {
      optionListRef.current.componentDidMount();
    }
  };
  /**
   * Close and retain focus if the user attempts to close the bottom sheet (e.g.
   * by tapping outside of it). This isn't necessary for the popover which
   * doesn't initiate its own close events.
   */


  var onCloseBottomSheet = function onCloseBottomSheet() {
    return close({
      retainFocus: true
    });
  };
  /**
   * Close the select when it loses focus.
   */


  var onBlur = function onBlur(event) {
    close({
      retainFocus: false
    });

    if (props.onBlur) {
      props.onBlur(event);
    }
  };
  /**
   * Clear out the default preselected index when the option list changes its
   * internal state. This allows us to update the default later on and stomp the
   * option list's internal state when we need too. If we didn't reset the
   * default here and just left it at 0 (for example), then setting it to 0
   * again later on would have no effect.
   */


  var onChangePreselectedIndex = function onChangePreselectedIndex(index) {
    if (defaultPreselectedIndex !== undefined) {
      setDefaultPreselectedIndex(undefined);
    }

    setPreselectedIndex(index);
  };

  (0, _react.useEffect)(function () {
    if (props.autoFocus || props.inaccessibleAutoFocus) {
      // NOTE: React guarantees that callback refs will be resolved before
      // componentDidMount is called, so this is safe.
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    } // NOTE: Only run this once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []); // Cleanup - formerly sat in componentWillUnmount

  (0, _react.useEffect)(function () {
    return function () {
      return clearInterval(clearTimeout(nativeSearchTimeout.current));
    };
  }, []);
  (0, _react.useEffect)(function () {
    var disabled = props.disabled; // Collapse the select if it was disabled while open

    if (disabled && open) {
      close({
        retainFocus: false
      });
    }
  }, [close, open, props.disabled]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: onBlur
  }),
      focusProps = _useFocus.focusProps,
      focus = _useFocus.focus;
  /**
   * When support text has been provided to Select, add an aria-describedby
   * prop to Select for better screen reader experiences
   */


  var ariaDescribedbySupportText = (0, _react.useMemo)(function () {
    return (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    });
  }, [id, props.helperText, props.constraintText, props.errorMessage, props.size]);

  var ariaProps = _objectSpread(_objectSpread({
    "aria-describedby": ariaDescribedbySupportText,
    "aria-label": props.label
  }, (0, _filterPropsByPrefix["default"])(props, ["aria-"])), {}, {
    role: "combobox",
    "aria-controls": popupId,
    "aria-haspopup": true,
    "aria-expanded": open,
    "aria-disabled": props.disabled,
    "aria-activedescendant": open && optionListRef.current ? "".concat(optionListRef.current.props.id, "-").concat(preselectedIndex) : undefined
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: styles(t, {
      width: props.width,
      minWidth: props.minWidth
    })
  }, /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
    query: "min-width",
    fallback: "".concat(t("optionListPopoverBreakpoint"), "px"),
    props: {
      optionListContainerType: isCustomSearchable ? {
        "default": "popover"
      } : (0, _defineProperty2["default"])({
        "default": "bottom-sheet"
      }, "".concat(t("optionListPopoverBreakpoint"), "px"), "popover")
    }
  }, function (_ref6) {
    var optionListContainerType = _ref6.optionListContainerType;
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, focusProps, {
      onKeyDown: props.disabled ? undefined : onKeyDown
    }), /*#__PURE__*/_react["default"].createElement(_context["default"].Consumer, null, function (_ref7) {
      var _ref7$suffixIconToken = _ref7.suffixIconTokens,
          suffixIconTokens = _ref7$suffixIconToken === void 0 ? _chevronSelect["default"] : _ref7$suffixIconToken;
      return /*#__PURE__*/_react["default"].createElement(_inputBox["default"], (0, _extends2["default"])({
        label: props.label,
        labelId: "".concat(id, "-label"),
        htmlFor: id,
        empty: !valueLabel,
        focus: focus,
        suffixIconTokens: suffixIconTokens,
        animated: optionListContainerType === "popover",
        labelFloated: isCustomSearchable && open || Boolean(props.placeholder || valueLabel),
        disabled: props.disabled,
        size: props.size,
        prefix: props.prefix,
        suffix: props.suffix,
        error: props.error && !focus,
        cursor: isCustomSearchable && open ? "text" : "pointer",
        onMouseDown: props.disabled ? undefined : onMouseDownInputBox,
        tabIndex: props.disabled || isCustomSearchable ? undefined : "0"
      }, !isCustomSearchable ? ariaProps : {}, {
        ref: assignRefs,
        id: id
      }, passThroughProps, {
        onKeyDown: props.disabled ? undefined : onKeyDown
      }), isCustomSearchable ? /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, isCustomSearchable ? ariaProps : {}, {
        // HACK: Prepend the value id if it exists to aria-labelledby
        // so it's read by screen-readers. This is necessary because
        // the <input> value attribute resets to an empty string
        // after a user has selected a value so they can begin
        // typing a new query with a fresh start.
        "aria-labelledby": "".concat(id, "-value ").concat(ariaProps["aria-labelledby"] || "".concat(id, "-label")),
        "aria-autocomplete": "list",
        "aria-controls": popupId,
        type: "text",
        onKeyDown: onKeyDownCustomSearchInput,
        className: customSearchInputStyles(t, {
          empty: props.searchQuery === undefined || props.searchQuery === "",
          open: open,
          disabled: props.disabled
        }),
        placeholder: props.placeholder,
        value: props.searchQuery || "",
        ref: customSearchInputRef,
        onChange: onChangeCustomSearchInput,
        disabled: props.disabled,
        autoComplete: "off"
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: valueLabelStyles,
        id: "".concat(id, "-value"),
        "mdn-select-value": ""
      }, valueLabel ? valueLabel : props.placeholder));
    }), /*#__PURE__*/_react["default"].createElement(_selectOptionListContainer["default"], {
      type: optionListContainerType,
      open: open,
      popoverAnchorNode: rootRef.current,
      popoverMaxHeight: props.popoverMaxHeight,
      onOpenPopover: onOpenPopover,
      onCloseBottomSheet: onCloseBottomSheet,
      t: t,
      closeLabel: props.closeLabel
    }, /*#__PURE__*/_react["default"].createElement(_selectOptionList["default"], (0, _extends2["default"])({
      open: open,
      autoFocus: !isCustomSearchable,
      value: props.value,
      searchQuery: props.searchQuery,
      defaultPreselectedIndex: defaultPreselectedIndex,
      onChangePreselectedIndex: onChangePreselectedIndex,
      onClickOption: onClickOption,
      onKeyDown: onKeyDownOptionList,
      ref: updateOptionListRef,
      id: popupId // Only recalculate focus if we're native searchable
      ,
      recalculateFocusOnUpdate: !isCustomSearchable
    }, focusProps), props.children)), props.name ? isMultiSelectable ? props.value.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        key: value,
        name: "".concat(props.name, "[]"),
        value: value
      });
    }) : /*#__PURE__*/_react["default"].createElement("input", {
      type: "hidden",
      name: props.name,
      value: props.value || ""
    }) : null);
  }));
});

Select.displayName = "Select";
Select.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements that represent the choices to present to
   * the user.
   *
   * If no `SelectOption` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asyncronously loaded options or a
   * message to the user when no options are available. Note that these elements
   * cannot contain anything interactive like links or buttons for accessibility
   * reasons.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Select component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-controls | aria-haspopup | aria-expanded | aria-disabled | aria-autocomplete | aria-activedescendant
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the Select these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the Select.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the close icon Button that appears in the mobile
   * view of the SelectOptionListContainer.
   *
   * NOTE: The default value for this prop is in English. If you support
   * multiple locales you will need to provide this prop for each locale.
   *
   * @since 5.27.0
   *
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Select.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the select will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since 5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */
  label: _propTypes["default"].string,

  /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Static text to show in an end-cap prepended to the select.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass the query obtained via the `onSearch` handler back to this prop to
   * update the query rendered by the Select.
   */
  searchQuery: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Static text to show in an end-cap appended to the input.
   */
  suffix: _propTypes["default"].string,

  /**
   * This is the value of the currently selected option. Provide a number or
   * string value for a single-selectable Select, __or an array__ of numbers or
   * strings __for a multi-selectable Select__. The matching option will
   * automatically be highlighted in the select.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This function generates the label that is shown in the Select's form
   * field to summarize the current value of the Select. This function
   * receives an array containing all of the selected options that are
   * provided as children to the Select component.
   *
   * The default function will return the selected option's label
   * if one selected option is found. If more than one selected option is
   * found it will return "X selected".
   *
   * If you are filtering the options in the Select (e.g. for a searchable
   * Select), you will have to provide your own function here that does not
   * rely on the array of options passed to this function. As stated above
   * that array will only include selected options *that are currently
   * rendered as children*, so it won't include any selected options that have
   * been filtered out of the current view.
   */
  valueLabel: _propTypes["default"].func,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This function makes the select "searchable". A searchable select allows
   * the user to type a query into a text input to search through options.
   *
   * This function will be called with the user's latest query, which should
   * be passed back to the `searchQuery` prop. Note that this will not
   * automatically filter the options in the select. That responsibility is
   * still up to the developer.
   */
  onSearch: _propTypes["default"].func
} : {};
Select.defaultProps = {
  closeLabel: "Close",
  onChange: _noop["default"],
  size: "medium",
  valueLabel: function valueLabel(options) {
    return options.length === 1 ? options[0].label : options.length > 0 ? "".concat(options.length, " selected") : "";
  }
};
var _default = Select;
exports["default"] = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronSelectData: "data:image/svg+xml,%3csvg width='10' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill-rule='nonzero' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 13l4 4 4-4M9 5L5 1 1 5'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronSelectWidth: 10,
  iconChevronSelectHeight: 18
};

/***/ }),
/* 639 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    selectIosToolbarHeight: 44,
    selectIosToolbarBackgroundColor: tokens.themeBackgroundAlternateTertiaryFocus,
    selectIosToolbarForegroundColor: tokens.themeForegroundAccentDefault,
    selectIosToolbarBorderWidth: 1,
    selectIosToolbarBorderRadius: 0,
    selectIosToolbarBorderColor: tokens.themeBorderSecondaryDefault,
    selectIosToolbarSpacingHorizontal: 16,
    selectIosPickerMotionDuration: "200ms",
    selectIosPickerMotionFunction: "ease",
    selectOptionListElevation: 70,
    selectOptionListBorderWidth: 1,
    selectOptionListBorderRadius: 4,
    selectOptionListBorderColor: tokens.themeBorderPrimaryDefault,
    selectOptionListShadowOffsetX: 0,
    selectOptionListShadowOffsetY: 2,
    selectOptionListShadowBlur: 4,
    selectOptionListShadowSpread: 0,
    selectOptionListShadowColor: "rgba(11, 12, 12, 0.16)",
    selectOptionListPopoverOffsetVertical: 4,
    selectOptionListPopoverBreakpoint: 721,
    selectOptionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    selectOptionListForegroundColor: tokens.themeForegroundPrimaryDefault,
    selectSearchInputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    selectSearchInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    selectSearchInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
  }
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(261);

var _optionList = _interopRequireDefault(__webpack_require__(149));

var _highlightSubstring = _interopRequireDefault(__webpack_require__(264));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectOptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionList, _React$Component);

  var _super = _createSuper(SelectOptionList);

  function SelectOptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function (event) {
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCustomSearchHighlightSubstring", function (option) {
      return function () {
        return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
          match: _this.props.searchQuery
        }, option.label);
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionList, [{
    key: "shouldComponentUpdate",
    value:
    /**
     * Only update if the option list will continue to be open. This prevents the
     * list contents from changing while the Select is in the process of closing,
     * which can be jarring to the user.
     */
    function shouldComponentUpdate(nextProps) {
      return nextProps.open;
    }
    /**
     * Disable mouse interaction with any non-option children becase a) it would
     * blur the select and cause it to close and b) we really don't want anyone
     * including interactive elements here because they'll be innaccessible to
     * keyboard users.
     *
     * NOTE: a `pointerEvents: none` style on the non-option children container is
     * not enough to prevent a blur event on the option list, we have to actually
     * prevent the event's default behavior.
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var optionsAndGroups = (0, _utils.createOptionItemsAndGroups)(props);
      var nonOptionChildren = optionsAndGroups.length > 0 ? [] : (0, _utils.getNonOptionsFromChildren)(props.children);
      return optionsAndGroups.length ? /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
        autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        defaultPreselectedIndex: props.defaultPreselectedIndex,
        onChangePreselectedIndex: props.onChangePreselectedIndex,
        multiSelectable: Array.isArray(props.value),
        recalculateFocusOnUpdate: props.recalculateFocusOnUpdate,
        id: props.id,
        ref: props.forwardedRef
      }, optionsAndGroups) : nonOptionChildren.length ? /*#__PURE__*/_react["default"].createElement("div", {
        onMouseDown: this.onMouseDownNonOptionChildren
      }, nonOptionChildren) : null;
    }
  }]);
  return SelectOptionList;
}(_react["default"].Component);

SelectOptionList.propTypes =  false ? {
  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  defaultPreselectedIndex: _propTypes["default"].number,
  forwardedRef: _propTypes["default"].func,
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,
  open: _propTypes["default"].bool,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  searchQuery: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,
  onChangePreselectedIndex: _propTypes["default"].func,
  onClickOption: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};

function forwardRef(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(SelectOptionList, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = "SelectOptionList";

var _default = /*#__PURE__*/_react["default"].forwardRef(forwardRef);

exports["default"] = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(260));

var _emotion = __webpack_require__(4);

var _typography = __webpack_require__(642);

var maxMatchLength = 100;
var defaultMatchedStyles = (0, _emotion.css)({
  fontWeight: _typography.typographyFontWeightH300
});

var makeSubstringWithMatch = function makeSubstringWithMatch(text, match) {
  return {
    text: text,
    match: match
  };
};
/**
 * Parses string into an ordered array of objects with substrings
 * and if was a match or not.
 * getSubstringWithMatchBool(/abc/g, "abc def abc")
 * [ {text: "abc", match: true},
 *   {text: "def", match: false},
 *   {text: "abc", match: true} ]
 */


var getSubstringsWithMatchBool = function getSubstringsWithMatchBool(regexp, stringInput) {
  var substringsWithMatchBool = [];
  var startBeforeIndex = 0;
  var match;
  var string = typeof stringInput !== "string" ? stringInput.toString() : stringInput;

  do {
    match = regexp.exec(string);

    if (match) {
      var length = match[0].length;
      var matchText = string.substr(match.index, length);
      var beforeText = string.substr(startBeforeIndex, match.index - startBeforeIndex);

      if (beforeText) {
        substringsWithMatchBool.push(makeSubstringWithMatch(beforeText, false));
      }

      substringsWithMatchBool.push(makeSubstringWithMatch(matchText, true));
      startBeforeIndex = match.index + length;
    } // Keep looking for matches if we previously found a match
    // and our regular expression is global (i.e. get all matches)

  } while (match && regexp.global); // If there's still some text leftover at the end, gobble it up


  if (startBeforeIndex < string.length) {
    var restText = string.substr(startBeforeIndex);
    substringsWithMatchBool.push(makeSubstringWithMatch(restText, false));
  }

  return substringsWithMatchBool;
};

var HighlightSubstring = function HighlightSubstring(_ref) {
  var children = _ref.children,
      match = _ref.match,
      className = _ref.className;
  var string = Array.isArray(children) ? children.join("") : children;
  var regexp = match instanceof RegExp ? match : new RegExp((0, _escapeRegExp["default"])(match.substr(0, maxMatchLength)), "i");
  var substrings = getSubstringsWithMatchBool(regexp, string);
  return /*#__PURE__*/_react["default"].createElement("span", null, substrings.map(function (_ref2, index) {
    var text = _ref2.text,
        match = _ref2.match;
    return !match ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, text) : /*#__PURE__*/_react["default"].createElement("span", {
      key: index,
      className: className
    }, text);
  }));
};

HighlightSubstring.propTypes =  false ? {
  /**
   * The string(s) to highlight.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,

  /**
   * A string or regular expression used to identify which substring(s) should
   * be highlighted.
   *
   * If a string is provided, the first substring that matches the string
   * exactly will be highlighted.
   *
   * If a regular expression is provided, any substring matching the regular
   * expression will be highlighted (use a greedy regular expression to
   * highlight all matches).
   */
  match: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]).isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string
} : {};
HighlightSubstring.defaultProps = {
  className: defaultMatchedStyles
};
var _default = HighlightSubstring;
exports["default"] = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  typographyFontSizeD300: 76,
  typographyFontSizeD200: 54,
  typographyFontSizeD100: 48,
  typographyFontSizeD50: 36,
  typographyFontSizeH600: 36,
  typographyFontSizeH500: 28,
  typographyFontSizeH400: 24,
  typographyFontSizeH300: 20,
  typographyFontSizeH200: 18,
  typographyFontSizeH100: 16,
  typographyFontSizeB500: 20,
  typographyFontSizeB400: 18,
  typographyFontSizeB300: 16,
  typographyFontSizeB200: 14,
  typographyFontSizeB100: 12,
  typographyFontWeightD300: 200,
  typographyFontWeightD200: 200,
  typographyFontWeightD100: 200,
  typographyFontWeightD50: 200,
  typographyFontWeightH600: 600,
  typographyFontWeightH500: 600,
  typographyFontWeightH400: 600,
  typographyFontWeightH300: 600,
  typographyFontWeightH200: 600,
  typographyFontWeightH100: 600,
  typographyFontWeightB500: 400,
  typographyFontWeightB400: 400,
  typographyFontWeightB300: 400,
  typographyFontWeightB200: 400,
  typographyFontWeightB100: 400,
  typographyLineHeightD300: "96px",
  typographyLineHeightD200: "64px",
  typographyLineHeightD100: "60px",
  typographyLineHeightD50: "48px",
  typographyLineHeightH600: "48px",
  typographyLineHeightH500: "36px",
  typographyLineHeightH400: "32px",
  typographyLineHeightH300: "24px",
  typographyLineHeightH200: "24px",
  typographyLineHeightH100: "20px",
  typographyLineHeightB500: "28px",
  typographyLineHeightB400: "28px",
  typographyLineHeightB300: "24px",
  typographyLineHeightB200: "20px",
  typographyLineHeightB100: "16px"
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _scrim = _interopRequireDefault(__webpack_require__(151));

var _closeMedium = _interopRequireDefault(__webpack_require__(644));

var _popoverController = _interopRequireDefault(__webpack_require__(145));

var _token = __webpack_require__(8);

var _text = _interopRequireDefault(__webpack_require__(22));

var _sheet = _interopRequireDefault(__webpack_require__(645));

var _button = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _context = _interopRequireDefault(__webpack_require__(266));

var _theme = __webpack_require__(7);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SheetContextProvider = _context["default"].Provider;
var popoverStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var anchorWidth = _ref.anchorWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    boxSizing: "border-box",
    minWidth: anchorWidth,
    overflowY: "auto",
    outline: "none",
    backgroundColor: t("optionListBackgroundColor"),
    borderRadius: t("optionListBorderRadius"),
    border: t.borderCss("optionListBorder"),
    boxShadow: t.boxShadowCss("optionListShadow"),
    zIndex: t("optionListElevation")
  });
}, ["anchorWidth"]); // NOTE: We reverse the column of the select options and the close icon Button
// for the mobile sheet. This allows the list options to be read before
// the close button is read, while keeping the position of the close icon Button
// top aligned with using an explicit position.

var sheetStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "column-reverse",
  // Close icon button styles
  "& > *:nth-child(2)": {
    display: "flex",
    justifyContent: "end"
  }
});

var SelectOptionListContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionListContainer, _React$Component);

  var _super = _createSuper(SelectOptionListContainer);

  function SelectOptionListContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionListContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function () {
      return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
        open: _this.props.open,
        anchorNode: _this.props.popoverAnchorNode,
        anchorOrigin: "bottom left",
        popoverOrigin: "top left",
        offsetVertical: _this.props.t("optionListPopoverOffsetVertical"),
        maxHeight: _this.props.popoverMaxHeight,
        shrinkToFit: true,
        onOpen: _this.props.onOpenPopover
      }, function (_ref2) {
        var popoverStyle = _ref2.popoverStyle,
            anchorRect = _ref2.anchorRect;
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _this.props.id,
          className: "\n            ".concat(popoverStyles(_this.props.t, {
            anchorWidth: anchorRect.width
          }), "\n            ").concat(popoverStyle)
        }, _this.props.children);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBottomSheet", function () {
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _scrim["default"],
        map: (0, _token.getTokenHelper)("scrim")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(SheetContextProvider, {
          value: {
            zIndex: t("elevation") + 2,
            // Turn off Sheet's onAfterClose which attempts to refocus to the
            // last active element before it was open which, in some cases, might
            // be other inputs.
            onAfterClose: function onAfterClose() {}
          }
        }, /*#__PURE__*/_react["default"].createElement(_sheet["default"], {
          id: _this.props.id,
          onClose: _this.props.onCloseBottomSheet,
          open: _this.props.open,
          type: "overlay",
          side: "bottom"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: sheetStyles
        }, _this.props.children, _this.props.closeLabel && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          label: _this.props.closeLabel,
          type: "icon",
          onClick: _this.props.onCloseBottomSheet
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _closeMedium["default"]
        }))))));
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionListContainer, [{
    key: "render",
    value: function render() {
      return this.props.type === "popover" ? this.renderPopover() : this.renderBottomSheet();
    }
  }]);
  return SelectOptionListContainer;
}(_react["default"].Component);

SelectOptionListContainer.propTypes =  false ? {
  children: _propTypes["default"].node,
  closeLabel: _propTypes["default"].string,
  id: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  popoverAnchorNode: _propTypes["default"].object,
  popoverMaxHeight: _propTypes["default"].number,
  t: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(["popover", "bottom-sheet"]),

  /**
   * NOTE: This is only available for the bottom sheet because the popover
   * does not trigger any close events on its own.
   */
  onCloseBottomSheet: _propTypes["default"].func,

  /**
   * NOTE: This is only available for the popover because the bottom sheet's
   * onOpen prop is executed before the bottom sheet is actually rendered to
   * the DOM.
   */
  onOpenPopover: _propTypes["default"].func
} : {};
var _default = SelectOptionListContainer;
exports["default"] = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseMediumData: "data:image/svg+xml,%3csvg width='14' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.613.21l.094.083L7 5.585 12.293.293l.094-.083a1 1 0 011.32 1.497L8.415 7l5.292 5.293a1 1 0 01-1.32 1.497l-.094-.083L7 8.415l-5.293 5.292-.094.083a1 1 0 01-1.32-1.497L5.585 7 .293 1.707A1 1 0 011.613.21z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseMediumWidth: 14,
  iconCloseMediumHeight: 14
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sheet = _interopRequireDefault(__webpack_require__(646));

var _default = _sheet["default"];
exports["default"] = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _emotion = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _sheet = _interopRequireDefault(__webpack_require__(647));

var _modal = _interopRequireDefault(__webpack_require__(265));

var _scrim = _interopRequireDefault(__webpack_require__(151));

var _context = _interopRequireDefault(__webpack_require__(266));

var _theme = __webpack_require__(7);

var _expanderController = _interopRequireDefault(__webpack_require__(648));

var _scrim2 = _interopRequireDefault(__webpack_require__(267));

var _portal = _interopRequireDefault(__webpack_require__(146));

var _focusTrap = _interopRequireDefault(__webpack_require__(270));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _focus = __webpack_require__(93);

var _token = __webpack_require__(8);

var _parsers = __webpack_require__(57);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

var _rtl = __webpack_require__(39);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var borderSides = {
  left: "borderRight",
  right: "borderLeft",
  bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var side = _ref.side,
      spacingInset = _ref.spacingInset,
      backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", (0, _defineProperty2["default"])({}, (0, _rtl.getRtl)(borderSides[side]), t.borderCss("border"))), (0, _defineProperty2["default"])(_css, "& > div", {
    backgroundColor: backgroundColor,
    padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
    outline: "none",
    overflowY: "auto",
    boxSizing: "border-box",
    maxHeight: side === "bottom" ? [// Take up 100% of the viewport height minus the minimum page reveal.
    // This has wide browser support but introduces an issue on mobile
    // browsers that can be solved by the following value.
    "calc(100vh - ".concat(t("minimumPageReveal"), "px)"), // If the browser supports it, use dynamic viewport height to
    // take care of that pesky problem where the browser UI changes
    // the perceived height of the webpage.
    //
    // https://www.bram.us/2021/07/08/the-large-small-and-dynamic-viewports/
    "calc(100dvh - ".concat(t("minimumPageReveal"), "px)")] : undefined
  }), _css));
}, ["side", "spacingInset", "backgroundColor"]);

var mediaQuery = function mediaQuery(floatingBreakpoint) {
  return "@media (max-width: ".concat(floatingBreakpoint, "px)");
};

var modalStyles = function modalStyles(tScrim, tModal, t, _ref2) {
  var _css2, _dirRtl2, _ref3;

  var side = _ref2.side,
      zIndex = _ref2.zIndex;
  return (0, _emotion.css)((_css2 = {
    zIndex: zIndex || tScrim("elevation")
  }, (0, _defineProperty2["default"])(_css2, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex || tScrim("elevation") - 1
  }), (0, _defineProperty2["default"])(_css2, "position", "fixed"), (0, _defineProperty2["default"])(_css2, "boxShadow", "".concat(t("shadowOffset", [side, "x"]), "px ").concat(t("shadowOffset", [side, "y"]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")), _css2), side === "bottom" ? {
    bottom: 0,
    left: 0,
    right: 0
  } : (_ref3 = {
    top: 0,
    bottom: 0
  }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", (_dirRtl2 = {}, (0, _defineProperty2["default"])(_dirRtl2, side, "auto"), (0, _defineProperty2["default"])(_dirRtl2, (0, _rtl.getRtl)(side), 0), _dirRtl2)), _ref3));
};

var overlayScrimStyles = function overlayScrimStyles(_ref4) {
  var tScrim = _ref4.tScrim,
      tModal = _ref4.tModal,
      zIndex = _ref4.zIndex;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 1
  }, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 2
  }));
}; // Overlay expanders are put into a portal


var OverlayExpanderController = function OverlayExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */


var Sheet = function Sheet(props) {
  var open = props.open,
      side = props.side,
      onClose = props.onClose,
      spacingInset = props.spacingInset,
      onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
  // we're explicitly told via props

  var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push

  var type = alwaysRenderChildren ? "push" : props.type;
  var t = (0, _theme.useTheme)(_sheet["default"], "sheet"); // HACK: using modal floatingBreakpoint tokens - but we should really add this to the Sheet tokens and update this.

  var tModal = (0, _theme.useTheme)(_modal["default"], "modal");
  var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
  var hasMounted = (0, _react.useRef)(false);
  var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content

  var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet

  var _useContext = (0, _react.useContext)(_context["default"]),
      zIndex = _useContext.zIndex,
      contextOnAfterClose = _useContext.onAfterClose; // An override z-index and custom onAfterClose method


  var initializeContentRef = (0, _react.useCallback)(function (contentProps) {
    return function (element) {
      contentRef.current = element;
      contentProps.ref(element);
    };
  }, []);
  var backgroundColor = (0, _react.useMemo)(function () {
    return (0, _token.getToken)(t.tokens, "themeBackground", [props.backgroundColor, "default"]) || props.backgroundColor;
  }, [t, props.backgroundColor]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
  // in portal and focus trap.

  var Expander = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
  }, [type]); // Put "overlay" sheets, which are essentially modals, in a focus trap

  var SheetWrapper = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
  }, [type]); // Overlay sheets are essentially modals. Here we add an keyboard listener
  // that closes the sheet when the user presses the "esc" key.
  // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal

  (0, _react.useEffect)(function () {
    if (type === "overlay" && onClose) {
      var onKeyDown = function onKeyDown(e) {
        if ((0, _keycode["default"])(e) === "esc") onClose();
      };

      window.addEventListener("keydown", onKeyDown);
      return function () {
        return window.removeEventListener("keydown", onKeyDown);
      };
    }
  }, [type, onClose]); // On open, move focus to the first focusable element. On close, move focus
  // back to the original element that opened the sheet.

  var onAfterOpen = (0, _react.useCallback)(function () {
    // Run this effect only after the component has mounted. Else, sheet
    // that load as `open` will immediately take over the active element.
    if (hasMounted.current && contentRef.current) {
      var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
      if (firstFocusableNode) firstFocusableNode.focus();else contentRef.current.focus();
    }
  }, []); // On close, return focus to where it was before the bottom sheet was opened.

  var onAfterClose = function onAfterClose() {
    if (contextOnAfterClose) contextOnAfterClose();else if (anchorRef.current) anchorRef.current.focus();
  }; // When opening, record which element opened the sheet


  (0, _react.useEffect)(function () {
    if (open) anchorRef.current = document.activeElement;
    hasMounted.current = true;
  }, [open]);
  (0, _react.useEffect)(function () {
    if (open && onOpen) onOpen();
  }, [open, onOpen]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }),
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(Expander, {
    open: open,
    direction: side === "bottom" ? "down" : side,
    motionDuration: props.motionDuration || parseInt(t("motionTiming")),
    motionFunction: props.motionFunction || t("motionFunction"),
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    alwaysRenderChildren: alwaysRenderChildren,
    closedSize: props.closedSize
  }, function (_ref5) {
    var state = _ref5.state,
        containerProps = _ref5.containerProps,
        contentProps = _ref5.contentProps;
    // The children of a sheet might be interested in the state of the expander
    // to dynamically hide/show components for various stages. For example, skinny
    // SideMenu shows different links based on the expander state.
    var children = typeof props.children === "function" ? props.children({
      expanderState: state
    }) : props.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SheetWrapper, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
      className: (0, _emotion.cx)(props.className, containerStyles(t, {
        side: side,
        spacingInset: spacingInset,
        backgroundColor: backgroundColor
      }), type === "overlay" ? modalStyles(tScrim, tModal, t, {
        side: side,
        zIndex: zIndex
      }) : undefined, containerProps.className)
    }), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      // TODO: Remove these props in 6.x
      "aria-labelledby": props.labelledById,
      "aria-describedby": props.describedById
    }, passThroughProps, focusProps, {
      className: contentProps.className,
      id: props.id,
      ref: initializeContentRef(contentProps),
      role: type === "overlay" ? "dialog" : undefined,
      "aria-modal": type === "overlay" ? true : undefined,
      tabIndex: "-1",
      onKeyDown: props.onKeyDown
    }), children))), type === "overlay" ? /*#__PURE__*/_react["default"].createElement(_scrim2["default"], {
      className: overlayScrimStyles({
        tScrim: tScrim,
        tModal: tModal,
        zIndex: zIndex
      }),
      onClick: props.onClose,
      open: state === "entering" || state === "entered",
      duration: t("motionTiming")
    }) : null);
  });
};

Sheet.displayName = "Sheet";
Sheet.propTypes =  false ? {
  /**
   * Set this to true if children should be rendered even when the sheet
   * is closed. This can be helpful when, for example, you want the sheet
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical sheet, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The sheet's background color. Any CSS color value is acceptable.
   *
   * Note that accessibility should be carefully considered when selecting a
   * background color. A [minimum contrast ratio of 4.5:1](https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html) between text and
   * background must be maintained. For large text a contrast ratio of 3:1 is acceptable.
   * You can use [a contrast checker](https://webaim.org/resources/contrastchecker/) to verify that your chosen background color
   * maintains an appropriate level of contrast. You can [read more here](https://meridian.a2z.com/guides/accessibility/?platform=react-web) about accessibility in Meridian.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The contents of the sheet. When a sheet is opened (and alwaysRenderChildren and closedSize
   * are _not_ set), the first focusable element will gain focus. Ideally this element should be
   * a close button so users can quickly toggle the sheet off.
   *
   * Children can also be a function that receives as its only argument an object with a key
   * `expanderState`. Expander state describes the phase of sheet's animation: "entering"/"entered"
   * when `open` is set to `true`, and "exiting"/"exited" when `open` is set to `false`. This
   * can be useful to conditionally show different components in the sheet based on the sheet's
   * animation phase.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Causes the sheet to close to a fixed pixel height/width value.
   *
   * Forces `alwaysRenderChildren` to be `true` and type to be `push`.
   */
  closedSize: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `aria-describedby` instead.
   *
   * @deprecated 5.30.0
   */
  describedById: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `aria-labelledby` instead.
   *
   * @deprecated 5.30.0
   */
  labelledById: _propTypes["default"].string,

  /**
   * The duration it should take to animate in milliseconds.
   */
  motionDuration: _propTypes["default"].number,

  /**
   * The animation function to use when animating. Learn more about [animation functions](https://developer.mozilla.org/en-US/docs/Web/CSS/animation-timing-function).
   */
  motionFunction: _propTypes["default"].string,

  /**
   * The state of the sheet. If true the sheet will be open, otherwise it will be closed.
   */
  open: _propTypes["default"].bool,

  /**
   * The side of the screen the sheet will appear. For type `overlay`, the sheet
   * is automatically fixed to the chosen side. For type `push`, however, setting
   * side _only_ affects how the sheet animates. Composing a `push` Sheet inside
   * the app's layout is the responsibility of the developer.
   */
  side: _propTypes["default"].oneOf(["left", "right", "bottom"]),

  /**
   * Apply padding around the contents of the sheet using a preset.
   */
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium", "300", "400"]),

  /**
   * sheets come in two flavors, push and overlay. Push displaces other elements on the
   * screen when it enters/exits. Overlay, on the other hand, enters/exits on top of the
   * application accompanied by a scrim (semi-transparent  overlay that covers the application
   * behind the sheet)
   */
  type: _propTypes["default"].oneOf(["push", "overlay"]),

  /**
   * This is called when the sheet loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * Required for type overlay. Called when a user presses the scrim (semi-transparent
   * overlay that covers the application behind the sheet) or hits the "escape" key.
   */
  onClose: _propTypes["default"].func,

  /**
   * This is called when the sheet gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * Called when the sheet is opened or when it is mounted open.
   */
  onOpen: _propTypes["default"].func
} : {};
Sheet.defaultProps = {
  type: "push",
  open: false,
  side: "right",
  spacingInset: "medium",
  backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    sheetMinimumPageReveal: 40,
    sheetMotionTiming: "200ms",
    sheetMotionFunction: "ease",
    sheetBorderWidth: 1,
    sheetBorderRadius: 0,
    sheetBorderColor: tokens.themeBorderSecondaryDefault,
    sheetShadowColor: "rgba(11, 12, 12, 0.1)",
    sheetShadowBlur: 16,
    sheetShadowSpread: 0,
    sheetShadowOffsetBottomX: 0,
    sheetShadowOffsetBottomY: -8,
    sheetShadowOffsetLeftX: 8,
    sheetShadowOffsetLeftY: 0,
    sheetShadowOffsetRightX: -8,
    sheetShadowOffsetRightY: 0
  }
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _expanderController = _interopRequireDefault(__webpack_require__(649));

var _default = _expanderController["default"];
exports["default"] = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(142));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _transitionController = _interopRequireDefault(__webpack_require__(248));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(104));

var _functional = __webpack_require__(19);

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getSizeProperty = function getSizeProperty(direction) {
  return {
    left: "width",
    right: "width",
    up: "height",
    down: "height"
  }[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.


var containerStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _css;

  var state = _ref.state,
      direction = _ref.direction,
      size = _ref.size,
      motionDuration = _ref.motionDuration,
      motionFunction = _ref.motionFunction,
      closedSize = _ref.closedSize;
  return (0, _emotion.css)({
    left: {
      // Horizontal expanders are inline-flex to ensure they shrink to fit
      // their children's width (vertical expanders shrink to fit by default
      // 'cause that's how CSS layout works).
      display: "inline-flex",
      // The up/left expanders use row/column-reverse so that content is fixed
      // to the bottom/right edges instead of top/left (the default).
      // NOTE: justifyContent: "flex-end" would work here instead *except* for
      // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
      flexDirection: "row-reverse"
    },
    right: {
      display: "inline-flex",
      flexDirection: "row"
    },
    up: {
      display: "flex",
      flexDirection: "column-reverse"
    },
    down: {
      display: "flex",
      flexDirection: "column"
    }
  }[direction], (_css = {
    // Don't let a flex parent squish the expander
    flexShrink: 0
  }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, ["state", "direction", "size", "motionDuration", "motionFunction", "closedSize"]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.

var contentStyles = (0, _functional.memoize)(function (direction) {
  var _css2;

  return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */

/**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */

var ExpanderControllerClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);

  var _super = _createSuper(ExpanderControllerClass);

  function ExpanderControllerClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, ExpanderControllerClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      size: undefined,
      render: _this.props.open || _this.props.alwaysRenderChildren
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function (node) {
      return _this.contentRef = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function () {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function (done) {
      return _this.setState({
        size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
      }, done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      if (!_this.state.render) {
        // If the children aren't rendered yet, do so and then give them a chance
        // to settle before poking through the DOM
        _this.setState({
          render: true
        }, function () {
          _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function () {
            return _this.fixSize(done);
          });
        });
      } else {
        _this.fixSize(done);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function () {
      _this.setState({
        size: undefined
      });

      if (_this.props.onAfterOpen) _this.props.onAfterOpen();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function (done) {
      _this.cancelFixSize();

      _this.fixSize(done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      if (!_this.props.alwaysRenderChildren) {
        _this.setState({
          render: false
        });
      }

      if (_this.props.onAfterClose) _this.props.onAfterClose();
    });
    return _this;
  }

  (0, _createClass2["default"])(ExpanderControllerClass, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelFixSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state = this.state,
          size = _this$state.size,
          render = _this$state.render;
      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open,
        duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
        onBeforeEnter: this.onBeforeOpen,
        onAfterEnter: this.onAfterOpen,
        onBeforeExit: this.onBeforeClose,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? children({
          state: state,
          containerProps: {
            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
              state: state,
              size: size
            })),
            "aria-hidden": !props.closedSize && !props.open
          },
          contentProps: {
            className: contentStyles(props.direction),
            ref: _this2.updateContentRef
          }
        }) : null;
      });
    }
  }]);
  return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var ExpanderController = function ExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(ExpanderControllerClass, props);
};

ExpanderController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  direction: _propTypes["default"].oneOf(["up", "down", "left", "right"]).isRequired,
  open: _propTypes["default"].bool.isRequired,

  /**
   * Set this to true if children should be rendered even when the expander
   * is closed. This can be helpful when, for example, you want the expander
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical expander, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * The value the expander should close to. Setting the value to > 0 will
   * keep the expander visible even when closed.
   */
  closedSize: _propTypes["default"].number,
  motionDuration: _propTypes["default"].number,
  motionFunction: _propTypes["default"].string,
  onAfterClose: _propTypes["default"].func,
  onAfterOpen: _propTypes["default"].func
} : {};
ExpanderController.defaultProps = {
  closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _scrim = _interopRequireDefault(__webpack_require__(151));

var _theme = __webpack_require__(7);

var _animateMount = _interopRequireWildcard(__webpack_require__(268));

var _onDirectClick = _interopRequireDefault(__webpack_require__(269));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: t("elevation"),
    backgroundColor: t("backgroundColor")
  });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */


var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};

var Scrim = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeWithMount, {
    open: props.open,
    onOpen: props.onOpen,
    duration: props.duration || t("motionTiming"),
    easing: props.easing || t("motionFunction"),
    type: "fade"
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd;
    return (
      /*#__PURE__*/
      // Regarding role=none, see:
      // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
      _react["default"].createElement("div", {
        role: "none",
        className: (0, _emotion.cx)(className, styles(t), props.className),
        onTransitionEnd: onTransitionEnd,
        onMouseDown: (0, _onDirectClick["default"])(props.onClick),
        ref: ref
      }, props.children)
    );
  });
}), shouldNotUpdate);

Scrim.displayName = "Scrim";
Scrim.propTypes =  false ? {
  open: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  duration: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  easing: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
Scrim.defaultProps = {
  open: false,
  className: null
};
var _default = Scrim;
exports["default"] = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
  return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};

var withAnimateMount = function withAnimateMount(WrappedComponent) {
  var _class;

  /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */
  return _class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WithAnimateMount, _React$Component);

    var _super = _createSuper(WithAnimateMount);

    function WithAnimateMount() {
      var _this;

      (0, _classCallCheck2["default"])(this, WithAnimateMount);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        show: false
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
        if (typeof _this.props.onOpen !== "undefined" && _this.state.show) {
          _this.props.onOpen();
        } // Remount the node when the open prop is true


        _this.setState({
          show: true
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
        if (!_this.props.open) {
          _this.setState({
            show: false
          });
        }
      });
      return _this;
    }

    (0, _createClass2["default"])(WithAnimateMount, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            duration = _this$props.duration,
            easing = _this$props.easing,
            open = _this$props.open,
            animateToHeight = _this$props.animateToHeight;
        var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
          animateToHeight: animateToHeight
        } : null;
        return this.state.show && /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
          duration: duration,
          easing: easing,
          open: open,
          updateStateOnOpen: this.updateStateOnOpen,
          transitionEnd: this.transitionEnd
        }, animateToHeightProps), children);
      }
    }]);
    return WithAnimateMount;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
    /**
     * A function that returns the elements to animate.
     */
    children: _propTypes["default"].func.isRequired,

    /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */
    open: _propTypes["default"].bool.isRequired,

    /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */
    animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */
    duration: _propTypes["default"].string,

    /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */
    easing: _propTypes["default"].string,

    /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */
    onOpen: _propTypes["default"].func
  }), (0, _defineProperty2["default"])(_class, "defaultProps", {
    duration: "150ms",
    easing: "ease",
    open: false
  }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _class;
};

var _default = withAnimateMount;
exports["default"] = _default;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transition: "opacity ".concat(duration, " ").concat(easing)
  });
};

var AnimateFade = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFade, _React$Component);

  var _super = _createSuper(AnimateFade);

  function AnimateFade() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFade, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        this.updateStateOnMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var opacity = this.state.opacity;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, duration, easing);
      return children({
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFade;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFade.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFade;
exports["default"] = _default;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(104));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(_ref) {
  var open = _ref.open,
      height = _ref.height,
      duration = _ref.duration,
      easing = _ref.easing;
  return (0, _emotion.css)({
    transform: "translateY(".concat(open ? "0" : "100%", ")"),
    height: height,
    overflow: "auto",
    transition: "transform ".concat(duration, " ").concat(easing)
  });
};

var AnimateSlideIn = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateSlideIn, _React$Component);

  var _super = _createSuper(AnimateSlideIn);

  function AnimateSlideIn() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateSlideIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
      // element, then set the state to trigger the mount animation


      (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      return _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      if (_this.isMounted) _this.setState({
        open: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateSlideIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMounted = true;

      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.updateStateOnOpen();
      } else if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state;
      var props = this.props;
      var styles = mountStyled({
        open: state.open,
        duration: props.duration,
        easing: props.easing,
        height: props.animateToHeight
      });
      return props.children({
        open: state.open,
        className: (0, _emotion.cx)(props.className, styles),
        onTransitionEnd: this.props.transitionEnd
      });
    }
  }]);
  return AnimateSlideIn;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateSlideIn.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Allows for cases when the desired effect is animating height to
   * a value that's different than the element's scrollHeight
   */
  animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateSlideIn;
exports["default"] = _default;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, scale, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transform: scale ? "scale(".concat(scale, ")") : undefined,
    transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
  });
};

var AnimateFadeScale = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFadeScale, _React$Component);

  var _super = _createSuper(AnimateFadeScale);

  function AnimateFadeScale() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFadeScale);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0,
      scale: 0.75,
      applyScale: true
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0,
        scale: 0.75,
        applyScale: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1,
        scale: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      } // Clear opening timer if it exists


      clearTimeout(_this.timer); // HACK: turn off `transform: scale(X)` to workaround this Chromium issue https://bugs.chromium.org/p/chromium/issues/detail?id=20574
      // which can cause a `position: fixed` child to render improperly.

      _this.setState({
        applyScale: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFadeScale, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        // Set state to trigger intro animation
        this.timer = setTimeout(this.updateStateOnMount, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          opacity = _this$state.opacity,
          scale = _this$state.scale,
          applyScale = _this$state.applyScale;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, applyScale ? scale : undefined, duration, easing);
      return children({
        open: opacity !== 0,
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFadeScale;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFadeScale.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFadeScale;
exports["default"] = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _includes = _interopRequireDefault(__webpack_require__(271));

var _find = _interopRequireDefault(__webpack_require__(88));

var _findLast = _interopRequireDefault(__webpack_require__(658));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _focus = __webpack_require__(93);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */
var FocusTrap = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap() {
    var _this;

    (0, _classCallCheck2["default"])(this, FocusTrap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      if ((0, _keycode["default"])(event) === "tab") {
        var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode),
            startNodes = _getBoundingFocusNode.startNodes,
            endNodes = _getBoundingFocusNode.endNodes;

        var willBlur = _this.willBlur(event, startNodes, endNodes);

        var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);

        var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
        var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves

        if (willBlur === -1 && allowBlur === undefined && lastFocusNode) {
          lastFocusNode.focus();
        }

        if (willBlur === 1 && allowBlur === undefined && firstFocusNode) {
          firstFocusNode.focus();
        } // If allowBlur was not explicitly set to true then cancel the default event
        // behavior


        if (willBlur && allowBlur !== true) {
          event.preventDefault();
        }
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(FocusTrap, [{
    key: "focus",
    value: function focus() {
      var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];

      if (node) {
        node.focus();
      }
    }
  }, {
    key: "focusEnd",
    value: function focusEnd() {
      var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
      var node = nodes[nodes.length - 1];

      if (node) {
        node.focus();
      }
    }
    /**
     * Takes in a keydown event, returns 0 if focus is not leaving, 1 if it's
     * leaving to the next node in the tab order, and -1 if it's leaving to the
     * previous node in the tab order.
     */

  }, {
    key: "willBlur",
    value: function willBlur(event, startNodes, endNodes) {
      var key = (0, _keycode["default"])(event);
      var target = event.target,
          shiftKey = event.shiftKey;
      return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.rootNode = _reactDom["default"].findDOMNode(this);
      this.rootNode.addEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.rootNode.removeEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return FocusTrap;
}(_react["default"].Component);

(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
  onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes =  false ? {
  children: _propTypes["default"].element.isRequired,

  /**
   * This is called when the focus trap is about to lose focus because of
   * keyboard input.
   *
   * If the function is not provided or does not return a value then the blur
   * will be blocked and focus will be looped within the trap. If the function
   * is provided and returns false then the blur will be blocked but the focus
   * will not automatically be looped. If the function is provided and returns
   * true then focus will be allowed to leave the trap.
   *
   * The function is called with a single argument that indicates the
   * direction of the tab change: -1 if the user is moving backwards in the
   * tab order, or 1 if the user is moving fowards in the tab order.
   *
   * IMPORTANT: As mentioned above, this will only be called when the trap is
   * about to lose focus due to keyboard input. This will not be called if
   * focus is moved outside the trap via mouse input.
   */
  onBeforeBlur: _propTypes["default"].func
} : {};
var _default = FocusTrap;
exports["default"] = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(657),
    keys = __webpack_require__(85);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(120);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(235),
    findLastIndex = __webpack_require__(226);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(661);


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSVLink = exports.CSVDownload = undefined;

var _Download = __webpack_require__(662);

var _Download2 = _interopRequireDefault(_Download);

var _Link = __webpack_require__(663);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSVDownload = exports.CSVDownload = _Download2.default;
var CSVLink = exports.CSVLink = _Link2.default;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(272);

var _metaProps = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  target: '_blank'
};

var CSVDownload = function (_React$Component) {
  _inherits(CSVDownload, _React$Component);

  function CSVDownload(props) {
    _classCallCheck(this, CSVDownload);

    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CSVDownload, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          enclosingCharacter = _props.enclosingCharacter,
          uFEFF = _props.uFEFF,
          target = _props.target,
          specs = _props.specs,
          replace = _props.replace;

      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
    }
  }, {
    key: 'getWindow',
    value: function getWindow() {
      return this.state.page;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return CSVDownload;
}(_react2.default.Component);

CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
CSVDownload.propTypes = _metaProps.propTypes;
exports.default = CSVDownload;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(272);

var _metaProps = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSVLink = function (_React$Component) {
  _inherits(CSVLink, _React$Component);

  function CSVLink(props) {
    _classCallCheck(this, CSVLink);

    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));

    _this.buildURI = _this.buildURI.bind(_this);
    _this.state = { href: '' };
    return _this;
  }

  _createClass(CSVLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          uFEFF = _props.uFEFF,
          enclosingCharacter = _props.enclosingCharacter;

      this.setState({ href: this.buildURI(data, uFEFF, headers, separator, enclosingCharacter) });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data,
          headers = nextProps.headers,
          separator = nextProps.separator,
          uFEFF = nextProps.uFEFF;

      this.setState({ href: this.buildURI(data, uFEFF, headers, separator) });
    }
  }, {
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'handleLegacy',
    value: function handleLegacy(event) {
      if (window.navigator.msSaveOrOpenBlob) {
        event.preventDefault();

        var _props2 = this.props,
            data = _props2.data,
            headers = _props2.headers,
            separator = _props2.separator,
            filename = _props2.filename,
            enclosingCharacter = _props2.enclosingCharacter,
            uFEFF = _props2.uFEFF;


        var blob = new Blob([uFEFF ? '\uFEFF' : '', (0, _core.toCSV)(data, headers, separator, enclosingCharacter)]);
        window.navigator.msSaveBlob(blob, filename);

        return false;
      }
    }
  }, {
    key: 'handleAsyncClick',
    value: function handleAsyncClick(event) {
      var _this2 = this;

      var done = function done(proceed) {
        if (proceed === false) {
          event.preventDefault();
          return;
        }
        _this2.handleLegacy(event);
      };

      this.props.onClick(event, done);
    }
  }, {
    key: 'handleSyncClick',
    value: function handleSyncClick(event) {
      var stopEvent = this.props.onClick(event) === false;
      if (stopEvent) {
        event.preventDefault();
        return;
      }
      this.handleLegacy(event);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this3 = this;

      return function (event) {
        if (typeof _this3.props.onClick === 'function') {
          return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
        }
        _this3.handleLegacy(event);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props3 = this.props,
          data = _props3.data,
          headers = _props3.headers,
          separator = _props3.separator,
          filename = _props3.filename,
          uFEFF = _props3.uFEFF,
          children = _props3.children,
          onClick = _props3.onClick,
          asyncOnClick = _props3.asyncOnClick,
          enclosingCharacter = _props3.enclosingCharacter,
          rest = _objectWithoutProperties(_props3, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);

      return _react2.default.createElement(
        'a',
        _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          target: '_self',
          href: this.state.href,
          onClick: this.handleClick()
        }),
        children
      );
    }
  }]);

  return CSVLink;
}(_react2.default.Component);

CSVLink.defaultProps = _metaProps.defaultProps;
CSVLink.propTypes = _metaProps.propTypes;
exports.default = CSVLink;

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPATCH_TIME */
/* unused harmony export CART_ID */
/* unused harmony export ROUTE_ID */
/* unused harmony export STAGE_BY_TIME */
/* unused harmony export LOCATION_CART_VIEW */
/* unused harmony export LOCATION */
/* unused harmony export STATUS */
/* unused harmony export DWELL_DURATION */
/* unused harmony export STAGE_TIME */
/* unused harmony export ASSOCIATE */
/* unused harmony export STATION_PAIRS */
/* unused harmony export ROUTE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CART_VIEW_TABLE_COLUMNS_AR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CART_VIEW_TABLE_COLUMNS_AMZL; });
var DISPATCH_TIME="Dispatch Time";var CART_ID="Cart ID";var ROUTE_ID="Route ID";var STAGE_BY_TIME="Stage By Time";var LOCATION_CART_VIEW="Staging Location";var LOCATION="Location";var STATUS="Status";var DWELL_DURATION="Dwell Duration";var STAGE_TIME="Stage Time";var ASSOCIATE="Associate";var STATION_PAIRS="Pick Station";var ROUTE_TYPE="Type";var CART_VIEW_TABLE_COLUMNS_AR=[CART_ID,ROUTE_ID,STAGE_BY_TIME,LOCATION_CART_VIEW,STATUS,DWELL_DURATION,ASSOCIATE,STATION_PAIRS,ROUTE_TYPE];var CART_VIEW_TABLE_COLUMNS_AMZL=[DISPATCH_TIME,CART_ID,ROUTE_ID,LOCATION,STATUS,DWELL_DURATION,STAGE_TIME,ASSOCIATE,ROUTE_TYPE];

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPATCH_TIME */
/* unused harmony export ROUTE_ID */
/* unused harmony export LOCATION */
/* unused harmony export STATUS */
/* unused harmony export STAGE_TIME */
/* unused harmony export CARTS */
/* unused harmony export DRIVER */
/* unused harmony export ROUTE_TYPE */
/* unused harmony export PROGRESS */
/* unused harmony export ASSOCIATE */
/* unused harmony export DURATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTE_VIEW_TABLE_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AR_SSD_ROUTE_VIEW_TABLE_COLUMNS; });
var DISPATCH_TIME="Dispatch Time";var ROUTE_ID="Route ID";var LOCATION="Location";var STATUS="Status";var STAGE_TIME="Stage Time";var CARTS="Carts";var DRIVER="Driver";var ROUTE_TYPE="Type";var PROGRESS="Progress";var ASSOCIATE="Associate";var DURATION="Duration";var ROUTE_VIEW_TABLE_COLUMNS=[DISPATCH_TIME,ROUTE_ID,LOCATION,STATUS,STAGE_TIME,CARTS,DRIVER,ROUTE_TYPE];var AR_SSD_ROUTE_VIEW_TABLE_COLUMNS=[DISPATCH_TIME,ROUTE_ID,LOCATION,STATUS,PROGRESS,ASSOCIATE,STAGE_TIME,DURATION,ROUTE_TYPE];

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPATCH_TIME */
/* unused harmony export ROUTE_ID */
/* unused harmony export LOCATION */
/* unused harmony export STATUS */
/* unused harmony export PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DRIVER; });
/* unused harmony export ROUTE_TYPE */
/* unused harmony export DEPART_TIME */
/* unused harmony export SECTORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEPART_TABLE_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEPART_TABLE_COLUMNS_IN; });
var DISPATCH_TIME="Dispatch Time";var ROUTE_ID="Route ID";var LOCATION="Location";var STATUS="Status";var PROGRESS="Progress";var DRIVER="Driver";var ROUTE_TYPE="Type";var DEPART_TIME="Depart Time";var SECTORS="Sectors";var DEPART_TABLE_COLUMNS=[DISPATCH_TIME,ROUTE_ID,LOCATION,STATUS,PROGRESS,ROUTE_TYPE,DRIVER,DEPART_TIME];var DEPART_TABLE_COLUMNS_IN=[DISPATCH_TIME,ROUTE_ID,SECTORS,STATUS,PROGRESS,ROUTE_TYPE,DRIVER,DEPART_TIME];

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var StageViewSelector=function StageViewSelector(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["d" /* CART_VIEW */]),_useState2=_slicedToArray(_useState,2),cartView=_useState2[0],setCartView=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_StageFilterContext__["a" /* StageFilterContext */]),dispatchF=_useContext.dispatchF;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;var toggleView=function toggleView(newValue){setCartView(newValue);dispatchF({type:'SELECT_VIEW_TYPE',viewType:newValue});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,!__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)||configViewModel.stationConfig.pickStageDecoupleEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacingInset:spacingInset_shorthand4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group___default.a,{value:cartView,onChange:toggleView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__["ButtonOption"],{value:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["d" /* CART_VIEW */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"stageOverall.cartView",defaultMessage:"Cart View"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__["ButtonOption"],{value:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["w" /* ROUTE_VIEW */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"stageOverall.routeView",defaultMessage:"Route View"})))):null);};/* harmony default export */ __webpack_exports__["a"] = (StageViewSelector);

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _noop = _interopRequireDefault(__webpack_require__(27));

var _button2 = _interopRequireDefault(__webpack_require__(121));

var _elevation = __webpack_require__(54);

var _buttonGroupContext = _interopRequireDefault(__webpack_require__(275));

var _theme = _interopRequireWildcard(__webpack_require__(7));

var _parsers = __webpack_require__(57);

var _fieldsetReset = _interopRequireDefault(__webpack_require__(276));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _functional = __webpack_require__(19);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var legendStyles = (0, _emotion.css)(_visuallyHidden["default"]);
var rowStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _button;

  var horizontalSpacing = _ref.horizontalSpacing,
      minWidth = _ref.minWidth,
      buttonBorderRadius = _ref.buttonBorderRadius,
      singleButton = _ref.singleButton;
  var buttonBorderRadiusLeftSide = "".concat(buttonBorderRadius, "px 0 0 ").concat(buttonBorderRadius, "px");
  var buttonBorderRadiusRightSide = "0 ".concat(buttonBorderRadius, "px ").concat(buttonBorderRadius, "px 0");
  return (0, _emotion.css)(_fieldsetReset["default"], {
    display: "flex",
    zIndex: _elevation.elevationBackground,
    position: "relative",
    label: _visuallyHidden["default"],
    "& > *:not([mdn-button-group-label])": {
      display: "inline-block"
    },
    "& button": (_button = {
      zIndex: _elevation.elevationMidground,
      boxSizing: "border-box",
      margin: "0 ".concat(horizontalSpacing, "px 0 0")
    }, (0, _defineProperty2["default"])(_button, "[dir=\"rtl\"] &", {
      margin: "0 0 0 ".concat(horizontalSpacing, "px")
    }), (0, _defineProperty2["default"])(_button, "borderRadius", singleButton ? buttonBorderRadius : "0"), _button),
    "& div:first-of-type > button": (0, _defineProperty2["default"])({
      borderRadius: singleButton ? undefined : buttonBorderRadiusLeftSide
    }, "[dir=\"rtl\"] &", {
      borderRadius: singleButton ? undefined : buttonBorderRadiusRightSide
    }),
    "& div:last-of-type > button": (0, _defineProperty2["default"])({
      borderRadius: singleButton ? undefined : buttonBorderRadiusRightSide,
      marginRight: 0
    }, "[dir=\"rtl\"] &", {
      borderRadius: singleButton ? undefined : buttonBorderRadiusLeftSide,
      marginLeft: 0
    }),
    "& button:focus, & button:hover, & input:focus + button": {
      // HACK: When we hover or focus on a button, bring it to the front z-index wise
      // so that the focus ring / fill doesn't get clipped by neighboring buttons
      zIndex: _elevation.elevationForeground
    },
    "& button:disabled": {
      // HACK: When the button is disabled, drop its z-index to 0 so the other
      // buttons can appear in front
      zIndex: "".concat(_elevation.elevationBackground, " !important")
    }
  }, minWidth ? {
    display: "flex",
    minWidth: minWidth,
    flexDirection: "row",
    "& > *:not([mdn-button-group-label])": {
      flex: "auto",
      display: "flex",
      "& > button": {
        flex: 1
      }
    }
  } : undefined);
}, ["horizontalSpacing", "minWidth", "buttonBorderRadius", "singleButton"]);

var getButtonTokens = function getButtonTokens(_ref2) {
  var type = _ref2.type;
  return {
    // Apply a transparent border to primary and secondary buttons so that they
    // size exactly the same as tertiary buttons (which have a border). This
    // allows us to mix and match tertiary and non-tertiary buttons without any
    // change in the way the buttons size.
    buttonBorderColorPrimaryDefault: type === "outline" ? "transparent" : null,
    buttonBorderColorSecondaryDefault: type === "outline" ? "transparent" : null
  };
};
/**
 * Render two or more buttons joined together into a unified form element that
 * can allow the selection of one or more options.
 */


var ButtonGroup = function ButtonGroup(props) {
  var value = props.value,
      onChange = props.onChange,
      size = props.size,
      name = props.name,
      type = props.type,
      children = props.children,
      minWidth = props.minWidth,
      label = props.label;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var t = (0, _theme.useTheme)(_button2["default"], "button");
  var buttonBorderRadius = t("borderRadius");
  var inputType = (0, _react.useMemo)(function () {
    return Array.isArray(value) ? "checkbox" : "radio";
  }, [value]);
  var handleChange = (0, _react.useCallback)(function (optionValue) {
    var nextValue;

    if (inputType === "checkbox") {
      nextValue = value.indexOf(optionValue) === -1 ? [].concat((0, _toConsumableArray2["default"])(value), [optionValue]) : value.filter(function (v) {
        return v !== optionValue;
      });
    } else {
      nextValue = optionValue;
    }

    onChange(nextValue);
  }, [inputType, value, onChange]);
  var context = (0, _react.useMemo)(function () {
    return {
      onChange: handleChange,
      value: value,
      size: size,
      name: name,
      groupType: type,
      inputType: inputType
    };
  }, [handleChange, inputType, value, name, size, type]);
  var overrideButtonTokens = (0, _react.useMemo)(function () {
    return getButtonTokens({
      type: type
    });
  }, [type]);

  var _useMemo = (0, _react.useMemo)(function () {
    return type === "outline" ? [-2] : (0, _parsers.parseSpacing)("xxsmall");
  }, [type]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 1),
      horizontalSpacing = _useMemo2[0];

  return /*#__PURE__*/_react["default"].createElement(_buttonGroupContext["default"].Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideButtonTokens
  }, /*#__PURE__*/_react["default"].createElement("fieldset", (0, _extends2["default"])({}, passThroughProps, {
    className: rowStyles({
      horizontalSpacing: horizontalSpacing,
      minWidth: minWidth,
      buttonBorderRadius: buttonBorderRadius,
      singleButton: children.length === 1
    })
  }), /*#__PURE__*/_react["default"].createElement("legend", {
    className: legendStyles
  }, label), children)));
};

ButtonGroup.propTypes =  false ? {
  /**
   * A list of ButtonOption components.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width of the group. The group may be wider if the button
   * options that it contains have labels that cannot fit within the minimum
   * width.
   */
  minWidth: _propTypes["default"].string,

  /**
   * The name of the form control for each button option contained in the group.
   * If the group is placed in a form, this will be the name associated with
   * the group's controls when the form is submitted.
   *
   * Any names set explicitly on individual components in the group will
   * override this property.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the button options in the group using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Sets the style of the group.
   */
  type: _propTypes["default"].oneOf(["fill", "outline"]),

  /**
   * The current value of the group.
   *
   * Match this with the value(s) of button options within the group to show
   * those options as checked.
   *
   * If this is an array then the group will allow multiple button options to be
   * checked (like a group of checkboxes). If this is a single value then the
   * group will only allow one button option to be checked (like a group of
   * radio buttons).
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by clicking on a button option). The new value will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func
} : {};
ButtonGroup.defaultProps = {
  size: "medium",
  type: "fill",
  onChange: _noop["default"]
};
var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(49));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _button = _interopRequireDefault(__webpack_require__(121));

var _noop = _interopRequireDefault(__webpack_require__(27));

var _buttonGroupContext = _interopRequireDefault(__webpack_require__(275));

var _button2 = _interopRequireDefault(__webpack_require__(28));

var _theme = __webpack_require__(7);

var _buttonStyles = __webpack_require__(208);

var _token = __webpack_require__(8);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      disableHover = _ref.disableHover,
      disabled = _ref.disabled,
      backdropColor = _ref.backdropColor,
      minWidth = _ref.minWidth;
  var state = disabled ? "disabled" : "default";
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    // flex: "none !important" is used to allow for individual Buttons within
    // a ButtonGroupRow to override the minWidth set on the ButtonGroup
    flex: minWidth ? "none !important" : undefined,
    // Hide the input visual, but allow it to be still interacted with via
    // keyboard
    "& > input": _visuallyHidden["default"],
    // Artificially apply active/focused states to the button when the input
    // is active/focused.
    "& > input:active + button": (0, _buttonStyles.activeStyles)(t, {
      type: type
    }),
    "& > input:focus + button": (0, _buttonStyles.focusStyles)(t, {
      focus: true,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      backdropColor: backdropColor || t.tokens.themeBackgroundPrimaryDefault,
      linkOrIcon: type === "icon"
    }),
    // Disable the hover styles on the button (but ensure that we keep the
    // active/pressed styles) if `disableHover` is true (this is used when
    // unchecking a button because the hover styles look very similar to the
    // checked styles).
    "& > button:hover": disableHover ? (0, _buttonStyles.defaultStyles)(t, {
      type: type
    }) : undefined,
    "& > button:hover:active": disableHover ? (0, _buttonStyles.activeStyles)(t, {
      type: type
    }) : undefined
  });
}, ["type", "disableHover", "disabled", "backdropColor", "minWidth"]);
/**
 * Render a single option in a button group. This should only be used as the
 * child of a `ButtonGroup` component.
 */

var ButtonOption = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      disableHover = _useState2[0],
      setDisableHover = _useState2[1];

  var context = (0, _react.useContext)(_buttonGroupContext["default"]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  var onChange = context.onChange,
      inputType = context.inputType;
  var idProp = props.id,
      value = props.value,
      onClick = props.onClick;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("checkable-button-");
  }, [idProp]);
  var checked = props.value !== undefined ? inputType === "checkbox" ? context.value.indexOf(props.value) !== -1 : context.value === props.value : false;
  var type = checked ? "primary" : context.groupType === "fill" ? "secondary" : "tertiary"; // When the input is selected via keyboard, trigger the onChange handler with
  // the input's value and trigger the onClick hander.

  var onChangeInput = (0, _react.useCallback)(function () {
    onChange(value);
    onClick();
  }, [value, onClick, onChange]); // When the button is clicked, disable the hover state if we're dealing with a
  // checkbox input and trigger the input's change handler.

  var onClickButton = (0, _react.useCallback)(function () {
    if (inputType === "checkbox") {
      setDisableHover(true);
    }

    onChangeInput();
  }, [inputType, onChangeInput]); // When the user's mouse enters or leaves a checkbox button, ensure that the
  // hover state is re-enabled

  var onMouseEnterLeaveButton = (0, _react.useCallback)(function () {
    if (inputType === "checkbox" && disableHover) {
      setDisableHover(false);
    }
  }, [inputType, disableHover]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      disableHover: disableHover,
      type: type,
      minWidth: props.minWidth,
      disabled: props.disabled,
      backdropColor: props.backdropColor
    }),
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, props.label || props.children), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, {
    name: props.name || context.name,
    type: inputType,
    checked: checked,
    disabled: props.disabled,
    onChange: onChangeInput,
    id: id,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  })), /*#__PURE__*/_react["default"].createElement(_button2["default"], {
    size: context.size,
    type: type,
    minWidth: props.minWidth,
    disabled: props.disabled,
    onClick: onClickButton,
    onMouseEnter: onMouseEnterLeaveButton,
    onMouseLeave: onMouseEnterLeaveButton,
    tabIndex: "-1",
    "aria-hidden": true
  }, props.children));
});

ButtonOption.propTypes =  false ? {
  /**
   * The content shown in the button option. Plain text and/or icons are
   * recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * If the button is placed on a backdrop that is not the primary background
   * color, then provide the color of the backdrop here so the button colors
   * can be optimized for display against the backdrop.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on a button. The button label may still extend
   * the width of the button if necessary
   */
  minWidth: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   *
   * This will override any `name` prop set on the parent ButtonGroup component.
   */
  name: _propTypes["default"].string,

  /**
   * The value of the option's form control. Use this in conjunction with the
   * `value` prop of the ButtonGroup component to mark this option as either
   * checked or unchecked.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the user clicks the option. No arguments are passed to
   * this function.
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
ButtonOption.defaultProps = {
  onClick: _noop["default"]
};
ButtonOption.displayName = "ButtonOption";
var _default = ButtonOption;
exports["default"] = _default;

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StageStatusViewV2__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_FilterUtil__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fileupload_context_DWPUploadContext__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fileupload_DWPUpload__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_ScrollableElementWrapper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var StageOverallStatusV2=function StageOverallStatusV2(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext3.viewModelF,dispatchF=_useContext3.dispatchF;var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__fileupload_context_DWPUploadContext__["a" /* DWPFileContext */]),viewModelDWP=_useContext4.viewModelDWP;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_19__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;var routeList=Array.from(viewModel.routeList);var filterOption=function filterOption(route,filter,key){if(!viewModelF[filter]||viewModelF[filter].length===0){return true;}var result=false;viewModelF[filter].forEach(function(filterValue){if(filter==='status'){result=result||route[key]===filterValue;}else if(route[key].includes(filterValue)){result=true;}});return result;};routeList=routeList.filter(function(route){return filterOption(route,"cluster","routeCode");}).filter(function(route){return filterOption(route,"driverType","routeType");}).filter(function(route){return filterOption(route,"departure","routeSLA");});if(viewModelF.viewType===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["w" /* ROUTE_VIEW */]||!configViewModel.stationConfig.pickStageDecoupleEnabled){routeList=routeList.filter(function(route){return filterOption(route,"status","stageStatus");}).filter(function(route){return Object(__WEBPACK_IMPORTED_MODULE_11__util_FilterUtil__["a" /* applyGlobalStageLocationTypeFilter */])(viewModelF,route);});}var getStageMetrics=function getStageMetrics(routes){var metrics={totalRoutes:routes.length,notReadyRoutes:0,readyRoutes:0,preStagedRoutes:0,stagedRoutes:0,partialStagedRoutes:0,interimStagedRoutes:0,stagedCarts:0,preStagedCarts:0,dwellingCartsDSP:0,dwellingCartsFlex:0,otsMetric:"-"};routes.forEach(function(route){if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].STAGED){metrics.stagedRoutes++;}else if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].PARTIALLY_STAGED){metrics.partialStagedRoutes++;}else if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].PRE_STAGED){metrics.preStagedRoutes++;}else if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].READY){metrics.readyRoutes++;}else if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].NOT_READY){metrics.notReadyRoutes++;}else if(route.stageStatus===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["d" /* INTERIM_STAGED */]){metrics.interimStagedRoutes++;}var cartList=Array.isArray(route.carts)?route.carts:[];cartList=cartList.filter(function(cart){return filterOption(cart,"status","status");});cartList.forEach(function(cart){if(cart.status===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["l" /* STAGED */]){metrics.stagedCarts++;}else if(cart.status===__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["i" /* PRE_STAGED */]){metrics.preStagedCarts++;}});metrics.dwellingCartsDSP+=cartList.filter(function(cart){return cart.dwelling===true&&cart.routeType.startsWith("DSP");}).length;metrics.dwellingCartsFlex+=cartList.filter(function(cart){return cart.dwelling===true&&!cart.routeType.startsWith("DSP");}).length;});metrics.otsMetric=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["a" /* calculateOTSMetric */])(routes);return metrics;};var renderDWPUploadView=function renderDWPUploadView(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,{minWidth:"15%",maxWidth:"25%",spacingInset:"small",spacing:"none",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacing:"none",wrap:"down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"stage.dwpLoaded",defaultMessage:"Dispatch plan"}),":\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:viewModelDWP.fileName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"b300"},viewModelDWP.fileName&&viewModelDWP.fileName.length>28?viewModelDWP.fileName.substr(0,28)+"...":viewModelDWP.fileName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"stage.dwpTime",defaultMessage:"Last update"}),":\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"b300"},viewModelDWP.creationTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__fileupload_DWPUpload__["a" /* default */],null));};var stageMetrics=getStageMetrics(routeList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacingInset:spacingInset_shorthand4,spacing:"medium",alignmentVertical:"stretch"},viewModelF.viewType===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["w" /* ROUTE_VIEW */]||!configViewModel.stationConfig.pickStageDecoupleEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{wrap:"down",maxWidth:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StageStatusViewV2__["a" /* default */],{stageStatus:{title:"depart.totalRoutes",message:"Total routes",value:stageMetrics.totalRoutes}})),!Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["t" /* isARorSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StageStatusViewV2__["a" /* default */],{stageStatus:{title:"stageOverall.timelyStaged",message:"Timely staged (%)",tooltip:"% of routes staged on time. This excludes sidelined routes and routes without DPO time.",value:stageMetrics.otsMetric}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ScrollableElementWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{alignmentVertical:"bottom",width:"100%",spacing:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].NOT_READY]});},stageStatus:{title:"stageOverall.notReady",message:"Not ready",value:stageMetrics.notReadyRoutes}}),!configViewModel.stationConfig.pickStageDecoupleEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].READY]});},stageStatus:{title:"stageOverall.ready",message:__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].READY,value:stageMetrics.readyRoutes}}):null,configViewModel.stationConfig.splitStagingEnabled||configViewModel.stationConfig.pickStageDecoupleEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["m" /* STAGE_STATUS */].PRE_STAGED]});},stageStatus:{title:"stageOverall.preStaged",message:"Pre staged",value:stageMetrics.preStagedRoutes}}):null,configViewModel.stationConfig.ssdmmotenabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["d" /* INTERIM_STAGED */]]});},stageStatus:{title:"stage.interimStaged",message:"Interim Staged",value:stageMetrics.interimStagedRoutes}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["h" /* PARTIALLY_STAGED */]]});},stageStatus:{title:"stage.partiallyStaged",message:"Partially Staged",value:stageMetrics.partialStagedRoutes}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["l" /* STAGED */]]});},stageStatus:{title:"cartContent.staged",message:"Staged",value:stageMetrics.stagedRoutes}}))))):null,configViewModel.capability===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["a" /* AR */]?renderDWPUploadView():null,viewModelF.viewType===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["d" /* CART_VIEW */]&&configViewModel.stationConfig.pickStageDecoupleEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StageStatusViewV2__["a" /* default */],{stageStatus:{title:"depart.totalRoutes",message:"Total routes",value:stageMetrics.totalRoutes}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",spacing:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["i" /* PRE_STAGED */]]});},stageStatus:{title:"stageOverall.cartPreStaged",message:"Carts Pre Staged",value:stageMetrics.preStagedCarts}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["l" /* STAGED */]]});},stageStatus:{title:"stageOverall.cartsStaged",message:"Carts Staged",value:stageMetrics.stagedCarts}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["i" /* PRE_STAGED */]]});dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:["DSP"]});},stageStatus:{title:"stageOverall.cartDwellingDSP",message:"Carts Dwelling (DSP)",value:stageMetrics.dwellingCartsDSP}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_6__util_EntityStatusManager__["i" /* PRE_STAGED */]]});dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:["DP"]});},stageStatus:{title:"stageOverall.cartDwellingFlex",message:"Carts Dwelling (Flex)",value:stageMetrics.dwellingCartsFlex}})))):null);};/* harmony default export */ __webpack_exports__["a"] = (StageOverallStatusV2);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DWPUploadReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_DwpNetworkAPI__ = __webpack_require__(672);
var DWPUploadReducer=function DWPUploadReducer(state,action){switch(action.type){case"LOAD_DWP_INFO":{var _action$data=action.data,dispatcher=_action$data.dispatcher,baseUrl=_action$data.baseUrl,stationConfig=_action$data.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_DwpNetworkAPI__["a" /* getDWPInfo */])(dispatcher,baseUrl,stationConfig);return state;}case"RECEIVE_DWP_INFO":{return Object.assign({},state,action.data);}case"UPLOAD_DWP":Object(__WEBPACK_IMPORTED_MODULE_0__network_DwpNetworkAPI__["b" /* uploadDWPFile */])(action.data);return state;case"UNLOAD_VIEW":return state;default:return state;}};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadDWPFile;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDWPInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Logger__ = __webpack_require__(67);
var uploadDWPFileUtil=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data){var dispatcher,baseUrl,file,alertDispatch,filterDispatcher,xptNodes,capability,routeDispatcher,stationConfig,startTime,stationCode,formData,config,api,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatcher=data.dispatcher,baseUrl=data.baseUrl,file=data.file,alertDispatch=data.alertDispatch,filterDispatcher=data.filterDispatcher,xptNodes=data.xptNodes,capability=data.capability,routeDispatcher=data.routeDispatcher,stationConfig=data.stationConfig;startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context.prev=3;formData=new FormData();formData.append("file",file,file.name);config={headers:{"Content-Type":"multipart/form-data"}};api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DWP_UPLOAD_API_TIMEOUT});_context.next=10;return api.post("/rsws/station/"+stationCode+"/uploadRoutes",formData,config);case 10:response=_context.sent;if(!(response.status===200)){_context.next=17;break;}Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["l" /* RSWS_DWP_UPLOAD_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].SUCCESS);alertDispatch({type:"SHOW_NOTIFICATION",data:{alert:{title:"Upload Success",type:"success"}}});dispatcher({type:'LOAD_DWP_INFO',data:{baseUrl:baseUrl,dispatcher:dispatcher,stationConfig:stationConfig}});routeDispatcher({type:'REFRESH_VIEW',data:{dispatcher:routeDispatcher,filterDispatcher:filterDispatcher,baseUrl:baseUrl,capability:capability,xptNodes:xptNodes,stationConfig:stationConfig}});return _context.abrupt("return");case 17:_context.next=22;break;case 19:_context.prev=19;_context.t0=_context["catch"](3);__WEBPACK_IMPORTED_MODULE_7__util_Logger__["a" /* Logger */].error("Exception in DwpNetworkAPI.uploadDWPFileUtil",_context.t0);case 22:Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["l" /* RSWS_DWP_UPLOAD_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].FAILED);alertDispatch({type:"SHOW_NOTIFICATION",data:{alert:{title:"Upload Failed",type:"error"}}});case 24:case"end":return _context.stop();}}},_callee,this,[[3,19]]);}));return function uploadDWPFileUtil(_x){return _ref.apply(this,arguments);};}();var getDWPFileInfoFromRSWS=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,baseUrl,stationConfig){var startTime,stationCode,api,response,requestPayload,output;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context2.prev=2;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context2.next=11;break;}requestPayload={resourcePath:"/apigw/station/"+stationCode+"/dwpMetadata",httpMethod:"get",processName:"routeStaging"};_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_6__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 8:response=_context2.sent;_context2.next=14;break;case 11:_context2.next=13;return api.get("/rsws/station/"+stationCode+"/dwpMetadata");case 13:response=_context2.sent;case 14:output=response.data;Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["k" /* RSWS_DWP_METADATA_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].SUCCESS);if(output.filename)dispatcher({type:"RECEIVE_DWP_INFO",data:convertDWPInfoResponse(output)});_context2.next=23;break;case 19:_context2.prev=19;_context2.t0=_context2["catch"](2);__WEBPACK_IMPORTED_MODULE_7__util_Logger__["a" /* Logger */].error("Exception in DwpNetworkAPI.getDWPFileInfoFromRSWS",_context2.t0);Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["v" /* STAGE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["k" /* RSWS_DWP_METADATA_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].FAILED);case 23:case"end":return _context2.stop();}}},_callee2,this,[[2,19]]);}));return function getDWPFileInfoFromRSWS(_x2,_x3,_x4){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Upload DWP File **/function uploadDWPFile(data){uploadDWPFileUtil(data);}/** Fetch DWP File Details **/function getDWPInfo(dispatcher,baseUrl,stationConfig){getDWPFileInfoFromRSWS(dispatcher,baseUrl,stationConfig);}function convertDWPInfoResponse(response){return{fileName:response.filename,creationTime:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["c" /* convertEpochMillisToLocalDateTime */])(response.creationTime),uploadSource:response.uploadSource};}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_DWPUploadContext__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stageStatus_context_StageFilterContext__ = __webpack_require__(38);
var DWPUpload=function DWPUpload(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_DWPUploadContext__["a" /* DWPFileContext */]),dispatchDWP=_useContext.dispatchDWP;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),dispatch=_useContext3.dispatch;var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__stageStatus_context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext4.viewModelF,dispatchF=_useContext4.dispatchF;var hiddenFileInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);var uploadDWP=function uploadDWP(){hiddenFileInput.current.click();};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){dispatchDWP({type:'LOAD_DWP_INFO',data:{baseUrl:configViewModel.baseUrl,dispatcher:dispatchDWP,stationConfig:configViewModel.stationConfig}});},[]);var uploadFile=function uploadFile(event){var files=event.target.files;dispatchDWP({type:'UPLOAD_DWP',data:{dispatcher:dispatchDWP,baseUrl:configViewModel.baseUrl,file:files[0],filterDispatcher:dispatchF,alertDispatch:dispatch,xptNodes:viewModelF.xptNodes,capability:configViewModel.capability,routeDispatcher:dispatch,stationConfig:configViewModel.stationConfig}});event.target.value='';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacingInset:"none",spacing:"none",alignmentHorizontal:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{ref:hiddenFileInput,type:"file",style:{display:'none'},onChange:uploadFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default.a,{type:"secondary",onClick:uploadDWP},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"stage.uploadDwp",defaultMessage:"Upload DWP"}))));};/* harmony default export */ __webpack_exports__["a"] = (DWPUpload);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssociateDetail__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AssociateContextProvider__ = __webpack_require__(107);
var AssociateDetailView=function AssociateDetailView(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AssociateContextProvider__["a" /* AssociateContext */]),associateViewModel=_useContext.associateViewModel,associateModelDispatcher=_useContext.associateModelDispatcher;var resetAssociateSelection=function resetAssociateSelection(){associateModelDispatcher({type:"RESET_ASSOCIATE_SELECTION"});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"large large small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb__["BreadcrumbGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb___default.a,{onClick:function onClick(){return resetAssociateSelection();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"routeInfo.stage",defaultMessage:"Stage"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_breadcrumb___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"associate.associate_detail",defaultMessage:"Associate Detail"})))),associateViewModel.associate.map(function(associate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AssociateDetail__["a" /* default */],{key:associate,associate:associate});}));};/* harmony default export */ __webpack_exports__["a"] = (AssociateDetailView);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stageStatus_context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_EntityStatusManager__ = __webpack_require__(32);
var AssociateDetail=function AssociateDetail(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__stageStatus_context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var getAssociateRoutes=function getAssociateRoutes(){var associateRoutes=[];viewModel.routeList.forEach(function(route){if(route.picker===props.associate){associateRoutes.push({routeCode:route.routeCode,status:route.stageStatus,progress:route.stageProgress,duration:route.stageDuration,statusTag:Object(__WEBPACK_IMPORTED_MODULE_11__util_EntityStatusManager__["y" /* getStageStatusColor */])(route.stageStatus),startTime:route.startTime,endTime:route.endTime});}});return associateRoutes;};var rowsData=getAssociateRoutes();var getAverageStageTime=function getAverageStageTime(){var totalRouteStageTime=0;var count=0;rowsData.forEach(function(row){if(row.duration!=="..."){totalRouteStageTime=totalRouteStageTime+Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["s" /* getTimeInSecond */])(row.duration);count++;}});if(count>0){var averageStageTimeInSecond=totalRouteStageTime/count;return Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["h" /* convertSecondsToTimeFormat */])(averageStageTimeInSecond);}return 0;};var getPhoneToolLink=function getPhoneToolLink(){var alias=props.associate;return"https://phonetool.amazon.com/users/"+alias;};var renderAssociateMetadata=function renderAssociateMetadata(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{backgroundColor:"secondary",spacingInset:"medium",spacing:"xlarge"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.averageStageTime",defaultMessage:"Average Stage Duration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{type:"b200"},getAverageStageTime()," mins")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"routeInfo.associate",defaultMessage:"Associate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_link___default.a,{href:getPhoneToolLink(),type:"secondary",target:"_blank",rel:"noreferrer noopener"},props.associate)));};var renderAssociateTable=function renderAssociateTable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,showStripes:true,spacing:"medium"},renderAssociateTableHeader(),renderAssociateRows());};var renderAssociateTableHeader=function renderAssociateTableHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.route",defaultMessage:"Route"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.progress",defaultMessage:"Progress"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.duration",defaultMessage:"Duration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.start_time",defaultMessage:"Start Time"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"associate.end_time",defaultMessage:"End Time"})));};var renderAssociateRows=function renderAssociateRows(){return rowsData.map(function(row){var primaryKey=configViewModel.stationConfig.parallelPickEnabled?row.picklistCode:row.routeCode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{key:primaryKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,primaryKey),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tag___default.a,{type:row.statusTag},row.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,row.progress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,row.duration),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,row.startTime),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,row.endTime));});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"small large small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading___default.a,{level:3,type:"h600",alignment:"left"},props.associate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"small large small"},renderAssociateMetadata()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"small large small"},renderAssociateTable()));};/* harmony default export */ __webpack_exports__["a"] = (AssociateDetail);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _breadcrumb = _interopRequireDefault(__webpack_require__(677));

var _context = _interopRequireDefault(__webpack_require__(281));

var _theme = __webpack_require__(7);

var _listReset = _interopRequireDefault(__webpack_require__(678));

var _functional = __webpack_require__(19);

var styles = (0, _emotion.css)(_listReset["default"], {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
});
var getContextValue = (0, _functional.memoizeCurry)(function (t, selected) {
  return {
    t: t,
    selected: selected
  };
}, 1);
/**
 * Used to group a set of breadcrumbs.
 */

function BreadcrumbGroup(props) {
  var t = (0, _theme.useTheme)(_breadcrumb["default"], "breadcrumb");

  var breadcrumbs = _react["default"].Children.toArray(props.children);

  var lastIndex = breadcrumbs.length - 1;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: styles
  }, breadcrumbs.map(function (breadcrumb, index) {
    return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
      key: index,
      value: getContextValue(t)(index === lastIndex)
    }, breadcrumb);
  }));
}

BreadcrumbGroup.propTypes =  false ? {
  /**
   * The list of breadcrumbs to display. These must be elements of the
   * `Breadcrumb` component.
   */
  children: _propTypes["default"].node.isRequired
} : {};
var _default = BreadcrumbGroup;
exports["default"] = _default;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    breadcrumbForegroundColorDefault: tokens.themeForegroundAccentDefault,
    breadcrumbForegroundColorHover: tokens.themeForegroundAccentHover,
    breadcrumbForegroundColorPressed: tokens.themeForegroundAccentPressed,
    breadcrumbForegroundColorSelected: tokens.themeForegroundPrimaryDefault,
    breadcrumbSeparatorColor: tokens.themeBorderSecondaryDefault,
    breadcrumbSpacingHorizontal: 24,
    breadcrumbFontSize: 14,
    breadcrumbLineHeight: "20px",
    breadcrumbMotionDuration: "100ms",
    breadcrumbMotionFunction: "ease"
  }
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var listReset = {
  listStyle: "none",
  padding: 0,
  margin: 0
};
var _default = listReset;
exports["default"] = _default;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(137));

var _context = _interopRequireDefault(__webpack_require__(281));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _clickable = _interopRequireDefault(__webpack_require__(59));

var _tooltip = _interopRequireDefault(__webpack_require__(65));

var _text = _interopRequireDefault(__webpack_require__(22));

var _noTextWrap = _interopRequireDefault(__webpack_require__(101));

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _getIconCss = _interopRequireDefault(__webpack_require__(86));

var _token = __webpack_require__(8);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var chevronIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);

var chevronStyles = function chevronStyles(t, backgroundImage) {
  return {
    content: "''",
    display: "block",
    width: t("spacingHorizontal"),
    height: chevronIcon.height,
    backgroundImage: (0, _getIconCss["default"])(backgroundImage, t("separatorColor")),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    // Center the icon just to the left of the breadcrumb
    position: "absolute",
    right: "100%",
    top: "50%",
    marginTop: -(chevronIcon.height / 2)
  };
};

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var focus = _ref.focus,
      selected = _ref.selected;
  return (0, _emotion.css)((0, _text["default"])(t), (_css = {
    // This helps with the absolutely-positioned chevron icon.
    position: "relative",
    // Set a min width of 0 to allow truncation of text inside a flex child.
    // This does not work in IE11.
    // See: https://stackoverflow.com/a/36247448/2747759
    minWidth: 0,
    // Add spacing between breadcrumbs
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "li + &": {
    //   marginInlineStart: t("spacingHorizontal"),
    // },
    "li + &": (0, _defineProperty2["default"])({
      marginLeft: t("spacingHorizontal"),
      marginRight: 0
    }, "[dir=\"rtl\"] &", {
      marginLeft: 0,
      marginRight: t("spacingHorizontal")
    }),
    // Add an chevron icon to the left of the breadcrumb (unless it's the
    // first one).
    "&:not(:first-of-type):before": chevronStyles(t, chevronIcon.data)
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &:not(:last-of-type):before", chevronStyles(t, chevronIcon.dataRtl)), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &:last-of-type:before", {
    display: "none"
  }), (0, _defineProperty2["default"])(_css, "& > a, & > button", (0, _emotion.css)(_noTextWrap["default"], {
    display: "block",
    color: t("foregroundColor", selected ? "selected" : "default"),
    cursor: selected ? "default" : "pointer",
    transition: t.transitionCss("motion", "color"),
    ":hover": !selected ? {
      color: t("foregroundColorHover")
    } : undefined,
    ":active": !selected ? {
      color: t("foregroundColorPressed")
    } : undefined
  })), _css), (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 4
  }));
}, ["focus", "selected"]);
/**
 * Used to render a single breadcrumb in a group of breadcrumbs. Place this as
 * a child of the BreadcrumbGroup component.
 */

var Breadcrumb = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var truncate = props.truncate,
      children = props.children;

  var _useContext = (0, _react.useContext)(_context["default"]),
      t = _useContext.t,
      selected = _useContext.selected;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // Wrap the breadcrumb in a tooltip if the `truncate` prop is set to true.

  var MaybeTooltip = (0, _react.useCallback)(function (props) {
    return truncate ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], (0, _extends2["default"])({
      title: children,
      position: "bottom"
    }, props)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, props);
  }, [truncate, children]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: styles(t, {
      focus: focus && focusTrigger === "keyboard",
      selected: selected
    })
  }, /*#__PURE__*/_react["default"].createElement(MaybeTooltip, null, /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
    "aria-current": selected ? "page" : undefined,
    disabled: selected,
    href: props.href,
    onClick: props.onClick,
    ref: ref
  }), props.truncate ? "…" : props.children)));
});

Breadcrumb.displayName = "Breadcrumb";
Breadcrumb.propTypes =  false ? {
  /**
   * The text to show in the breadcrumb. This is generally the title of the page
   * that the breadcrumb links to.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The URL of the page that the breadcrumb links to.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Set this to `true` to display the breadcrumb in a truncated format. Only
   * ellipsis will be shown in the UI. The full title will appear in a tooltip
   * on hover or focus.
   *
   * If this is `false` the breadcrumb may still be partially truncated by the
   * browser if there is not enough room in the layout for all breadcrumbs to be
   * shown.
   *
   * NOTE: Automatic truncation is not supported in IE11. If you support IE11
   * and your breadcrumbs do not fit in the layout please use this `truncate`
   * prop.
   *
   * @since 5.x
   */
  truncate: _propTypes["default"].bool,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = Breadcrumb;
exports["default"] = _default;

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_component_FilterExpander__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StageFilterV2__ = __webpack_require__(682);
var StageFilterV2Wrapper=function StageFilterV2Wrapper(){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_component_FilterExpander__["a" /* FilterExpander */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StageFilterV2__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StageFilterV2__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (StageFilterV2Wrapper);

/***/ }),
/* 681 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconFilterData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentColor' stroke-width='2'%3e%3cpath d='M3 5h12M3 19h12M21 5h-2M21 19h-2M9 12h12M3 12h2'/%3e%3ccircle fill-rule='nonzero' cx='17' cy='5' r='2'/%3e%3ccircle fill-rule='nonzero' cx='17' cy='19' r='2'/%3e%3ccircle fill-rule='nonzero' cx='7' cy='12' r='2'/%3e%3c/g%3e%3c/svg%3e",
  iconFilterWidth: 24,
  iconFilterHeight: 24
};

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_FilterUtil__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_RefreshTimer__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_context_DeviceLayoutContext__ = __webpack_require__(25);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var StageFilterV2=function StageFilterV2(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_StageFilterContext__["a" /* StageFilterContext */]),viewModelF=_useContext.viewModelF,dispatchF=_useContext.dispatchF;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext3.viewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_16__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;var stageDataConversionHandler=function stageDataConversionHandler(){return Object(__WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__["c" /* getStageDataInCSVFormat */])(viewModel.cartList,viewModel.routeList,viewModelF.viewType,configViewModel.capability,configViewModel.stationConfig);};var isFilterSet=function isFilterSet(){var result=false;Object.entries(viewModelF).forEach(function(entry){var key=entry[0];var values=entry[1];result=result||Array.isArray(values)&&values.length&&key!=='data';});return result;};var clearAllFilters=function clearAllFilters(){dispatchF({type:'REMOVE_ALL_FILTER'});};var isXPTFilterRequired=function isXPTFilterRequired(){var xptNodes=viewModelF.data.xptNodes;return Array.isArray(xptNodes)&&xptNodes.length&&__WEBPACK_IMPORTED_MODULE_13__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){dispatchF({type:'LOAD_FILTERS'});dispatchF({type:'LOAD_XPT_NODES',data:{dispatcher:dispatchF,baseUrl:configViewModel.baseUrl,capability:configViewModel.capability,stationConfig:configViewModel.stationConfig}});},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand2,spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"none",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__["a" /* default */],{isLink:true,csvDataProvider:stageDataConversionHandler,filePrefix:"STAGE"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{wrap:"down",width:"100%",spacingInset:"medium small",spacing:"small",backgroundColor:"secondary"},isXPTFilterRequired()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_XPT_NODE',xptNodes:data});},value:viewModelF.xptNodes,size:"small",placeholder:props.intl.formatMessage({id:"stage.xptNodes",defaultMessage:"XPT Nodes"}),width:"120px"},[].concat(_toConsumableArray(viewModelF.data.xptNodes)).sort().map(function(xptNode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:xptNode,label:xptNode,value:xptNode});})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DEPARTURE',Departure:data});},value:viewModelF.departure,size:"small",placeholder:props.intl.formatMessage({id:"stage.stageByTime",defaultMessage:"Stage by time"}),width:"145px"},[].concat(_toConsumableArray(viewModelF.data.departure)).sort().map(function(departure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:departure,label:"Stage by "+departure,value:departure});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:data});},value:viewModelF.driverType,size:"small",placeholder:props.intl.formatMessage({id:"stageFilter.driverType",defaultMessage:"Driver Type"}),width:"125px"},[].concat(_toConsumableArray(viewModelF.data.driverType)).sort().map(function(driverType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:driverType,label:driverType,value:driverType});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_CLUSTER',Cluster:data});},value:viewModelF.cluster,size:"small",placeholder:props.intl.formatMessage({id:"stageFilter.cluster",defaultMessage:"Cluster"}),width:"115px"},[].concat(_toConsumableArray(viewModelF.data.cluster)).sort().map(function(cluster){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:cluster,label:cluster,value:cluster});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_STATUS',status:data});},value:viewModelF.status,size:"small",placeholder:props.intl.formatMessage({id:"cartInfo.status",defaultMessage:"Status"}),width:"120px"},Object(__WEBPACK_IMPORTED_MODULE_8__util_EntityStatusManager__["z" /* getStageStatusList */])(viewModelF.viewType,configViewModel.stationConfig).map(function(status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:status,label:status,value:status});})),configViewModel.stationConfig.highSPREnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_STAGE_LOCATION_TYPE',stageLocationType:data});},value:viewModelF.stageLocationType,size:"small",placeholder:props.intl.formatMessage({id:"cartInfo.stageLocationType",defaultMessage:"Location Type"}),width:"137px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["A" /* STAGE_LOCATION_TYPE */].OVERFLOW,label:props.intl.formatMessage({id:"cartInfo.overflowStatus",defaultMessage:"Overflow"}),value:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["A" /* STAGE_LOCATION_TYPE */].OVERFLOW})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"small none none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{spacing:"small"},Object.entries(viewModelF).map(function(entry){var key=entry[0];var values=entry[1];return Array.isArray(values)&&key!=='data'?values.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default.a,{key:value,type:"theme",onClose:function onClose(){return dispatchF({type:'REMOVE_FILTER',data:{key:key,value:value}});}},Object(__WEBPACK_IMPORTED_MODULE_14__util_FilterUtil__["c" /* getFilterTagLabel */])(key,value));}):null;}),isFilterSet()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default.a,{onClick:clearAllFilters,type:"secondary"},"Clear all"):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{spacingInset:"small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_RefreshTimer__["a" /* default */],{deps:[viewModel.lastUpdated],lastUpdated:viewModel.lastUpdated})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(StageFilterV2));

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_StageFilterContext__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__ = __webpack_require__(25);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var StageTabViewSelector=function StageTabViewSelector(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["w" /* ROUTE_VIEW */]),_useState2=_slicedToArray(_useState,2),stageTabView=_useState2[0],setStageTabView=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_StageFilterContext__["a" /* StageFilterContext */]),dispatchF=_useContext.dispatchF;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext2.configViewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_7__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;var toggleView=function toggleView(newValue){setStageTabView(newValue);dispatchF({type:'SELECT_STAGE_TAB_VIEW_TYPE',stageTabViewType:newValue});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)&&configViewModel.stationConfig.stagenabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{spacingInset:spacingInset_shorthand4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group___default.a,{value:stageTabView,onChange:toggleView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__["ButtonOption"],{value:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["w" /* ROUTE_VIEW */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"stageOverall.routeView",defaultMessage:"Route View"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button_group__["ButtonOption"],{value:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["u" /* PLAN_MANAGEMENT_VIEW */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"stageOverall.planManagementView",defaultMessage:"Plan Management View"})))):null);};/* harmony default export */ __webpack_exports__["a"] = (StageTabViewSelector);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_context_useCapabilityContext__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_RouteStageContext__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var PlanManagementView=function PlanManagementView(){var _useCapabilityContext=Object(__WEBPACK_IMPORTED_MODULE_7__global_context_useCapabilityContext__["a" /* default */])(),configViewModel=_useCapabilityContext.configViewModel,configViewModelRef=_useCapabilityContext.configViewModelRef;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_RouteStageContext__["a" /* RouteStageContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showConfirmationModal=_useState2[0],setShowConfirmationModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),pendingConfirmationData=_useState4[0],setPendingConfirmationData=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var config=configViewModelRef.current;if(config.stationConfig.initialised){getStagePlanTasksData(config);}},[configViewModel.stationConfig.initialised]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(viewModel.showPendingConfirmation){setShowConfirmationModal(true);setPendingConfirmationData(viewModel.pendingConfirmationData);}},[viewModel.showPendingConfirmation,viewModel.pendingConfirmationData]);var getStagePlanTasksData=function getStagePlanTasksData(config){dispatch({type:'LOAD_STAGE_PLAN_TASKS',data:{baseUrl:config.baseUrl,stationConfig:config.stationConfig,dispatcher:dispatch}});};var planList=viewModel.stageTaskPlanList;var getTableHeader=function getTableHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableRow"],{header:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.cycle",defaultMessage:"Cycle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.node",defaultMessage:"Node"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.plan_id",defaultMessage:"Plan id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.created_date",defaultMessage:"Created date"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.update_plan_status",defaultMessage:"Update plan status"})));};var updatePlanStatus=function updatePlanStatus(plan){var config=configViewModelRef.current;var isPlanBeingActivated=plan.status==="HOLD";Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["A" /* isRouteAdjustmentEnabled */])().then(function(isEnabled){dispatch({type:'UPDATE_STAGE_TASK_PLAN_STATUS',data:{baseUrl:config.baseUrl,stationConfig:config.stationConfig,dispatcher:dispatch,planId:plan.stageTaskPlanId,status:getStatusToBeUpdated(plan.status),forceUpdate:!isEnabled||!isPlanBeingActivated,cycleName:plan.planCycle}});});};var getTableRows=function getTableRows(){return planList.map(function(plan){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableRow"],{key:plan.stageTaskPlanId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{header:true,key:""+plan.planCycle+plan.stageTaskPlanId}," ",plan.planCycle," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{key:""+plan.nodeId+plan.stageTaskPlanId}," ",plan.nodeId," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{key:"StagePlanId"+plan.stageTaskPlanId}," ",plan.stageTaskPlanId," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{key:""+plan.planDay+plan.stageTaskPlanId}," ",plan.planDay," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{key:""+plan.status+plan.stageTaskPlanId}," ",getPlanStatusString(plan.status)," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table__["TableCell"],{key:"UpdateButton"+plan.stageTaskPlanId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{onClick:function onClick(){return updatePlanStatus(plan);}},getUpdateButtonStatusString(plan.status))));});};var getPlanStatusString=function getPlanStatusString(status){if(status===__WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__["n" /* STAGE_TASK_PLAN_STATUS */].ASSIGNABLE){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.active_plan",defaultMessage:"Active"});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.inactive_plan",defaultMessage:"Inactive"});}};var getUpdateButtonStatusString=function getUpdateButtonStatusString(status){if(status===__WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__["n" /* STAGE_TASK_PLAN_STATUS */].ASSIGNABLE){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.deactivate_plan",defaultMessage:"Deactivate status"});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.activate_plan",defaultMessage:"Activate status"});}};var getStatusToBeUpdated=function getStatusToBeUpdated(currentStatus){if(currentStatus===__WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__["n" /* STAGE_TASK_PLAN_STATUS */].ASSIGNABLE){return __WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__["n" /* STAGE_TASK_PLAN_STATUS */].HOLD;}else{return __WEBPACK_IMPORTED_MODULE_9__util_EntityStatusManager__["n" /* STAGE_TASK_PLAN_STATUS */].ASSIGNABLE;}};var handleProceedAnyway=function handleProceedAnyway(){var config=configViewModelRef.current;var currentPlan=viewModel.stageTaskPlanList.find(function(p){return p.stageTaskPlanId===pendingConfirmationData.planId;});var cycleName=currentPlan.planCycle;dispatch({type:'UPDATE_STAGE_TASK_PLAN_STATUS',data:{baseUrl:config.baseUrl,stationConfig:config.stationConfig,dispatcher:dispatch,planId:pendingConfirmationData.planId,status:pendingConfirmationData.status,forceUpdate:true,// Unblock Staging despite pending adjustments
cycleName:cycleName}});setShowConfirmationModal(false);dispatch({type:"CLEAR_PENDING_CONFIRMATION"});};var handleCancel=function handleCancel(){setShowConfirmationModal(false);dispatch({type:"CLEAR_PENDING_CONFIRMATION"});};var renderConfirmationModal=function renderConfirmationModal(){if(!showConfirmationModal||!pendingConfirmationData)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{width:500,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.route_adjustment_title",defaultMessage:"Route Adjustment Status"}),open:showConfirmationModal,onClose:handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.pending_tasks_message",defaultMessage:"There are {count} pending route adjustment tasks.",values:{count:pendingConfirmationData.numberOfRemainingPackages}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.proceed_confirmation",defaultMessage:"Do you want to proceed with activating the plan anyway?"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{spacing:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{onClick:handleProceedAnyway},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.proceed_anyway",defaultMessage:"Proceed Anyway"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{onClick:handleCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"planManagement.cancel",defaultMessage:"Cancel"}))));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{width:"100%",spacingInset:"medium large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showStripes:true},getTableHeader(),getTableRows())),renderConfirmationModal());};/* harmony default export */ __webpack_exports__["a"] = (PlanManagementView);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _modal = _interopRequireDefault(__webpack_require__(265));

var _modalBox = _interopRequireWildcard(__webpack_require__(686));

var _theme = __webpack_require__(7);

var _scrim = _interopRequireDefault(__webpack_require__(267));

var _portal = _interopRequireDefault(__webpack_require__(146));

var _responsive = _interopRequireDefault(__webpack_require__(148));

var _animateMount = _interopRequireWildcard(__webpack_require__(268));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _onDirectClick = _interopRequireDefault(__webpack_require__(269));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeScaleWithMount = (0, _animateMount["default"])(_animateMount.AnimateFadeScale);
/**
 * The scrim is the vertical scroll container, and uses flexbox to center the
 * modal in the viewport.
 */

var scrimStyles = (0, _emotion.css)({
  display: "flex",
  alignItems: "center",
  overflow: "auto"
});
/**
 * This wrapper uses margin "auto" to center the modal, but sets a max width and
 * height which force the modal to overflow to the bottom/right of the viewport
 * instead of oveflowing all sides (which looks funky and makes the top/left
 * content inaccessible). For details see:
 * https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
 */

var outerWrapperStyles = (0, _emotion.css)({
  maxWidth: "100%",
  maxHeight: "100%",
  margin: "auto"
});
/**
 * The inner wrapper applies a margin around the modal to ensure a certain
 * amount of scrim is always shown. Applying the margin here as opposed to on
 * the outer wrapper ensures that the margin below the modal is preserved even
 * if the modal overflows the viewport and requires scrolling (otherwise the
 * padding would disappear due to this problem:
 * https://www.brunildo.org/test/overscrollback.html).
 */

var innerWrapperStyles = (0, _emotion.css)({
  padding: "".concat(_modalBox.scrimSpacingVertical, "vh ").concat(_modalBox.scrimSpacingHorizontal, "vw"),
  // HACK: IE11 will only respect the max-height property of the modal if the
  // modal's parent is a flex column. See:
  // https://stackoverflow.com/questions/44635857/flexbox-max-height-issue-with-ie11
  display: "flex",
  flexDirection: "column"
});
/**
 * Don't bother updating the modal if it's persisting in a closed state.
 */

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};
/**
 * Render a modal in the viewport. On desktop the modal will be shown with a
 * scrim behind it. On mobile the modal will be shown fullscreen. Only one modal
 * should be rendered at a time.
 *
 * NOTE: Do not mount a Modal inside an interactive element. The Modal's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Modal will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Modal being counted as a click on the element
 * where the Modal was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */


var Modal = /*#__PURE__*/_react["default"].memo(function (props) {
  var t = (0, _theme.useTheme)(_modal["default"], "modal");
  var scrimRef = (0, _react.useRef)();
  var anchorRef = (0, _react.useRef)(); // We want an onClose callback, but only if props.onClose is defined

  var onCloseProp = props.onClose;
  var onCloseCallback = (0, _react.useCallback)(function () {
    if (anchorRef.current && anchorRef.current.focus) {
      anchorRef.current.focus();
    }

    onCloseProp();
  }, [onCloseProp, anchorRef]);
  var onCloseMaybe = onCloseProp ? onCloseCallback : undefined;
  (0, _react.useEffect)(function () {
    if (props.open) {
      // Remember the node that the modal was opened from. We'll try to focus on
      // this when the modal is closed. We put this logic in a side effect rather
      // then the `modalRef` callback b/c by the time that callback is called
      // it's too late and the `activeElement` might already be an auto-focused
      // element inside of the modal - negating the benefit of remembering which
      // node caused the modal to open.
      anchorRef.current = document.activeElement;
    }
  }, [props.open]);
  var modalRef = (0, _react.useCallback)(function (modalNode) {
    if (modalNode) {
      // Get the active element and check if it's inside of the modal
      var activeElementInsideModal = modalNode.contains(document.activeElement);

      if (!activeElementInsideModal) {
        // Focus the first node in the Modal
        modalNode.focus(); // Reset the scroll position of the scrim to counteract the browser
        // auto-scrolling to the focused node. Note that we have to wait one
        // event loop for this to work (otherwise we'd be resetting the scroll
        // *before* the browser auto-scrolls).
        // Prevent the browser from scrolling to the focused node to avoid a
        // jitter when the modal opens.
        // TODO: Update this to use the "preventScroll" focus option when Safari
        // implements that and we drop support for IE11.

        if (scrimRef.current) {
          setTimeout(function () {
            scrimRef.current.scrollTop = 0;
            scrimRef.current.scrollLeft = 0;
          }, 0);
        }
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeScaleWithMount, {
    open: props.open,
    duration: t("motionDuration"),
    easing: t("motionFunction"),
    onOpen: props.onOpen
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd,
        open = _ref.open;
    return /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
      query: "min-width",
      props: {
        fullscreen: (0, _defineProperty2["default"])({
          "default": true
        }, "".concat(t("floatingBreakpoint"), "px"), false)
      }
    }, function (_ref2) {
      var fullscreen = _ref2.fullscreen;

      var modal = /*#__PURE__*/_react["default"].createElement(_modalBox["default"], (0, _extends2["default"])({}, props, {
        onClose: onCloseMaybe,
        t: t,
        scrollContainer: props.scrollContainer,
        fullscreen: fullscreen,
        className: className,
        onTransitionEnd: onTransitionEnd,
        ref: modalRef
      }));

      return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_scrim["default"], {
        open: props.open || open,
        className: scrimStyles,
        onClick: onCloseMaybe,
        ref: scrimRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: outerWrapperStyles
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: innerWrapperStyles,
        onMouseDown: // The inner wrapper has a little padding
        // applied to keep the modal away from the
        // edges of the viewport. This padding appears
        // as scrim space to the user, but it blocks
        // clicks to the scrim so we have to add the
        // click-to-close behavior here as well
        (0, _onDirectClick["default"])(onCloseMaybe)
      }, modal))));
    });
  });
}, shouldNotUpdate);

Modal.displayName = "Modal";
Modal.propTypes =  false ? {
  /**
   * The contents of the modal.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the modal open? If false the modal will not be mounted in the DOM. If
   * changed from false to true the modal will be mounted and will animate
   * open.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.11.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Sets the padding on the body of the modal
   */
  bodySpacingInset: _propTypes2["default"].spacing(4),

  /**
   * Determines whether or not the click event for the close button will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   *
   * @since 5.x
   */
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * An accessibility label for the close button. This will be read by screen
   * readers, but will not be present in the UI.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [action](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formAction: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),

  /**
   * This determines where the vertical scrollbar is placed for modals with
   * content that overflows vertically. If set to "modal", the scrollbar will
   * be placed inside the modal. The content will overflow inside the modal,
   * but the the modal itself will fit inside the viewport. If set to
   * "viewport", the scrollbar will be placed inside the viewport. The modal
   * will overflow the viewport, and the user will scroll the entire modal to
   * view the content.
   *
   * NOTE: This does not currently affect the horizontal scrollbar for content
   * which is too wide for the modal and cannot wrap. The horizontal scrollbar
   * will always be shown inside the modal.
   *
   * NOTE: This only applies to modals on desktop. On mobile modals are shown
   * fullscreen so there is no meaningful distinction between the modal
   * and the viewport.
   */
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),

  /**
   * The title of the modal. This will be shown in the modal header. If no
   * title is provided, no header will be shown.
   */
  title: _propTypes["default"].string,

  /**
   * Set the width of the modal using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * This width only applies to desktop, as modals are displayed
   * full-screen on mobile.
   *
   * A max width is applied to the modal in
   * addition to this width to ensure that the modal is never too wide for the
   * viewport.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a callback is provided here, a close button will be rendered in the
   * modal. The user will be able to close the modal by clicking on the button
   * or the scrim behind the modal. The callback will be fired whent he user
   * performs either of these actions.
   *
   * If a callback is not provided here, no close button will be rendered and
   * nothing will happen when the user clicks the scrim. This can be helpful
   * for dialog modals that require an action from the user. Note that if
   * you do not provide a close handler here you *must* provide another way
   * for the user to close the modal (e.g. by confirming or denying a dialog
   * action). Otherwise the user will be stuck in the modal.
   */
  onClose: _propTypes["default"].func,

  /**
   * This callback will be fired after the Modal opens.
   */
  onOpen: _propTypes["default"].func,

  /**
   * If a callback is provided here the Modal will behave like a [form](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
   *
   * To set the [action and method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) of the form, see `formAction` and `formMethod`.
   *
   * If using a Meridian [Button](https://meridian.a2z.com/components/button/?platform=react-web&detailsTab=api) in the footer for submission,
   * be sure to use set the button's `submit` prop to `true`.
   *
   * @since 4.x
   */
  onSubmitForm: _propTypes["default"].func
} : {};
Modal.defaultProps = {
  closeButtonPropagateClickEvent: true,
  closeLabel: "Close",
  bodySpacingInset: "medium",
  scrollContainer: "viewport"
};
var _default = Modal;
exports["default"] = _default;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrimSpacingVertical = exports.scrimSpacingHorizontal = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _keycode = _interopRequireDefault(__webpack_require__(51));

var _close = _interopRequireDefault(__webpack_require__(83));

var _elevation = __webpack_require__(54);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _modalFooter = _interopRequireDefault(__webpack_require__(286));

var _button = _interopRequireDefault(__webpack_require__(28));

var _icon = _interopRequireDefault(__webpack_require__(24));

var _focusTrap = _interopRequireDefault(__webpack_require__(270));

var _propTypes2 = _interopRequireDefault(__webpack_require__(70));

var _parsers = __webpack_require__(57);

var _isElementOf = _interopRequireDefault(__webpack_require__(60));

var _text = _interopRequireDefault(__webpack_require__(22));

var _useFocus2 = _interopRequireDefault(__webpack_require__(41));

var _focusRing = _interopRequireDefault(__webpack_require__(52));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var closeButtonWidth = 32; // px

var scrimSpacingVertical = 10; // vh

exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw

exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);

var isNotFooter = function isNotFooter(child) {
  return !isFooter(child);
};

var styles = function styles(t, _ref) {
  var _css, _divNotMdnMod;

  var focus = _ref.focus,
      scrollContainer = _ref.scrollContainer,
      fullscreen = _ref.fullscreen,
      width = _ref.width,
      bodySpacingInset = _ref.bodySpacingInset,
      showTitle = _ref.showTitle,
      showCloseButton = _ref.showCloseButton;
  var padding = (0, _parsers.parseSpacing)(bodySpacingInset);
  return (0, _emotion.css)(
  /**
   * Focus ring styles - important that these are first so subsequent styles
   * (like `position: fixed` for fullscreen modals) can overwrite the ring styles.
   */
  focus ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: t("borderRadius")
  }) : {},
  /**
   * Fullscreen vs non-fullscreen styles
   */
  fullscreen ? {
    // Fullscreen modals aren't shown in a scrim so we've got to handle
    // layout here
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: _elevation.elevationModal,
    // Use momentum scrolling on iOS. See:
    // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch"
  } : {
    // Apply the user-provided width if we're not showing a fullscreen
    // modal
    width: width,
    // This allows the absolutely-positioned close button to anchor itself
    // to the modal
    position: "relative",
    boxShadow: t.boxShadowCss("dropShadow"),
    maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
    maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
    borderRadius: t("borderRadius")
  }, {
    /**
     * Common styles
     */
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: t("bodyBackgroundColor"),
    outline: "none",

    /**
     * Header styles
     */
    "& > header": (0, _emotion.css)((0, _text["default"])(t), (_css = {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      minHeight: t("headerMinHeight"),
      paddingTop: t("headerSpacingInsetTop"),
      paddingBottom: t("headerSpacingInsetBottom"),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11
      // and we update the token names, we can simplify these styles to be:
      // {
      //   paddingInlineStart: t("headerSpacingInsetStart")
      //   paddingInlineEnd: t("headerSpacingInsetEnd")
      // }
      paddingRight: t("headerSpacingInsetRight"),
      paddingLeft: t("headerSpacingInsetLeft")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      paddingLeft: t("headerSpacingInsetRight"),
      paddingRight: t("headerSpacingInsetLeft")
    }), (0, _defineProperty2["default"])(_css, "backgroundColor", t("headerBackgroundColor")), (0, _defineProperty2["default"])(_css, "color", t("headerForegroundColor")), (0, _defineProperty2["default"])(_css, "fontWeight", t("headerFontWeight")), _css)),

    /**
     * Body styles
     */
    "& > div:not([mdn-modal-footer])": (_divNotMdnMod = {
      padding: (0, _parsers.parseSpacing)(bodySpacingInset).map(function (value) {
        return "".concat(value, "px");
      }).join(" "),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   paddingInlineEnd: showCloseButton && !showTitle
      //             ? `calc(${padding[1] || padding[0]}px + ${closeButtonWidth}px)`
      //             : undefined,
      // }
      // Add extra right-padding on modals with no title and a close button
      paddingRight: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined
    }, (0, _defineProperty2["default"])(_divNotMdnMod, "[dir=\"rtl\"] &", {
      paddingLeft: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined,
      // HACK: Need to remove the additional right padding until we
      // update to use paddingInlineStart
      paddingRight: "".concat(t("headerSpacingInsetLeft"), "px !important")
    }), (0, _defineProperty2["default"])(_divNotMdnMod, "overflowY", scrollContainer === "modal" ? "auto" : undefined), (0, _defineProperty2["default"])(_divNotMdnMod, "overflowX", "auto"), (0, _defineProperty2["default"])(_divNotMdnMod, "flex", fullscreen ? "auto" : undefined), _divNotMdnMod),

    /**
     * Footer styles
     */
    "& > footer": {
      borderTop: t.borderCss("footerBorder"),
      padding: t("footerSpacingInset")
    }
  });
};

var closeButtonStyles = function closeButtonStyles(t) {
  var _css2;

  return (0, _emotion.css)((_css2 = {
    position: "absolute",
    top: t("closeButtonSpacingTop"),
    right: t("closeButtonSpacingRight")
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] &", {
    left: t("closeButtonSpacingRight"),
    right: "auto"
  }), (0, _defineProperty2["default"])(_css2, "zIndex", _elevation.elevationForeground), _css2));
};
/* eslint-disable react/prop-types, react/display-name */
// The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>


var ModalBoxRoot = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: 0,
    ref: ref,
    role: "dialog"
  }));
});
/* eslint-enable react/prop-types, react/display-name */

/**
 * This component can be used to render a modal for your application
 */


var ModalBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClose = props.onClose,
      onSubmitForm = props.onSubmitForm,
      formAction = props.formAction,
      formMethod = props.formMethod;
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("modal-");
  }, []);
  var headerId = props.title ? "".concat(id, "-header") : undefined;

  var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps,
      focusDescendent = _useFocus.focusDescendent; // Call the onClose handler if the esc key is pressed


  var onKeyDownDocument = (0, _react.useCallback)(function (event) {
    if ((0, _keycode["default"])(event) === "esc") {
      onClose();
    }
  }, [onClose]); // Bind the onKeyDownDocument handler to the window

  (0, _react.useEffect)(function () {
    if (onClose) {
      window.addEventListener("keydown", onKeyDownDocument);
    }

    return function () {
      return window.removeEventListener("keydown", onKeyDownDocument);
    };
  }, [onClose, onKeyDownDocument]);
  var onSubmit = (0, _react.useCallback)(function (event) {
    if (!formAction && !formMethod) event.preventDefault();
    onSubmitForm();
  }, [formAction, formMethod, onSubmitForm]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/_react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, focusProps, {
    className: (0, _emotion.cx)(props.className, styles(props.t, {
      focus: focus && focusTrigger === "keyboard" && !focusDescendent,
      scrollContainer: props.scrollContainer,
      width: props.width,
      fullscreen: props.fullscreen,
      bodySpacingInset: props.bodySpacingInset,
      showTitle: Boolean(props.title),
      showCloseButton: Boolean(onClose)
    })),
    onTransitionEnd: props.onTransitionEnd,
    onSubmit: onSubmitForm ? onSubmit : undefined,
    action: props.formAction,
    method: props.formMethod,
    "aria-labelledby": headerId,
    "aria-describedby": props.describedById,
    "aria-modal": true,
    ref: ref
  }, passThroughProps), props.title ? /*#__PURE__*/_react["default"].createElement("header", {
    id: headerId
  }, props.title) : null, onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: onClose,
    size: "small",
    type: "icon",
    backdropColor: props.title ? props.t("headerBackgroundColor") : props.t("bodyBackgroundColor"),
    className: closeButtonStyles(props.t),
    propagateClickEvent: props.closeButtonPropagateClickEvent
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }, props.closeLabel)) : null, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});

ModalBox.displayName = "ModalBox";
ModalBox.propTypes =  false ? {
  closeLabel: _propTypes["default"].string.isRequired,
  bodySpacingInset: _propTypes2["default"].spacing(4),
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,
  formAction: _propTypes["default"].string,
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),
  fullscreen: _propTypes["default"].bool,
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),
  t: _propTypes["default"].func,
  title: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClose: _propTypes["default"].func,
  onSubmitForm: _propTypes["default"].func,
  onTransitionEnd: _propTypes["default"].func
} : {};
var _default = ModalBox;
exports["default"] = _default;

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssociatePerformance__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AssociateFilterContext__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssociateFilter__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AssociatePerformanceContext__ = __webpack_require__(287);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Associates=function(_Component){_inherits(Associates,_Component);function Associates(){_classCallCheck(this,Associates);return _possibleConstructorReturn(this,(Associates.__proto__||Object.getPrototypeOf(Associates)).apply(this,arguments));}_createClass(Associates,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__global_context_CapabilityContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AssociateFilterContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AssociateFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__context_AssociatePerformanceContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AssociatePerformance__["a" /* default */],null))));}}]);return Associates;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Associates);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_AssociatePerformanceContext__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AssociateFilterContext__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_context_CapabilityContext__ = __webpack_require__(20);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AssociatePerformance=function AssociatePerformance(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AssociateFilterContext__["a" /* AssociateFilterContext */]),states=_useContext2.states;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_AssociatePerformanceContext__["a" /* AssociatePerformanceContext */]),viewModel=_useContext3.viewModel,dispatch=_useContext3.dispatch;var getData=function getData(baseUrl){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch,baseUrl:baseUrl}});dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch,baseUrl:baseUrl,stationConfig:configViewModel.stationConfig}});};var getAssociateLink=function getAssociateLink(loginId){Object(__WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(documentUrl){var searchURL=new URL(documentUrl.toString().replace('associatestage','search'));var startDate=new Date();startDate.setHours(0,0,0,0);var endDate=new Date();endDate.setDate(startDate.getDate()+1);endDate.setHours(0,0,0,0);var optionsObj={"type":"ASSOCIATE","startDate":startDate.getTime(),"endDate":endDate.getTime()};var shareableLink="/detailPage/"+loginId+'/'+JSON.stringify(optionsObj);searchURL.searchParams.set("shareableLink",shareableLink);window.open(searchURL.href,"_blank");});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){var baseUrl=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["j" /* getBaseUrl */])(result);getData(baseUrl);var interval=setInterval(function(){getData(baseUrl);},Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["o" /* getRefreshInterval */])());return function(){return clearInterval(interval);};});},[]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedAssociatePerformance=[].concat(_toConsumableArray(viewModel.associatePerformance));sortedAssociatePerformance&&sortedAssociatePerformance.sort(function(a,b){if(a[viewModel.sortPref.column]<b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?-1:1;}if(a[viewModel.sortPref.column]>b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?1:-1;}return 0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{widths:["grid-11"],alignmentVertical:"top",spacingInset:"large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_heading___default.a,{level:2,type:"h400",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.associates",defaultMessage:"Associates"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"alias"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.associate",defaultMessage:"Associate"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"cartsPerHour",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.cartsPerHour",defaultMessage:"Carts Per Hour"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"hourSpent",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.hours",defaultMessage:"Hours"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"cartsHandled",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.totalCarts",defaultMessage:"Total Carts"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.active",defaultMessage:"Active"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"associate.location",defaultMessage:"Location"}))),sortedAssociatePerformance.map(function(associate){return states.length===0||states.includes(associate.active)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{key:associate.alias},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default.a,{onClick:function onClick(){return getAssociateLink(associate.loginId);},type:"secondary",target:"_blank",rel:"noreferrer noopener"},associate.alias)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},associate.cartsPerHour),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},associate.hourSpent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},associate.cartsHandled),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,associate.active),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,associate.location)):null;})))));};/* harmony default export */ __webpack_exports__["a"] = (AssociatePerformance);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociatePerformanceReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AssociateNetworkAPI__ = __webpack_require__(690);
var AssociatePerformanceReducer=function AssociatePerformanceReducer(state,action){switch(action.type){case"LOAD_VIEW":var _action$data=action.data,dispatcher=_action$data.dispatcher,baseUrl=_action$data.baseUrl,stationConfig=_action$data.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_AssociateNetworkAPI__["a" /* fetchAssociateMetrics */])(dispatcher,baseUrl,stationConfig);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data);case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAssociateMetrics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Logger__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handler_ParentDataHandler__ = __webpack_require__(26);
var getRouteInformation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,baseUrl,stationConfig){var response,output;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return getStationRoutes(baseUrl,stationConfig);case 3:response=_context.sent;output=response.data.routes;dispatcher({type:"RECEIVE_DATA",data:getStagersMetrics(output)});_context.next=12;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);__WEBPACK_IMPORTED_MODULE_6__util_Logger__["a" /* Logger */].error("Exception in AssociateNetworkAPI.getRouteInformation",_context.t0);Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["B" /* logErrorMetric */])(Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["d" /* ERROR_COUNT_METRIC */]);case 12:case"end":return _context.stop();}}},_callee,this,[[0,8]]);}));return function getRouteInformation(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var getStationRoutes=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(baseUrl,stationConfig){var startTime,stationCode,api,response,requestBody,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context2.prev=2;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["B" /* TIMEOUTS */].RSWS_GET_STATION_ROUTES_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context2.next=12;break;}requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)]};requestPayload={resourcePath:"/apigw/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),httpMethod:"get",processName:"routeStaging",requestParams:requestBody};_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_7__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 9:response=_context2.sent;_context2.next=15;break;case 12:_context2.next=14;return api.get("/rsws/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])()+"?date="+Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0));case 14:response=_context2.sent;case 15:if(!(response&&response.status===200)){_context2.next=20;break;}Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["a" /* ASSOCIATE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].SUCCESS);return _context2.abrupt("return",response);case 20:error={response:response};__WEBPACK_IMPORTED_MODULE_6__util_Logger__["a" /* Logger */].error("Exception in AssociateNetworkAPI.getStationRoutes",error);Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["a" /* ASSOCIATE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].FAILED,error);case 23:_context2.next=29;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](2);__WEBPACK_IMPORTED_MODULE_6__util_Logger__["a" /* Logger */].error("Exception in AssociateNetworkAPI.getStationRoutes",_context2.t0);Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["a" /* ASSOCIATE_TAB_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_4__util_MetricUtil__["g" /* MetricType */].FAILED,_context2.t0);case 29:return _context2.abrupt("return",null);case 30:case"end":return _context2.stop();}}},_callee2,this,[[2,25]]);}));return function getStationRoutes(_x4,_x5){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function fetchAssociateMetrics(dispatcher,baseUrl,stationConfig){getRouteInformation(dispatcher,baseUrl,stationConfig);}function getStagersMetrics(routes){var allCarts=[];routes.forEach(function(route){route.carts.forEach(function(cart){if(cart.assignee&&cart.status==="STAGED"){var index=cart.allAssignments.findIndex(function(assignment){return assignment.alias===cart.assignee;});if(index>=0&&cart.allAssignments[index].endTime){allCarts.push({loginId:cart.assignee,associate:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["i" /* formatAlias */])(cart.assignee),cart:cart.cartId,location:route.stagingLocation,startTime:cart.allAssignments[index].startTime,endTime:cart.allAssignments[index].endTime});}}});});var associateMap=allCarts.reduce(function(map,cart){if(map[cart.associate]){if(cart.startTime<map[cart.associate].startTime){map[cart.associate].startTime=cart.startTime;}if(cart.endTime>map[cart.associate].endTime){map[cart.associate].endTime=cart.endTime;map[cart.associate].location=cart.location;}map[cart.associate].cartsHandled++;}else{map[cart.associate]={loginId:cart.loginId,alias:cart.associate,cartsHandled:1,location:cart.location,startTime:cart.startTime,endTime:cart.endTime};}return map;},{});var associatePerformance=Object.values(associateMap).map(function(mapping){return{loginId:mapping.loginId,alias:mapping.alias,location:mapping.location,cartsHandled:mapping.cartsHandled,cartsPerHour:getCartsPerHour(mapping.startTime,mapping.endTime,mapping.cartsHandled),hourSpent:getAssociateDuration(mapping.startTime,mapping.endTime),active:getAssociateActiveStatus(mapping.endTime),inActivePeriod:"..."};});return{associatePerformance:associatePerformance};}function getCartsPerHour(startTime,endTime,cartsStaged){var durationInMillis=endTime-startTime;if(!durationInMillis){return 0;}return Math.ceil(cartsStaged*60/Math.ceil(durationInMillis/60000.0));}function getAssociateDuration(startTime,endTime){return Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["h" /* convertSecondsToTimeFormat */])((endTime-startTime)/1000);}// Active: if last scan was done in last 9 minutes
function getAssociateActiveStatus(endTime){if(!endTime){return"No";}var isActive=Date.now()-300000-endTime<=240000;return isActive?"Yes":"No";}

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateFilterReducer; });
var AssociateFilterReducer=function AssociateFilterReducer(state,action){switch(action.type){case'SELECT_STATE':return action.state;case'REMOVE_STATE':return state.filter(function(value){return value!==action.state;});default:return state;}};

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_AssociateFilterContext__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_checkbox__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(18);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AssociateFilter=function AssociateFilter(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_AssociateFilterContext__["a" /* AssociateFilterContext */]),states=_useContext.states,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),filterState=_useState2[0],setFilterState=_useState2[1];var toggleFilter=function toggleFilter(){setFilterState(!filterState);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"large large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default.a,{href:"",type:"secondary",onClick:toggleFilter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"associate.option",defaultMessage:"Options"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"filter-tag"},states.map(function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default.a,{key:state,onClose:function onClose(){return dispatch({type:'REMOVE_STATE',state:state});},type:"neutral"},state);})))),filterState?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"medium large",backgroundColor:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_control_group___default.a,{label:intl.formatMessage({id:'associate.active',defaultMessage:"Active"}),name:"state",onChange:function onChange(data){return dispatch({type:'SELECT_STATE',state:data});},value:states},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_checkbox___default.a,{key:"yes",value:"Yes"},"Yes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_checkbox___default.a,{key:"no",value:"No"},"No"))):null);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["d" /* injectIntl */])(AssociateFilter));

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _controlGroup = _interopRequireDefault(__webpack_require__(694));

var _default = _controlGroup["default"];
exports["default"] = _default;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(61));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(23));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _uniqueId = _interopRequireDefault(__webpack_require__(43));

var _uniq = _interopRequireDefault(__webpack_require__(695));

var _includes = _interopRequireDefault(__webpack_require__(271));

var _controlGroup = _interopRequireDefault(__webpack_require__(696));

var _theme = __webpack_require__(7);

var _token = __webpack_require__(8);

var _fieldsetReset = _interopRequireDefault(__webpack_require__(276));

var _text = _interopRequireDefault(__webpack_require__(22));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(t) {
  return (0, _emotion.css)(_fieldsetReset["default"], {
    display: "flex",
    flexDirection: "column",
    // Don't stretch children - otherwise you may end up with a lot of
    // clickable whitespace in the label if the control group is wider than the
    // label.
    alignItems: "flex-start",
    "& > * + *": {
      marginTop: t("spacingVertical")
    }
  });
};

var labelStyles = function labelStyles(t, _ref) {
  var disabled = _ref.disabled,
      clickable = _ref.clickable;
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: disabled ? "disabled" : "default"
  }), {
    cursor: clickable ? disabled ? "not-allowed" : "pointer" : "default"
  });
};

var ControlGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ControlGroup, _React$Component);

  var _super = _createSuper(ControlGroup);

  function ControlGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("control-group-"));
    return _this;
  }

  (0, _createClass2["default"])(ControlGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          value = _this$props.value,
          name = _this$props.name,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      var valueIsArray = Array.isArray(value) ? true : false;

      var renderChildren = _react["default"].Children.map(children, function (child) {
        return child ? /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread({
          checked: valueIsArray ? (0, _includes["default"])(value, child.props.value) : child.props.value === value,
          onChange: valueIsArray ? function (checked) {
            return onChange(checked ? (0, _uniq["default"])([].concat((0, _toConsumableArray2["default"])(value), [child.props.value])) : value.filter(function (v) {
              return v !== child.props.value;
            }));
          } : onChange,
          disabled: disabled,
          name: name
        }, child.props)) : null;
      });

      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _controlGroup["default"],
        map: (0, _token.getTokenHelper)("controlGroup")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("fieldset", (0, _extends2["default"])({}, passThroughProps, {
          className: styles(t)
        }), label ? /*#__PURE__*/_react["default"].createElement("legend", {
          className: labelStyles(t, {
            disabled: disabled
          })
        }, label) : null, renderChildren);
      });
    }
  }]);
  return ControlGroup;
}(_react["default"].Component);

ControlGroup.propTypes =  false ? {
  /**
   * All children must be elements of the same type (e.g. all Checkbox
   * elements or all RadioButton elements). Any element that supports `value`,
   * `onChange`, `checked`, `disabled`, and `name` props may be used.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with all the components in the control group
   * and applies special visual styles to indicate that they are not
   * interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The label for the control group.
   */
  label: _propTypes["default"].string,

  /**
   * The name of the form control for each component contained in the group.
   * If the group is placed in a form, this will be the name associated with
   * the group's controls when the form is submitted.
   *
   * Any names set explicitly on individual components in the group will
   * override this property.
   */
  name: _propTypes["default"].string,

  /**
   * The current value of the group.
   *
   * Match this with the value(s) of controls options within the group to mark
   * those controls as checked.
   *
   * If this is an array then the group will allow multiple controls to be
   * checked (e.g. a group of checkboxes). If this is a single value then the
   * group will only allow one control to be checked (e.g. a group of radio
   * buttons).
   *
   * Note that this prop is not required, but if you do not use it you must
   * use the `checked` props on the individual controls within the group.
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by clicking on a control in the group). The new
   * value will be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   *
   * Note that this prop is not required, but if you do not use it you must
   * use the `onChange` props on the individual controls within the group.
   */
  onChange: _propTypes["default"].func
} : {};
var _default = ControlGroup;
exports["default"] = _default;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(243);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 696 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    controlGroupForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    controlGroupForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    controlGroupFontSize: 16,
    controlGroupFontWeight: 600,
    controlGroupLineHeight: "20px",
    controlGroupSpacingVertical: 8
  }
};

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartInfo__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartContent__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_CartDetailContext__ = __webpack_require__(157);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartDetailComponent=function(_Component){_inherits(CartDetailComponent,_Component);function CartDetailComponent(){_classCallCheck(this,CartDetailComponent);return _possibleConstructorReturn(this,(CartDetailComponent.__proto__||Object.getPrototypeOf(CartDetailComponent)).apply(this,arguments));}_createClass(CartDetailComponent,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__global_context_CapabilityContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_CartDetailContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CartInfo__["a" /* default */],{cart:this.props.match.params}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CartContent__["a" /* default */],null)));}}]);return CartDetailComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CartDetailComponent);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_CartDetailContext__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_context_CapabilityContext__ = __webpack_require__(20);
var CartInfo=function CartInfo(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_CartDetailContext__["a" /* CartDetailContext */]),dispatch=_useContext2.dispatch;var getPhoneToolLink=function getPhoneToolLink(){var alias=props.cart.associate;return alias.includes('@')?"https://phonetool.amazon.com/users/"+alias.split("@")[0]:"#";};var getCartData=function getCartData(){Object(__WEBPACK_IMPORTED_MODULE_7__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){dispatch({type:'LOAD_VIEW',data:{routeId:props.cart.routeId,cartId:props.cart.cartId,stationCode:props.cart.stationCode,dispatcher:dispatch,baseUrl:Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["j" /* getBaseUrl */])(result),stationConfig:configViewModel.stationConfig}});});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getCartData();var interval=setInterval(function(){getCartData();},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["o" /* getRefreshInterval */])());return function(){return clearInterval(interval);};},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"large large small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb__["BreadcrumbGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb___default.a,{href:"#stage"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.stage",defaultMessage:"Stage"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_breadcrumb___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.cartDetail",defaultMessage:"Cart Details"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"small large small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_heading___default.a,{level:3,type:"h600",alignment:"left"},props.cart.cartId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-2","grid-10"],alignmentVertical:"top",spacingInset:"medium large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"b200"},props.cart.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-2","grid-10"],alignmentVertical:"top",spacingInset:"medium large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.location",defaultMessage:"Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"b200"},props.cart.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-2","grid-10"],alignmentVertical:"top",spacingInset:"medium large none large"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartInfo.associate",defaultMessage:"Associate"})),props.cart.associate!=='...'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default.a,{href:getPhoneToolLink(),type:"secondary",target:"_blank",rel:"noreferrer noopener"},props.cart.associate):'...'));};/* harmony default export */ __webpack_exports__["a"] = (CartInfo);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartDetailReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__ = __webpack_require__(66);
var CartDetailReducer=function CartDetailReducer(state,action){switch(action.type){case"LOAD_VIEW":var _action$data=action.data,routeId=_action$data.routeId,cartId=_action$data.cartId,dispatcher=_action$data.dispatcher,baseUrl=_action$data.baseUrl,stationCode=_action$data.stationCode,stationConfig=_action$data.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__["b" /* fetchRouteContent */])(routeId,cartId,dispatcher,baseUrl,stationCode,stationConfig);return state;case"UNLOAD_VIEW":return state;case"RECEIVE_DATA":return Object.assign({},state,action.data);default:return state;}};

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_CartDetailContext__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(18);
var CartContent=function CartContent(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_CartDetailContext__["a" /* CartDetailContext */]),viewModel=_useContext.viewModel;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{widths:"100%",spacingInset:"large large small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_heading___default.a,{level:3,type:"h500",alignment:"left"},viewModel.name)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{widths:["grid-7"],spacingInset:"small large small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{headerRows:1,showDividers:false,headerColumns:1,fixHeaderRows:true,stickyHeaderColumn:true,stickyHeaderRow:true,spacing:"small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.location",defaultMessage:"Location"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.picked",defaultMessage:"Picked"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.staged",defaultMessage:"Staged"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.departed",defaultMessage:"Departed"}))),viewModel.bags.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableSectionHeader"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.bags",defaultMessage:"Bags"}),": ",viewModel.bags.length):null,viewModel.bags.map(function(bag){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:bag.label},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,bag.label),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,bag.location),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,bag.picked?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,bag.staged?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,bag.departed?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))));}),viewModel.packages.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableSectionHeader"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"cartContent.packages",defaultMessage:"Packages"}),": ",viewModel.packages.length):null,viewModel.packages.map(function(packages){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:packages.label},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,packages.label),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,packages.location),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,packages.picked?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,packages.staged?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,packages.departed?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-success",tokens:__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tokens_base_icon_check_large___default.a}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{className:"picked-failed",tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_close___default.a}))));}))));};/* harmony default export */ __webpack_exports__["a"] = (CartContent);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_DepartContext__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepartView__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_DepartFilterContext__ = __webpack_require__(89);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Depart=function(_Component){_inherits(Depart,_Component);function Depart(){_classCallCheck(this,Depart);return _possibleConstructorReturn(this,(Depart.__proto__||Object.getPrototypeOf(Depart)).apply(this,arguments));}_createClass(Depart,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__global_context_CapabilityContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_DepartFilterContext__["b" /* default */],{context:this.props.match.params.context},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_DepartContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DepartView__["a" /* default */],null))));}}]);return Depart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Depart);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepartReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_CacheManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(10);
var DepartReducer=function DepartReducer(state,action){switch(action.type){case"LOAD_VIEW":var _action$data=action.data,dispatcher=_action$data.dispatcher,filterDispatcher=_action$data.filterDispatcher,xptNodes=_action$data.xptNodes,capability=_action$data.capability,stationConfig=_action$data.stationConfig;var metricKey=Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */];//try to load data from cache if xpt filters and ttl is valid.
if(Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["c" /* isRouteCacheValid */])(xptNodes)){var _getDataWithExpiry=Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["a" /* getDataWithExpiry */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]),cachedData=_getDataWithExpiry.cachedData,lastUpdated=_getDataWithExpiry.lastUpdated;Object(__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["A" /* logCounterMetric */])(Object(__WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__["a" /* getStationCode */])(),metricKey,__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["h" /* ROUTE_CACHE_HIT_METRIC */]);dispatcher({type:"RECEIVE_DATA",data:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__["d" /* getRouteData */])(cachedData.response.routes,capability,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:Object(__WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__["c" /* getFilterData */])(cachedData.response.routes,capability)});return state;}else{Object(__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["A" /* logCounterMetric */])(Object(__WEBPACK_IMPORTED_MODULE_4__network_NetworkUtil__["a" /* getStationCode */])(),metricKey,__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["i" /* ROUTE_CACHE_MISS_METRIC */]);}Object(__WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__["b" /* fetchRouteInformation */])(action.data,capability);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data);case"UPDATE_ROUTE_DATA_CACHE":{Object(__WEBPACK_IMPORTED_MODULE_1__util_CacheManager__["d" /* setDataWithExpiry */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */],action.data);return state;}case"UPDATE_ROUTE_STATUS":{var _action$data2=action.data,_dispatcher=_action$data2.dispatcher,routeId=_action$data2.routeId,baseUrl=_action$data2.baseUrl,_stationConfig=_action$data2.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__["e" /* updateRouteStatusToReadyForDispatch */])({dispatcher:_dispatcher,routeId:routeId,baseUrl:baseUrl,stationConfig:_stationConfig,additionalData:action.data});return state;}case __WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_UPDATE_ROUTE_STATUS_MODAL:{return Object.assign({},state,action.data);}case __WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_UPDATE_ROUTE_STATUS:{var _action$data3=action.data,_dispatcher2=_action$data3.dispatcher,routeIds=_action$data3.routeIds,_baseUrl=_action$data3.baseUrl,_stationConfig2=_action$data3.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__network_DepartNetworkAPI__["a" /* bulkUpdateRouteStatusToReadyForDispatch */])({dispatcher:_dispatcher2,routeIds:routeIds,baseUrl:_baseUrl,stationConfig:_stationConfig2,additionalData:action.data});return state;}case"SUCCESS_NOTIFICATION":return Object.assign({},state,action.data);case"FAILURE_NOTIFICATION":return Object.assign({},state,action.data);case"REMOVE_NOTIFICATION":var notification={alert:{}};return Object.assign({},state,notification);case __WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_SUCCESS_NOTIFICATION_UPDATE:return Object.assign({},state,action.data);case __WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].CLOSE_BULK_UPDATE_NOTIFICATION:var bulkDepartStatus={bulkDepartStatus:null};return Object.assign({},state,bulkDepartStatus);default:return state;}};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchRouteInformation;
/* harmony export (immutable) */ __webpack_exports__["a"] = bulkUpdateRouteStatusToReadyForDispatch;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateRouteStatusToReadyForDispatch;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRouteData;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFilterData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stageStatus_network_StageNetworkAPI__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Logger__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_CacheManager__ = __webpack_require__(80);
var getRouteInformation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(args,capability){var dispatcher,filterDispatcher,baseUrl,xptNodes,configDispatch,stationConfig,startTime,stationCode,metricKey,api,response,requestPayload,output,lastUpdated,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatcher=args.dispatcher,filterDispatcher=args.filterDispatcher,baseUrl=args.baseUrl,xptNodes=args.xptNodes,configDispatch=args.configDispatch,stationConfig=args.stationConfig;startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();metricKey=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */];_context.prev=4;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["B" /* TIMEOUTS */].RSWS_GET_STATION_ROUTES_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context.next=13;break;}requestPayload=getRouteRequestPayload(xptNodes);_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 10:response=_context.sent;_context.next=16;break;case 13:_context.next=15;return api.get(getRouteRequestURL(xptNodes));case 15:response=_context.sent;case 16:if(response&&response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);output=response.data.routes;lastUpdated=new Date().getTime();dispatcher({type:"UPDATE_ROUTE_DATA_CACHE",data:{record:{response:response.data,xptNodes:xptNodes,stationCode:stationCode},lastUpdated:lastUpdated}});dispatcher({type:"RECEIVE_DATA",data:Object.assign({},getRouteData(output,capability,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:getFilterData(output,capability)});configDispatch({type:'RECEIVE_REFRESH_INTERVAL',data:{refreshInterval:response.data.routeRefreshRate}});}else{error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.getRouteInformation",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context.next=23;break;case 19:_context.prev=19;_context.t0=_context["catch"](4);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.getRouteInformation",_context.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["p" /* RSWS_ROUTE_LIST_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context.t0);case 23:case"end":return _context.stop();}}},_callee,this,[[4,19]]);}));return function getRouteInformation(_x,_x2){return _ref.apply(this,arguments);};}();/** Batch get route information for give route code **/var batchGetRouteContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(routeIds,baseUrl,stationCode,stationConfig){var startTime,metricKey,api,response,requestBody,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();metricKey=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */];_context2.prev=2;api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});requestBody={"date":Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0),"routeIds":routeIds};if(!(stationConfig&&stationConfig.authEnabled)){_context2.next=12;break;}requestPayload={resourcePath:"/apigw/stationCode/"+stationCode+"/routes-batch",httpMethod:"post",processName:"routeStaging",requestParams:requestBody};_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 9:response=_context2.sent;_context2.next=15;break;case 12:_context2.next=14;return api.post("/rsws/stationCode/"+stationCode+"/routes-batch",requestBody);case 14:response=_context2.sent;case 15:if(!(response&&response.status===200)){_context2.next=20;break;}Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["j" /* RSWS_BATCH_ROUTE_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);return _context2.abrupt("return",response.data);case 20:error={response:response};__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.batchGetRouteContent",error);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["j" /* RSWS_BATCH_ROUTE_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);case 23:_context2.next=29;break;case 25:_context2.prev=25;_context2.t0=_context2["catch"](2);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.batchGetRouteContent",_context2.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["j" /* RSWS_BATCH_ROUTE_DETAILS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context2.t0);case 29:case"end":return _context2.stop();}}},_callee2,this,[[2,25]]);}));return function batchGetRouteContent(_x3,_x4,_x5,_x6){return _ref2.apply(this,arguments);};}();/**
 * Function to fetch Routes Information for AMXL Stations
 * @param args
 * @returns {Promise<void>}
 */var getAMXLRoutes=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(args,capability){var dispatcher,filterDispatcher,baseUrl,xptNodes,configDispatch,stationConfig,startTime,stationCode,metricKey,request,gatewayRequest,response,routeIdToRouteMap,routeIds,enrichedRouteInfo,routeIdToEnrichDataMap,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,routeId,amxlRoutes,lastUpdated;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatcher=args.dispatcher,filterDispatcher=args.filterDispatcher,baseUrl=args.baseUrl,xptNodes=args.xptNodes,configDispatch=args.configDispatch,stationConfig=args.stationConfig;startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();metricKey=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */];request={filters:{NODE:[Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])()]},fieldsRequired:["ID","CODE","PLANNED_COUNT","CPT"]};_context3.prev=5;gatewayRequest=getStowRouteAPIGatewayRequest(request);_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(gatewayRequest);case 9:response=_context3.sent;if(!(response.status===200)){_context3.next=44;break;}Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["x" /* SVS_ROUTE_DATA_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);routeIdToRouteMap=response.data.routes.reduce(function(a,v){return Object.assign({},a,_defineProperty({},v.id,v));},{});routeIds=Object.keys(routeIdToRouteMap);_context3.next=16;return batchGetRouteContent(routeIds,baseUrl,stationCode,stationConfig);case 16:enrichedRouteInfo=_context3.sent;routeIdToEnrichDataMap=enrichedRouteInfo?enrichedRouteInfo.routes.reduce(function(a,v){return Object.assign({},a,_defineProperty({},v.routeId,v));},{}):null;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context3.prev=21;for(_iterator=routeIds[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){routeId=_step.value;routeIdToRouteMap[routeId].routeCode=routeIdToRouteMap[routeId].code;routeIdToRouteMap[routeId].routeId=routeIdToRouteMap[routeId].id;routeIdToRouteMap[routeId].stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();routeIdToRouteMap[routeId].type=routeIdToRouteMap[routeId].code.includes('_')?routeIdToRouteMap[routeId].code.split('_')[0]:routeIdToRouteMap[routeId].code.substring(0,2);routeIdToRouteMap[routeId].criticalPullTime=routeIdToRouteMap[routeId].cpt;//enrich containers, status and driver etc. information from RSWS
if(routeIdToEnrichDataMap&&routeId in routeIdToEnrichDataMap){routeIdToRouteMap[routeId].departProgress=routeIdToEnrichDataMap[routeId].departProgress;routeIdToRouteMap[routeId].stowProgress=routeIdToEnrichDataMap[routeId].stowProgress;routeIdToRouteMap[routeId].routeStatus=getAMXLDepartStatus(routeIdToEnrichDataMap[routeId].stowProgress,routeIdToEnrichDataMap[routeId].departProgress);routeIdToRouteMap[routeId].driver=routeIdToEnrichDataMap[routeId].driver;routeIdToRouteMap[routeId].stagingLocation=routeIdToEnrichDataMap[routeId].stagingLocation;routeIdToRouteMap[routeId].stagingLocations=routeIdToEnrichDataMap[routeId].stagingLocations;}}_context3.next=29;break;case 25:_context3.prev=25;_context3.t0=_context3["catch"](21);_didIteratorError=true;_iteratorError=_context3.t0;case 29:_context3.prev=29;_context3.prev=30;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 32:_context3.prev=32;if(!_didIteratorError){_context3.next=35;break;}throw _iteratorError;case 35:return _context3.finish(32);case 36:return _context3.finish(29);case 37:amxlRoutes=Object.values(routeIdToRouteMap);lastUpdated=new Date().getTime();response.data.routes=amxlRoutes;dispatcher({type:"UPDATE_ROUTE_DATA_CACHE",data:{record:{response:response.data,xptNodes:xptNodes,stationCode:stationCode},lastUpdated:lastUpdated}});dispatcher({type:"RECEIVE_DATA",data:Object.assign({},getRouteData(amxlRoutes,capability,stationConfig),{lastUpdated:lastUpdated})});filterDispatcher({type:"RECEIVE_FILTER_DATA",data:getFilterData(amxlRoutes,capability)});configDispatch({type:'RECEIVE_REFRESH_INTERVAL',data:{refreshInterval:enrichedRouteInfo.routeRefreshRate}});case 44:_context3.next=50;break;case 46:_context3.prev=46;_context3.t1=_context3["catch"](5);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.getAMXLRoutes",_context3.t1);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["x" /* SVS_ROUTE_DATA_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context3.t1);case 50:case"end":return _context3.stop();}}},_callee3,this,[[5,46],[21,25,29,37],[30,,32,36]]);}));return function getAMXLRoutes(_x7,_x8){return _ref3.apply(this,arguments);};}();/**
 * Function to update RouteStatus
 * @param args
 * @returns {Promise<void>}
 */var updateRouteStatusToReadyForDispatchRequest=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(args){var dispatcher,routeId,baseUrl,stationConfig,additionalData,metricKey,startTime,stationCode,requestBody,api,response,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatcher=args.dispatcher,routeId=args.routeId,baseUrl=args.baseUrl,stationConfig=args.stationConfig,additionalData=args.additionalData;metricKey=__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN;startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();_context4.prev=4;requestBody={"stationCode":stationCode,"operationType":"ROUTE_READY_FOR_DISPATCH","requestAttributes":{"routeId":[routeId]}};api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});if(!(stationConfig&&stationConfig.authEnabled)){_context4.next=14;break;}requestPayload={resourcePath:"/apigw/execute-operation/",httpMethod:"post",processName:"routeStaging",requestBody:requestBody};_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 11:response=_context4.sent;_context4.next=17;break;case 14:_context4.next=16;return api.post("/rsws/execute-operation/",requestBody);case 16:response=_context4.sent;case 17:if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);Object(__WEBPACK_IMPORTED_MODULE_11__util_CacheManager__["e" /* updateRouteToStowedInCacheOnReadyForDispatch */])(routeId);dispatcher({type:"LOAD_VIEW",data:additionalData});dispatcher({type:"SUCCESS_NOTIFICATION",data:{alert:{title:"Route marked ready to Depart",type:"success"}}});}else{error={response:response};Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);dispatcher({type:"FAILURE_NOTIFICATION",data:{alert:{title:response.data.errorMessage,type:"error"}}});}_context4.next=25;break;case 20:_context4.prev=20;_context4.t0=_context4["catch"](4);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.updateRouteStatus",_context4.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context4.t0);dispatcher({type:"FAILURE_NOTIFICATION",data:{alert:{title:_context4.t0.message,type:"error"}}});case 25:case"end":return _context4.stop();}}},_callee4,this,[[4,20]]);}));return function updateRouteStatusToReadyForDispatchRequest(_x9){return _ref4.apply(this,arguments);};}();/**
 * Function to update RouteStatus for multiple route ids - IN Bulk Depart
 * @param args
 * @returns {Promise<void>}
 */var bulkUpdateRouteStatusToReadyForDispatchRequest=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(args){var dispatcher,routeIds,baseUrl,stationConfig,additionalData,failureIds,successIds,key,routeData,routeId,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatcher=args.dispatcher,routeIds=args.routeIds,baseUrl=args.baseUrl,stationConfig=args.stationConfig,additionalData=args.additionalData;failureIds=[];successIds=[];//Open Modal with Loading symbol for all routes
updateBulkDepartModal(dispatcher,successIds,failureIds,routeIds);_context5.t0=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(routeIds);case 5:if((_context5.t1=_context5.t0()).done){_context5.next=16;break;}key=_context5.t1.value;routeData=routeIds[key];routeId=routeData.routeId;// Depart the route
_context5.next=11;return markRouteAsDeparted(routeId,baseUrl,stationConfig);case 11:response=_context5.sent;if(response){successIds.push(routeId);}else{failureIds.push(routeId);}// Update Route status
updateBulkDepartModal(dispatcher,successIds,failureIds,routeIds);_context5.next=5;break;case 16:// Reload view - after all are marked
dispatcher({type:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].LOAD_VIEW,data:additionalData});case 17:case"end":return _context5.stop();}}},_callee5,this);}));return function bulkUpdateRouteStatusToReadyForDispatchRequest(_x10){return _ref5.apply(this,arguments);};}();/**
 * Fire a dispatcher to update bulk depart modal with success, failure ids
 * @param dispatcher DepartReducer
 * @param successIds List of successful routes
 * @param failureIds List of failed routes
 * @param routeIds List of all routes
 *//**
 * Makes an API request to mark the route as departed
 * @param routeId - Route Id to depart
 * @param baseUrl - Url for the endpoint
 * @param stationConfig - Station Configuration
*/var markRouteAsDeparted=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(routeId,baseUrl,stationConfig){var metricKey,startTime,stationCode,requestSuccess,requestBody,api,response,requestPayload,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:metricKey=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */];startTime=Date.now();stationCode=Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();requestSuccess=false;_context6.prev=4;requestBody={"stationCode":stationCode,"operationType":__WEBPACK_IMPORTED_MODULE_6__util_Constants__["s" /* OPERATION_TYPES */].ROUTE_READY_FOR_DISPATCH,"requestAttributes":{"routeId":[routeId]}};api=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,timeout:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["B" /* TIMEOUTS */].RSWS_DEFAULT_API_TIMEOUT});// If auth is enabled - use api gateway else use post endpoint
if(!(stationConfig&&stationConfig.authEnabled)){_context6.next=14;break;}requestPayload={resourcePath:"/apigw/execute-operation/",httpMethod:"post",processName:"routeStaging",requestBody:requestBody};_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_10__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(requestPayload);case 11:response=_context6.sent;_context6.next=17;break;case 14:_context6.next=16;return api.post("/rsws/execute-operation/",requestBody);case 16:response=_context6.sent;case 17:if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].SUCCESS);Object(__WEBPACK_IMPORTED_MODULE_11__util_CacheManager__["e" /* updateRouteToStowedInCacheOnReadyForDispatch */])(routeId);requestSuccess=true;}else{error={response:response};Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,error);}_context6.next=24;break;case 20:_context6.prev=20;_context6.t0=_context6["catch"](4);__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.updateRouteStatus",_context6.t0);Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["C" /* logOperationalMetric */])(startTime,stationCode,metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["u" /* RSWS_UPDATE_ROUTE_STATUS_METRIC */],__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["g" /* MetricType */].FAILED,_context6.t0);case 24:return _context6.abrupt("return",requestSuccess);case 25:case"end":return _context6.stop();}}},_callee6,this,[[4,20]]);}));return function markRouteAsDeparted(_x11,_x12,_x13){return _ref6.apply(this,arguments);};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Fetch Route List **/function fetchRouteInformation(args,capability){args.stationConfig.amxl?getAMXLRoutes(args,capability):getRouteInformation(args,capability);}/** Bulk Updates Route Status to Ready For Dispatch **/function bulkUpdateRouteStatusToReadyForDispatch(args){bulkUpdateRouteStatusToReadyForDispatchRequest(args);}/** Updates Route Status to Ready For Dispatch **/function updateRouteStatusToReadyForDispatch(args){updateRouteStatusToReadyForDispatchRequest(args);}function getRouteRequestPayload(xptNodes){var mainUri="/apigw/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])();if(Array.isArray(xptNodes)&&xptNodes.length){var nodeList=[].concat(_toConsumableArray(xptNodes));var requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)],"nodes":[nodeList.join(",")]};var requestPayload={resourcePath:mainUri,httpMethod:"get",processName:"routeStaging",requestParams:requestBody};return requestPayload;}else{var _requestBody={"date":[Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0)]};var _requestPayload={resourcePath:mainUri,httpMethod:"get",processName:"routeStaging",requestParams:_requestBody};return _requestPayload;}}function getStowRouteAPIGatewayRequest(request){return{resourcePath:"/svs/routes/data",httpMethod:"post",processName:"stow",requestBody:request};}function getAMXLDepartStatus(stowProgress,departProgress){if(departProgress!=null&&departProgress.completedCount===departProgress.totalCount&&departProgress.completedCount>0)return __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["b" /* DEPARTED */];if(departProgress!=null&&0<departProgress.completedCount)return __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["g" /* PARTIALLY_DEPARTED */];if(stowProgress!=null&&stowProgress.completedCount===stowProgress.totalCount&&stowProgress.completedCount>0)return __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["j" /* READY */];return __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["f" /* NOT_READY */];}function updateBulkDepartModal(dispatcher,successIds,failureIds,routeIds){dispatcher({type:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_SUCCESS_NOTIFICATION_UPDATE,data:{bulkDepartStatus:{successIds:successIds,failureIds:failureIds,routeIds:routeIds}}});}function getRouteRequestURL(xptNodes){var mainUri="/rsws/route/station/"+Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])()+"?date="+Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["l" /* getDateInMMDDYYYYWithOffset */])(0);if(Array.isArray(xptNodes)&&xptNodes.length){var nodeList=[].concat(_toConsumableArray(xptNodes));return mainUri+"&nodes="+nodeList.join(",");}else{return mainUri;}}function getRouteData(output,capability,stationConfig){var model={totalRoute:output.length,partialDepartedRoutes:0,departedRoutes:0,routeList:[]};output=Object(__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["A" /* handleUnassignedRoutes */])(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["e" /* CORE_AMZL */],output);output.forEach(function(route){switch(route.routeStatus){case"Departed":model.departedRoutes++;break;case"Departed (partial)":model.partialDepartedRoutes++;break;default:break;}try{route.criticalPullTime=Object(__WEBPACK_IMPORTED_MODULE_5__stageStatus_network_StageNetworkAPI__["e" /* getDispatchTime */])(route,__WEBPACK_IMPORTED_MODULE_6__util_Constants__["e" /* CORE_AMZL */]);route.stagingLocations=Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["d" /* transformStagingLocations */])(route);var routeDetail={routeId:route.routeId,routeCode:route.routeCode,routeType:route.type,stationCode:route.stationCode,routeSLA:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["g" /* convertMillisecondsToHHMM */])(route.criticalPullTime),routeStatus:Object(__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["u" /* getRouteStatus */])(route,stationConfig),status:Object(__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["r" /* getDepartStatus */])(route,capability),hazmatWeight:route.hazmatWeight?route.hazmatWeight:"...",departProgress:getDepartProgress(route,capability),stagingLocations:route.stagingLocations,stagingLocation:Object(__WEBPACK_IMPORTED_MODULE_8__util_DataTransformUtil__["c" /* getRouteStagingLocation */])(route),picker:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["i" /* formatAlias */])(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["n" /* getLatestPicker */])(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["e" /* CORE_AMZL */],route)),driver:route.driver&&route.driver.name?route.driver.name:"...",totalCarts:route.carts?route.carts.length:0,departByTime:route.plannedDispatchTime?getDepartByTime(route.plannedDispatchTime,capability):"...",stowProgress:getStowProgress(route,capability),topOffPackageCount:route.topOffPackageCount?route.topOffPackageCount:0,sectorCodes:route.sectorCodes?route.sectorCodes.join(', '):''};model.routeList.push(routeDetail);}catch(e){__WEBPACK_IMPORTED_MODULE_9__util_Logger__["a" /* Logger */].error("Exception in DepartNetworkAPI.getRouteData",e);var metricKey=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN?__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */]+"_"+__WEBPACK_IMPORTED_MODULE_6__util_Constants__["v" /* REGION */].IN:__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */];Object(__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["B" /* logErrorMetric */])(Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),metricKey,__WEBPACK_IMPORTED_MODULE_7__util_MetricUtil__["d" /* ERROR_COUNT_METRIC */]);}});return model;}function getDepartByTime(plannedDispatchTime,capability){return typeof plannedDispatchTime==="number"&&Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["x" /* isNotSSDAndINRegion */])(capability)?Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["g" /* convertMillisecondsToHHMM */])(plannedDispatchTime*__WEBPACK_IMPORTED_MODULE_6__util_Constants__["r" /* MILLIS_IN_SECOND */]):Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["g" /* convertMillisecondsToHHMM */])(plannedDispatchTime);}/**
 * method to get DepartProgress
 * @param route
 * @param capability
 * @returns {string|string}
 */function getDepartProgress(route,capability){if(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["x" /* isNotSSDAndINRegion */])(capability)){return route.departProgress;}return route.departProgress?route.departProgress.completedCount+"/"+route.departProgress.totalCount:"0/0";}function getStowProgress(route,capability){if(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["w" /* isNotINRegionOrSSD */])(capability)){return route.stowProgress;}return route.stowProgress.completedCount+"/"+route.stowProgress.totalCount;}function getFilterData(output,capability){var data={departure:new Set(),driverType:new Set(["DSP","DP"]),cluster:new Set(),departByTime:new Set()};output.forEach(function(route){if(route.type!=="..."){data.driverType.add(route.type);}data.cluster.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["k" /* getCluster */])(route.routeCode));if(route.criticalPullTime!=null){data.departure.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["g" /* convertMillisecondsToHHMM */])(route.criticalPullTime));}if(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["x" /* isNotSSDAndINRegion */])(capability)&&route.plannedDispatchTime!=="..."&&typeof route.plannedDispatchTime==="number"){data.departByTime.add(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["g" /* convertMillisecondsToHHMM */])(route.plannedDispatchTime*__WEBPACK_IMPORTED_MODULE_6__util_Constants__["r" /* MILLIS_IN_SECOND */]));}});return data;}

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepartOverallStatus__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepartTable__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PageHeader__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DepartFilterWrapper__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_MobileDisplay__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alert_DepartAlertView__ = __webpack_require__(716);
var DepartView=function DepartView(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext.configViewModel,configDispatch=_useContext.configDispatch;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__handler_ParentDataHandler__["c" /* getDocumentURL */])(),Object(__WEBPACK_IMPORTED_MODULE_5__handler_ParentDataHandler__["f" /* getNodeCapability */])()]).then(function(result){//const result = ["https://logistics.amazon.co.uk",{capability: "\""+CORE_AMZL+"\""}];
var model={capability:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["D" /* parseCapabilitiesResponse */])(result[1]),baseUrl:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["j" /* getBaseUrl */])(result[0])};configDispatch({type:'GET_CAPABILITIES',data:model});configDispatch({type:'GET_STATION_CONFIG',data:{dispatcher:configDispatch,baseUrl:model.baseUrl}});});},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,configViewModel.capability&&configViewModel.stationConfig.initialised?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_MobileDisplay__["a" /* MobileDisplay */],{visibility:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__alert_DepartAlertView__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_PageHeader__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__util_Constants__["t" /* PAGE_HEADERS */].DEPART),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DepartFilterWrapper__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DepartOverallStatus__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DepartTable__["a" /* default */],null)):null);};/* harmony default export */ __webpack_exports__["a"] = (DepartView);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_DepartContext__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_DepartFilterContext__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stageStatus_StageStatusViewV2__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stageStatus_ActionableMetricView__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ScrollableElementWrapper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_context_CapabilityContext__ = __webpack_require__(20);
var DepartOverallStatus=function DepartOverallStatus(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_DepartContext__["a" /* DepartContext */]),viewModel=_useContext.viewModel;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_DepartFilterContext__["a" /* DepartFilterContext */]),viewModelF=_useContext2.viewModelF,dispatchF=_useContext2.dispatchF;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext3.configViewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_9__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand4=_useDeviceLayout.spacingInset_shorthand4;var routeList=Array.from(viewModel.routeList);var filterOption=function filterOption(route,filter,key){if(viewModelF[filter].length===0){return true;}var result=false;viewModelF[filter].forEach(function(filterValue){if(!route[key]||filter==="status"&&route[key]===filterValue||filter!=="status"&&route[key].includes(filterValue)){result=true;}});return result;};routeList=routeList.filter(function(route){return filterOption(route,"cluster","routeCode");}).filter(function(route){return filterOption(route,"driverType","routeType");}).filter(function(route){return filterOption(route,"departure","routeSLA");}).filter(function(route){return filterOption(route,"status","status");}).filter(function(route){return filterOption(route,"departByTime","departByTime");});var getDepartMetrics=function getDepartMetrics(routes){var metrics={totalRoutes:routes.length,notReadyRoutes:0,readyRoutes:0,partialDepartedRoutes:0,departedRoutes:0};routes.forEach(function(route){switch(route.status){case __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].DEPARTED:metrics.departedRoutes++;break;case __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].PARTIALLY_DEPARTED:metrics.partialDepartedRoutes++;break;case __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].READY:metrics.readyRoutes++;break;case __WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].NOT_READY:metrics.notReadyRoutes++;break;default:break;}});return metrics;};var departMetrics=getDepartMetrics(routeList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{wrap:"down",spacingInset:spacingInset_shorthand4,spacing:"medium",width:"100%",alignmentVertical:"stretch"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__stageStatus_StageStatusViewV2__["a" /* default */],{stageStatus:{title:"depart.totalRoutes",message:"Total routes",value:departMetrics.totalRoutes}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ScrollableElementWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",spacing:"large",alignmentVertical:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__stageStatus_ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].NOT_READY]});},stageStatus:{title:"depart.notReady",message:"Not ready",value:departMetrics.notReadyRoutes}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__stageStatus_ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].READY]});},stageStatus:{title:"depart.ready",message:"Ready",value:departMetrics.readyRoutes}}),Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__stageStatus_ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].PARTIALLY_DEPARTED]});},stageStatus:{title:"depart.partiallyDeparted",message:"Partially departed",value:departMetrics.partialDepartedRoutes}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__stageStatus_ActionableMetricView__["a" /* default */],{onMetricCountClick:function onMetricCountClick(){return dispatchF({type:'SELECT_STATUS',status:[__WEBPACK_IMPORTED_MODULE_4__util_EntityStatusManager__["c" /* DEPART_STATUS */].DEPARTED]});},stageStatus:{title:"cartContent.departed",message:"Departed",value:departMetrics.departedRoutes}})))));};/* harmony default export */ __webpack_exports__["a"] = (DepartOverallStatus);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepartFilterReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__ = __webpack_require__(37);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DepartFilterReducer=function DepartFilterReducer(state,action){switch(action.type){case"RECEIVE_FILTER_DATA":{var newState=Object.assign({},state,{data:Object.assign({},state.data,action.data)});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],newState);return newState;}case"SELECT_CLUSTER":{var _newState=Object.assign({},state,{cluster:action.Cluster});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState);return _newState;}case"SELECT_DRIVER_TYPE":{var _newState2=Object.assign({},state,{driverType:action.DriverType});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState2);return _newState2;}case"SELECT_STATUS":{var _newState3=Object.assign({},state,{status:action.status});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState3);return _newState3;}case"SELECT_DEPARTURE":{var _newState4=Object.assign({},state,{departure:action.Departure});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState4);return _newState4;}case"SELECT_DEPART_TIME":{var _newState5=Object.assign({},state,{departByTime:action.DepartByTime});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState5);return _newState5;}case"SELECT_VIEW_TYPE":{var _newState6=Object.assign({},state,{viewType:action.viewType});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState6);return _newState6;}case"UNLOAD_VIEW":return state;case"REMOVE_ALL_FILTER":{var _newState7=Object.assign({},state);Object.entries(state).forEach(function(entry){var key=entry[0];var values=entry[1];if(Array.isArray(values)&&values.length&&key!=='data'){_newState7[key]=[];}});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState7);return _newState7;}case"REMOVE_FILTER":{var _action$data=action.data,key=_action$data.key,value=_action$data.value;state[key]=state[key].filter(function(item){return item!==value;});var newItem=state[key].filter(function(item){return item!==value;});var _newState8=Object.assign({},state,_defineProperty({},key,newItem));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState8);return _newState8;}case"LOAD_XPT_NODES":var _action$data2=action.data,dispatcher=_action$data2.dispatcher,baseUrl=_action$data2.baseUrl,capability=_action$data2.capability,stationConfig=_action$data2.stationConfig;Object(__WEBPACK_IMPORTED_MODULE_0__stageStatus_network_StageNetworkAPI__["d" /* fetchSubStations */])(dispatcher,baseUrl,capability,__WEBPACK_IMPORTED_MODULE_3__util_MetricUtil__["c" /* DEPART_TAB_METRIC_KEY */],stationConfig);return state;case"RECEIVE_XPT_NODES":{var xptNodes=action.data.xptNodes;var savedState=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["E" /* readFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */]);var _newState9=Object.assign({},state,{xptNodes:xptNodes,data:Object.assign({},state.data,{xptNodes:xptNodes})});if(savedState){_newState9=Object.assign({},state,{data:Object.assign({},state.data,{xptNodes:xptNodes})});}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState9);return _newState9;}case"SELECT_XPT_NODE":{var _newState10=Object.assign({},state,{xptNodes:action.xptNodes});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["F" /* saveFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */],_newState10);return _newState10;}case"LOAD_FILTERS":{var _savedState=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["E" /* readFilterState */])(__WEBPACK_IMPORTED_MODULE_2__util_LocalStorageKeys__["a" /* DEPART_FILTER_STATE_KEY */]);if(_savedState){return Object.assign({},state,_savedState);}return state;}default:return state;}};

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_modal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_TableScrollWrapper__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__context_DepartContext__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__context_DepartFilterContext__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_CacheManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_LocalStorageKeys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_FilterUtil__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__global_context_useCapabilityContext__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__RouteContextMenu__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_button__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DepartTable=function DepartTable(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__context_DepartContext__["a" /* DepartContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_19__context_DepartFilterContext__["a" /* DepartFilterContext */]),viewModelF=_useContext2.viewModelF,dispatchF=_useContext2.dispatchF;var _useCapabilityContext=Object(__WEBPACK_IMPORTED_MODULE_23__global_context_useCapabilityContext__["a" /* default */])(),configViewModel=_useCapabilityContext.configViewModel,configViewModelRef=_useCapabilityContext.configViewModelRef,configDispatch=_useCapabilityContext.configDispatch;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_26__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;/** Pagination State **/var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState2=_slicedToArray(_useState,2),currentPage=_useState2[0],setCurrentPage=_useState2[1];/** Sorting **/var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("routeSLA"),_useState4=_slicedToArray(_useState3,2),sortColumn=_useState4[0],setSortColumn=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ascending"),_useState6=_slicedToArray(_useState5,2),sortDirection=_useState6[0],setSortDirection=_useState6[1];var onSort=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_ref){var sortColumn=_ref.sortColumn,sortDirection=_ref.sortDirection;setSortDirection(sortDirection);setSortColumn(sortColumn);},[]);/** In Line Table Filter **/var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),routeCodeFilter=_useState8[0],setRouteCodeFilter=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),typeFilter=_useState10[0],setTypeFilter=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),statusFilter=_useState12[0],setStatusFilter=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),slaFilter=_useState14[0],setSLAFilter=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),progressFilter=_useState16[0],setProgressFilter=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),locationFilter=_useState18[0],setLocationFilter=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),sectorsFilter=_useState20[0],setSectorsFilter=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),driverFilter=_useState22[0],setDriverFilter=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),cartsFilter=_useState24[0],setCartsFilter=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState26=_slicedToArray(_useState25,2),stationCodeFilter=_useState26[0],setStationCodeFilter=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState28=_slicedToArray(_useState27,2),departByTimeFilter=_useState28[0],setDepartByTimeFilter=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState30=_slicedToArray(_useState29,2),checkedRoutes=_useState30[0],setCheckedRoutes=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),buttonLoading=_useState32[0],setButtonLoading=_useState32[1];/** Filters **/var filterOption=function filterOption(route,filter,key){if(viewModelF[filter].length===0){return true;}var result=false;viewModelF[filter].forEach(function(filterValue){if(!route[key]||filter==="status"&&route[key]===filterValue||filter!=="status"&&route[key].includes(filterValue)){result=true;}});return result;};var inLineFilter=function inLineFilter(route,filter,key){return filter.length===0||route[key]&&route[key].toString().toLowerCase().startsWith(filter.toLowerCase());};var inLineContainsFilter=function inLineContainsFilter(route,filter,key){return filter.length===0||route[key]!=null&&route[key].toString().toLowerCase().includes(filter.toLowerCase());};var routeList=viewModel.routeList;routeList.sort(function(a,b){if(a[sortColumn]<b[sortColumn]){return sortDirection==="ascending"?-1:1;}if(a[sortColumn]>b[sortColumn]){return sortDirection==="ascending"?1:-1;}return 0;});routeList=routeList.filter(function(route){return filterOption(route,"cluster","routeCode");}).filter(function(route){return filterOption(route,"driverType","routeType");}).filter(function(route){return filterOption(route,"departure","routeSLA");}).filter(function(route){return filterOption(route,"status","status");}).filter(function(route){return filterOption(route,"departByTime","departByTime");}).filter(function(route){return inLineFilter(route,routeCodeFilter,"routeCode");}).filter(function(route){return inLineContainsFilter(route,typeFilter,"routeType");}).filter(function(route){return inLineFilter(route,statusFilter,"status");}).filter(function(route){return inLineFilter(route,slaFilter,"routeSLA");}).filter(function(route){return inLineFilter(route,progressFilter,"departProgress");}).filter(function(route){return Object(__WEBPACK_IMPORTED_MODULE_22__util_FilterUtil__["b" /* applyInlineStagingLocationFilter */])(route,locationFilter);}).filter(function(route){return inLineContainsFilter(route,sectorsFilter,"sectorCodes");}).filter(function(route){return inLineFilter(route,driverFilter,"driver");}).filter(function(route){return inLineFilter(route,cartsFilter,"totalCarts");}).filter(function(route){return inLineFilter(route,stationCodeFilter,"stationCode");}).filter(function(route){return inLineFilter(route,departByTimeFilter,"departByTime");});/** Pagination **/var itemOnPage=50;var pageSize=Math.ceil(routeList.length/itemOnPage);var startPage=(currentPage-1)*itemOnPage;var endPage=startPage+itemOnPage>routeList.length-1?routeList.length-1:startPage+itemOnPage-1;if(startPage>routeList.length){setCurrentPage(1);}var getStation=function getStation(stationCode){var xptNodes=viewModelF.data.xptNodes;if(Array.isArray(xptNodes)&&xptNodes.length&&__WEBPACK_IMPORTED_MODULE_24__util_Constants__["h" /* DEFAULT_CAPABILITIES */].includes(configViewModel.capability)){return Object(__WEBPACK_IMPORTED_MODULE_25__network_NetworkUtil__["a" /* getStationCode */])()!==stationCode&&xptNodes.includes(stationCode)?stationCode:"-";}return"-";};/**
     * A route can be moved to ready for dispatch if any of the following conditions match
     *    -  At least one package is stowed/topped-off in that route
     *    -  There are no delivery package in that route, meaning all packages are CReturns
     *    -  Route status is NOT_READY
     */var isRouteReadyForDispatch=function isRouteReadyForDispatch(route){if(route.status!==__WEBPACK_IMPORTED_MODULE_18__util_EntityStatusManager__["c" /* DEPART_STATUS */].NOT_READY){return false;}if(!(route&&route.stowProgress&&route.stowProgress.split("/").length===2)){return false;}var _route$stowProgress$s=route.stowProgress.split("/"),_route$stowProgress$s2=_slicedToArray(_route$stowProgress$s,2),stowedPackages=_route$stowProgress$s2[0],totalPackages=_route$stowProgress$s2[1];var isCReturnOnlyRoute=totalPackages==="0";var hasStowingStartedInRoute=stowedPackages!=="0";return isCReturnOnlyRoute||hasStowingStartedInRoute||route.topOffPackageCount!==0;};var onRouteClick=function onRouteClick(route){Object(__WEBPACK_IMPORTED_MODULE_16__handler_ParentDataHandler__["c" /* getDocumentURL */])().then(function(result){var params=["Depart",Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(route.routeId),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(encodeURIComponent(route.routeStatus)),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(encodeURIComponent(route.stagingLocation)),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(route.hazmatWeight),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(route.picker),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(route.routeCode),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["C" /* naIfDefault */])(route.stationCode)];var url=new URL(result.replace("depart","pick"));var shareableLink="/routeDetail/"+params.join("/");url.searchParams.set("shareableLink",shareableLink);if(configViewModel.stationConfig.amxl){var amxlUrl=new URL(result.replace("depart","stowv2"));window.open(amxlUrl.href,"_parent");}else window.open(url.href,"_parent");});};var getDepartData=function getDepartData(){if(Array.isArray(viewModelF.xptNodes)){dispatch({type:__WEBPACK_IMPORTED_MODULE_24__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].LOAD_VIEW,data:{dispatcher:dispatch,filterDispatcher:dispatchF,baseUrl:configViewModel.baseUrl,xptNodes:viewModelF.xptNodes,configDispatch:configDispatch,stationConfig:configViewModel.stationConfig,capability:configViewModel.capability}});}};/**
     * Check if all rows are checked for IN Depart
     * - If checkedRows.length is 0, then false
     * - Check route status, and check if it is present in the list
     */var areAllRowsChecked=function areAllRowsChecked(routeList){if(checkedRoutes.length===0){return false;}for(var key in routeList){var route=routeList[key];if(isRouteReadyForDispatch(route)&&!checkedRoutes.includes(route.routeId)){return false;}}return true;};/**
     * Check all filtered rows - IN Depart
     */var checkAllRows=function checkAllRows(event){setCheckedRoutes(event?routeList.filter(function(route){return isRouteReadyForDispatch(route);}).map(function(route){return route.routeId;}):[]);};/**
     * Check if this row is selected - IN Depart.
     */var isChecked=function isChecked(routeId){return checkedRoutes.includes(routeId)===true;};/**
     * Select row for depart - IN Depart.
     */var checkRow=function checkRow(routeId){checkedRoutes.includes(routeId)===true?setCheckedRoutes(function(old){return old.filter(function(row){return row!==routeId;});}):setCheckedRoutes(function(old){return[].concat(_toConsumableArray(old),[routeId]);});};/**
     * Close Bulk Depart Notification Modal - IN Depart.
     */var closeModal=function closeModal(){setButtonLoading(false);setCheckedRoutes([]);dispatch({type:__WEBPACK_IMPORTED_MODULE_24__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].CLOSE_BULK_UPDATE_NOTIFICATION});};/**
     * Open Confirmation for Bulk Depart.
     */var handleOpenBulkDepartModal=function handleOpenBulkDepartModal(){dispatch({type:__WEBPACK_IMPORTED_MODULE_24__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_UPDATE_ROUTE_STATUS_MODAL,data:{bulkDepartStatus:{routeIds:routeList.filter(function(route){return checkedRoutes.includes(route.routeId);}).map(function(route){return{routeId:route.routeId,routeCode:route.routeCode};}),modalOpen:true}}});};/**
     * Bulk Depart selected & confirmed routes - IN Depart.
     */var handleBulkDepart=function handleBulkDepart(){setButtonLoading(true);dispatch({type:__WEBPACK_IMPORTED_MODULE_24__util_Constants__["j" /* DEPART_TABLE_ACTIONS */].BULK_UPDATE_ROUTE_STATUS,data:{dispatcher:dispatch,filterDispatcher:dispatchF,routeIds:routeList.filter(function(route){return checkedRoutes.includes(route.routeId);}).map(function(route){return{routeId:route.routeId,routeCode:route.routeCode};}),baseUrl:configViewModel.baseUrl,stationConfig:configViewModel.stationConfig,configDispatch:configDispatch,xptNodes:viewModelF.xptNodes}});};/**
     * This gets invoked on following events:
     *  1. On every page load,
     *  2. Every time xpt filter value is changed,
     *  Note: stationConfig can be update after GetStationRoutes API response is received.
     */Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getDepartData();var firstPollTime=Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["o" /* getRefreshInterval */])(configViewModelRef.current.stationConfig);var remainingTTL=Object(__WEBPACK_IMPORTED_MODULE_20__util_CacheManager__["b" /* getRemainingTTL */])(__WEBPACK_IMPORTED_MODULE_21__util_LocalStorageKeys__["b" /* ROUTE_DATA_CACHE_KEY */]);if(viewModelF.xptNodes&&Object(__WEBPACK_IMPORTED_MODULE_20__util_CacheManager__["c" /* isRouteCacheValid */])(viewModelF.xptNodes)){firstPollTime=remainingTTL;}var timeoutHandler=function timeoutHandler(){getDepartData();timeout=setTimeout(timeoutHandler,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["o" /* getRefreshInterval */])(configViewModelRef.current.stationConfig));};var timeout=setTimeout(timeoutHandler,firstPollTime);return function(){return clearTimeout(timeout);};},[viewModelF.xptNodes]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_TableScrollWrapper__["a" /* default */],null,viewModel.bulkDepartStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_modal___default.a,{width:500,title:"Depart Status",open:true,onClose:closeModal,scrollContainer:"modal",closeLabel:"Close",describedById:"alert-modal"},viewModel.bulkDepartStatus.modalOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,"Are you sure you want to continue departing ",checkedRoutes.length," routes?",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_button___default.a,{size:"small",disabled:buttonLoading,onClick:handleBulkDepart},buttonLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default.a,{size:"small",type:"circular"}):null,"Confirm")):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{showStripes:true,fixHeaderRows:true,headerRows:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,"Route Code"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,"Status")),viewModel.bulkDepartStatus.routeIds.map(function(v,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,v.routeCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,viewModel.bulkDepartStatus.modalOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"-"):viewModel.bulkDepartStatus.successIds.includes(v.routeId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"SUCCESS"):viewModel.bulkDepartStatus.failureIds.includes(v.routeId)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"FAILED"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default.a,{size:"small",type:"circular"})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,{spacingInset:"small"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",widths:"fill",spacingInset:spacingInset_shorthand2,className:"enable-scroll-x"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_button___default.a,{disabled:checkedRoutes.length===0||buttonLoading,onClick:handleOpenBulkDepartModal},buttonLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_loader___default.a,{size:"small",type:"circular"}):null,"Depart Routes")):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table___default.a,{showStripes:true,headerColumns:1,stickyHeaderColumn:true,fixHeaderRows:true,headerRows:1,stickyHeaderRow:true,showDividers:true,spacing:"small",sortColumn:sortColumn,sortDirection:sortDirection,onSort:onSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"routeSLA"},configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"depart.stowByTime",defaultMessage:"Stow by time"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"stage.stageByTime",defaultMessage:"Stage by time"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{checked:areAllRowsChecked(routeList),onChange:function onChange(e){return checkAllRows(e);}})),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"DepartByTime"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.departByTime",defaultMessage:"Depart by time"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.routeId",defaultMessage:"Route ID"})),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"stagingLocation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.location",defaultMessage:"Location"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"sectorCodes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.sectors",defaultMessage:"Sectors"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"status"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right",sortColumn:"departProgress"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.progress",defaultMessage:"Progress"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"routeType"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.type",defaultMessage:"Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"driver"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.driver",defaultMessage:"Driver"})),!(Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["t" /* isARorSSD */])(configViewModelRef.current.capability)||Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_24__util_Constants__["v" /* REGION */].IN)&&!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"totalCarts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.carts",defaultMessage:"Carts"})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{sortColumn:"stationCode"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["a" /* FormattedMessage */],{id:"departTable.station",defaultMessage:"Station"})),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{alignmentHorizontal:"right",type:"text",size:"small",value:slaFilter,onChange:setSLAFilter})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{alignmentHorizontal:"right",type:"text",size:"small",value:departByTimeFilter,onChange:setDepartByTimeFilter})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:routeCodeFilter,onChange:setRouteCodeFilter})),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:locationFilter,onChange:setLocationFilter})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:sectorsFilter,onChange:setSectorsFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:statusFilter,onChange:setStatusFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:progressFilter,onChange:setProgressFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:typeFilter,onChange:setTypeFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:driverFilter,onChange:setDriverFilter})),!(Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["t" /* isARorSSD */])(configViewModelRef.current.capability)||Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["p" /* getRegion */])()===__WEBPACK_IMPORTED_MODULE_24__util_Constants__["v" /* REGION */].IN)&&!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:cartsFilter,onChange:setCartsFilter})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{type:"text",size:"small",value:stationCodeFilter,onChange:setStationCodeFilter})),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null):null),routeList.map(function(route,key){return key>=startPage&&key<=endPage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableRow"],{key:route.routeId},Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.routeSLA):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,isRouteReadyForDispatch(route)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_checkbox___default.a,{checked:isChecked(route.routeId),onChange:function onChange(e){return checkRow(route.routeId);}}):null),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.departByTime):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_link___default.a,{onClick:function onClick(){onRouteClick(route);},type:"secondary"},route.routeCode)),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:route.stagingLocation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["G" /* trimColValue */])(route.stagingLocation,16)))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:route.sectorCodes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["G" /* trimColValue */])(route.sectorCodes,50)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:route.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default.a,{type:Object(__WEBPACK_IMPORTED_MODULE_18__util_EntityStatusManager__["s" /* getDepartStatusColor */])(route.status)},route.status.length>11?route.status.substr(0,10)+"...":route.status))),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.departProgress):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"right"},route.stowProgress,route.topOffPackageCount&&route.topOffPackageCount!==0?" + "+route.topOffPackageCount:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,route.routeType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:route.driver},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{truncate:true},route.driver))),Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)&&!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,route.totalCarts)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,getStation(route.stationCode))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)&&isRouteReadyForDispatch(route)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__RouteContextMenu__["a" /* default */],{route:route})):null)):null;}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,routeList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",alignmentHorizontal:"center",spacingInset:"medium none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_pagination___default.a,{numberOfPages:pageSize,onChange:setCurrentPage,currentPage:currentPage})):null)))));};/* harmony default export */ __webpack_exports__["a"] = (DepartTable);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _loader = _interopRequireDefault(__webpack_require__(709));

var _default = _loader["default"];
exports["default"] = _default;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));

var _createClass2 = _interopRequireDefault(__webpack_require__(13));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _emotion = __webpack_require__(4);

var _loader = _interopRequireDefault(__webpack_require__(710));

var _linear = _interopRequireDefault(__webpack_require__(711));

var _circular = _interopRequireDefault(__webpack_require__(712));

var _theme = __webpack_require__(7);

var _token = __webpack_require__(8);

var _text = _interopRequireDefault(__webpack_require__(22));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(6));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var wrapperStyles = function wrapperStyles(t, _ref) {
  var type = _ref.type,
      size = _ref.size;
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: type === "linear" ? type : size,
    lineHeight: type === "linear" ? type : size,
    fontWeight: "body"
  }));
};

var Loader = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Loader, _React$PureComponent);

  var _super = _createSuper(Loader);

  function Loader() {
    (0, _classCallCheck2["default"])(this, Loader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Loader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          type = _this$props.type,
          showPercentageText = _this$props.showPercentageText,
          label = _this$props.label;
      var percentage = this.props.percentage;
      percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage;
      var determinate = percentage !== undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _loader["default"],
        map: (0, _token.getTokenHelper)("loader")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
          className: wrapperStyles(t, {
            size: size,
            type: type
          })
        }), type === "linear" ? /*#__PURE__*/_react["default"].createElement(_linear["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }) : /*#__PURE__*/_react["default"].createElement(_circular["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }));
      });
    }
  }]);
  return Loader;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Loader, "defaultProps", {
  size: "large",
  type: "circular",
  showPercentageText: true
});
Loader.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * An accessible label. This is not shown in the UI, but will be read by
   * screen-readers.
   *
   * @since 5.x
   */
  label: _propTypes["default"].string,

  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  percentage: _propTypes["default"].number,

  /**
   * This determines whether the value of the `percentage` prop is shown in
   * text-form in the UI.
   */
  showPercentageText: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * The `"medium"` sizes is only available if `type` is set to `"circular"`.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),

  /**
   * Determines the shape of the loader.
   */
  type: _propTypes["default"].oneOf(["circular", "linear"])
} : {};
var _default = Loader;
exports["default"] = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    loaderIndicatorBackgroundColor: tokens.themeBorderAccentDefault,
    loaderIndicatorMotionIndeterminateDuration: "700ms",
    loaderIndicatorMotionIndeterminateFunction: "linear",
    loaderIndicatorMotionDeterminateDuration: "150ms",
    loaderIndicatorMotionDeterminateFunction: "linear",
    loaderTrackBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    loaderTrackLinearLargeHeight: 8,
    loaderTrackLinearSmallHeight: 4,
    loaderTrackCircularLargeSize: 64,
    loaderTrackCircularLargeStrokeWidth: 4,
    loaderTrackCircularMediumSize: 32,
    loaderTrackCircularMediumStrokeWidth: 4,
    loaderTrackCircularSmallSize: 16,
    loaderTrackCircularSmallStrokeWidth: 2,
    loaderPercentageSpacing: 8,
    loaderBorderRadius: 999,
    loaderFontSizeLinear: 14,
    loaderFontSizeSmall: 12,
    loaderFontSizeMedium: 12,
    loaderFontSizeLarge: 14,
    loaderLineHeightLinear: "20px",
    loaderLineHeightSmall: "16px",
    loaderLineHeightMedium: "16px",
    loaderLineHeightLarge: "20px"
  }
};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var _token = __webpack_require__(8);

var indeterminateLinearAnimation = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(0.25) translateX(-100%)"
  },
  to: {
    transform: "scaleX(1) translateX(150%)"
  }
});
var indeterminateLinearAnimationRtl = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(1) translateX(150%)"
  },
  to: {
    transform: "scaleX(0.25) translateX(-100%)"
  }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    display: "flex",
    borderRadius: t("borderRadius"),
    width: "100%",
    minWidth: 100,
    height: t("trackLinear", [size, "height"]),
    backgroundColor: t("trackBackgroundColor"),
    position: "relative",
    overflow: "hidden",
    // HACK: This allows `overflow: hidden` + `position: relative` to work
    // as intended in Safari desktop
    zIndex: 0
  });
}, ["size"]);
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var determinate = _ref2.determinate,
      _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
  return (0, _emotion.css)({
    width: "".concat(percentage, "%"),
    height: "100%",
    backgroundColor: t("indicatorBackgroundColor"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, ["determinate", "percentage"]);

var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
  return (0, _defineProperty2["default"])({
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: t("borderRadius"),
    transformOrigin: "top left",
    animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  }, "[dir=\"rtl\"] &", {
    animation: "".concat(indeterminateLinearAnimationRtl, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  });
};

var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var _css;

  var percentage = _ref4.percentage;
  return (0, _emotion.css)((_css = {
    width: "".concat(percentage, "%"),
    // HACK: IE11 does not support text-align "end" or "start" so we have
    // to use directional left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    //   textAlign: "end"
    textAlign: "right"
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    textAlign: "left"
  }), (0, _defineProperty2["default"])(_css, "marginTop", t("percentageSpacing")), (0, _defineProperty2["default"])(_css, "transition", t.transitionCss("indicatorMotionDeterminate", "width")), _css));
}, ["percentage"]);
var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/* eslint-disable react/prop-types */

var LinearLoader = function LinearLoader(_ref5) {
  var t = _ref5.t,
      percentage = _ref5.percentage,
      showPercentageText = _ref5.showPercentageText,
      size = _ref5.size,
      label = _ref5.label,
      determinate = _ref5.determinate;
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearWrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearIndicatorStyle(t, {
      determinate: determinate,
      percentage: percentage
    })
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: linearPercentageStyle(t, {
      percentage: percentage
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = LinearLoader;
exports["default"] = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(4);

var _token = __webpack_require__(8);

var _functional = __webpack_require__(19);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(64));

var indeterminateCircularAnimation = (0, _emotion.keyframes)({
  "0%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(100deg)"
  },
  "50%": {
    strokeDasharray: "30% 400%"
  },
  "100%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(460deg)"
  }
});
var wrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    position: "relative"
  }, size === "small" ? {
    display: "flex",
    alignItems: "center"
  } : undefined);
}, ["size"]);

var svgStyle = function svgStyle(size) {
  return (0, _emotion.css)({
    width: size,
    height: size
  });
};

var pathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transition: t.transitionCss("indicatorMotionDeterminate", "stroke-dasharray")
  });
});
var indeterminatePathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transformOrigin: "center",
    animation: "".concat(indeterminateCircularAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionDeterminateFunction"), " infinite")
  });
});
var percentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "small" ? smallPercentageStyle : size === "medium" ? mediumPercentageStyle(t) : largePercentageStyle(t));
}, ["size"]);
var smallPercentageStyle = (0, _defineProperty2["default"])({
  // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
  // to use directional margin-left/right. If/when we drop IE11 we can simplify
  // these styles to be:
  // {
  //   marginInlineStart: 8,
  // }
  marginLeft: 8
}, "[dir=\"rtl\"] &", {
  marginLeft: 0,
  marginRight: 8
});

var mediumPercentageStyle = function mediumPercentageStyle(t) {
  return {
    width: t("trackCircularMediumSize"),
    textAlign: "center",
    marginTop: t("percentageSpacing")
  };
};

var largePercentageStyle = function largePercentageStyle(t) {
  return {
    position: "absolute",
    top: t("trackCircularLargeSize") / 2,
    width: t("trackCircularLargeSize"),
    lineHeight: 0,
    textAlign: "center"
  };
};

var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * To draw the right amount of stroke we need to know
 * the total length of the path. These path lengths were
 * derived once in Chrome console in order that they not
 * be calculated every time
 */

var pathLengths = {
  large: 188.5220947265625,
  medium: 87.97695922851562,
  small: 43.98847961425781
};
/* eslint-disable react/prop-types */

var CircularLoader = function CircularLoader(props) {
  var t = props.t,
      size = props.size,
      percentage = props.percentage,
      showPercentageText = props.showPercentageText,
      determinate = props.determinate,
      label = props.label;
  var box = t("trackCircular", [size, "size"]);
  var startX = box / 2;
  var startY = t("trackCircular", [size, "strokeWidth"]) / 2;
  var endX = 0;
  var endY = box - t("trackCircular", [size, "strokeWidth"]);
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    role: "img",
    viewBox: "0 0 ".concat(box, " ").concat(box),
    className: svgStyle(box),
    "aria-hidden": label ? false : true,
    focusable: label ? true : false,
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("track", "backgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    fill: "none"
  }), !determinate ? /*#__PURE__*/_react["default"].createElement("circle", {
    className: indeterminatePathStyle(t),
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "10% 100%",
    fill: "none"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    className: pathStyle(t),
    d: "M".concat(startX, ",").concat(startY, "\n              a 1 1 0 0 1 ").concat(endX, " ").concat(endY, "\n              a 1 1 0 0 1 ").concat(endX, " -").concat(endY),
    fill: "none",
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "".concat(pathLengths[size] * percentage / 100, ", ").concat(pathLengths[size])
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: percentageStyle(t, {
      size: size
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = CircularLoader;
exports["default"] = _default;

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_DepartContext__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_context_useCapabilityContext__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_DepartFilterContext__ = __webpack_require__(89);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * This mehtod will handle route Status update event
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */var RouteContextMenu=function RouteContextMenu(props){var iconRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),open=_useState2[0],setOpen=_useState2[1];var onClickButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return setOpen(true);},[]);var onClose=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return setOpen(false);},[]);var _useCapabilityContext=Object(__WEBPACK_IMPORTED_MODULE_7__global_context_useCapabilityContext__["a" /* default */])(),configViewModel=_useCapabilityContext.configViewModel,configDispatch=_useCapabilityContext.configDispatch;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_DepartContext__["a" /* DepartContext */]),dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_DepartFilterContext__["a" /* DepartFilterContext */]),viewModelF=_useContext2.viewModelF,dispatchF=_useContext2.dispatchF;var getMenuItem=function getMenuItem(){var markReadyForDispatch={title:"contextMenu.ready_to_depart",message:"MARK READY TO DEPART"};var menuItem=[];menuItem.push(markReadyForDispatch);return menuItem;};var executeAction=function executeAction(){dispatch({type:'UPDATE_ROUTE_STATUS',data:{dispatcher:dispatch,filterDispatcher:dispatchF,routeId:props.route.routeId,baseUrl:configViewModel.baseUrl,stationConfig:configViewModel.stationConfig,configDispatch:configDispatch,xptNodes:viewModelF.xptNodes}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default.a,{type:"icon",ref:iconRef,onClick:onClickButton,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_menu_meatball___default.a},"Settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu___default.a,{anchorNode:iconRef.current,open:open,position:"right",onClose:onClose},getMenuItem().map(function(menu,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_menu__["MenuItem"],{key:key,onClick:function onClick(){return executeAction();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:menu.title,defaultMessage:menu.message}));})));};/* harmony default export */ __webpack_exports__["a"] = (RouteContextMenu);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_component_FilterExpander__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepartFilter__ = __webpack_require__(715);
var DepartFilterWrapper=function DepartFilterWrapper(){var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_1__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),isMobile=_useDeviceLayout.isMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_component_FilterExpander__["a" /* FilterExpander */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DepartFilter__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DepartFilter__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (DepartFilterWrapper);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_EntityStatusManager__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_DepartFilterContext__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__context_DepartContext__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_RefreshTimer__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_context_CapabilityContext__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_context_DeviceLayoutContext__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Util__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DepartFilter=function DepartFilter(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__context_DepartFilterContext__["a" /* DepartFilterContext */]),viewModelF=_useContext.viewModelF,dispatchF=_useContext.dispatchF;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__context_DepartContext__["a" /* DepartContext */]),viewModel=_useContext2.viewModel;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__global_context_CapabilityContext__["a" /* CapabilityContext */]),configViewModel=_useContext3.configViewModel;var _useDeviceLayout=Object(__WEBPACK_IMPORTED_MODULE_15__common_context_DeviceLayoutContext__["b" /* useDeviceLayout */])(),spacingInset_shorthand2=_useDeviceLayout.spacingInset_shorthand2;var departDataConversionHandler=function departDataConversionHandler(){if(Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability))return Object(__WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__["a" /* getDepartDataInCSVFormat */])(viewModel.routeList);else return Object(__WEBPACK_IMPORTED_MODULE_10__util_ExportUtils__["b" /* getDepartDataInCSVFormatForIN */])(viewModel.routeList);};var isFilterSet=function isFilterSet(){var result=false;Object.entries(viewModelF).forEach(function(entry){var key=entry[0];var values=entry[1];result=result||Array.isArray(values)&&values.length&&key!=='data';});return result;};var clearAllFilters=function clearAllFilters(){dispatchF({type:'REMOVE_ALL_FILTER'});};var isXPTFilterRequired=function isXPTFilterRequired(){var xptNodes=viewModelF.data.xptNodes;return Array.isArray(xptNodes)&&xptNodes.length;};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){dispatchF({type:'LOAD_FILTERS'});dispatchF({type:'LOAD_XPT_NODES',data:{dispatcher:dispatchF,baseUrl:configViewModel.baseUrl,capability:configViewModel.capability,stationConfig:configViewModel.stationConfig}});},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacingInset:spacingInset_shorthand2,spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"none",alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__exportcsv_ExportCSV__["a" /* default */],{isLink:true,csvDataProvider:departDataConversionHandler,filePrefix:"DEPART"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{width:"100%",spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",wrap:"down",spacingInset:"medium small",spacing:"small",backgroundColor:"secondary"},isXPTFilterRequired()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_XPT_NODE',xptNodes:data});},value:viewModelF.xptNodes,size:"small",placeholder:props.intl.formatMessage({id:"stage.xptNodes",defaultMessage:"XPT Nodes"}),width:"120px"},[].concat(_toConsumableArray(viewModelF.data.xptNodes)).sort().map(function(xptNode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:xptNode,label:xptNode,value:xptNode});})):null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DEPARTURE',Departure:data});},value:viewModelF.departure,size:"small",placeholder:props.intl.formatMessage({id:"stage.stageByTime",defaultMessage:"Stage by time"}),width:"145px"},[].concat(_toConsumableArray(viewModelF.data.departure)).sort().map(function(departure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:departure,label:"Stage by "+departure,value:departure});})):null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["x" /* isNotSSDAndINRegion */])(configViewModel.capability)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DEPART_TIME',DepartByTime:data});},value:viewModelF.departByTime,size:"small",placeholder:props.intl.formatMessage({id:"depart.departByTime",defaultMessage:"Depart by time"}),width:"145px"},[].concat(_toConsumableArray(viewModelF.data.departByTime)).map(function(departure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:departure,label:"Depart by "+departure,value:departure});})):null,!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:data});},value:viewModelF.driverType,size:"small",placeholder:props.intl.formatMessage({id:"stageFilter.driverType",defaultMessage:"Driver Type"}),width:"125px"},[].concat(_toConsumableArray(viewModelF.data.driverType)).sort().map(function(driverType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:driverType,label:driverType,value:driverType});})):null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["w" /* isNotINRegionOrSSD */])(configViewModel.capability)&&!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_CLUSTER',Cluster:data});},value:viewModelF.cluster,size:"small",placeholder:props.intl.formatMessage({id:"stageFilter.cluster",defaultMessage:"Cluster"}),width:"115px"},[].concat(_toConsumableArray(viewModelF.data.cluster)).sort().map(function(cluster){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:cluster,label:cluster,value:cluster});})):null,!configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_STATUS',status:data});},value:viewModelF.status,size:"small",placeholder:props.intl.formatMessage({id:"cartInfo.status",defaultMessage:"Status"}),width:"120px"},Object(__WEBPACK_IMPORTED_MODULE_8__util_EntityStatusManager__["t" /* getDepartStatusList */])(configViewModel.capability).map(function(status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:status,label:status,value:status});})):null,configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_DRIVER_TYPE',DriverType:data});},value:viewModelF.driverType,size:"small",placeholder:props.intl.formatMessage({id:"departFilter.routeType",defaultMessage:"Route Type"}),width:"125px"},[].concat(_toConsumableArray(viewModelF.data.driverType)).sort().map(function(driverType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:driverType,label:driverType,value:driverType});})):null,configViewModel.stationConfig.amxl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tooltip___default.a,{position:"end",title:"Shipment Type filter is currently not supported."},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{onChange:function onChange(data){return dispatchF({type:'SELECT_STATUS',status:data});},value:viewModelF.status,size:"small",disabled:true,placeholder:props.intl.formatMessage({id:"departFilter.shipmentType",defaultMessage:"Shipment Type"}),width:"160px"},Object(__WEBPACK_IMPORTED_MODULE_8__util_EntityStatusManager__["w" /* getShipmentTypeList */])().map(function(type){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:type,label:type,value:type});}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",spacingInset:"small none none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{spacing:"small"},Object.entries(viewModelF).map(function(entry){var key=entry[0];var values=entry[1];return Array.isArray(values)&&key!=='data'?values.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tag___default.a,{key:value,type:"theme",onClose:function onClose(){return dispatchF({type:'REMOVE_FILTER',data:{key:key,value:value}});}},value);}):null;}),isFilterSet()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_link___default.a,{onClick:clearAllFilters,type:"secondary"},"Clear all"):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{spacingInset:"small none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__util_RefreshTimer__["a" /* default */],{deps:[viewModel.lastUpdated],lastUpdated:viewModel.lastUpdated})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(DepartFilter));

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depart_context_DepartContext__ = __webpack_require__(75);
var DepartAlertView=function DepartAlertView(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__depart_context_DepartContext__["a" /* DepartContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var removeNotification=function removeNotification(){dispatch({type:'REMOVE_NOTIFICATION'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,viewModel.alert.title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-8"],spacingInset:"large large none",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{onClose:function onClose(){return removeNotification();},size:"medium",type:viewModel.alert.type},viewModel.alert.title)):null);};/* harmony default export */ __webpack_exports__["a"] = (DepartAlertView);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},"month-short":{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},"hour-short":{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},"minute-short":{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.tr=a())}(this,function(){"use strict";return[{locale:"tr",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},"year-short":{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},month:{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},"month-short":{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},day:{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},"day-short":{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},hour:{displayName:"saat",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} saat sonra",other:"{0} saat sonra"},past:{one:"{0} saat önce",other:"{0} saat önce"}}},"hour-short":{displayName:"sa.",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} sa. sonra",other:"{0} sa. sonra"},past:{one:"{0} sa. önce",other:"{0} sa. önce"}}},minute:{displayName:"dakika",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dakika sonra",other:"{0} dakika sonra"},past:{one:"{0} dakika önce",other:"{0} dakika önce"}}},"minute-short":{displayName:"dk.",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dk. sonra",other:"{0} dk. sonra"},past:{one:"{0} dk. önce",other:"{0} dk. önce"}}},second:{displayName:"saniye",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} saniye sonra",other:"{0} saniye sonra"},past:{one:"{0} saniye önce",other:"{0} saniye önce"}}},"second-short":{displayName:"sn.",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} sn. sonra",other:"{0} sn. sonra"},past:{one:"{0} sn. önce",other:"{0} sn. önce"}}}}},{locale:"tr-CY",parentLocale:"tr"}]});


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocale; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getDirection;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_util_Constants__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_handler_ParentDataHandler__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_util_Util__ = __webpack_require__(9);
var fetchLocale=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10__components_handler_ParentDataHandler__["e" /* getLocaleFromParent */])();case 2:locale=_context2.sent;return _context2.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_11__components_util_Util__["v" /* isNotEmpty */])(locale)?locale:navigator.language);case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function fetchLocale(){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getLocale=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetchLocale();case 2:locale=_context.sent;_context.t0=locale;_context.next=_context.t0==="de"?6:_context.t0==="de-DE"?6:_context.t0==="de-CH"?6:_context.t0==="de-AT"?6:_context.t0==="de-LU"?6:_context.t0==="de-LI"?6:_context.t0==="es"?7:_context.t0==="es-ES"?7:_context.t0==="es-AR"?7:_context.t0==="es-GT"?7:_context.t0==="es-CR"?7:_context.t0==="es-PA"?7:_context.t0==="es-DO"?7:_context.t0==="es-MX"?7:_context.t0==="es-VE"?7:_context.t0==="es-CO"?7:_context.t0==="es-PE"?7:_context.t0==="es-EC"?7:_context.t0==="es-CL"?7:_context.t0==="es-UY"?7:_context.t0==="es-PY"?7:_context.t0==="es-BO"?7:_context.t0==="es-SV"?7:_context.t0==="es-HN"?7:_context.t0==="es-NI"?7:_context.t0==="es-PR"?7:_context.t0==="ja"?8:_context.t0==="ja-JP"?8:_context.t0==="it"?9:_context.t0==="it-IT"?9:_context.t0==="it-CH"?9:_context.t0==="fr"?10:_context.t0==="fr-FR"?10:_context.t0==="fr-BE"?10:_context.t0==="fr-CA"?10:_context.t0==="fr-CH"?10:_context.t0==="fr-LU"?10:_context.t0==="ar"?11:_context.t0==="ar-SA"?11:_context.t0==="ar-IQ"?11:_context.t0==="ar-EG"?11:_context.t0==="ar-LY"?11:_context.t0==="ar-DZ"?11:_context.t0==="ar-MA"?11:_context.t0==="ar-TN"?11:_context.t0==="ar-OM"?11:_context.t0==="ar-YE"?11:_context.t0==="ar-SY"?11:_context.t0==="ar-JO"?11:_context.t0==="ar-LB"?11:_context.t0==="ar-KW"?11:_context.t0==="ar-AE"?11:_context.t0==="ar-BH"?11:_context.t0==="ar-QA"?11:_context.t0==="tr"?12:_context.t0==="tr-TR"?12:13;break;case 6:return _context.abrupt('return',"de");case 7:return _context.abrupt('return',"es");case 8:return _context.abrupt('return',"ja");case 9:return _context.abrupt('return',"it");case 10:return _context.abrupt('return',"fr");case 11:return _context.abrupt('return',"ar");case 12:return _context.abrupt('return',"tr");case 13:return _context.abrupt('return',"en");case 14:case'end':return _context.stop();}}},_callee,this);}));return function getLocale(){return _ref.apply(this,arguments);};}();function getDirection(locale){return locale===__WEBPACK_IMPORTED_MODULE_9__components_util_Constants__["p" /* LOCALE */].AR?__WEBPACK_IMPORTED_MODULE_9__components_util_Constants__["q" /* LOCALE_DIRECTION */].RIGHT_TO_LEFT:__WEBPACK_IMPORTED_MODULE_9__components_util_Constants__["q" /* LOCALE_DIRECTION */].LEFT_TO_RIGHT;}function getMessages(locale){switch(locale){case"en":return __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default.a;case"es":return __WEBPACK_IMPORTED_MODULE_2__il8n_locales_es_json___default.a;case"fr":return __WEBPACK_IMPORTED_MODULE_3__il8n_locales_fr_json___default.a;case"it":return __WEBPACK_IMPORTED_MODULE_4__il8n_locales_it_json___default.a;case"ja":return __WEBPACK_IMPORTED_MODULE_5__il8n_locales_ja_json___default.a;case"de":return __WEBPACK_IMPORTED_MODULE_6__il8n_locales_de_json___default.a;case"ar":return __WEBPACK_IMPORTED_MODULE_7__il8n_locales_ar_json___default.a;case"tr":return __WEBPACK_IMPORTED_MODULE_8__il8n_locales_tr_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_1__il8n_locales_en_json___default.a;}}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Location","cartContent.picked":"Picked","cartContent.staged":"Staged","cartContent.departed":"Departed","cartContent.bags":"Bags","cartContent.packages":"Packages","cartInfo.stage":"Stage","cartInfo.cartDetail":"Cart Details","cartInfo.status":"Status","cartInfo.location":"Location","cartInfo.associate":"Associate","depart.heading":"Depart","depart.description":"This table shows routes’ status and details during the outbound depart process","depart.totalRoutes":"Total routes","depart.routesPartiallyDeparted":"Routes Partially Departed","depart.routesDeparted":"Routes Departed","departTable.departByTime":"Depart By Time","departTable.dispatchTime":"Dispatch Time","departTable.updateStatus":"UpdateStatus","departTable.routeId":"Route ID","departTable.location":"Location","departTable.status":"Status","departTable.progress":"Progress","departTable.type":"Type","departTable.driver":"Driver","departTable.carts":"Carts","departFilter.routeType":"Route Type","departFilter.shipmentType":"Shipment Type","cartMenu.sideline":"Sideline","routeStageTable.dispatchTime":"Dispatch Time","routeStageTable.cartId":"Cart ID","routeStageTable.routeId":"Route ID","routeStageTable.location":"Location","routeStageTable.cartView_location":"Staging Location","routeStageTable.status":"Status","routeStageTable.dwellDuration":"Dwell Duration","routeStageTable.type":"Type","routeStageTable.driver":"Driver","routeStageTable.stationPairs":"Pick Station","routeStageTable.action":"Action","stageFilter.departure":"Departure","stageFilter.driverType":"Driver Type","stageFilter.cluster":"Cluster","stageOverall.cartPreStaged":"Carts Pre Staged","stageOverall.cartsStaged":"Carts Staged","stageOverall.cartDwellingDSP":"Carts Dwelling (DSP)","stageOverall.cartDwellingFlex":"Carts Dwelling (Flex)","stage.heading":"Stage","stage.description":"This table shows routes’ status and details during the outbound stage process","stageOverall.routesStaged":"Routes Staged","routeStageTable.carts":"Carts","routeStageTable.loadSheet":"Load Sheet","stage.exportCSV":"Export To CSV","stage.stageByTime":"Stage by time","stage.partiallyStaged":"Partially staged","stage.download":"Download","stage.interimStaged":"Interim staged","stageOverall.cartView":"Cart View","stageOverall.routeView":"Route View","depart.partiallyDeparted":"Partially departed","common.data_last_updated":"Data last updated","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"Route Adjustment Status","planManagement.pending_tasks_message":"There are {count} pending route adjustment tasks.","planManagement.proceed_confirmation":"Do you want to proceed with activating the plan anyway?","planManagement.proceed_anyway":"Proceed Anyway","planManagement.cancel":"Cancel"}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Ubicación","cartContent.picked":"Recogido","cartContent.staged":"Almacenado temporalmente","cartContent.departed":"Salido","cartContent.bags":"Bolsas","cartContent.packages":"Paquetes","cartInfo.stage":"Almacenar temporalmente","cartInfo.cartDetail":"Detalles del carro","cartInfo.status":"Estado","cartInfo.location":"Ubicación","cartInfo.associate":"Asociado","depart.heading":"Salir","depart.description":"En esta tabla se muestran el estado y los detalles de las rutas durante el proceso de salida saliente","depart.totalRoutes":"Rutas totales","depart.routesPartiallyDeparted":"Rutas que han salido parcialmente","depart.routesDeparted":"Rutas que han salido","departTable.dispatchTime":"Hora de distribución","departTable.routeId":"ID de ruta","departTable.location":"Ubicación","departTable.status":"Estado","departTable.progress":"Progreso","departTable.type":"Tipo","departTable.driver":"Conductor","departFilter.routeType":"Tipo de ruta","departFilter.shipmentType":"Tipo de envío","cartMenu.sideline":"Apartar","routeStageTable.dispatchTime":"Hora de distribución","routeStageTable.cartId":"ID de carro","routeStageTable.routeId":"ID de ruta","routeStageTable.location":"Ubicación","routeStageTable.cartView_location":"Ubicación de la puesta en escena","routeStageTable.status":"Estado","routeStageTable.dwellDuration":"Duración de la retención","routeStageTable.type":"Tipo","routeStageTable.driver":"Conductor","routeStageTable.stationPairs":"Estación de recogida","routeStageTable.action":"Acción","stageFilter.departure":"Salida","stageFilter.driverType":"Tipo de conductor","stageFilter.cluster":"Clúster","stageOverall.cartPreStaged":"Carros prealmacenados temporalmente","stageOverall.cartsStaged":"Carros almacenados temporalmente","stageOverall.cartDwellingDSP":"Retención de carros (DSP)","stageOverall.cartDwellingFlex":"Retención de carros (Flex)","stage.heading":"Almacenar temporalmente","stage.description":"Esta tabla muestra el estado y los detalles de las rutas durante el proceso de fase saliente","common.data_last_updated":"Datos actualizados por última vez","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"Estado de ajuste de ruta","planManagement.pending_tasks_message":"Hay {count} tareas de ajuste de ruta pendientes.","planManagement.proceed_confirmation":"¿Desea continuar con la activación del plan de todos modos?","planManagement.proceed_anyway":"Continuar de todos modos","planManagement.cancel":"Cancelar"}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Lieu","cartContent.picked":"Enlevé","cartContent.staged":"Planifié","cartContent.departed":"Parti","cartContent.bags":"Sacs","cartContent.packages":"Colis","cartInfo.stage":"Préparation","cartInfo.cartDetail":"Détails du conteneur","cartInfo.status":"Statut","cartInfo.location":"Lieu","cartInfo.associate":"Associé","depart.heading":"Partir","depart.description":"Ce tableau présente le statut et les détails des itinéraires pendant le processus de départ sortant","depart.totalRoutes":"Itinéraires au total","depart.routesPartiallyDeparted":"Itinéraires partiellement partis","depart.routesDeparted":"Itinéraires partis","departTable.dispatchTime":"Heure de livraison","departTable.routeId":"ID de l’itinéraire","departTable.location":"Lieu","departTable.status":"Statut","departTable.progress":"Progression","departTable.type":"Type","departTable.driver":"Conducteur","departFilter.routeType":"Type d’itinéraire","departFilter.shipmentType":"Type de colis","routeStageTable.stationPairs":"Station de prélèvement","cartMenu.sideline":"Mettre de côté","routeStageTable.dispatchTime":"Heure de livraison","routeStageTable.cartId":"ID du conteneur","routeStageTable.routeId":"ID de l’itinéraire","routeStageTable.location":"Lieu","routeStageTable.cartView_location":"Lieu de préparation","routeStageTable.status":"Statut","routeStageTable.dwellDuration":"Durée d’immobilisation","routeStageTable.type":"Type","routeStageTable.driver":"Conducteur","routeStageTable.action":"Action","stageFilter.departure":"Départ","stageFilter.driverType":"Type de conducteur","stageFilter.cluster":"Cluster","stageOverall.cartPreStaged":"Conteneurs pré-planifiés","stageOverall.cartsStaged":"Conteneurs planifiés","stageOverall.cartDwellingDSP":"Conteneurs en immobilisation (DSP)","stageOverall.cartDwellingFlex":"Conteneurs en immobilisation (Flex)","stage.heading":"Planifié","stage.description":"Ce tableau présente le statut et les détails des itinéraires au cours du processus de préparation sortant","common.data_last_updated":"Dernière mise à jour des données","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"Statut d'ajustement d'itinéraire","planManagement.pending_tasks_message":"Il y a {count} tâches d'ajustement d'itinéraire en attente.","planManagement.proceed_confirmation":"Voulez-vous quand même procéder à l'activation du plan ?","planManagement.proceed_anyway":"Continuer quand même","planManagement.cancel":"Annuler"}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Posizione","cartContent.picked":"Ritirato","cartContent.staged":"Allestito","cartContent.departed":"Partito","cartContent.bags":"Borse","cartContent.packages":"Pacchi","cartInfo.stage":"Allestimento","cartInfo.cartDetail":"Dettagli carrello","cartInfo.status":"Stato","cartInfo.location":"Posizione","cartInfo.associate":"Associate","depart.heading":"Partire","depart.description":"Questa tabella mostra lo stato e i dettagli dei percorsi durante il processo di partenza in uscita","depart.totalRoutes":"Percorsi totali","depart.routesPartiallyDeparted":"Percorsi parzialmente partiti","depart.routesDeparted":"Percorsi partiti","departTable.dispatchTime":"Ora invio","departTable.routeId":"ID percorso","departTable.location":"Posizione","departTable.status":"Stato","departTable.progress":"Avanzamento","departTable.type":"Tipo","departTable.driver":"Conducente","departFilter.routeType":"Tipo di percorso","departFilter.shipmentType":"Tipo di spedizione","routeStageTable.stationPairs":"Stazione di prelievo","cartMenu.sideline":"Sideline","routeStageTable.dispatchTime":"Ora invio","routeStageTable.cartId":"ID carrello","routeStageTable.routeId":"ID percorso","routeStageTable.location":"Posizione","routeStageTable.cartView_location":"Posizione di staging","routeStageTable.status":"Stato","routeStageTable.dwellDuration":"Durata dwell","routeStageTable.type":"Tipo","routeStageTable.driver":"Conducente","routeStageTable.action":"Azione","stageFilter.departure":"Partenza","stageFilter.driverType":"Tipo di conducente","stageFilter.cluster":"Cluster","stageOverall.cartPreStaged":"Carrelli pre-allestiti","stageOverall.cartsStaged":"Carrelli allestiti","stageOverall.cartDwellingDSP":"Carrelli in dwell (DSP)","stageOverall.cartDwellingFlex":"Carrelli in dwell (Flex)","stage.heading":"Allestire","stage.description":"Questa tabella mostra lo stato e i dettagli dei percorsi durante il processo della fase in uscita","common.data_last_updated":"Ultimo aggiornamento dei dati","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"Stato di aggiustamento percorso","planManagement.pending_tasks_message":"Ci sono {count} attività di aggiustamento percorso in sospeso.","planManagement.proceed_confirmation":"Vuoi procedere comunque con l'attivazione del piano?","planManagement.proceed_anyway":"Procedi comunque","planManagement.cancel":"Annulla"}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = {"outbound.banner":"こちらのアウトバウンドタップは2021年Q1を目途にルートステージャーの代わりになるツールとなり、現在開発中です。こちらのツールを使って頂きフィードバック/意見をSIMに共有してください ","cartContent.location":"場所","cartContent.picked":"ピック済み","cartContent.staged":"ステージ済み","cartContent.departed":"出庫済み","cartContent.bags":"バッグ","cartContent.packages":"パッケージ","cartInfo.stage":"ステージ","cartInfo.cartDetail":"カート詳細","cartInfo.status":"ステータス","cartInfo.location":"場所","cartInfo.associate":"アソシエイト","depart.heading":"出発","depart.description":"このテーブルには、アウトバウンド出発プロセス中のルートのステータスと詳細が表示されます","depart.totalRoutes":"全ルート","depart.routesPartiallyDeparted":"一部ディスパッチ済みルート","depart.routesDeparted":"ルート出庫済み","departTable.dispatchTime":"ディスパッチ時間","departTable.routeId":"ルートID","departTable.location":"場所","departTable.status":"ステータス","departTable.progress":"進行状況","departTable.type":"タイプ","departTable.driver":"ドライバー","departFilter.routeType":"ルートの種類","departFilter.shipmentType":"出荷タイプ","cartMenu.sideline":"サイドライン","routeStageTable.dispatchTime":"ディスパッチ時間","routeStageTable.cartId":"カート","routeStageTable.routeId":"ルートID","routeStageTable.location":"ロケーション","routeStageTable.cartView_location":"ステージング場所","routeStageTable.status":"ステータス","routeStageTable.dwellDuration":"滞留時間","routeStageTable.type":"タイプ","routeStageTable.driver":"ドライバー","routeStageTable.stationPairs":"測点を選択","routeStageTable.action":"アクション","stageFilter.departure":"出庫","stageFilter.driverType":"ドライバータイプ","stageFilter.cluster":"クラスター","stageOverall.cartPreStaged":"プレステージ済みカート","stageOverall.cartsStaged":"ステージング済みカート","stageOverall.cartDwellingDSP":"滞留中カート（DSP)","stageOverall.cartDwellingFlex":"滞留中カート（Flex)","stage.heading":"ステージ","stage.description":"この表には、アウトバウンドステージプロセス中のルートのステータスと詳細が表示されます","stageOverall.routesStaged":"ステージング済みルート","routeStageTable.carts":"カート","stage.exportCSV":"CSVダウンロード","stage.stageByTime":"ディスパッチ時間","common.data_last_updated":"データが最終更新されました","departTable.carts":"カート","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"ルート調整ステータス","planManagement.pending_tasks_message":"{count}件の保留中のルート調整タスクがあります。","planManagement.proceed_confirmation":"それでもプランの有効化を続行しますか？","planManagement.proceed_anyway":"とにかく続行","planManagement.cancel":"キャンセル"}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Ort","cartContent.picked":"Entnommen","cartContent.staged":"Vorbereitet","cartContent.departed":"Abgefahren","cartContent.bags":"Taschen","cartContent.packages":"Pakete","cartInfo.stage":"Vorbereiten","cartInfo.cartDetail":"Wageninformationen","cartInfo.status":"Status","cartInfo.location":"Ort","cartInfo.associate":"Mitarbeiter","depart.heading":"Abgehen","depart.description":"Diese Tabelle zeigt den Status und die Details der Routen während des ausgehenden Abfahrtsvorgangs","depart.totalRoutes":"Gesamtanzahl der Routen","depart.routesPartiallyDeparted":"Routen teilweise abgefahren","depart.routesDeparted":"Gefahrene Routen","departTable.dispatchTime":"Abgefertigt um","departTable.routeId":"Routennummer","departTable.location":"Ort","departTable.status":"Status","departTable.progress":"Fortschritt","departTable.type":"Typ","departTable.driver":"Fahrer","departFilter.routeType":"Typ der Route","departFilter.shipmentType":"Lieferungsart","cartMenu.sideline":"Herausnehmen","routeStageTable.dispatchTime":"Abgefertigt um","routeStageTable.cartId":"Wagen-ID","routeStageTable.routeId":"Routennummer","routeStageTable.location":"Ort","routeStageTable.cartView_location":"Staging-Standort","routeStageTable.status":"Status","routeStageTable.dwellDuration":"Verweildauer","routeStageTable.type":"Typ","routeStageTable.driver":"Fahrer","routeStageTable.stationPairs":"Station wählen","routeStageTable.action":"Aktion","stageFilter.departure":"Abfahrt","stageFilter.driverType":"Fahrertyp","stageFilter.cluster":"Cluster","stageOverall.cartPreStaged":"Vorab vorbereitete Wagen","stageOverall.cartsStaged":"Vorbereitete Wagen","stageOverall.cartDwellingDSP":"Verweilende Wagen (DSP)","stageOverall.cartDwellingFlex":"Verweilende Wagen (Flex)","stage.heading":"Vorbereiten","stage.description":"Diese Tabelle zeigt den Status und die Details der Routen während des Outbound-Phase Prozesses","common.data_last_updated":"Daten wurden zuletzt aktualisiert","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"Routenanpassungsstatus","planManagement.pending_tasks_message":"Es gibt {count} ausstehende Routenanpassungsaufgaben.","planManagement.proceed_confirmation":"Möchten Sie trotzdem mit der Aktivierung des Plans fortfahren?","planManagement.proceed_anyway":"Trotzdem fortfahren","planManagement.cancel":"Abbrechen"}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"الموقع","cartContent.picked":"الملتقطة","cartContent.staged":"في منطقة التجهيز","cartContent.departed":"المغادرة","cartContent.bags":"الحقائب","cartContent.packages":"الشحنات","cartInfo.stage":"في منطقة التجهيز","cartInfo.cartDetail":"تفاصيل عربة التسوق","cartInfo.status":"الحالة","cartInfo.location":"الموقع","cartInfo.associate":"الموظف","depart.heading":"المغادرة","depart.description":"يعرض هذا الجدول حالة المسارات وتفاصيلها أثناء عملية المغادرة الصادرة","depart.totalRoutes":"مجموع المسارات","depart.routesPartiallyDeparted":"المسارات التي غادر منها السائقون جزئياً","depart.routesDeparted":"المسارات التي غادر منها السائقون ","departTable.dispatchTime":"وقت الإرسال","departTable.routeId":"رقم المسار","departTable.location":"الموقع","departTable.status":"الحالة","departTable.progress":"التقدم","departTable.type":"النوع","departTable.driver":"السائق","departFilter.routeType":"نوع المسار","departFilter.shipmentType":"نوع الطلبية","cartMenu.sideline":"ستتم معالجتها بشكل منفصل","routeStageTable.dispatchTime":"وقت الإرسال","routeStageTable.cartId":"رقم عربة التسوق","routeStageTable.routeId":"رقم المسار","routeStageTable.location":"الموقع","routeStageTable.cartView_location":"موقع التدريج","routeStageTable.status":"الحالة","routeStageTable.dwellDuration":"مدة نفس الحالة","routeStageTable.type":"النوع","routeStageTable.driver":"السائق","routeStageTable.stationPairs":"محطة بيك","routeStageTable.action":"الإجراء","stageFilter.departure":"المغادرة","stageFilter.driverType":"نوع السائق","stageFilter.cluster":"مجموعة الشحنات","stageOverall.cartPreStaged":"العربات قبل إرسالها إلى منطقة التجهيز","stageOverall.cartsStaged":"العربات في منطقة التجهيز","stageOverall.cartDwellingDSP":"العربات في نفس الحالة (DSP)","stageOverall.cartDwellingFlex":"العربات في نفس الحالة(Flex)","stageOverall.routesStaged":"تم تحديد المسارات","routeStageTable.carts":"العربات","stage.exportCSV":"تصدير إلى CSV","stage.stageByTime":"المرحلة بمرور الوقت","stage.partiallyStaged":"تم تنظيمها بشكل جزئي","stageOverall.cartView":"عرض عربة التسوق","stageOverall.routeView":"عرض المسار","stage.heading":"في منطقة التجهيز","stage.description":"يوضح هذا الجدول حالة المسارات وتفاصيلها أثناء عملية المرحلة الصادرة","depart.partiallyDeparted":"تم ترحيلها بشكل جزئي","common.data_last_updated":"آخر تحديث للبيانات","departTable.carts":"العربات","planManagement.cycle":"Cycle","planManagement.node":"Node","planManagement.plan_id":"Plan id","planManagement.created_date":"Created date","planManagement.status":"Status","planManagement.update_plan_status":"Update plan status","planManagement.active_plan":"Active plan","planManagement.inactive_plan":"Inactive plan","planManagement.deactivate_plan":"Deactivate plan","planManagement.activate_plan":"Activate plan","planManagement.route_adjustment_title":"حالة تعديل المسار","planManagement.pending_tasks_message":"توجد {count} مهام تعديل مسار معلقة.","planManagement.proceed_confirmation":"هل تريد المتابعة بتفعيل الخطة على أي حال؟","planManagement.proceed_anyway":"المتابعة على أي حال","planManagement.cancel":"إلغاء"}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = {"cartContent.location":"Konum","cartContent.picked":"Teslim alındı","cartContent.staged":"Hazırlanmış","cartContent.departed":"Ayrıldı","cartContent.bags":"Çantalar","cartContent.packages":"Paketler","cartInfo.stage":"Hazırlama/Hazırlık","cartInfo.cartDetail":"Sepet Ayrıntıları","cartInfo.status":"Durum","cartInfo.location":"Konum","cartInfo.associate":"Çalışan","depart.heading":"Çıkış","depart.description":"Bu tablo, giden çıkış işlemi sırasında rotaların durumunu ve ayrıntılarını gösterir","depart.totalRoutes":"Toplam rotalar","depart.routesPartiallyDeparted":"Kısmen Çıkış Yapılan Rotalar","depart.routesDeparted":"Çıkış Yapılan Rotalar","departTable.departByTime":"Zamana Göre Çıkış","departTable.dispatchTime":"Gönderme süresi","departTable.updateStatus":"GüncellemeStatus","departTable.routeId":"Rota numarası","departTable.location":"Konum","departTable.status":"Durum","departTable.progress":"İlerleme","departTable.type":"Tür","departTable.driver":"Sürücü","departTable.carts":"Arabalar","departFilter.routeType":"Rota Türü","departFilter.shipmentType":"Kargo Türü","cartMenu.sideline":"Kenar","routeStageTable.dispatchTime":"Gönderme süresi","routeStageTable.cartId":"Sepet ID’si","routeStageTable.routeId":"Rota numarası","routeStageTable.location":"Konum","routeStageTable.cartView_location":"Hazırlama yeri","routeStageTable.status":"Durum","routeStageTable.dwellDuration":"Bekleme Süresi","routeStageTable.type":"Tür","routeStageTable.driver":"Sürücü","routeStageTable.stationPairs":"Alma İstasyonu","routeStageTable.action":"Eylem","stageFilter.departure":"Gidiş","stageFilter.driverType":"Sürücü Türü","stageFilter.cluster":"Küme","stageOverall.cartPreStaged":"Önceden Hazırlanmış Sepetler","stageOverall.cartsStaged":"Sepetler Hazırlanmış","stageOverall.cartDwellingDSP":"Sepetler Bekliyor (DSP)","stageOverall.cartDwellingFlex":"Sepetler Bekliyor (Flex)","stage.heading":"Hazırlama/Hazırlık","stage.description":"Bu tablo, giden hazırlama işlemi sırasında rotaların durumunu ve ayrıntılarını gösterir","stageOverall.routesStaged":"Aşamalı Rotalar","routeStageTable.carts":"Arabalar","routeStageTable.loadSheet":"Sayfayı Yükle","stage.exportCSV":"CSV’ye dışa aktar","stage.stageByTime":"Zamana göre hazırlama","stage.partiallyStaged":"Kısmen hazırlanmış","stage.download":"İndir","stage.interimStaged":"Geçici olarak hazırlanmış","stageOverall.cartView":"Sepet Görüntüle","stageOverall.routeView":"Rota Görünümü","depart.partiallyDeparted":"Kısmen çıktı","common.data_last_updated":"Veriler son güncellendi","planManagement.cycle":"Döngü","planManagement.node":"Node","planManagement.plan_id":"Plan kimliği","planManagement.created_date":"Oluşturma tarihi:","planManagement.status":"Durum","planManagement.update_plan_status":"Plan durumunu güncelle","planManagement.active_plan":"Aktif plan","planManagement.inactive_plan":"Etkin olmayan plan","planManagement.deactivate_plan":"Planı devre dışı bırakın","planManagement.activate_plan":"Planı etkinleştirin","planManagement.route_adjustment_title":"Rota Ayarlama Durumu","planManagement.pending_tasks_message":"{count} bekleyen rota ayarlama görevi var.","planManagement.proceed_confirmation":"Yine de planı etkinleştirmeye devam etmek istiyor musunuz?","planManagement.proceed_anyway":"Yine de devam et","planManagement.cancel":"İptal"}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_MetricUtil__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Logger__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Error boundary for logging unhandled exception metric during rendering, in lifecycle methods,
 * and in constructors of the whole tree below them.
 * https://reactjs.org/docs/error-boundaries.html
 */var ErrorBoundary=function(_React$Component){_inherits(ErrorBoundary,_React$Component);function ErrorBoundary(props){_classCallCheck(this,ErrorBoundary);var _this=_possibleConstructorReturn(this,(ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call(this,props));_this.state={hasError:false};return _this;}_createClass(ErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,errorInfo){__WEBPACK_IMPORTED_MODULE_3__util_Logger__["a" /* Logger */].fatal("unhandled exception thrown in error boundary",error);Object(__WEBPACK_IMPORTED_MODULE_1__util_MetricUtil__["B" /* logErrorMetric */])(Object(__WEBPACK_IMPORTED_MODULE_2__network_NetworkUtil__["a" /* getStationCode */])(),__WEBPACK_IMPORTED_MODULE_1__util_MetricUtil__["f" /* GLOBAL_METRIC_KEY */],__WEBPACK_IMPORTED_MODULE_1__util_MetricUtil__["d" /* ERROR_COUNT_METRIC */]);}},{key:"render",value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1",{style:{textAlign:"center"}},"Something went wrong!");}return this.props.children;}}],[{key:"getDerivedStateFromError",value:function getDerivedStateFromError(error){return{hasError:true};}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.b47f5c26.js